var _defineProperty = require("/home/backendteam/Frontend/localclarity-frontend/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _french, _spanish;

module.exports = {
  english: {
    10010: "1 Star",
    10013: "2 Star",
    10016: "3 Star",
    10019: "4 Star",
    10022: "5 Star",
    10025: "100-300 Words",
    10120: "Actions",
    10123: "Activate",
    10124: "Always active",
    10126: "Active Organizations",
    10129: "Add",
    10132: "Add a button",
    10135: "Add a Button (optional)",
    10138: "Add Account",
    10141: "Add Additional Phone",
    10144: "Add an account",
    10147: "Add Another Category",
    10150: "Add Another Label",
    10153: "Add Attributes",
    10156: "Add Line",
    10159: "Add New Date",
    10162: "Add New Review Tag",
    10165: "Add new role",
    10168: "Add Opening Date",
    10171: "Add Profile",
    10174: "New Report",
    10177: "Add Report",
    10180: "Add Role",
    10181: "Add Review Tag",
    10183: "Additional Category",
    10186: "Additional Phone",
    10189: "Address",
    10192: "ADMIN",
    10195: "Administrator",
    10198: "adWords Location Extensions",
    10201: "adWords Location Extensions Phone",
    10204: "All",
    10207: "All Reviews",
    10210: "All users assigned to this role will have access to the following features",
    10213: "Apply",
    10216: "Approval Inbox",
    10219: "Are you sure you want to reset this user's password?",
    10222: "Are you sure?",
    10225: "Area",
    10228: "Areas",
    10231: "Attributes",
    10234: "Authorize Account",
    10237: "Average",
    10240: "Average Quantity",
    10243: "Average Rating",
    10244: "Avg. Rating",
    10246: "Average per Location",
    10249: "Awaiting Response",
    10320: "Back",
    10321: "back to admin",
    10323: "Billing",
    10326: "Book",
    10329: "Bulk Upload Post",
    10332: "Bulk Upload Tags",
    10335: "Bulk Upload TSV",
    10338: "Business Name",
    10520: "Calendar",
    10523: "Cancel",
    10526: "Can't Upload Master Location Mapping!",
    10529: "Category",
    10532: "Change role",
    10535: "Citation History",
    10538: "City",
    10541: "Click here",
    10544: "Click on a user to assign him this role",
    10547: "CO",
    10548: "Confirm Password",
    10550: "Copy",
    10553: "Copy and Paste",
    10556: "Couldn't change role!",
    10559: "Could't Upload Post",
    10562: "Countries",
    10565: "Country",
    10568: "Coupon Code",
    10571: "Coupon Code (optional)",
    10574: "Create a new filter by selecting below options",
    10577: "Create New Filter",
    10580: "Create new report",
    10583: "Create Posts",
    10586: "Create Tag",
    10589: "Create this Report",
    10592: "Create this role",
    10595: "Created by",
    10598: "Customer Actions",
    10720: "D",
    10723: "Dashboard",
    10726: "Date",
    10729: "Date Range",
    10732: "Day",
    10735: "Deactivate",
    10738: "DEFAULT",
    10741: "Delay before posting",
    10744: "Delay sending of replies by",
    10747: "Delay sending of replies by",
    10750: "Delete",
    10753: "Delete ?",
    10754: "Delete Profile",
    10756: "Desc",
    10759: "Description",
    10762: "Direct",
    10765: "Direct Queries",
    10768: "Directions",
    10771: "Discovery",
    10774: "Distinct View",
    10777: "Download all location data",
    10780: "Download",
    10783: "Download Google location details",
    10786: "Download data",
    10789: "Drafts",
    10792: "Driving Directions",
    10795: "Driving Directions by Day",
    10920: "Edit",
    10923: "Edit Profile",
    10926: "Edit Report",
    10929: "Edit this Report",
    10932: "Editor",
    10935: "Email",
    10938: "End Time",
    10941: "Enter adWords Location Extensions",
    10944: "Enter group name",
    10947: "Enter Labels",
    10950: "Enter Search Text",
    10953: "Enter tag name",
    10956: "Equals",
    10959: "Event",
    10962: "Event Details",
    10965: "Event Title",
    10968: "Every",
    10971: "example.com",
    10974: "Example: 20% off in store or online",
    11120: "Feature Access Management",
    11123: "Filters",
    11126: "Forgot Password?",
    11129: "Friday",
    11320: "Get Offer",
    11323: "Greater Than",
    11520: "Happiness Rating",
    11525: "Help",
    11530: "Holiday",
    11535: "Hour",
    11540: "Hours",
    11545: "How customers search for your business",
    11720: "Image",
    11723: "Image URL",
    11726: "In Maps",
    11729: "In Search",
    11732: "Inbox",
    11735: "Indirect Queries",
    11738: "Insights",
    11741: "Insufficient permission",
    11744: "Integration",
    11747: "Integrations",
    11750: "Invite User",
    11753: "INVITED",
    11756: "Invited by",
    11759: "items",
    12120: "Knowledge Panel",
    12320: "Labels",
    12323: "Last login",
    12326: "Last Updated",
    12329: "Learn More",
    12332: "Less Than",
    12335: "Link for your button",
    12338: "Link to redeem offer",
    12341: "Link to redeem offer (optional)",
    12344: "Link",
    12347: "Listings Management",
    12350: "Local Performance",
    12353: "Local Performance Overview",
    12356: "Local Search Conversion",
    12359: "Localities",
    12362: "Locality",
    12365: "Location",
    12368: "Location Details",
    12371: "Location ID",
    12374: "Locations",
    12377: "Login",
    12380: "Logout",
    12520: "M",
    12523: "Make your post standout with a photo",
    12526: "Manage Bulk Activity",
    12529: "Manage Groups",
    12532: "Manage Locations",
    12535: "Manage Profile",
    12538: "Manage Roles",
    12541: "Manage Users",
    12544: "Maps",
    12547: "Merchant Count",
    12550: "Merchant Photos",
    12553: "Merchant Photos",
    12556: "Message",
    12559: "Minutes",
    12562: "Monday",
    12565: "Month",
    12720: "Name",
    12723: "Name of the new role",
    12726: "Name of the Report",
    12729: "Need an Account?",
    12732: "New",
    12735: "Next Page",
    12738: "No Replies",
    12741: "No results found",
    12744: "No Review Tags Exist Yet",
    12747: "No reviews",
    12750: "No, cancel",
    12753: "No. of Users",
    12756: "Notes",
    12920: "of",
    12923: "Offer",
    12926: "OK",
    12929: "Ok, Got it!",
    12932: "Once",
    12935: "Opening Date",
    12938: "Order",
    12941: "Organizations",
    12944: "Outbox",
    12947: "Owner",
    13120: "page",
    13123: "Password",
    13126: "Paste TSV",
    13129: "Pdf Type",
    13132: "Phone",
    13135: "Phone Calls by Day",
    13138: "Phone Number",
    13141: "Photo Quantity",
    13144: "Photo Views",
    13147: "Please enter a recipient name!",
    13150: "Please enter a report name!",
    13153: "Please enter a summary!",
    13156: "Please enter a title!",
    13159: "Please enter a valid Time!",
    13162: "Please enter a valid url!",
    13165: "Please Refresh the page to Update your Location Details",
    13168: "Please Reload",
    13171: "Please select Schedule Type!",
    13174: "Post History",
    13177: "Posts",
    13180: "Previous Page",
    13183: "Primary Category",
    13186: "Primary Phone",
    13189: "Primary Telephone Number",
    13192: "Profiles",
    13195: "Public Count",
    13198: "Public Photos",
    13201: "Public Photos",
    13204: "Publish",
    13520: "Rating",
    13523: "Real time notifications",
    13526: "Recipient List",
    13529: "Recurring",
    13532: "Remove User",
    13535: "Reply",
    13538: "Reply approval",
    13541: "Report Management",
    13544: "Report Name",
    13547: "Report Type",
    13550: "Reset Password",
    13553: "Response by Star Rating",
    13556: "Review Count",
    13559: "Review Download",
    13562: "Review Settings",
    13565: "Review Source",
    13568: "Review Tags",
    13571: "ReviewLink",
    13574: "Reviews",
    13577: "Reviews by Star Rating",
    13580: "Reviews vs Average Rating",
    13583: "Reviews Inbox",
    13586: "Reviews Management",
    13589: "Reviews, Day of Month",
    13592: "Reviews, Day of Week",
    13595: "Reviews, Month of Year",
    13598: "Role",
    13601: "Role Details",
    13604: "Role Name",
    13720: "Saturday",
    13723: "Save",
    13726: "Save as custom filter",
    13729: "Save new filter",
    13732: "Save role",
    13735: "Saved Replies",
    13738: "Schedule Date",
    13741: "Schedule Post",
    13742: "To Schedule a Report",
    13744: "Schedule Time",
    13747: "Schedule Type",
    13750: "Search",
    13753: "Searches",
    13756: "Select",
    13759: "Select an existing filter",
    13762: "Select Category",
    13765: "Select City",
    13768: "Select Country",
    13771: "Select date and time",
    13774: "Select Date Range",
    13777: "Select Editor(s) to review",
    13780: "Select group",
    13783: "Select Filter",
    13786: "Select Filters",
    13789: "Select granularity",
    13792: "Select Organization",
    13795: "Select review tag",
    13798: "Select Saved Filter",
    13801: "Select Source",
    13804: "Select State",
    13807: "Select Time",
    13810: "SELF",
    13813: "Send it for Approval",
    13816: "Send it to Outbox",
    13819: "Sent",
    13822: "Services",
    13825: "Settings",
    13828: "Settings Management",
    13831: "Shop",
    13834: "Show Posts",
    13837: "Show/Hide Nav",
    13840: "Sign Up",
    13843: "Single Location Edit",
    13846: "Sorry!",
    13849: "Sort by",
    13852: "Special hours",
    13855: "Specific Access",
    13858: "STANDARD",
    13861: "Start Time",
    13864: "State",
    13867: "Status",
    13870: "Store",
    13873: "StoreCode",
    13876: "Street",
    13879: "Summary View",
    13882: "Sunday",
    13885: "Sync this Account",
    13920: "Telephone",
    13923: "Terms and conditions",
    13926: "Thursday",
    13929: "Time",
    13932: "Top Localities",
    13935: "Total",
    13938: "Tuesday",
    14120: "Unanswered",
    14123: "Unsure of the format?",
    14126: "Upload",
    14129: "Upload Location Details",
    14132: "Upload Location Map",
    14135: "Upload Location Mapping",
    14138: "Upload TSV",
    14141: "URL",
    14144: "UserId",
    14320: "View Image",
    14323: "View Profile",
    14326: "Views",
    14520: "W",
    14523: "Website",
    14526: "Website by Day",
    14529: "Website Name",
    14532: "Wednesday",
    14535: "Week",
    14538: "What actions do customers take",
    14541: "When a reply to a review is made",
    14544: "Where customers view your business",
    14547: "Would you like to Delete this Scheduled Post?",
    14550: "Write Your Title",
    14920: "Year",
    14923: "Yes, continue",
    14926: "You may choose to limit the access of users with this role by selecting a filter to be attached to it.",
    14929: "Your name",
    15120: "Zip",
    20010: "Monday",
    20011: "Mon",
    20020: "Tuesday",
    20021: "Tue",
    20030: "Wednesday",
    20031: "Wed",
    20040: "Thursday",
    20041: "Thu",
    20050: "Friday",
    20051: "Fri",
    20060: "Saturday",
    20061: "Sat",
    20070: "Sunday",
    20071: "Sun",
    20110: "January",
    20111: "Jan",
    20120: "February",
    20121: "Feb",
    20130: "March",
    20131: "Mar",
    20140: "April",
    20141: "Apr",
    20150: "May",
    20151: "May",
    20160: "June",
    20161: "Jun",
    20170: "July",
    20171: "Jul",
    20180: "August",
    20181: "Aug",
    20190: "September",
    20191: "Sep",
    20200: "October",
    20201: "Oct",
    20210: "November",
    20211: "Nov",
    20220: "December",
    20221: "Dec",
    20231: "Reviews & Ratings",
    20241: "Percent",
    20251: "Review with Percentage",
    20261: "Cumulative",
    20271: "Cumulative count",
    20281: "Source",
    20291: "Review by Sources",
    20301: "Happiness",
    20311: "Response Time",
    20321: "Select location",
    20331: "Search by reviews keyword",
    20341: "search by Reviewer",
    20351: "Select",
    20361: "Equals",
    20371: "Less Than",
    20381: "Greater Than",
    20391: "Select Months",
    20401: "Select date",
    20411: "Click to view these reviews",
    20421: "There were no reviews found for the selected date range and criteria",
    20431: "Clear Filter",
    20441: "Delete a custom filter",
    20451: "Has Google Updates",
    20461: "Verified",
    20471: "Location published",
    20481: "Has pending edits",
    20491: "Knowledge panel",
    20501: "Review Link",
    20511: "Directions",
    20521: "Duplicate",
    20531: "Active",
    20541: "Can update",
    20551: "Can delete",
    20561: "No pending review",
    20571: "Location enabled",
    20581: "Not disconnected",
    20591: "Change log",
    20601: "Bulk Upload Image",
    20611: "Image History",
    20621: "Bulk Upload Note",
    20631: "Bulk Upload Q&A",
    20641: "Q&A History",
    20651: "Add a question",
    20661: "Present a question to customers that highlights a core value proposition or a distinct competitive advantage of your location. You can then answer the questions.",
    20671: "Platform details",
    20681: "Auto reply variables",
    20691: "Location Name",
    20701: "Geo Name",
    20711: "Signature",
    20721: "Geo name (max. 80 characters)",
    20731: "Signature name (max. 80 characters)",
    20741: "Auto Reply",
    20751: "Download Reviews",
    20761: "Auto Response",
    20771: "External Link",
    20781: "Copy Review",
    20791: "Add Note",
    20801: "External Note",
    20811: "Flag as inappropriate",
    20821: "Mark as removed",
    20831: "Are you sure ?",
    20841: "Would you like to mark this review as removed from Google?",
    20851: "Insert Saved Replies",
    20861: "Save as reply template",
    20871: "Insert auto reply template",
    20881: "Send",
    20891: "Send for approval",
    20901: "Save as draft",
    20911: "Assign note",
    20921: "Email note",
    20931: "Recipient",
    20941: "Save as note",
    20951: "Close",
    20961: "Discard",
    20971: "Send mail",
    20981: "You don't have any saved Notes",
    20991: "All caught up!",
    21001: "No entries to show",
    21011: "Sent Replies",
    21021: "no comment added",
    21031: "Edit reply",
    21041: "Delete reply",
    21051: "Search saved replies",
    21061: "Add saved reply",
    21071: "Choose a group and subject to save this reply.",
    21081: "Select a group or start typing to create one",
    21091: "Enter title here",
    21101: "Enter reply template",
    21111: "Please make sure to select/create a Group and Title to save this reply.",
    21121: "Auto Replies",
    21131: "Add auto reply",
    21141: "Select a group",
    21151: "Enter variable here",
    21161: "Choose your variables",
    21171: "Do you want to continue?",
    21181: "This request contains more than 100 reviews For such requests, we will send you an email with a link to download the review csv.",
    21191: "You have more than 100 reviews",
    21201: "We will send you an email (to X) with a link to download the review csv.",
    21211: "Actions",
    21221: "All Location",
    21231: "Avg Rating",
    21241: "Brand",
    21251: "Direct",
    21261: "Discovery",
    21271: "Geography",
    21281: "Happiness",
    21291: "Queries",
    21301: "Replies",
    21311: "Views",
    21321: "Post Schedule",
    21331: "Google Post Schedule",
    21341: "Create Post",
    21351: "Manage Post",
    21361: "Schedule LocalPost",
    21371: "Upload",
    21381: "Progress",
    21391: "Validate & Schedule",
    21401: "Schedule Status",
    21411: "Select File",
    21421: "Select a schedule type",
    21431: "Immediate",
    21441: "File time",
    21451: "Select Time",
    21461: "Post immediately after verification",
    21471: "Schedule based on the time in the file",
    21481: "Schedule file by your selected time",
    21491: "Queue",
    21501: "Validation is in progress. Processing time is approximately 40 posts per minute. After validation, each post's status will be available on the next page.",
    21511: "Post processed",
    21521: "Successful validation",
    21531: "Failed validation",
    21541: "Scheduled",
    21551: "Type/Action",
    21561: "Dates",
    21571: "Start",
    21581: "End",
    21591: "Title/Product",
    21601: "Post Summary",
    21611: "Status",
    21621: "Success",
    21631: "Failed",
    21641: "Edit/Delete",
    21651: "Post Insights",
    21661: "Google Post Insights",
    21671: "Performance",
    21681: "Post views",
    21691: "Post by media",
    21701: "Post by topic",
    21711: "Post by action",
    21721: "Analysis",
    21731: "Created",
    21741: "Type",
    21751: "Action",
    21761: "Source filter",
    21771: "Platform",
    21781: "Update localpost status",
    21791: "Campaign Builder",
    21801: "Intelligent Auto Response",
    21811: "Turn on auto response campaign builder",
    21821: "Before enabling the auto response schedule option, Please make sure to follow the instructions given below:",
    21831: "Before enabling Inteligent Auto response make sure to add your auto reply templates in ReviewInbox section.Build the responses first so that they can be assigned to the star ratings (1-5) that will trigger an Inteligent Auto Response.",
    21841: "In the Campaign Builder please select a delay time between review receipt and auto response delivery. The delay setting should correspond to the ideal review response time, as it is intended to mask the automatic nature of the program.",
    21851: "Please also consider setting the operation time (days of the week and hours of the day) for the campaign. The default timezone setting is GMT+00:00, so please update as appropriate.",
    21861: "Create Campaign",
    21871: "Assign a name and any notes to easily identify your campaign.",
    21881: "Campaign Name",
    21891: "Campaign Responder",
    21901: "If no option is selected, email used to signup and authorize accounts will be the default respondent.",
    21911: "Respondent for the auto reply",
    21921: "Campaign date range",
    21931: "Notes/Goals",
    21941: "Campaign description",
    21951: "Set Triggers",
    21961: "Choose the type of review(s) that will prompt an automated response for this campaign.",
    21971: "With Comment",
    21981: "Without Comment",
    21991: "Previous",
    22001: "Next",
    22011: "Set Audience (optional)",
    22021: "Set the locations to be part of the campaign based on an Entity Tag, an Organization, or a specific Country/Area/Locality. These filters are available only for Google reviews and Mapped locations",
    22031: "entity",
    22041: "Organization",
    22051: "Set Schedule",
    22061: "Assign the parameters and the schedule for reviews responses, i.e. the percentage of targeted reviews and the hours of operation operations for responses.",
    22071: 'Please know that automatic responses are currently available only on a "go-forward" basis. We are working on separate processes for users who might wish to do a near-term clean up automatically.',
    22081: "Set Response Rate",
    22091: "Set Response Count",
    22101: "delay before sending auto reply",
    22111: "schedule periodically",
    22121: "Select day and set time to schedule auto response periodically",
    22131: "Select Timezone",
    22141: "Assign Responses",
    22151: "From the list, select which responses to use in rotation for this campaign.",
    22161: "Confirm",
    22171: 'Review each of the details below and hit "confirm" to launch your campaign.',
    22181: "Days",
    22191: "Star",
    22201: "Avg",
    22211: "Reporting",
    22221: "Competitor Setup",
    22231: "Best Practices",
    22241: "Quadrant",
    22251: "Ratings",
    22261: "Competitive Ranking",
    22271: "Resp",
    22281: "View Review Sources",
    22291: "Add Competitor",
    22301: "Filtered by",
    22311: "Clear",
    22321: "Competitor",
    22331: "CompEntity",
    22341: "Entity Tag",
    22351: "Comments",
    22361: "No Options",
    22371: "Bad",
    22381: "Poor",
    22391: "Average",
    22401: "Great",
    22411: "Excellent",
    22421: "Reviews with Reply",
    22431: "Reviews without Reply",
    22441: "Reviews with Comments",
    22451: "Reviews without Comments",
    22461: "Review Volume vs Average Rating",
    22471: "Brands",
    22481: "Zoom",
    22491: "Total reviews",
    22501: "Review rating by star",
    22511: "Competitor Reviews",
    22521: "Competitor of",
    22531: "Code",
    22541: "Manage Competitors",
    22551: "Updated",
    22561: "Add Competitors",
    22571: "Add Location",
    22581: "Add competitors Name",
    22591: "The first step is to add the competitor's name, once you have added the names and optional icons (48x48 images) to the list, click on 'Add'. Once the Competitors are created, you will be able to assign the individual locations",
    22601: "Enter competitor Name (required)",
    22611: "Enter competitor URL (optional)",
    22621: "Upload image",
    22631: "Coming soon",
    22641: "Comment Ratio",
    22651: "Percent of reviews with and without comments",
    22661: "Without",
    22671: "With",
    22681: "Comment Length",
    22691: "Average number of words used in each comment by star rating",
    22701: "Words",
    22711: "Word Ratio",
    22721: "Total and percentage of words in comments for each star rating",
    22731: "here.",
    22741: "Competitors",
    22751: "add tag",
    22761: "Choose variables to be added to the template",
    22771: "close review",
    22781: "Closed review",
    22791: "Do you want to close this review ? Once you close, you will need to reopen it in order to reply",
    22801: "External",
    22811: "Negative",
    22821: "No",
    22831: "No auto replies yet!",
    22841: "No saved replies yet!",
    22851: "Note",
    22861: "Permanently Closed",
    22871: "Positive",
    22881: "Read timed out",
    22891: "Reinstate Review",
    22901: "Re-Open Review",
    22911: "Replied",
    22921: "Reply sent (from google interface)",
    22931: "Reply sent from App",
    22941: "Review removed",
    22951: "Templates",
    22961: "Temporarily Closed",
    22971: "Yes",
    22981: "You don't have any saved drafts",
    22991: "Insufficient permissions to access the resource",
    23001: "Internal error encountered",
    23011: "Request contains an invalid argument",
    23021: "Requested entity was not found",
    23031: "Review no longer exists on Google platform",
    23041: "Some of the Auto insert values are not available. Please replace and Sent",
    23051: "The service is currently unavailable",
    23061: "This operation is not supported for unclaimed locations",
    23071: "Published post",
    23081: "Scheduled post",
    23091: "Friendly name",
    23101: "Add friendly name",
    23111: "Contact",
    23121: "No contacts!",
    23131: "to add contact",
    23141: "Contact Name",
    23151: "Contact E-Mail",
    23161: "Add contact",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "No Data",
    23201: "Google Audit",
    23211: "Audit Logs",
    23221: "Select a report",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "Data Downloads",
    23271: "Review Download",
    23281: "All Reviews",
    23291: "Download Photo URL",
    23301: "Customer Photo URLs",
    23311: "Merchant Photo URLs",
    23321: "Report Downloads History",
    23331: "Report Name",
    23341: "Sent to",
    23351: "Created Time (UTC)",
    23361: "Report Type",
    23371: "Profile Settings",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "Update",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "Upload",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "Bulk Management Control",
    23721: "Update location details and control platform parameters directly in Google Sheets.",
    23731: "PLATFORM",
    23741: "Easily manage accounts of any scale with custom location variables and settings.",
    23751: "GBP Details",
    23761: "View all Google Business Profile listings and directly add/edit/delete location details.",
    23771: "GBP Attributes",
    23781: "Assign all eligible attributes to each location to gain incremental search discovery.",
    23791: "GBP Listing",
    23801: "Create new GBP listing.",
    23811: "Facebook",
    23821: "Facebook listing control",
    23831: "History",
    23841: "Training",
    23851: "Access resources for bulk edit workflows, best practices, limitations, and updates.",
    23861: "WARNING",
    23871: "Requirement:",
    23881: "Users must have a Google account so that the system can present a Google Sheet with the profile data.",
    23891: "Notice:",
    23901: "The data populating each sheet is from the system database. If you wish to make certain that the spreadsheet presents current Google data, we strongly recommend that you first synchronize your profile.",
    23911: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    23921: "The platform has a direct API connection to Google, but there may still be times when Google delays the direct update to the public location listing page.",
    23931: "Pushing “Update” triggers a direct system directly to Google. There is no undo or reversion process available. Please make certain you are comfortable with all edits before triggering the update. If a mistake is made, please wait a few minutes and then make the necessary change.",
    23941: "COLOR SCHEME",
    23951: "Each sheet has a default color scheme to help users understand which fields are eligible for editing.",
    23961: "Variables that either convey status details from Google or can’t be edited directly via bulk controls.",
    23971: "Google variables directly open for bulk edit.",
    23981: "Platform variables directly open for bulk edit.",
    23991: "Control",
    24001: "Details",
    24011: "Attributes",
    24021: "Create Listing",
    24031: "Instructions",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 14 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "Activity",
    24361: "Authorized",
    24371: "Authorized connections access full review and response capabilities from/to each source.",
    24381: "Bulk Upload Groups",
    24391: "Bulk Upload GBP Detail",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "Create Group",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "GBP Detail History",
    24491: "Impressions",
    24501: "Inactive",
    24511: "Indexed",
    24521: "Indexed connections access all historic and current reviews from each source.",
    24531: "Manage LocalPost",
    24541: "no comment added",
    24551: "Number",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "Save a reply",
    24601: "Total location",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "Upload Location Aliases",
    24641: "View",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "Detached",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Choose File",
    24911: "No file chosen",
    24921: "View a log of each update push to confirm listing content changes and spot any errors.",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "User Id",
    24961: "Do you want to delete?",
    24971: "Account",
    24981: "Has no Google Updates",
    24991: "Reverification not required",
    25001: "No pending edits",
    25011: "Audit Time",
    25021: "Field",
    25031: "Value (to)",
    25041: "Value (from)",
    25051: "remove from entity tag",
    25061: "Attributelist",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "Explore",
    25111: "Explore Responses",
    25121: "Select Template",
    25131: "Continue",
    25141: "Choose star rating,template name and add template content to save the auto reply.",
    25151: "Select reply type",
    25161: "Template",
    25171: "Snippet",
    25181: "Assign to rating (required)",
    25191: "Enter Template name (required)",
    25201: "Custom template variable (optional)",
    25211: "Select of create topic (optional)",
    25221: "Assign to single location (optional)",
    25231: "Assign to entity tag (optional)",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "Location Note",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "See the review directly on Google",
    25301: "Positive-5 Stars",
    25311: "Negative - 1/2 Stars",
    25321: "Mixed - 3/4 Stars",
    25331: "Template Name",
    25341: "Variable",
    25351: "Select or Create topic (optional)",
    25361: "Group",
    25371: "Topic",
    25381: "Prior Reviews",
    25391: "Save As Reply",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "Created Date",
    25441: "Custom filter name",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "Download",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "Default landing page",
    25691: "Reviews Inbox",
    25701: "Bulk Management",
    25711: "Post Scheduling",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn on Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "Response Rate",
    25781: "Response Count",
    25791: "Star Ratings",
    25801: "With",
    25811: "Without",
    25821: "Delay",
    25831: "Time Zone",
    25841: "Review",
    25851: "Competitor Report",
    25861: "Format",
    25871: "HTML Email",
    25881: "Excel",
    25891: "If there are no reviews in selected range",
    25901: "Don't send email",
    25911: "Send email",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "Please contact support with any questions about profile sync cadence.",
    25971: "Include Audit File",
    25981: "Profile",
    25991: "CompTag",
    26001: "Review Details",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "Customer actions line chart for Driving Direction, Phone Calls, and Website clicks.",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Yesterday",
    27251: "Last 7 days",
    27261: "Last week",
    27271: "Last 30 days",
    27281: "Last month",
    27291: "All time",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "Save this reply?",
    27341: "Select or create a group",
    27351: "No saved replies",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "All Locations",
    27451: "Open",
    27461: "Google Updates",
    27471: "Missing Content",
    27481: "Store Code",
    27491: "Additional Categories",
    27501: "Search Locations",
    27511: "GBP Audit",
    27521: "Bulk Activity",
    27531: "Select Group",
    27541: "20/ page",
    27551: "Sync",
    27561: "Set Audience",
    27571: "Done",
    27581: "Group Name",
    27591: "Minute",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "Quadrant Analysis",
    27631: "All locations Data",
    27641: "High Search + Low Conversion",
    27651: "High Search + High Conversion",
    27661: "Low Search + Low Conversion",
    27671: "Low Search + High Conversion",
    27681: "Location Data By Region",
    27691: "Location Data By City",
    27701: "Location",
    27711: "Conversion Rate:",
    27721: "Searches:",
    27731: "Google Q&A",
    27741: "Google QA",
    27751: "Download QA",
    27761: "Post Answer",
    27771: "Post Insight",
    27781: "Download the sample CSV",
    27791: "Pre populated CSV",
    27801: "Manage Portfolio",
    27811: "Add Portfolio",
    27821: "View Portfolio",
    27831: "Delete Portfolio",
    27841: "Users",
    27851: "Manage Profiles",
    27861: "Remove Profile",
    27871: "Are you sure you want to Remove this profile ?",
    27881: "Accounts",
    27891: "Select Profiles",
    27901: "Select Profile",
    27911: "Portfolio Account",
    27921: "Portfolio Details",
    27931: "Portfolio Name",
    27941: "Currrent Portfolio Image",
    27951: "Upload image as a logo for portfolio",
    27961: "Change portfolio name",
    27971: "Free Trial",
    27981: "Current",
    27991: "Expired",
    28001: "Cancelled",
    28011: "Invoicing",
    28021: "Connected",
    28031: "Number of Accounts",
    28041: "Total Locations",
    28051: "Active Locations",
    28061: "Reviews (30 days)",
    28071: "Payment Status",
    28081: "Profile Name",
    28091: "Enter name of new portfolio",
    28101: "A portfolio can bulk manage their users across different profiles easily",
    28111: "Name of new portfolio",
    28121: "Portfolio names can only have a maximum of 20 characters",
    28131: "Portfolio Created Successfully!",
    28141: "Total Profile",
    28151: "Total Users",
    28161: "Enter email",
    28171: "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role.",
    28181: "Invite",
    28191: "Current Portfolio Image",
    28201: "Sentiment",
    28211: "Awaiting",
    28221: "More Filters",
    28231: "Review Tag",
    28241: "Saved Filters",
    28251: "Less Filters",
    28261: "No Text",
    28271: "Medium",
    28281: "Expand",
    28291: "Single Image Upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "Open",
    28471: "Closed",
    28481: "Removed",
    28491: "New Review Tag",
    28501: "All Reviews",
    28511: "Nothing to show in this range!",
    28521: "Search",
    28531: "Select All",
    28541: "Search source",
    28551: "Search review tag",
    28561: "Search Location",
    28571: "Search Store Code",
    28581: "Search Group",
    28591: "Organizations",
    28601: "Entity Tags",
    28611: "Apply",
    28621: "Groups",
    28631: "Search Saved Filters",
    28641: "No options!",
    28651: "Adjust review text view",
    28661: "See the review directly on",
    28671: "Reply On Review Platform",
    28681: "Select Template",
    28691: "Copy",
    28701: "Prior Reviews",
    28711: "No Reviews",
    28721: "Rating",
    28731: "Reply Location name not added in this location",
    28741: "Signature not added in this location",
    28751: "Do you want to continue download?",
    28761: "Reviews without Reply",
    28771: "Reviews with Internal Reply",
    28781: "Reviews with Auto-Reply",
    28791: "Reviews with External Reply",
    28801: "View Google Knowledge Panel",
    28811: "Location Note",
    28821: "New Manager",
    28831: "Enable Cc",
    28841: "Save As Reply",
    28851: "Delete Reply",
    28861: "Group",
    28871: "Mixed",
    28881: "Stars",
    28891: "Negative, Mixed, Positive",
    28901: "Rating",
    28911: "Template Name",
    28921: "Variable",
    28931: "Save a Reply",
    28941: "Edit Account Name",
    28951: "Change account name",
    28961: "Account Name",
    28971: "Facebook Locations",
    28981: "Add Page",
    28991: "Activated",
    29001: "Show Hidden Location",
    29011: "View FB Page",
    29021: "No hidden account to show",
    29031: "Hours Ago",
    29041: "Inviter",
    29051: "Review Showcase",
    29061: "Google Locations",
    29071: "Your locations",
    29081: "Location URL",
    29091: "Are you sure you want to delete this URL?",
    29101: "Would you like to delete url and its related data from the application ?",
    29111: "Competitor Locations",
    29121: "Competitor Name",
    29131: "Place ID",
    29141: "CompTag",
    29151: "Enter Location URLs and Competitor Details",
    29161: "IsCompetitor",
    29171: "Booking locations",
    29181: "To initiate Booking review integration",
    29191: "Back Office Location ID (optional)",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,please provide a list of each location as an Excel file to ",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "Create campaigns to directly respond to reviews with the perfect response at the perfect time",
    29301: "Are you sure you want to delete this campaign?",
    29311: "Copy intelligent Reviews to each assigned location manager",
    29321: "CC Replies to Assigned Location Managers",
    29331: "CC Replies to Corporate",
    29341: "Recipients",
    29351: "All Recipients",
    29361: "Select Review Source",
    29371: "Pub/Sub Only",
    29381: "Select Star Rating",
    29391: "Select Review Content",
    29401: "Custom Group",
    29411: "Set delay before sending auto reply",
    29421: "Set Hours of Operation",
    29431: "optional",
    29441: "No locations assigned",
    29451: "There were no insight found for the selected date range and criteria.",
    29461: "Filter menu",
    29471: "Sort",
    29481: "Views in Search",
    29491: "Views in Maps",
    29501: "You don't have sufficient permissions to post a reply.",
    29511: "Already sent",
    29521: "Upload AR Templates",
    29531: "Followers Count",
    29541: "Last Sync",
    29551: "Corporate",
    29561: "Agency",
    29571: "Localpost Enabled",
    29581: "No pending verification",
    29591: "Click to view this review in the inbox",
    29601: "Read More",
    29611: "Loading",
    29621: "Total (number) items",
    29631: "Google Business Profile verified",
    29641: "Mark As",
    29651: "Add Hours",
    29661: "Today",
    29671: "Street Address",
    29681: "Postal Code",
    29691: "Identifies as Black-Owned",
    29701: "Add URL",
    29711: "Post",
    29721: "Contact Email",
    29731: "COVID_19 Update",
    29741: "Changes to your business?",
    29751: "Campaign",
    29761: "Order Online",
    29771: "Buy",
    29781: "Call Now",
    29791: "Now",
    29801: "Sync this location?",
    29811: "Facebook Listing",
    29821: "Create New Facebook Listing",
    29831: "Selected",
    29841: "Business Details",
    29851: "Contacts",
    29861: "Variables",
    29871: "Internal ID",
    29881: "click to connect",
    29891: "Back to upload",
    29901: "See the Q&A on Google",
    29911: "Require",
    29921: "Disable",
    29931: "Review close confirmation",
    29941: "Review reply confirmation",
    29951: "Review removal confirmation",
    29961: "Region",
    29971: "Answer to this question",
    29981: "Manage",
    29991: "Create Google Post",
    30001: "Manage Google Post",
    30011: "Hide Location",
    30021: "Select Current Page",
    30031: "Create Facebook Post",
    30041: "Manage Facebook Post",
    30051: "Clear All",
    30061: "Save Filter",
    30071: "Search Role",
    30081: "Search User",
    30091: "All Editors",
    30101: "Assign to rating(required)",
    30111: "Enter Template Name(required)",
    30121: "Custom template variable(optional)",
    30131: "Select or Create topic(optional)",
    30141: "Assign to single location(optional)",
    30151: "Assign to entity tag(optional)",
    30161: "Review Variables",
    30171: "Reviewer First Name",
    30181: "Reviewer Full Name",
    30191: "Location Variables",
    30201: "Reply Location Name",
    30211: "Geo Location Name",
    30221: "A reply for this review has already been sent.",
    30231: "Replies for this review can not be sent anymore. You can delete this reply to remove it from here.",
    30241: "Would you like to sync the data of this location? This will pull in all updates made to the location.",
    30251: "Let customers know about any changes to your business due to COVID-19",
    30261: "Send Now",
    30271: "Search Showcase",
    30281: "Use the controls on the right to build the exact Review Showcase. Click on the 'Apply' button to load the instant preview",
    30291: "Build Your Review Showcase",
    30301: "Showcase Details",
    30311: "Name this Showcase",
    30321: "Individual Location",
    30331: "Location Group",
    30341: "Showcase Title",
    30351: "Hide",
    30361: "Reviewer Image/Avatar",
    30371: "Show",
    30381: "Select Review Set",
    30391: "Review Sources",
    30401: "Reviews From",
    30411: "Create Showcase",
    30421: "Minimum Rating",
    30431: "Rating Only Reviews",
    30441: "Define Presentation",
    30451: "Max Review Count",
    30461: "Max Comment Lenght",
    30471: "Max Reviews Per Page",
    30481: "Responsive Layout",
    30491: "Sort Order",
    30501: "Newest First",
    30511: "Star Rating Color",
    30521: "Review Comments",
    30531: "Source Logo",
    30541: "Review Date",
    30551: "Precise Date",
    30561: "Font Family",
    30571: "Showcase Title Size",
    30581: "Reviewer Name Size",
    30591: "Comment Size",
    30601: "Set Overrides",
    30611: "Pin To Top",
    30621: "Exclude",
    30631: "My Reviews",
    30641: "Needs Assistance",
    30651: "Awaiting Customer",
    30661: "Awaiting Feedback",
    30671: "New Feedback",
    30681: "Search Name",
    30691: "Not Assigned",
    30701: "Successfully Updated",
    30711: "Campaign Content Name (optional)",
    30721: "Terms and Conditions (optional)",
    30731: "Are you sure you want to remove this user? Once removed, the user will no longer have access to this profile, unless invited.",
    30741: "Would you like to remove this user?",
    30751: "Response Distribution",
    30761: "We will send an email () with a link to download the review csv.",
    30771: "This profile has more than 100 locations. We will send you an email with the download link",
    30781: "User Reply",
    30791: "Mark Replied",
    30801: "Destination Reply",
    null: "Months of Year",
    1001: "Signing up signifies you’ve read and agree to our ",
    1002: "Terms of Service",
    1003: "and",
    1004: "Privacy Policy",
    1005: ".",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "Cumulative",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "Team Reviews",
    2029: "Automate",
    2030: "Full",
    2031: "Assigned",
    2032: "Search user",
    2033: "Send Email",
    2034: "Compose",
    2035: "AI Reply",
    2036: "Post Reply",
    2037: "Regenerate",
    2038: "Approval",
    2039: "Post on Source",
    2040: "Reply sent",
    2041: "No sent messages",
    2042: "Clear",
    2043: "Closed",
    2044: "No reply text found",
    2045: "Copy response and go to the source",
    2046: "Edit reply",
    2047: "Approve reply",
    2048: "Update Reply",
    2049: "Delete Reply",
    2050: "Are you sure you want to delete this reply?",
    2051: "Are you sure you want to submit this response?",
    2052: "Would you like to reinstate this review ?",
    2053: "Are you sure ?",
    2054: "Are you sure you want to approve this response?",
    2055: "Teams",
    2056: "Rating Only",
    2057: "Rating + Short Comment",
    2058: "Rating + Comment",
    2059: "Review By Language",
    2060: "Please provide a comment length between 1 and 100, Default will be 20 characters",
    2061: "Copy Intelligent Review Replies to each assigned location manager",
    2062: "Sign in",
    2063: "Email address",
    2064: "Don't have an account?",
    2065: "First name",
    2066: "Last name",
    2067: "Company",
    2068: "Company name",
    2069: "Already have an account?",
    2070: "Show password",
    2071: "Hide password",
    2072: "Local Impression Conversion",
    2073: "Maps Mobile",
    2074: "Maps Desktop",
    2075: "Search Mobile",
    2076: "Search Desktop",
    2077: "Search Views",
    2078: "Map Views",
    2081: "Universal",
    2091: "By Topic",
    30811: "Reviews Dashboard",
    30812: "Overview",
    30813: "Avg",
    30814: "AVG Rating",
    30815: "Pos",
    30816: "Happiness",
    30817: "Word Ratio",
    30818: "Response Ratio",
    30819: "Review by Source",
    30820: "Review by Rating",
    30821: "Response by Rating",
    30822: "Recent Reviews",
    30823: "You received {x} reviews in the past {x} days. Here are the most recent",
    30824: "The average number of reviews per parent location during the time range",
    30825: "The percentage of reviews with 4-Star and 5-Star ratings",
    30826: "The Happiness Score is a presentation of the percent of positive reviews minus the percentage of negative reviews",
    30827: "The Percent of all comments found in 5-Star and 4-Star reviews compared to all words shared in the time range. The range goes from 5-Star to 1-Star.",
    30828: "The percentage of reviews within the timeframe that have received a response.",
    30829: "Decrease in {x data} from prior {xx} days",
    30830: "Increase in {x data} from prior {xx} days",
    30831: "No change in {x data} from prior {xx} days",
    30832: "Click to view these reviews",
    30833: "{locationName} , {x} Star, Reviewer: {x}",
    30834: "Reviews & Rating Average",
    30835: "Review count over time stacked by star rating + line chart of rating average.",
    30836: "Percent by Star Rating",
    30837: "Review count over time stacked by star rating as a percentage of the total.",
    30838: "Cumulative Count & Rating Average",
    30839: "Review total and average rating for the time range of the report.",
    30840: "Reviews by Source",
    30841: "Count of reviews over time period by source.",
    30842: "Happiness Score over Time",
    30843: "The net Happiness Score per time period over the report range.",
    30844: "Day of Week",
    30845: "Day of Month",
    30846: "Month of Year",
    30847: "Top Countries",
    30848: "Top States",
    30849: "Top Cities",
    30850: "Responses",
    30851: "Rapid Reply Rate",
    30852: "Median",
    30853: "The number of responses published during the time period and the average per location.",
    30854: "The percentage of reviews receiving a reply within 2 days and the median response time.",
    30855: "Response Count & Ratio",
    30856: "The response count by star rating and the overall response ratio.",
    30857: "Average Response Time",
    30858: "The mean response time in days.",
    30859: "Response Distribution",
    30860: "Histogram of review response time broken into 10 tiers.",
    30861: "Happy",
    30862: "Ratio",
    30863: "Lifetime",
    30864: "Count of parent location records, plus unmapped listing records.",
    30865: "Energy",
    30866: "Comment Ratio",
    30867: "Comment Length",
    30868: "Ratio Gap",
    30869: "Length Gap",
    30870: "Reviews with and without comments",
    30871: "Average words per star rating",
    30872: "Percent of words in each star rating",
    30873: "Comment Ratio Percentage",
    30874: "The percent of all reviews that include customer comments",
    30875: "Comment Word Count",
    30876: "The average number of words contained in reviews with comments",
    30877: "Comment Word Distribution",
    30878: "The percent of words in each star rating for each time period",
    30879: "Percent of positive reviews with comments minus the percentage of negative reviews.",
    30880: "Average length of positive reviews minus the average length of negative reviews.",
    30881: "Reviews with response rate",
    30882: "Comment length rate",
    30883: "Grid View",
    30884: "AVG Location",
    30885: "The average review score of the locations and the percent of locations above 4.0 rating in the time range.",
    30886: "Review Performance Grid",
    30887: "Present location rating average versus review volume to identify outliers",
    30888: "Sentiment",
    30889: "Influence",
    30890: "Performance Dashboard",
    30891: "Leadership Grid",
    30892: "Total Views",
    30893: "Conv. Rate",
    30894: "Total views and the average views per locations.",
    30895: "Map views on desktop and mobile with the percent breakdown.",
    30896: "Local search view on desktop and mobile with the percent breakdown.",
    30897: "Total actions with the percent breakdown between calls, website clicks and driving directions.",
    30898: "Total conversion rate of actions/views for calls, website clicks and driving directions.",
    30899: "Customer Views",
    30900: "How and where customers view your business.",
    30901: "Customer Actions",
    30902: "The trackable actions from your Google listings.",
    30903: "The percent of business listing impressions that results in an action",
    30904: "Effectiveness by Location",
    30905: "Total views vs. conversion rate (actions/views) to show each location’s effectiveness in generating views and converting them into actions.",
    30906: "Effectiveness by City",
    30907: "Total views vs. conversion rate (actions/views) for each city.",
    30908: "Effectiveness by Group",
    30909: "Total views vs. conversion rate (actions/views) for each custom group.",
    30910: "High Views + Low Conversion",
    30911: "High Views + High Conversion",
    30912: "Low Views + Low Conversion",
    30913: "Low Views + High Conversion",
    30914: "Mobile",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "Site",
    30920: "Calls",
    30921: "Health Score",
    30922: "Daily Performance",
    30923: "Select the locations from the table and the metric (views or actions)",
    30924: "Happiness Rate",
    30925: "Name/Friendly",
    30926: "{x} locations with {y} star average in last {xx} days ",
    30927: "Above",
    30928: "group",
    30929: "All Views",
    30930: "All Actions",
    30931: "Desktop",
    30932: "Maximum limit reached: Select up to 8 locations for the chart.",
    30933: "Reviewer",
    30934: "Overall Sentiment",
    30935: "Sentiment score distribution across {XX} topics.",
    30936: "Sentiment by Topic",
    30937: "Topic frequency and corresponding sentiment scores.",
    30938: "Very Positive",
    30939: "Very Negative",
    30940: "An automation rule triggered for new review on",
    30941: "An automation rule triggered for updated review on",
    30942: "approved the response on",
    30943: "assigned a tag",
    30944: "assigned the review to",
    30945: "at",
    30946: "Auto reply sent",
    30947: "Business owner created a new external response on",
    30948: "by automation rule on",
    30949: "by system on",
    30950: "created a new",
    30951: "created a new response on",
    30952: "created a review note for",
    30953: "deleted a note on",
    30954: "deleted a review note on",
    30955: "deleted the response on",
    30956: "edited the response on",
    30957: "from",
    30958: "generated an auto-response on",
    30959: "local",
    30960: "notification",
    30961: "Notified",
    30962: "Overview",
    30963: "performed",
    30964: "response",
    30965: "Response moved to Approval Inbox on",
    30966: "Response moved to Outbox and scheduled for posting",
    30967: "Response posted to",
    30968: "Review assigned to",
    30969: "review on",
    30970: "Review received from",
    30971: "sent a note to",
    30972: "System assigned a language tag",
    30973: "System assigned an auto-response on",
    30974: "Tags",
    30975: "team by automation rule on",
    30976: "Timeline",
    30977: "to",
    30978: "updated a",
    30979: "updated a review note on",
    30980: "updated review rating from",
    30981: "updated review status from",
    30982: "Updated review status to",
    30983: "updated the comment on their",
    30984: "via API during",
    30985: "via Pub-Sub on",
    30986: "No Comment Added",
    30987: "on",
    30988: "System",
    30989: "by",
    30990: "unassigned the review from",
    30991: "assigned to",
    30992: "Assigned tag:",
    30993: "Assigned tag group:",
    30994: "removed a tag:",
    30995: "Review with Updates",
    30996: "Review without Updates",
    30997: "Select all tags",
    30998: "Select un-tagged",
    30999: "Awaiting Approval",
    31000: "Oldest first",
    31001: "You don't have any saved Notes",
    31002: "Reply in outbox",
    31003: "Review Versions",
    31004: "Review Detail",
    31005: "Open Info",
    31006: "Relationships",
    31007: "Error",
    31008: "Primary",
    31009: "Categories",
    31010: "Social Links",
    31011: "Original image removed by user or platform."
  },
  portuguese: {
    10010: "1 estrela",
    10013: "2 estrelas",
    10016: "3 estrelas",
    10019: "4 estrelas",
    10022: "5 estrelas",
    10025: "100 a 300 palavras",
    10120: "Ações",
    10123: "Ativar",
    10124: "Sempre ativo",
    10126: "Organizações Ativas",
    10129: "Adicionar",
    10132: "Adicione um botão",
    10135: "Adicionar um botão (opcional)",
    10138: "Adicionar Conta",
    10141: "ADICIONAR TELEFONE ADICIONAL",
    10144: "Adicione uma conta",
    10147: "ADICIONAR OUTRA CATEGORIA",
    10150: "ADICIONAR OUTRA ETIQUETA",
    10153: "Adicionar atributos",
    10156: "Adicionar linha",
    10159: "ADICIONAR NOVA DATA",
    10162: "Adicionar nova tag de comentário",
    10165: "Adicionar novo papel",
    10168: "Adicionar data de abertura",
    10171: "Adicionar perfil",
    10174: "Novo relatório",
    10177: "Adicionar relatório",
    10180: "Adicionar regra",
    10181: "Adicionar tag de revisão",
    10183: "Categoria Adicional",
    10186: "Telefone Adicional",
    10189: "Endereço",
    10192: "ADMIN",
    10195: "Administrador",
    10198: "Extensões de localização do adWords",
    10201: "extensões de localização do adWords",
    10204: "Todos",
    10207: "Todas as Avaliações",
    10210: "Todos os usuários atribuídos a essa função terão acesso aos seguintes recursos",
    10213: "Aplicar",
    10216: "Caixa entrada aprovação",
    10219: "Tem certeza de que deseja redefinir a senha deste usuário?",
    10222: "Você tem certeza?",
    10225: "Estado",
    10228: "Estados",
    10231: "Atributos",
    10234: "Autorizar conta",
    10237: "Média",
    10240: "Quantidade média",
    10243: "Classificação média",
    10244: "Classificação média",
    10246: "Média por local",
    10249: "Esperando resposta",
    10320: "Costas",
    10321: "costas",
    10323: "Faturamento",
    10326: "Livro",
    10329: "Publicação de Envio em Massa",
    10332: "Tags de upload em massa",
    10335: "Upload em massa TSV",
    10338: "Nome da empresa",
    10520: "Calendário",
    10523: "Cancelar",
    10526: "Não é possível fazer o upload do mapeamento de localização principal!",
    10529: "Categoria",
    10532: "Mudar papel",
    10535: "História da citação",
    10538: "Cidade",
    10541: "Clique aqui",
    10544: "Clique em um usuário para atribuir a ele este papel",
    10547: "País",
    10548: "Confirme a Senha",
    10550: "Copiar",
    10553: "Copiar e colar",
    10556: "Não foi possível mudar de papel!",
    10559: "Não foi possível enviar a postagem",
    10562: "Países",
    10565: "País",
    10568: "Código do cupom",
    10571: "Código do cupom (opcional)",
    10574: "Crie um novo filtro selecionando as opções abaixo",
    10577: "Criar novo filtro",
    10580: "Criar novo relatório",
    10583: "Criar Postagens",
    10586: "Criar Tag",
    10589: "Crie este relatório",
    10592: "Crie este papel",
    10595: "Criado por",
    10598: "Ações do Cliente",
    10720: "D",
    10723: "Painel de Controle",
    10726: "Encontro",
    10729: "Intervalo de datas",
    10732: "Dia",
    10735: "Desativar",
    10738: "PADRÃO",
    10741: "Atraso antes de postar",
    10744: "Adiar o envio de respostas por",
    10747: "Adiar o envio de respostas por",
    10750: "Deletar",
    10753: "Excluir?",
    10754: "Excluir",
    10756: "Desc",
    10759: "Descrição",
    10762: "Direta",
    10765: "Consultas diretas",
    10768: "Direções",
    10771: "Descoberta",
    10774: "Visão Distinta",
    10777: "Download de todos os dados de localização",
    10780: "Baixar",
    10783: "Faça o download dos detalhes do local do Google",
    10786: "Download de dados",
    10789: "Rascunhos",
    10792: "Solicitações de Direção",
    10795: "Solicitações de Direção por dia",
    10920: "Editar",
    10923: "Editar Perfil",
    10926: "Editar relatório",
    10929: "Editar este relatório",
    10932: "editor",
    10935: "E-mail",
    10938: "Fim do tempo",
    10941: "Insira as extensões de local do adWords",
    10944: "Digite o nome da tag de entidade",
    10947: "Digite os rótulos",
    10950: "Digite o texto da pesquisa",
    10953: "Digite o nome da tag",
    10956: "É igual a",
    10959: "Evento",
    10962: "Detalhes do evento",
    10965: "Título do evento",
    10968: "Cada",
    10971: "example.com",
    10974: "Exemplo: 20% de desconto na loja ou on-line",
    11120: "Gerenciamento de acesso a recursos",
    11123: "Filtros",
    11126: "Esqueceu a senha?",
    11129: "Sexta-feira",
    11320: "Obter oferta",
    11323: "Maior que",
    11520: "Índice de Satisfação",
    11525: "Socorro",
    11530: "Feriado",
    11535: "Horas",
    11540: "Horas",
    11545: "Como os clientes pesquisam sua empresa",
    11720: "Imagen",
    11723: "Imagem URL",
    11726: "No Maps",
    11729: "Em busca",
    11732: "Caixa de entrada",
    11735: "Consultas Indiretas",
    11738: "Insights",
    11741: "Permissão insuficiente",
    11744: "Integração",
    11747: "Integrações",
    11750: "Convidar Usuário",
    11753: "CONVIDADO",
    11756: "Convidado por",
    11759: "Items",
    12120: "Painel de conhecimento",
    12320: "Rótulos",
    12323: "Último login",
    12326: "Ultima atualização",
    12329: "Saber mais",
    12332: "Menos que",
    12335: "Link para o seu botão",
    12338: "Link para resgatar oferta",
    12341: "Link para resgatar oferta (opcional)",
    12344: "Ligação",
    12347: "Gestão de listagens",
    12350: "Desempenho Local",
    12353: "Visão geral de desempenho local",
    12356: "Conversão de pesquisa local",
    12359: "Cidades",
    12362: "Cidade",
    12365: "Localidade",
    12368: "Detalhes da localização",
    12371: "ID de localização",
    12374: "Localidade",
    12377: "Entrar",
    12380: "Sair",
    12520: "M",
    12523: "Destaque seu post com uma foto",
    12526: "Gerenciar atividade em massa",
    12529: "Gerenciar tags de entidade",
    12532: "Gerenciar locais",
    12535: "Gerenciar perfil",
    12538: "Gerenciar Funções",
    12541: "Gerenciar usuários",
    12544: "Mapas",
    12547: "Contagem de Estabelecimentos",
    12550: "Fotos da localidade",
    12553: "Fotos da Localidade",
    12556: "mensagem",
    12559: "Minutos",
    12562: "segunda-feira",
    12565: "mês",
    12720: "Nome",
    12723: "Nome do novo papel",
    12726: "Nome do relatório",
    12729: "Precisa de uma conta?",
    12732: "Novo",
    12735: "Próxima página",
    12738: "Sem Respostas",
    12741: "Nenhum resultado encontrado",
    12744: "Nenhuma marca de revisão existe ainda",
    12747: "Sem resenhas",
    12750: "Não, cancelar",
    12753: "Nº de usuários",
    12756: "Notas",
    12920: "de",
    12923: "Oferta",
    12926: "Está bem",
    12929: "OK, entendi!",
    12932: "Uma vez",
    12935: "Data de abertura",
    12938: "Ordem",
    12941: "Organizações",
    12944: "Caixa de fora",
    12947: "Proprietário",
    13120: "Página",
    13123: "Senha",
    13126: "Colar TSV",
    13129: "Tipo de PDF",
    13132: "telefone",
    13135: "Telefonemas por dia",
    13138: "Número de telefone",
    13141: "Quantidade de Fotos",
    13144: "Visualizações de fotos",
    13147: "Por favor insira um nome de recepiente!",
    13150: "Por favor insira um nome de relatório!",
    13153: "Por favor, insira um resumo!",
    13156: "Por favor insira um título!",
    13159: "Por favor insira um horário válido!",
    13162: "Por favor, insira um URL válido!",
    13165: "Por favor, atualize a página para atualizar seus detalhes de localização",
    13168: "Por favor recarregue",
    13171: "Por favor, selecione o tipo de agendamento!",
    13174: "Postar Histórico",
    13177: "Postagens",
    13180: "Página Anterior",
    13183: "Categoria principal",
    13186: "Telefone principal",
    13189: "Telefone principal",
    13192: "Perfis",
    13195: "Contagem Pública",
    13198: "Fotos Públicas",
    13201: "Fotos públicas",
    13204: "PUBLICAR",
    13520: "Class. Méd.",
    13523: "Notificações em tempo real",
    13526: "Lista de destinatários",
    13529: "Recorrente",
    13532: "Remover usuário",
    13535: "Responder",
    13538: "Aprovação de resposta",
    13541: "Gerenciamento de relatórios",
    13544: "Nome do relatório",
    13547: "Tipo de relatório",
    13550: "Redefinir senha",
    13553: "Respostas por classificação por estrelas",
    13556: "Contagem de revisão",
    13559: "Revisar Download",
    13562: "Revisar configurações",
    13565: "Fonte das Avaliações",
    13568: "Revisar tags",
    13571: "Revisar Link",
    13574: "Avaliações",
    13577: "Avaliações por classificação por estrelas",
    13580: "Avaliações vs Classificação Média",
    13583: "Avaliações Caixa de Entrada",
    13586: "Gerenciamento de avaliações",
    13589: "Avaliações (dias do mês)",
    13592: "Avaliações (dias da semana)",
    13595: "Avaliações (meses do ano)",
    13598: "Função",
    13601: "Detalhes da Função",
    13604: "Nome do papel",
    13720: "sábado",
    13723: "Salvar",
    13726: "Salvar como filtro personalizado",
    13729: "Salvar novo filtro",
    13732: "Salvar papel",
    13735: "Respostas salvas",
    13738: "Data de agendamento",
    13741: "Agendar Post",
    13742: "Para agendar um relatório",
    13744: "Hora agendada",
    13747: "Tipo de agendamento",
    13750: "Busca",
    13753: "Pesquisas",
    13756: "Selecione",
    13759: "Selecione um filtro existente",
    13762: "Selecione a Categoria",
    13765: "Selecionar a cidade",
    13768: "Selecionar o país",
    13771: "Selecione data e hora",
    13774: "Selecione o período",
    13777: "Selecione Editor (s) para revisar",
    13780: "Selecionar tag de entidade",
    13783: "Selecionar filtro",
    13786: "Selecionar filtros",
    13789: "Selecione granularidade",
    13792: "Selecione a organização",
    13795: "Selecionar etiqueta de revisão",
    13798: "Selecionar filtro salvo",
    13801: "Selecionar a fonte",
    13804: "Selecionar o estado",
    13807: "Selecionar hora",
    13810: "AUTO",
    13813: "Envie-o para aprovação",
    13816: "Envie para a caixa de saída",
    13819: "Enviei",
    13822: "Serviços",
    13825: "Configurações",
    13828: "Gerenciamento de configurações",
    13831: "Fazer Compras",
    13834: "Mostrar mensagens",
    13837: "Mostrar / ocultar navegação",
    13840: "Inscrever-se",
    13843: "Único local Editar",
    13846: "Desculpa!",
    13849: "Ordenar por",
    13852: "Horas especiais",
    13855: "Acesso Específico",
    13858: "PADRÃO",
    13861: "Hora de início",
    13864: "Estado",
    13867: "Status",
    13870: "Loja",
    13873: "Código da loja",
    13876: "Rua",
    13879: "Visão resumida",
    13882: "domingo",
    13885: "Sincronizar esta conta",
    13920: "Chamadas telefônicas",
    13923: "Termos e Condições",
    13926: "Quinta-feira",
    13929: "Tempo",
    13932: "Principais localidades",
    13935: "Total",
    13938: "terça-feira",
    14120: "Sem resposta",
    14123: "Não tem certeza do formato?",
    14126: "Envio",
    14129: "Carregar Detalhes do Local",
    14132: "Carregar Mapa de Localização",
    14135: "Upload de mapeamento de localização",
    14138: "Carregar TSV",
    14141: "URL",
    14144: "ID do usuário",
    14320: "Ver imagem",
    14323: "Ver perfil",
    14326: "Visualizações",
    14520: "S",
    14523: "Cliques no site",
    14526: "Website por dia",
    14529: "Nome do site",
    14532: "Quarta-feira",
    14535: "semana",
    14538: "Quais ações os clientes realizam",
    14541: "Quando uma resposta a um comentário é feita",
    14544: "Onde os clientes visualizam sua empresa",
    14547: "Deseja excluir esta postagem programada?",
    14550: "Escreva seu título",
    14920: "Ano",
    14923: "Sim continuar",
    14926: "Você pode optar por limitar o acesso de usuários com essa função, selecionando um filtro para anexá-lo.",
    14929: "Nome",
    15120: "CEP",
    20010: "Segunda-feira",
    20011: "Seg",
    20020: "Terça-feira",
    20021: "Ter",
    20030: "quarta-feira",
    20031: "Qua",
    20040: "quinta-feira",
    20041: "Qui",
    20050: "sexta-feira",
    20051: "Sex",
    20060: "sábado",
    20061: "Sab",
    20070: "domingo",
    20071: "Dom",
    20110: "janeiro",
    20111: "jan.",
    20120: "fevereiro",
    20121: "fev.",
    20130: "março",
    20131: "março",
    20140: "abril",
    20141: "abril",
    20150: "maio",
    20151: "maio",
    20160: "junho",
    20161: "junho",
    20170: "julho",
    20171: "julho",
    20180: "agosto",
    20181: "agosto",
    20190: "setembro",
    20191: "set.",
    20200: "outubro",
    20201: "out.",
    20210: "novembro",
    20211: "nov.",
    20220: "dezembro",
    20221: "dez.",
    20231: "Avaliações & Classificação",
    20241: "Porcentagem",
    20251: "Percentagem das Avaliações",
    20261: "Acumulado",
    20271: "Contagem cumulativa",
    20281: "Fonte",
    20291: "Fonte das Avaliações",
    20301: "Satisfação",
    20311: "Tempo de Resposta",
    20321: "Selecionar local",
    20331: "Busca por palavra-chave comentários",
    20341: "pesquisa por revisor",
    20351: "Selecione",
    20361: "Igual a",
    20371: "Menor que",
    20381: "Maior que",
    20391: "Selecionar meses",
    20401: "Selecione a data",
    20411: "Clique para visualizer as avaliações",
    20421: "Não houve comentários encontrados para o período selecionado e critérios",
    20431: "Limpar filtro",
    20441: "Excluir um filtro personalizado",
    20451: "Tem Google Updates",
    20461: "Verificado",
    20471: "Localidade publicada",
    20481: "Tem edições pendentes",
    20491: "Painel Principal",
    20501: "Link da avaliação",
    20511: "Direções",
    20521: "Duplicado",
    20531: "Ativo",
    20541: "Pode atualizar",
    20551: "Pode excluir",
    20561: "Nenhuma avaliação pendente",
    20571: "Localidade ativada",
    20581: "Não desconectado",
    20591: "Log de alterações",
    20601: "Upload imagens em massa",
    20611: "Histórico imagens",
    20621: "Upload notas em massa",
    20631: "Upload P&R em massa",
    20641: "Histórico P&R",
    20651: "Adicione uma pergunta",
    20661: "Compartilhe perguntas direcionadas para clientes que destacam o propósito ou vantagem competitiva da sua localidade. Feito isso, as perguntas podem ser respondidas.",
    20671: "Detalhes da plataforma",
    20681: "Variáveis para respostas automáticas",
    20691: "Nome da localidade",
    20701: "Nome geográfico",
    20711: "Assinatura",
    20721: "Nome geográfico (máx. 80 caracteres)",
    20731: "Nome da assinatura (máx. 80 caracteres)",
    20741: "Resposta automatica",
    20751: "Baixar avaliações",
    20761: "Resposta Automática",
    20771: "Link externo",
    20781: "Revisão de cópia",
    20791: "Adicionar nota",
    20801: "Nota Externa",
    20811: "Marcar como impróprio",
    20821: "Marcar como removido",
    20831: "Você tem certeza ?",
    20841: "Deseja marcar esta avaliação como removida do Google?",
    20851: "Inserir respostas salvas",
    20861: "Salvar como resposta modelo",
    20871: "Inserir resposta automática modelo",
    20881: "Enviar",
    20891: "Enviar para aprovação",
    20901: "Salvar como rascunho",
    20911: "Atribuir anotação",
    20921: "E-mail anotação",
    20931: "Destinatário",
    20941: "Salvar como anotação",
    20951: "Fechar",
    20961: "Descartar",
    20971: "Enviar correio",
    20981: "Nehuma anotação salva",
    20991: "Todos apanhados!",
    21001: "Nehuma entrada",
    21011: "Respostas Enviadas",
    21021: "Nenhum comentário",
    21031: "Editar resposta",
    21041: "Excluir resposta",
    21051: "Pesquisar resposta salva",
    21061: "Adicionar resposta salva",
    21071: "Definir grupo e assunto para salvar resposta",
    21081: "Selecionar/criar grupo",
    21091: "Digitar título",
    21101: "Inserir resposta modelo",
    21111: "Selecionar/criiar grupo e título para salvar resposta",
    21121: "Respostas automáticas",
    21131: "Adicionar resposta automática",
    21141: "Selecione um grupo",
    21151: "Inserir variável",
    21161: "Escolha suas variáveis",
    21171: "Você deseja continuar?",
    21181: "Solicitação acima de 100 avaliações. E-mail será enviado com link para baixar avaliações",
    21191: "Solicitação acima de 100 avaliações",
    21201: "E-mail será enviado para XXXXXX com um link para baixar avaliações",
    21211: "Ações",
    21221: "Todas localidades",
    21231: "Classificação média",
    21241: "Marca",
    21251: "Direto",
    21261: "Descoberta",
    21271: "Geografia",
    21281: "Satisfação",
    21291: "Pesquisas",
    21301: "Respostas",
    21311: "Visualizações",
    21321: "Agendamento Post",
    21331: "Agendamento Post no Google",
    21341: "Crirar Post",
    21351: "Gerenciar Post",
    21361: "Agendar Post Local",
    21371: "Subir Arquivo",
    21381: "Progresso",
    21391: "Validar e agendar",
    21401: "Status Agendamento",
    21411: "Selecionar Arquivo",
    21421: "Selecionar Tipo de Agendamento",
    21431: "Imediato",
    21441: "Horário do Arquivo",
    21451: "Selecionar hora",
    21461: "Enviar após vericicação",
    21471: "Agenda com base no horário no arquivo",
    21481: "Agendar arquivo pelo horário selecionado",
    21491: "Fila",
    21501: "Validação em andamento. A velocidade é 40 posts por minuto. Após a validação, veja o status de cada postagem na próxima página.",
    21511: "Post processado",
    21521: "Validação com sucesso",
    21531: "Falha na validação",
    21541: "Agendado",
    21551: "Tipo / Ação",
    21561: "datas",
    21571: "Iniciar",
    21581: "Finalizar",
    21591: "Título / Produto",
    21601: "Resumo da Postagem",
    21611: "Status",
    21621: "Sucesso",
    21631: "Erro",
    21641: "Editar / Excluir",
    21651: "Post Insights",
    21661: "Google Post Insights",
    21671: "Desempenho",
    21681: "Post visualizações",
    21691: "Post por mídia",
    21701: "Post por assunto",
    21711: "Post por ação",
    21721: "Análise",
    21731: "Criada",
    21741: "Tipo",
    21751: "Ação",
    21761: "Filtro de origem",
    21771: "Plataforma",
    21781: "Status dos post locais atualizados",
    21791: "Criador de campanhas",
    21801: "Resposta automática inteligente",
    21811: "Ativar o criador de campanhas de resposta automática",
    21821: "Antes de ativar a opção de agendamento de resposta automática, siga as instruções abaixo:",
    21831: 'Antes de ativar a resposta automática inteligente, adicione seus modelos de resposta automática na seção "Caixa Avaliação". Crie as respostas e classifique na escala de (1-5) estrelas para acionar a resposta automática inteligente.',
    21841: "No criador de campanhas, defina o tempo entre o recebimento da avaliação e o envio da resposta automática. O tempo para envio das resposta deve ser configurado com objetivo de mascarar a natureza automática do programa.",
    21851: "Para a campanha configure o horário e dias da semana. O padrão para o fuso horário é GMT + 00: 00; portanto, atualize de acordo com a localização.",
    21861: "Criar Campanha",
    21871: "Atribua um nome e notas para identificar facilmente sua campanha.",
    21881: "Nome da campanha",
    21891: "Responsável pela campanha",
    21901: "Se nenhuma opção for selecionada, o email padrão usado para inscrição e autorização de contas será o da pessoa responsável pela campanha.",
    21911: "Responsável pela resposta automática",
    21921: "Período da campanha",
    21931: "Notas / Objetivos",
    21941: "Descrição da campanha",
    21951: "Definir gatilhos",
    21961: "Escolha o tipo de avaliação que solicitará uma resposta automática para a campanha.",
    21971: "com comentário",
    21981: "sem comentários",
    21991: "anterior",
    22001: "Próximo",
    22011: "Definir público-alvo (opcional)",
    22021: "Defina os locais para campanha com base em uma tag de entidade, uma organização, um país, região ou localidade específica. Esses filtros estão disponíveis apenas para avaliações do Google e locais mapeados",
    22031: "entidade",
    22041: "organização",
    22051: "Definir programação",
    22061: "Atribua os parâmetros e o cronograma para as respostas das avaliações, ou seja, a porcentagem de avaliações direcionadas e o horário de operação das respostas.",
    22071: 'Saiba que atualmente as respostas automáticas estão disponíveis apenas com base em "avanço". Estamos trabalhando em processos separados para usuários que desejam fazer uma limpeza a curto prazo automaticamente.',
    22081: "Definir taxa de resposta",
    22091: "definir contagem de respostas",
    22101: "Tempo antes de enviar a resposta automática",
    22111: "agendar periodicamente",
    22121: "Selecione o dia e defina a hora para agendar periodicamente a resposta automática",
    22131: "Selecionar fuso horário",
    22141: "Atribuir respostas",
    22151: "Selecione na lista quais respostas serão usadas na campanha.",
    22161: "Confirmar",
    22171: 'Revise todas informações abaixo e pressione "confirmar" para iniciar sua campanha.',
    22181: "Dias",
    22191: "Estrela",
    22201: "Média",
    22211: "Informando",
    22221: "Configuração do concorrente",
    22231: "Melhores Práticas",
    22241: "Quadrante",
    22251: "Tipo de Avaliação",
    22261: "Ranking Competitivo",
    22271: "Resp.",
    22281: "Exibir fonte das avliações",
    22291: "Adicionar concorrente",
    22301: "Filtrado por",
    22311: "Limpar",
    22321: "Concorrente",
    22331: "Entidade concorrente",
    22341: "Tag de Entidade",
    22351: "Comentários",
    22361: "Sem opções",
    22371: "Mal",
    22381: "Fraco",
    22391: "Médio",
    22401: "Ótimo",
    22411: "Excelente",
    22421: "Avaliações c/ resposta",
    22431: "Avaliações s/ resposta",
    22441: "Avaliações c/ comentários",
    22451: "Avaliações s/ comentários",
    22461: "Quantidade de Avaliações versus Classificação Média",
    22471: "Marcas",
    22481: "Ampliação",
    22491: "Total de Avaliações",
    22501: "Analisar classificação por estrela",
    22511: "Avaliações dos concorrentes",
    22521: "Concorrente de",
    22531: "Código",
    22541: "Gerenciar concorrentes",
    22551: "Atualizada",
    22561: "Adicionar concorrentes",
    22571: "Adicionar local",
    22581: "Adicionar nome do concorrente",
    22591: 'Primeiro adicione o nome do competidor e em seguida a logomarca (48x48 imagem) como opcional na lista, após isso clique em "adicionar". Após a criação dos competidores você poderá associar à cada localidade específica',
    22601: "Digite o nome do concorrente (obrigatório)",
    22611: "Digite o URL do concorrente (opcional)",
    22621: "Enviar Imagem",
    22631: "Em breve",
    22641: "Taxa de comentários por avaliação",
    22651: "Porcentagem das avaliações com e sem comentários",
    22661: "Sem",
    22671: "Com",
    22681: "Tamanho da avaliação",
    22691: "Quantidade média de palavras usadas em cada uma das avaliações.",
    22701: "Palavras",
    22711: "Taxa de palavras por comentário",
    22721: "Quantidade e porcentagem de palavras para cada avaliação.",
    22731: "aqui.",
    22741: "Competidores",
    22751: "Adicionar palavra-chave",
    22761: "Escolha variáveis para serem adicionadas ao modelo",
    22771: "Fechar avaliação",
    22781: "Avaliação fechada",
    22791: "Deseja fechar esta avaliação? Depois de fechá-la, será necessário reabrí-la para responder",
    22801: "Externo",
    22811: "Negativo",
    22821: "Não",
    22831: "Nenhuma resposta automática!",
    22841: "Nenhuma resposta salva ainda!",
    22851: "Nota",
    22861: "Permanentemente fechada",
    22871: "Positivo",
    22881: "Tempo limite de leitura esgotado",
    22891: "Reintegrar avaliação",
    22901: "Reabrir avaliação",
    22911: "Respondida",
    22921: "Resposta enviada (da interface do Google)",
    22931: "Resposta enviada a partir do aplicativo",
    22941: "Avaliação removida",
    22951: "Modelos",
    22961: "Temporariamente fechada",
    22971: "Sim",
    22981: "Você não tem nenhum rascunho salvo",
    22991: "Permissões insuficientes para acessar o recurso",
    23001: "Erro interno encontrado",
    23011: "O pedido contém um argumento inválido",
    23021: "A entidade solicitada não foi encontrada",
    23031: "A avalição foi removida do GMN.",
    23041: "Alguns dos valores de inserção automática não estão disponíveis. Substitua e envie",
    23051: "O serviço está indisponível no momento",
    23061: "Esta operação não é compatível em localidades sem verificação de propriedade.",
    23071: "Postagem Publicada",
    23081: "Postagem Agendada",
    23091: "Nome Amigável",
    23101: "Add friendly name",
    23111: "Contato",
    23121: "No contacts!",
    23131: "To add contact",
    23141: "Nome de Contato",
    23151: "Contact E-Mail",
    23161: "Adicionar contato",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "Sem Dados",
    23201: "Google Audit",
    23211: "Registros de Auditoria",
    23221: "Selecionar um Relatório",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "Downloads de Dados",
    23271: "Download de Avaliação",
    23281: "Todas Avaliações",
    23291: "Download de URL de Fotos",
    23301: "URLs de Fotos de Cliente",
    23311: "URLs de Fotos do Marca",
    23321: "Relatório de Histórico de Downloads",
    23331: "Report Name",
    23341: "Enviado para",
    23351: "Horário de Criação (UTC)",
    23361: "Tipo de Relatório",
    23371: "Profile Details",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "Atualizar",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "Upload",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "Controle de Gerenciamento em Massa",
    23721: "Atualize os detalhes de localidade e controle os parâmetros da plataforma diretamente nas Planilhas Google.",
    23731: "PLATFORM",
    23741: "Gerencie facilmente contas de qualquer escala com variáveis e configurações de localidades personalizadas.",
    23751: "Detalhes GBP",
    23761: "Visualize todas as listagens do Google Meu Negócio e adicione/edite/exclua diretamente os detalhes da localidade.",
    23771: "Atributos GBP",
    23781: "Atribua todos os atributos elegíveis a cada localidade para obter descoberta de pesquisa incremental.",
    23791: "Listagem GBP",
    23801: "Criar nova listagem GBP",
    23811: "Facebook",
    23821: "Controle de listagem do Facebook",
    23831: "Histórico",
    23841: "Treinamento",
    23851: "Acesse recursos para fluxos de trabalho de edição em massa, práticas recomendadas, limitações e atualizações.",
    23861: "AVISO",
    23871: "Requisito",
    23881: "Os usuários devem ter uma conta do Google para que o sistema possa apresentar uma planilha do Google com os dados do perfil.",
    23891: "Aviso:",
    23901: "Os dados que preenchem cada planilha são provenientes do banco de dados do sistema. Se você deseja ter certeza de que a planilha apresenta os dados atuais do Google, recomendamos que primeiro sincronize seu perfil.",
    23911: 'Dependendo do número de localidades em sua conta, o Editor de Planilhas do Google pode levar algum tempo para criar inicialmente e depois atualizar conforme você navega na planilha. Certifique-se de que todos os dados estejam estáveis antes de clicar "Atualizar" para salvar as edições no sistema e enviar atualizações para o Google.',
    23921: "A plataforma tem uma conexão direta de API com o Google, mas ainda pode haver momentos em que o Google atrasa a atualização direta da página de listagem de localidades públicas",
    23931: "Clicar “Atualizar” aciona um sistema direto diretamente para o Google. Não há processo de desfazer ou reverter disponível. Certifique-se de que você está confortável com todas as edições antes de acionar a atualização. Se você cometer um erro, aguarde alguns minutos e faça as alterações necessárias",
    23941: "ESQUEMA DE CORES",
    23951: "Cada planilha possui um esquema de cores padrão para ajudar os usuários a entender quais campos estão qualificados para edição.",
    23961: "Variáveis que transmitem detalhes de status do Google ou não podem ser editadas diretamente por meio de controles em massa.",
    23971: "As variáveis do Google são abertas diretamente para edição em massa.",
    23981: "Variáveis de plataforma abrem diretamente para edição em massa.",
    23991: "Controle",
    24001: "Detalhes",
    24011: "Atributos",
    24021: "Criar Listagem",
    24031: "Instruções",
    24041: "Expira em",
    24051: "Renove a assinatura",
    24061: "A assinatura expira em",
    24071: "Para acessar a plataforma, por favor, renove a assinatura",
    24081: "Me leve lá!",
    24091: "Mais tarde",
    24101: "Cobrança",
    24111: "Detalhes do plano",
    24121: "Básico",
    24131: "Pro",
    24141: "por localidade",
    24151: "$ 8 por localidade",
    24161: "10 primeiras localidades",
    24171: "mínimo de $ 24 por mês",
    24181: "Teste grátis por 14 dias",
    24191: "Todas funcionalidades inclúsas",
    24201: "Caixa de entrada com todas as avaliações",
    24211: "Acesso a todas as funções",
    24221: "Painel completo de relatórios",
    24231: "Usuários ilimitados",
    24241: "30 respostas pré-instaladas para avaliações",
    24251: "Total suporte",
    24261: "Localidades 11 a 200",
    24271: "Todas funcionalidades do plano básico",
    24281: "Gerenciamento completo do GMN",
    24291: "Programar/Disparar Posts em massa",
    24301: "Notificações em tempo real",
    24311: "Configuração de relatórios personalizados",
    24321: "Otimização de pesquisa local",
    24331: "Configuração inicial personalizada",
    24341: "Auditoria de avaliações Ofensivas & Fraudulentas",
    24351: "Atividade",
    24361: "Autorizado",
    24371: "As conexões autorizadas tem acesso a todos os recursos de revisão e resposta de/para cada fonte.",
    24381: "Criar e nomear entidades em massa",
    24391: "Upload em Massa Detalhes GMN",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "Criar e nomear uma entidade",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "Histórico do relatório do GBP",
    24491: "Impressões",
    24501: "Inativo",
    24511: "Indexado",
    24521: "As conexões indexadas acessam todos os comentários anteriores e atuais de cada fonte.",
    24531: "Manage LocalPost",
    24541: "nenhum comentário adicionado",
    24551: "Número",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "Save a reply",
    24601: "Localizações Totais",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "Upload de Apelidos de Localizações",
    24641: "Visualizar",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "Desanexado",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Escolher arquivo",
    24911: "No file chosen",
    24921: "Visualize um registro de cada push de atualização para confirmar as alterações de conteúdo da lista e detectar quaisquer erros.",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "ID de Usuário",
    24961: "Do you want to delete?",
    24971: "Conta",
    24981: "Não Há Atualizações do Google",
    24991: "Reverificação não necessária",
    25001: "No pending edits",
    25011: "Horário de Auditoria",
    25021: "Campo",
    25031: "Valor(para)",
    25041: "Valor(de)",
    25051: "remove from entity tag",
    25061: "Lista de Atributos",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "Explorar",
    25111: "Explorar as respostas",
    25121: "Selecionar Modelo",
    25131: "Continuar",
    25141: "Escolha a classificação por estrelas, o nome do modelo e adicione o conteúdo do modelo para salvar a resposta automática.",
    25151: "Select reply type",
    25161: "Modelo",
    25171: "Snippet",
    25181: "Atribuir à classificação (obrigatório)",
    25191: "Insira o Nome do Modelo (obrigatório)",
    25201: "Variável de Modelo Personalizado (opcional)",
    25211: "Selecionar ou Criar tópico (opcional)",
    25221: "Atribuir à uma única localidade (opcional)",
    25231: "Atribuir à tag de entidade (opcional)",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "Nota da Localzação",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "See the review directly on Google",
    25301: "Positivo-5 estrelas",
    25311: "Negativo - 1/2 estrelas",
    25321: "Mista - 3/4 estrelas",
    25331: "Nome do Modelo",
    25341: "Variável",
    25351: "Select or Create topic (optional)",
    25361: "Grupo",
    25371: "Tópico",
    25381: "Avaliações Anteriores",
    25391: "Salvar Como Resposta",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "Data Criada",
    25441: "Nome de Filtro Personalizado",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "Download",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "Pagina Inicial Padrão",
    25691: "Avaliações Caixa de Entrada",
    25701: "Gestão de Massa",
    25711: "Agendamento de Postagem",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn of Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "Taxa de Resposta",
    25781: "Contagem de Resposta",
    25791: "Avaliações por estrelas",
    25801: "Com",
    25811: "Sem",
    25821: "Atraso",
    25831: "Fuso Horário",
    25841: "Revisão",
    25851: "Competitor Report",
    25861: "Formato",
    25871: "HTML Email",
    25881: "Excel",
    25891: "Se não houver comentários no intervalo selecionado",
    25901: "Não enviar email",
    25911: "Enviar email",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "Entre em contato com o suporte se tiver dúvidas sobre a cadência de sincronização de perfil",
    25971: "Include Audit File",
    25981: "Perfil",
    25991: "CompTag",
    26001: "Detalhes das Avaliações",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "Gráfico de linhas de ações do cliente para direções, chamadas telefônicas e cliques no site.",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings.",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size.",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users.",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses.",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Ontem",
    27251: "Últimos 7 dias",
    27261: "Semana Passada",
    27271: "Últimos 30 dias",
    27281: "Mês passado",
    27291: "Todos os períodos",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "Salvar esta resposta?",
    27341: "Select or create a group",
    27351: "No saved replies",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "Todas localidades",
    27451: "Abertas",
    27461: "Atualizações do Google",
    27471: "Conteúdo ausente",
    27481: "Código da Loja",
    27491: "Categorias Adicionais",
    27501: "Localizações de pesquisa",
    27511: "GBP Audit",
    27521: "Atividade em massa",
    27531: "Selecione o Grupo",
    27541: "20/ page",
    27551: "Sincronizar",
    27561: "Definir Público Alvo",
    27571: "Feito",
    27581: "Group Name",
    27591: "Minutos",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "Análise de Quadrante",
    27631: "Dados de todos os locais",
    27641: "Grande Qtd Pesquisa + Baixa taxa de conversão",
    27651: "Grande Qtd Pesquisa + Alta taxa de conversão",
    27661: "Baixa Qtd Pesquisa + Baixa taxa de conversão",
    27671: "Baixa Qtd Pesquisa + Alta taxa de conversão",
    27681: "Dados de localização por região",
    27691: "Dados de localização por cidade",
    27701: "Localidade",
    27711: "Taxa de Conversão",
    27721: "Pesquisas",
    27731: "Google Perguntas & Respostas",
    27741: "Google QA",
    27751: "Baixar Perguntas & Respostas",
    27761: "Postar Resposta",
    27771: "Insight de Postagem",
    27781: "Baixar exemplo arquivo CSV",
    27791: "Arquivo CSV modelo",
    27801: "Gerenciar Perfil",
    27811: "Adicionar Perfil",
    27821: "Visualizar Pefil",
    27831: "Remover Perfil",
    27841: "Usuários",
    27851: "Gerenciar Perfil",
    27861: "Remover Perfil",
    27871: "Você tem certeza que quer remover este perfil?",
    27881: "Contas",
    27891: "Selecionar Perfís",
    27901: "Selecionar Perfil",
    27911: "Conta do Perfil",
    27921: "Detalhes do Perfil",
    27931: "Nome do Perfil",
    27941: "Imagem atual do Perfil",
    27951: "Upload Logotipo do Perfil",
    27961: "Altere o nome do perfil",
    27971: "Teste piloto",
    27981: "Atual",
    27991: "Expirou",
    28001: "Cancelada",
    28011: "Nota Fiscal",
    28021: "Conectado",
    28031: "Quantidade de contas",
    28041: "Total de localidades",
    28051: "Localidades ativas",
    28061: "Avaliações (30 dias)",
    28071: "Status do pagamento",
    28081: "Nome do perfil",
    28091: "Insira o Nome do Perfil",
    28101: "A portfolio can bulk manage their users across different prolfiles easily",
    28111: "Nome do novo perfil",
    28121: "O nome do perfil pode ter no máximo 20 cractéres",
    28131: "Perfil criado com sucesso",
    28141: "Total de Perfís",
    28151: "Total de Usuários",
    28161: "Insira E-mail",
    28171: "Convide alguém para ajudar no gerenciamento do seu perfil. Você pode configurar o acesso ao seu perfil selecionando a função.",
    28181: "Convite",
    28191: "Arquivo Atual de Imagens",
    28201: "Sentimento",
    28211: "Aguardando",
    28221: "Mais Filtros",
    28231: "Tag de revisão",
    28241: "Filtros salvos",
    28251: "Menos Filtros",
    28261: "Nenhum texto",
    28271: "Médio",
    28281: "Expandir",
    28291: "Upldoad Imagem Única",
    28301: "Selecione Tipo de Imagem",
    28311: "Selecione Tipo",
    28321: "Foto de Capa",
    28331: "Foto do Perfil",
    28341: "Foto Externa",
    28351: "Foto Interna",
    28361: "Foto Produto",
    28371: "Foto Trabalho",
    28381: "Foto Logotipo",
    28391: "Foto Comida e Bebida",
    28401: "Menu Fotos",
    28411: "Foto Área Comum",
    28421: "Foto Ambiente",
    28431: "Foto da Equipe",
    28441: "Visualizações",
    28451: "Foto",
    28461: "Abertas",
    28471: "Concluída",
    28481: "Removida",
    28491: "Nova Palavra Chave",
    28501: "Todas as Avaliações",
    28511: "Nada para mostrar nesta faixa!",
    28521: "Procurar",
    28531: "Selecionar Todos",
    28541: "Procurar fonte",
    28551: "Procurar tag de revisão",
    28561: "Procurar Localização",
    28571: "Procurar Código da Loja",
    28581: "Procurar Grupo",
    28591: "Organizações",
    28601: "Tag de entidades",
    28611: "Aplicar",
    28621: "Grupo",
    28631: "Procurar Filtros Salvos",
    28641: "Sem opções!",
    28651: "Ajustar visualização do texto de revisão",
    28661: "Veja a avaliação diretamente em",
    28671: "Responder na Plataforma de Revisão",
    28681: "Selecionar Modelo",
    28691: "Copiar",
    28701: "Avaliações Anteriores",
    28711: "Sem Avaliações",
    28721: "Avaliação",
    28731: "Nome da Localização da Resposta não adicionado nessa localização",
    28741: "Assinatura não adicionada nessa localização",
    28751: "Você deseja continuar o download?",
    28761: "Avaliações sem Resposta",
    28771: "Avaliações com Resposta Interna",
    28781: "Avaliações com Resposta-Automática",
    28791: "Avaliações com Resposta Externa",
    28801: "Veja o Painel do Google Knowledge",
    28811: "Nota da Localzação",
    28821: "Novo Gerente",
    28831: "Habilitar Cc",
    28841: "Salvar Como Resposta",
    28851: "Apagar Resposta",
    28861: "Grupo",
    28871: "Mista",
    28881: "Estrelas",
    28891: "Negativo, Misto, Positivo",
    28901: "Avaliação",
    28911: "Nome do Modelo",
    28921: "Variável",
    28931: "Salvar Resposta",
    28941: "Editar Nome da Conta",
    28951: "Mudar Nome da Conta",
    28961: "Nome da Conta",
    28971: "Localizações Facebook",
    28981: "Adicionar Página",
    28991: "Ativada",
    29001: "Mostrar Localidade Ocultas",
    29011: "Visualizar Página do FB",
    29021: "Nenhuma conta oculta para mostrar",
    29031: "Horas Atras",
    29041: "Convidado Por",
    29051: "Mostruário de Avaliações",
    29061: "Google Localidade",
    29071: "Suas localizações",
    29081: "URL da Localização",
    29091: "Tem certeza de que deseja excluir essa URL?",
    29101: "Gostaria de excluir a URL e seus dados relacionados do aplicativo?",
    29111: "Localidade dos Concorrentes",
    29121: "Nome dos Competidores",
    29131: "ID do Local",
    29141: "Tag do Compt",
    29151: "Insira URLs de localização e Detalhes do Concorrente",
    29161: "É Competidor",
    29171: "Localizações do Booking",
    29181: "Para iniciar a integração de Avaliações do Booking",
    29191: "ID de Localização do Back Office (opcional)",
    29201: "Por favor, preencha o seu ID de Local ou os detalhes do concorrente. Para 20 ou mais locais, forneça uma lista de cada local como um arquivo Excel para",
    29211: "Para baixar o arquivo de amostra, clique aqui.",
    29221: "Observe que pode levar vários minutos para concluir a busca inicial",
    29231: "Forneça uma lista de cada",
    29241: "URL de localização do Trustpilot para empresas para",
    29251: "Você pode colocá-los diretamente no e-mail ou fornecer um Excel de listas de planilhas do Google",
    29261: "Preencha o URL do seu local e o ID do local de back office opcional (para oferecer suporte a links diretos para respostas de comentários) ou os",
    29271: "detalhes do concorrente",
    29281: "Grandes contas (mais de 20 locais) podem fornecer uma lista de cada local como um arquivo Excel para",
    29291: "Crie campanhas para responder diretamente as avaliações com a resposta perfeita no momento perfeito.",
    29301: "Tem certeza de que deseja excluir esta campanha?",
    29311: "Copie Avaliações inteligentes para cada gerente de localidade atribuído",
    29321: "Respostas CC para Gerentes de Localidades Atribuídos",
    29331: "Respostas CC para Corporativo",
    29341: "Recipientes",
    29351: "Todos os destinatários",
    29361: "Selecionar a Fonte da Avaliação",
    29371: "Pub/Sub Apenas",
    29381: "Selecionar Avaliação por Estrelas",
    29391: "Selecionar Conteúdo da Avaliação",
    29401: "Grupo Personalizado",
    29411: "Definir atraso antes de enviar resposta automática",
    29421: "Definir o Horário de Funcionamento",
    29431: "Opcional",
    29441: "Nenhuma localidade selecionada",
    29451: "Não foram encontrados insights para o intervalo de datas e critérios selecionados.",
    29461: "Menu de filtro",
    29471: "Ordenar",
    29481: "Visualizações em Pesquisa",
    29491: "Visualizações no Maps",
    29501: "Você não tem permissões suficientes para postar uma resposta.",
    29511: "Já foi enviada",
    29521: "Upload de Modelos de Resp. Auto",
    29531: "Contagem de Seguidores",
    29541: "Última Sincronização",
    29551: "Corporativo",
    29561: "Agência",
    29571: "Postagem local habilitada",
    29581: "Sem verificação pendente",
    29591: "Clique para ver essa avaliação na caixa de entrada",
    29601: "Leia Mais",
    29611: "Carregando",
    29621: "Total de (number) itens",
    29631: "Google Meu Negócio verificado",
    29641: "Marque Como",
    29651: "Adicionar Horários",
    29661: "Hoje",
    29671: "Endereço",
    29681: "Código Postal",
    29691: "Se identifica como Administrado por Negros",
    29701: "Adicionar URL",
    29711: "Postar",
    29721: "Email de Contato",
    29731: "Atualização COVID_19",
    29741: "Mudanças no seu negócio?",
    29751: "Campanha",
    29761: "Comprar Online",
    29771: "Comprar",
    29781: "Ligar Agora",
    29791: "Agora",
    29801: "Sincronizar essa localização?",
    29811: "Listagem do Facebook",
    29821: "Criar Nova Listagem do Facebook",
    29831: "Selecionado",
    29841: "Detalhes do Negócio",
    29851: "Contatos",
    29861: "Variáveis",
    29871: "ID Interno",
    29881: "clique para conectar",
    29891: "Voltar ao upload",
    29901: "Veja as P&R diretamente no Google",
    29911: "Exigir",
    29921: "Desativar",
    29931: "Avaliar confirmaçao de fechamento",
    29941: "Avaliar confirmação de resposta",
    29951: "Avaliar confirmaçao de remoção",
    29961: "Região",
    29971: "Responder a essa pergunta",
    29981: "Gerenciar",
    29991: "Criar Google Post",
    30001: "Gerenciar Google Post",
    30011: "Ocultar localidade",
    30021: "Selecione a página atual",
    30031: "Criar postagem no Facebook",
    30041: "Gerenciar postagem no Facebook",
    30051: "Limpar Tudo",
    30061: "Salvar Filtro",
    30071: "Procurar Função",
    30081: "Procurar Usuário",
    30091: "Todos os Editores",
    30101: "Atribuir à classificação (obrigatório)",
    30111: "Insira o Nome do Modelo (obrigatório)",
    30121: "Variável de Modelo Personalizado (opcional)",
    30131: "Selecionar ou Criar tópico (opcional)",
    30141: "Atribuir à uma única localidade (opcional)",
    30151: "Atribuir à tag de entidade (opcional)",
    30161: "Variáveis de Avaliações",
    30171: "Primeiro Nome do Avaliador",
    30181: "Nome Completo do Avaliador",
    30191: "Variáveis da Localidade",
    30201: "Nome da Localidade de Resposta",
    30211: "Nome da Localização Geográfica",
    30221: "Uma resposta para esta avaliação já foi enviada.",
    30231: "Respostas para esta avaliação não podem mais ser enviadas. Você pode excluir esta resposta para removê-la daqui.",
    30241: "Você gostaria de sincronizar os dados deste local? Isso irá trazer todas as atualizações feitas no local.",
    30251: "Informe os clientes sobre quaisquer mudanças em sua empresa devido ao COVID-19",
    30261: "Enviar Agora",
    30271: "Pesquisar Mostruário",
    30281: "Use os controles a direita para montar o Mostruário de Avaliações. Clique no botão 'Aplicar' para carregar a pré-visualização instantânea.",
    30291: "Monte Seu Mostruário de Avaliações",
    30301: "Detalhes do Mostruário",
    30311: "Nomeie esse Mostruário",
    30321: "Localidade Individual",
    30331: "Grupo de Localidade",
    30341: "Titulo do Mostruário",
    30351: "Esconder",
    30361: "Imagem/Avatar do Avaliador",
    30371: "Mostrar",
    30381: "Escolher Conjunto de Avaliações",
    30391: "Fontes de Avaliações",
    30401: "Avaliações de",
    30411: "Criar Mostruário",
    30421: "Classificação Mínima",
    30431: "Somente Avaliações de Classificações",
    30441: "Definir Apresentação",
    30451: "Contagem Máxima de Avaliações",
    30461: "Tamanho Máximo de Comentários",
    30471: "Avaliações Máximas Por Página",
    30481: "Layout Responsivo",
    30491: "Ordem de Classificação",
    30501: "Mais recentes primeiro",
    30511: "Cor de Classificações por Estrela",
    30521: "Comentários de Avaliações",
    30531: "Logo da Fonte",
    30541: "Data da Avaliação",
    30551: "Data Precisa",
    30561: "Fonte",
    30571: "Tamanho do Título do Mostruário",
    30581: "Tamanho do Nome do Avaliador",
    30591: "Tamanho do Comentário",
    30601: "Definir Sobreposições",
    30611: "Fixar No Topo",
    30621: "Excluir",
    30631: "Minhas Avaliações",
    30641: "Precisa de Ajuda",
    30651: "A Espera do Cliente",
    30661: "A Espera de Feedback",
    30671: "Novo Feedback",
    30681: "Procurar Nome",
    30691: "Não Atribuído",
    30701: "Atualizado com Sucesso",
    30711: "Nome do Conteúdo da Campanha (opcional)",
    30721: "Termos e Condições (opcional)",
    30731: "Você tem certeza que deseja remover este usuário? Uma vez removido, o usuário não vai mais ter acesso a este perfil, a não ser que seja convidado.",
    30741: "Você deseja remover este usuário?",
    30751: "Distribuição de Resposta",
    30761: "Vamos enviar um email () com o link para baixar o CSV de avaliações.",
    30771: "Este perfil tem mais de 100 localidades. Nós enviaremos um email com o link para download",
    30781: "Resposta do Usuário",
    30791: "Marcar Resposta",
    30801: "Resposta no Destino",
    null: null,
    1001: "Inscrever-se significa que você leu e concorda com nossos ",
    1002: " Termos de Serviço",
    1003: " e ",
    1004: "Política de Privacidade",
    1005: ".",
    1006: " ",
    2001: "Verificação de propriedade de localidade (GMN – Google Meu Negócio)",
    2002: "Escolha o modo de verificação",
    2003: "Para ter o controle de cada localidade junto ao Google é necessário receber a confirmação de propriedade. Para tal, selecione o meio pelo qual você deseja receber o código de verificação.",
    2004: "Receba o seu código por meio do telefone ou por mensagem de texto (sujeito a cobrança)",
    2005: "Correio",
    2006: "Receba o seu código no endereço abaixo",
    2007: "Nome de Contato",
    2008: "Receba o seu código no e-mail abaixo",
    2009: "Correio",
    2010: "Avaliações & Classificação",
    2011: "Por Cento",
    2012: "Percentagem das Avaliações",
    2013: "Acumulado",
    2014: "Fonte",
    2015: "Avaliações por Fonte",
    2016: "Satisfação",
    2017: "Tempo de Resposta",
    2018: "Dias",
    2019: "estrela",
    2020: "Média",
    2021: "Marca",
    2022: "Veja Tudo",
    2023: "P&R",
    2024: "Tudo",
    2025: "C/ Comentário",
    2026: "S/ Comentário",
    2027: "Interna",
    2028: "Avaliações da equipe",
    2029: "Automatizar",
    2030: "Completo",
    2031: "Atribuído",
    2032: "Pesquisar usuário",
    2033: "Enviar e-mail",
    2034: "compor",
    2035: "Resposta da AI",
    2036: "Postar resposta",
    2037: "Regenerar",
    2038: "Aprovação",
    2039: "Postar na fonte",
    2040: "Resposta enviada",
    2041: "Nenhuma mensagem enviada",
    2042: "Limpo",
    2043: "Fechado",
    2044: "Nenhum texto de resposta encontrado",
    2045: "Copiar resposta e ir para a fonte",
    2046: "Editar resposta",
    2047: "Aprovar resposta",
    2048: "Atualizar resposta",
    2049: "Excluir resposta",
    2050: "Tem certeza de que deseja excluir esta resposta?",
    2051: "Tem certeza de que deseja enviar esta resposta?",
    2052: "Você gostaria de restabelecer esta avaliação?",
    2053: "Tem certeza?",
    2054: "Tem certeza de que deseja aprovar essa resposta?",
    2055: "Equipes",
    2056: "Apenas classificação",
    2057: "Classificação + Comentário breve",
    2058: "Classificação + Comentário",
    2059: "Revisão por idioma",
    2060: "Forneça um comprimento de comentário entre 1 e1 00, o padrão será 20 caracteres",
    2061: "Copie as respostas de avaliação inteligente para cada gerente de local designado",
    2062: "Entrar",
    2063: "Endereço de email",
    2064: "Não tem uma conta?",
    2065: "Primeiro nome",
    2066: "Sobrenome",
    2067: "Empresa",
    2068: "Nome da empresa",
    2069: "já tem uma conta?",
    2070: "Mostrar senha",
    2071: "Esconder senha",
    2072: "Conversão Loca",
    2073: "Mapas Celular",
    2074: "Mapas Desktop",
    2075: "Busca Celular",
    2076: "Busca Desktop ",
    2077: "Visualizações de Busca",
    2078: "Visualizações de Mapa",
    2081: "Universal",
    2091: "Por Tópico",
    30811: "Painel de Avaliações",
    30812: "Visão Geral",
    30813: "Avg",
    30814: "Classificação MÉDIA ",
    30815: "Posição",
    30816: "Felicidade",
    30817: "Taxa de Palavras",
    30818: "Taxa de Resposta",
    30819: "Avaliação por Fonte",
    30820: "Avaliação por Classificação",
    30821: "Resposta por Classificação",
    30822: "Avaliações Recentes",
    30823: "Você recebeu {x} avaliações nos últimos {x} dias. Aqui estão as mais recentes",
    30824: "O número médio de avaliações por local principal durante o intervalo de tempo",
    30825: "A porcentagem de avaliações com classificações de 4 e 5 estrelas",
    30826: "O Índice de Felicidade é uma apresentação da porcentagem de avaliações positivas menos a porcentagem de avaliações negativas",
    30827: "A porcentagem de todos os comentários encontrados em avaliações de 5 e 4 estrelas em comparação com todas as palavras compartilhadas no intervalo de tempo. A faixa vai de 5 estrelas a 1 estrela.",
    30828: "A porcentagem de avaliações dentro do período de tempo que receberam uma resposta.",
    30829: "Redução em {x data} dos últimos {xx} dias",
    30830: "Aumento em {x data} dos últimos {xx} dias",
    30831: "Nenhuma mudança em {x data} dos últimos {xx} dias",
    30832: "Clique para ver essas avaliações",
    30833: "(nome do local) , (x) Estrelas, Revisor: (x)",
    30834: "Média de Avaliações & Classificação",
    30835: "Contagem de avaliações ao longo do tempo empilhada por classificação de estrelas + gráfico de linha da média de classificação.",
    30836: "Porcentagem por Classificação de Estrelas",
    30837: "Contagem de avaliações ao longo do tempo empilhada por classificação de estrelas como uma porcentagem do total.",
    30838: "Contagem Cumulativa & Média de Classificação",
    30839: "Total de avaliações e média de classificação para o período do relatório.",
    30840: "Avaliações por Fonte",
    30841: "Contagem de avaliações ao longo do período por fonte.",
    30842: "Pontuação de Felicidade ao Longo do Tempo",
    30843: "A Pontuação Líquida de Felicidade por período de tempo ao longo do intervalo do relatório.",
    30844: "Dia da Semana",
    30845: "Dia do Mês",
    30846: "Mês do Ano",
    30847: "Principais Países",
    30848: "Principais Estados",
    30849: "Principais Cidades",
    30850: "Respostas",
    30851: "Taxa de Resposta Rápida",
    30852: "Mediana",
    30853: "O número de respostas publicadas durante o período e a média por local.",
    30854: "A porcentagem de avaliações que recebem uma resposta em 2 dias e o tempo mediano de resposta.",
    30855: "Contagem & Taxa de Respostas",
    30856: "A contagem de respostas por classificação de estrelas e a taxa de resposta geral.",
    30857: "Tempo Médio de Resposta",
    30858: "O tempo médio de resposta em dias.",
    30859: "Distribuição de Respostas",
    30860: "Histograma do tempo de resposta das avaliações dividido em 10 camadas.",
    30861: "Feliz",
    30862: "Razão",
    30863: "Tempo de Vida",
    30864: "Contagem de registros de locais principais, além de registros de listagens não mapeados.",
    30865: "Energia",
    30866: "Taxa de Comentários",
    30867: "Comprimento do Comentário",
    30868: "Diferença de Razão",
    30869: "Diferença de Comprimento",
    30870: "Avaliações com e sem comentários",
    30871: "Média de palavras por classificação de estrelas",
    30872: "Porcentagem de palavras em cada classificação de estrelas",
    30873: "Percentual de Razão de Comentários",
    30874: "A porcentagem de todas as avaliações que incluem comentários de clientes",
    30875: "Contagem de Palavras do Comentário",
    30876: "A média de palavras contidas em avaliações com comentários",
    30877: "Distribuição de Palavras do Comentário",
    30878: "A porcentagem de palavras em cada classificação de estrelas para cada período de tempo",
    30879: "Porcentagem de avaliações positivas com comentários menos a porcentagem de avaliações negativas.",
    30880: "Comprimento médio das avaliações positivas menos o comprimento médio das avaliações negativas.",
    30881: "Avaliações com taxa de resposta",
    30882: "Taxa de comprimento do comentário",
    30883: "Visualização em Grade",
    30884: "Localização Média",
    30885: "A média das avaliações dos locais e a porcentagem de locais acima da classificação de 4,0 no intervalo de tempo.",
    30886: "Grade de Desempenho de Avaliações",
    30887: "Apresentar a média da classificação do local em comparação com o volume de avaliações para identificar valores atípicos",
    30888: "Sentimento",
    30889: "Influência",
    30890: "Painel de Desempenho",
    30891: "Grade de Liderança",
    30892: "Visualizações Totais",
    30893: "Taxa de Conversão",
    30894: "Visualizações totais e a média de visualizações por locais.",
    30895: "Visualizações de mapa em desktop e mobile com a porcentagem de repartição.",
    30896: "Visualização de pesquisa local em desktop e mobile com a porcentagem de repartição.",
    30897: "Ações totais com a porcentagem de repartição entre chamadas, cliques no site e direções de direção.",
    30898: "Taxa de conversão total de ações/visualizações para chamadas, cliques no site e direções de direção.",
    30899: "Visualizações do Cliente",
    30900: "Como e onde os clientes visualizam seu negócio.",
    30901: "Ações do Cliente",
    30902: "As ações rastreáveis das suas listagens do Google.",
    30903: "A porcentagem de impressões de listagem de negócios que resulta em uma ação",
    30904: "Eficácia por Localização",
    30905: "Visualizações totais vs. taxa de conversão (ações/visualizações) para mostrar a eficácia de cada localização na geração de visualizações e conversão em ações.",
    30906: "Eficácia por Cidade",
    30907: "Visualizações totais vs. taxa de conversão (ações/visualizações) para cada cidade.",
    30908: "Eficácia por Grupo",
    30909: "Visualizações totais vs. taxa de conversão (ações/visualizações) para cada grupo personalizado.",
    30910: "Altas Visualizações + Baixa Conversão",
    30911: "Altas Visualizações + Alta Conversão",
    30912: "Baixas Visualizações + Baixa Conversão",
    30913: "Baixas Visualizações + Alta Conversão",
    30914: "Móvel",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "Site",
    30920: "Chamadas",
    30921: "Pontuação de Saúde",
    30922: "Desempenho Diário",
    30923: "Selecione as locais da tabela e a métrica (visualizações ou ações)",
    30924: "Taxa de Satisfação",
    30925: "Nome/Amigável",
    30926: "{x} locais com média de {y} estrelas nos últimos {xx} dias",
    30927: "Acima",
    30928: "Grupo",
    30929: "Todas as Visualizações",
    30930: "Todas as Ações",
    30931: "Desktop",
    30932: "Limite máximo atingido: Selecione até 8 locais para o gráfico.",
    30933: "Revisor",
    30934: "Sentimento Geral",
    30935: "Distribuição da pontuação de sentimento em {XX} tópicos.",
    30936: "Sentimento por Tópico",
    30937: "Frequência de Tópico e Pontuações de Sentimento Correspondentes.",
    30938: "Muito Positivo",
    30939: "Muito Negativo",
    30940: "Uma regra de automação acionada para uma nova avaliação em",
    30941: "Uma regra de automação acionada para uma avaliação atualizada em",
    30942: "aprovou a resposta em",
    30943: "atribuiu uma etiqueta",
    30944: "atribuiu a avaliação a",
    30945: "em",
    30946: "Resposta automática enviada",
    30947: "O proprietário do negócio criou uma nova resposta externa em",
    30948: "por regra de automação em",
    30949: "por sistema em",
    30950: "criou um novo",
    30951: "criou uma nova resposta em",
    30952: "criou uma nota de revisão para",
    30953: "apagou uma nota em",
    30954: "apagou uma nota de revisão em",
    30955: "apagou a resposta em",
    30956: "editou a resposta em",
    30957: "de",
    30958: "gerou uma resposta automática em",
    30959: "local",
    30960: "notificação",
    30961: "notificado",
    30962: "visão geral",
    30963: "realizado",
    30964: "resposta",
    30965: "Resposta movida para a Caixa de Entrada de Aprovação em",
    30966: "Resposta movida para a Caixa de Saída e agendada para postagem",
    30967: "Resposta publicada em",
    30968: "Revisão atribuída a",
    30969: "revisão em",
    30970: "Revisão recebida de",
    30971: "enviou uma nota para",
    30972: "Sistema atribuiu uma etiqueta de idioma",
    30973: "Sistema atribuiu uma resposta automática em",
    30974: "Etiquetas",
    30975: "equipe por regra de automação em",
    30976: "Cronograma",
    30977: "para",
    30978: "atualizou um",
    30979: "atualizou uma nota de revisão em",
    30980: "atualizou a classificação de revisão de",
    30981: "atualizou o status da revisão de",
    30982: "atualizou o status da revisão para",
    30983: "atualizou o comentário sobre o",
    30984: "via API durante",
    30985: "via Pub-Sub em",
    30986: "Nenhum comentário adicionado",
    30987: "em",
    30988: "Sistema",
    30989: "por",
    30990: "desatribuiu a revisão de",
    30991: "atribuído a",
    30992: "Tag atribuída:",
    30993: "Grupo de tags atribuído:",
    30994: "removi uma tag:",
    30995: "Revisão com atualizações",
    30996: "Revisão sem atualizações",
    30997: "Selecionar todas as tags",
    30998: "Selecionar não etiquetados",
    30999: "Aguardando aprovação",
    31000: "Mais antigo primeiro",
    31001: "Você não tem nenhuma nota salva",
    31002: "Responder na caixa de saída",
    31003: "Versões de Avaliações",
    31004: "Detalhe da Avaliação",
    31005: "Abrir Informações",
    31006: "Relacionamentos",
    31007: "Erro",
    31008: "Primário",
    31009: "Categorias",
    31010: "Links Sociais",
    31011: "Imagem original removida pelo usuário ou pela plataforma."
  },
  german: {
    1001: "Al registrarse, significa que ha leído y acepta nuestros ",
    1002: "Servicebedingungen",
    1003: " und ",
    1004: "Datenschutzbestimmungen",
    1005: " gelesen haben und ihnen zustimmen.",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "Cumulative",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "Teambewertungen",
    2029: "Automatisieren",
    2030: "Voll",
    2031: "Zugewiesen",
    2032: "Benutzer suchen",
    2033: "Notiz hinzufügen",
    2034: "Erstellen",
    2035: "AI -Beantwortung",
    2036: "Antworten",
    2037: "Regenerieren",
    2038: "Zulassen",
    2039: "Poste auf Quelle",
    2040: "Antwort gesendet",
    2041: "Keine gesendeten Nachrichten",
    2042: "Klar",
    2043: "Geschlossen",
    2044: "Kein Antworttext gefunden",
    2045: "Antwort kopieren und zur Quelle gehen",
    2046: "Antwort bearbeiten",
    2047: "Antwort genehmigen",
    2048: "Antwort aktualisieren",
    2049: "Antwort löschen",
    2050: "Sind Sie sicher, dass Sie diese Antwort löschen wollen?",
    2051: "Sind Sie sicher, dass Sie diese Antwort übermitteln möchten?",
    2052: "Möchten Sie diese Bewertung erneut einreichen?",
    2053: "Sind Sie sicher?",
    2054: "Sind Sie sicher, dass Sie diese Antwort genehmigen wollen?",
    2055: "Mannschaften",
    2056: "Immer aktiv",
    2057: "Bewertung + Kurzkommentar",
    2058: "Bewertung + Kommentar",
    2059: "Bewertung nach Sprache",
    2060: "Bitte geben Sie eine Kommentarlänge zwischen 1 und 100 an,Standard sind 20 Zeichen",
    2061: "Kopieren Sie intelligente Bewertungsantworten an jeden zugewiesenen Standortmanager",
    2062: "Anmelden",
    2063: "E-Mail-Adresse",
    2064: "Sie haben noch kein Konto?",
    2065: "Vorname",
    2066: "Nachname",
    2067: "Unternehmen",
    2068: "Firmenname",
    2069: "Sie haben bereits ein Konto?",
    2070: "Passwort anzeigen",
    2071: "Passwort anzeigen",
    2072: "Konversion  Impressionen",
    2073: "Karten Mobil",
    2074: "Karten Desktop",
    2075: "Suche Mobil",
    2076: "Suche Desktop",
    2077: "Suchansichten ",
    2078: "Kartenansichten ",
    2081: "Universal",
    2091: "Nach Thema",
    10010: "1 Stern",
    10013: "2 Sterne",
    10016: "3 Sterne",
    10019: "4 Sterne",
    10022: "5 Sterne",
    10025: "100-300 Worter",
    10120: "Aktionen",
    10123: "aktivieren Sie",
    10124: "Immer aktiv",
    10126: "Aktive Organisationen",
    10129: "Hinzufügen",
    10132: "Fügen Sie eine Schaltfläche hinzu",
    10135: "Schaltfläche hinzufügen (optional)",
    10138: "Konto hinzufügen",
    10141: "ADDIEREN ZUSATZTELEFON",
    10144: "Füge ein Konto hinzu",
    10147: "Füge eine andere Kategorie hinzu",
    10150: "Füge ein weiteres Etikett hinzu",
    10153: "Attribute hinzufügen",
    10156: "Zeile hinzufügen",
    10159: "NEUES DATUM HINZUFÜGEN",
    10162: "Neues Review-Tag hinzufügen",
    10165: "Neue Rolle hinzufügen",
    10168: "Eröffnungsdatum hinzufügen",
    10171: "Profil hinzufügen",
    10174: "Neuer Bericht",
    10177: "Bericht hinzufügen",
    10180: "Rolle hinzufügen",
    10181: "Bewertungstag hinzufügen",
    10183: "Zusätzliche Kategorie",
    10186: "Zusätzliches Telefon",
    10189: "Adresse",
    10192: "ADMINISTRATOR",
    10195: "Administrator",
    10198: "adWords-Standorterweiterungen",
    10201: "adWords Standorterweiterungen Telefon",
    10204: "Alle",
    10207: "Alle Bewertungen",
    10210: "Alle dieser Rolle zugewiesenen Benutzer haben Zugriff auf die folgenden Funktionen",
    10213: "Bewerben",
    10216: "Genehmigungseingang",
    10219: "Möchten Sie das Passwort dieses Benutzers wirklich zurücksetzen?",
    10222: "Bist du sicher?",
    10225: "Bereich",
    10228: "Bereiche",
    10231: "Attribute",
    10234: "Konto autorisieren",
    10237: "Durchschnittlich",
    10240: "Durchschnittliche Menge",
    10243: "Durchschnittliche Bewertung",
    10244: "Durchschn. Bewertung",
    10246: "Durchschnitt pro Standort",
    10249: "Bitte um Antwort",
    10320: "Zurück",
    10321: "zurück",
    10323: "Abrechnung",
    10326: "Buch",
    10329: "Bulk-Upload-Beitrag",
    10332: "Bulk-Upload-Tags",
    10335: "Massen-Upload von TSV",
    10338: "Geschäftsname",
    10520: "Kalender",
    10523: "Abbrechen",
    10526: "Hochladen der Master-Standortzuordnung nicht möglich!",
    10529: "Kategorie",
    10532: "Ändern Sie die Rolle",
    10535: "Zitat Geschichte",
    10538: "Stadt",
    10541: "Klick hier",
    10544: "Klicken Sie auf einen Benutzer, um ihm diese Rolle zuzuweisen",
    10547: "Land",
    10548: "Bestätige das Passwort",
    10550: "Kopieren",
    10553: "Kopieren und Einfügen",
    10556: "Konnte Rolle nicht ändern!",
    10559: "Beitrag konnte nicht hochgeladen werden",
    10562: "Länder",
    10565: "Land",
    10568: "Gutscheincode",
    10571: "Gutscheincode (Optional)",
    10574: "Erstellen Sie einen neuen Filter, indem Sie die folgenden Optionen auswählen",
    10577: "Erstellen Sie einen neuen Filter",
    10580: "Erstellen Sie einen neuen Bericht",
    10583: "Beiträge Erstellen",
    10586: "Tag erstellen",
    10589: "Erstellen Sie diesen Bericht",
    10592: "Erstellen Sie diese Rolle",
    10595: "Erstellt von",
    10598: "Kundenaktionen",
    10720: "T",
    10723: "Dashboard",
    10726: "Datum",
    10729: "Datumsbereich",
    10732: "Tag",
    10735: "Deaktivieren",
    10738: "Standart",
    10741: "Verzögerung vor dem Posten",
    10744: "Verzögertes Senden von Antworten durch",
    10747: "Verzögertes Senden von Antworten durch",
    10750: "Löschen",
    10753: "Löschen?",
    10754: "Löschen",
    10756: "Desc",
    10759: "Beschreibung",
    10762: "Direkte",
    10765: "Direktabfragen",
    10768: "Richtungen",
    10771: "Entdeckung",
    10774: "Eindeutige Ansicht",
    10777: "Alle Standortdaten herunterladen",
    10780: "Herunterladen",
    10783: "Laden Sie die Google-Standortdetails herunter",
    10786: "Daten herunterladen",
    10789: "Entwürfe",
    10792: "Fahrtrichtung",
    10795: "Wegbeschreibung nach Tag",
    10920: "Bearbeiten",
    10923: "Profil bearbeiten",
    10926: "Bericht bearbeiten",
    10929: "Bearbeiten Sie diesen Bericht",
    10932: "Editor",
    10935: "Email",
    10938: "Endzeit",
    10941: "Geben Sie adWords-Standorterweiterungen ein",
    10944: "Geben Sie den Namen der Entitätsbezeichnung ein",
    10947: "Geben Sie Labels ein",
    10950: "Geben Sie Suchtext ein",
    10953: "Geben Sie den Tag-Namen ein",
    10956: "Entspricht",
    10959: "Veranstaltung",
    10962: "Veranstaltungsdetails",
    10965: "Name der Veranstaltung",
    10968: "Jeden",
    10971: "example.com",
    10974: "Beispiel: 20 % Rabatt im Geschäft oder online",
    11120: "Feature Zugriffsverwaltung",
    11123: "Filter",
    11126: "Passwort vergessen?",
    11129: "Freitag",
    11320: "Angebot bekommen",
    11323: "Größer als",
    11520: "Glücksbewertung",
    11525: "Hilfe",
    11530: "Urlaub",
    11535: "Stunde",
    11540: "Std",
    11545: "Wie Nutzer nach Ihrem Unternehmen suchen",
    11720: "Bild",
    11723: "Bild-URL",
    11726: "In Karten",
    11729: "Auf der Suche",
    11732: "Posteingang",
    11735: "Indirekte Abfragen",
    11738: "Erkenntnisse",
    11741: "Unzureichende Erlaubnis",
    11744: "Integration",
    11747: "Integrationen",
    11750: "Benutzer einladen",
    11753: "EINGELADEN",
    11756: "Eingeladen von",
    11759: "Artikel",
    12120: "Wissensbereich",
    12320: "Etiketten",
    12323: "Letzte Anmeldung",
    12326: "Letzte Aktualisierung",
    12329: "Erfahren Sie mehr",
    12332: "Weniger als",
    12335: "Link für Ihren Knopf",
    12338: "Link zum Einlösen des Angebots",
    12341: "Link zum Einlösen des Angebots (optional)",
    12344: "Verknüpfung",
    12347: "Auflistungsverwaltung",
    12350: "Lokale Leistung",
    12353: "Lokale Leistungsübersicht",
    12356: "Lokale Suchkonvertierung",
    12359: "Orte",
    12362: "Standort",
    12365: "Ort",
    12368: "Standortdetails",
    12371: "Standort-ID",
    12374: "Standorte",
    12377: "Anmeldung",
    12380: "Ausloggen",
    12520: "M",
    12523: "Mit einem Foto oder Video weckt Ihr Beitrag mehr Interesse",
    12526: "Massenaktivität verwalten",
    12529: "Entitäts-Tags verwalten",
    12532: "Standorte verwalten",
    12535: "Profil verwalten",
    12538: "Rollen verwalten",
    12541: "Benutzer verwalten",
    12544: "Karten",
    12547: "Händleranzahl",
    12550: "Händlerfotos",
    12553: "Händlerfotos",
    12556: "Botschaft",
    12559: "Protokoll",
    12562: "Montag",
    12565: "Monat",
    12720: "Name",
    12723: "Name der neuen Rolle",
    12726: "Name des Berichts",
    12729: "Brauche ein Konto?",
    12732: "Neu",
    12735: "Nächste Seite",
    12738: "Keine Antworten",
    12741: "keine Ergebnisse gefunden",
    12744: "Noch keine Review-Tags vorhanden",
    12747: "Keine Bewertungen",
    12750: "Nein, abbrechen",
    12753: "Anzahl der Benutzer",
    12756: "Notizen",
    12920: "von",
    12923: "Angebot",
    12926: "OK",
    12929: "OK habe es!",
    12932: "Einmal",
    12935: "Eröffnungsdatum",
    12938: "Auftrag",
    12941: "Organisationen",
    12944: "Postausgang",
    12947: "Inhaber",
    13120: "Seite",
    13123: "Passwort",
    13126: "Einfügen TSV",
    13129: "Pdf-Typ",
    13132: "Telefon",
    13135: "Telefonate nach Tag",
    13138: "Telefonnummer",
    13141: "Foto Menge",
    13144: "Fotoansichten",
    13147: "Bitte geben Sie einen Empfängernamen ein!",
    13150: "Bitte geben Sie einen Berichtsnamen ein!",
    13153: "Bitte geben Sie eine Zusammenfassung ein!",
    13156: "Bitte geben Sie einen Titel ein!",
    13159: "Bitte geben Sie eine gültige Uhrzeit ein!",
    13162: "Bitte geben Sie eine gültige URL ein!",
    13165: "Aktualisieren Sie die Seite, um Ihre Standortdetails zu aktualisieren",
    13168: "Bitte neu laden",
    13171: "Bitte wählen Sie den Typ des Zeitplans!",
    13174: "Postgeschichte",
    13177: "Beiträge",
    13180: "Vorherige Seite",
    13183: "Hauptkategorie",
    13186: "Primäres Telefon",
    13189: "Primäre Telefonnummer",
    13192: "Profile",
    13195: "Öffentliche Zählung",
    13198: "Öffentliche Fotos",
    13201: "Öffentliche Fotos",
    13204: "VERÖFFENTLICHEN",
    13520: "Bewertung",
    13523: "Echtzeit-Benachrichtigungen",
    13526: "Empfängerliste",
    13529: "Wiederkehrend",
    13532: "Benutzer entfernen",
    13535: "Antworten",
    13538: "Antwort der Antwort",
    13541: "Berichtsverwaltung",
    13544: "Berichtsname",
    13547: "Berichtstyp",
    13550: "Passwort zurücksetzen",
    13553: "Antwort nach Sternenbewertung",
    13556: "Zählung überprüfen",
    13559: "Überprüfen Sie den Download",
    13562: "Überprüfen Sie die Einstellungen",
    13565: "Quelle überprüfen",
    13568: "Überprüfungs Tag ",
    13571: "RezensionLink",
    13574: "Bewertungen",
    13577: "Bewertungen nach Sternebewertung",
    13580: "Bewertungen gegen Durchschnittliche Bewertung",
    13583: "Bewertungen Posteingang",
    13586: "Bewertungen Management",
    13589: "Bewertungen, Tag des Monats",
    13592: "Bewertungen, Wochentag",
    13595: "Bewertungen, Monat des Jahres",
    13598: "Rolle",
    13601: "Rolle Details",
    13604: "Rollenname",
    13720: "Samstag",
    13723: "Speichern",
    13726: "Als benutzerdefinierten Filter speichern",
    13729: "Speichere einen neuen Filter",
    13732: "Rolle speichern",
    13735: "Gespeicherte Antworten",
    13738: "Zeitplan Datum",
    13741: "Zeitplan Beitrag",
    13742: "Einen Bericht erstellen",
    13744: "Planmäßige Zeit",
    13747: "Zeitplan-Typ",
    13750: "Suche",
    13753: "Suchvorgänge",
    13756: "Wählen",
    13759: "Wählen Sie einen vorhandenen Filter aus",
    13762: "Kategorie wählen",
    13765: "Stadt wählen",
    13768: "Land auswählen",
    13771: "Wählen Sie Datum und Uhrzeit",
    13774: "Wählen Sie Datumsbereich",
    13777: "Wählen Sie Editor (e) zum Überprüfen aus",
    13780: "Wählen Sie das Entitäts-Tag",
    13783: "Wählen Sie Filter",
    13786: "Wählen Sie Filter",
    13789: "Wählen Sie Granularität",
    13792: "Wählen Sie Organisation",
    13795: "Überprüfungstag auswählen",
    13798: "Wählen Sie Gespeicherter Filter",
    13801: "Quelle auswählen",
    13804: "Staat wählen",
    13807: "Zeit auswählen",
    13810: "SELBST",
    13813: "Zur Freigabe senden",
    13816: "Senden Sie es an den Postausgang",
    13819: "Geschickt",
    13822: "Leistungen",
    13825: "die Einstellungen",
    13828: "Einstellungsverwaltung",
    13831: "Einkaufen",
    13834: "Beiträge anzeigen",
    13837: "Nav anzeigen / ausblenden",
    13840: "Anmelden",
    13843: "Einzelner Standort bearbeiten",
    13846: "Es tut uns leid!",
    13849: "Sortiere nach",
    13852: "Besondere Stunden",
    13855: "Spezifischer Zugang",
    13858: "STANDARD",
    13861: "Startzeit",
    13864: "Bundesstaat",
    13867: "Status",
    13870: "Geschäft",
    13873: "Geschäftscode",
    13876: "Straße",
    13879: "Zusammenfassungsansicht",
    13882: "Sonntag",
    13885: "Synchronisieren Sie dieses Konto",
    13920: "Telefonnummer",
    13923: "Geschäftsbedingungen",
    13926: "Donnerstag",
    13929: "Zeit",
    13932: "Top-Orte",
    13935: "Gesamt",
    13938: "Dienstag",
    14120: "Unbeantwortet",
    14123: "Du bist unsicher über das Format?",
    14126: "Hochladen",
    14129: "Standortdetails hochladen",
    14132: "Standortkarte hochladen",
    14135: "Standortzuordnung hochladen",
    14138: "Laden Sie TSV hoch",
    14141: "URL",
    14144: "Benutzeridentifikation",
    14320: "Bild ansehen",
    14323: "Profil anzeigen",
    14326: "Ansichten",
    14520: "W",
    14523: "Webseite",
    14526: "Website nach Tag",
    14529: "Webseiten-Name",
    14532: "Mittwoch",
    14535: "Woche",
    14538: "Welche Maßnahmen ergreifen Kunden?",
    14541: "Wenn eine Antwort auf eine Rezension erfolgt",
    14544: "Wo Kunden Ihr Geschäft sehen",
    14547: "Möchten Sie diesen geplanten Beitrag löschen?",
    14550: "Schreiben Sie Ihren Titel",
    14920: "Jahr",
    14923: "Ja, weitermachen",
    14926: "Sie können den Zugriff von Benutzern mit dieser Rolle einschränken, indem Sie einen Filter auswählen, der an ihn angehängt wird.",
    14929: "Name",
    15120: "Postleitzahl",
    20010: "Montag",
    20011: "Mo",
    20020: "Dienstag",
    20021: "Di",
    20030: "Mittwoch",
    20031: "Mi",
    20040: "Donnerstag",
    20041: "Do",
    20050: "Freitag",
    20051: "Fr",
    20060: "Samstag",
    20061: "Sa",
    20070: "Sonntag",
    20071: "So",
    20110: "Januar",
    20111: "Jan.",
    20120: "Februar",
    20121: "Feb.",
    20130: "März",
    20131: "März",
    20140: "April",
    20141: "Apr.",
    20150: "Mai",
    20151: "Mai",
    20160: "Juni",
    20161: "Juni",
    20170: "Juli",
    20171: "Juli",
    20180: "August",
    20181: "Aug.",
    20190: "September",
    20191: "Sept.",
    20200: "Oktober",
    20201: "Okt.",
    20210: "November",
    20211: "Nov.",
    20220: "Dezember",
    20221: "Dez.",
    20231: "Bewertungen & Bewertungen",
    20241: "Prozent",
    20251: "Überprüfung mit Prozentsatz",
    20261: "Kumulativ",
    20271: "Cumulative count",
    20281: "Quelle",
    20291: "Überprüfung durch Quellen",
    20301: "Glück",
    20311: "Reaktionszeit",
    20321: "Ort auswählen",
    20331: "Search by reviews keyword",
    20341: "search by Reviewer",
    20351: "Wählen",
    20361: "Equals",
    20371: "Weniger als",
    20381: "Größer als",
    20391: "Select Months",
    20401: "Select date",
    20411: "Click to view these reviews",
    20421: "There were no reviews found for the selected date range and criteria",
    20431: "Clear Filter",
    20441: "Delete a custom filter",
    20451: "Has Google Updates",
    20461: "Verified",
    20471: "Location published",
    20481: "Has pending edits",
    20491: "Knowledge panel",
    20501: "Review Link",
    20511: "Richtungen",
    20521: "Duplicate",
    20531: "Active",
    20541: "Can update",
    20551: "Can delete",
    20561: "No pending review",
    20571: "Location enabled",
    20581: "Not disconnected",
    20591: "Change log",
    20601: "Bulk upload Image",
    20611: "Image History",
    20621: "Bulk upload Note",
    20631: "Bulk upload q&a",
    20641: "q&a history",
    20651: "Add a question",
    20661: "Present a question to customers that highlights a core value proposition or a distinct competitive advantage of your location. You can then answer the questions.",
    20671: "Platform details",
    20681: "Auto reply variables",
    20691: "Standortname",
    20701: "Geo name",
    20711: "Unterschrift",
    20721: "Geo name (max. 80 characters)",
    20731: "Signature name (max. 80 characters)",
    20741: "Automatische Antwort",
    20751: "Bewertungen herunterladen",
    20761: "Automatische Antwort",
    20771: "External Link",
    20781: "Copy Review",
    20791: "Notiz hinzufügen",
    20801: "External Note",
    20811: "Flag as inappropriate",
    20821: "Mark as removed",
    20831: "Are you sure ?",
    20841: "Would you like to mark this review as removed from Google?",
    20851: "Gespeicherte Antworten einfügen",
    20861: "Save as reply template",
    20871: "Insert auto reply template",
    20881: "Send",
    20891: "Send for approval",
    20901: "Save as draft",
    20911: "Assign note",
    20921: "Email note",
    20931: "Recipient",
    20941: "Save as note",
    20951: "Close",
    20961: "Discard",
    20971: "Send mail",
    20981: "You don't have any saved Notes",
    20991: "All caught up!",
    21001: "No entries to show",
    21011: "Gesendete Antworten",
    21021: "no comment added",
    21031: "Antwort bearbeiten",
    21041: "Delete reply",
    21051: "Search saved replies",
    21061: "Gespeicherte Antwort hinzufügen",
    21071: "Choose a group and subject to save this reply.",
    21081: "Wählen Sie eine Gruppe aus oder beginnen Sie mit der Eingabe, um eine Gruppe zu erstellen.",
    21091: "Titel hier eingeben",
    21101: "Antwortvorlage eingeben",
    21111: "Bitte stellen Sie sicher, dass Sie eine Gruppe und einen Titel auswählen/erstellen, um diese Antwort zu speichern.",
    21121: "Auto Replies",
    21131: "Add auto reply",
    21141: "Gruppe selektieren",
    21151: "Enter variable here",
    21161: "Choose your variables",
    21171: "Do you want to continue?",
    21181: "This request contains more than 100 reviews For such requests, we will send you an email with a link to download the review csv.",
    21191: "You have more than 100 reviews",
    21201: "We will send you an email (to X) with a link to download the review csv.",
    21211: "Aktionen",
    21221: "All Location",
    21231: "Avg Rating",
    21241: "Brand",
    21251: "Direct",
    21261: "Entdeckung",
    21271: "Geography",
    21281: "Glück",
    21291: "Queries",
    21301: "Antworten",
    21311: "Ansichten",
    21321: "Post Schedule",
    21331: "Google Post Schedule",
    21341: "Create Post",
    21351: "Manage Post",
    21361: "Schedule LocalPost",
    21371: "Upload",
    21381: "Progress",
    21391: "Validate & Schedule",
    21401: "Schedule Status",
    21411: "Select File",
    21421: "Select a schedule type",
    21431: "Immediate",
    21441: "File time",
    21451: "Zeit auswählen",
    21461: "Post immediately after verification",
    21471: "Schedule based on the time in the file",
    21481: "Schedule file by your selected time",
    21491: "Queue",
    21501: "Validation is in progress. Processing time is approximately 40 posts per minute. After validation, each post's status will be available on the next page.",
    21511: "Post processed",
    21521: "Successful validation",
    21531: "Failed validation",
    21541: "Scheduled",
    21551: "Type/Action",
    21561: "Dates",
    21571: "Start",
    21581: "End",
    21591: "Title/Product",
    21601: "Post Summary",
    21611: "Status",
    21621: "Success",
    21631: "Gescheitert",
    21641: "Edit/Delete",
    21651: "Post Insights",
    21661: "Google Post Insights",
    21671: "Performance",
    21681: "Post ansichten",
    21691: "Post von Medien",
    21701: "Post nach Thema",
    21711: "Post von Aktion",
    21721: "Analyse",
    21731: "Erstellt",
    21741: "Typ",
    21751: "Aktion",
    21761: "Quellfilter",
    21771: "Plattform",
    21781: "Aktualisieren Sie den Localpost-Status",
    21791: "Kampagnen-Generator",
    21801: "Intelligente automatische Reaktion",
    21811: "Aktivieren Sie den Builder für automatische Antwortkampagnen",
    21821: "Befolgen Sie vor dem Aktivieren der Option für den automatischen Antwortzeitplan die folgenden Anweisungen:",
    21831: 'Stellen Sie vor dem Aktivieren der automatischen automatischen Antwort sicher, dass Sie Ihre Vorlagen für die automatische Antwort im Abschnitt "ReviewInbox" hinzufügen. Erstellen Sie die Antworten zuerst, damit sie den Sternebewertungen (1-5) zugewiesen werden können, die eine automatische Antwort von Inteligent auslösen.',
    21841: "Wählen Sie im Campaign Builder eine Verzögerungszeit zwischen dem Empfangsbestätigung und der automatischen Antwortzustellung aus. Die Verzögerungseinstellung sollte der idealen Überprüfungsreaktionszeit entsprechen, da sie die automatische Natur des Programms maskieren soll.",
    21851: "Bitte berücksichtigen Sie auch die Betriebszeit (Wochentage und Stunden des Tages) für die Kampagne. Die Standardeinstellung für die Zeitzone ist GMT + 00: 00. Bitte aktualisieren Sie sie entsprechend.",
    21861: "Kampagne erstellen",
    21871: "Weisen Sie einen Namen und Notizen zu, um Ihre Kampagne leicht identifizieren zu können.",
    21881: "Kampagnenname",
    21891: "Kampagnen-Responder",
    21901: "Wenn keine Option ausgewählt ist, wird die E-Mail-Adresse, mit der Konten registriert und autorisiert werden, standardmäßig beantwortet.",
    21911: "Befragter für die automatische Antwort",
    21921: "Datumsbereich der Kampagne",
    21931: "Notizen / Ziele",
    21941: "Kampagnenbeschreibung",
    21951: "Trigger setzen",
    21961: "Wählen Sie die Art der Überprüfung (en) aus, die eine automatische Antwort für diese Kampagne auslösen.",
    21971: "mit Kommentar",
    21981: "ohne Kommentar",
    21991: "Bisherige",
    22001: "Nächster",
    22011: "Zielgruppe festlegen (optional)",
    22021: "Legen Sie die Standorte fest, die Teil der Kampagne sein sollen, basierend auf einem Entity-Tag, einer Organisation oder einem bestimmten Land / Gebiet / Ort. Diese Filter sind nur für Google-Bewertungen und zugeordnete Standorte verfügbar",
    22031: "Entität",
    22041: "Organisation",
    22051: "Zeitplan festlegen",
    22061: "Weisen Sie die Parameter und den Zeitplan für Überprüfungsantworten zu, d. H. Den Prozentsatz der gezielten Überprüfungen und die Betriebsstunden für Antworten.",
    22071: 'Bitte beachten Sie, dass automatische Antworten derzeit nur "vorwärts" verfügbar sind. Wir arbeiten an separaten Prozessen für Benutzer, die möglicherweise eine kurzfristige automatische Bereinigung durchführen möchten.',
    22081: "Antwortrate einstellen",
    22091: "Antwortanzahl einstellen",
    22101: "Verzögerung vor dem Senden der automatischen Antwort",
    22111: "regelmäßig planen",
    22121: "Wählen Sie den Tag aus und stellen Sie die Zeit ein, um die automatische Reaktion regelmäßig zu planen",
    22131: "Wähle Zeitzone aus",
    22141: "Antworten zuweisen",
    22151: "Wählen Sie aus der Liste aus, welche Antworten für diese Kampagne abwechselnd verwendet werden sollen.",
    22161: "Bestätigen",
    22171: 'Überprüfen Sie die folgenden Details und klicken Sie auf "Bestätigen", um Ihre Kampagne zu starten.',
    22181: "Tage",
    22191: "Star",
    22201: "Durchschn",
    22211: "Berichterstattung",
    22221: "Mitbewerber-Setup",
    22231: "Empfohlene Vorgehensweise",
    22241: "Quadrant",
    22251: "Bewertungen",
    22261: "Wettbewerbsranking",
    22271: "Bzw",
    22281: "Überprüfungsquellen anzeigen",
    22291: "Mitbewerber hinzufügen",
    22301: "Gefiltert nach",
    22311: "Klar",
    22321: "Wettbewerber",
    22331: "CompEntity",
    22341: "Entitäts-Tag.",
    22351: "Bemerkungen",
    22361: "Keine Optionen",
    22371: "Schlecht",
    22381: "Unterdurchschnittlich",
    22391: "Durchschnittlich",
    22401: "Toll",
    22411: "Ausgezeichnet",
    22421: "Bewertungen mit Antwort",
    22431: "Bewertungen ohne Antwort",
    22441: "Bewertungen mit Kommentaren",
    22451: "Bewertungen ohne Kommentare",
    22461: "Bewertungsvolumen vs. Durchschnittsbewertung",
    22471: "Marken",
    22481: "Zoomen",
    22491: "Bewertungen insgesamt",
    22501: "Bewertung nach Stern bewerten",
    22511: "Mitbewerber Bewertungen",
    22521: "Konkurrent von",
    22531: "Code",
    22541: "Konkurrenten verwalten",
    22551: "Aktualisiert",
    22561: "Konkurrenten hinzufügen",
    22571: "Ort hinzufügen",
    22581: "Name des Konkurrenten hinzufügen",
    22591: "The first step is to add the competitor's name, once you have added the names and optional icons (48x48 images) to the list, click on 'Add'. Once the Competitors are created, you will be able to assign the individual locations",
    22601: "Name des Teilnehmers eingeben (erforderlich)",
    22611: "Teilnehmer-URL eingeben (optional)",
    22621: "Bild hochladen",
    22631: "Kommt bald",
    22641: "Kommentarverhältnis",
    22651: "Prozent der Bewertungen mit und ohne Kommentare",
    22661: "Ohne",
    22671: "Mit",
    22681: "Länge des Kommentars",
    22691: "Durchschnittliche Anzahl der in jedem Kommentar verwendeten Wörter nach Sternebewertung",
    22701: "Wörter",
    22711: "Wortverhältnis",
    22721: "Summe und Prozentsatz der Wörter in Kommentaren für jede Sternebewertung",
    22731: "here.",
    22741: "Wettbewerber",
    22751: "Tag hinzufügen",
    22761: "Wählen Sie Variablen aus, die der Vorlage hinzugefügt werden sollen",
    22771: "enge Überprüfung",
    22781: "Geschlossene Bewertung",
    22791: "Möchten Sie diese Bewertung schließen? Sobald Sie schließen, müssen Sie es erneut öffnen, um zu antworten",
    22801: "Extern",
    22811: "Negativ",
    22821: "Nein",
    22831: "Noch keine automatischen Antworten!",
    22841: "Noch keine gespeicherten Antworten!",
    22851: "Notiz",
    22861: "Dauerhaft geschlossen",
    22871: "Positiv",
    22881: "Zeitüberschreitung beim Lesen",
    22891: "Überprüfung wiederherstellen",
    22901: "Überprüfen Sie die Überprüfung erneut",
    22911: "Beantwortet",
    22921: "Antwort gesendet (über die Google-Schnittstelle)",
    22931: "Antwort über die App gesendet",
    22941: "Bewertung entfernt",
    22951: "Vorlagen",
    22961: "Vorübergehend geschlossen",
    22971: "Jawohl",
    22981: "Sie haben keine gespeicherten Entwürfe",
    22991: "Unzureichende Berechtigungen für den Zugriff auf die Ressource",
    23001: "Interner Fehler aufgetreten",
    23011: "Anfrage enthält ein ungültiges Argument",
    23021: "Angeforderte Entität wurde nicht gefunden",
    23031: "Die Überprüfung ist auf der Google-Plattform nicht mehr vorhanden",
    23041: "Einige der Werte für das automatische Einfügen sind nicht verfügbar. Bitte ersetzen und senden",
    23051: "Der Dienst ist derzeit nicht verfügbar",
    23061: "Dieser Vorgang wird für nicht beanspruchte Standorte nicht unterstützt",
    23071: "Veröffentlichter Beitrag",
    23081: "Geplanter Beitrag",
    23091: "Freundlicher Name",
    23101: "Add friendly name",
    23111: "Kontakt",
    23121: "No contacts!",
    23131: "To add contact",
    23141: "Kontaktname",
    23151: "Contact E-Mail",
    23161: "Kontakt hinzufügen",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "Keine Daten",
    23201: "Google Audit",
    23211: "Auditprotokolle",
    23221: "Wählen Sie einen Bericht aus",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "Daten-Downloads.",
    23271: "Download überprüfen.",
    23281: "Alle Bewertungen",
    23291: "Foto-URL herunterladen",
    23301: "Kunden-Foto-URLs.",
    23311: "Händler-Foto-URLs.",
    23321: "Downloads der Downloads",
    23331: "Report Name",
    23341: "Gesendet an",
    23351: "Zeit erstellt (UTC)",
    23361: "Berichtstyp",
    23371: "Profile Details",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "Aktualisieren",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "Hochladen",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "Bulk Management Control",
    23721: "Aktualisieren Sie den Standortdetails und die Steuerungsplattformparameter direkt in Google-Blättern.",
    23731: "PLATFORM",
    23741: "Verwalten Sie leicht Konten über jede Skala mit benutzerdefinierten Standortvariablen und -einstellungen.",
    23751: "GBP Details",
    23761: "Alle anzeigen Google Business Profile-Angebote und fügen Sie die Location Details direkt hinzu / editieren / löschen.",
    23771: "GBP Attributes",
    23781: "Weisen Sie jedem Speicherplatz alle in der Inkrementalsuche, um die Inkrementalsuche zuzuweisen.",
    23791: "GBP Listing",
    23801: "Create new GBP listing.",
    23811: "Facebook",
    23821: "Facebook Listing Steuerung",
    23831: "Geschichte",
    23841: "Ausbildung",
    23851: "Zugriff auf Ressourcen für Bulk Bearbeiten Workflows, Best Practices, Einschränkungen und Updates.",
    23861: "WARNUNG",
    23871: "Erfordernis",
    23881: "Benutzer müssen ein Google-Konto haben, damit das System ein Google-Blatt mit den Profildaten vorlegen kann.",
    23891: "Notiz:",
    23901: "Die Daten, die jedes Blatt ausfüllen, falls aus der Systemdatenbank. Wenn Sie sicherstellen möchten, dass die Tabellenkalkulation aktuelle Google-Daten enthält, empfehlen wir dringend, dass Sie Ihr Profil zuerst synchronisieren.",
    23911: 'Abhängig von der Anzahl der Standorte Ihres Kontos dauert die Google-Blätter möglicherweise Zeit, um anfänglich aufzubauen, und erfrischt dann, wenn Sie das Blatt navigieren. Bitte stellen Sie sicher, dass alle Daten stabil sind, bevor Sie das "Update" drücken, um die Bearbeitungen in das System zu speichern und Updates an Google zu drücken.',
    23921: "Die Plattform verfügt über eine direkte API-Verbindung zu Google, aber es gibt jedoch noch Zeiten, in denen Google das direkte Update auf der Seite Öffentliche Standortlistungsdatei verzögert.",
    23931: 'Das Drücken von "Update" löst ein direktes System direkt an Google aus. Es ist kein Rückgängig- oder Rückkehrvorgang verfügbar. Bitte stellen Sie sicher, dass Sie mit allen Änderungen vertraut sind, bevor Sie das Update auslösen. Wenn ein Fehler gemacht wird, warten Sie bitte ein paar Minuten und nehmen Sie dann die notwendige Änderung vor.',
    23941: "FARBSCHEMA",
    23951: "Jedes Blatt verfügt über ein Standardfarbschema, um den Benutzern zu verstehen, welche Felder für die Bearbeitung geeignet sind.",
    23961: "Variablen, die entweder Statusdetails von Google vermitteln oder nicht direkt über Bulk-Steuerungen bearbeitet werden können.",
    23971: "Google-Variablen sind direkt für Bulk Edit geöffnet.",
    23981: "Platform-Variablen, die direkt für Bulk Edit geöffnet sind.",
    23991: "Steuerung",
    24001: "Einzelheiten",
    24011: "Attribute",
    24021: "Liste erstellen",
    24031: "Anweisungen",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "/PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 14 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "Aktivität",
    24361: "Autorisiert",
    24371: "Autorisierte Verbindungen Zugriff auf die vollständige Überprüfung und Reaktionsfunktionen von / zu jeder Quelle.",
    24381: "Bulk Upload Groups",
    24391: "Bulk Upload GBP Detail",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "Entity-Tag erstellen",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "GBP-Detailverlauf",
    24491: "Impressionen",
    24501: "Inaktiv",
    24511: "Indiziert",
    24521: "Indizierte Anschlüsse Zugang Alle historischen und aktuellen Bewertungen von jeder Quelle.",
    24531: "Manage LocalPost",
    24541: "Kein Kommentar hinzugefügt",
    24551: "Nummer",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "Antwort speichern",
    24601: "Gesamtstandort",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "Standort-Aliase hochladen",
    24641: "Sicht",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "Löste sich",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Choose File",
    24911: "No file chosen",
    24921: "Zeigen Sie ein Protokoll jedes Updates an, um die Auflistungsinhaltsänderungen zu bestätigen und Fehler zu erkennen.",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "Benutzeridentifikation",
    24961: "Do you want to delete?",
    24971: "Konto",
    24981: "Hat keine Google-Updates",
    24991: "Reverifizierung nicht erforderlich",
    25001: "No pending edits",
    25011: "Prüfungszeit",
    25021: "Gebiet",
    25031: "Wert (bis)",
    25041: "Wert (von)",
    25051: "remove from entity tag",
    25061: "Attributelist",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "Entdecken",
    25111: "Antworten prüfen",
    25121: "Vorlage auswählen",
    25131: "Weiter",
    25141: "Wählen Sie Sterne-Rating, Vorlagenname und fügen Sie Vorlageninhalt hinzu, um die automatische Antwort zu speichern.",
    25151: "Antworttyp auswählen",
    25161: "Vorlage",
    25171: "Ausschnitt",
    25181: "einem Rating zuordnen (erforderlich)",
    25191: "Geben Sie den Vorlagennamen ein (erforderlich)",
    25201: "Benutzerdefinierte Vorlagenvariable (optional)",
    25211: "Thema auswählen oder erstellen (optional)",
    25221: "Einzelstandort zuweisen (optional)",
    25231: "Dem Entity-Tag zuweisen (optional)",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "Standortanmerkung",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "Sehen Sie die Bewertung direkt auf Google",
    25301: "Positive-5 Stars",
    25311: "Negative - 1/2 Stars",
    25321: "Mixed - 3/4 Stars",
    25331: "Name des Vorlagers",
    25341: "Variable",
    25351: "Thema auswählen oder erstellen",
    25361: "Gruppe",
    25371: "Thema",
    25381: "Vorherige Bewertungen",
    25391: "Speichern als Antwort",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "Erstellungsdatum",
    25441: "Benutzerdefinierte Filtername",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "Herunterladen",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "Standard-Landing-Seite",
    25691: "Bewertungen inbox.",
    25701: "Massenmanagement",
    25711: "Postplanung",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn of Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "Antwortrate",
    25781: "Antwortzählung",
    25791: "Sternbewertungen.",
    25801: "Mit",
    25811: "Ohne",
    25821: "Verzögern",
    25831: "Zeitzone",
    25841: "Rezension",
    25851: "Competitor Report",
    25861: "Format",
    25871: "HTML Email",
    25881: "Excel",
    25891: "Wenn es keine Bewertungen in der gewählten Sortiment gibt",
    25901: "Senden Sie keine E-Mails",
    25911: "E-Mail senden",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "Bitte wenden Sie sich an den Support mit Fragen zum Profilsynchronisationskadenz",
    25971: "Include Audit File",
    25981: "Profil",
    25991: "CompTag",
    26001: "Überprüfen Sie details.",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "Customer actions line chart for Driving Direction, Phone Calls, and Website clicks.",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings.",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size.",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users.",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses.",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Yesterday",
    27251: "Last 7 days",
    27261: "Last week",
    27271: "Last 30 days",
    27281: "Last month",
    27291: "Alle Zeiten",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "Speichern Sie diese Antwort",
    27341: "Select or create a group",
    27351: "Keine gespeicherten Antworten",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "Alle Orte",
    27451: "Offen",
    27461: "Google Updates",
    27471: "Missing Content",
    27481: "Speichercode",
    27491: "Additional Categories",
    27501: "Standorte durchsuchen.",
    27511: "GBP Audit",
    27521: "Bulk-Aktivität",
    27531: "Wähle die Gruppe",
    27541: "20/ page",
    27551: "Synchronisieren",
    27561: "Publikum einstellen",
    27571: "Fertig",
    27581: "Group Name",
    27591: "Minute",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "Quadrantanalyse.",
    27631: "Alle Standorte Daten.",
    27641: "High Search + Low Conversion",
    27651: "High Search + High Conversion",
    27661: "Low Search + Low Conversion",
    27671: "Low Search + High Conversion",
    27681: "Location Data By Region",
    27691: "Location Data By City",
    27701: "Location:",
    27711: "Conversion Rate:",
    27721: "Searches:",
    27731: "Google Q&A",
    27741: "Google QA",
    27751: "Download QA",
    27761: "Antwort post",
    27771: "Post Insight",
    27781: "Download the sample CSV",
    27791: "Pre populated CSV",
    27801: "Manage Portfolio",
    27811: "Add Portfolio",
    27821: "View Portfolio",
    27831: "Delete Portfolio",
    27841: "Benutzer",
    27851: "Manage Profiles",
    27861: "Remove Profile",
    27871: "Are you sure you want to Remove this profile ?",
    27881: "Accounts",
    27891: "Select Profiles",
    27901: "Select Profile",
    27911: "Portfolio Account",
    27921: "Portfolio Details",
    27931: "Portfolio Name",
    27941: "Currrent Portfolio Image",
    27951: "Upload image as a logo for portfolio",
    27961: "Change portfolio name",
    27971: "Free Trial",
    27981: "Current",
    27991: "Expired",
    28001: "Cancelled",
    28011: "Invoicing",
    28021: "In Verbindung gebracht",
    28031: "Number of Accounts",
    28041: "Total Locations",
    28051: "Active Locations",
    28061: "Reviews (30 days)",
    28071: "Payment Status",
    28081: "Profile Name",
    28091: "Enter name of new portfolio",
    28101: "A portfolio can bulk manage their users across different profiles easily",
    28111: "Name of new portfolio",
    28121: "Portfolio names can only have a maximum of 20 characters",
    28131: "Portfolio Created Successfully!",
    28141: "Total Profile",
    28151: "Total Users",
    28161: "Enter email",
    28171: "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role.",
    28181: "Invite",
    28191: "Current Portfolio Image",
    28201: "Sentiment",
    28211: "Awaiting",
    28221: "Mehr Filter",
    28231: "Review Tag",
    28241: "Gespeicherte Filter",
    28251: "Weniger Filter",
    28261: "No Text",
    28271: "Medium",
    28281: "Expand",
    28291: "Single image upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "Offen",
    28471: "Geschlossen",
    28481: "Entfernt",
    28491: "Neue Review Tag",
    28501: "Alle Bewertungen",
    28511: "Nichts in diesem Bereich zu zeigen!",
    28521: "Suche",
    28531: "Alle auswählen",
    28541: "Quelle suchen",
    28551: "Bewertungstag auswählen",
    28561: "Standort suchen",
    28571: "Suche Geschäftscode",
    28581: "Gruppe suchen",
    28591: "Organisationen",
    28601: "Entitäts-Tags",
    28611: "Anwenden",
    28621: "Gruppe",
    28631: "Gespeicherte Filter duchsuchen",
    28641: "Keine Optionen!",
    28651: "Textansicht anpassen",
    28661: "Sehen Sie sich die Bewertung direkt auf",
    28671: "Antworten auf Bewertungsplattform",
    28681: "Vorlage auswählen",
    28691: "Kopieren",
    28701: "Vor Bewertungen",
    28711: "Keine Bewertungen",
    28721: "Wertung",
    28731: "Antworten Standortname nicht in diesem Ort hinzugefügt",
    28741: "Die Unterschrift ist nicht an dieser Stelle hinzugefügt",
    28751: "Wollen Sie Download fortsetzen?",
    28761: "Bewertungen ohne Antworten",
    28771: "Bewertungen mit internen Antworten",
    28781: "Bewertungen mit Auto-Reply",
    28791: "Bewertungen mit externen Antworten",
    28801: "Google anzeigen Wissens-Panel",
    28811: "Lage Hinweis",
    28821: "New-Manager",
    28831: "Aktivieren Cc",
    28841: "Speichern unter Antworten",
    28851: "Löschen Antworten",
    28861: "Gruppe",
    28871: "Gemischt",
    28881: "Sterne",
    28891: "Negative, Gemischt, Positive",
    28901: "Wertung",
    28911: "Vorlagenname",
    28921: "Variable",
    28931: "Speichern einer Antwort",
    28941: "Benutzername bearbeiten.",
    28951: "Benutzername ändern.",
    28961: "Kontobezeichnung",
    28971: "Facebook-Standorte",
    28981: "Seite hinzufügen",
    28991: "Aktiviert",
    29001: "Versteckte Lage zeigen.",
    29011: "FB-Seite anzeigen.",
    29021: "Kein verborgenes Konto zu zeigen",
    29031: "Vor Stunden",
    29041: "Einladend",
    29051: "Review-Showcase.",
    29061: "Google-Standorte.",
    29071: "Ihre Standorte",
    29081: "Standort-URL.",
    29091: "Möchten Sie diese URL sicher, dass Sie diese URL löschen möchten?",
    29101: "Möchten Sie die URL und ihre zugehörigen Daten aus der Anwendung löschen?",
    29111: "Konkurrentenstandorte.",
    29121: "Wettbewerbername",
    29131: "Aufgeben",
    29141: "Comptag",
    29151: "Geben Sie den Standort-URLs und -Pentitor-Details ein",
    29161: "IscomPetitor.",
    29171: "Buchungsorte",
    29181: "Um Buchungsüberprüfung initiieren Integration",
    29191: "Back Office Standort-ID (optional)",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "Erstellen Sie Kampagnen, um direkt auf Bewertungen mit der perfekten Antwort zum perfekten Zeit zu antworten",
    29301: "Möchten Sie diese Kampagne sicherlich löschen?",
    29311: "Kopieren Sie intelligente Bewertungen jedem zugewiesenen Standortmanager",
    29321: "CC antwortet auf zugewiesene Standortmanager",
    29331: "CC antwortet auf Corporate",
    29341: "Empfänger",
    29351: "Alle Empfänger.",
    29361: "Select Review Source.",
    29371: "NUR PUB / SUB",
    29381: "Wählen Sie die Sternbewertung aus",
    29391: "Inhalt überprüfen",
    29401: "Benutzerdefinierte Gruppe",
    29411: "Legen Sie die Verzögerung fest, bevor Sie die automatische Antwort senden",
    29421: "Betriebsstunden",
    29431: "Optional",
    29441: "Keine Standorte zugewiesen",
    29451: "Es gab keinen Einblick für den ausgewählten Datumsbereich und die Kriterien.",
    29461: "Filtermenü",
    29471: "Sortieren",
    29481: "Ansichten in der Suche.",
    29491: "Ansichten in Karten",
    29501: "Sie haben keine ausreichenden Berechtigungen, um eine Antwort zu posten.",
    29511: "Bereits verschickt",
    29521: "AR-Vorlagen hochladen",
    29531: "Anhänger zählen",
    29541: "Letzte Sync",
    29551: "Angesagt",
    29561: "Agentur",
    29571: "Localpost aktiviert",
    29581: "Keine anstehende Überprüfung",
    29591: "Klicken Sie hier, um diese Bewertung im Posteingang anzuzeigen",
    29601: "Weiterlesen",
    29611: "Wird geladen",
    29621: "Gesamtzahl (Nummer) Artikel",
    29631: "Google, mein Unternehmen überprüft",
    29641: "Markieren als",
    29651: "Stunden hinzufügen",
    29661: "Heute",
    29671: "Adresse",
    29681: "Postleitzahl",
    29691: "Identifiziert als Schwarzbesitz",
    29701: "URL hinzufügen",
    29711: "Post",
    29721: "Kontakt E-mail",
    29731: "COVID_19-Update.",
    29741: "Änderungen an Ihrem Unternehmen?",
    29751: "Kampagne",
    29761: "Online bestellen",
    29771: "Besorgen",
    29781: "Jetzt anrufen",
    29791: "Jetzt",
    29801: "Diesen Standort synchronisieren?",
    29811: "Facebook-Listing.",
    29821: "Neue Facebook-Liste erstellen",
    29831: "Ausgewählt",
    29841: "Geschäftsdetails.",
    29851: "Kontakte",
    29861: "Variablen",
    29871: "Interne ID",
    29881: "Klicken Sie hier, um herzustellen",
    29891: "Zurück zum Hochladen",
    29901: "Siehe das Q & A bei Google",
    29911: "Benötigen",
    29921: "Deaktivieren",
    29931: "Überprüfen Sie die enge Bestätigung",
    29941: "Antwort überprüfen Bestätigung",
    29951: "Überprüfung der Entfernung der Entfernung",
    29961: "Region",
    29971: "Antwort auf diese Frage",
    29981: "Verwalten",
    29991: "Google Post erstellen",
    30001: "Google Post verwalten",
    30011: "Versteck",
    30021: "Wählen Sie die aktuelle Seite aus",
    30031: "Erstellen Sie Facebook Post.",
    30041: "Facebook Post verwalten",
    30051: "Alles löschen",
    30061: "Filter speichern",
    30071: "Suchrolle",
    30081: "Suchbenutzer",
    30091: "Alle Redakteure",
    30101: "Rating zuordnen (erforderlich)",
    30111: "Geben Sie den Vorlagennamen ein (erforderlich)",
    30121: "Benutzerdefinierte Vorlagenvariable (optional)",
    30131: "Thema auswählen oder erstellen (optional)",
    30141: "Einzelstandort zuweisen (optional)",
    30151: "Dem Entity-Tag zuweisen (optional)",
    30161: "Überprüfungsvariablen",
    30171: "Vorname Bewerter",
    30181: "Vollständiger Name Bewerter",
    30191: "Standortvariablen",
    30201: "Reply-Standortname",
    30211: "Geo Standortname",
    30221: "Eine Antwort für diese Überprüfung wurde bereits gesendet.",
    30231: "Antworten für diese Bewertung kann nicht mehr gesendet werden. Sie können diese Antwort löschen, um es von hier zu entfernen.",
    30241: "Möchten Sie die Daten dieses Standorts synchronisieren? Dadurch wird alle Updates an den Standort angezogen.",
    30251: "Lassen Sie Kunden aufgrund von Covid-19 über alle Änderungen an Ihrem Unternehmen wissen",
    30261: "Schick jetzt",
    30271: "Suchen Showcase",
    30281: "Verwenden Sie die Steuerelemente rechts, um das genaue Überprüfungs-Showcase aufzubauen. Klicken Sie auf die Schaltfläche 'Übernehmen', um die Instant-Vorschau zu laden",
    30291: "Bauen Sie Ihre Bewertung Showcase auf",
    30301: "Showcase-Details.",
    30311: "Nennen Sie dieses Showcase",
    30321: "Individueller Ort",
    30331: "Standortgruppe",
    30341: "Showcase-Titel",
    30351: "Verstecken",
    30361: "Reviewer-Bild / Avatar",
    30371: "Zeigen",
    30381: "Select-Set",
    30391: "Überprüfungsquellen",
    30401: "Bewertungen von",
    30411: "Showcase erstellen",
    30421: "Mindestbewertung.",
    30431: "Bewertung von Bewertungen.",
    30441: "Präsentation definieren",
    30451: "Max-Review Count.",
    30461: "Max Comment Lenght.",
    30471: "Max Bewertungen pro Seite",
    30481: "Ansprechendes Layout",
    30491: "Sortierreihenfolge",
    30501: "Neueste zuerst",
    30511: "Sterne-Ratingfarbe",
    30521: "Kommentare überprüfen.",
    30531: "Quelllogo",
    30541: "Prüfungsdatum",
    30551: "Genaues Datum",
    30561: "Schriftfamilie",
    30571: "Showcase Titelgröße.",
    30581: "Bewertername-Größe",
    30591: "Kommentargröße",
    30601: "Befreie einstellen",
    30611: "Oben anpinnen",
    30621: "Ausschließen",
    30631: "Meine Rezensionen",
    30641: "Braucht Unterstützung",
    30651: "Warten auf den Kunden",
    30661: "Erwarte Feedback",
    30671: "Neues Feedback",
    30681: "Suchname",
    30691: "Nicht zugeordnet",
    30701: "Erfolgreich aktualisiert",
    30711: "Name des Kampagneninhalts (optional)",
    30721: "Allgemeine Geschäftsbedingungen (optional)",
    30731: "Sind Sie sicher, dass Sie diesen Benutzer entfernen möchten? Nach dem Entfernen hat der Benutzer keinen Zugriff mehr auf dieses Profil, sofern nicht mehr eingeladen.",
    30741: "Möchten Sie diesen Benutzer entfernen?",
    30751: "Antwortverteilung",
    30761: "Wir senden Ihnen eine E-Mail () mit einem Link zum Laden der Überprüfung CSV.",
    30771: "Dieses Profil hat mehr als 100 Standorte. Wir senden Ihnen eine E-Mail mit dem Download-Link",
    30781: "Benutzerantwort.",
    30791: "Gepresste Marke",
    30801: "Zielantwort.",
    null: null,
    30811: "Bewertungen-Dashboard",
    30812: "Überblick",
    30813: "Durchschn.",
    30814: "BEW Rating",
    30815: "Pos",
    30816: "Glück",
    30817: "Wortverhältnis",
    30818: "Reaktionsverhältnis",
    30819: "Bewertung nach Quelle",
    30820: "Bewertung nach Bewertung",
    30821: "Antwort nach Bewertung",
    30822: "Neueste Bewertungen",
    30823: "Sie haben in den letzten {x} Tagen {x} Bewertungen erhalten. Hier sind die neuesten",
    30824: "Die durchschnittliche Anzahl von Bewertungen pro Hauptstandort während des Zeitraums",
    30825: "Der Prozentsatz der Bewertungen mit 4-Sterne- und 5-Sterne-Bewertungen",
    30826: "Der Glücklichkeits-Score ist eine Darstellung des Prozentsatzes positiver Bewertungen minus des Prozentsatzes negativer Bewertungen",
    30827: "Der Prozentsatz aller Kommentare, die in 5-Sterne- und 4-Sterne-Bewertungen gefunden wurden, im Vergleich zu allen Wörtern, die im angegebenen Zeitraum geteilt wurden. Der Bereich reicht von 5-Sterne bis 1-Sterne.",
    30828: "Der Prozentsatz der Bewertungen innerhalb des Zeitraums, die eine Antwort erhalten haben.",
    30829: "Abnahme in {x data} von den vorherigen {xx} Tagen",
    30830: "Zunahme in {x data} von den vorherigen {xx} Tagen",
    30831: "Keine Änderung in {x data} von den vorherigen {xx} Tagen",
    30832: "Klicken Sie, um diese Bewertungen anzuzeigen",
    30833: "(StandortName) , (x) Sterne, Bewerter: (x)",
    30834: "Bewertungen & Durchschnittsbewertung",
    30835: "Bewertungsanzahl über die Zeit gestapelt nach Sternebewertung + Liniendiagramm des Bewertungsdurchschnitts.",
    30836: "Prozentsatz nach Sternebewertung",
    30837: "Bewertungsanzahl über die Zeit gestapelt nach Sternebewertung als Prozentsatz des Gesamtwerts.",
    30838: "Kumulative Anzahl & Durchschnittsbewertung",
    30839: "Gesamtzahl der Bewertungen und durchschnittliche Bewertung für den Berichtszeitraum.",
    30840: "Bewertungen nach Quelle",
    30841: "Anzahl der Bewertungen im Zeitverlauf nach Quelle.",
    30842: "Glückswert im Laufe der Zeit",
    30843: "Der Netto-Glücksscore pro Zeitraum über den Berichtsbereich.",
    30844: "Wochentag",
    30845: "Tag des Monats",
    30846: "Monat des Jahres",
    30847: "Top-Länder",
    30848: "Top-Staaten",
    30849: "Top-Städte",
    30850: "Antworten",
    30851: "Schnelle Antwortquote",
    30852: "Median",
    30853: "Die Anzahl der veröffentlichten Antworten im Zeitraum und der Durchschnitt pro Standort.",
    30854: "Der Prozentsatz der Bewertungen, die innerhalb von 2 Tagen eine Antwort erhalten, und die mittlere Antwortzeit.",
    30855: "Antwortanzahl & Verhältnis",
    30856: "Die Anzahl der Antworten nach Sternebewertung und das gesamte Antwortverhältnis.",
    30857: "Durchschnittliche Antwortzeit",
    30858: "Die durchschnittliche Antwortzeit in Tagen.",
    30859: "Antwortverteilung",
    30860: "Histogramm der Bewertungsantwortzeit in 10 Stufen unterteilt.",
    30861: "Glücklich",
    30862: "Verhältnis",
    30863: "Lebensdauer",
    30864: "Anzahl der übergeordneten Standortdatensätze plus nicht zugeordnete Eintragsdatensätze.",
    30865: "Energie",
    30866: "Kommentarverhältnis",
    30867: "Kommentarlänge",
    30868: "Verhältnis Lücke",
    30869: "Längenunterschied",
    30870: "Bewertungen mit und ohne Kommentare",
    30871: "Durchschnittliche Wörter pro Sternebewertung",
    30872: "Prozentsatz der Wörter in jeder Sternebewertung",
    30873: "Prozentsatz des Kommentarverhältnisses",
    30874: "Der Prozentsatz aller Bewertungen, die Kundenkommentare enthalten",
    30875: "Kommentaranzahl",
    30876: "Die durchschnittliche Anzahl der Wörter in Bewertungen mit Kommentaren",
    30877: "Wortverteilung im Kommentar",
    30878: "Der Prozentsatz der Wörter in jeder Sternebewertung für jeden Zeitraum",
    30879: "Prozentsatz positiver Bewertungen mit Kommentaren minus der Prozentsatz negativer Bewertungen.",
    30880: "Durchschnittliche Länge positiver Bewertungen minus durchschnittliche Länge negativer Bewertungen.",
    30881: "Bewertungen mit Antwortrate",
    30882: "Kommentarlängenrate",
    30883: "Rasteransicht",
    30884: "Durchschnittsstandort",
    30885: "Die durchschnittliche Bewertung der Standorte und der Prozentsatz der Standorte mit einer Bewertung über 4,0 im Zeitraum.",
    30886: "Bewertungsleistungsraster",
    30887: "Präsentieren Sie den durchschnittlichen Standortbewertungswert im Vergleich zum Bewertungsvolumen, um Ausreißer zu identifizieren",
    30888: "Stimmung",
    30889: "Einfluss",
    30890: "Leistungs-Dashboard",
    30891: "Führungsraster",
    30892: "Gesamtansichten",
    30893: "Konversionsrate",
    30894: "Gesamtansichten und die durchschnittlichen Ansichten pro Standort.",
    30895: "Kartenansichten auf Desktop und Mobilgerät mit prozentualer Aufschlüsselung.",
    30896: "Lokale Suchansicht auf Desktop und Mobilgerät mit prozentualer Aufschlüsselung.",
    30897: "Gesamtaktionen mit prozentualer Aufschlüsselung zwischen Anrufen, Website-Klicks und Wegbeschreibungen.",
    30898: "Gesamtkonversionsrate von Aktionen/Ansichten für Anrufe, Website-Klicks und Wegbeschreibungen.",
    30899: "Kundenansichten",
    30900: "Wie und wo Kunden Ihr Unternehmen sehen.",
    30901: "Kundenaktionen",
    30902: "Die nachvollziehbaren Aktionen aus Ihren Google-Einträgen.",
    30903: "Der Prozentsatz der Geschäftseintrag-Impressionen, der zu einer Aktion führt",
    30904: "Effektivität nach Standort",
    30905: "Gesamtansichten vs. Konversionsrate (Aktionen/Ansichten), um die Effektivität jedes Standorts bei der Generierung von Ansichten und deren Umwandlung in Aktionen zu zeigen.",
    30906: "Effektivität nach Stadt",
    30907: "Gesamtansichten vs. Konversionsrate (Aktionen/Ansichten) für jede Stadt.",
    30908: "Effektivität nach Gruppe",
    30909: "Gesamtansichten vs. Konversionsrate (Aktionen/Ansichten) für jede benutzerdefinierte Gruppe.",
    30910: "Hohe Ansichten + Niedrige Konversion",
    30911: "Hohe Ansichten + Hohe Konversion",
    30912: "Niedrige Ansichten + Niedrige Konversion",
    30913: "Niedrige Ansichten + Hohe Konversion",
    30914: "Mobile",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "Seitе",
    30920: "Anrufe",
    30921: "Gesundheitspunktzahl",
    30922: "Tägliche Leistung",
    30923: "Wählen Sie die Standorte aus der Tabelle und die Metrik (Aufrufe oder Aktionen)",
    30924: "Zufriedenheitsrate",
    30925: "Name/Freundlich",
    30926: "{x} Standorte mit einem Durchschnitt von {y} Sternen in den letzten {xx} Tagen",
    30927: "Über",
    30928: "Gruppe",
    30929: "Alle Ansichten",
    30930: "Alle Aktionen",
    30931: "Desktop",
    30932: "Maximaler Limit erreicht: Wählen Sie bis zu 8 Standorte für das Diagramm aus.",
    30933: "Bewerter",
    30934: "Gesamtstimmung",
    30935: "Verteilung der Sentiment-Score über {XX} Themen.",
    30936: "Stimmung nach Thema",
    30937: "Themenhäufigkeit und entsprechende Sentimentwerte.",
    30938: "Sehr Positiv",
    30939: "Sehr Negativ",
    30940: "Eine Automatisierungsregel ausgelöst für neue Bewertung auf",
    30941: "Eine Automatisierungsregel für aktualisierte Bewertung ausgelöst auf",
    30942: "die Antwort genehmigt am",
    30943: "einen Tag zugewiesen",
    30944: "die Bewertung zugewiesen an",
    30945: "bei",
    30946: "Automatische Antwort gesendet",
    30947: "Der Geschäftsinhaber hat eine neue externe Antwort erstellt auf",
    30948: "durch Automatisierungsregel am",
    30949: "durch System am",
    30950: "hat ein neues erstellt",
    30951: "hat eine neue Antwort erstellt am",
    30952: "hat eine Überprüfungsnotiz erstellt für",
    30953: "hat eine Notiz gelöscht am",
    30954: "hat eine Überprüfungsnotiz gelöscht am",
    30955: "hat die Antwort gelöscht am",
    30956: "hat die Antwort bearbeitet am",
    30957: "von",
    30958: "hat eine automatische Antwort generiert am",
    30959: "lokal",
    30960: "Benachrichtigung",
    30961: "benachrichtigt",
    30962: "Übersicht",
    30963: "durchgeführt",
    30964: "Antwort",
    30965: "Antwort in den Genehmigungseingang verschoben am",
    30966: "Antwort in den Postausgang verschoben und zur Veröffentlichung geplant",
    30967: "Antwort gepostet auf",
    30968: "Überprüfung zugewiesen an",
    30969: "Überprüfung am",
    30970: "Überprüfung erhalten von",
    30971: "schickte eine Notiz an",
    30972: "System wies ein Sprach-Tag zu",
    30973: "System hat eine automatische Antwort zugewiesen am",
    30974: "Tags",
    30975: "Team durch Automatisierungsregel am",
    30976: "Zeitachse",
    30977: "zu",
    30978: "aktualisierte ein",
    30979: "aktualisierte eine Überprüfungsnotiz am",
    30980: "aktualisierte die Bewertungsbewertung von",
    30981: "aktualisierte den Überprüfungsstatus von",
    30982: "aktualisierte den Überprüfungsstatus zu",
    30983: "aktualisierte den Kommentar zu ihrem",
    30984: "über die API während",
    30985: "über Pub-Sub am",
    30986: "Kein Kommentar hinzugefügt",
    30987: "auf",
    30988: "System",
    30989: "von",
    30990: "Die Überprüfungsaufgabe wurde entfernt aus",
    30991: "zugewiesen an",
    30992: "Zugewiesene Kennzeichnung:",
    30993: "Zugewiesene Etikettengruppe:",
    30994: "Etikett entfernt:",
    30995: "Überprüfung mit Aktualisierungen",
    30996: "Überprüfung ohne Aktualisierungen",
    30997: "Alle Tags auswählen",
    30998: "Nicht markierte auswählen",
    30999: "Ausstehende Genehmigung",
    31000: "Älteste zuerst",
    31001: "Sie haben keine gespeicherten Notizen",
    31002: "Antwort im Postausgang",
    31003: "Bewertungs-Versionen",
    31004: "Bewertungsdetails",
    31005: "Informationen Öffnen",
    31006: "Beziehungen",
    31007: "Fehler",
    31008: "Primär",
    31009: "Kategorien",
    31010: "Soziale Links",
    31011: "Originalbild wurde vom Nutzer oder von der Plattform entfernt."
  },
  french: (_french = {
    1001: "L'inscription signifie que vous avez lu et accepté nos ",
    1002: "conditions d'utilisation ",
    1003: " et  ",
    1004: "notre politique de confidentialité",
    1005: ".",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "Cumulées",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "Examens d'équipe",
    2029: "Automatiser",
    2030: "Complet",
    2031: "Attribué",
    2032: "Recherche d'un utilisateur",
    2033: "Envoyer un courriel",
    2034: "composer",
    2035: "Réponse IA",
    2036: "Répondre au courrier",
    2037: "Régénérer",
    2038: "Approbation",
    2039: "Poste sur Source",
    2040: "Réponse envoyée",
    2041: "Pas de messages envoyés",
    2042: "Clair",
    2043: "Fermé",
    2044: "Aucun texte de réponse n'a été trouvé",
    2045: "Copier la réponse et aller à la source",
    2046: "Modifier la réponse",
    2047: "Approuver la réponse",
    2048: "Mettre à jour la réponse",
    2049: "Supprimer la réponse",
    2050: "Êtes-vous sûr de vouloir supprimer cette réponse ?",
    2051: "Êtes-vous sûr de vouloir soumettre cette réponse ?",
    2052: "Souhaitez-vous rétablir cet examen ?",
    2053: "Êtes-vous sûr ?",
    2054: "Êtes-vous sûr de vouloir approuver cette réponse ?",
    2055: "Les équipes",
    2056: "Toujours ctif",
    2057: "Classement + courtcommentaire",
    2058: "Note + commentaire",
    2059: "Commentaire par langue",
    2060: "Veuillez indiquer une longueur de commentaire comprise entre 1 et 100. La valeur par défaut est de 20 caractères",
    2061: "Copier les réponses àl'examen intelligent à chaque responsable de site assigné",
    2062: "S'identifier",
    2063: "Adresse e-mail",
    2064: "Vous n'avez pas de compte ?",
    2065: "Prénom",
    2066: "Nom de famille",
    2067: "Entreprise",
    2068: "Nom de l'entreprise",
    2069: "Vous avez déjà un compte?",
    2070: "Montrer le mot de passe",
    2071: "Masquer le mot de passe",
    2072: "Conversion Locales",
    2073: "Cartes Mobile",
    2074: "Cartes Bureau",
    2075: "Recherche Mobile",
    2076: "Recherche Bureau",
    2077: "Vues de Recherche",
    2078: "Vues de Carte",
    2081: "Universel",
    2091: "Par Sujet",
    10010: "1 étoile",
    10013: "2 étoiles",
    10016: "3 étoiles",
    10019: "4 étoiles",
    10022: "5 étoiles",
    10025: "De 100 à 300 mots",
    10120: "actes",
    10123: "Activer",
    10124: "Toujours actif",
    10126: "Organisations actives",
    10129: "Ajouter",
    10132: "Ajouter un bouton",
    10135: "Vinculo de tu botón",
    10138: "Ajouter un compte",
    10141: "AJOUTER UN TÉLÉPHONE SUPPLÉMENTAIRE",
    10144: "Ajouter un compte",
    10147: "AJOUTEZ UNE AUTRE CATÉGORIE",
    10150: "AJOUTEZ UN AUTRE LABEL",
    10153: "Ajouter des attributs",
    10156: "Ajouter une ligne",
    10159: "AJOUTER UNE NOUVELLE DATE",
    10162: "Ajouter une nouvelle étiquette de révision",
    10165: "Ajouter un nouveau rôle",
    10168: "Ajouter la date d'ouverture",
    10171: "Ajouter un profil",
    10174: "Nouveau rapport",
    10177: "Ajouter un rapport",
    10180: "Ajouter un rôle",
    10181: "Ajouter une balise de révision",
    10183: "Catégorie supplémentaire",
    10186: "Téléphone supplémentaire",
    10189: "Adresse",
    10192: "ADMIN",
    10195: "Administrateur",
    10198: "extensions de site adWords",
    10201: "Téléphone des extensions de lieu adWords",
    10204: "Tout",
    10207: "Tous les avis",
    10210: "Tous les utilisateurs affectés à ce rôle auront accès aux fonctionnalités suivantes",
    10213: "Appliquer",
    10216: "Boîte de réception d'approbation",
    10219: "Êtes-vous sûr de vouloir réinitialiser le mot de passe de cet utilisateur?",
    10222: "Êtes-vous sûr?",
    10225: "Région",
    10228: "Domaines",
    10231: "Les attributs",
    10234: "Autoriser le compte",
    10237: "Moyen",
    10240: "Nombre de photos moyen",
    10243: "Note moyenne",
    10244: "Note moyenne",
    10246: "Note moyenne par établissements",
    10249: "En attente de réponse",
    10320: "Arrière",
    10321: "arrière",
    10323: "Facturation",
    10326: "Livre",
    10329: "Bulk Upload Post",
    10332: "Bulk Upload Tags",
    10335: "Transfert en vrac TSV",
    10338: "Nom de l'entreprise",
    10520: "Calendrier",
    10523: "Annuler",
    10526: "Impossible de télécharger la cartographie de l'emplacement principal!",
    10529: "Catégorie",
    10532: "Changer de rôle",
    10535: "Histoire de la citation",
    10538: "Ville",
    10541: "Cliquez ici",
    10544: "Cliquez sur un utilisateur pour lui attribuer ce rôle",
    10547: "Pays",
    10548: "Confirmez le mot de passe",
    10550: "Copie",
    10553: "Copier et coller",
    10556: "Impossible de changer de rôle!",
    10559: "Impossible de télécharger le message",
    10562: "Pays",
    10565: "Pays",
    10568: "Code de coupon",
    10571: "Code de réduction (optionnel)",
    10574: "Créez un nouveau filtre en sélectionnant les options ci-dessous",
    10577: "Créer un nouveau filtre",
    10580: "Créer un nouveau rapport",
    10583: "Créer des messages",
    10586: "Créer un tag",
    10589: "Créer ce rapport",
    10592: "Créer ce rôle",
    10595: "Créé par",
    10598: "Actions du client",
    10720: "J",
    10723: "Tableau de bord",
    10726: "Date",
    10729: "Plage de dates",
    10732: "journée",
    10735: "Désactiver",
    10738: "DÉFAUT",
    10741: "Retarder avant de poster",
    10744: "Retarder l'envoi des réponses par",
    10747: "Retarder l'envoi des réponses par",
    10750: "Supprimer",
    10753: "Effacer ?",
    10754: "Effacer",
    10756: "Desc",
    10759: "La description",
    10762: "Direct",
    10765: "Requêtes directes",
    10768: "instructions",
    10771: "Découverte",
    10774: "Vue distincte",
    10777: "Télécharger toutes les données de localisation",
    10780: "Télécharger",
    10783: "Télécharger les détails de localisation Google",
    10786: "Télécharger les données",
    10789: "Brouillons",
    10792: "Demandes d'itinéraire",
    10795: "Demandes d'itinéraire par jour",
    10920: "Éditer",
    10923: "Editer le profil",
    10926: "Modifier le rapport",
    10929: "Modifier ce rapport",
    10932: "Éditeur",
    10935: "Email",
    10938: "Heure de fin",
    10941: "Entrez les extensions de lieu adWords",
    10944: "Entrez le nom de la balise d'entité",
    10947: "Entrez les étiquettes",
    10950: "Saisir le texte de recherche",
    10953: "Entrez le nom de la balise",
    10956: "Égal",
    10959: "un événement",
    10962: "Détails de l'événement",
    10965: "Titre de l'événement",
    10968: "Chaque",
    10971: "example.com",
    10974: "Par exemple : 20 % de réduction en magasin ou en ligne",
    11120: "Gestion de l'accès aux fonctionnalités",
    11123: "Filtres",
    11126: "Mot de passe oublié?",
    11129: "Vendredi",
    11320: "Obtenir une offre",
    11323: "Supérieur à",
    11520: "Évaluation du bonheur",
    11525: "Aidez-moi",
    11530: "Vacances",
    11535: "Heure",
    11540: "Heures",
    11545: "Façon dont les clients cherchent votre entreprise",
    11720: "Image",
    11723: "URL de l'image",
    11726: "Dans les cartes",
    11729: "À la recherche",
    11732: "Boîte de réception",
    11735: "Requêtes indirectes",
    11738: "Connaissances",
    11741: "Permission insuffisante",
    11744: "L'intégration",
    11747: "Intégrations",
    11750: "Inviter un utilisateur",
    11753: "INVITÉ",
    11756: "Inviter par",
    11759: "articles",
    12120: "Panneau de connaissances",
    12320: "Étiquettes",
    12323: "Dernière connexion",
    12326: "Dernière mise à jour",
    12329: "Apprendre encore plus",
    12332: "Moins que",
    12335: "Lien pour votre bouton",
    12338: "Lien pour échanger une offre",
    12341: "Lien pour échanger une offre (facultatif)",
    12344: "Lien",
    12347: "Gestion des inscriptions",
    12350: "Performance locale",
    12353: "Aperçu des performances locales",
    12356: "Conversion de recherche locale",
    12359: "Villes",
    12362: "Locaity",
    12365: "Lieu",
    12368: "Détails de l'emplacement",
    12371: "ID d'emplacement",
    12374: "Emplacements",
    12377: "S'identifier",
    12380: "Connectez - Out",
    12520: "M",
    12523: "Faites votre post avec une photo",
    12526: "Gérer l'activité en vrac",
    12529: "Gérer les balises d'entité",
    12532: "Gérer les emplacements",
    12535: "Gérer le profil",
    12538: "Gérer les rôles",
    12541: "gérer les utilisateurs",
    12544: "Plans",
    12547: "Nombre de marchands",
    12550: "Photos (du propriétaire)",
    12553: "Photos de marchands",
    12556: "Message",
    12559: "Minutes",
    12562: "lundi",
    12565: "mois",
    12720: "Nom",
    12723: "Nom du nouveau rôle",
    12726: "Nom du rapport",
    12729: "Besoin d'un compte?",
    12732: "Nouveau",
    12735: "Page suivante",
    12738: "Aucune réponse",
    12741: "Aucun résultat trouvé",
    12744: "Aucune étiquette d'avis n'existe",
    12747: "Aucun avis",
    12750: "Non, annuler",
    12753: "Nombre d'utilisateurs",
    12756: "Examens d'équipe",
    12920: "de",
    12923: "Offre",
    12926: "D'accord",
    12929: "Ok, c'est compris!",
    12932: "Une fois que",
    12935: "Date d'ouverture",
    12938: "Commande",
    13201: "Photos (des clients)",
    12944: "Boîte d'envoi",
    12947: "Propriétaire",
    13120: "page",
    13123: "Mot de passe",
    13126: "Coller TSV",
    13129: "Type de pdf",
    13132: "Téléphone",
    13135: "Appels téléphoniques par jour",
    13138: "Numéro de téléphone",
    13141: "Quantité de photo",
    13144: "Vues de photo",
    13147: "Veuillez entrer un nom de destinataire!",
    13150: "Veuillez entrer un nom de rapport!",
    13153: "Veuillez entrer un résumé!",
    13156: "Veuillez entrer un titre!",
    13159: "Veuillez entrer une heure valide!",
    13162: "Veuillez entrer une URL valide!",
    13165: "Veuillez actualiser la page pour mettre à jour vos détails de localisation",
    13168: "S'il vous plaît recharger",
    13171: "Veuillez sélectionner le type d'horaire!",
    13174: "Post histoire",
    13177: "Messages",
    13180: "Page précédente",
    13183: "Catégorie principale",
    13186: "Téléphone primaire",
    13189: "Numéro de téléphone principal",
    13192: "Les profils",
    13195: "Compte public",
    13198: "Photos publiques"
  }, _defineProperty(_french, "13201", "Photos publiques"), _defineProperty(_french, 13204, "PUBLIER"), _defineProperty(_french, 13520, "Évaluation"), _defineProperty(_french, 13523, "Notifications en temps réel"), _defineProperty(_french, 13526, "Liste de destinataires"), _defineProperty(_french, 13529, "Récurrent"), _defineProperty(_french, 13532, "Supprimer l'utilisateur"), _defineProperty(_french, 13535, "Répondre"), _defineProperty(_french, 13538, "Approbation de la réponse"), _defineProperty(_french, 13541, "Gestion des rapports"), _defineProperty(_french, 13544, "Nom du rapport"), _defineProperty(_french, 13547, "Type de rapport"), _defineProperty(_french, 13550, "Réinitialiser le mot de passe"), _defineProperty(_french, 13577, "Nombre d'avis par note"), _defineProperty(_french, 13556, "Compte de révision"), _defineProperty(_french, 13559, "Revue de téléchargement"), _defineProperty(_french, 13562, "Paramètres de révision"), _defineProperty(_french, 13565, "Source de révision"), _defineProperty(_french, 13568, "Critères d'évaluation"), _defineProperty(_french, 13571, "ReviewLink"), _defineProperty(_french, 13574, "Avis"), _defineProperty(_french, "13577", "Nombre d'avis par note"), _defineProperty(_french, 13580, "Avis vs Note moyenne"), _defineProperty(_french, 13583, "Avis de boîte de réception"), _defineProperty(_french, 13586, "Gestion des avis"), _defineProperty(_french, 13589, "Critiques, jour du mois"), _defineProperty(_french, 13592, "Avis par jours de la semaine"), _defineProperty(_french, 13595, "Avis par mois"), _defineProperty(_french, 13598, "Rôle"), _defineProperty(_french, 13601, "Détails du rôle"), _defineProperty(_french, 13604, "Nom de rôle"), _defineProperty(_french, 13720, "samedi"), _defineProperty(_french, 13723, "sauver"), _defineProperty(_french, 13726, "Enregistrer en tant que filtre personnalisé"), _defineProperty(_french, 13729, "Enregistrer un nouveau filtre"), _defineProperty(_french, 13732, "Enregistrer le rôle"), _defineProperty(_french, 13735, "Réponses enregistrées"), _defineProperty(_french, 13738, "Date de planification"), _defineProperty(_french, 13741, "Calendrier Post"), _defineProperty(_french, 13742, "Pour planifier un rapport"), _defineProperty(_french, 13744, "Horaire"), _defineProperty(_french, 13747, "Type d'horaire"), _defineProperty(_french, 13750, "Chercher"), _defineProperty(_french, 13753, "Nombre de Recherches"), _defineProperty(_french, 13756, "Sélectionner"), _defineProperty(_french, 13759, "Sélectionnez un filtre existant"), _defineProperty(_french, 13762, "Choisir une catégorie"), _defineProperty(_french, 13765, "Sélectionnez une ville"), _defineProperty(_french, 13768, "Choisissez le pays"), _defineProperty(_french, 13771, "Sélectionnez la date et l'heure"), _defineProperty(_french, 13774, "Sélectionner une plage de dates"), _defineProperty(_french, 13777, "Sélectionnez l'éditeur (s) à examiner"), _defineProperty(_french, 13780, "Sélectionner une balise d'entité"), _defineProperty(_french, 13783, "Sélectionnez le filtre"), _defineProperty(_french, 13786, "Sélectionnez les filtres"), _defineProperty(_french, 13789, "Sélectionnez granularité"), _defineProperty(_french, 13792, "Sélectionner une organisation"), _defineProperty(_french, 13795, "Sélectionnez la balise de révision"), _defineProperty(_french, 13798, "Sélectionnez le filtre enregistré"), _defineProperty(_french, 13801, "Sélectionner la source"), _defineProperty(_french, 13804, "Sélectionnez l'état"), _defineProperty(_french, 13807, "Sélectionner le temps"), _defineProperty(_french, 13810, "SOI"), _defineProperty(_french, 13813, "Envoyez-le pour approbation"), _defineProperty(_french, 13816, "Envoyez-le à la boîte d'envoi"), _defineProperty(_french, 13819, "Envoyé"), _defineProperty(_french, 13822, "Services"), _defineProperty(_french, 13825, "Paramètres"), _defineProperty(_french, 13828, "Gestion des paramètres"), _defineProperty(_french, 13831, "Vendre"), _defineProperty(_french, 13834, "Afficher les messages"), _defineProperty(_french, 13837, "Afficher / Masquer Nav"), _defineProperty(_french, 13840, "S'inscrire"), _defineProperty(_french, 13843, "Single Location Edit"), _defineProperty(_french, 13846, "Pardon!"), _defineProperty(_french, 13849, "Trier par"), _defineProperty(_french, 13852, "Heures spéciales"), _defineProperty(_french, 13855, "Accès spécifique"), _defineProperty(_french, 13858, "LA NORME"), _defineProperty(_french, 13861, "Heure de début"), _defineProperty(_french, 13864, "Etat"), _defineProperty(_french, 13867, "Statut"), _defineProperty(_french, 13870, "le magasin"), _defineProperty(_french, 13873, "StoreCode"), _defineProperty(_french, 13876, "rue"), _defineProperty(_french, 13879, "Vue sommaire"), _defineProperty(_french, 13882, "dimanche"), _defineProperty(_french, 13885, "Synchroniser ce compte"), _defineProperty(_french, 13920, "Appels téléphoniques"), _defineProperty(_french, 13923, "Termes et conditions"), _defineProperty(_french, 13926, "Jeudi"), _defineProperty(_french, 13929, "Temps"), _defineProperty(_french, 13932, "Top Localities"), _defineProperty(_french, 13935, "Total"), _defineProperty(_french, 13938, "mardi"), _defineProperty(_french, 14120, "Sans réponse"), _defineProperty(_french, 14123, "Pas sûr du format?"), _defineProperty(_french, 14126, "Télécharger"), _defineProperty(_french, 14129, "Télécharger les détails de l'emplacement"), _defineProperty(_french, 14132, "Télécharger la carte de localisation"), _defineProperty(_french, 14135, "Transférer l'emplacement"), _defineProperty(_french, 14138, "Upload TSV"), _defineProperty(_french, 14141, "URL"), _defineProperty(_french, 14144, "Identifiant d'utilisateur"), _defineProperty(_french, 14320, "Voir l'image"), _defineProperty(_french, 14323, "Voir le profil"), _defineProperty(_french, 14326, "Nombre de Vues"), _defineProperty(_french, 14520, "S"), _defineProperty(_french, 14523, "Clic sur le site web"), _defineProperty(_french, 14526, "Clic sur le site web par jour"), _defineProperty(_french, 14529, "Nom du site"), _defineProperty(_french, 14532, "Mercredi"), _defineProperty(_french, 14535, "semaine"), _defineProperty(_french, 14538, "Quelles actions les clients prennent-ils?"), _defineProperty(_french, 14541, "Quand une réponse à une critique est faite"), _defineProperty(_french, 14544, "Où les clients voient votre entreprise"), _defineProperty(_french, 14547, "Voulez-vous supprimer cette publication programmée?"), _defineProperty(_french, 14550, "Écrivez votre titre"), _defineProperty(_french, 14920, "An"), _defineProperty(_french, 14923, "Oui continuer"), _defineProperty(_french, 14926, "Vous pouvez choisir de limiter l'accès des utilisateurs à ce rôle en sélectionnant un filtre à joindre à celui-ci."), _defineProperty(_french, 14929, "Nom"), _defineProperty(_french, 15120, "Code postal"), _defineProperty(_french, 20010, "lundi"), _defineProperty(_french, 20011, "Lu"), _defineProperty(_french, 20020, "mardi"), _defineProperty(_french, 20021, "Ma"), _defineProperty(_french, 20030, "mercredi"), _defineProperty(_french, 20031, "Me"), _defineProperty(_french, 20040, "jeudi"), _defineProperty(_french, 20041, "Je"), _defineProperty(_french, 20050, "vendredi"), _defineProperty(_french, 20051, "Ve"), _defineProperty(_french, 20060, "samedi"), _defineProperty(_french, 20061, "Sa"), _defineProperty(_french, 20070, "dimanche"), _defineProperty(_french, 20071, "Di"), _defineProperty(_french, 20110, "janvier"), _defineProperty(_french, 20111, "janv."), _defineProperty(_french, 20120, "février"), _defineProperty(_french, 20121, "févr."), _defineProperty(_french, 20130, "mars"), _defineProperty(_french, 20131, "mars"), _defineProperty(_french, 20140, "avril"), _defineProperty(_french, 20141, "avril"), _defineProperty(_french, 20150, "mai"), _defineProperty(_french, 20151, "mai"), _defineProperty(_french, 20160, "juin"), _defineProperty(_french, 20161, "juin"), _defineProperty(_french, 20170, "juillet"), _defineProperty(_french, 20171, "juil."), _defineProperty(_french, 20180, "aout"), _defineProperty(_french, 20181, "août"), _defineProperty(_french, 20190, "septembre"), _defineProperty(_french, 20191, "sept."), _defineProperty(_french, 20200, "octobre"), _defineProperty(_french, 20201, "oct."), _defineProperty(_french, 20210, "novembre"), _defineProperty(_french, 20211, "nov."), _defineProperty(_french, 20220, "décembre"), _defineProperty(_french, 20221, "déc."), _defineProperty(_french, 20231, "Reviews & Ratings"), _defineProperty(_french, 20241, "Pourcentages"), _defineProperty(_french, 20251, "Review with Percentage"), _defineProperty(_french, 20261, "Cumulative"), _defineProperty(_french, 20271, "Cumulative count"), _defineProperty(_french, 20281, "Source"), _defineProperty(_french, 20291, "Avis par Plateformes"), _defineProperty(_french, 20301, "Happiness"), _defineProperty(_french, 20311, "Temps de réponse"), _defineProperty(_french, 20321, "Sélectionnez l'emplacement"), _defineProperty(_french, 20331, "Search by reviews keyword"), _defineProperty(_french, 20341, "search by Reviewer"), _defineProperty(_french, 20351, "Sélectionner"), _defineProperty(_french, 20361, "Equals"), _defineProperty(_french, 20371, "Menos que"), _defineProperty(_french, 20381, "Plus grand que"), _defineProperty(_french, 20391, "Select Months"), _defineProperty(_french, 20401, "Select date"), _defineProperty(_french, 20411, "Click to view these reviews"), _defineProperty(_french, 20421, "There were no reviews found for the selected date range and criteria"), _defineProperty(_french, 20431, "Supprimer les filtres"), _defineProperty(_french, 20441, "Delete a custom filter"), _defineProperty(_french, 20451, "Has Google Updates"), _defineProperty(_french, 20461, "Verified"), _defineProperty(_french, 20471, "Location published"), _defineProperty(_french, 20481, "Has pending edits"), _defineProperty(_french, 20491, "Knowledge panel"), _defineProperty(_french, 20501, "Review Link"), _defineProperty(_french, 20511, "instructions"), _defineProperty(_french, 20521, "Duplicate"), _defineProperty(_french, 20531, "Active"), _defineProperty(_french, 20541, "Can update"), _defineProperty(_french, 20551, "Can delete"), _defineProperty(_french, 20561, "No pending review"), _defineProperty(_french, 20571, "Location enabled"), _defineProperty(_french, 20581, "Not disconnected"), _defineProperty(_french, 20591, "Change log"), _defineProperty(_french, 20601, "Bulk upload Image"), _defineProperty(_french, 20611, "Image History"), _defineProperty(_french, 20621, "Bulk upload Note"), _defineProperty(_french, 20631, "Bulk upload q&a"), _defineProperty(_french, 20641, "q&a history"), _defineProperty(_french, 20651, "Add a question"), _defineProperty(_french, 20661, "Present a question to customers that highlights a core value proposition or a distinct competitive advantage of your location. You can then answer the questions."), _defineProperty(_french, 20671, "Platform details"), _defineProperty(_french, 20681, "Auto reply variables"), _defineProperty(_french, 20691, "Nom de la localisation"), _defineProperty(_french, 20701, "Geo name"), _defineProperty(_french, 20711, "Signature"), _defineProperty(_french, 20721, "Geo name (max. 80 characters)"), _defineProperty(_french, 20731, "Signature name (max. 80 characters)"), _defineProperty(_french, 20741, "Réponse automatique"), _defineProperty(_french, 20751, "Télécharger les avis"), _defineProperty(_french, 20761, "Réponse automatique"), _defineProperty(_french, 20771, "External Link"), _defineProperty(_french, 20781, "Copy Review"), _defineProperty(_french, 20791, "Ajouter une note"), _defineProperty(_french, 20801, "External Note"), _defineProperty(_french, 20811, "Flag as inappropriate"), _defineProperty(_french, 20821, "Mark as removed"), _defineProperty(_french, 20831, "Are you sure ?"), _defineProperty(_french, 20841, "Would you like to mark this review as removed from Google?"), _defineProperty(_french, 20851, "Insérer des réponses enregistrées"), _defineProperty(_french, 20861, "Save as reply template"), _defineProperty(_french, 20871, "Insert auto reply template"), _defineProperty(_french, 20881, "Send"), _defineProperty(_french, 20891, "Envoyer pour approbation"), _defineProperty(_french, 20901, "Save as draft"), _defineProperty(_french, 20911, "Assign note"), _defineProperty(_french, 20921, "Email note"), _defineProperty(_french, 20931, "Recipient"), _defineProperty(_french, 20941, "Save as note"), _defineProperty(_french, 20951, "Close"), _defineProperty(_french, 20961, "Discard"), _defineProperty(_french, 20971, "Send mail"), _defineProperty(_french, 20981, "You don't have any saved Notes"), _defineProperty(_french, 20991, "All caught up!"), _defineProperty(_french, 21001, "No entries to show"), _defineProperty(_french, 21011, "Réponses envoyées"), _defineProperty(_french, 21021, "no comment added"), _defineProperty(_french, 21031, "Modifier la réponse"), _defineProperty(_french, 21041, "Delete reply"), _defineProperty(_french, 21051, "Search saved replies"), _defineProperty(_french, 21061, "Ajouter une réponse enregistrée"), _defineProperty(_french, 21071, "Choose a group and subject to save this reply."), _defineProperty(_french, 21081, "Sélectionnez un groupe ou commencez à taper pour en créer un"), _defineProperty(_french, 21091, "Entrez le titre ici"), _defineProperty(_french, 21101, "Entrez le modèle de réponse"), _defineProperty(_french, 21111, "Assurez-vous de sélectionner/créer un groupe et un titre pour enregistrer cette réponse."), _defineProperty(_french, 21121, "Auto Replies"), _defineProperty(_french, 21131, "Add auto reply"), _defineProperty(_french, 21141, "Sélectionnez un groupe"), _defineProperty(_french, 21151, "Enter variable here"), _defineProperty(_french, 21161, "Choose your variables"), _defineProperty(_french, 21171, "Do you want to continue?"), _defineProperty(_french, 21181, "This request contains more than 100 reviews For such requests, we will send you an email with a link to download the review csv."), _defineProperty(_french, 21191, "You have more than 100 reviews"), _defineProperty(_french, 21201, "We will send you an email (to X) with a link to download the review csv."), _defineProperty(_french, 21211, "actes"), _defineProperty(_french, 21221, "All Location"), _defineProperty(_french, 21231, "Avg Rating"), _defineProperty(_french, 21241, "Marque"), _defineProperty(_french, 21251, "Direct"), _defineProperty(_french, 21261, "Découverte"), _defineProperty(_french, 21271, "Geography"), _defineProperty(_french, 21281, "Happiness"), _defineProperty(_french, 21291, "Queries"), _defineProperty(_french, 21301, "Réponses"), _defineProperty(_french, 21311, "Des vues"), _defineProperty(_french, 21321, "Post Schedule"), _defineProperty(_french, 21331, "Google Post Schedule"), _defineProperty(_french, 21341, "Create Post"), _defineProperty(_french, 21351, "Manage Post"), _defineProperty(_french, 21361, "Schedule LocalPost"), _defineProperty(_french, 21371, "Upload"), _defineProperty(_french, 21381, "Progress"), _defineProperty(_french, 21391, "Validate & Schedule"), _defineProperty(_french, 21401, "Schedule Status"), _defineProperty(_french, 21411, "Select File"), _defineProperty(_french, 21421, "Select a schedule type"), _defineProperty(_french, 21431, "Immediate"), _defineProperty(_french, 21441, "File time"), _defineProperty(_french, 21451, "Sélectionner le temps"), _defineProperty(_french, 21461, "Post immediately after verification"), _defineProperty(_french, 21471, "Schedule based on the time in the file"), _defineProperty(_french, 21481, "Schedule file by your selected time"), _defineProperty(_french, 21491, "Queue"), _defineProperty(_french, 21501, "Validation is in progress. Processing time is approximately 40 posts per minute. After validation, each post's status will be available on the next page."), _defineProperty(_french, 21511, "Post processed"), _defineProperty(_french, 21521, "Successful validation"), _defineProperty(_french, 21531, "Failed validation"), _defineProperty(_french, 21541, "Scheduled"), _defineProperty(_french, 21551, "Type/Action"), _defineProperty(_french, 21561, "Dates"), _defineProperty(_french, 21571, "Start"), _defineProperty(_french, 21581, "End"), _defineProperty(_french, 21591, "Title/Product"), _defineProperty(_french, 21601, "Post Summary"), _defineProperty(_french, 21611, "Statut"), _defineProperty(_french, 21621, "Success"), _defineProperty(_french, 21631, "Échoué"), _defineProperty(_french, 21641, "Edit/Delete"), _defineProperty(_french, 21651, "Post Insights"), _defineProperty(_french, 21661, "Google Post Insights"), _defineProperty(_french, 21671, "Performance"), _defineProperty(_french, 21681, "Post views"), _defineProperty(_french, 21691, "Post by media"), _defineProperty(_french, 21701, "Post by topic"), _defineProperty(_french, 21711, "Post by action"), _defineProperty(_french, 21721, "Analysis"), _defineProperty(_french, 21731, "Created"), _defineProperty(_french, 21741, "Type"), _defineProperty(_french, 21751, "action"), _defineProperty(_french, 21761, "Source filter"), _defineProperty(_french, 21771, "Platform"), _defineProperty(_french, 21781, "Update localpost status"), _defineProperty(_french, 21791, "Campaign Builder"), _defineProperty(_french, 21801, "Intelligent Auto Response"), _defineProperty(_french, 21811, "Turn on auto response campaign builder"), _defineProperty(_french, 21821, "Before enabling the auto response schedule option, Please make sure to follow the instructions given below:"), _defineProperty(_french, 21831, "Before enabling Inteligent Auto response make sure to add your auto reply templates in ReviewInbox section.Build the responses first so that they can be assigned to the star ratings (1-5) that will trigger an Inteligent Auto Response."), _defineProperty(_french, 21841, "In the Campaign Builder please select a delay time between review receipt and auto response delivery. The delay setting should correspond to the ideal review response time, as it is intended to mask the automatic nature of the program."), _defineProperty(_french, 21851, "Please also consider setting the operation time (days of the week and hours of the day) for the campaign. The default timezone setting is GMT+00:00, so please update as appropriate."), _defineProperty(_french, 21861, "Créer une campagne"), _defineProperty(_french, 21871, "Assign a name and any notes to easily identify your campaign."), _defineProperty(_french, 21881, "Campaign Name"), _defineProperty(_french, 21891, "Campaign Responder"), _defineProperty(_french, 21901, "If no option is selected, email used to signup and authorize accounts will be the default respondent."), _defineProperty(_french, 21911, "Respondent for the auto reply"), _defineProperty(_french, 21921, "Campaign date range"), _defineProperty(_french, 21931, "Notes/Goals"), _defineProperty(_french, 21941, "Campaign description"), _defineProperty(_french, 21951, "Set Triggers"), _defineProperty(_french, 21961, "Choose the type of review(s) that will prompt an automated response for this campaign."), _defineProperty(_french, 21971, "with comment"), _defineProperty(_french, 21981, "without comment"), _defineProperty(_french, 21991, "previous"), _defineProperty(_french, 22001, "next"), _defineProperty(_french, 22011, "Set Audience (Optional)"), _defineProperty(_french, 22021, "Set the locations to be part of the campaign based on an Entity Tag, an Organization, or a specific Country/Area/Locality. These filters are available only for Google reviews and Mapped locations"), _defineProperty(_french, 22031, "entity"), _defineProperty(_french, 22041, "organization"), _defineProperty(_french, 22051, "Set Schedule"), _defineProperty(_french, 22061, "Assign the parameters and the schedule for reviews responses, i.e. the percentage of targeted reviews and the hours of operation operations for responses."), _defineProperty(_french, 22071, 'Please know that automatic responses are currently available only on a "go-forward" basis. We are working on separate processes for users who might wish to do a near-term clean up automatically.'), _defineProperty(_french, 22081, "Set response rate"), _defineProperty(_french, 22091, "set response count"), _defineProperty(_french, 22101, "delay before sending auto reply"), _defineProperty(_french, 22111, "schedule periodically"), _defineProperty(_french, 22121, "Select day and set time to schedule auto response periodically"), _defineProperty(_french, 22131, "Select timezone"), _defineProperty(_french, 22141, "Assign Responses"), _defineProperty(_french, 22151, "From the list, select which responses to use in rotation for this campaign."), _defineProperty(_french, 22161, "Confirm"), _defineProperty(_french, 22171, 'Review each of the details below and hit "confirm" to launch your campaign.'), _defineProperty(_french, 22181, "Days"), _defineProperty(_french, 22191, "Star"), _defineProperty(_french, 22201, "Moyenne"), _defineProperty(_french, 22211, "Reporting"), _defineProperty(_french, 22221, "Competitor Setup"), _defineProperty(_french, 22231, "Best Practices"), _defineProperty(_french, 22241, "Quadrant"), _defineProperty(_french, 22251, "Ratings"), _defineProperty(_french, 22261, "Competitive Ranking"), _defineProperty(_french, 22271, "Resp"), _defineProperty(_french, 22281, "View Review Sources"), _defineProperty(_french, 22291, "Add Competitor"), _defineProperty(_french, 22301, "Filtered by"), _defineProperty(_french, 22311, "Dégager"), _defineProperty(_french, 22321, "Competitor"), _defineProperty(_french, 22331, "CompEntity"), _defineProperty(_french, 22341, "Étiquette d'entité"), _defineProperty(_french, 22351, "Commentaires"), _defineProperty(_french, 22361, "No Options"), _defineProperty(_french, 22371, "Mauvais"), _defineProperty(_french, 22381, "Médiocre"), _defineProperty(_french, 22391, "Average"), _defineProperty(_french, 22401, "Très bon"), _defineProperty(_french, 22411, "Excellent"), _defineProperty(_french, 22421, "Reviews with Reply"), _defineProperty(_french, 22431, "Avis sans réponse"), _defineProperty(_french, 22441, "Avis avec commentaires"), _defineProperty(_french, 22451, "Avis sans commentaires"), _defineProperty(_french, 22461, "Review Volume vs Average Rating"), _defineProperty(_french, 22471, "Brands"), _defineProperty(_french, 22481, "Zoom"), _defineProperty(_french, 22491, "Total reviews"), _defineProperty(_french, 22501, "Review rating by star"), _defineProperty(_french, 22511, "Competitor Reviews"), _defineProperty(_french, 22521, "Competitor of"), _defineProperty(_french, 22531, "Code"), _defineProperty(_french, 22541, "Manage Competitors"), _defineProperty(_french, 22551, "Updated"), _defineProperty(_french, 22561, "Add Competitors"), _defineProperty(_french, 22571, "Add Location"), _defineProperty(_french, 22581, "Add competitors Name"), _defineProperty(_french, 22591, "The first step is to add the competitor's name, once you have added the names and optional icons (48x48 images) to the list, click on 'Add'. Once the Competitors are created, you will be able to assign the individual locations"), _defineProperty(_french, 22601, "Enter competitor Name (required)"), _defineProperty(_french, 22611, "Enter competitor URL (optional)"), _defineProperty(_french, 22621, "Upload image"), _defineProperty(_french, 22631, "Coming soon"), _defineProperty(_french, 22641, "Ratio Commentaire"), _defineProperty(_french, 22651, "Percent of reviews with and without comments"), _defineProperty(_french, 22661, "Without"), _defineProperty(_french, 22671, "With"), _defineProperty(_french, 22681, "Nombre de mots"), _defineProperty(_french, 22691, "Average number of words used in each comment by star rating"), _defineProperty(_french, 22701, "Mots"), _defineProperty(_french, 22711, "Taux de mots"), _defineProperty(_french, 22721, "Total and percentage of words in comments for each star rating"), _defineProperty(_french, 22731, "here."), _defineProperty(_french, 22741, "Concurrents"), _defineProperty(_french, 22751, "Ajouter une étiquette"), _defineProperty(_french, 22761, "Choisissez les variables à ajouter au modèle"), _defineProperty(_french, 22771, "fermer l'examen"), _defineProperty(_french, 22781, "Examen fermé"), _defineProperty(_french, 22791, "Voulez-vous fermer cet avis? Une fois que vous fermez, vous devrez le rouvrir pour répondre"), _defineProperty(_french, 22801, "Externe"), _defineProperty(_french, 22811, "Négatif"), _defineProperty(_french, 22821, "Non"), _defineProperty(_french, 22831, "Pas encore de réponse automatique!"), _defineProperty(_french, 22841, "Aucune réponse enregistrée pour le moment!"), _defineProperty(_french, 22851, "Noter"), _defineProperty(_french, 22861, "Fermé définitivement"), _defineProperty(_french, 22871, "Positif"), _defineProperty(_french, 22881, "Lecture expirée"), _defineProperty(_french, 22891, "Rétablir l'examen"), _defineProperty(_french, 22901, "Rouvrir l'examen"), _defineProperty(_french, 22911, "Répondu"), _defineProperty(_french, 22921, "Réponse envoyée (depuis l'interface Google)"), _defineProperty(_french, 22931, "Réponse envoyée depuis l'application"), _defineProperty(_french, 22941, "Avis supprimé"), _defineProperty(_french, 22951, "Modèles"), _defineProperty(_french, 22961, "Fermé temporairement"), _defineProperty(_french, 22971, "Oui"), _defineProperty(_french, 22981, "Vous n'avez aucun brouillon enregistré"), _defineProperty(_french, 22991, "Autorisations insuffisantes pour accéder à la ressource"), _defineProperty(_french, 23001, "Erreur interne rencontrée"), _defineProperty(_french, 23011, "La requête contient un argument non valide"), _defineProperty(_french, 23021, "L'entité demandée est introuvable"), _defineProperty(_french, 23031, "L'avis n'existe plus sur la plateforme Google"), _defineProperty(_french, 23041, "Certaines des valeurs d'insertion automatique ne sont pas disponibles. Veuillez remplacer et envoyer"), _defineProperty(_french, 23051, "Le service est actuellement indisponible"), _defineProperty(_french, 23061, "Cette opération n'est pas prise en charge pour les emplacements non revendiqués"), _defineProperty(_french, 23071, "Message publié"), _defineProperty(_french, 23081, "Post planifié"), _defineProperty(_french, 23091, "Nom familier"), _defineProperty(_french, 23101, "Add friendly name"), _defineProperty(_french, 23111, "Contact"), _defineProperty(_french, 23121, "No contacts!"), _defineProperty(_french, 23131, "To add contact"), _defineProperty(_french, 23141, "Nom du contact"), _defineProperty(_french, 23151, "Contact E-Mail"), _defineProperty(_french, 23161, "Ajouter le contact"), _defineProperty(_french, 23171, "Post Insights"), _defineProperty(_french, 23181, "Google Post Insights"), _defineProperty(_french, 23191, "Pas de données"), _defineProperty(_french, 23201, "Google Audit"), _defineProperty(_french, 23211, "Journaux d'audit"), _defineProperty(_french, 23221, "Sélectionnez un rapport"), _defineProperty(_french, 23231, "Select"), _defineProperty(_french, 23241, "All Download"), _defineProperty(_french, 23251, "No options"), _defineProperty(_french, 23261, "Téléchargements de données"), _defineProperty(_french, 23271, "Révision Télécharger"), _defineProperty(_french, 23291, "Télécharger la photo URL"), _defineProperty(_french, 23301, "URL de la photo client"), _defineProperty(_french, 23311, "URL de la photo marchand"), _defineProperty(_french, 23321, "Rapport Téléchargements Historique"), _defineProperty(_french, 23331, "Report Name"), _defineProperty(_french, 23341, "Envoyé à"), _defineProperty(_french, 23351, "Temps créé (UTC)"), _defineProperty(_french, 23361, "Type de rapport"), _defineProperty(_french, 23371, "Profile Details"), _defineProperty(_french, 23381, "Change Profile Name"), _defineProperty(_french, 23391, "Weekly sync"), _defineProperty(_french, 23401, "Enable Bulk Manage Location Tab"), _defineProperty(_french, 23411, "Date Format settings"), _defineProperty(_french, 23421, "Save"), _defineProperty(_french, 23431, "Happiness/NPS Setting"), _defineProperty(_french, 23441, "Promoter/Happy"), _defineProperty(_french, 23451, "Neutral"), _defineProperty(_french, 23461, "Detractor/Unhappy"), _defineProperty(_french, 23471, "Mettre à jour"), _defineProperty(_french, 23481, "Current Logos"), _defineProperty(_french, 23491, "Full Logo"), _defineProperty(_french, 23501, "Icon"), _defineProperty(_french, 23511, "Report Logo"), _defineProperty(_french, 23521, "Favicon"), _defineProperty(_french, 23531, "This logo will present on the top-left corner while expanded left navigation of your profile."), _defineProperty(_french, 23541, "This logo will present on the top-left corner of your profile."), _defineProperty(_french, 23551, "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results"), _defineProperty(_french, 23561, "This logo will present on the top-left corner of the browser tab."), _defineProperty(_french, 23571, "Replace logo"), _defineProperty(_french, 23581, "Choose which type logo you want to change using the dropdown options and upload logo."), _defineProperty(_french, 23591, "Upload Logo For"), _defineProperty(_french, 23601, "GBP Location Status Configuration: Suppression Settings"), _defineProperty(_french, 23611, "Suppress"), _defineProperty(_french, 23621, "Visible"), _defineProperty(_french, 23631, "Disconnected"), _defineProperty(_french, 23641, "Unverified"), _defineProperty(_french, 23651, "Suspended"), _defineProperty(_french, 23661, "Duplicate"), _defineProperty(_french, 23671, "First Party Review Upload"), _defineProperty(_french, 23681, "Télécharger"), _defineProperty(_french, 23691, "Clear"), _defineProperty(_french, 23701, "Manage Locations in Bulk"), _defineProperty(_french, 23711, "Contrôle de gestion en vrac"), _defineProperty(_french, 23721, "Mettez à jour les détails de la localisation et les paramètres de la plate-forme de contrôle directement dans les fiches Google."), _defineProperty(_french, 23731, "PLATFORM"), _defineProperty(_french, 23741, "Gérer facilement des comptes de n'importe quelle échelle avec des variables et des paramètres de localisation personnalisés."), _defineProperty(_french, 23751, "Détails GBP"), _defineProperty(_french, 23761, "Voir toutes les annonces Google Mes Business et Ajouter / Modifier / Edition / Supprimer les détails de la localisation."), _defineProperty(_french, 23771, "Attributs GBP"), _defineProperty(_french, 23781, "Attribuez tous les attributs éligibles à chaque emplacement pour obtenir une découverte de recherche incrémentielle."), _defineProperty(_french, 23791, "Liste GBP"), _defineProperty(_french, 23801, "Créer une nouvelle liste GBP."), _defineProperty(_french, 23811, "Facebook"), _defineProperty(_french, 23821, "Contrôle de la liste Facebook"), _defineProperty(_french, 23831, "Histoire"), _defineProperty(_french, 23841, "ENTRAÎNEMENT"), _defineProperty(_french, 23851, "Ressources d'accès pour les flux de travail, meilleures pratiques, limitations et mises à jour."), _defineProperty(_french, 23861, "ATTENTION"), _defineProperty(_french, 23871, "Exigence"), _defineProperty(_french, 23881, "Les utilisateurs doivent avoir un compte Google afin que le système puisse présenter une feuille Google avec les données de profil."), _defineProperty(_french, 23891, "Avis:"), _defineProperty(_french, 23901, "Les données remplissent chaque feuille si de la base de données système. Si vous souhaitez vous assurer que la feuille de calcul présente des données Google actuelles, nous vous recommandons vivement de synchroniser votre profil."), _defineProperty(_french, 23911, 'En fonction du nombre d\'emplacements de votre compte, les fiches Google peuvent prendre le temps de construire, puis de rafraîchir à mesure que vous naviguez dans la feuille. Veuillez vous assurer que toutes les données sont stables avant de pousser "Mettre à jour" pour enregistrer les modifications au système et appuyer les mises à jour sur Google.'), _defineProperty(_french, 23921, "La plate-forme a une connexion API directe à Google, mais il peut toujours y avoir des moments où Google retarde la mise à jour directe de la page d'inscription de lieu public."), _defineProperty(_french, 23931, "Pousser \"Mettre à jour\" déclenche un système direct directement sur Google. Il n'y a pas de processus d'annulation ou de retournement disponible. Veuillez vous assurer que vous êtes à l'aise avec toutes les modifications avant de déclencher la mise à jour. Si une erreur est faite, veuillez patienter quelques minutes, puis apporter le changement nécessaire."), _defineProperty(_french, 23941, "SCHÉMA DE COULEUR"), _defineProperty(_french, 23951, "Chaque feuille a un jeu de couleurs par défaut pour aider les utilisateurs à comprendre quels champs sont admissibles à la modification."), _defineProperty(_french, 23961, "Variables qui transmettent des détails sur l'état de Google ou ne peuvent pas être modifiés directement via des commandes en vrac."), _defineProperty(_french, 23971, "Google Variables directement ouverte pour la modification en vrac."), _defineProperty(_french, 23981, "Variables de plate-forme directement ouvertes pour la modification en vrac."), _defineProperty(_french, 23991, "Contrôler"), _defineProperty(_french, 24001, "Des détails"), _defineProperty(_french, 24011, "Les attributs"), _defineProperty(_french, 24021, "Créer une liste"), _defineProperty(_french, 24031, "Instructions"), _defineProperty(_french, 24041, "Expired on"), _defineProperty(_french, 24051, "Time to subscribe !"), _defineProperty(_french, 24061, "This profile will expire on"), _defineProperty(_french, 24071, "To keep accessing this profile, please subscribe."), _defineProperty(_french, 24081, "Take me there!"), _defineProperty(_french, 24091, "Later"), _defineProperty(_french, 24101, "Billing"), _defineProperty(_french, 24111, "Plan details"), _defineProperty(_french, 24121, "Plus"), _defineProperty(_french, 24131, "Pro"), _defineProperty(_french, 24141, "/PER LOCATIONS"), _defineProperty(_french, 24151, "$8/PER LOCATIONS"), _defineProperty(_french, 24161, "First 10 Locations"), _defineProperty(_french, 24171, "$24/month minimum"), _defineProperty(_french, 24181, "Try Free for 14 Days"), _defineProperty(_french, 24191, "All Integrations Included"), _defineProperty(_french, 24201, "Full Reviews Inbox"), _defineProperty(_french, 24211, "Full Roles Access"), _defineProperty(_french, 24221, "Full Reporting Suite"), _defineProperty(_french, 24231, "Unlimited Users"), _defineProperty(_french, 24241, "30 Pre-installed Review Responses"), _defineProperty(_french, 24251, "Full Support"), _defineProperty(_french, 24261, "Locations 11-200"), _defineProperty(_french, 24271, "All Features of Plus Plan"), _defineProperty(_french, 24281, "Full GBP Management"), _defineProperty(_french, 24291, "Bulk/Schedule Google Posts"), _defineProperty(_french, 24301, "Real-time Notifications"), _defineProperty(_french, 24311, "Custom Report Set-Up"), _defineProperty(_french, 24321, "Local Search Optimization"), _defineProperty(_french, 24331, "Personalized Onboarding"), _defineProperty(_french, 24341, "Profanity & Fraudulent Review Audit"), _defineProperty(_french, 24351, "Activité"), _defineProperty(_french, 24361, "Autorisé"), _defineProperty(_french, 24371, "Connections autorisées Accédez à la révision complète et aux capacités de réponse de / à chaque source."), _defineProperty(_french, 24381, "Bulk Upload Groups"), _defineProperty(_french, 24391, "Bulk Télécharger des détails GBP"), _defineProperty(_french, 24401, "Choose a group and subject to save the auto reply."), _defineProperty(_french, 24411, "Count"), _defineProperty(_french, 24421, "Créer une étiquette d'entité"), _defineProperty(_french, 24431, "Create Time (UTC)"), _defineProperty(_french, 24441, "Custom Sidebar Tabs"), _defineProperty(_french, 24451, "Custom Sidebar Tools"), _defineProperty(_french, 24461, "Download GBP Audit"), _defineProperty(_french, 24471, "File Name"), _defineProperty(_french, 24481, "Historique des détails GBP"), _defineProperty(_french, 24491, "Impressions"), _defineProperty(_french, 24501, "Inactif"), _defineProperty(_french, 24511, "Indexé"), _defineProperty(_french, 24521, "Les connexions indexées accèdent à toutes les critiques historiques et actuelles de chaque source."), _defineProperty(_french, 24531, "Manage LocalPost"), _defineProperty(_french, 24541, "Aucun commentaire ajouté"), _defineProperty(_french, 24551, "Nombre"), _defineProperty(_french, 24561, 'Please click on "New Report" Button,on the top Right'), _defineProperty(_french, 24571, "Profile Created"), _defineProperty(_french, 24581, "Request Id"), _defineProperty(_french, 24591, "Enregistrer une réponse"), _defineProperty(_french, 24601, "Emplacement total"), _defineProperty(_french, 24611, "Total Post"), _defineProperty(_french, 24621, "Upload AR Template"), _defineProperty(_french, 24631, "Télécharger des alias d'emplacement"), _defineProperty(_french, 24641, "Vue"), _defineProperty(_french, 24651, "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally."), _defineProperty(_french, 24661, "GBP DETAILS"), _defineProperty(_french, 24671, "GBP ATTRIBUTES"), _defineProperty(_french, 24681, "GBP LISTING"), _defineProperty(_french, 24691, "FACEBOOK"), _defineProperty(_french, 24701, "HISTORY"), _defineProperty(_french, 24711, "TRAINING"), _defineProperty(_french, 24721, "Weekly sync triggered on"), _defineProperty(_french, 24731, "MMM D,YYY"), _defineProperty(_french, 24741, "Eg:-Oct 13,2020"), _defineProperty(_french, 24751, "MM/DD/YYYY"), _defineProperty(_french, 24761, "MMMM D,YYYY"), _defineProperty(_french, 24771, "Eg:-October 13,2020"), _defineProperty(_french, 24781, "DD/MM/YYYY"), _defineProperty(_french, 24791, "DD MMM YYYY"), _defineProperty(_french, 24801, "DD MMMM YYYY"), _defineProperty(_french, 24811, "Eg:- 13 October 2020"), _defineProperty(_french, 24821, "Upload New Logo"), _defineProperty(_french, 24831, "Détaché"), _defineProperty(_french, 24841, "Visible Hidden"), _defineProperty(_french, 24851, "Review Details Pane Configuration"), _defineProperty(_french, 24861, "Show Store code"), _defineProperty(_french, 24871, "Show Full Address"), _defineProperty(_french, 24881, "Show Summary Widget"), _defineProperty(_french, 24891, "Inverted Header"), _defineProperty(_french, 24901, "Choose File"), _defineProperty(_french, 24911, "No file chosen"), _defineProperty(_french, 24921, "Afficher un journal de chaque mise à jour Appuyez sur pour confirmer la liste Contenu Modifier et repérer les erreurs."), _defineProperty(_french, 24931, 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.'), _defineProperty(_french, 24941, "Resources for bulk edit workflows, best practices, limitations, and updates."), _defineProperty(_french, 24951, "Identifiant d'utilisateur"), _defineProperty(_french, 24961, "Do you want to delete?"), _defineProperty(_french, 24971, "Compte"), _defineProperty(_french, 24981, "N'a pas de mises à jour Google"), _defineProperty(_french, 24991, "Réviser non requis"), _defineProperty(_french, 25001, "No pending edits"), _defineProperty(_french, 25011, "Temps d'audit"), _defineProperty(_french, 25021, "Champ"), _defineProperty(_french, 25031, "Valeur (à)"), _defineProperty(_french, 25041, "Valeur (de)"), _defineProperty(_french, 25051, "remove from entity tag"), _defineProperty(_french, 25061, "Attributeliste"), _defineProperty(_french, 25071, "adwords"), _defineProperty(_french, 25081, "View All"), _defineProperty(_french, 25091, "Q&A"), _defineProperty(_french, 25101, "Explorer"), _defineProperty(_french, 25111, "Explorer les réponses"), _defineProperty(_french, 25121, "Sélectionner un modèle"), _defineProperty(_french, 25131, "Continuer"), _defineProperty(_french, 25141, "Choisissez Star Note, Nom du modèle et Ajouter un contenu de modèle pour enregistrer la réponse automatique."), _defineProperty(_french, 25151, "Sélectionnez le type de réponse"), _defineProperty(_french, 25161, "Modèle"), _defineProperty(_french, 25171, "Fragment"), _defineProperty(_french, 25181, "Attribuer à la note (obligatoire)"), _defineProperty(_french, 25191, "Entrez le nom du modèle (obligatoire)"), _defineProperty(_french, 25201, "Variable de modèle personnalisé (facultatif)"), _defineProperty(_french, 25211, "Sélectionner ou créer une rubrique (facultatif)"), _defineProperty(_french, 25221, "Attribuer à un seul emplacement (facultatif)"), _defineProperty(_french, 25231, "Attribuer à l'étiquette d'entité (facultatif)"), _defineProperty(_french, 25241, "Add Topic name and snippet content to save the auto reply."), _defineProperty(_french, 25251, "Total # items"), _defineProperty(_french, 25261, "Note de localisation"), _defineProperty(_french, 25271, "View Location Details"), _defineProperty(_french, 25281, "View Google Knowledge Pannel"), _defineProperty(_french, 25291, "Voir l'avis directement sur Google"), _defineProperty(_french, 25301, "Positive-5 Stars"), _defineProperty(_french, 25311, "Negative - 1/2 Stars"), _defineProperty(_french, 25321, "Mixed - 3/4 Stars"), _defineProperty(_french, 25331, "Nom de modèle"), _defineProperty(_french, 25341, "Variable"), _defineProperty(_french, 25351, "Sélectionnez ou créez un sujet"), _defineProperty(_french, 25361, "Grouper"), _defineProperty(_french, 25371, "Sujet"), _defineProperty(_french, 25381, "Commentaires antérieurs"), _defineProperty(_french, 25391, "Enregistrer en réponse"), _defineProperty(_french, 25401, "Cc"), _defineProperty(_french, 25411, "Reset"), _defineProperty(_french, 25421, "WHAT'S NEW"), _defineProperty(_french, 25431, "créer un rendez-vous"), _defineProperty(_french, 25441, "Nom du filtre personnalisé"), _defineProperty(_french, 25451, "READ ONLY"), _defineProperty(_french, 25461, "Feature Access"), _defineProperty(_french, 25471, "None"), _defineProperty(_french, 25481, "READ"), _defineProperty(_french, 25491, "Unrestricted"), _defineProperty(_french, 25501, "This is a default role and cannot be edited/deleted"), _defineProperty(_french, 25511, "Read"), _defineProperty(_french, 25521, "Write"), _defineProperty(_french, 25531, "Télécharger"), _defineProperty(_french, 25541, "All users assigned to this role will have visibilty/access to the following features"), _defineProperty(_french, 25551, "Settings Subtab Visibility"), _defineProperty(_french, 25561, "Manage Roles"), _defineProperty(_french, 25571, "Custom Sidebar"), _defineProperty(_french, 25581, "OR"), _defineProperty(_french, 25591, "Save role attributes"), _defineProperty(_french, 25601, "Are you sure you want to delete the role"), _defineProperty(_french, 25611, "This will change the role of all users currently assigned to this role to READ ONLY."), _defineProperty(_french, 25621, "Assign Users"), _defineProperty(_french, 25631, "Users in profile"), _defineProperty(_french, 25641, "Search here"), _defineProperty(_french, 25651, "Users assigned to this role"), _defineProperty(_french, 25661, "NO USER"), _defineProperty(_french, 25671, "Re-invite"), _defineProperty(_french, 25681, "Page d'atterrissage par défaut"), _defineProperty(_french, 25691, "Avis de boîte de réception"), _defineProperty(_french, 25701, "Gestion en vrac"), _defineProperty(_french, 25711, "Planification postale"), _defineProperty(_french, 25721, "ON"), _defineProperty(_french, 25731, "OFF"), _defineProperty(_french, 25741, "Are you sure turn off Campaign?"), _defineProperty(_french, 25751, "Are you sure turn of Campaign?"), _defineProperty(_french, 25761, "Succesfully updated the campaign"), _defineProperty(_french, 25771, "Taux de réponse"), _defineProperty(_french, 25781, "Nombre de réponses"), _defineProperty(_french, 25791, "Évaluations d'étoiles"), _defineProperty(_french, 25801, "Avec"), _defineProperty(_french, 25811, "Sans"), _defineProperty(_french, 25821, "Retard"), _defineProperty(_french, 25831, "Fuseau horaire"), _defineProperty(_french, 25841, "Revoir"), _defineProperty(_french, 25851, "Competitor Report"), _defineProperty(_french, 25861, "Format"), _defineProperty(_french, 25871, "HTML Email"), _defineProperty(_french, 25881, "Excel"), _defineProperty(_french, 25891, "S'il n'y a pas d'avis dans la plage sélectionnée"), _defineProperty(_french, 25901, "N'envoyez pas d'email"), _defineProperty(_french, 25911, "Envoyer un email"), _defineProperty(_french, 25921, "Q&A"), _defineProperty(_french, 25931, "If there are no Q&A in selected range"), _defineProperty(_french, 25941, "Customer Image"), _defineProperty(_french, 25951, "Audit Log"), _defineProperty(_french, 25961, "Veuillez contacter Support avec toutes les questions concernant le profil Sync Cadence"), _defineProperty(_french, 25971, "Include Audit File"), _defineProperty(_french, 25981, "Profil"), _defineProperty(_french, 25991, "CompTag"), _defineProperty(_french, 26001, "Révision des détails"), _defineProperty(_french, 26011, "Manage Tier Controls"), _defineProperty(_french, 26021, "Override the default functionality,organized into Tiers"), _defineProperty(_french, 26031, "Build Offer Tier"), _defineProperty(_french, 26041, "Create New Tier"), _defineProperty(_french, 26051, "Tier Name"), _defineProperty(_french, 26061, "DEFAULT"), _defineProperty(_french, 26071, "Default"), _defineProperty(_french, 26081, "Reputation Dashboard"), _defineProperty(_french, 26091, "Comprehensive insightsinto all review KPIs"), _defineProperty(_french, 26101, "Full visibility across all locations and sources"), _defineProperty(_french, 26111, "Sections"), _defineProperty(_french, 26121, "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio."), _defineProperty(_french, 26131, "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram."), _defineProperty(_french, 26141, "Comment ratio, comment length and cumulative word ratio by rating."), _defineProperty(_french, 26151, "Reviews by day of week, day of month, and month of year."), _defineProperty(_french, 26161, "Top five countries, states/provinces, and cities by review volume."), _defineProperty(_french, 26171, "All historic data is compiled during initial account set up and then updated from all connected review sources daily."), _defineProperty(_french, 26181, "GBP Insights"), _defineProperty(_french, 26191, "Direct, Discover, and Brand daily search volume area chart."), _defineProperty(_french, 26201, "Maps and Search daily views area chart."), _defineProperty(_french, 26211, "Actions des clients - Demande d'itinéraire, Appels téléphoniques, Clic sur le site web."), _defineProperty(_french, 26221, "Location actions by day of week column charts."), _defineProperty(_french, 26231, "Unique Local Conversion Ration (actions / daily searches)."), _defineProperty(_french, 26241, "Brand photo average quantity hosted to GBP location and total views"), _defineProperty(_french, 26251, "Customer uploaded photo average quantity hosted to GBP location and total views."), _defineProperty(_french, 26261, "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay."), _defineProperty(_french, 26271, "Local search exposure and action reporting."), _defineProperty(_french, 26281, "LocalPerformance"), _defineProperty(_french, 26291, "Easily compare performance across locations"), _defineProperty(_french, 26301, "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions"), _defineProperty(_french, 26311, "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting."), _defineProperty(_french, 26321, "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger."), _defineProperty(_french, 26331, "Reviews and GBP Insights table and charts by individual location."), _defineProperty(_french, 26341, "ReviewsInbox"), _defineProperty(_french, 26351, "Aggregate inbox for all locations and sources - filter, search, respond, and manage."), _defineProperty(_french, 26361, "Manage all reviews from all sources"), _defineProperty(_french, 26371, "Workflows"), _defineProperty(_french, 26381, "Search and filter to find reviews by rating, source, content, reviewer, tags or location."), _defineProperty(_french, 26391, "Respond to authorized review sources directly from platform."), _defineProperty(_french, 26401, "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed."), _defineProperty(_french, 26411, "Create workflows for controlled response approvals."), _defineProperty(_french, 26421, "Send notes or cc’ replies directly to location management."), _defineProperty(_french, 26431, "Full Control"), _defineProperty(_french, 26441, "Manage Location Listings"), _defineProperty(_french, 26451, "Direct API add/edit/delete control of all location listings details across accounts."), _defineProperty(_french, 26461, "Streamline control of any number of listings."), _defineProperty(_french, 26471, "Search and filter across any number of locations and connected accounts by status and content."), _defineProperty(_french, 26481, "Directly edit GBP details by individual location."), _defineProperty(_french, 26491, "Create individual GBP Posts for all eligible locations."), _defineProperty(_french, 26501, "Organize locations into an number of unique customer groups via entity tags."), _defineProperty(_french, 26511, "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles."), _defineProperty(_french, 26521, "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more."), _defineProperty(_french, 26531, "Bulk add new Google Questions & Answers to each location’s knowledge panel."), _defineProperty(_french, 26541, "Bulk add/edit platform content such as location notes, local managers and more."), _defineProperty(_french, 26551, "Competitor Review Tracking"), _defineProperty(_french, 26561, "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant."), _defineProperty(_french, 26571, "Gain unparalleled insights into competitor feedback"), _defineProperty(_french, 26581, "Competitor review reporting dashboard, filterable to identify exact comparisons."), _defineProperty(_french, 26591, "Rating distribution comparison across competitor brands."), _defineProperty(_french, 26601, "Wave chart of review volume versus average rating, comparing brands or individual locations,"), _defineProperty(_french, 26611, "Full review comment detail and even the competitor’s responses."), _defineProperty(_french, 26621, "Section is officially still in beta status as we continue to add more reporting and presentation options."), _defineProperty(_french, 26631, "Bulk Management"), _defineProperty(_french, 26641, "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet."), _defineProperty(_french, 26651, "The fastest and easiest way to control accounts of any size."), _defineProperty(_french, 26661, "Platform - Bulk assignment and updates of the key variables to manage the platform."), _defineProperty(_french, 26671, "Details - Primary section for all Google Business Profile details."), _defineProperty(_french, 26681, "Attributes - Optimize the assignment of attributes across GBP listings"), _defineProperty(_french, 26691, "Create Listings - Build new GBP listings will all the critical content"), _defineProperty(_french, 26701, "Facebook - Control all Facebook details from a single spreadsheet"), _defineProperty(_french, 26711, "History - Log of file edits and updates."), _defineProperty(_french, 26721, "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms."), _defineProperty(_french, 26731, "Post Scheduling"), _defineProperty(_french, 26741, "Bulk creation and scheduling for Google Posts across locations and account."), _defineProperty(_french, 26751, "Share critical updates and promotional messages"), _defineProperty(_french, 26761, "Download template to create Google Posts for all eligible locations."), _defineProperty(_french, 26771, "Schedule timing for the entire file or set each post to start at a unique day and time"), _defineProperty(_french, 26781, "Plan an entire promotional calendar"), _defineProperty(_french, 26791, "Post Insights Reporting"), _defineProperty(_french, 26801, "View Google Post views and click performance over time - filters reporting by type, media, and call to action."), _defineProperty(_french, 26811, "Identify performance trends to optimize free advertising"), _defineProperty(_french, 26821, "Bar chart represent performance over time, set date range and chart granularity."), _defineProperty(_french, 26831, "View post volume by media, topic, and call to action type."), _defineProperty(_french, 26841, "View each posts individual performance metrics."), _defineProperty(_french, 26851, "Report download allows for further analysis by campaign."), _defineProperty(_french, 26861, "Settings"), _defineProperty(_french, 26871, "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads"), _defineProperty(_french, 26881, "Enterprise-grade controls to set a customized experience for all users."), _defineProperty(_french, 26891, "Primary Admin Sections"), _defineProperty(_french, 26901, "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking)."), _defineProperty(_french, 26911, "Set integrations to available review sources."), _defineProperty(_french, 26921, "Manage/Create distinct user roles."), _defineProperty(_french, 26931, "Assign/Control individual access."), _defineProperty(_french, 26941, "Schedule reporting by type, user, and even location."), _defineProperty(_french, 26951, "Download data sets from the platform, access the 10 most recent requests."), _defineProperty(_french, 26961, "Authorize Account"), _defineProperty(_french, 26971, "Google Audit"), _defineProperty(_french, 26981, "Integrations"), _defineProperty(_french, 26991, "Manager Role"), _defineProperty(_french, 27001, "Manage Users"), _defineProperty(_french, 27011, "Review Settings"), _defineProperty(_french, 27021, "Campagin Builder"), _defineProperty(_french, 27031, "Report Management"), _defineProperty(_french, 27041, "Data Downloads"), _defineProperty(_french, 27051, "Profile Details"), _defineProperty(_french, 27061, "Custom Navigation"), _defineProperty(_french, 27071, "Review Clarity"), _defineProperty(_french, 27081, "Claim Location"), _defineProperty(_french, 27091, "Authorized Sources"), _defineProperty(_french, 27101, "Required for full data access and direct review responses."), _defineProperty(_french, 27111, "Options"), _defineProperty(_french, 27121, "Authorized connections will continue to grow as platforms make the API connections available."), _defineProperty(_french, 27131, "Directly authorize the connection between the platform and user accounts to gain the created possible control."), _defineProperty(_french, 27141, "All Sources"), _defineProperty(_french, 27151, "Indexed Review Sources"), _defineProperty(_french, 27161, "Aggregate feedback from 40+ sources across industry verticals"), _defineProperty(_french, 27171, "Notes"), _defineProperty(_french, 27181, "Use Google indexing to access reviews without control of the GBP listing."), _defineProperty(_french, 27191, "Indexed sourcing is used for all competitive review collection."), _defineProperty(_french, 27201, "After initial index, reviews and responses are collected daily"), _defineProperty(_french, 27211, "Public indexing or all historic reviews and responses by URL or PlaceID"), _defineProperty(_french, 27221, "All Sources"), _defineProperty(_french, 27231, "Configure"), _defineProperty(_french, 27241, "Yesterday"), _defineProperty(_french, 27251, "Last 7 days"), _defineProperty(_french, 27261, "Last week"), _defineProperty(_french, 27271, "Last 30 days"), _defineProperty(_french, 27281, "Last month"), _defineProperty(_french, 27291, "Tout le temps"), _defineProperty(_french, 27301, "Asc"), _defineProperty(_french, 27311, "Desc"), _defineProperty(_french, 27321, "No contact for cc"), _defineProperty(_french, 27331, "Sauvegarder cette réponse"), _defineProperty(_french, 27341, "Select or create a group"), _defineProperty(_french, 27351, "Pas de réponses enregistrées"), _defineProperty(_french, 27361, "No auto replies"), _defineProperty(_french, 27371, "Total 0 items"), _defineProperty(_french, 27381, "Saved Templates"), _defineProperty(_french, 27391, "Total 26 items"), _defineProperty(_french, 27401, "Recently Used"), _defineProperty(_french, 27411, "Smileys & People"), _defineProperty(_french, 27421, "Has comments"), _defineProperty(_french, 27431, "No comments"), _defineProperty(_french, 27441, "Tous les endroits"), _defineProperty(_french, 27451, "Ouvert"), _defineProperty(_french, 27461, "Google Updates"), _defineProperty(_french, 27471, "Missing Content"), _defineProperty(_french, 27481, "Code de magasin"), _defineProperty(_french, 27491, "Additional Categories"), _defineProperty(_french, 27501, "Emplacements de recherche"), _defineProperty(_french, 27511, "Audit GBP"), _defineProperty(_french, 27521, "Activité en vrac"), _defineProperty(_french, 27531, "Sélectionner un groupe"), _defineProperty(_french, 27541, "20/ page"), _defineProperty(_french, 27551, "Synchronisation"), _defineProperty(_french, 27561, "Régler le public"), _defineProperty(_french, 27571, "Terminé"), _defineProperty(_french, 27581, "Group Name"), _defineProperty(_french, 27591, "Minute"), _defineProperty(_french, 27601, "with & without Comment"), _defineProperty(_french, 27611, "Rate"), _defineProperty(_french, 27621, "Analyse du quadrant"), _defineProperty(_french, 27631, "Toutes les données sur les emplacements"), _defineProperty(_french, 27641, "Volume de Recherche Haut + Conversion Basse"), _defineProperty(_french, 27651, "Volume de Recherche Haut + Conversion Haute"), _defineProperty(_french, 27661, "Volume de Recherche Bas + Conversion Basse"), _defineProperty(_french, 27671, "Volume de Recherche Bas + Conversion Haute"), _defineProperty(_french, 27681, "Données par Régions"), _defineProperty(_french, 27691, "Données par Villes"), _defineProperty(_french, 27701, "Location:"), _defineProperty(_french, 27711, "Conversion Rate:"), _defineProperty(_french, 27721, "Searches:"), _defineProperty(_french, 27731, "Google Q&A"), _defineProperty(_french, 27741, "Google QA"), _defineProperty(_french, 27751, "Download QA"), _defineProperty(_french, 27761, "Post-réponse"), _defineProperty(_french, 27771, "Poster"), _defineProperty(_french, 27781, "Download the sample CSV"), _defineProperty(_french, 27791, "Pre populated CSV"), _defineProperty(_french, 27801, "Manage Portfolio"), _defineProperty(_french, 27811, "Add Portfolio"), _defineProperty(_french, 27821, "View Portfolio"), _defineProperty(_french, 27831, "Delete Portfolio"), _defineProperty(_french, 27841, "Utilisateurs"), _defineProperty(_french, 27851, "Manage Profiles"), _defineProperty(_french, 27861, "Remove Profile"), _defineProperty(_french, 27871, "Are you sure you want to Remove this profile ?"), _defineProperty(_french, 27881, "Accounts"), _defineProperty(_french, 27891, "Select Profiles"), _defineProperty(_french, 27901, "Select Profile"), _defineProperty(_french, 27911, "Portfolio Account"), _defineProperty(_french, 27921, "Portfolio Details"), _defineProperty(_french, 27931, "Portfolio Name"), _defineProperty(_french, 27941, "Currrent Portfolio Image"), _defineProperty(_french, 27951, "Upload image as a logo for portfolio"), _defineProperty(_french, 27961, "Change portfolio name"), _defineProperty(_french, 27971, "Free Trial"), _defineProperty(_french, 27981, "Current"), _defineProperty(_french, 27991, "Expired"), _defineProperty(_french, 28001, "Cancelled"), _defineProperty(_french, 28011, "Invoicing"), _defineProperty(_french, 28021, "Lié"), _defineProperty(_french, 28031, "Number of Accounts"), _defineProperty(_french, 28041, "Total Locations"), _defineProperty(_french, 28051, "Active Locations"), _defineProperty(_french, 28061, "Reviews (30 days)"), _defineProperty(_french, 28071, "Payment Status"), _defineProperty(_french, 28081, "Profile Name"), _defineProperty(_french, 28091, "Enter name of new portfolio"), _defineProperty(_french, 28101, "A portfolio can bulk manage their users across different profiles easily"), _defineProperty(_french, 28111, "Name of new portfolio"), _defineProperty(_french, 28121, "Portfolio names can only have a maximum of 20 characters"), _defineProperty(_french, 28131, "Portfolio Created Successfully!"), _defineProperty(_french, 28141, "Total Profile"), _defineProperty(_french, 28151, "Total Users"), _defineProperty(_french, 28161, "Enter email"), _defineProperty(_french, 28171, "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role."), _defineProperty(_french, 28181, "Invite"), _defineProperty(_french, 28191, "Current Portfolio Image"), _defineProperty(_french, 28201, "Sentiment"), _defineProperty(_french, 28211, "Awaiting"), _defineProperty(_french, 28221, "Plus de filtres"), _defineProperty(_french, 28231, "Review Tag"), _defineProperty(_french, 28241, "Filtres enregistrés"), _defineProperty(_french, 28251, "Moins de filtres"), _defineProperty(_french, 28261, "No Text"), _defineProperty(_french, 28271, "Medium"), _defineProperty(_french, 28281, "Expand"), _defineProperty(_french, 28291, "Single image upload"), _defineProperty(_french, 28301, "Select Image Type"), _defineProperty(_french, 28311, "Select Type"), _defineProperty(_french, 28321, "Cover Photo"), _defineProperty(_french, 28331, "Profile Photo"), _defineProperty(_french, 28341, "Exterior Photo"), _defineProperty(_french, 28351, "Interior Photo"), _defineProperty(_french, 28361, "Product photo"), _defineProperty(_french, 28371, "Work Photo"), _defineProperty(_french, 28381, "Logo Photo"), _defineProperty(_french, 28391, "Food and Drink Photo"), _defineProperty(_french, 28401, "Menu Photo"), _defineProperty(_french, 28411, "Common Area Photo"), _defineProperty(_french, 28421, "Rooms Photo"), _defineProperty(_french, 28431, "Teams Photo"), _defineProperty(_french, 28441, "Views"), _defineProperty(_french, 28451, "Photo"), _defineProperty(_french, 28461, "Ouvert"), _defineProperty(_french, 28471, "Fermé"), _defineProperty(_french, 28481, "Supprimé"), _defineProperty(_french, 28491, "New Review Tag"), _defineProperty(_french, 28501, "Tous les avis"), _defineProperty(_french, 28511, "Rien à afficher dans cette gamme!"), _defineProperty(_french, 28521, "Chercher"), _defineProperty(_french, 28531, "Tout sélectionner"), _defineProperty(_french, 28541, "source de recherche"), _defineProperty(_french, 28551, "Recherche de tag d'examen"), _defineProperty(_french, 28561, "Rechercher Lieu"), _defineProperty(_french, 28571, "Recherchez StoreCode"), _defineProperty(_french, 28581, "Rechercher un groupe"), _defineProperty(_french, 28591, "organisations"), _defineProperty(_french, 28601, "Entité Mots clés"), _defineProperty(_french, 28611, "Appliquer"), _defineProperty(_french, 28621, "Grouper"), _defineProperty(_french, 28631, "Filtres de recherche sauvegardées"), _defineProperty(_french, 28641, "Pas d'options!"), _defineProperty(_french, 28651, "Ajuster vue Texte de l'avis"), _defineProperty(_french, 28661, "Voir la revue directement sur"), _defineProperty(_french, 28671, "Réponse sur la plate-forme d'examen"), _defineProperty(_french, 28681, "Sélectionner un modèle"), _defineProperty(_french, 28691, "Copie"), _defineProperty(_french, 28701, "Les avis antérieurs"), _defineProperty(_french, 28711, "Aucun avis"), _defineProperty(_french, 28721, "Évaluation"), _defineProperty(_french, 28731, "Répondre Nom Lieu non ajouté à cet endroit"), _defineProperty(_french, 28741, "Signature non ajouté à cet endroit"), _defineProperty(_french, 28751, "Voulez-vous continuer à télécharger?"), _defineProperty(_french, 28761, "Avis sans réponse"), _defineProperty(_french, 28771, "Avis avec Répondre interne"), _defineProperty(_french, 28781, "Avis avec réponse automatique"), _defineProperty(_french, 28791, "Avis avec externe Répondre"), _defineProperty(_french, 28801, "Voir Google Panel des connaissances"), _defineProperty(_french, 28811, "Lieu Remarque"), _defineProperty(_french, 28821, "nouveau directeur"), _defineProperty(_french, 28831, "activer Cc"), _defineProperty(_french, 28841, "Enregistrer sous Répondre"), _defineProperty(_french, 28851, "Supprimer"), _defineProperty(_french, 28861, "Grouper"), _defineProperty(_french, 28871, "Mixte"), _defineProperty(_french, 28881, "Étoiles"), _defineProperty(_french, 28891, "Négative, Métis, positif"), _defineProperty(_french, 28901, "Évaluation"), _defineProperty(_french, 28911, "Nom du modèle"), _defineProperty(_french, 28921, "Variable"), _defineProperty(_french, 28931, "Enregistrer un commentaire"), _defineProperty(_french, 28941, "Modifier le nom du compte"), _defineProperty(_french, 28951, "Changer le nom du compte"), _defineProperty(_french, 28961, "Nom du compte"), _defineProperty(_french, 28971, "Emplacements Facebook"), _defineProperty(_french, 28981, "Ajouter une page"), _defineProperty(_french, 28991, "Activé"), _defineProperty(_french, 29001, "Montrer l'emplacement caché"), _defineProperty(_french, 29011, "Voir la page FB"), _defineProperty(_french, 29021, "Aucun compte caché à montrer"), _defineProperty(_french, 29031, "Il y a des heures"), _defineProperty(_french, 29041, "Inviter"), _defineProperty(_french, 29051, "Vu la vitrine"), _defineProperty(_french, 29061, "Emplacements Google"), _defineProperty(_french, 29071, "Vos endroits"), _defineProperty(_french, 29081, "URL de l'emplacement"), _defineProperty(_french, 29091, "Êtes-vous sûr de vouloir supprimer cette URL?"), _defineProperty(_french, 29101, "Souhaitez-vous supprimer l'URL et ses données connexes de l'application?"), _defineProperty(_french, 29111, "Emplacements concurrents"), _defineProperty(_french, 29121, "Nom du concurrent"), _defineProperty(_french, 29131, "Endroit"), _defineProperty(_french, 29141, "Comptag"), _defineProperty(_french, 29151, "Entrez les URL de localisation et les détails du concurrent"), _defineProperty(_french, 29161, "Iscompétor"), _defineProperty(_french, 29171, "Emplacements de réservation"), _defineProperty(_french, 29181, "Initier une intégration de révision de la réservation"), _defineProperty(_french, 29191, "ID d'emplacement de back bureau (facultatif)"), _defineProperty(_french, 29201, "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to"), _defineProperty(_french, 29211, "To download the sample file click"), _defineProperty(_french, 29221, "please note it may take several minutes to complete the initial fetch"), _defineProperty(_french, 29231, "Please provide a list of each"), _defineProperty(_french, 29241, "location URLs for businesses to"), _defineProperty(_french, 29251, "You can place them directly in the email or provide an Excel of Google Sheet Lists"), _defineProperty(_french, 29261, "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the"), _defineProperty(_french, 29271, "competitor details."), _defineProperty(_french, 29281, "Large accounts (20+ locations) can provide a list of each location as an Excel file to"), _defineProperty(_french, 29291, "Créez des campagnes pour répondre directement aux critiques avec la réponse parfaite au moment idéal"), _defineProperty(_french, 29301, "Êtes-vous sûr de vouloir supprimer cette campagne?"), _defineProperty(_french, 29311, "Copier des critiques intelligents à chaque responsable de localisation attribuée"), _defineProperty(_french, 29321, "CC répond aux gestionnaires de localisation assignés"), _defineProperty(_french, 29331, "CC répond à l'entreprise"), _defineProperty(_french, 29341, "Bénéficiaires"), _defineProperty(_french, 29351, "Tous les destinataires"), _defineProperty(_french, 29361, "Sélectionnez une critique Source"), _defineProperty(_french, 29371, "Pub / sous seulement"), _defineProperty(_french, 29381, "Sélectionnez Star Note"), _defineProperty(_french, 29391, "Sélectionnez Contenu de révision"), _defineProperty(_french, 29401, "Groupe personnalisé"), _defineProperty(_french, 29411, "Définir le délai avant d'envoyer une réponse automatique"), _defineProperty(_french, 29421, "Définir des heures d'opération"), _defineProperty(_french, 29431, "Optionnel"), _defineProperty(_french, 29441, "Aucun emplacement assigné"), _defineProperty(_french, 29451, "Il n'y avait aucune idée de la plage et des critères de date sélectionnés."), _defineProperty(_french, 29461, "Menu de filtre"), _defineProperty(_french, 29471, "Sorte"), _defineProperty(_french, 29481, "Vues à la recherche"), _defineProperty(_french, 29491, "Vues sur les cartes"), _defineProperty(_french, 29501, "Vous n'avez pas suffisamment d'autorisations pour poster une réponse."), _defineProperty(_french, 29511, "Déjà envoyé"), _defineProperty(_french, 29521, "Télécharger des modèles AR"), _defineProperty(_french, 29531, "Les adeptes comptent"), _defineProperty(_french, 29541, "Dernière synchronisation"), _defineProperty(_french, 29551, "D'entreprise"), _defineProperty(_french, 29561, "Agence"), _defineProperty(_french, 29571, "Localpost activé"), _defineProperty(_french, 29581, "Pas de vérification en attente"), _defineProperty(_french, 29591, "Cliquez pour voir cet avis dans la boîte de réception"), _defineProperty(_french, 29601, "Lire la suite"), _defineProperty(_french, 29611, "Chargement"), _defineProperty(_french, 29621, "Nombre total d'éléments"), _defineProperty(_french, 29631, "Google mon entreprise vérifiée"), _defineProperty(_french, 29641, "Marquer comme"), _defineProperty(_french, 29651, "Ajouter des heures"), _defineProperty(_french, 29661, "Aujourd'hui"), _defineProperty(_french, 29671, "Adresse de la rue"), _defineProperty(_french, 29681, "code postal"), _defineProperty(_french, 29691, "Identifie comme appartenant au noir"), _defineProperty(_french, 29701, "Ajouter l'URL"), _defineProperty(_french, 29711, "Poster"), _defineProperty(_french, 29721, "Email du contact"), _defineProperty(_french, 29731, "Covid_19 mise à jour"), _defineProperty(_french, 29741, "Changements dans votre entreprise?"), _defineProperty(_french, 29751, "Campagne"), _defineProperty(_french, 29761, "Commander en ligne"), _defineProperty(_french, 29771, "Acheter"), _defineProperty(_french, 29781, "Appelle maintenant"), _defineProperty(_french, 29791, "Maintenant"), _defineProperty(_french, 29801, "Synchroniser cet emplacement?"), _defineProperty(_french, 29811, "Liste Facebook"), _defineProperty(_french, 29821, "Créer une nouvelle liste Facebook"), _defineProperty(_french, 29831, "Choisi"), _defineProperty(_french, 29841, "Détails de l'entreprise"), _defineProperty(_french, 29851, "Contacts"), _defineProperty(_french, 29861, "Variables"), _defineProperty(_french, 29871, "ID interne"), _defineProperty(_french, 29881, "Cliquez pour vous connecter"), _defineProperty(_french, 29891, "Retour au téléchargement"), _defineProperty(_french, 29901, "Voir le Q & A sur Google"), _defineProperty(_french, 29911, "Exiger"), _defineProperty(_french, 29921, "Désactiver"), _defineProperty(_french, 29931, "Examiner la confirmation fermée"), _defineProperty(_french, 29941, "Vérifier la confirmation de réponse"), _defineProperty(_french, 29951, "Examiner la confirmation de suppression"), _defineProperty(_french, 29961, "Région"), _defineProperty(_french, 29971, "Réponse à cette question"), _defineProperty(_french, 29981, "Faire en sorte"), _defineProperty(_french, 29991, "Créer Google Post"), _defineProperty(_french, 30001, "Gérer Google Post"), _defineProperty(_french, 30011, "Masquer la position"), _defineProperty(_french, 30021, "Sélectionnez la page en cours"), _defineProperty(_french, 30031, "Créer Facebook Post"), _defineProperty(_french, 30041, "Gérer la poste Facebook"), _defineProperty(_french, 30051, "Tout effacer"), _defineProperty(_french, 30061, "Sauvegarder le filtre"), _defineProperty(_french, 30071, "Rôle de recherche"), _defineProperty(_french, 30081, "Recherche utilisateur"), _defineProperty(_french, 30091, "Tous les éditeurs"), _defineProperty(_french, 30101, "Attribuer à la note (obligatoire)"), _defineProperty(_french, 30111, "Entrez le nom du modèle (obligatoire)"), _defineProperty(_french, 30121, "Variable de modèle personnalisé (facultatif)"), _defineProperty(_french, 30131, "Sélectionner ou créer une rubrique (facultatif)"), _defineProperty(_french, 30141, "Attribuer à un seul emplacement (facultatif)"), _defineProperty(_french, 30151, "Attribuer à l'étiquette d'entité (facultatif)"), _defineProperty(_french, 30161, "Revoir les variables"), _defineProperty(_french, 30171, "Prénom du critique"), _defineProperty(_french, 30181, "Nom complet du critique"), _defineProperty(_french, 30191, "Variables de localisation"), _defineProperty(_french, 30201, "Répondre Nom de l'emplacement"), _defineProperty(_french, 30211, "Nom de lieu de Geo"), _defineProperty(_french, 30221, "Une réponse pour cet avis a déjà été envoyée."), _defineProperty(_french, 30231, "Les réponses pour cet avis ne peuvent plus être envoyées. Vous pouvez supprimer cette réponse pour la supprimer d'ici."), _defineProperty(_french, 30241, "Souhaitez-vous synchroniser les données de cet emplacement? Cela tirera dans toutes les mises à jour faites à l'emplacement."), _defineProperty(_french, 30251, "Laissez les clients connus de toute modification de votre entreprise en raison de Covid-19"), _defineProperty(_french, 30261, "Envoyer maintenant"), _defineProperty(_french, 30271, "Vitrine de recherche"), _defineProperty(_french, 30281, "Utilisez les commandes à droite pour construire la vitrine exacte. Cliquez sur le bouton 'Appliquer' pour charger l'aperçu instantané."), _defineProperty(_french, 30291, "Construire votre présentation de votre évaluation"), _defineProperty(_french, 30301, "Détails de la vitrine"), _defineProperty(_french, 30311, "Nommez cette vitrine"), _defineProperty(_french, 30321, "Emplacement individuel"), _defineProperty(_french, 30331, "Groupe de localisation"), _defineProperty(_french, 30341, "Titre de la vitrine"), _defineProperty(_french, 30351, "Cacher"), _defineProperty(_french, 30361, "Image de critique / avatar"), _defineProperty(_french, 30371, "Spectacle"), _defineProperty(_french, 30381, "Sélectionnez un examen de l'examen"), _defineProperty(_french, 30391, "Examiner les sources"), _defineProperty(_french, 30401, "Commentaires de"), _defineProperty(_french, 30411, "Créer une vitrine"), _defineProperty(_french, 30421, "Note minimale"), _defineProperty(_french, 30431, "Note uniquement Commentaires"), _defineProperty(_french, 30441, "Définir la présentation"), _defineProperty(_french, 30451, "Max comptage compte"), _defineProperty(_french, 30461, "Max Commentaire Lenght"), _defineProperty(_french, 30471, "MAX Avis par page"), _defineProperty(_french, 30481, "Mise en page réactive"), _defineProperty(_french, 30491, "Ordre de tri"), _defineProperty(_french, 30501, "Les plus récents en premier"), _defineProperty(_french, 30511, "Couleur d'étoiles étoiles"), _defineProperty(_french, 30521, "Commentaires de la révision"), _defineProperty(_french, 30531, "Logo source"), _defineProperty(_french, 30541, "Date de révision"), _defineProperty(_french, 30551, "Date précise"), _defineProperty(_french, 30561, "Famille de polices"), _defineProperty(_french, 30571, "Vitrine Titre Taille"), _defineProperty(_french, 30581, "Taille du nom du critique"), _defineProperty(_french, 30591, "Taille du commentaire"), _defineProperty(_french, 30601, "Définir des remplacements"), _defineProperty(_french, 30611, "Épingle to top"), _defineProperty(_french, 30621, "Exclure"), _defineProperty(_french, 30631, "Mes critiques"), _defineProperty(_french, 30641, "A besoin d'aide"), _defineProperty(_french, 30651, "En attente du client"), _defineProperty(_french, 30661, "En attente d'un retour"), _defineProperty(_french, 30671, "Nouveaux commentaires"), _defineProperty(_french, 30681, "Nom de la recherche"), _defineProperty(_french, 30691, "Non assigné"), _defineProperty(_french, 30701, "Mise à jour réussie"), _defineProperty(_french, 30711, "Nom du contenu de la campagne (facultatif)"), _defineProperty(_french, 30721, "Termes et conditions (facultatif)"), _defineProperty(_french, 30731, "Êtes-vous sûr de vouloir supprimer cet utilisateur? Une fois supprimé, l'utilisateur n'aura plus accès à ce profil, sauf invitation."), _defineProperty(_french, 30741, "Souhaitez-vous supprimer cet utilisateur?"), _defineProperty(_french, 30751, "Répartition des réponses"), _defineProperty(_french, 30761, "Nous enverrons un courrier électronique () avec un lien pour télécharger la revue CSV."), _defineProperty(_french, 30771, "Ce profil compte plus de 100 emplacements. Nous vous enverrons un email avec le lien de téléchargement"), _defineProperty(_french, 30781, "Réponse utilisateur"), _defineProperty(_french, 30791, "Mark a répondu"), _defineProperty(_french, 30801, "Réponse de destination"), _defineProperty(_french, "null", null), _defineProperty(_french, 30811, "Tableau de Bord des Avis"), _defineProperty(_french, 30812, "Aperçu"), _defineProperty(_french, 30813, "Moy"), _defineProperty(_french, 30814, "Note MOY"), _defineProperty(_french, 30815, "Pos"), _defineProperty(_french, 30816, "Bonheur"), _defineProperty(_french, 30817, "Ratio de Mots"), _defineProperty(_french, 30818, "Ratio de Réponses"), _defineProperty(_french, 30819, "Avis par Source"), _defineProperty(_french, 30820, "Avis par Note"), _defineProperty(_french, 30821, "Réponse par Note"), _defineProperty(_french, 30822, "Avis Récents"), _defineProperty(_french, 30823, "Vous avez reçu {x} avis au cours des {x} derniers jours. Voici les plus récents"), _defineProperty(_french, 30824, "Le nombre moyen d'avis par emplacement principal pendant la période"), _defineProperty(_french, 30825, "Le pourcentage d'avis avec des notes de 4 et 5 étoiles"), _defineProperty(_french, 30826, "Le Score de Bonheur est une présentation du pourcentage d'avis positifs moins le pourcentage d'avis négatifs"), _defineProperty(_french, 30827, "Le pourcentage de tous les commentaires trouvés dans les avis de 5 et 4 étoiles par rapport à tous les mots partagés dans la période de temps. La plage va de 5 étoiles à 1 étoile."), _defineProperty(_french, 30828, "Le pourcentage d'avis dans la période de temps qui ont reçu une réponse."), _defineProperty(_french, 30829, "Diminution de {x data} par rapport aux {xx} jours précédents"), _defineProperty(_french, 30830, "Augmentation de {x data} par rapport aux {xx} jours précédents"), _defineProperty(_french, 30831, "Pas de changement dans {x data} par rapport aux {xx} jours précédents"), _defineProperty(_french, 30832, "Cliquez pour voir ces avis"), _defineProperty(_french, 30833, "(nom du lieu) , (x) Étoiles, Critique: (x)"), _defineProperty(_french, 30834, "Moyenne des Avis & Évaluation"), _defineProperty(_french, 30835, "Nombre d'avis dans le temps empilé par note d'étoiles + graphique en ligne de la moyenne des notes."), _defineProperty(_french, 30836, "Pourcentage par Note d'Étoiles"), _defineProperty(_french, 30837, "Nombre d'avis dans le temps empilé par note d'étoiles en pourcentage du total."), _defineProperty(_french, 30838, "Compte Cumulatif & Moyenne des Notes"), _defineProperty(_french, 30839, "Total des avis et note moyenne pour la période du rapport."), _defineProperty(_french, 30840, "Avis par Source"), _defineProperty(_french, 30841, "Nombre d'avis sur la période par source."), _defineProperty(_french, 30842, "Score de Bonheur au Fil du Temps"), _defineProperty(_french, 30843, "Le Score de Bonheur Net par période de temps sur la plage du rapport."), _defineProperty(_french, 30844, "Jour de la Semaine"), _defineProperty(_french, 30845, "Jour du Mois"), _defineProperty(_french, 30846, "Mois de l'Année"), _defineProperty(_french, 30847, "Pays Principaux"), _defineProperty(_french, 30848, "États Principaux"), _defineProperty(_french, 30849, "Villes Principales"), _defineProperty(_french, 30850, "Réponses"), _defineProperty(_french, 30851, "Taux de Réponse Rapide"), _defineProperty(_french, 30852, "Médiane"), _defineProperty(_french, 30853, "Le nombre de réponses publiées au cours de la période et la moyenne par emplacement."), _defineProperty(_french, 30854, "Le pourcentage d'avis recevant une réponse en 2 jours et le temps de réponse médian."), _defineProperty(_french, 30855, "Compte & Ratio de Réponses"), _defineProperty(_french, 30856, "Le nombre de réponses par note d'étoiles et le ratio de réponse global."), _defineProperty(_french, 30857, "Temps Moyen de Réponse"), _defineProperty(_french, 30858, "Le temps de réponse moyen en jours."), _defineProperty(_french, 30859, "Distribution des Réponses"), _defineProperty(_french, 30860, "Histogramme du temps de réponse des avis divisé en 10 niveaux."), _defineProperty(_french, 30861, "Heureux"), _defineProperty(_french, 30862, "Ratio"), _defineProperty(_french, 30863, "Durée de Vie"), _defineProperty(_french, 30864, "Nombre de dossiers de lieux principaux, plus les dossiers d'annonces non cartographiés."), _defineProperty(_french, 30865, "Énergie"), _defineProperty(_french, 30866, "Ratio de Commentaires"), _defineProperty(_french, 30867, "Longueur du Commentaire"), _defineProperty(_french, 30868, "Écart de Ratio"), _defineProperty(_french, 30869, "Écart de Longueur"), _defineProperty(_french, 30870, "Avis avec et sans commentaires"), _defineProperty(_french, 30871, "Moyenne de mots par note d'étoiles"), _defineProperty(_french, 30872, "Pourcentage de mots dans chaque note d'étoiles"), _defineProperty(_french, 30873, "Pourcentage de Ratio de Commentaires"), _defineProperty(_french, 30874, "Le pourcentage de tous les avis qui incluent des commentaires de clients"), _defineProperty(_french, 30875, "Nombre de mots du commentaire"), _defineProperty(_french, 30876, "Le nombre moyen de mots contenus dans les avis avec commentaires"), _defineProperty(_french, 30877, "Distribution des mots du commentaire"), _defineProperty(_french, 30878, "Le pourcentage de mots dans chaque évaluation d'étoiles pour chaque période de temps"), _defineProperty(_french, 30879, "Pourcentage d'avis positifs avec commentaires moins le pourcentage d'avis négatifs."), _defineProperty(_french, 30880, "Longueur moyenne des avis positifs moins la longueur moyenne des avis négatifs."), _defineProperty(_french, 30881, "Avis d'avis avec taux de réponse"), _defineProperty(_french, 30882, "Taux de longueur des commentaires"), _defineProperty(_french, 30883, "Vue en Grille"), _defineProperty(_french, 30884, "Emplacement moyen"), _defineProperty(_french, 30885, "La note moyenne des avis des emplacements et le pourcentage d'emplacements dépassant une note de 4,0 dans la plage de temps."), _defineProperty(_french, 30886, "Grille de Performance des Avis"), _defineProperty(_french, 30887, "Présenter la moyenne des notes des lieux par rapport au volume de critiques pour identifier les valeurs aberrantes"), _defineProperty(_french, 30888, "Sentiment"), _defineProperty(_french, 30889, "Influence"), _defineProperty(_french, 30890, "Tableau de performance"), _defineProperty(_french, 30891, "Grille de leadership"), _defineProperty(_french, 30892, "Vues totales"), _defineProperty(_french, 30893, "Taux de conversion"), _defineProperty(_french, 30894, "Vues totales et vues moyennes par emplacement."), _defineProperty(_french, 30895, "Vues de carte sur ordinateur et mobile avec la répartition en pourcentage."), _defineProperty(_french, 30896, "Vue de recherche locale sur ordinateur et mobile avec la répartition en pourcentage."), _defineProperty(_french, 30897, "Actions totales avec la répartition en pourcentage entre appels, clics sur le site Web et itinéraires."), _defineProperty(_french, 30898, "Taux de conversion total des actions/vues pour les appels, les clics sur le site Web et les itinéraires."), _defineProperty(_french, 30899, "Vues des clients"), _defineProperty(_french, 30900, "Comment et où les clients voient votre entreprise."), _defineProperty(_french, 30901, "Actions des Clients"), _defineProperty(_french, 30902, "Les actions suivies de vos annonces Google."), _defineProperty(_french, 30903, "Le pourcentage d'impressions de listes d'entreprises qui aboutit à une action"), _defineProperty(_french, 30904, "Efficacité par Lieu"), _defineProperty(_french, 30905, "Vues totales vs. taux de conversion (actions/vues) pour montrer l'efficacité de chaque emplacement à générer des vues et à les convertir en actions."), _defineProperty(_french, 30906, "Efficacité par Ville"), _defineProperty(_french, 30907, "Vues totales vs. taux de conversion (actions/vues) pour chaque ville."), _defineProperty(_french, 30908, "Efficacité par Groupe"), _defineProperty(_french, 30909, "Vues totales vs. taux de conversion (actions/vues) pour chaque groupe personnalisé."), _defineProperty(_french, 30910, "Vues Élevées + Faible Conversion"), _defineProperty(_french, 30911, "Vues Élevées + Conversion Élevée"), _defineProperty(_french, 30912, "Vues Basses + Faible Conversion"), _defineProperty(_french, 30913, "Vues Basses + Conversion Élevée"), _defineProperty(_french, 30914, "Mobile"), _defineProperty(_french, 30915, "Msearch"), _defineProperty(_french, 30916, "MMaps"), _defineProperty(_french, 30917, "DSearch"), _defineProperty(_french, 30918, "DMaps"), _defineProperty(_french, 30919, "Site"), _defineProperty(_french, 30920, "Appels"), _defineProperty(_french, 30921, "Score de Santé"), _defineProperty(_french, 30922, "Performance Quotidienne"), _defineProperty(_french, 30923, "Sélectionnez les emplacements dans le tableau et la métrique (vues ou actions)"), _defineProperty(_french, 30924, "Taux de Satisfaction"), _defineProperty(_french, 30925, "Nom/Ami"), _defineProperty(_french, 30926, "{x} lieux avec une moyenne de {y} étoiles au cours des {xx} derniers jours"), _defineProperty(_french, 30927, "Au-dessus"), _defineProperty(_french, 30928, "Groupe"), _defineProperty(_french, 30929, "Toutes les Vues"), _defineProperty(_french, 30930, "Toutes les Actions"), _defineProperty(_french, 30931, "Bureau"), _defineProperty(_french, 30932, "Limite maximum atteint : Sélectionnez jusqu'à 8 lieux pour le graphique."), _defineProperty(_french, 30933, "Critique"), _defineProperty(_french, 30934, "Sentiment Global"), _defineProperty(_french, 30935, "Distribution du score de sentiment sur {XX} sujets."), _defineProperty(_french, 30936, "Sentiment par Sujet"), _defineProperty(_french, 30937, "Fréquence des Sujets et Scores de Sentiment Correspondants."), _defineProperty(_french, 30938, "Très Positif"), _defineProperty(_french, 30939, "Très Négatif"), _defineProperty(_french, 30940, "Une règle d'automatisation déclenchée pour un nouvel avis sur"), _defineProperty(_french, 30941, "Une règle d'automatisation déclenchée pour un avis mis à jour sur"), _defineProperty(_french, 30942, "approuvé la réponse sur"), _defineProperty(_french, 30943, "attribué une étiquette"), _defineProperty(_french, 30944, "attribué l'avis à"), _defineProperty(_french, 30945, "à"), _defineProperty(_french, 30946, "Réponse automatique envoyée"), _defineProperty(_french, 30947, "Le propriétaire de l'entreprise a créé une nouvelle réponse externe sur"), _defineProperty(_french, 30948, "par règle d'automatisation sur"), _defineProperty(_french, 30949, "par système sur"), _defineProperty(_french, 30950, "a créé un nouveau"), _defineProperty(_french, 30951, "a créé une nouvelle réponse sur"), _defineProperty(_french, 30952, "a créé une note de révision pour"), _defineProperty(_french, 30953, "a supprimé une note sur"), _defineProperty(_french, 30954, "a supprimé une note de révision sur"), _defineProperty(_french, 30955, "a supprimé la réponse sur"), _defineProperty(_french, 30956, "a modifié la réponse sur"), _defineProperty(_french, 30957, "de"), _defineProperty(_french, 30958, "a généré une réponse automatique sur"), _defineProperty(_french, 30959, "local"), _defineProperty(_french, 30960, "notification"), _defineProperty(_french, 30961, "notifié"), _defineProperty(_french, 30962, "aperçu"), _defineProperty(_french, 30963, "effectué"), _defineProperty(_french, 30964, "réponse"), _defineProperty(_french, 30965, "Réponse déplacée dans la boîte de réception des approbations le"), _defineProperty(_french, 30966, "Réponse déplacée vers la boîte d'envoi et programmée pour publication"), _defineProperty(_french, 30967, "Réponse publiée sur"), _defineProperty(_french, 30968, "Revue assignée à"), _defineProperty(_french, 30969, "revue sur"), _defineProperty(_french, 30970, "Revue reçue de"), _defineProperty(_french, 30971, "a envoyé une note à"), _defineProperty(_french, 30972, "Système a attribué une étiquette de langue"), _defineProperty(_french, 30973, "Système a attribué une réponse automatique le"), _defineProperty(_french, 30974, "Balises"), _defineProperty(_french, 30975, "équipe par règle d'automatisation le"), _defineProperty(_french, 30976, "Chronologie"), _defineProperty(_french, 30977, "à"), _defineProperty(_french, 30978, "a mis à jour un"), _defineProperty(_french, 30979, "a mis à jour une note de révision le"), _defineProperty(_french, 30980, "a mis à jour la note d'évaluation de"), _defineProperty(_french, 30981, "a mis à jour le statut de la révision de"), _defineProperty(_french, 30982, "a mis à jour le statut de la révision à"), _defineProperty(_french, 30983, "a mis à jour le commentaire sur leur"), _defineProperty(_french, 30984, "via API pendant"), _defineProperty(_french, 30985, "via Pub-Sub le"), _defineProperty(_french, 30986, "Aucun commentaire ajouté"), _defineProperty(_french, 30987, "sur"), _defineProperty(_french, 30988, "Système"), _defineProperty(_french, 30989, "par"), _defineProperty(_french, 30990, "Supprimer la révision de"), _defineProperty(_french, 30991, "affecté à"), _defineProperty(_french, 30992, "Balise attribuée :"), _defineProperty(_french, 30993, "Groupe de balises attribué :"), _defineProperty(_french, 30994, "Suppression d'une balise :"), _defineProperty(_french, 30995, "Revue avec mises à jour"), _defineProperty(_french, 30996, "Revue sans mises à jour"), _defineProperty(_french, 30997, "Sélectionner toutes les balises"), _defineProperty(_french, 30998, "Sélectionner les non étiquetés"), _defineProperty(_french, 30999, "En attente d'approbation"), _defineProperty(_french, 31000, "Le plus ancien en premier"), _defineProperty(_french, 31001, "Vous n'avez aucune note enregistrée"), _defineProperty(_french, 31002, "Répondre dans la boîte d'envoi"), _defineProperty(_french, 31003, "Versions des Avis"), _defineProperty(_french, 31004, "Détail de l’Avis"), _defineProperty(_french, 31005, "Ouvrir Infos"), _defineProperty(_french, 31006, "Relations"), _defineProperty(_french, 31007, "Erreur"), _defineProperty(_french, 31008, "Principal"), _defineProperty(_french, 31009, "Catégories"), _defineProperty(_french, 31010, "Liens Sociaux"), _defineProperty(_french, 31011, "L’image originale a été supprimée par l’utilisateur ou par la plateforme."), _french),
  spanish: (_spanish = {
    1001: "Al registrarse, significa que ha leído y acepta nuestros ",
    1002: "Términos de servicio",
    1003: " y ",
    1004: "Política de privacidad",
    1005: ".",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "Acumulativo",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "Revisiones de equipo",
    2029: "Automatice",
    2030: "Completo",
    2031: "Asignado",
    2032: "Buscar usuario",
    2033: "Enviar correo electrónico",
    2034: "componer",
    2035: "Respuesta de IA",
    2036: "Enviar respuesta",
    2037: "Regenere",
    2038: "Aprobación",
    2039: "Publicar en Source",
    2040: "Respuesta enviada",
    2041: "No hay mensajes enviados",
    2042: "Claro",
    2043: "Cerrado",
    2044: "No se ha encontrado ningún texto de respuesta",
    2045: "Copiar respuesta e ir a la fuente",
    2046: "Editar respuesta",
    2047: "Aprobar respuesta",
    2048: "Actualizar Respuesta",
    2049: "Borrar respuesta",
    2050: "¿Estás seguro de que quieres borrar esta respuesta?",
    2051: "¿Está seguro de que desea enviar esta respuesta?",
    2052: "¿Desea restablecer esta respuesta?",
    2053: "¿Está seguro?",
    2054: "¿Está seguro de que desea aprobar esta respuesta?",
    2055: "Equipos",
    2056: "Siempre activo",
    2057: "Valoración + Comentario breve",
    2058: "Valoración + Comentario",
    2059: "Valoración por xidioma",
    2060: "Porfavor, indique una longitud de comentario entre 1 y 100, por defecto será de 20 caracteres",
    2061: "Copie las respuestas de revisión inteligentes a cada administrador de ubicación asignado",
    2062: "Iniciar sesión",
    2063: "Dirección de correo electrónico",
    2064: "¿No tienes una cuenta?",
    2065: "Nombre de pila",
    2066: "Apellido",
    2067: "Compañía",
    2068: "Nombre de empresa",
    2069: "¿Ya tienes una cuenta?",
    2070: "Mostrar contraseña",
    2071: "Ocultar contrasena",
    2072: "Conversión local",
    2073: "Mapas Móvil",
    2074: "Mapas Escritorio",
    2075: "Búsqueda Móvil",
    2076: "Búsqueda Escritorio",
    2077: "Vistas de búsqueda ",
    2078: "Vistas de mapa",
    2081: "Universel",
    2091: "Por Tema",
    10010: "1 estrella",
    10013: "2 estrellas",
    10016: "3 estrellas",
    10019: "4 estrellas",
    10022: "5 estrellas",
    10025: "De 100 a 300 palabras",
    10120: "Comportamiento",
    10123: "Activar",
    10124: "Siempre activo",
    10126: "Organizaciones activas",
    10129: "Agregar",
    10132: "Agregar un botón",
    10135: "Agrega un botón (opcional)",
    10138: "Añadir cuenta",
    10141: "AGREGAR TELÉFONO ADICIONAL",
    10144: "Agregar una cuenta",
    10147: "AÑADIR OTRA CATEGORÍA",
    10150: "AGREGUE OTRA ETIQUETA",
    10153: "Añadir atributos",
    10156: "Añadir línea",
    10159: "AGREGAR FECHA",
    10162: "Agregar nueva etiqueta de revisión",
    10165: "Agregar un nuevo rol",
    10168: "Agregar fecha de apertura",
    10171: "Añadir perfil",
    10174: "Nuevo informe",
    10177: "Agregar informe",
    10180: "Agregar rol",
    10181: "Añadir etiqueta de revisión",
    10183: "Categoría adicional",
    10186: "Teléfono adicional",
    10189: "Dirección",
    10192: "ADMINISTRACIÓN",
    10195: "Administrador",
    10198: "Extensiones de ubicación de AdWords",
    10201: "Extensiones de ubicación de AdWords Teléfono",
    10204: "Todas",
    10207: "Todas las reseñas",
    10210: "Todos los usuarios asignados a este rol tendrán acceso a las siguientes características",
    10213: "Aplicar",
    10216: "Bandeja de entrada de aprobación",
    10219: "¿Seguro que quieres restablecer la contraseña de este usuario?",
    10222: "¿Estás seguro?",
    10225: "Área",
    10228: "Áreas",
    10231: "Atributos",
    10234: "Autorizar cuenta",
    10237: "Promedio",
    10240: "Cantidad promedio",
    10243: "Puntuación media",
    10244: "Puntuación media",
    10246: "Promedio por ubicación",
    10249: "Esperando respuesta",
    10320: "Espalda",
    10321: "espalda",
    10323: "Facturación",
    10326: "Libro",
    10329: "Publicación de carga masiva",
    10332: "Carga de etiquetas masiva",
    10335: "Carga TSV masiva",
    10338: "Nombre del Negocio",
    10520: "Calendario",
    10523: "Cancelar",
    10526: "¡No se puede cargar la asignación de ubicación maestra!",
    10529: "Categoría",
    10532: "Cambiar el rol",
    10535: "Historial de citas",
    10538: "Ciudad",
    10541: "haga clic aquí",
    10544: "Haga clic en un usuario para asignarle este rol",
    10547: "País",
    10548: "Confirmar contraseña",
    10550: "Copiar",
    10553: "Copiar y pegar",
    10556: "No se pudo cambiar el rol!",
    10559: "No se pudo subir la publicación",
    10562: "Países",
    10565: "País",
    10568: "Código promocional",
    10571: "Código de cupon (opcional)",
    10574: "Crea un nuevo filtro seleccionando las opciones a continuación",
    10577: "Crear nuevo filtro",
    10580: "Crear un nuevo informe",
    10583: "Crear Publicaciones",
    10586: "Crear etiqueta",
    10589: "Crea este informe",
    10592: "Crea este rol",
    10595: "Creado por",
    10598: "Acciones del cliente",
    10720: "D",
    10723: "Panel",
    10726: "Fecha",
    10729: "Rango de fechas",
    10732: "Día",
    10735: "Desactivar",
    10738: "POR DEFECTO",
    10741: "Demora antes de publicar",
    10744: "Retrasar el envío de respuestas por",
    10747: "Retrasar el envío de respuestas",
    10750: "Borrar",
    10753: "Borrar ?",
    10754: "Borrar",
    10756: "Desc",
    10759: "Descripción",
    10762: "Directo",
    10765: "Consultas directas",
    10768: "Direcciones",
    10771: "Indirecto",
    10774: "Vista diferente",
    10777: "Descargar todos los datos de ubicación",
    10780: "Descargar",
    10783: "Descargar los detalles de la ubicación de Google",
    10786: "Descargar datos",
    10789: "Borradores",
    10792: "Indicaciones de viaje",
    10795: "Direcciones de conducción de día",
    10920: "Editar",
    10923: "Editar perfil",
    10926: "Editar informe",
    10929: "Editar este informe",
    10932: "Editor",
    10935: "Email",
    10938: "Hora de finalización",
    10941: "Ingrese las extensiones de ubicación de AdWords",
    10944: "Introduzca el nombre de la etiqueta de entidad",
    10947: "Ingrese las etiquetas",
    10950: "Ingrese el texto de búsqueda",
    10953: "Introduzca el nombre de la etiqueta",
    10956: "Égal",
    10959: "Evento",
    10962: "Información del evento",
    10965: "Título del evento",
    10968: "Cada",
    10971: "example.com",
    10974: "Ejemplo: 20 % de descuento en tienda u online",
    11120: "Gestión de acceso a funciones",
    11123: "Filtros",
    11126: "¿Se te olvidó tu contraseña?",
    11129: "viernes",
    11320: "Obtener oferta",
    11323: "Mas grande que",
    11520: "Calificación de la felicidad",
    11525: "Ayuda",
    11530: "Festivo",
    11535: "Hora",
    11540: "Horas",
    11545: "Cómo los clientes buscan su negocio",
    11720: "Imagen",
    11723: "URL de la imagen",
    11726: "En Mapas",
    11729: "En la búsqueda",
    11732: "Bandeja de entrada",
    11735: "Consultas indirectas",
    11738: "Perspectivas",
    11741: "Permiso insuficiente",
    11744: "Integración",
    11747: "Integraciones",
    11750: "Invitar usuario",
    11753: "INVITADO",
    11756: "Invitado por",
    11759: "ítems",
    12120: "Panel de conocimiento",
    12320: "Etiquetas",
    12323: "Último acceso",
    12326: "Última actualización",
    12329: "Aprende más",
    12332: "Menor que",
    12335: "Enlace para su botón",
    12338: "Enlace a la oferta de canje",
    12341: "Enlace a la oferta de canje (opcional)",
    12344: "Enlazar a la reseña",
    12347: "Gestión de listados",
    12350: "Rendimiento local",
    12353: "Visión general del rendimiento local",
    12356: "Conversión de búsqueda local",
    12359: "Localidades",
    12362: "Localidad",
    12365: "Ubicación",
    12368: "Detalles de ubicación",
    12371: "ID de ubicación",
    12374: "Ubicaciones",
    12377: "Iniciar sesión",
    12380: "Cerrar sesión",
    12520: "M",
    12523: "Destaca tu publicación con una foto o un video",
    12526: "Administración masiva de actividad",
    12529: "Administrar etiquetas de entidad",
    12532: "Administrar ubicaciones",
    12535: "Administrar perfil",
    12538: "Administrar Roles",
    12541: "Administrar usuarios",
    12544: "Mapas",
    12547: "Recuento de negocio",
    12550: "Fotos comerciales",
    12553: "Fotos de negocios",
    12556: "Mensaje",
    12559: "Minutos",
    12562: "Lunes",
    12565: "mes",
    12720: "Nombre",
    12723: "Nombre del nuevo rol",
    12726: "Nombre del informe",
    12729: "¿Necesito una cuenta?",
    12732: "Nuevo",
    12735: "Siguiente página",
    12738: "No hay respuestas",
    12741: "No se han encontrado resultados",
    12744: "No existen etiquetas de revisión",
    12747: "Sin reseñas",
    12750: "No, cancelar",
    12753: "Nº de usuarios",
    12756: "Notas",
    12920: "de",
    12923: "Oferta",
    12926: "DE ACUERDO",
    12929: "¡Ok lo tengo!",
    12932: "Una vez",
    12935: "Fecha de apertura",
    12938: "Orden",
    12941: "Organizaciones",
    12944: "Bandeja de salida",
    12947: "Propietario",
    13120: "página",
    13123: "Contraseña",
    13126: "Pegar TSV",
    13129: "Tipo de PDF",
    13132: "Teléfono",
    13135: "Llamadas telefónicas por día",
    13138: "Número de teléfono",
    13141: "Cantidad de fotos",
    13144: "Vistas de fotos",
    13147: "Por favor ingrese un nombre de recepcionista!",
    13150: "Por favor, introduzca un nombre de informe!",
    13153: "Por favor ingrese un resumen!",
    13156: "Por favor ingrese un título!",
    13159: "Por favor ingrese un tiempo válido!",
    13162: "¡Por favor introduzca un URL válido!",
    13165: "Por favor, actualice la página para actualizar los detalles de su ubicación",
    13168: "Por favor recarga",
    13171: "Por favor seleccione el tipo de horario!",
    13174: "Historial de publicaciones",
    13177: "Publicaciones",
    13180: "Pagina anterior",
    13183: "Categoría principal",
    13186: "Teléfono Principal",
    13189: null,
    13192: "Perfiles",
    13195: "Recuento de público",
    13198: "Fotos públicas",
    13201: "Fotos públicas",
    13204: "PUBLICAR",
    13520: "Clasificación",
    13523: "Notificaciones en tiempo real",
    13526: "Lista de recipientes",
    13529: "Periódico",
    13532: "Eliminar usuario",
    13535: "Responder",
    13538: "Aprobación de respuesta",
    13541: "Gestión de informes",
    13544: "Nombre del informe",
    13547: "Tipo de informe",
    13550: "Restablecer la contraseña",
    13553: "Respuesta por calificación estrella",
    13556: "Recuento de reseñas",
    13559: "Descargar reseñas",
    13562: "Revisar configuración",
    13565: "Revisar Fuente",
    13568: "Etiquetas de revisión",
    13571: "Enlace reseña",
    13574: "Reseñas",
    13577: "Nombre d'avis par note",
    13580: "Revisiones vs calificación promedio",
    13583: "Revisa la bandeja de entrada",
    13586: "Gestión de comentarios",
    13589: "Reseñas, día del mes",
    13592: "Reseñas, día de la semana",
    13595: "Revisiones, mes de año",
    13598: "Rol",
    13601: "Detalles del rol",
    13604: "Nombre de rol",
    13720: "sábado",
    13723: "Salvar",
    13726: "Guardar como filtro personalizado",
    13729: "Guardar filtro nuevo",
    13732: "Guardar rol",
    13735: "Respuestas guardadas",
    13738: "Fecha de programacion",
    13741: "Programar publicación",
    13742: "Para programar un informe",
    13744: "Tiempo programado",
    13747: "Tipo de horario",
    13750: "Buscar",
    13753: "Búsquedas",
    13756: "Seleccionar",
    13759: "Seleccione un filtro existente",
    13762: "selecciona una categoría",
    13765: "Ciudad selecta",
    13768: "Seleccionar país",
    13771: "Seleccione la fecha y la hora",
    13774: "Seleccionar rango de fechas",
    13777: "Seleccionar Editor (es) para revisar",
    13780: "Seleccionar etiqueta de entidad",
    13783: "Seleccionar filtro",
    13786: "Seleccionar filtros",
    13789: "Seleccionar granularidad",
    13792: "Organización seleccionada",
    13795: "Seleccione la etiqueta de revisión",
    13798: "Seleccione Filtro guardado",
    13801: "Seleccionar fuente",
    13804: "Seleccione estado",
    13807: "Seleccione hora",
    13810: "YO",
    13813: "Enviarlo para su aprobación",
    13816: "Enviar a bandeja de salida",
    13819: "Enviado",
    13822: "Servicios",
    13825: "Configuraciones",
    13828: "Gestión de configuración",
    13831: "Hacer Compras",
    13834: "Mostrar publicaciones",
    13837: "Mostrar / Ocultar navegación",
    13840: "Regístrate",
    13843: "Ubicación única Editar",
    13846: "¡Lo siento!",
    13849: "Ordenar por",
    13852: "Horas especiales",
    13855: "Acceso específico",
    13858: "ESTÁNDAR",
    13861: "Hora de inicio",
    13864: "Provincia",
    13867: "Estado",
    13870: "Almacenar",
    13873: "Código de almacenamiento",
    13876: "Calle",
    13879: "Vista de resumen",
    13882: "domingo",
    13885: "Sincroniza esta cuenta",
    13920: "Teléfono",
    13923: "Términos y Condiciones",
    13926: "jueves",
    13929: "Hora",
    13932: "Principales Localidades",
    13935: "Total",
    13938: "Martes",
    14120: "Sin respuesta",
    14123: "¿No estás seguro del formato?",
    14126: "Subir",
    14129: "Subir detalles de ubicación",
    14132: "Cargar mapa de ubicación",
    14135: "Cargar asignación de ubicación",
    14138: "Subir TSV",
    14141: "URL",
    14144: "Identidad de usuario",
    14320: "Ver imagen",
    14323: "Ver perfil",
    14326: "Puntos de vista",
    14520: "S",
    14523: "Sitio web",
    14526: "Sitio web por día",
    14529: "Nombre del Sitio Web",
    14532: "miércoles",
    14535: "semana",
    14538: "Qué acciones toman los clientes",
    14541: "Cuando se responde a una reseña",
    14544: "Donde los clientes ven su negocio",
    14547: "¿Te gustaría eliminar esta publicación programada?",
    14550: "Escribe tu título",
    14920: "Año",
    14923: "Sí, continúa",
    14926: "Puede elegir limitar el acceso de los usuarios con este rol seleccionando un filtro para adjuntarlo.",
    14929: "Nombre",
    15120: "Código postal",
    20010: "Lunes",
    20011: "L",
    20020: "Martes",
    20021: "M",
    20030: "Miércoles",
    20031: "X",
    20040: "Jueves",
    20041: "J",
    20050: "Viernes",
    20051: "V",
    20060: "Sábado",
    20061: "S",
    20070: "Domingo",
    20071: "D",
    20110: "enero",
    20111: "enero",
    20120: "febrero",
    20121: "feb.",
    20130: "marzo",
    20131: "marzo",
    20140: "abril",
    20141: "abr.",
    20150: "mayo",
    20151: "mayo",
    20160: "junio",
    20161: "jun.",
    20170: "julio",
    20171: "jul.",
    20180: "agosto",
    20181: "agosto",
    20190: "septiembre",
    20191: "sep.",
    20200: "octubre",
    20201: "oct.",
    20210: "noviembre",
    20211: "nov.",
    20220: "diciembre",
    20221: "dic.",
    20231: "Comentarios y calificaciones",
    20241: "Por ciento",
    20251: "Revisar con porcentaje",
    20261: "Acumulativo",
    20271: "Cumulative count",
    20281: "Fuente",
    20291: "Revisión por fuentes",
    20301: "Felicidad",
    20311: "Tiempo de respuesta",
    20321: "Seleccionar ubicación",
    20331: "Search by reviews keyword",
    20341: "search by Reviewer",
    20351: "Seleccionar",
    20361: "Equals",
    20371: "Menos que",
    20381: "Mayor que",
    20391: "Select Months",
    20401: "Select date",
    20411: "Click to view these reviews",
    20421: "There were no reviews found for the selected date range and criteria",
    20431: "Filtro claro",
    20441: "Delete a custom filter",
    20451: "Has Google Updates",
    20461: "Verified",
    20471: "Location published",
    20481: "Has pending edits",
    20491: "Knowledge panel",
    20501: "Review Link",
    20511: "Direcciones",
    20521: "Duplicate",
    20531: "Active",
    20541: "Can update",
    20551: "Can delete",
    20561: "No pending review",
    20571: "Location enabled",
    20581: "Not disconnected",
    20591: "Change log",
    20601: "Bulk upload Image",
    20611: "Image History",
    20621: "Bulk upload Note",
    20631: "Bulk upload q&a",
    20641: "q&a history",
    20651: "Add a question",
    20661: "Present a question to customers that highlights a core value proposition or a distinct competitive advantage of your location. You can then answer the questions.",
    20671: "Platform details",
    20681: "Auto reply variables",
    20691: "Nombre del lugar",
    20701: "Geo name",
    20711: "Firma",
    20721: "Geo name (max. 80 characters)",
    20731: "Signature name (max. 80 characters)",
    20741: "Respuesta automática",
    20751: "Descargar reseñas",
    20761: "Respuesta automática",
    20771: "External Link",
    20781: "Copy Review",
    20791: "Añadir la nota",
    20801: "External Note",
    20811: "Flag as inappropriate",
    20821: "Mark as removed",
    20831: "Are you sure ?",
    20841: "Would you like to mark this review as removed from Google?",
    20851: "Insertar respuestas guardadas",
    20861: "Save as reply template",
    20871: "Insert auto reply template",
    20881: "Send",
    20891: "Enviar para su aprobación",
    20901: "Save as draft",
    20911: "Assign note",
    20921: "Email note",
    20931: "Recipient",
    20941: "Save as note",
    20951: "Close",
    20961: "Discard",
    20971: "Send mail",
    20981: "You don't have any saved Notes",
    20991: "All caught up!",
    21001: "No entries to show",
    21011: "Respuestas enviadas",
    21021: "no comment added",
    21031: "Editar respuesta",
    21041: "Delete reply",
    21051: "Search saved replies",
    21061: "Agregar respuesta guardada",
    21071: "Choose a group and subject to save this reply.",
    21081: "Seleccione un grupo o comience a escribir para crear uno",
    21091: "Ingrese el título aquí",
    21101: "Ingrese la plantilla de respuesta",
    21111: "Asegúrese de seleccionar/crear un grupo y un título para guardar esta respuesta",
    21121: "Auto Replies",
    21131: "Add auto reply",
    21141: "Seleccione un grupo",
    21151: "Enter variable here",
    21161: "Choose your variables",
    21171: "Do you want to continue?",
    21181: "This request contains more than 100 reviews For such requests, we will send you an email with a link to download the review csv.",
    21191: "You have more than 100 reviews",
    21201: "We will send you an email (to X) with a link to download the review csv.",
    21211: "Acciones",
    21221: "All Location",
    21231: "Avg Rating",
    21241: "Marca",
    21251: "Direct",
    21261: "Descubrimiento",
    21271: "Geography",
    21281: "Felicidad",
    21291: "Queries",
    21301: "Respuestas",
    21311: "Vistas",
    21321: "Post Schedule",
    21331: "Google Post Schedule",
    21341: "Create Post",
    21351: "Manage Post",
    21361: "Schedule LocalPost",
    21371: "Upload",
    21381: "Progress",
    21391: "Validate & Schedule",
    21401: "Schedule Status",
    21411: "Select File",
    21421: "Seleccione un tipo de horario",
    21431: "Immediate",
    21441: "File time",
    21451: "Seleccione hora",
    21461: "Post immediately after verification",
    21471: "Schedule based on the time in the file",
    21481: "Schedule file by your selected time",
    21491: "Queue",
    21501: "Validation is in progress. Processing time is approximately 40 posts per minute. After validation, each post's status will be available on the next page.",
    21511: "Post processed",
    21521: "Successful validation",
    21531: "Failed validation",
    21541: "Scheduled",
    21551: "Type/Action",
    21561: "Dates",
    21571: "Start",
    21581: "End",
    21591: "Title/Product",
    21601: "Post Summary",
    21611: "Estado",
    21621: "Success",
    21631: "Fallido",
    21641: "Edit/Delete",
    21651: "Post Insights",
    21661: "Google Post Insights",
    21671: "Actuación",
    21681: "Post vistas",
    21691: "Post por medios",
    21701: "Post por tema",
    21711: "Post por acción",
    21721: "Análisis",
    21731: "Creado",
    21741: "Tipo",
    21751: "Acción",
    21761: "Filtro fuente",
    21771: "Plataforma",
    21781: "Actualizar el estado de localpost",
    21791: "Creador de campaña",
    21801: "Respuesta automática inteligente",
    21811: "Active el generador de campañas de respuesta automática",
    21821: "Antes de habilitar la opción de programación de respuesta automática, asegúrese de seguir las instrucciones que se proporcionan a continuación:",
    21831: "Antes de habilitar la respuesta automática inteligente, asegúrese de agregar sus plantillas de respuesta automática en la sección ReviewInbox. Primero, cree las respuestas para que puedan asignarse a las clasificaciones de estrellas (1-5) que activarán una respuesta automática inteligente.",
    21841: "En el Creador de campaña, seleccione un tiempo de retraso entre el recibo de revisión y la entrega de respuesta automática. La configuración del retraso debe corresponder al tiempo de respuesta de revisión ideal, ya que está destinado a enmascarar la naturaleza automática del programa.",
    21851: "También considere establecer el tiempo de operación (días de la semana y horas del día) para la campaña. La configuración de zona horaria predeterminada es GMT + 00: 00, por lo tanto, actualice según corresponda.",
    21861: "Crear campaña",
    21871: "Asigne un nombre y cualquier nota para identificar fácilmente su campaña.",
    21881: "Nombre de campaña",
    21891: "Respondedor de campaña",
    21901: "Si no se selecciona ninguna opción, el correo electrónico utilizado para registrarse y autorizar cuentas será el respondedor predeterminado.",
    21911: "Respondedor de la respuesta automática",
    21921: "Rango de fechas de campaña",
    21931: "Notas / objetivos",
    21941: "Descripción de la campaña.",
    21951: "Establecer disparadores",
    21961: "Elija el tipo de revisiones que generarán una respuesta automática para esta campaña.",
    21971: "con comentario",
    21981: "sin comentario",
    21991: "anterior",
    22001: "siguiente",
    22011: "Establecer audiencia (opcional)",
    22021: "Establezca las ubicaciones para que formen parte de la campaña en función de una etiqueta de entidad, una organización o un país / área / localidad específicos. Estos filtros están disponibles solo para reseñas de Google y ubicaciones asignadas",
    22031: "entidad",
    22041: "organización",
    22051: "Establecer horario",
    22061: "Asigne los parámetros y el cronograma para las respuestas de las revisiones, es decir, el porcentaje de revisiones específicas y las horas de operación para las respuestas.",
    22071: 'Tenga en cuenta que las respuestas automáticas están disponibles actualmente solo en forma de "avance". Estamos trabajando en procesos separados para los usuarios que deseen realizar una limpieza a corto plazo automáticamente.',
    22081: "Establecer tasa de respuesta",
    22091: "establecer conteo de respuestas",
    22101: "retraso antes de enviar respuesta automática",
    22111: "programar periódicamente",
    22121: "Seleccione el día y establezca la hora para programar la respuesta automática periódicamente",
    22131: "Selecciona la zona horaria",
    22141: "Asignar respuestas",
    22151: "En la lista, seleccione qué respuestas usar en rotación para esta campaña.",
    22161: "Confirmar",
    22171: 'Revise cada uno de los detalles a continuación y presione "confirmar" para lanzar su campaña.',
    22181: "Dias",
    22191: "Estrella",
    22201: "Promedio",
    22211: "Informes",
    22221: "Configuración de la competencia",
    22231: "Mejores prácticas",
    22241: "Cuadrante",
    22251: "Calificaciones",
    22261: "Ranking competitivo",
    22271: "Resp",
    22281: "Ver fuentes de revisión",
    22291: "Añadir competidor",
    22301: "Filtrado por",
    22311: "Claro",
    22321: "Competidor",
    22331: "CompEntidad",
    22341: "Etiqueta de entidad",
    22351: "Comentarios",
    22361: "Sin opciones",
    22371: "Malo",
    22381: "Pobre",
    22391: "Promedio",
    22401: "Excelente",
    22411: "Excelente",
    22421: "Comentarios con respuesta",
    22431: "Reseñas sin respuesta",
    22441: "Reseñas con comentarios",
    22451: "Reseñas sin comentarios",
    22461: "Revisar Volumen vs Calificación Promedio",
    22471: "Marcas",
    22481: "Enfocar",
    22491: "Revisiones totales",
    22501: "Valoración por estrellas",
    22511: "Revisiones de la competencia",
    22521: "Competidor de",
    22531: "Código",
    22541: "Administrar competidores",
    22551: "Actualizado",
    22561: "Añadir competidores",
    22571: "Añade una ubicación",
    22581: "Agregar nombre de competidores",
    22591: "El primer paso es agregar el nombre del competidor, una vez que haya agregado los nombres e íconos opcionales (imágenes de 48x48) a la lista, haga clic en 'Agregar'. Una vez que se crean los competidores, podrá asignar las ubicaciones individuales",
    22601: "Ingrese el nombre del competidor (requerido)",
    22611: "Ingrese la URL de la competencia (opcional)",
    22621: "Cargar imagen",
    22631: "Próximamente",
    22641: "Relación de comentarios",
    22651: "Porcentaje de comentarios con y sin comentarios",
    22661: "Sin",
    22671: "Con",
    22681: "Duración de los comentarios",
    22691: "Número promedio de palabras utilizadas en cada comentario por clasificación de estrellas",
    22701: "Palabras",
    22711: "Relación de palabras",
    22721: "Total y porcentaje de palabras en los comentarios para cada calificación de estrellas",
    22731: "aquí.",
    22741: "Competidores",
    22751: "Añadir etiqueta",
    22761: "Elija variables para agregar a la plantilla",
    22771: "revisión cercana",
    22781: "Revisión cerrada",
    22791: "¿Quieres cerrar esta revisión? Una vez que cierre, deberá volver a abrirlo para responder.",
    22801: "Externo",
    22811: "Negativo",
    22821: "No",
    22831: "¡Aún no hay respuestas automáticas!",
    22841: "¡Aún no hay respuestas guardadas!",
    22851: "Nota",
    22861: "Cerrado permanentemente",
    22871: "Positivo",
    22881: "Se agotó el tiempo de lectura",
    22891: "Restablecer revisión",
    22901: "Reabrir revisión",
    22911: "Respondió",
    22921: "Respuesta enviada (desde la interfaz de Google)",
    22931: "Respuesta enviada desde la aplicación",
    22941: "Revisión eliminada",
    22951: "Plantillas",
    22961: "Cerrado temporalmente",
    22971: "sí",
    22981: "No tienes borradores guardados",
    22991: "Permisos insuficientes para acceder al recurso",
    23001: "Se encontró un error interno",
    23011: "La solicitud contiene un argumento no válido",
    23021: "No se encontró la entidad solicitada",
    23031: "La reseña ya no existe en la plataforma de Google",
    23041: "Algunos de los valores de inserción automática no están disponibles. Reemplazar y enviar",
    23051: "El servicio no está disponible actualmente",
    23061: "Esta operación no es compatible con ubicaciones no reclamadas",
    23071: "Publicación publicada",
    23081: "Puesto programado",
    23091: "Nombre amigable",
    23101: "Add friendly name",
    23111: "Contacto",
    23121: "No contacts!",
    23131: "To add contact",
    23141: "Nombre de contacto",
    23151: "Contact E-Mail",
    23161: "Agregar contacto",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "Sin datos",
    23201: "Google Audit",
    23211: "Registros de auditoría",
    23221: "Seleccione un informe",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "Descargas de datos",
    23271: "Revisión Descargar",
    23281: "Todas las reseñas",
    23291: "Descargar foto URL",
    23301: "URLS de fotos del cliente",
    23311: "Merchant Photo URLS",
    23321: "Denunciar Descargas Historial",
    23331: "Report Name",
    23341: "Enviado a",
    23351: "Tiempo creado (UTC)",
    23361: "Tipo de informe",
    23371: "Profile Details",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "Actualizar",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "Subir",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "Control de gestión a granel",
    23721: "Actualice los detalles de la plataforma de la ubicación y los parámetros de la plataforma de control directamente en Google Sheets.",
    23731: "PLATFORM",
    23741: "Administre fácilmente las cuentas de cualquier escala con variables y configuraciones de ubicación personalizadas.",
    23751: "Detalles de GBP",
    23761: "Ver todos los anuncios de Google Mis negocios y agregar / editar / eliminar / eliminar detalles de ubicación.",
    23771: "Atributos GBP",
    23781: "Asigne todos los atributos elegibles a cada ubicación para obtener descubrimiento de búsqueda incremental.",
    23791: "Listado de GBP",
    23801: "Crea una nueva lista de GBP.",
    23811: "Facebook",
    23821: "Control de listado de Facebook",
    23831: "Historia",
    23841: "CAPACITACIÓN",
    23851: "Recursos de acceso para flujos de trabajo de edición a granel, mejores prácticas, limitaciones y actualizaciones.",
    23861: "ADVERTENCIA",
    23871: "Requisito",
    23881: "Los usuarios deben tener una cuenta de Google para que el sistema pueda presentar una hoja de Google con los datos del perfil.",
    23891: "Aviso:",
    23901: "Los datos han poblado cada hoja si desde la base de datos del sistema. Si desea asegurarse de que la hoja de cálculo presenta datos actuales de Google, le recomendamos encarecidamente que primero sincronice su perfil.",
    23911: 'Dependiendo de la cantidad de ubicaciones en su cuenta, las hojas de Google pueden tomar tiempo para construir inicialmente y luego refrescarse a medida que navega por la hoja. Asegúrese de que todos los datos sean estables antes de presionar "Actualizar" para guardar las ediciones en el sistema y presionar actualizaciones a Google.',
    23921: "La plataforma tiene una conexión API directa a Google, pero aún puede haber ocasiones en que Google retrasa la actualización directa a la página de listado de la ubicación pública.",
    23931: 'Empujar "Actualizar" desencadena un sistema directo directamente a Google. No hay un proceso de deshacer ni reversión disponible. Por favor, asegúrese de estar cómodo con todas las ediciones antes de activar la actualización. Si se comete un error, espere unos minutos y luego realice el cambio necesario.',
    23941: "ESQUEMA DE COLORES",
    23951: "Cada hoja tiene un esquema de color predeterminado para ayudar a los usuarios a comprender qué campos son elegibles para la edición.",
    23961: "Variables que transmiten los detalles de estado de Google o no se pueden editar directamente a través de controles a granel.",
    23971: "Las variables de Google se abren directamente para la edición a granel.",
    23981: "Variables de plataforma directamente abierta para editar a granel.",
    23991: "Control",
    24001: "Detalles",
    24011: "Atributos",
    24021: "Crear listado",
    24031: "Instrucciones",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "/PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 30 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "Actividad",
    24361: "Autorizado",
    24371: "Conexiones autorizadas Acceda a la revisión completa de la revisión y las capacidades de respuesta de / a cada fuente.",
    24381: "Etiquetas de entidad de carga a granel",
    24391: "Detalle GBP de carga a granel",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "Crear etiqueta de entidad",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "Historial de detalles GBP",
    24491: "Impresiones",
    24501: "Inactivo",
    24511: "Indexado",
    24521: "Las conexiones indexadas acceden a todas las revisiones históricas y actuales de cada fuente.",
    24531: "Manage LocalPost",
    24541: "Ningún comentario añadido",
    24551: "Número",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "Guardar una respuesta",
    24601: "Ubicación total",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "Subir alias de ubicación",
    24641: "Vista",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "Separado",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Choose File",
    24911: "No file chosen",
    24921: "Ver un registro de cada versión de actualización para confirmar los cambios de contenido de listado y detectar cualquier error.",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "ID de usuario",
    24961: "Do you want to delete?",
    24971: "Cuenta",
    24981: "No tiene actualizaciones de Google",
    24991: "No se requiere reverplicación",
    25001: "No pending edits",
    25011: "Tiempo de auditoría",
    25021: "Campo",
    25031: "Valor (a)",
    25041: "Valor (de)",
    25051: "remove from entity tag",
    25061: "Atribayo",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "Explorar",
    25111: "Explorar respuestas",
    25121: "Seleccione plantilla",
    25131: "Continuar",
    25141: "Elija la calificación de estrellas, el nombre de la plantilla y agregue contenido de plantilla para guardar la respuesta automática.",
    25151: "Seleccione Tipo de respuesta",
    25161: "Plantilla",
    25171: "Retazo",
    25181: "Asignar a la calificación (requerido)",
    25191: "Ingrese el nombre de la plantilla (requerido)",
    25201: "Variable de plantilla personalizada (opcional)",
    25211: "Seleccione o cree tema (opcional)",
    25221: "Asignar a una sola ubicación (opcional)",
    25231: "Asignar a la etiqueta de entidad (opcional)",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "Nota de ubicación",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "Vea la revisión directamente en Google",
    25301: "Positive-5 Stars",
    25311: "Negative - 1/2 Stars",
    25321: "Mixed - 3/4 Stars",
    25331: "Nombre de la plantilla",
    25341: "Variable",
    25351: "Seleccione o cree un tema",
    25361: "Grupo",
    25371: "Tema",
    25381: "Revisiones previas",
    25391: "Guardar como respuesta",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "Fecha de Creación",
    25441: "Nombre del filtro personalizado",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "Descargar",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "Página de destino predeterminada",
    25691: "Revisar la bandeja de entrada",
    25701: "Gestión masiva",
    25711: "Programación postal",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn of Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "Tasa de respuesta",
    25781: "Recuento de respuesta",
    25791: "Calificaciones de estrellas",
    25801: "Con",
    25811: "Sin",
    25821: "Demora",
    25831: "Zona horaria",
    25841: "Revisar",
    25851: "Competitor Report",
    25861: "Formato",
    25871: "HTML Email",
    25881: "Excel",
    25891: "Si no hay comentarios en el rango seleccionado",
    25901: "No envíe un correo electrónico",
    25911: "Enviar correo electrónico",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "Póngase en contacto con el soporte con cualquier pregunta sobre el perfil Cadence Sync",
    25971: "Include Audit File",
    25981: "Perfil",
    25991: "CompTag",
    26001: "Revisar los detalles",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "Gráfico de acciones del cliente para la dirección de conducción, llamadas telefónicas y clics en el sitio web.",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings.",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size.",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users.",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses.",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Yesterday",
    27251: "Last 7 days",
    27261: "Last week",
    27271: "Last 30 days",
    27281: "Last month",
    27291: "Todo el tiempo",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "Guardar esta respuesta",
    27341: "Select or create a group",
    27351: "Sin respuestas guardadas",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "Todas las localizaciones",
    27451: "Abierto",
    27461: "Google Updates",
    27471: "Missing Content",
    27481: "Código de tienda",
    27491: "Additional Categories",
    27501: "Ubicaciones de búsqueda",
    27511: "Auditoría GBP",
    27521: "Actividad a granel",
    27531: "Selecciona grupo",
    27541: "20/ page",
    27551: "Sincronizar",
    27561: "Establecer audiencia",
    27571: "Hecho",
    27581: "Group Name",
    27591: "Minuto",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "Análisis del cuadrante",
    27631: "Todos los datos de ubicaciones",
    27641: "Alta búsqueda + baja conversión",
    27651: "Búsqueda alta + alta conversión",
    27661: "Baja búsqueda + baja conversión",
    27671: "Baja búsqueda + conversión alta",
    27681: "Datos de ubicación por región",
    27691: "Datos de ubicación por ciudad",
    27701: "Location:",
    27711: "Conversion Rate:",
    27721: "Searches:",
    27731: "Google Q&A",
    27741: "Google QA",
    27751: "Download QA",
    27761: "Respuesta posterior",
    27771: "Visión posterior",
    27781: "Download the sample CSV",
    27791: "Pre populated CSV",
    27801: "Manage Portfolio",
    27811: "Add Portfolio",
    27821: "View Portfolio",
    27831: "Delete Portfolio",
    27841: "Usuarios",
    27851: "Manage Profiles",
    27861: "Remove Profile",
    27871: "Are you sure you want to Remove this profile ?",
    27881: "Accounts",
    27891: "Select Profiles",
    27901: "Select Profile",
    27911: "Portfolio Account",
    27921: "Portfolio Details",
    27931: "Portfolio Name",
    27941: "Currrent Portfolio Image",
    27951: "Upload image as a logo for portfolio",
    27961: "Change portfolio name",
    27971: "Free Trial",
    27981: "Current",
    27991: "Expired",
    28001: "Cancelled",
    28011: "Invoicing",
    28021: "Conectado",
    28031: "Number of Accounts",
    28041: "Total Locations",
    28051: "Active Locations",
    28061: "Reviews (30 days)",
    28071: "Payment Status",
    28081: "Profile Name",
    28091: "Enter name of new portfolio",
    28101: "A portfolio can bulk manage their users across different profiles easily",
    28111: "Name of new portfolio",
    28121: "Portfolio names can only have a maximum of 20 characters",
    28131: "Portfolio Created Successfully!",
    28141: "Total Profile",
    28151: "Total Users",
    28161: "Enter email",
    28171: "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role.",
    28181: "Invite",
    28191: "Current Portfolio Image",
    28201: "Sentiment",
    28211: "Awaiting",
    28221: "Más filtros",
    28231: "Review Tag",
    28241: "Filtros Guardados",
    28251: "Menos filtros",
    28261: "No Text",
    28271: "Medium",
    28281: "Expand",
    28291: "Single image upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "Abierto",
    28471: "Cerrado",
    28481: "Remoto",
    28491: "Nueva revisión Tag",
    28501: "todos los comentarios",
    28511: "No hay nada que mostrar en este rango!",
    28521: "Búsqueda",
    28531: "Seleccionar todo",
    28541: "Fuente de búsqueda",
    28551: "Etiqueta de revisión de búsqueda",
    28561: "Ubicación de búsqueda",
    28571: "Código de búsqueda de tiendas",
    28581: "Grupo de búsqueda",
    28591: "organizaciones",
    28601: "Etiquetas de entidad",
    28611: "Solicitar",
    28621: "Grupo",
    28631: "Filtros guardados de búsqueda",
    28641: "¡Sin opciones!",
    28651: "Ajustar la vista de texto de revisión",
    28661: "Mira la reseña directamente en",
    28671: "Responder En Plataforma Crítica",
    28681: "Seleccionar plantilla",
    28691: "Dupdo",
    28701: "Los comentarios anteriores",
    28711: "Sin reseñas",
    28721: "Clasificación",
    28731: "Responder Nombre de la ubicación no se añade en esta ubicación",
    28741: "La firma no ha añadido en esta ubicación",
    28751: "¿Quieres descarga continuar?",
    28761: "Opiniones sin comentario",
    28771: "Reseñas con respuesta interna",
    28781: "Revisiones con autocronceador",
    28791: "Reseñas con respuesta externa",
    28801: "Ver Panel de Conocimiento Google",
    28811: "Localización Nota",
    28821: "nuevo gerente",
    28831: "permiten a CC",
    28841: "Guardar como Responder",
    28851: "Borrar Respuesta",
    28861: "Grupo",
    28871: "Mezclado",
    28881: "Estrellas",
    28891: "Negativo, mezclado, Positivo",
    28901: "Clasificación",
    28911: "Nombre de la plantilla",
    28921: "Variable",
    28931: "Guardar un comentario",
    28941: "Editar nombre de cuenta",
    28951: "Cambiar nombre de cuenta",
    28961: "Nombre de la cuenta",
    28971: "Ubicaciones de Facebook",
    28981: "Añadir página",
    28991: "Activado",
    29001: "Mostrar ubicación oculta",
    29011: "Ver página fb",
    29021: "No hay cuenta oculta para mostrar",
    29031: "Horas atras",
    29041: "Invitador",
    29051: "Escaparate de la revisión",
    29061: "Ubicaciones de Google",
    29071: "Tus lugares",
    29081: "URL URL",
    29091: "¿Está seguro de que desea eliminar esta URL?",
    29101: "¿Le gustaría eliminar URL y sus datos relacionados de la solicitud?",
    29111: "Ubicaciones de competidores",
    29121: "Nombre de competidor",
    29131: "ID de lugar",
    29141: "Comprimir",
    29151: "Ingrese URL de ubicación y detalles de los competidores",
    29161: "IsCompetitor",
    29171: "Ubicaciones de reserva",
    29181: "Para iniciar la integración de la revisión de la reserva.",
    29191: "Back Office Ubicación ID (opcional)",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "Cree campañas para responder directamente a las revisiones con la respuesta perfecta en el momento perfecto.",
    29301: "¿Estás seguro de que quieres eliminar esta campaña?",
    29311: "Copia revisiones inteligentes a cada administrador de ubicación asignado",
    29321: "CC responde a los gerentes de ubicación asignados",
    29331: "CC responde a la empresa",
    29341: "Destinatarios",
    29351: "Todos los destinatarios",
    29361: "Seleccione la fuente de la revisión",
    29371: "Pub / Sub solamente",
    29381: "Seleccione la calificación de estrellas",
    29391: "Seleccione Revisión Contenido",
    29401: "Grupo personalizado",
    29411: "Establezca el retraso antes de enviar la respuesta automática",
    29421: "Establecer horas de operación",
    29431: "Opcional",
    29441: "No hay ubicaciones asignadas",
    29451: "No se encontraron información para el rango de fechas y los criterios seleccionados.",
    29461: "MENÚ DE FILTRO",
    29471: "Clasificar",
    29481: "Vistas en la búsqueda",
    29491: "Vistas en mapas",
    29501: "No tiene suficientes permisos para publicar una respuesta.",
    29511: "Ya esta enviado",
    29521: "Sube plantillas AR",
    29531: "Los seguidores cuentan",
    29541: "Última sincronización",
    29551: "Corporativo",
    29561: "Agencia",
    29571: "Post de local habilitado",
    29581: "Sin verificación pendiente",
    29591: "Haga clic para ver esta revisión en la bandeja de entrada",
    29601: "Lee mas",
    29611: "Cargando",
    29621: "Artículos totales (número)",
    29631: "Google mi negocio verificado",
    29641: "Marcar como",
    29651: "Añadir horas",
    29661: "Hoy dia",
    29671: "Dirección",
    29681: "Código postal",
    29691: "Se identifica como de propiedad negra",
    29701: "Agregar URL",
    29711: "Correo",
    29721: "Email de contacto",
    29731: "Actualización de COVID_19",
    29741: "¿Cambios en tu negocio?",
    29751: "Campaña",
    29761: "Comprar online",
    29771: "Comprar",
    29781: "Llama ahora",
    29791: "Ahora",
    29801: "Sincronizar esta ubicación?",
    29811: "Listado de Facebook",
    29821: "Crear nuevo listado de Facebook",
    29831: "Seleccionado",
    29841: "Detalles del negocio",
    29851: "Contactos",
    29861: "Variables",
    29871: "ID interno",
    29881: "Haga clic para conectar",
    29891: "Volver a subir",
    29901: "Ver las preguntas y respuestas en Google",
    29911: "Exigir",
    29921: "Desactivar",
    29931: "Revisión Cerrar Confirmación",
    29941: "Revisión de confirmación de respuesta",
    29951: "Revisar la confirmación de eliminación",
    29961: "Región",
    29971: "Responder a esta pregunta",
    29981: "Administrar",
    29991: "Crea Google Post",
    30001: "Administrar Google Post",
    30011: "Ocultar ubicación",
    30021: "Seleccione la página actual",
    30031: "Crea Facebook Post",
    30041: "Gestionar la publicación de facebook",
    30051: "Limpiar todo",
    30061: "Guardar el filtro",
    30071: "Función de búsqueda",
    30081: "Usuario de búsqueda",
    30091: "Todos los editores",
    30101: "Asignar a la calificación (requerido)",
    30111: "Ingrese el nombre de la plantilla (requerido)",
    30121: "Variable de plantilla personalizada (opcional)",
    30131: "Seleccione o cree tema (opcional)",
    30141: "Asignar a una sola ubicación (opcional)",
    30151: "Asignar a la etiqueta de entidad (opcional)",
    30161: "Variables de revisión",
    30171: "Nombre del revisor",
    30181: "Nombre completo del revisor",
    30191: "Variables de ubicación",
    30201: "Responder Nombre de la ubicación",
    30211: "Nombre de la ubicación GEO",
    30221: "Ya se ha enviado una respuesta para esta revisión.",
    30231: "Las respuestas para esta revisión ya no se pueden enviar. Puede eliminar esta respuesta para eliminarla desde aquí.",
    30241: "¿Le gustaría sincronizar los datos de esta ubicación? Esto retirará todas las actualizaciones realizadas a la ubicación.",
    30251: "Deje que los clientes sepan sobre cualquier cambio en su negocio debido a COVID-19",
    30261: "Enviar ahora",
    30271: "Escaparate de búsqueda",
    30281: "Use los controles a la derecha para construir el escaparate exacto de la revisión. Haga clic en el botón 'Aplicar' para cargar la vista previa instantánea",
    30291: "Construye tu reseña Showcase",
    30301: "Detalles de escaparate",
    30311: "Nombre este escaparate",
    30321: "Ubicación individual",
    30331: "Grupo de ubicación",
    30341: "Título del escaparate",
    30351: "Esconder",
    30361: "Imagen del revisor / Avatar",
    30371: "Show",
    30381: "Seleccione Conjunto de revisión",
    30391: "Revisión de fuentes",
    30401: "Comentarios",
    30411: "Crear escaparate",
    30421: "Calificación mínima",
    30431: "Calificación Solo opiniones",
    30441: "Define la presentación",
    30451: "Cuenta de revisión máxima",
    30461: "Máximo comentario longitud",
    30471: "Max Reviews por página",
    30481: "Disposición Responsive",
    30491: "Orden de clasificación",
    30501: "Más reciente primero",
    30511: "Color de calificación de estrellas",
    30521: "Comentarios de revisión",
    30531: "Logotipo de la fuente",
    30541: "Fecha de revisión",
    30551: "Fecha precisa",
    30561: "Familia tipográfica",
    30571: "Showcase Título Tamaño",
    30581: "Nombre del revisor Tamaño",
    30591: "Tamaño de comentarios",
    30601: "Conjunto de anulaciones",
    30611: "Pin a la parte superior",
    30621: "Excluir",
    30631: "Mis reseñas",
    30641: "Necesita ayuda",
    30651: "A la espera del cliente",
    30661: "En espera de retroalimentación",
    30671: "Nuevos comentarios",
    30681: "Nombre de búsqueda",
    30691: "No asignado",
    30701: "Actualizado exitosamente",
    30711: "Nombre de contenido de la campaña (opcional)",
    30721: "Términos y condiciones (opcional)",
    30731: "¿Está seguro de que desea eliminar este usuario? Una vez eliminado, el usuario ya no tendrá acceso a este perfil, a menos que esté invitado.",
    30741: "¿Te gustaría eliminar este usuario?",
    30751: "Distribución de respuesta",
    30761: "Enviaremos un correo electrónico () con un enlace para descargar el CSV de revisión.",
    30771: "Este perfil tiene más de 100 ubicaciones. Le enviaremos un correo electrónico con el enlace de descarga.",
    30781: "Respuesta de usuario",
    30791: "Mark respondió",
    30801: "Respuesta de destino",
    null: null,
    30811: "Panel de Reseñas ",
    30812: "Visión General",
    30813: "Promedio",
    30814: "Promedio de Calificaciones",
    30815: "Posición",
    30816: "Felicidad",
    30817: "Proporción de Palabras",
    30818: "Proporción de Respuestas",
    30819: "Revisión por Fuente",
    30820: "Revisión por Calificación",
    30821: "Respuesta por Calificación",
    30822: "Reseñas Recientes",
    30823: "Has recibido {x} reseñas en los últimos {x} días. Aquí están las más recientes",
    30824: "El número promedio de reseñas por ubicación principal durante el rango de tiempo",
    30825: "El porcentaje de reseñas con calificaciones de 4 y 5 estrellas",
    30826: "El Puntaje de Felicidad es una presentación del porcentaje de reseñas positivas menos el porcentaje de reseñas negativas",
    30827: "El porcentaje de todos los comentarios encontrados en reseñas de 5 y 4 estrellas en comparación con todas las palabras compartidas en el rango de tiempo. El rango va de 5 estrellas a 1 estrella.",
    30828: "El porcentaje de reseñas dentro del marco de tiempo que han recibido una respuesta.",
    30829: "Disminución en {x data} de los {xx} días anteriores",
    30830: "Aumento en {x data} de los {xx} días anteriores",
    30831: "Sin cambios en {x data} de los {xx} días anteriores",
    30832: "Haga clic para ver estas reseñas",
    30833: "(nombreDelLugar) , (x) Estrellas, Revisor/a: (x)",
    30834: "Promedio de Reseñas & Calificación",
    30835: "Conteo de reseñas a lo largo del tiempo apilado por calificación de estrellas + gráfico de líneas del promedio de calificación.",
    30836: "Porcentaje por Calificación de Estrellas",
    30837: "Conteo de reseñas a lo largo del tiempo apilado por calificación de estrellas como un porcentaje del total.",
    30838: "Conteo Acumulativo & Promedio de Calificación",
    30839: "Total de reseñas y calificación promedio para el rango de tiempo del informe.",
    30840: "Reseñas por Fuente",
    30841: "Conteo de reseñas durante el período por fuente.",
    30842: "Puntuación de Felicidad a lo Largo del Tiempo",
    30843: "La Puntuación Neta de Felicidad por período de tiempo durante el rango del informe.",
    30844: "Día de la Semana",
    30845: "Día del Mes",
    30846: "Mes del Año",
    30847: "Principales Países",
    30848: "Principales Estados",
    30849: "Principales Ciudades",
    30850: "Respuestas",
    30851: "Tasa de Respuesta Rápida",
    30852: "Mediana",
    30853: "El número de respuestas publicadas durante el período de tiempo y el promedio por ubicación.",
    30854: "El porcentaje de reseñas que reciben una respuesta en 2 días y el tiempo de respuesta mediano.",
    30855: "Conteo & Proporción de Respuestas",
    30856: "El conteo de respuestas por calificación de estrellas y la proporción de respuesta general.",
    30857: "Tiempo Promedio de Respuesta",
    30858: "El tiempo medio de respuesta en días.",
    30859: "Distribución de Respuestas",
    30860: "Histograma del tiempo de respuesta de las reseñas dividido en 10 niveles.",
    30861: "Feliz",
    30862: "Relación",
    30863: "Duración",
    30864: "Conteo de registros de ubicaciones principales, más registros de listados no mapeados.",
    30865: "Energía",
    30866: "Proporción de Comentarios",
    30867: "Longitud del Comentario",
    30868: "Brecha de Proporción",
    30869: "Brecha de Longitud",
    30870: "Reseñas con y sin comentarios",
    30871: "Promedio de palabras por calificación de estrellas",
    30872: "Porcentaje de palabras en cada calificación de estrellas",
    30873: "Porcentaje de Proporción de Comentarios",
    30874: "El porcentaje de todas las reseñas que incluyen comentarios de clientes",
    30875: "Contador de Palabras del Comentario",
    30876: "El número promedio de palabras contenidas en reseñas con comentarios",
    30877: "Distribución de Palabras del Comentario",
    30878: "El porcentaje de palabras en cada calificación de estrellas para cada período de tiempo",
    30879: "Porcentaje de reseñas positivas con comentarios menos el porcentaje de reseñas negativas.",
    30880: "Longitud media de las reseñas positivas menos la longitud media de las reseñas negativas.",
    30881: "Reseñas con tasa de respuesta",
    30882: "Tasa de longitud del comentario",
    30883: "Vista en Rejilla",
    30884: "Ubicación Promedio",
    30885: "La puntuación media de las reseñas de las ubicaciones y el porcentaje de ubicaciones con una calificación superior a 4.0 en el rango de tiempo.",
    30886: "Cuadro de Desempeño de Reseñas",
    30887: "Presentar la media de la calificación del lugar frente al volumen de reseñas para identificar valores atípicos",
    30888: "Sentimiento",
    30889: "Influencia",
    30890: "Panel de Rendimiento",
    30891: "Cuadrícula de Liderazgo",
    30892: "Vistas Totales",
    30893: "Tasa de Conversión",
    30894: "Vistas totales y el promedio de vistas por ubicaciones.",
    30895: "Vistas de mapa en escritorio y móvil con el desglose porcentual.",
    30896: "Vista de búsqueda local en escritorio y móvil con el desglose porcentual.",
    30897: "Acciones totales con el desglose porcentual entre llamadas, clics en el sitio web e indicaciones de manejo.",
    30898: "Tasa de conversión total de acciones/vistas para llamadas, clics en el sitio web e indicaciones de manejo."
  }, _defineProperty(_spanish, "30897", "Acciones totales con el desglose porcentual entre llamadas, clics en el sitio web e indicaciones de manejo."), _defineProperty(_spanish, "30898", "Tasa de conversión total de acciones/vistas para llamadas, clics en el sitio web e indicaciones de manejo."), _defineProperty(_spanish, 30899, "Vistas del Cliente"), _defineProperty(_spanish, 30900, "Cómo y dónde los clientes ven su negocio."), _defineProperty(_spanish, 30901, "Acciones del Cliente"), _defineProperty(_spanish, 30902, "Las acciones rastreables de tus listados de Google."), _defineProperty(_spanish, 30903, "El porcentaje de impresiones de listados comerciales que resulta en una acción"), _defineProperty(_spanish, 30904, "Efectividad por Ubicación"), _defineProperty(_spanish, 30905, "Vistas totales vs. tasa de conversión (acciones/vistas) para mostrar la efectividad de cada ubicación en generar vistas y convertirlas en acciones."), _defineProperty(_spanish, 30906, "Efectividad por Ciudad"), _defineProperty(_spanish, 30907, "Vistas totales vs. tasa de conversión (acciones/vistas) para cada ciudad."), _defineProperty(_spanish, 30908, "Efectividad por Grupo"), _defineProperty(_spanish, 30909, "Vistas totales vs. tasa de conversión (acciones/vistas) para cada grupo personalizado."), _defineProperty(_spanish, 30910, "Altas Vistas + Baja Conversión"), _defineProperty(_spanish, 30911, "Altas Vistas + Alta Conversión"), _defineProperty(_spanish, 30912, "Bajas Vistas + Baja Conversión"), _defineProperty(_spanish, 30913, "Bajas Vistas + Alta Conversión"), _defineProperty(_spanish, 30914, "Móvil"), _defineProperty(_spanish, 30915, "Msearch"), _defineProperty(_spanish, 30916, "MMaps"), _defineProperty(_spanish, 30917, "DSearch"), _defineProperty(_spanish, 30918, "DMaps"), _defineProperty(_spanish, 30919, "Sitio"), _defineProperty(_spanish, 30920, "Llamadas"), _defineProperty(_spanish, 30921, "Puntuación de Salud"), _defineProperty(_spanish, 30922, "Rendimiento Diario"), _defineProperty(_spanish, 30923, "Selecciona las ubicaciones de la tabla y la métrica (vistas o acciones)"), _defineProperty(_spanish, 30924, "Tasa de Felicidad"), _defineProperty(_spanish, 30925, "Nombre/Amigable"), _defineProperty(_spanish, 30926, "{x} ubicaciones con una media de {y} estrellas en los últimos {xx} días"), _defineProperty(_spanish, 30927, "Arriba"), _defineProperty(_spanish, 30928, "Grupo"), _defineProperty(_spanish, 30929, "Todas las Vistas"), _defineProperty(_spanish, 30930, "Todas las Acciones"), _defineProperty(_spanish, 30931, "Escritorio"), _defineProperty(_spanish, 30932, "Límite máximo alcanzado: Selecciona hasta 8 ubicaciones para el gráfico."), _defineProperty(_spanish, 30933, "Revisor/a"), _defineProperty(_spanish, 30934, "Sentimiento General"), _defineProperty(_spanish, 30935, "Distribución de la puntuación de sentimiento en {XX} temas."), _defineProperty(_spanish, 30936, "Sentimiento por Tema"), _defineProperty(_spanish, 30937, "Frecuencia de Temas y Puntuaciones de Sentimiento Correspondientes."), _defineProperty(_spanish, 30938, "Muy Positivo"), _defineProperty(_spanish, 30939, "Muy Negativo"), _defineProperty(_spanish, 30940, "Una regla de automatización activada para nueva reseña en"), _defineProperty(_spanish, 30941, "Una regla de automatización activada para reseña actualizada en"), _defineProperty(_spanish, 30942, "aprobó la respuesta en"), _defineProperty(_spanish, 30943, "asignó una etiqueta"), _defineProperty(_spanish, 30944, "asignó la reseña a"), _defineProperty(_spanish, 30945, "en"), _defineProperty(_spanish, 30946, "Respuesta automática enviada"), _defineProperty(_spanish, 30947, "El propietario del negocio creó una nueva respuesta externa en"), _defineProperty(_spanish, 30948, "por regla de automatización en"), _defineProperty(_spanish, 30949, "por sistema en"), _defineProperty(_spanish, 30950, "creó un nuevo"), _defineProperty(_spanish, 30951, "creó una nueva respuesta en"), _defineProperty(_spanish, 30952, "creó una nota de revisión para"), _defineProperty(_spanish, 30953, "eliminó una nota en"), _defineProperty(_spanish, 30954, "eliminó una nota de revisión en"), _defineProperty(_spanish, 30955, "eliminó la respuesta en"), _defineProperty(_spanish, 30956, "editó la respuesta en"), _defineProperty(_spanish, 30957, "de"), _defineProperty(_spanish, 30958, "generó una respuesta automática en"), _defineProperty(_spanish, 30959, "local"), _defineProperty(_spanish, 30960, "notificación"), _defineProperty(_spanish, 30961, "notificado"), _defineProperty(_spanish, 30962, "visión general"), _defineProperty(_spanish, 30963, "realizado"), _defineProperty(_spanish, 30964, "respuesta"), _defineProperty(_spanish, 30965, "Respuesta movida a la Bandeja de Aprobación en"), _defineProperty(_spanish, 30966, "Respuesta movida a la bandeja de salida y programada para publicación"), _defineProperty(_spanish, 30967, "Respuesta publicada en"), _defineProperty(_spanish, 30968, "Revisión asignada a"), _defineProperty(_spanish, 30969, "revisión en"), _defineProperty(_spanish, 30970, "Revisión recibida de"), _defineProperty(_spanish, 30971, "envió una nota a"), _defineProperty(_spanish, 30972, "El sistema asignó una etiqueta de idioma"), _defineProperty(_spanish, 30973, "El sistema asignó una respuesta automática el"), _defineProperty(_spanish, 30974, "Etiquetas"), _defineProperty(_spanish, 30975, "equipo por regla de automatización el"), _defineProperty(_spanish, 30976, "Línea de tiempo"), _defineProperty(_spanish, 30977, "a"), _defineProperty(_spanish, 30978, "actualizó un"), _defineProperty(_spanish, 30979, "actualizó una nota de revisión el"), _defineProperty(_spanish, 30980, "actualizó la calificación de la reseña de"), _defineProperty(_spanish, 30981, "actualizó el estado de la revisión de"), _defineProperty(_spanish, 30982, "actualizó el estado de la revisión a"), _defineProperty(_spanish, 30983, "actualizó el comentario sobre su"), _defineProperty(_spanish, 30984, "a través de API durante"), _defineProperty(_spanish, 30985, "a través de Pub-Sub el"), _defineProperty(_spanish, 30986, "No se han añadido comentarios."), _defineProperty(_spanish, 30987, "en"), _defineProperty(_spanish, 30988, "Sistema"), _defineProperty(_spanish, 30989, "por"), _defineProperty(_spanish, 30990, "No asignada la revisión de"), _defineProperty(_spanish, 30991, "asignado a"), _defineProperty(_spanish, 30992, "Etiqueta asignada:"), _defineProperty(_spanish, 30993, "Grupo de etiquetas asignado:"), _defineProperty(_spanish, 30994, "Se ha eliminado una etiqueta:"), _defineProperty(_spanish, 30995, "Revisión con actualizaciones"), _defineProperty(_spanish, 30996, "Revisión sin actualizaciones"), _defineProperty(_spanish, 30997, "Seleccionar todas las etiquetas"), _defineProperty(_spanish, 30998, "Seleccionar no etiquetados"), _defineProperty(_spanish, 30999, "En espera de aprobación"), _defineProperty(_spanish, 31000, "El más antiguo primero"), _defineProperty(_spanish, 31001, "No tienes notas guardadas"), _defineProperty(_spanish, 31002, "Responder en la bandeja de salida"), _defineProperty(_spanish, 31003, "Versiones de Reseñas"), _defineProperty(_spanish, 31004, "Detalle de la Reseña"), _defineProperty(_spanish, 31005, "Abrir Información"), _defineProperty(_spanish, 31006, "Relaciones"), _defineProperty(_spanish, 31007, "Error"), _defineProperty(_spanish, 31008, "Primario"), _defineProperty(_spanish, 31009, "Categorías"), _defineProperty(_spanish, 31010, "Enlaces Sociales"), _defineProperty(_spanish, 31011, "La imagen original fue eliminada por el usuario o la plataforma."), _spanish),
  日本語: {
    1001: "サインアップとは、",
    1002: "利用規約",
    1003: " とプライバシーポリシーを読み、同意し ",
    1004: "たことを意味します。",
    1005: "",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "累積的な",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "チームレビュー",
    2029: "自動化する",
    2030: "フル",
    2031: "割り当て",
    2032: "検索ユーザー",
    2033: "メールを送る",
    2034: "構成します",
    2035: "AI返信",
    2036: "返信",
    2037: "リジェネレート",
    2038: "承認",
    2039: "ソースへの投稿",
    2040: "返信送信",
    2041: "送信されたメッセージはありません",
    2042: "クリア",
    2043: "終了しました",
    2044: "返信用テキストが見つかりません",
    2045: "レスポンスをコピーしてソースへ",
    2046: "返信を編集する",
    2047: "返信を承認する",
    2048: "アップデート返信",
    2049: "返信を削除する",
    2050: "本当にこの返信を削除していいのですか？",
    2051: "本当にこの回答を送信しますか？",
    2052: "このレビューを復活させたいですか？",
    2053: "本当によろしいですか？",
    2054: "この回答を承認してよろしいですか？",
    2055: "チームです",
    2056: "評価のみ",
    2057: "評価 ＋ 短いコメント",
    2058: "評価 ＋ コメント",
    2059: "言語別レビュー",
    2060: "コメントの長さを1～100の間で指定してください、デフォルトは20文字です。",
    2061: "インテリジェントレビューの返信を各拠点責任者にコピーします。",
    2062: "ログイン",
    2063: "電子メールアドレス",
    2064: "アカウントをお持ちでない場合は、",
    2065: "ファーストネーム",
    2066: "苗字",
    2067: "会社",
    2068: "会社名",
    2069: "すでにアカウントをお持ちですか？",
    2070: "パスワードを表示",
    2071: "パスワードを隠す",
    2072: "ローカル変換",
    2073: "マップ モバイル",
    2074: "マップ デスクトップ",
    2075: "検索 モバイル",
    2076: "検索 デスクトップ",
    2077: "ビューを検索します",
    2078: "マップビュー",
    2081: "ユニバーサル (Yunibāsaru)",
    2091: "トピック別に (Topikku-betsu ni)",
    10010: "1つ星",
    10013: "2つ星",
    10016: "3つ星",
    10019: "4つ星",
    10022: "5つ星",
    10025: "100〜300語",
    10120: "行動",
    10123: "アクティブ化する",
    10124: "常にアクティブ",
    10126: "アクティブな組織",
    10129: "追加",
    10132: "ボタンを追加する",
    10135: "ボタンを追加する（オプション）",
    10138: "アカウントを追加する",
    10141: "追加電話を追加する",
    10144: "アカウントを追加",
    10147: "他のカテゴリを追加",
    10150: "他のラベルを追加",
    10153: "属性を追加する",
    10156: "ラインを追加",
    10159: "新しい日付を追加",
    10162: "新しいレビュータグを追加します",
    10165: "新しい役割を追加する",
    10168: "開始日を追加する",
    10171: "プロフィールを追加",
    10174: "新しいレポート",
    10177: "レポートを追加",
    10180: "役割を追加する",
    10181: "レビュータグを追加",
    10183: "追加カテゴリ",
    10186: "追加の電話番号",
    10189: "住所",
    10192: "管理人",
    10195: "管理者",
    10198: "アドワーズ広告の住所指定オプション",
    10201: "アドワーズ広告の住所表示オプションの電話番号",
    10204: "すべて",
    10207: "すべてのレビュー",
    10210: "このロールに割り当てられたすべてのユーザーは、次の機能にアクセスできます",
    10213: "適用する",
    10216: "承認受信トレイ",
    10219: "このユーザーのパスワードをリセットしてもよろしいですか？",
    10222: "本気ですか？",
    10225: "エリア",
    10228: "エリア",
    10231: "属性",
    10234: "アカウントを承認する",
    10237: "平均",
    10240: "平均量",
    10243: "平均評価",
    10244: "平均評価",
    10246: "場所あたりの平均",
    10249: "レスポンスを待っている",
    10320: "バック",
    10321: "バック",
    10323: "請求書",
    10326: "本",
    10329: "バルクアップロードポスト",
    10332: "バルクアップロードタグ",
    10335: "バルクアップロードTSV",
    10338: "商号",
    10520: "カレンダー",
    10523: "キャンセル",
    10526: "マスターロケーションマッピングをアップロードできません！",
    10529: "カテゴリー",
    10532: "役割を変更する",
    10535: "引用履歴",
    10538: "シティ",
    10541: "ここをクリック",
    10544: "彼にこの役割を割り当てるには、ユーザーをクリックしてください",
    10547: "CO",
    10548: "パスワードを認証する",
    10550: "コピー",
    10553: "コピーアンドペースト",
    10556: "役割を変更できませんでした！",
    10559: "投稿をアップロードできませんでした",
    10562: "国",
    10565: "国",
    10568: "クーポンコード",
    10571: "クーポンコード（オプション）",
    10574: "以下のオプションを選択して新しいフィルタを作成する",
    10577: "新しいフィルタを作成する",
    10580: "新しいレポートを作成します",
    10583: "投稿を作成する",
    10586: "タグを作成する",
    10589: "このレポートを作成します",
    10592: "このロールを作成する",
    10595: "によって作成された",
    10598: "顧客対応",
    10720: "日",
    10723: "ダッシュボード",
    10726: "日付",
    10729: "日付範囲",
    10732: "日",
    10735: "無効化する",
    10738: "デフォルト",
    10741: "転記までの遅延",
    10744: "返信の送信遅延",
    10747: "返信の送信遅延",
    10750: "消去",
    10753: "削除？",
    10754: "削除",
    10756: "Desc",
    10759: "説明",
    10762: "直接",
    10765: "直接クエリ",
    10768: "行き方",
    10771: "発見",
    10774: "識別可能なビュー",
    10777: "すべてのロケーションデータをダウンロードする",
    10780: "ダウンロード",
    10783: "Googleの場所の詳細をダウンロード",
    10786: "データをダウンロードする",
    10789: "下書き",
    10792: "道順",
    10795: "毎日運転する方向",
    10920: "編集",
    10923: "プロファイル編集",
    10926: "レポートの編集",
    10929: "このレポートを編集する",
    10932: "編集者",
    10935: "Eメール",
    10938: "終了時間",
    10941: "アドワーズ広告の住所表示オプションを入力",
    10944: "エンティティタグ名を入力",
    10947: "ラベルを入力",
    10950: "検索テキストを入力",
    10953: "タグ名を入力",
    10956: "平等です",
    10959: "イベント",
    10962: "イベントの詳細",
    10965: "イベントのタイトル",
    10968: "すべて",
    10971: "example.com",
    10974: "例：店舗またはオンラインで20％オフ",
    11120: "機能アクセス管理",
    11123: "フィルタ",
    11126: "パスワードをお忘れですか？",
    11129: "金曜日",
    11320: "オファーを受ける",
    11323: "より大きい",
    11520: "幸福の評価",
    11525: "助けて",
    11530: "休日",
    11535: "時間",
    11540: "時間",
    11545: "顧客があなたのビジネスを検索する方法",
    11720: "画像",
    11723: "画像のURL",
    11726: "マップで",
    11729: "検索中",
    11732: "受信トレイ",
    11735: "間接問合せ",
    11738: "洞察",
    11741: "不十分なアクセス許可",
    11744: "統合",
    11747: "統合",
    11750: "ユーザーを招待する",
    11753: "招待された",
    11756: "招待された人",
    11759: "アイテム",
    12120: "ナレッジパネル",
    12320: "ラベル",
    12323: "前回のログイン",
    12326: "最終更新",
    12329: "もっと詳しく知る",
    12332: "未満",
    12335: "あなたのボタンのリンク",
    12338: "クーポンを利用するためのリンク",
    12341: "オファーを利用するためのリンク（オプション）",
    12344: "リンク",
    12347: "リスト管理",
    12350: "局所性能",
    12353: "ローカルパフォーマンスの概要",
    12356: "ローカル検索の変換",
    12359: "地域",
    12362: "地方",
    12365: "位置",
    12368: "所在地の詳細",
    12371: "ロケーションID",
    12374: "居場所",
    12377: "ログイン",
    12380: "ログアウト",
    12520: "月",
    12523: "あなたの投稿を写真で傑出したものにする",
    12526: "バルク活動の管理",
    12529: "エンティティタグの管理",
    12532: "場所の管理",
    12535: "プロフィールを管理する",
    12538: "役割の管理",
    12541: "ユーザーの管理",
    12544: "マップ",
    12547: "商人数",
    12550: "商人の写真",
    12553: "商人の写真",
    12556: "メッセージ",
    12559: "分",
    12562: "月曜日",
    12565: "月",
    12720: "名",
    12723: "新しいロールの名前",
    12726: "レポートの名前",
    12729: "アカウントが必要です？",
    12732: "新しい",
    12735: "次のページ",
    12738: "返事がない",
    12741: "結果が見つかりません",
    12744: "レビュータグは存在しません",
    12747: "レビューはありません",
    12750: "いいえ、キャンセル",
    12753: "ユーザー数",
    12756: "ノート",
    12920: "の",
    12923: "提供",
    12926: "[OK]",
    12929: "はい、わかった！",
    12932: "一度",
    12935: "開始日",
    12938: "注文",
    12941: "組織",
    12944: "アウトボックス",
    12947: "オーナー",
    13120: "ページ",
    13123: "パスワード",
    13126: "TSV貼り付け",
    13129: "PDF形式",
    13132: "電話",
    13135: "日ごとに電話",
    13138: "電話番号",
    13141: "写真の数量",
    13144: "写真ビュー",
    13147: "受信者の名前を入力してください！",
    13150: "レポート名を入力してください！",
    13153: "要約を入力してください！",
    13156: "タイトルを入力してください！",
    13159: "有効な時間を入力してください！",
    13162: "有効なURLを入力してください！",
    13165: "あなたの場所の詳細を更新するページを更新してください",
    13168: "リロードしてください",
    13171: "スケジュールタイプを選択してください！",
    13174: "投稿履歴",
    13177: "投稿",
    13180: "前のページ",
    13183: "主要カテゴリ",
    13186: "プライマリ電話",
    13189: "プライマリ電話番号",
    13192: "プロフィール",
    13195: "公開カウント",
    13198: "公開写真",
    13201: "公開写真",
    13204: "出版",
    13520: "評価",
    13523: "リアルタイム通知",
    13526: "受信者リスト",
    13529: "繰り返し",
    13532: "ユーザーを削除",
    13535: "応答",
    13538: "返信承認",
    13541: "レポート管理",
    13544: "レポート名",
    13547: "レポートタイプ",
    13550: "パスワードを再設定する",
    13553: "星評価による応答",
    13556: "レビュー数",
    13559: "レビューのダウンロード",
    13562: "設定を確認する",
    13565: null,
    13568: "タグを確認します",
    13571: "レビューリンク",
    13574: null,
    13577: "星評価によるレビュー",
    13580: "レビュー対平均評価",
    13583: "受信トレイを確認します",
    13586: "レビュー管理",
    13589: "レビュー、月の日",
    13592: "レビュー、曜日",
    13595: "レビュー、月の月",
    13598: "役割",
    13601: "役割の詳細",
    13604: "ロール名",
    13720: "土曜日",
    13723: "保存する",
    13726: "カスタムフィルターとして保存します",
    13729: "新しいフィルターを保存",
    13732: "役割を保存する",
    13735: "保存された返信",
    13738: "スケジュール日",
    13741: "スケジュール投稿",
    13742: "レポートをスケジュールする",
    13744: "予定時刻",
    13747: "スケジュールタイプ",
    13750: "検索",
    13753: "検索",
    13756: "選択",
    13759: "既存のフィルタを選択する",
    13762: "カテゴリを選んでください",
    13765: "Cityを選択します",
    13768: "国を選択",
    13771: "日付と時刻を選択",
    13774: "期間を選択",
    13777: "レビューするエディタを選択",
    13780: "エンティティタグを選択します",
    13783: "フィルターを選択します",
    13786: "フィルターを選択します",
    13789: "粒度を選択する",
    13792: "[組織]を選択します",
    13795: "レビュータグを選択します",
    13798: "保存されたフィルターを選択します",
    13801: "ソースを選択します",
    13804: "状態を選択します",
    13807: "時間を選択",
    13810: "自己",
    13813: "承認のために送信してください",
    13816: "送信トレイに送信する",
    13819: "送信済み",
    13822: "サービス",
    13825: "設定",
    13828: "設定管理",
    13831: "ショップ",
    13834: "投稿を表示",
    13837: "ナビゲーションの表示/非表示",
    13840: "サインアップ",
    13843: "単一の場所の編集",
    13846: "ごめんなさい！",
    13849: "並び替え",
    13852: "特別時間",
    13855: "特定のアクセス",
    13858: "標準",
    13861: "始まる時間",
    13864: "状態",
    13867: "状態",
    13870: "格納",
    13873: "コードを保存します",
    13876: "通り",
    13879: "サマリービュー",
    13882: "日曜日",
    13885: "このアカウントを同期する",
    13920: "電話",
    13923: "規約と条件",
    13926: "木曜日",
    13929: "時間",
    13932: "上位の地点",
    13935: "合計",
    13938: "火曜日",
    14120: "無回答",
    14123: "フォーマットがわからない？",
    14126: "アップロード",
    14129: "アップロード場所の詳細",
    14132: "アップロードロケーションマップ",
    14135: "アップロードロケーションマッピング",
    14138: "TSVをアップロードする",
    14141: "URL",
    14144: "ユーザーID",
    14320: "画像を見る",
    14323: "プロフィールを見る",
    14326: "ビュー",
    14520: "週",
    14523: "Webサイト",
    14526: "日ごとにウェブサイト",
    14529: "ウェブサイト名",
    14532: "水曜日",
    14535: "週間",
    14538: "ユーザーの行動",
    14541: "レビューへの返信が行われると",
    14544: "顧客があなたのビジネスを見る場所",
    14547: "この予定の投稿を削除しますか？",
    14550: "あなたのタイトルを書く",
    14920: "年",
    14923: "はい、続行します",
    14926: "この役割を持つユーザーのアクセスを制限するには、そのユーザーに接続するフィルターを選択します。",
    14929: "名",
    15120: "ジップ",
    20010: "月曜日",
    20011: "月",
    20020: "火曜日",
    20021: "火",
    20030: "水曜日",
    20031: "水",
    20040: "木曜日",
    20041: "木",
    20050: "金曜日",
    20051: "金",
    20060: "土曜日",
    20061: "土",
    20070: "日曜日",
    20071: "日",
    20110: "1月",
    20111: "1月",
    20120: "2月",
    20121: "2月",
    20130: "3月",
    20131: "3月",
    20140: "4月",
    20141: "4月",
    20150: "5月",
    20151: "5月",
    20160: "6月",
    20161: "6月",
    20170: "7月",
    20171: "7月",
    20180: "8月",
    20181: "8月",
    20190: "9月",
    20191: "9月",
    20200: "10月",
    20201: "10月",
    20210: "11月",
    20211: "11月",
    20220: "12月",
    20221: "12月",
    20231: "Reviews & Ratings",
    20241: "パーセント",
    20251: "Review with Percentage",
    20261: "Cumulative",
    20271: "Cumulative count",
    20281: "Source",
    20291: "ソースによるレビュー",
    20301: "Happiness",
    20311: "反応時間",
    20321: "[場所]を選択します",
    20331: "Search by reviews keyword",
    20341: "search by Reviewer",
    20351: "選択",
    20361: "Equals",
    20371: "未満",
    20381: "より大きい",
    20391: "Select Months",
    20401: "Select date",
    20411: "Click to view these reviews",
    20421: "There were no reviews found for the selected date range and criteria",
    20431: "クリアフィルター",
    20441: "Delete a custom filter",
    20451: "Has Google Updates",
    20461: "Verified",
    20471: "Location published",
    20481: "Has pending edits",
    20491: "Knowledge panel",
    20501: "Review Link",
    20511: "行き方",
    20521: "Duplicate",
    20531: "Active",
    20541: "Can update",
    20551: "Can delete",
    20561: "No pending review",
    20571: "Location enabled",
    20581: "Not disconnected",
    20591: "Change log",
    20601: "Bulk upload Image",
    20611: "Image History",
    20621: "Bulk upload Note",
    20631: "Bulk upload q&a",
    20641: "q&a history",
    20651: "Add a question",
    20661: "Present a question to customers that highlights a core value proposition or a distinct competitive advantage of your location. You can then answer the questions.",
    20671: "Platform details",
    20681: "Auto reply variables",
    20691: "場所の名前",
    20701: "Geo name",
    20711: "サイン",
    20721: "Geo name (max. 80 characters)",
    20731: "Signature name (max. 80 characters)",
    20741: "自動返信",
    20751: "レビューをダウンロードしてください",
    20761: "自動応答",
    20771: "External Link",
    20781: "Copy Review",
    20791: "メモを追加",
    20801: "External Note",
    20811: "Flag as inappropriate",
    20821: "Mark as removed",
    20831: "Are you sure ?",
    20841: "Would you like to mark this review as removed from Google?",
    20851: "保存された返信を挿入します",
    20861: "Save as reply template",
    20871: "Insert auto reply template",
    20881: "Send",
    20891: "承認のために送信します",
    20901: "Save as draft",
    20911: "Assign note",
    20921: "Email note",
    20931: "Recipient",
    20941: "Save as note",
    20951: "Close",
    20961: "Discard",
    20971: "Send mail",
    20981: "You don't have any saved Notes",
    20991: "All caught up!",
    21001: "No entries to show",
    21011: "送信された返信",
    21021: "no comment added",
    21031: "返信を編集します",
    21041: "Delete reply",
    21051: "Search saved replies",
    21061: "保存した返信を追加します",
    21071: "Choose a group and subject to save this reply.",
    21081: "グループを選択するか、入力を開始して作成します",
    21091: "ここにタイトルを入力してください",
    21101: "返信テンプレートを入力します",
    21111: "この返信を保存するには、必ずグループとタイトルを選択/作成してください。",
    21121: "Auto Replies",
    21131: "Add auto reply",
    21141: "グループを選択します",
    21151: "Enter variable here",
    21161: "Choose your variables",
    21171: "Do you want to continue?",
    21181: "This request contains more than 100 reviews For such requests, we will send you an email with a link to download the review csv.",
    21191: "You have more than 100 reviews",
    21201: "We will send you an email (to X) with a link to download the review csv.",
    21211: "行動",
    21221: "All Location",
    21231: "Avg Rating",
    21241: "ブランド",
    21251: "Direct",
    21261: "発見",
    21271: "Geography",
    21281: "Happiness",
    21291: "Queries",
    21301: "返信",
    21311: "表示回数",
    21321: "Post Schedule",
    21331: "Google Post Schedule",
    21341: "Create Post",
    21351: "Manage Post",
    21361: "Schedule LocalPost",
    21371: "Upload",
    21381: "Progress",
    21391: "Validate & Schedule",
    21401: "Schedule Status",
    21411: "Select File",
    21421: "スケジュールタイプを選択します",
    21431: "Immediate",
    21441: "File time",
    21451: "時間を選択",
    21461: "Post immediately after verification",
    21471: "Schedule based on the time in the file",
    21481: "Schedule file by your selected time",
    21491: "Queue",
    21501: "Validation is in progress. Processing time is approximately 40 posts per minute. After validation, each post's status will be available on the next page.",
    21511: "Post processed",
    21521: "Successful validation",
    21531: "Failed validation",
    21541: "Scheduled",
    21551: "Type/Action",
    21561: "Dates",
    21571: "Start",
    21581: "End",
    21591: "Title/Product",
    21601: "Post Summary",
    21611: "状態",
    21621: "Success",
    21631: "失敗した",
    21641: "Edit/Delete",
    21651: "Post Insights",
    21661: "Google Post Insights",
    21671: "パフォーマンス",
    21681: "Post views",
    21691: "Post by media",
    21701: "Post by topic",
    21711: "Post by action",
    21721: "Analysis",
    21731: "Created",
    21741: "Type",
    21751: "アクション",
    21761: "Source filter",
    21771: "プラットホーム",
    21781: "Update localpost status",
    21791: "Campaign Builder",
    21801: "Intelligent Auto Response",
    21811: "Turn on auto response campaign builder",
    21821: "Before enabling the auto response schedule option, Please make sure to follow the instructions given below:",
    21831: "Before enabling Inteligent Auto response make sure to add your auto reply templates in ReviewInbox section.Build the responses first so that they can be assigned to the star ratings (1-5) that will trigger an Inteligent Auto Response.",
    21841: "In the Campaign Builder please select a delay time between review receipt and auto response delivery. The delay setting should correspond to the ideal review response time, as it is intended to mask the automatic nature of the program.",
    21851: "Please also consider setting the operation time (days of the week and hours of the day) for the campaign. The default timezone setting is GMT+00:00, so please update as appropriate.",
    21861: "キャンペーンを作成します",
    21871: "Assign a name and any notes to easily identify your campaign.",
    21881: "Campaign Name",
    21891: "Campaign Responder",
    21901: "If no option is selected, email used to signup and authorize accounts will be the default respondent.",
    21911: "Respondent for the auto reply",
    21921: "Campaign date range",
    21931: "Notes/Goals",
    21941: "Campaign description",
    21951: "Set Triggers",
    21961: "Choose the type of review(s) that will prompt an automated response for this campaign.",
    21971: "with comment",
    21981: "without comment",
    21991: "previous",
    22001: "next",
    22011: "Set Audience (Optional)",
    22021: "Set the locations to be part of the campaign based on an Entity Tag, an Organization, or a specific Country/Area/Locality. These filters are available only for Google reviews and Mapped locations",
    22031: "entity",
    22041: "organization",
    22051: "Set Schedule",
    22061: "Assign the parameters and the schedule for reviews responses, i.e. the percentage of targeted reviews and the hours of operation operations for responses.",
    22071: 'Please know that automatic responses are currently available only on a "go-forward" basis. We are working on separate processes for users who might wish to do a near-term clean up automatically.',
    22081: "Set response rate",
    22091: "set response count",
    22101: "delay before sending auto reply",
    22111: "schedule periodically",
    22121: "Select day and set time to schedule auto response periodically",
    22131: "TimeZoneを選択します",
    22141: "Assign Responses",
    22151: "From the list, select which responses to use in rotation for this campaign.",
    22161: "Confirm",
    22171: 'Review each of the details below and hit "confirm" to launch your campaign.',
    22181: "Days",
    22191: "Star",
    22201: "平均",
    22211: "Reporting",
    22221: "Competitor Setup",
    22231: "Best Practices",
    22241: "Quadrant",
    22251: "Ratings",
    22261: "Competitive Ranking",
    22271: "Resp",
    22281: "View Review Sources",
    22291: "Add Competitor",
    22301: "Filtered by",
    22311: "クリア",
    22321: "Competitor",
    22331: "CompEntity",
    22341: "エンティティタグ",
    22351: "コメント",
    22361: "No Options",
    22371: "悪い",
    22381: "貧しい",
    22391: "Average",
    22401: "素晴らしい",
    22411: "素晴らしい",
    22421: "Reviews with Reply",
    22431: "返信なしでレビュー",
    22441: "コメント付きのレビュー",
    22451: "コメントなしのレビュー",
    22461: "Review Volume vs Average Rating",
    22471: "Brands",
    22481: "Zoom",
    22491: "Total reviews",
    22501: "Review rating by star",
    22511: "Competitor Reviews",
    22521: "Competitor of",
    22531: "Code",
    22541: "Manage Competitors",
    22551: "Updated",
    22561: "Add Competitors",
    22571: "Add Location",
    22581: "Add competitors Name",
    22591: "The first step is to add the competitor's name, once you have added the names and optional icons (48x48 images) to the list, click on 'Add'. Once the Competitors are created, you will be able to assign the individual locations",
    22601: "Enter competitor Name (required)",
    22611: "Enter competitor URL (optional)",
    22621: "Upload image",
    22631: "Coming soon",
    22641: "コメント比",
    22651: "Percent of reviews with and without comments",
    22661: "Without",
    22671: "With",
    22681: "コメントの長さ",
    22691: "Average number of words used in each comment by star rating",
    22701: "言葉",
    22711: "単語比",
    22721: "Total and percentage of words in comments for each star rating",
    22731: "here.",
    22741: "競争相手",
    22751: "タグ付けする",
    22761: "Choose variables to be added to the template",
    22771: "close review",
    22781: "Closed review",
    22791: "Do you want to close this review ? Once you close, you will need to reopen it in order to reply",
    22801: "External",
    22811: "Negative",
    22821: "番号",
    22831: "No auto replies yet!",
    22841: "No saved replies yet!",
    22851: "ノート",
    22861: "Permanently Closed",
    22871: "Positive",
    22881: "Read timed out",
    22891: "Reinstate Review",
    22901: "Re-Open Review",
    22911: "答えた",
    22921: "返信が送信されました（Googleのインターフェースから）",
    22931: "アプリから送信された返信",
    22941: "削除されたレビュー",
    22951: "テンプレート",
    22961: "Temporarily Closed",
    22971: "はい",
    22981: "You don't have any saved drafts",
    22991: "リソースにアクセスする権限が不十分です",
    23001: "内部エラーが発生しました",
    23011: "リクエストには無効な引数が含まれています",
    23021: "要求されたエンティティが見つかりませんでした",
    23031: "Google Platformにレビューがなくなりました",
    23041: "Some of the Auto insert values are not available. Please replace and Sent",
    23051: "サービスは現在利用できません",
    23061: "この操作は、除いていない場所ではサポートされていません",
    23071: "公開投稿",
    23081: "予約投稿",
    23091: "分かりやすい名前",
    23101: "Add friendly name",
    23111: "コンタクト",
    23121: "No contacts!",
    23131: "To add contact",
    23141: "連絡先",
    23151: "Contact E-Mail",
    23161: "連絡先を追加",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "データなし",
    23201: "Google Audit",
    23211: "監査ログ",
    23221: "レポートを選択してください",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "データのダウンロード",
    23271: "レビューダウンロード",
    23281: "すべてのレビュー",
    23291: "写真のURLをダウンロードしてください",
    23301: "顧客写真のURL",
    23311: "マーチャントフォトURL",
    23321: "レポートダウンロード履歴",
    23331: "Report Name",
    23341: "に送信された",
    23351: "作成された時間（UTC）",
    23361: "レポートタイプ",
    23371: "Profile Details",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "アップデート",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "アップロード",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "バルク管理制御",
    23721: "Googleシートでの場所の詳細を更新し、プラットフォームパラメータを直接制御します。",
    23731: "PLATFORM",
    23741: "カスタムロケーション変数と設定で任意のスケールのアカウントを簡単に管理できます。",
    23751: "GBPの詳細",
    23761: "すべてのGoogleのマイビジネスリストを表示し、場所の詳細を直接追加/編集/削除します。",
    23771: "GBP属性",
    23781: "増分検索検出を得るために、すべての適格な属性を各場所に割り当てます。",
    23791: "GBPリスティング",
    23801: "新しいGBPリストを作成します。",
    23811: "Facebook",
    23821: "Facebookリスティングコントロール",
    23831: "歴史",
    23841: "トレーニング",
    23851: "バルク編集ワークフロー、ベストプラクティス、制限事項、および更新のためのリソースへのアクセス。",
    23861: "警告",
    23871: "要件",
    23881: "システムがプロファイルデータを使用してGoogleシートを提示できるように、ユーザーはGoogleアカウントを持つ必要があります。",
    23891: "知らせ:",
    23901: "システムデータベースから各シートに入っているデータ。スプレッドシートが現在のGoogleデータを提示するようにしたい場合は、最初にプロファイルを同期させることを強くお勧めします。",
    23911: "あなたのアカウント内の場所の数に応じて、Googleシートは最初にビルドされてシートをナビゲートしたときに更新するのに時間がかかることがあります。 「更新」を押す前にすべてのデータが安定していることを確認して、編集をシステムに保存し、Googleに更新をプッシュします。",
    23921: "プラットフォームはGoogleへの直接API接続を持ちますが、GoogleがPublic Location Listingページへの直接更新を遅らせる時期がまだある場合があります。",
    23931: "「更新」を押すと、直接システムが直接Googleにトリガされます。 UNDOまたは復帰プロセスはありません。アップデートを開始する前に、すべての編集内容に慣れていることを確認してください。間違いがあったら、数分待ってから必要な変更を加えてください。",
    23941: "カラースキーム",
    23951: "各シートには、ユーザーがどのフィールドが編集の対象となるかをユーザーに理解するのに役立つデフォルトの配色があります。",
    23961: "Googleからステータスの詳細を伝えるか、またはバルクコントロールを介して直接編集できない変数。",
    23971: "Google変数は一括編集用に直接開きます。",
    23981: "一括編集用に直接開くプラットフォーム変数。",
    23991: "コントロール",
    24001: "詳細",
    24011: "属性",
    24021: "リストを作成します",
    24031: "手順",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "/PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 14 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "アクティビティ",
    24361: "承認された",
    24371: "許可された接続は、各ソースからのフルレビューと応答機能にアクセスします。",
    24381: "一括アップロードエンティティタグ",
    24391: "BULKアップロードGBPの詳細",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "エンティティタグを作成します",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "GBP詳細履歴",
    24491: "im im",
    24501: "非活性",
    24511: "索引付き",
    24521: "インデックス付き接続は、各ソースからすべての歴史的および現在のレビューにアクセスします。",
    24531: "Manage LocalPost",
    24541: "コメントは追加されていません",
    24551: "番号",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "返信を保存します",
    24601: "合計の場所",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "ロケーションエイリアスをアップロードします",
    24641: "意見",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "切り離された",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Choose File",
    24911: "No file chosen",
    24921: "各アップデートプッシュのログを表示して、内容の変更を確認し、エラーを見つけます。",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "ユーザーID",
    24961: "Do you want to delete?",
    24971: "アカウント",
    24981: "Googleのアップデートはありません",
    24991: "拒否されていません",
    25001: "No pending edits",
    25011: "監査時間",
    25021: "分野",
    25031: "値（へ）",
    25041: "値（から）",
    25051: "remove from entity tag",
    25061: "属性",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "探検する",
    25111: "応答を調べます",
    25121: "テンプレートを選択してください",
    25131: "続く",
    25141: "星評価、テンプレート名を選択し、テンプレートのコンテンツを追加して自動返信を保存します。",
    25151: "[返信タイプ]を選択します",
    25161: "テンプレート",
    25171: "スニペット",
    25181: "評価に割り当てる（必須）",
    25191: "テンプレート名を入力します（必須）",
    25201: "カスタムテンプレート変数",
    25211: "トピックを選択または作成する（オプション）",
    25221: "単一の場所に割り当てます",
    25231: "エンティティタグに割り当てます",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "場所注",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "Googleで直接レビューをご覧ください",
    25301: "Positive-5 Stars",
    25311: "Negative - 1/2 Stars",
    25321: "Mixed - 3/4 Stars",
    25331: "テンプレートの名前",
    25341: "変数",
    25351: "トピックを選択または作成します",
    25361: "グループ",
    25371: "トピック",
    25381: "以前のレビュー",
    25391: "返信として保存します",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "日付を作成します",
    25441: "カスタムフィルタの名前",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "ダウンロード",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "デフォルトのランディングページ",
    25691: "レビューIntobox.",
    25701: "バルク管理",
    25711: "ポストスケジューリング",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn of Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "回答率",
    25781: "応答カウント",
    25791: "星評価",
    25801: "と",
    25811: "それなし",
    25821: "遅れ",
    25831: "タイムゾーン",
    25841: "レビュー",
    25851: "Competitor Report",
    25861: "フォーマット",
    25871: "HTML Email",
    25881: "Excel",
    25891: "選択された範囲にレビューがない場合",
    25901: "電子メールを送ってはいけません",
    25911: "メールを送る",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "プロファイル同期ケイデンスについての質問についてもサポートに連絡してください",
    25971: "Include Audit File",
    25981: "プロフィール",
    25991: "CompTag",
    26001: "詳細を確認してください",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "運転指示、電話、ウェブサイトのクリックのための顧客アクションチャート。",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings.",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size.",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users.",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses.",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Yesterday",
    27251: "Last 7 days",
    27261: "Last week",
    27271: "Last 30 days",
    27281: "Last month",
    27291: "常に",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "この返信を保存してください",
    27341: "Select or create a group",
    27351: "保存された返信はありません",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "すべての場所",
    27451: "開ける",
    27461: "Google Updates",
    27471: "Missing Content",
    27481: "店舗コード",
    27491: "Additional Categories",
    27501: "検索場所を検索",
    27511: "GBP監査",
    27521: "バルクアクティビティ",
    27531: "グループを選択してください",
    27541: "20/ page",
    27551: "同期する",
    27561: "聴衆を設定します",
    27571: "終わり",
    27581: "Group Name",
    27591: "分",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "象限分析",
    27631: "すべての場所データ",
    27641: "高い検索 +低変換",
    27651: "高い検索 +ハイコンバージョン",
    27661: "低検索 +低変換",
    27671: "低検索 +高変換",
    27681: "地域ごとのロケーションデータ",
    27691: "市による位置データ",
    27701: "Location:",
    27711: "Conversion Rate:",
    27721: "Searches:",
    27731: "Google Q&A",
    27741: "Google QA",
    27751: "Download QA",
    27761: "答え",
    27771: "洞察をする",
    27781: "Download the sample CSV",
    27791: "Pre populated CSV",
    27801: "Manage Portfolio",
    27811: "Add Portfolio",
    27821: "View Portfolio",
    27831: "Delete Portfolio",
    27841: "ユーザー",
    27851: "Manage Profiles",
    27861: "Remove Profile",
    27871: "Are you sure you want to Remove this profile ?",
    27881: "Accounts",
    27891: "Select Profiles",
    27901: "Select Profile",
    27911: "Portfolio Account",
    27921: "Portfolio Details",
    27931: "Portfolio Name",
    27941: "Currrent Portfolio Image",
    27951: "Upload image as a logo for portfolio",
    27961: "Change portfolio name",
    27971: "Free Trial",
    27981: "Current",
    27991: "Expired",
    28001: "Cancelled",
    28011: "Invoicing",
    28021: "併せて",
    28031: "Number of Accounts",
    28041: "Total Locations",
    28051: "Active Locations",
    28061: "Reviews (30 days)",
    28071: "Payment Status",
    28081: "Profile Name",
    28091: "Enter name of new portfolio",
    28101: "A portfolio can bulk manage their users across different profiles easily",
    28111: "Name of new portfolio",
    28121: "Portfolio names can only have a maximum of 20 characters",
    28131: "Portfolio Created Successfully!",
    28141: "Total Profile",
    28151: "Total Users",
    28161: "Enter email",
    28171: "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role.",
    28181: "Invite",
    28191: "Current Portfolio Image",
    28201: "Sentiment",
    28211: "Awaiting",
    28221: "その他のフィルター",
    28231: "Review Tag",
    28241: "保存されたフィルター",
    28251: "フィルターが少ない",
    28261: "No Text",
    28271: "Medium",
    28281: "Expand",
    28291: "Single image upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "開ける",
    28471: "閉まっている",
    28481: "削除",
    28491: "新しいレビュータグ",
    28501: "すべてのレビュー",
    28511: "この範囲で表示するためには何もありません！",
    28521: "探す",
    28531: "すべて選択",
    28541: "ソースを検索します",
    28551: "レビュータグを検索します",
    28561: "場所を検索します",
    28571: "検索ストアコード",
    28581: "検索グループ",
    28591: "組織",
    28601: "エンティティタグ",
    28611: "申し込み",
    28621: "グループ",
    28631: "保存されたフィルターを検索します",
    28641: "オプションはありません！",
    28651: "レビューテキストビューを調整します",
    28661: "直接のレビューを参照してください。",
    28671: "レビュープラットフォーム上で返信",
    28681: "[テンプレートの選択",
    28691: "コピー",
    28701: "以前レビュー",
    28711: "クチコミなし",
    28721: "格付け",
    28731: "この場所に追加されていない返信ロケーション名",
    28741: "署名は、この場所に追加されません",
    28751: "あなたがダウンロードを続行しますか？",
    28761: "返信なしレビュー",
    28771: "内部返信によるレビュー",
    28781: "Auto Replyによるレビュー",
    28791: "外部返信によるレビュー",
    28801: "ビューGoogle知識パネル",
    28811: "場所の注意",
    28821: "新マネージャー",
    28831: "Ccのを有効にします",
    28841: "返信を付けて保存",
    28851: "返信削除",
    28861: "グループ",
    28871: "ミックス",
    28881: "出演者",
    28891: "負、ミックス、正",
    28901: "格付け",
    28911: "テンプレート名",
    28921: "変数",
    28931: "返信の保存",
    28941: "アカウント名を編集します",
    28951: "アカウント名を変更します",
    28961: "アカウント名",
    28971: "Facebookの場所",
    28981: "ページを追加してください",
    28991: "有効になって",
    29001: "隠された場所を表示",
    29011: "FBページを表示します",
    29021: "ショーに隠れたアカウントはありません",
    29031: "時間前",
    29041: "凛々しい",
    29051: "ショーケースをレビューする",
    29061: "Googleの場所",
    29071: "あなたの場所",
    29081: "場所のURL",
    29091: "このURLを削除してよろしいですか？",
    29101: "アプリケーションからURLとその関連データを削除しますか？",
    29111: "競争相手",
    29121: "競合他社の名前",
    29131: "場所IDを入れる",
    29141: "コンプ",
    29151: "場所のURLと競合他社の詳細を入力してください",
    29161: "IsCompetitor",
    29171: "予約場所",
    29181: "予約レビュー統合を開始する",
    29191: "バックオフィスの場所ID（オプション）",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "完璧な時間に最適な対応と共に直接レビューに応答するためのキャンペーンを作成す���",
    29301: "このキャンペーンを削除してよろしいですか？",
    29311: "割り当てられた各ロケーションマネージャにインテリジェントレビューをコピーします",
    29321: "CCは割り当てられた場所マネージャに返信します",
    29331: "CCは企業に返信します",
    29341: "受信者",
    29351: "すべての受信者",
    29361: "レビューソースを選択してください",
    29371: "パブ/サブのみ",
    29381: "星の評価を選択してください",
    29391: "コンテンツを確認してください",
    29401: "カスタムグループ",
    29411: "自動返信を送信する前に遅延を設定してください",
    29421: "営業時間を設定します",
    29431: "任意の",
    29441: "割り当てられた場所はありません",
    29451: "選択した日付範囲と基準の洞察が見つかりませんでした。",
    29461: "フィルタメニュー",
    29471: "選別",
    29481: "検索の見解",
    29491: "地図の表示",
    29501: "返信を投稿するのに十分な権限がありません。",
    29511: "送信済み",
    29521: "ARテンプレートをアップロードします",
    29531: "フォロワーカウント",
    29541: "最後の同期",
    29551: "企業の",
    29561: "エージェンシー",
    29571: "LocalPost Enabled.",
    29581: "保留中の検証なし",
    29591: "受信箱の中でこのレビューを書くまでクリックする",
    29601: "続きを読む",
    29611: "荷重",
    29621: "総（数）項目",
    29631: "Googleマイビジネスが認証済みです",
    29641: "としてマークする",
    29651: "時間を加える",
    29661: "今日",
    29671: "住所",
    29681: "郵便番号",
    29691: "黒所有者として識別します",
    29701: "URLを追加します",
    29711: "役職",
    29721: "連絡先メールアドレス",
    29731: "COVID_19更新プログラム",
    29741: "あなたのビジネスに変更？",
    29751: "運動",
    29761: "オンライン注文",
    29771: "買う",
    29781: "今すぐ電話してください",
    29791: "今",
    29801: "この場所を同期しますか？",
    29811: "Facebookのリスティング",
    29821: "新しいFacebookリストを作成します",
    29831: "選択済み",
    29841: "ビジネスの詳細",
    29851: "コンタクト",
    29861: "変数",
    29871: "内部ID",
    29881: "Connectをクリックしてください",
    29891: "アップロードに戻る",
    29901: "GoogleのQ＆Aを参照してください",
    29911: "必須",
    29921: "無効にする",
    29931: "閉じる確認を確認してください",
    29941: "返信確認を確認してください",
    29951: "削除確認を確認します",
    29961: "領域",
    29971: "この質問に答えてください",
    29981: "管理",
    29991: "Google投稿を作成します",
    30001: "Google投稿を管理する",
    30011: "場所を隠す",
    30021: "現在のページを選択してください",
    30031: "Facebookの投稿を作成します",
    30041: "Facebookの投稿を管理します",
    30051: "すべてクリア",
    30061: "フィルタを保存します",
    30071: "検索ロール",
    30081: "ユーザーを検索する",
    30091: "すべての編集者",
    30101: "評価（必須）に割り当てる",
    30111: "テンプレート名を入力してください（必須）",
    30121: "カスタムテンプレート変数（オプション）",
    30131: "トピックを選択または作成する（オプション）",
    30141: "シングルロケーションに割り当てる（オプション）",
    30151: "エンティティタグに割り当てる（オプション）",
    30161: "変数を確認します",
    30171: "レビュアー名",
    30181: "レビュアーのフルネーム",
    30191: "位置変数",
    30201: "返信ロケーション名",
    30211: "GEOロケーション名",
    30221: "このレビューの返信はすでに送信されています。",
    30231: "このレビューの返信はもう送信できません。この応答を削除してここから削除できます。",
    30241: "この場所のデータを同期させますか？これは場所に行われたすべての更新を引いています。",
    30251: "Covid-19によるあなたのビジネスへの変更について顧客に知らせてください",
    30261: "今すぐ送る",
    30271: "検索ショーケース",
    30281: "右側のコントロールを使用して、正確なレビューショーケースを構築します。インスタントプレビューをロードするには、 '適用'ボタンをクリックしてください",
    30291: "あなたのレビューショーケースを構築します",
    30301: "ショーケースの詳細",
    30311: "このショーケースに名前を付ける",
    30321: "個別の場所",
    30331: "場所グループ",
    30341: "ショーケースタイトル",
    30351: "隠れる",
    30361: "レビューアイメージ/アバター",
    30371: "見せる",
    30381: "[セット]を選択します",
    30391: "レビューソース",
    30401: "からのレビュー",
    30411: "ショーケースを作成します",
    30421: "最低限の評価",
    30431: "レビューのみ",
    30441: "プレゼンテーションを定義します",
    30451: "最大レビューカウント",
    30461: "マックスコメントLenght",
    30471: "マックスレビュー1ページあたり",
    30481: "レスポンシブレイアウト",
    30491: "ソート順",
    30501: "最新のものから",
    30511: "星評価の色",
    30521: "コメントを確認します",
    30531: "ソースのロゴ",
    30541: "デューティを見直す",
    30551: "正確な日付",
    30561: "フォントファミリー",
    30571: "ショーケースタイトルサイズ",
    30581: "レビューアの名前サイズ",
    30591: "コメントサイズ",
    30601: "上書きを設定します",
    30611: "トップへピン",
    30621: "除外されます",
    30631: "チームのレビュー",
    30641: "支援が必要です",
    30651: "お客様を待っています",
    30661: "フィードバックを待っています",
    30671: "新しいフィードバック",
    30681: "検索名",
    30691: "割り当てられていない",
    30701: "正常に更新されました",
    30711: "キャンペーンコンテンツ名（オプション）",
    30721: "利用規約（オプション）",
    30731: "このユーザーを削除してよろしいですか？削除されると、招待されない限り、ユーザーはこのプロファイルにアクセスできなくなります。",
    30741: "このユーザーを削除しますか？",
    30751: "応答分布",
    30761: "Review CSVをダウンロードするためのリンクでEメール（）を送信します。",
    30771: "このプロファイルには100以上の場所があります。ダウンロードリンクであなたに電子メールを送ります",
    30781: "ユーザーの返信",
    30791: "マークが答えた",
    30801: "宛先返信",
    null: null,
    30811: "レビュー ダッシュボード  ",
    30812: "概要 ",
    30813: "平均",
    30814: "平均評価",
    30815: "位置",
    30816: "幸福",
    30817: "単語比率",
    30818: "対応率",
    30819: "ソース別レビュー",
    30820: "評価別レビュー",
    30821: "評価別の対応",
    30822: "最近のレビュー",
    30823: "過去 {x} 日間に {x} のレビューを受け取りました。ここに最近のものがあります",
    30824: "期間中の親ロケーションごとの平均レビュー数",
    30825: "4つ星および5つ星の評価を持つレビューの割合",
    30826: "幸福スコアは、ポジティブなレビューの割合からネガティブなレビューの割合を引いたものです",
    30827: "5つ星および4つ星のレビューで見つかったすべてのコメントの割合が、時間範囲内で共有されたすべての単語に対して。範囲は5つ星から1つ星までです。",
    30828: "期間内に返信を受けたレビューの割合。",
    30829: "前の {xx} 日からの {x data} の減少",
    30830: "前の {xx} 日からの {x data} の増加",
    30831: "前の {xx} 日からの {x data} の変化なし",
    30832: "これらのレビューを見るにはクリックしてください",
    30833: "(場所の名前) , (x) 星, レビューア: (x)",
    30834: "レビュー＆評価平均",
    30835: "星評価別に積み上げた時系列のレビュー数 + レーティング平均の折れ線グラフ。",
    30836: "星評価ごとの割合",
    30837: "星評価別に積み上げた時系列のレビュー数を全体の割合として。",
    30838: "累計数 & 評価平均",
    30839: "レポートの期間のレビュー総数と平均評価。",
    30840: "ソース別レビュー",
    30841: "ソース別の期間中のレビュー数。",
    30842: "時間経過による幸福スコア",
    30843: "レポート範囲内の各期間の純粋な幸福スコア。",
    30844: "曜日",
    30845: "月の日",
    30846: "年の月",
    30847: "トップ国",
    30848: "トップ州",
    30849: "トップ都市",
    30850: "応答",
    30851: "迅速な返信率",
    30852: "中央値",
    30853: "期間中に公開された応答の数と場所ごとの平均。",
    30854: "2日以内に返信を受けたレビューの割合と応答時間の中央値。",
    30855: "応答数＆比率",
    30856: "星評価別の応答数と全体の応答率。",
    30857: "平均応答時間",
    30858: "平均応答時間（日）",
    30859: "応答の分布",
    30860: "レビュー応答時間を10の階層に分けたヒストグラム。",
    30861: "幸せ",
    30862: "比率",
    30863: "生涯",
    30864: "親ロケーションレコードの数と、マッピングされていないリストレコード。",
    30865: "エネルギー",
    30866: "コメント比率",
    30867: "コメントの長さ",
    30868: "比率ギャップ",
    30869: "長さの差",
    30870: "コメントありとなしのレビュー",
    30871: "星評価ごとの平均単語数",
    30872: "各星評価における単語の割合",
    30873: "コメント比率の割合",
    30874: "顧客コメントを含むすべてのレビューの割合",
    30875: "コメントの単語数",
    30876: "コメントを含むレビューに含まれる単語の平均数",
    30877: "コメントの単語分布",
    30878: "各时间段内每个星级评分中的单词百分比",
    30879: "コメントが付いたポジティブレビューのパーセンテージからネガティブレビューのパーセンテージを引いたもの。",
    30880: "ポジティブレビューの平均長さからネガティブレビューの平均長さを引いたもの。",
    30881: "返信率のあるレビュー",
    30882: "コメントの長さ比率",
    30883: "グリッドビュー",
    30884: "平均位置",
    30885: "場所の平均レビュー スコアと、時間範囲内で 4.0 の評価を超える場所のパーセンテージ。",
    30886: "レビューパフォーマンスグリッド",
    30887: "位置評価平均値とレビュー数を提示して外れ値を特定する",
    30888: "感情",
    30889: "影響",
    30890: "パフォーマンス ダッシュボード",
    30891: "リーダーシップ グリッド",
    30892: "総ビュー",
    30893: "コンバージョン率",
    30894: "総視聴回数と各場所ごとの平均視聴回数。",
    30895: "デスクトップとモバイルでのマップビューのパーセント内訳。",
    30896: "ローカル検索ビューのデスクトップとモバイルでのパーセント内訳。",
    30897: "通話、ウェブサイトのクリック、運転経路の間のパーセント内訳による総アクション。",
    30898: "通話、ウェブサイトのクリック、運転経路に対するアクション/ビューの総コンバージョン率。",
    30899: "顧客ビュー",
    30900: "顧客がどのように、そしてどこであなたのビジネスを見ているか。",
    30901: "顧客のアクション",
    30902: "あなたの Google リスティングからの追跡可能なアクション。",
    30903: "アクションにつながるビジネスリスティングインプレッションの割合",
    30904: "場所ごとの効果",
    30905: "各場所のビューを生成し、それをアクションに変換する上での効果を示す総ビュー数対コンバージョン率（アクション/ビュー）。",
    30906: "都市別の効果",
    30907: "各都市の総ビュー数対コンバージョン率（アクション/ビュー）。",
    30908: "グループごとの効果",
    30909: "カスタムグループごとの総ビュー数対コンバージョン率（アクション/ビュー）。",
    30910: "ビューが多い + コンバージョンが低い",
    30911: "ビューが多い + コンバージョンが高い",
    30912: "ビューが少ない + コンバージョンが低い",
    30913: "ビューが少ない + コンバージョンが高い",
    30914: "モバイル",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "サイト",
    30920: "電話",
    30921: "健康スコア",
    30922: "日々のパフォーマンス",
    30923: "テーブルから場所とメトリック（ビューまたはアクション）を選択します",
    30924: "幸福率",
    30925: "名前/フレンドリー",
    30926: "過去 {xx} 日間 {x} 地點的平均 {y} 星",
    30927: "上",
    30928: "グループ",
    30929: "すべてのビュー",
    30930: "すべてのアクション",
    30931: "デスクトップ",
    30932: "最大制限に達しました: チャートに最大8つの場所を選択してください。",
    30933: "レビューア",
    30934: "全体的な感情",
    30935: "{XX} トピックにおける感情スコアの分布。",
    30936: "トピックによる感情",
    30937: "トピックの頻度と対応する感情スコア。",
    30938: "とてもポジティブ",
    30939: "とてもネガティブ",
    30940: "新しいレビューに対してトリガーされた自動化ルール",
    30941: "更新されたレビューに対してトリガーされた自動化ルール",
    30942: "返答を承認しました",
    30943: "タグを割り当てました",
    30944: "レビューを担当に割り当てました",
    30945: "で",
    30946: "自動返信が送信されました",
    30947: "ビジネスオーナーが新しい外部応答を作成しました",
    30948: "自動化ルールによって",
    30949: "システムによって",
    30950: "新しいものを作成しました",
    30951: "新しい応答を作成しました",
    30952: "レビュー用のメモを作成しました",
    30953: "メモを削除しました",
    30954: "レビュー用のメモを削除しました",
    30955: "応答を削除しました",
    30956: "応答を編集しました",
    30957: "から",
    30958: "自動応答を生成しました",
    30959: "ローカル",
    30960: "通知",
    30961: "通知された",
    30962: "概要",
    30963: "実行された",
    30964: "応答",
    30965: "承認受信トレイに移動された応答",
    30966: "送信トレイに移動され、投稿が予定された応答",
    30967: "応答が投稿されました",
    30968: "レビューが割り当てられました",
    30969: "レビュー日",
    30970: "レビュー受け取り元",
    30971: "にメモを送った",
    30972: "システムが言語タグを割り当てました",
    30973: "システムが自動応答を割り当てました",
    30974: "タグ",
    30975: "自動化ルールによるチーム",
    30976: "タイムライン",
    30977: "へ",
    30978: "を更新しました",
    30979: "レビューのメモを更新しました",
    30980: "レビュー評価を更新しました",
    30981: "レビューのステータスを更新しました",
    30982: "レビューのステータスを更新しました",
    30983: "コメントを更新しました",
    30984: "API経由で",
    30985: "Pub-Subを介して",
    30986: "コメントは追加されていません。",
    30987: "オン",
    30988: "システム",
    30989: "によって",
    30990: "レビューの割り当てが削除されました。",
    30991: "割り当てられた",
    30992: "割り当てられたタグ:",
    30993: "割り当てられたタググループ:",
    30994: "タグを削除しました:",
    30995: "更新付きレビュー",
    30996: "更新なしのレビュー",
    30997: "すべてのタグを選択",
    30998: "タグなしを選択",
    30999: "承認待ち",
    31000: "古い順",
    31001: "保存されたメモはありません",
    31002: "送信トレイで返信",
    31003: "レビューのバージョン",
    31004: "レビューの詳細",
    31005: "情報を開",
    31006: "関係",
    31007: "エラー",
    31008: "主な",
    31009: "カテゴリー",
    31010: "ソーシャルリンク",
    31011: "元の画像はユーザーまたはプラットフォームによって削除されました。"
  },
  malayalam: {
    Login: "ലോഗിൻ",
    Email: "ഇമെയിൽ",
    Password: "പാസ്‌വേഡ്",
    "Forgot Password?": "പാസ്വേഡ് മറന്നോ?",
    "Need an account?": "ഒരു അക്കൌണ്ട് ആവശ്യമുണ്ടോ?",
    "Sign up": "സൈൻ അപ്പ് ചെയ്യുക",
    "1 Star": "1 നക്ഷത്രം",
    "2 Star": "2 നക്ഷത്രം",
    "3 Star": "3 നക്ഷത്രം",
    "4 Star": "4 നക്ഷത്രം",
    "5 Star": "5 നക്ഷത്രം",
    Average: "ശരാശരി",
    Dashboard: "ഡാഷ്ബോർഡ്",
    Reviews: "അവലോകനങ്ങൾ",
    "Average Rating": "ശരാശരി റേറ്റിംഗ്",
    "Reviews by Star Rating": "സ്റ്റാർ റേറ്റിംഗ് നൽകിയിട്ടുള്ള അവലോകനങ്ങൾ",
    "Reviews Source": "അവലോകന ഉറവിടം",
    "Happiness Rating": "സന്തോഷത്തിന്റെ റേറ്റിംഗ്",
    "Response by Star Rating": "സ്റ്റാർ റേറ്റിംഗ് പ്രതികരിക്കുന്നു",
    "Reviews vs Average Rating": "അവലോകനങ്ങൾ ശരാശരി റേറ്റിംഗ്",
    "Reviews, Day of week": "അവലോകനങ്ങൾ, ആഴ്ചയിലെ ദിവസം",
    "Reviews, Day of month": "അവലോകനങ്ങൾ, മാസത്തിലെ ദിവസം",
    "Reviews, Month of year": "അവലോകനങ്ങൾ, വർഷത്തിലെ മാസം",
    Countries: "രാജ്യങ്ങൾ",
    Areas: "ഭരണ പ്രദേശം",
    Localities: "പ്രദേശങ്ങൾ",
    "Average per Location": "ഓരോ ലൊക്കേഷനും ശരാശരി",
    "Download reviews vs average rating data as csv": "അവലോകനങ്ങളെ ശരാശരി റേറ്റിംഗ് ഡാറ്റയെ CSV ആയി ഡൗൺലോഡുചെയ്യുക"
  },
  arabic: {
    1001: "Signing up signifies you’ve read and agree to our ",
    1002: "Terms of Service",
    1003: "and",
    1004: "Privacy Policy",
    1005: ".",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "التراكمية",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "ملحوظات",
    2029: "أتمتة",
    2030: "ممتلىء",
    2031: "مُكَلَّف",
    2032: "مستخدم البحث",
    2033: "ارسل بريد الكتروني",
    2034: "مؤلف موسيقى",
    2035: "رد الذكاء الاصطناعي",
    2036: "الرد آخر",
    2037: "تجديد",
    2038: "موافقة",
    2039: "النشر على المصدر",
    2040: "تم إرسال الرد",
    2041: "لا توجد رسائل مرسلة",
    2042: "واضح",
    2043: "مغلق",
    2044: "لم يتم العثور على نص الرد",
    2045: "انسخ الرد وانتقل إلى المصدر",
    2046: "تحرير الرد",
    2047: "الموافقة على الرد",
    2048: "تحديث الرد",
    2049: "حذف الرد",
    2050: "هل أنت متأكد أنك تريد حذف هذا الرد؟",
    2051: "هل أنت متأكد أنك تريد إرسال هذا الرد؟",
    2052: "هل ترغب في إعادة هذه المراجعة؟",
    2053: "هل أنت متأكد ؟",
    2054: "هل أنت متأكد أنك تريد الموافقة على هذا الرد؟",
    2055: "الفرق",
    2056: "امئادطشن",
    2057: "فینصتلا + قیلعتریصق",
    2058: "مییقتل ا+ قیلعتلا",
    2059: "ةعجارمبسحةغللا",
    2060: "يرجى تقديم طول تعليق بين 1 و 100 ، الافتراضي سيكون 20 حرفًا",
    2061: "مدير الكل للمراجعة الذكية الردود المنسوخة محدد",
    2062: "تسجيل الدخول",
    2063: "عنوان البريد الإلكتروني",
    2064: "ليس لديك حساب؟",
    2065: "الاسم الأول",
    2066: "اسم العائلة",
    2067: "شركة",
    2068: "اسم الشركة",
    2069: "هل لديك حساب؟",
    2070: "عرض كلمة المرور",
    2071: "اخفاء كلمة المرور",
    2072: "التحويل المحلي",
    2073: "الخرائط الهاتف المحمول",
    2074: "الخرائط سطح المكتب",
    2075: "البحث الهاتف المحمول",
    2076: "البحث سطح المكتب",
    2077: "طرق عرض البحث",
    2078: "طرق عرض الخريطة",
    2081: "شامل",
    2091: "حسب الموضوع",
    10010: "1 نجمة",
    10013: "2 نجمة",
    10016: "3 نجمة",
    10019: "4 نجوم",
    10022: "5 نجوم",
    10025: "بين 100 و 300 كلمة",
    10120: "أجراءات",
    10123: "تفعيل",
    10124: "امئادطشن",
    10126: "المنظمات الفعالة",
    10129: "يضيف",
    10132: "إضافة زر",
    10135: "إضافة زر (اختياري)",
    10138: "إضافة حساب",
    10141: "إضافة رقم هاتف إضافي",
    10144: "إضافة حساب",
    10147: "إضافة تصنيف آخر",
    10150: "إضافة عنوان آخر",
    10153: "إضافة خصائص",
    10156: "إضافة سطر",
    10159: "إضافة تاريخ جديد",
    10162: "أضف علامة مراجعة جديدة",
    10165: "إضافة دور جديد",
    10168: "إضافة تاريخ ابتدائي",
    10171: "إضافة ملف شخصي",
    10174: "إضافة تقرير",
    10177: "إضافة تقرير",
    10180: "إضافة دور",
    10181: "إضافة علامة مراجعة",
    10183: "تصنيف إضافي",
    10186: "رقم هاتف إضافي",
    10189: "العنوان",
    10192: "المشرف",
    10195: "المشرف",
    10198: "إضافات مواقع كلمات الإعلانات",
    10201: "رقم هاتف إضافات مواقع كلمات الإعلانات",
    10204: "الكل",
    10207: "جميع المراجعات",
    10210: "جيمع المستخدمين المكلفين بهذا الدور ستكون لهم الصلاحية على التالي",
    10213: "يتقدم",
    10216: "صندوق الوارد",
    10219: "هل انت متأكد من إعادة تعيين كلمة مرور هذا المستخدم؟",
    10222: "هل انت متأكد؟",
    10225: "المنطقة",
    10228: "المناطق",
    10231: "قائمة الخصائص",
    10234: "رخّص الحساب",
    10237: "متوسط",
    10240: "متوسط ​​الكمية",
    10243: "متوسط ​​تقييم",
    10244: "التصنيف الوسطي",
    10246: "متوسط ​​لكل موقع",
    10249: "بانتظار الإجابة",
    10320: "رجوع",
    10321: "رجوع إالى المسؤول",
    10323: "الفواتير",
    10326: "كتاب",
    10329: "رفع منشورات مجمّعةَ",
    10332: "رفع إشارات مجمّعةَ",
    10335: "رفع القيم المفصولة بعلامة جدولة مجمّعةً",
    10338: "اسم العمل",
    10520: "التقويم",
    10523: "يلغي",
    10526: "لا يمكن رفع الموقع الرئيسي",
    10529: "الصنف",
    10532: "تغيير الدور",
    10535: "تاريخ الاقتباس",
    10538: "المدينة",
    10541: "اضغط عنا",
    10544: "اضغط على مستخدم لتسليمه هذا الدور",
    10547: "شركة",
    10548: "تأكيد كلمة المرور",
    10550: "نسخ",
    10553: "نسخ و لصق",
    10556: "لم يتم تغيير الدور!",
    10559: "لم يتم رفع المنشور",
    10562: "بلدان",
    10565: "دولة",
    10568: "رمز القسيمة",
    10571: "رمز القسيمة (اختياري)",
    10574: "أنشئ تصفية جديدة باختيارك من الخيارات أدناه",
    10577: "أنشئ تصفية جديدة",
    10580: "إنشاء تقرير جديد",
    10583: "أنشئ منشورات",
    10586: "أنشئ مؤشراَ",
    10589: "إنشاء هذا التقرير",
    10592: "أنشئ هذا الدور",
    10595: "تم الإنشاء من قِبل",
    10598: "أفعال الزبون",
    10720: "يوم",
    10723: "لوحة القيادة",
    10726: "التاريخ",
    10729: "نطاق الموعد",
    10732: "اليوم",
    10735: "تعطيل",
    10738: "تقصير",
    10741: "التأخير قبل النشر",
    10744: "تأخير الإرسال أو الردود بمقدار",
    10747: "تأخير الإرسال أو الردود بمقدار",
    10750: "حذف",
    10753: "حذف؟",
    10754: "حذف الملف الشخصي",
    10756: "تنازلي",
    10759: "الوصف",
    10762: "مباشر",
    10765: "استفسارات مباشرة",
    10768: "الاتجاهات",
    10771: "اكتشاف",
    10774: "نظرة بعيدة",
    10777: "تحميل جميع بيانات الموقع",
    10780: "تحميل",
    10783: "تحميل تفاصيل الموقع",
    10786: "تحميل البيانات",
    10789: "المسودات",
    10792: "اتجاهات القيادة",
    10795: "اتجاهات القيادة حسب اليوم",
    10920: "يحرر",
    10923: "تعديل الملف الشخصي",
    10926: "تعديل التقرير",
    10929: "تعديل هذا التقرير",
    10932: "المعدِّل",
    10935: "البريد الالكتروني",
    10938: "تاريخ الانتهاء",
    10941: "إدخال إضافات موقع الكلمات الإعلانية",
    10944: "إدخال إشارة الكينونة بالاسم",
    10947: "إدخال ملصق تعريفي",
    10950: "ادخل نص للبحث",
    10953: "أدخل اسم الإشارة",
    10956: "يساوي",
    10959: "حدث",
    10962: "تفاصيل الحدث",
    10965: "عنوان الحدث",
    10968: "كل",
    10971: "example.com",
    10974: "مثال: خصم 20% في المتجر أو على الانترنت",
    11120: "إدارة الوصول إلى الميزات",
    11123: "مرشحات",
    11126: "نسيت كلمة المرور؟",
    11129: "الجمعة",
    11320: "احصل على العرض",
    11323: "أكثر من",
    11520: "تقييم السعادة",
    11525: "مساعدة",
    11530: "العطلة",
    11535: "ساعة",
    11540: "ساعات",
    11545: "كيف يبحث العملاء عن عملك",
    11720: "صورة",
    11723: "رابط الصورة",
    11726: "في الخرائط",
    11729: "في البحث",
    11732: "البريد الوارد",
    11735: "استعلامات غير مباشرة",
    11738: "أفكار",
    11741: "صلاحيات غير كافية",
    11744: "دمج",
    11747: "عمليات الدمج",
    11750: "دعوة مستخدم",
    11753: "مدعوّ",
    11756: "تمت الدعوة من",
    11759: "العناصر",
    12120: "لوحة المعرفة",
    12320: "الملصقات التعريفية",
    12323: "آخر تسجيل دخول",
    12326: "آخر تحديث",
    12329: "اعرف المزيد",
    12332: "أقل من",
    12335: "رابط للزر الخاص بك",
    12338: "رابط لاسترداد العرض",
    12341: "رابط لاسترداد العرض (اختياري)",
    12344: "رابط",
    12347: "إدارة القوائم",
    12350: "الأداء المحلي",
    12353: "نظرة عامة على الأداء المحلي",
    12356: "تحويل البحث المحلي",
    12359: "المناطق",
    12362: "محلية",
    12365: "موقع",
    12368: "تفاصيل الموقع",
    12371: "معرّف الموقع",
    12374: "المواقع",
    12377: "تسجيل دخول",
    12380: "تسجيل خروج",
    12520: "شهر",
    12523: "اجعل منشورك مميزا بإضافة صورة",
    12526: "إدارة النشاطات الكبيرة",
    12529: "إدارة إشارات الكينونة",
    12532: "إدارة المواقع",
    12535: "إدارة المف الشخصي",
    12538: "إدارة الأدوار",
    12541: "إدارة المستخدمين",
    12544: "خرائط",
    12547: "عدد التجار",
    12550: "صور تجارية",
    12553: "التاجر، كمية الصور مقابل عدد مرات مشاهدة الصور",
    12556: "رسالة الاختصار اليومية",
    12559: "الدقائق",
    12562: "الاثنين",
    12565: "الشهر",
    12720: "الاسم",
    12723: "اسم الدور الجديد",
    12726: "اسم التقرير",
    12729: "أتريد حساباَ؟",
    12732: "جديد",
    12735: "الصفحة التالية",
    12738: "لا توجد ردود",
    12741: "لم يتم إيجاد نتائج",
    12744: "لا توجد علامات مراجعة",
    12747: "لم يتم تقديم تعليقات",
    12750: "لا ، إلغاء",
    12753: "لا. عن المستخدمين",
    12756: "ملاحظات",
    12920: "عن",
    12923: "عرض",
    12926: "حسناَ",
    12929: "حسناَ، فهمت!",
    12932: "مرة واحدة",
    12935: "التاريخ الابتدائي",
    12938: "الطلب",
    12941: "المنظمات",
    12944: "صندوق النادي",
    12947: "المالك",
    13120: "الصفحة",
    13123: "كلمة السر",
    13126: "لصق القيم المفصولة بعلامة جدولة",
    13129: "نوع ال pdf",
    13132: "هاتف",
    13135: "المكالمات الهاتفية حسب اليوم",
    13138: "رقم الهاتف",
    13141: "كمية الصور",
    13144: "وجهات نظر الصورة",
    13147: "الرجاء إدخال اسم مستقبل!",
    13150: "الرجاء إدخال اسم تقرير!",
    13153: "الرجاء إدخال ملخص!",
    13156: "الرجاء إدخال عنوان!",
    13159: "الرجاء إدخال وقت صالح!",
    13162: "الرجاء إدخال رابط صالح!",
    13165: "يرجى إعادة تحميل الصفحة لتحدث معلومات موقعك",
    13168: "يرجى إعادة تحميل الصفحة",
    13171: "الرجاء اختيار نوع جدول مواعيد!",
    13174: "تاريخ المنشور",
    13177: "المنشورات",
    13180: "الصفحة السابقة",
    13183: "التصنيف الأساسي",
    13186: "الهاتف الأساسي",
    13189: "رقم الهاتف الرئيسي",
    13192: "الملفات الشخصية",
    13195: "العدد العام",
    13198: "الصور العامة",
    13201: "صور عامة",
    13204: "نشر",
    13520: "تقييم",
    13523: "إشعارات لحظية",
    13526: "قائمة المستلم",
    13529: "متكرر",
    13532: "إزالة مستخدم",
    13535: "رد",
    13538: "موافقة الرد",
    13541: "تبليغ الإدارة",
    13544: "تبليغ الاسم",
    13547: "نوع التبليغ",
    13550: "اعادة تعيين كلمة المرور",
    13553: "استجابة تصنيف النجوم",
    13556: "مراجعة العدد",
    13559: "مراجعة التنزيل",
    13562: "مراجعة الإعدادت",
    13565: "مراجعة المصدر",
    13568: "مراجعة العلامات",
    13571: "مراجعة الرابط",
    13574: "المراجعات",
    13577: "مراجعات تصنيف النجوم",
    13580: "المراجعات مقابل متوسط ​​التصنيف",
    13583: "مراجعة الوارد",
    13586: "إدارة المراجعات",
    13589: "الاستعراضات ، يوم الشهر",
    13592: "المراجعات ، يوم الأسبوع",
    13595: "المراجعات ، شهر من السنة",
    13598: "الدور",
    13601: "تفاصيل الدور",
    13604: "اسم الدور",
    13720: "السبت",
    13723: "يحفظ",
    13726: "حفظ كمرشح مخصص",
    13729: "حفط فلتر جديد",
    13732: "حفظ الدور",
    13735: "الردود المحفوظة",
    13738: "تاريخ الجدول الزمني",
    13741: "منشور الجدول الزمني",
    13742: "لجدولة تقرير",
    13744: "وقت الجدول",
    13747: "نوع الجدولة",
    13750: "يبحث",
    13753: "عمليات البحث",
    13756: "اختيار",
    13759: "اختيار فلتر موجود",
    13762: "اختيار تصنيف",
    13765: "اختر مدينة",
    13768: "حدد الدولة",
    13771: "اختيار الوقت و التاريخ",
    13774: "اختيار مجال التاريخ",
    13777: "اختيار محرر/ين للمراجعة",
    13780: "حدد علامة الكيان",
    13783: "حدد مرشح",
    13786: "حدد المرشحات",
    13789: "اختيار تقسيمات",
    13792: "حدد منظمة",
    13795: "حدد علامة المراجعة",
    13798: "حدد مرشح حفظ",
    13801: "اختر مصدر",
    13804: "اختر ولايه",
    13807: "اختيار وقت",
    13810: "نفس",
    13813: "أرسل للموافقة",
    13816: "الإرسال للبريد الصادر",
    13819: "تم الإرسال",
    13822: "خدمات",
    13825: "إعدادات",
    13828: "إدارة الإعدادات",
    13831: "متجر",
    13834: "عرض المنشورات",
    13837: "عرض/إخفاء شريط التنقل اليساري",
    13840: "تسجيل جديد",
    13843: "تعديل موقع وحيد",
    13846: "عذراً!",
    13849: "ترتيب حسب",
    13852: "ساعات خاصة",
    13855: "وصول محدد",
    13858: "معيار",
    13861: "وقت البدء",
    13864: "الحالة",
    13867: "الحالة",
    13870: "متجر",
    13873: "رمز المتجر",
    13876: "شارع",
    13879: "عرض الملخص",
    13882: "الأحد",
    13885: "مزامنة هذا الحساب",
    13920: "هاتف",
    13923: "الأحكام و الشروط",
    13926: "الخميس",
    13929: "الوقت",
    13932: "المحليات الأفضل",
    13935: "المجموع",
    13938: "يوم الثلاثاء",
    14120: "غير المُجابة",
    14123: "غير متأكد من الصيغة؟",
    14126: "رفع",
    14129: "رفع تفاصيل الموقع",
    14132: "رفع خريطة الموقع",
    14135: "رفع خريطة الموقع",
    14138: "رفع القيم المفصولة بعلامة جدولة",
    14141: "رابط",
    14144: "معرّف المستخدم",
    14320: "عرض صورة",
    14323: "عرض ملف شخصي",
    14326: "الآراء",
    14520: "أسبوع",
    14523: "موقع إلكتروني",
    14526: "موقع على شبكة الإنترنت",
    14529: "اسم الموقع الالكتروني",
    14532: "الأربعاء",
    14535: "اسبوع",
    14538: "ما الإجراءات التي يأخذها المستخدمون",
    14541: "عندما يتم الرد على مراجعة",
    14544: "حيث يشاهد العملاء عملك",
    14547: "هل ترغب بحذف هذا المنشور المجدول؟",
    14550: "اكتب العنوان",
    14920: "السنة",
    14923: "نعم ، تابع",
    14926: "يمكنك تحديد وصول المستخدمين باستخدام هذا الدور و ذلك عبر اختيار فلتر للربط معه",
    14929: "اسمك",
    15120: "الرمز البريدي",
    20010: "الاثنين",
    20011: "الاثنين",
    20020: "الثلاثاء",
    20021: "الثلاثاء",
    20030: "الأربعاء",
    20031: "الأربعاء",
    20040: "يوم الخميس",
    20041: "الخميس",
    20050: "جمعة",
    20051: "الجمعة",
    20060: "السبت",
    20061: "السبت",
    20070: "الأحد",
    20071: "الأحد",
    20110: "كانون الثاني",
    20111: "كانون الثاني",
    20120: "شباط",
    20121: "شباط",
    20130: "آذار",
    20131: "آذار",
    20140: "نيسان",
    20141: "نيسان",
    20150: "أيار",
    20151: "أيار",
    20160: "أيار",
    20161: "حزيران",
    20170: "حزيران",
    20171: "تموز",
    20180: "تموز",
    20181: "آب",
    20190: "آب",
    20191: "أيلول",
    20200: "أيلول",
    20201: "تشرين الأول",
    20210: "تشرين الأول",
    20211: "تشرين الثاني",
    20220: "تشرين الثاني",
    20221: "كانون الأول",
    20231: "كانون الأول",
    20241: "نسبه مئويه",
    20251: "مراجعة مع نسبة مئوية",
    20261: "تراكمي",
    20271: "عدّ تراكمي",
    20281: "مصدر",
    20291: "مراجعة المصادر",
    20301: "سعادة",
    20311: "وقت الاستجابة",
    20321: "اختر موقعا",
    20331: "بحث حسب الكلمات المفتاحية للمراجعات",
    20341: "بحث حسب المُراجع",
    20351: "اختيار",
    20361: "يساوي",
    20371: "أقل من",
    20381: "أكبر من",
    20391: "اختيار الشهور",
    20401: "اختيار التاريخ",
    20411: "اضغط لمشاهدة هذه المراجعات",
    20421: "لم يتم إيجاد مراجعات للتواريخ و المعايير التي تم تحديدها",
    20431: "クリアフィルター",
    20441: "حذف فلتر مخصص",
    20451: "له تحديثات من غوغل",
    20461: "تم التحقق منه",
    20471: "تم نشر الموقع",
    20481: "له تعديلات غير مكتلمة",
    20491: "لوحة المعرفة",
    20501: "رابط المراجعة",
    20511: "الاتجاهات",
    20521: "مكرر",
    20531: "نشط",
    20541: "يمكن التعديل",
    20551: "يمكن الحذف",
    20561: "لا مراجعات غير مكتملة",
    20571: "الموقع مُفعل",
    20581: "غير مفصول",
    20591: "تغيير السجل",
    20601: "رفع الصور مجمّعةً",
    20611: "سوابق الصورة",
    20621: "رفع الملاحظات مجمّعةً",
    20631: "رفع الأسئلة و الأجوبة مجمّعةً",
    20641: "سوابق الأسئلة و الأجوبة",
    20651: "إضافة سؤال",
    20661: "قم بتقديم سؤال لزبائنك بحيث توضح اقتراح بأهمية عالية أو ميزة تنافسية فريدة لموقعك. ثم بإمكانك الإجابة على الأسئلة",
    20671: "تفاصيل المنصة",
    20681: "متغيرات الرد التلقائي",
    20691: "اسم الموقع",
    20701: "الاسم الجغرافي",
    20711: "إمضاء",
    20721: "الاسم الجغرافي (80 محرف كحد أعظم)",
    20731: "اسم التوقيع (80 محرف كحد أعظم)",
    20741: "رد آلي",
    20751: "تنزيل المراجعات",
    20761: "رد تلقائي",
    20771: "رابط خارجي",
    20781: "نسخ المراجعة",
    20791: "اضف ملاحظة",
    20801: "ملاحظة خارجية",
    20811: "تعليم كغير لائق",
    20821: "تعليم كمُلغى",
    20831: "هل أنت متأكد؟",
    20841: "هل ترغب بتعليم هذه المراجعة كمُلغاة من غوغل؟",
    20851: "أدخل الردود المحفوظة",
    20861: "حفظ كقالب للرد",
    20871: "إدخال قالب الرد التلقائي",
    20881: "إرسال",
    20891: "أرسل للموافقة",
    20901: "حفظ كمسودة",
    20911: "تكليف الملاحظة",
    20921: "ملاحظة بالبريد الالكتروني",
    20931: "مستقبل",
    20941: "حفظ كملاحظة",
    20951: "إغلاق",
    20961: "تجاهل",
    20971: "إرسال البريد",
    20981: "ليس لديك أي ملاحظات محفوظة",
    20991: "لا  يوجد جديد",
    21001: "لا يوجد مدخلات للعرض",
    21011: "إرسال الردود",
    21021: "المراجع لم يضِف أي تعليقات",
    21031: "تحرير الرد",
    21041: "حذف الرد",
    21051: "بحث في الردود المحفوظة",
    21061: "أضف الرد المحفوظ",
    21071: "اختر مجموعة و عنوان لحفظ هذا الرد",
    21081: "حدد مجموعة أو ابدأ في الكتابة لإنشاء مجموعة",
    21091: "أدخل العنوان هنا",
    21101: "أدخل قالب الرد",
    21111: "يرجى التأكد من تحديد/إنشاء مجموعة وعنوان لحفظ هذا الرد.",
    21121: "الردود التلقائية",
    21131: "إضافة رد تلقائي",
    21141: "حدد مجموعة",
    21151: "أدخل المتغير هنا",
    21161: "اختر متغيراتك",
    21171: "هل تريد المتابعة؟",
    21181: "هذا الطلب يحوي أكثر من 100 مراجعة، سنرسل لك بريداً الكترونياً فيه رابط بتحميل هذه المراجهة بصيغة csv",
    21191: "لديك أكثر من مئة مراجعة",
    21201: "سنرسل لك بريداً الكترونياً (إلى س) فيه رابط تحميل المراجعة بصيغة csv",
    21211: "الإجراءات",
    21221: "كل الموقع",
    21231: "التقييم الوسطي",
    21241: "ماركة",
    21251: "مباشر",
    21261: "اكتشاف",
    21271: "جغرافيا",
    21281: "سعادة",
    21291: "الاستعلامات",
    21301: "الردود",
    21311: "المشاهدات",
    21321: "الجدول الزمني للمنشور",
    21331: "الجدول الزمني للمنشور الخاص بغوغل",
    21341: "إنشاء منشور",
    21351: "إدارة منشور",
    21361: "جدولة منشور محلي",
    21371: "رفع",
    21381: "التقدّم",
    21391: "تثبيت و جدولة",
    21401: "جدولة الحالة",
    21411: "اختيار ملف",
    21421: "حدد نوع الجدول الزمني",
    21431: "فوري",
    21441: "توقيت الملف",
    21451: "اختيار وقت",
    21461: "النشر مباشرة بعد تمام التحقق",
    21471: "الجدولة بناءً على الوقت في الملف",
    21481: "جدولة الملف بالوقت الذي اخترته",
    21491: "رتل",
    21501: "قيد التحقق. وقت المعالجة حوالي 40 منشوراً في الدقيقة. بعد التحقق، حالة كل منشور ستكون موجودة في الصفحة التالية.",
    21511: "تمت معالجة المنشور",
    21521: "تم التحقق بنجاح",
    21531: "لم يتم التحقق بنجاح",
    21541: "مجدولة",
    21551: "نوع/فعل",
    21561: "تواريخ",
    21571: "بداية",
    21581: "نهاية",
    21591: "عنوان/منتج",
    21601: "ملخص المنشور",
    21611: "الحالة",
    21621: "نجاح",
    21631: "باءت بالفشل",
    21641: "تعديل/حذف",
    21651: "أفكار المنشور",
    21661: "أفكار المنشور من غوغل",
    21671: "أداء",
    21681: "مشاهدات المنشور",
    21691: "المنشور حسب الوسائط",
    21701: "المنشور حسب العنوان",
    21711: "المنشور حسب الفعل",
    21721: "تحليل",
    21731: "تم الإنشاء",
    21741: "نوع",
    21751: "عمل",
    21761: "فلتر المصدر",
    21771: "منصة",
    21781: "تحديث حالة المنشور المحلي",
    21791: "باني الحملات",
    21801: "رد تلقائي ذكي",
    21811: "تشغيل باني الحملات ذو الرد التلقائي",
    21821: "قبل تفعيل خيار جدول الرد التلقائي، تأكد من اتباع التعليمات أدناه:",
    21831: "قبل تفعيل الرد التلقائي الذكي تاكد من إضافة قوالب الرد التلقائي الخاصة بك في قسم المراجعات الواردة. أنشئ الردود أولا بحيث يتم تعيينها وفق التقييم بالنجوم (1-5) التي ستفعل الرد التلقائي.",
    21841: "في باني الحملات رجاءً اختر وقت تأخير بين وصول المراجعة و توصيل الرد التلقائي. إعدادات التأخير يجب أن تتوافق مع الرد المثالي على المراجعة.",
    21851: "نرجو أيضا إضافة أوقات العمل (أيام الأسبوع و ساعات اليوم) للحملة. المنطقة الزمنية الافتراضية هي الساعة 00:00+ بتوقيت غرينيتش، لذا رجاءً قم بالتعديل كما يناسب.",
    21861: "إنشاء حملة",
    21871: "حدد اسماً أو أي ملاحظات للتعرف على حملتك بسهولة.",
    21881: "اسم الحملة",
    21891: "مستجيب الحملة",
    21901: "في حال عدم اختيار أي شيء، البريد الالكترني المستعمل للتسجيل و تفعيل الحسابات سيكون المستقبل الافتراضي",
    21911: "مجيب الرد التلقائي",
    21921: "مجال التواريخ للحملة",
    21931: "ملاحظات/أهداف",
    21941: "وصف الحملة",
    21951: "وضع المحفزات",
    21961: "اختر نوع المراجعة/ات التي ستشغل رداً تلقائيا لهذه الحملة",
    21971: "مع تعليق",
    21981: "بدون تعليق",
    21991: "السابق",
    22001: "التالي",
    22011: "حدد جمهور (اختياري)",
    22021: "حدد الموقع ليكون جزءاً من الحملة بناءً على إشارة كينونة، منظمة، أو بلد/منطقة/محلية محددة.هذه الفلترات متاحة فقط لمراجعات غوغل و المواقع الموجودة على الخريطة.",
    22031: "كينونة",
    22041: "منظمة",
    22051: "حدد جدول زمني",
    22061: "حدد معايير و الجدول الزمني لردود المراجعات، مثلا النسبة المئوية للمراجعات المستهدفة و ساعات العمل للردود.",
    22071: "الرجاء العلم بأن خاصية الرد التلقائي فعالة حالياً من لحظة تشغيلها و للردود المستقبلية حصراً. نقوم بتطوير  عمليات منفصلة للمستخدمين المهتمين بالقيام بردود آلية للماضي القريب.",
    22081: "حدد تاريخ استجابة",
    22091: "حدد عدد الاستجابات",
    22101: "تأخير قبل إرسال الرد التلقائي",
    22111: "الجدولة دورياً",
    22121: "اختر اليوم و حدد الوقت لجدولة الرد التلقائي دورياً",
    22131: "اختر المجال الزمني",
    22141: "وظّف الردود",
    22151: "من القائمة، اختر أي الردود لتستعمل بالتناوب في هذه الحملة",
    22161: "تأكيد",
    22171: 'راجع كل التفاصيل أدناه و اضغط "تأكيد" لإطلاق حملتك',
    22181: "أيام",
    22191: "تعليم بنجمة",
    22201: "الوسطي",
    22211: "عملية التقرير",
    22221: "إعداد المنافس",
    22231: "الطرق المثلى",
    22241: "رباعي",
    22251: "تقييمات",
    22261: "التصنيف التنافسي",
    22271: "رد",
    22281: "عرض مصادر المراجعة",
    22291: "إضافة منافس",
    22301: "تمت الفلترة من قبل",
    22311: "واضح",
    22321: "منافس",
    22331: "كينونة المنافس",
    22341: "علامة كيان",
    22351: "تعليقات",
    22361: "لا خيارات",
    22371: "سيء",
    22381: "فقير",
    22391: "وسط",
    22401: "عظيم",
    22411: "ممتاز",
    22421: "المراجعات مع ردود",
    22431: "المراجعات دون رد",
    22441: "مراجعات مع التعليقات",
    22451: "مراجعات بدون تعليقات",
    22461: "حجم المراجعة مقابل التقييم الوسطي",
    22471: "العلامات التجارية",
    22481: "تكبير",
    22491: "إجمالي المراجعات",
    22501: "تقييم المراجعة بالنجوم",
    22511: "مراجعات المنافس",
    22521: "منافس لـ",
    22531: "كود",
    22541: "إدارة المنافسين",
    22551: "تم تحديثه",
    22561: "إضافة منافسين",
    22571: "إضافة موقع",
    22581: "إضافة أسماء المنافسين",
    22591: "The first step is to add the competitor's name, once you have added the names and optional icons (48x48 images) to the list, click on 'Add'. Once the Competitors are created, you will be able to assign the individual locations",
    22601: "أدخل اسم المنافس (مطلوب)",
    22611: "أدخل رابط المنافس (اختياري)",
    22621: "رفع صورة",
    22631: "قريباً",
    22641: "نسبة التعليق  ",
    22651: "النسبة المثوية للمراجعات مع و بدون تعليقات.",
    22661: "بدون",
    22671: "مع",
    22681: "طول التعليق",
    22691: "العدد الوسطي للكلمات المستعملة في كل تعليق في تقييمات النجوم",
    22701: "كلمات",
    22711: "نسبة الكلمة",
    22721: "إجمالي النسبة المئوية للكلمات في التعليقات لكل تقييم يستخدم النجوم",
    22731: "here.",
    22741: "المنافسين",
    22751: "إضافة علامة",
    22761: "Choose variables to be added to the template",
    22771: "close review",
    22781: "Closed review",
    22791: "Do you want to close this review ? Once you close, you will need to reopen it in order to reply",
    22801: "External",
    22811: "Negative",
    22821: "رقم",
    22831: "No auto replies yet!",
    22841: "No saved replies yet!",
    22851: "ملحوظة",
    22861: "Permanently Closed",
    22871: "Positive",
    22881: "Read timed out",
    22891: "Reinstate Review",
    22901: "Re-Open Review",
    22911: "رد",
    22921: "تم إرسال الرد (من واجهة Google).",
    22931: "الرد المرسل من التطبيق",
    22941: "مراجعة إزالة",
    22951: "قوالب",
    22961: "Temporarily Closed",
    22971: "نعم",
    22981: "You don't have any saved drafts",
    22991: "أذونات غير كافية للوصول إلى المورد",
    23001: "خطأ داخلي واجهته",
    23011: "طلب يحتوي على وسيطة غير صالحة",
    23021: "لم يتم العثور على الكيان المطلوب",
    23031: "مراجعة لم تعد موجودة على منصة Google",
    23041: "Some of the Auto insert values are not available. Please replace and Sent",
    23051: "الخدمة غير متوفرة حاليا",
    23061: "هذه العملية غير مدعومة للمواقع غير المطالب بها",
    23071: "منشور البريد",
    23081: "البريد المقرر",
    23091: "اسم ودود",
    23101: "Add friendly name",
    23111: "اتصل",
    23121: "No contacts!",
    23131: "To add contact",
    23141: "اسم جهة الاتصال",
    23151: "Contact E-Mail",
    23161: "إضافة جهة اتصال",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "لايوجد بيانات",
    23201: "Google Audit",
    23211: "سجلات التدقيق",
    23221: "حدد تقرير",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "تنزيل البيانات",
    23271: "مراجعة تنزيل",
    23281: "جميع المراجعات",
    23291: "قم بتنزيل صور URL.",
    23301: "عنوان URL Photo Photo.",
    23311: "URL Photo Merchant.",
    23321: "تقرير التنزيلات التاريخ",
    23331: "Report Name",
    23341: "أرسلت إلى",
    23351: "وقت تم إنشاؤه (UTC)",
    23361: "نوع التقرير",
    23371: "Profile Details",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "تحديث",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "تحميل",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "السيطرة على الإدارة السائبة",
    23721: "تحديث تفاصيل الموقع ومعلمات النظام الأساسي السيطرة مباشرة في أوراق Google.",
    23731: "PLATFORM",
    23741: "إدارة حسابات بسهولة على أي مقياس مع متغيرات وإعدادات الموقع المخصصة.",
    23751: "GBP التفاصيل",
    23761: "عرض جميع قوائم الأعمال Google الخاصة بي وضيف / تحرير / حذف الموقع مباشرة.",
    23771: "سمات GBP.",
    23781: "قم بتعيين جميع السمات المؤهلة لكل موقع لاكتساب اكتشاف البحث الإضافي.",
    23791: "قائمة GBP",
    23801: "إنشاء قائمة GBP الجديدة.",
    23811: "Facebook",
    23821: "السيطرة على قائمة فيسبوك",
    23831: "تاريخ",
    23841: "تمرين",
    23851: "الوصول إلى الموارد لسطح العمل تحرير السائبة وأفضل الممارسات والقيود والتحديثات.",
    23861: "تحذير",
    23871: "المتطلبات:",
    23881: "يجب أن يكون لدى المستخدمين حساب Google بحيث يمكن للنظام تقديم ورقة Google مع بيانات الملف الشخصي.",
    23891: "تنويه:",
    23901: "يتم ملء البيانات كل ورقة إذا من قاعدة بيانات النظام. إذا كنت ترغب في التأكد من أن جدول البيانات يقدم بيانات Google الحالية، نوصي بشدة بمزامنة ملفك الشخصي لأول مرة.",
    23911: 'اعتمادا على عدد المواقع الموجودة في حسابك، قد تستغرق أوراق Google بعض الوقت في البداية في البداية ثم تحديثها أثناء التنقل في الورقة. يرجى التأكد من أن جميع البيانات مستقرة قبل الضغط على "التحديث" لحفظ التعديلات على النظام ودفع التحديثات إلى Google.',
    23921: "يحتوي النظام الأساسي على اتصال API المباشر لدى Google، ولكن قد لا تزال هناك أوقات تتأخر فيها Google التحديث المباشر إلى صفحة قائمة المواقع العامة.",
    23931: 'دفع "التحديث" يؤدي إلى تشغيل نظام مباشر مباشرة إلى Google. لا يوجد عملية تراجع أو عكس المتاحة. يرجى التأكد من أنك مرتاح لجميع التعديلات قبل تشغيل التحديث. إذا تم صنع خطأ، يرجى الانتظار بضع دقائق ثم إجراء التغيير اللازم.',
    23941: "نظام الألوان",
    23951: "تحتوي كل ورقة على نظام ألوان افتراضي لمساعدة المستخدمين على فهم الحقول المؤهلة للتحرير.",
    23961: "المتغيرات التي تنقل تفاصيل الحالة من Google أو لا يمكن تحريرها مباشرة عبر عناصر التحكم السائبة.",
    23971: "متغيرات جوجل مفتوحة مباشرة لبرنامج التعديل بالجملة.",
    23981: "متغيرات منصة مفتوحة مباشرة لتعديل السائبة.",
    23991: "مراقبة",
    24001: "تفاصيل",
    24011: "صفات",
    24021: "إنشاء قائمة",
    24031: "تعليمات",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "/PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 30 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "نشاط",
    24361: "مخول",
    24371: "الاتصالات المعتمدة والوصول إلى إمكانيات المراجعة واستجابة كاملة من / إلى كل مصدر.",
    24381: "التفصيل بالجملة علامات الكيان",
    24391: "السائبة تحميل GBP التفاصيل",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "إنشاء علامة الكيان",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "GBP Detail History",
    24491: "انطباعات",
    24501: "غير نشط",
    24511: "مفهرسة",
    24521: "وصلات مفهرسة الوصول إلى جميع المراجعات التاريخية والحالية من كل مصدر.",
    24531: "Manage LocalPost",
    24541: "لم أضبط أي تعليق",
    24551: "عدد",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "حفظ الرد",
    24601: "مجموع الموقع",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "تحميل مستعار الموقع",
    24641: "رأي",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "منفصل",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Choose File",
    24911: "No file chosen",
    24921: "عرض سجل من كل تحديث دفع لتأكيد تغييرات المحتوى في قائمة وتحديد أي أخطاء.",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "معرف المستخدم",
    24961: "Do you want to delete?",
    24971: "حساب",
    24981: "لا يوجد لديه تحديثات جوجل",
    24991: "التبجيل غير مطلوب",
    25001: "No pending edits",
    25011: "وقت مراجعة الحسابات",
    25021: "حقل",
    25031: "القيمة (إلى)",
    25041: "القيمة (من)",
    25051: "remove from entity tag",
    25061: "عوده",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "يستكشف",
    25111: "استكشاف الردود",
    25121: "حدد قالب",
    25131: "يكمل",
    25141: "اختر تصنيف النجوم واسم القالب وإضافة محتوى القالب لحفظ الرد التلقائي.",
    25151: "حدد نوع الرد",
    25161: "نموذج",
    25171: "مقتطف",
    25181: "تعيين للتصنيف (مطلوب)",
    25191: "أدخل اسم القالب (مطلوب)",
    25201: "متغير قالب مخصص",
    25211: "حدد أو إنشاء موضوع (اختياري)",
    25221: "تعيين إلى موقع واحد",
    25231: "تعيين لعلامة الكيان",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "الموقع ملاحظة",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "انظر المراجعة مباشرة على Google",
    25301: "Positive-5 Stars",
    25311: "Negative - 1/2 Stars",
    25321: "Mixed - 3/4 Stars",
    25331: "اسم القالب",
    25341: "عامل",
    25351: "حدد أو إنشاء موضوع",
    25361: "مجموعة",
    25371: "عنوان",
    25381: "الاستعراضات السابقة",
    25391: "حفظ كرد",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "إنشاء تاريخ",
    25441: "اسم تصفية مخصص",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "تحميل",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "الصفحة الافتراضية الصفحة",
    25691: "مراجعات الوارد",
    25701: "الإدارة السائبة",
    25711: "جدولة بعد",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn of Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "معدل الاستجابة",
    25781: "استجابة العد",
    25791: "تصنيفات النجوم",
    25801: "مع",
    25811: "بدون",
    25821: "تأخير",
    25831: "وحدة زمنية",
    25841: "مراجعة",
    25851: "Competitor Report",
    25861: "صيغة",
    25871: "HTML Email",
    25881: "Excel",
    25891: "إذا لم تكن هناك مراجعات في النطاق المحدد",
    25901: "لا ترسل البريد الإلكتروني",
    25911: "ارسل بريد الكتروني",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "يرجى الاتصال بدعم مع أي أسئلة حول ملف التعريف Sync Cadence",
    25971: "Include Audit File",
    25981: "الملف الشخصي",
    25991: "CompTag",
    26001: "مراجعة التفاصيل",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "مخطط إجراءات العملاء لاتجاه القيادة والمكالمات الهاتفية ونقرات الموقع.",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings.",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size.",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users.",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses.",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Yesterday",
    27251: "Last 7 days",
    27261: "Last week",
    27271: "Last 30 days",
    27281: "Last month",
    27291: "كل الوقت",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "حفظ هذا الرد",
    27341: "Select or create a group",
    27351: "لا ردود حفظ",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "جميع المواقع",
    27451: "مراجعاتي",
    27461: "Google Updates",
    27471: "Missing Content",
    27481: "رمز تخزين",
    27491: "Additional Categories",
    27501: "مواقع البحث",
    27511: "جي دبي التدقيق",
    27521: "نشاط السائبة",
    27531: "اختر مجموعة",
    27541: "20/ page",
    27551: "مزامنة",
    27561: "ضبط الجمهور",
    27571: "منتهي",
    27581: "Group Name",
    27591: "دقيقة",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "تحليل الربع",
    27631: "جميع المواقع بيانات",
    27641: "البحث العالي + تحويل منخفض",
    27651: "البحث العالي + تحويل عال",
    27661: "بحث منخفض + تحويل منخفض",
    27671: "بحث منخفض + تحويل عالٍ",
    27681: "بيانات الموقع حسب المنطقة",
    27691: "بيانات الموقع من قبل المدينة",
    27701: "Location:",
    27711: "Conversion Rate:",
    27721: "Searches:",
    27731: "Google Q&A",
    27741: "Google QA",
    27751: "Download QA",
    27761: "آخر إجابة",
    27771: "نشر البصيرة",
    27781: "Download the sample CSV",
    27791: "Pre populated CSV",
    27801: "Manage Portfolio",
    27811: "Add Portfolio",
    27821: "View Portfolio",
    27831: "Delete Portfolio",
    27841: "المستخدمون",
    27851: "Manage Profiles",
    27861: "Remove Profile",
    27871: "Are you sure you want to Remove this profile ?",
    27881: "Accounts",
    27891: "Select Profiles",
    27901: "Select Profile",
    27911: "Portfolio Account",
    27921: "Portfolio Details",
    27931: "Portfolio Name",
    27941: "Currrent Portfolio Image",
    27951: "Upload image as a logo for portfolio",
    27961: "Change portfolio name",
    27971: "Free Trial",
    27981: "Current",
    27991: "Expired",
    28001: "Cancelled",
    28011: "Invoicing",
    28021: "متصل",
    28031: "Number of Accounts",
    28041: "Total Locations",
    28051: "Active Locations",
    28061: "Reviews (30 days)",
    28071: "Payment Status",
    28081: "Profile Name",
    28091: "Enter name of new portfolio",
    28101: "A portfolio can bulk manage their users across different profiles easily",
    28111: "Name of new portfolio",
    28121: "Portfolio names can only have a maximum of 20 characters",
    28131: "Portfolio Created Successfully!",
    28141: "Total Profile",
    28151: "Total Users",
    28161: "Enter email",
    28171: "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role.",
    28181: "Invite",
    28191: "Current Portfolio Image",
    28201: "Sentiment",
    28211: "Awaiting",
    28221: "المزيد من المرشحات",
    28231: "Review Tag",
    28241: "المرشحات المحفوظة",
    28251: "فلاتر أقل",
    28261: "No Text",
    28271: "Medium",
    28281: "Expand",
    28291: "Single image upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "يفتح",
    28471: "مغلق",
    28481: "إزالة",
    28491: "مراجعة علامة جديدة",
    28501: "كل التعليقات",
    28511: "لا شيء لاظهار في هذا النطاق!",
    28521: "بحث",
    28531: "اختر الكل",
    28541: "مصدر البحث",
    28551: "بحث علامة مراجعة",
    28561: "موقع البحث",
    28571: "رمز متجر البحث",
    28581: "مجموعة البحث",
    28591: "المنظمات",
    28601: "علامات الكيان",
    28611: "تطبيق",
    28621: "مجموعة",
    28631: "البحث المحفوظ مرشحات",
    28641: "لا يوجد خيارات!",
    28651: "ضبط عرض نص المراجعة",
    28661: "انظر استعراض مباشرة على",
    28671: "رد منصة الاستعراض على",
    28681: "حدد قالب",
    28691: "ينسخ",
    28701: "التعليقات السابقة",
    28711: "لم يتم تقديم تعليقات",
    28721: "تقييم",
    28731: "رد الموقع اسم يقم بإضافة في هذا الموقع",
    28741: "التوقيع يقم بإضافة في هذا الموقع",
    28751: "هل ترغب في الاستمرار في التحميل؟",
    28761: "استعراض دون رد",
    28771: "المراجعات مع الرد الداخلي",
    28781: "مراجعات مع تلقائي",
    28791: "المراجعات مع الرد الخارجي",
    28801: "عرض لوحة المعرفة جوجل",
    28811: "الموقع ملاحظة",
    28821: "مدير جديد",
    28831: "تمكين نسخة",
    28841: "حفظ باسم رد",
    28851: "حذف الرد",
    28861: "مجموعة",
    28871: "مختلط",
    28881: "نجوم",
    28891: "سلبي، مختلط، إيجابي",
    28901: "تقييم",
    28911: "اسم القالب",
    28921: "عامل",
    28931: "حفظ الرد",
    28941: "تحرير اسم الحساب",
    28951: "تغيير اسم الحساب",
    28961: "إسم الحساب",
    28971: "مواقع الفيسبوك",
    28981: "إضافة صفحة",
    28991: "مفعل",
    29001: "إظهار الموقع المخفي",
    29011: "عرض صفحة FB",
    29021: "لا حساب مخفي لإظهار",
    29031: "منذ ساعات",
    29041: "الدعوة",
    29051: "مراجعة عرض",
    29061: "مواقع جوجل",
    29071: "مواقعك",
    29081: "عنوان URL الموقع",
    29091: "هل أنت متأكد أنك تريد حذف عنوان URL هذا؟",
    29101: "هل ترغب في حذف عنوان URL وبياناته ذات الصلة من التطبيق؟",
    29111: "مواقع المنافس",
    29121: "اسم المنافس",
    29131: "معرف المكان",
    29141: "كومبتاج",
    29151: "أدخل موقع عناوين URL وتفاصيل المنافسة",
    29161: "iscompetitor.",
    29171: "مواقع الحجز",
    29181: "لبدء حجز تكامل مراجعة",
    29191: "معرف موقع المكتب الخلفي (اختياري)",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "إنشاء حملات للاستجابة مباشرة للاستعراضات مع الاستجابة المثالية في الوقت المثالي",
    29301: "هل أنت متأكد أنك تريد حذف هذه الحملة؟",
    29311: "نسخ الاستعراضات الذكية لكل مدير الموقع المعين",
    29321: "ردود CC على مديري الموقع المعين",
    29331: "ردود CC على الشركات",
    29341: "المستفيدون",
    29351: "جميع المستفيدين",
    29361: "حدد مراجعة المصدر",
    29371: "حانة / sub فقط",
    29381: "حدد تصنيف النجوم",
    29391: "حدد مراجعة المحتوى",
    29401: "مجموعة مخصصة",
    29411: "تعيين تأخير قبل إرسال الرد التلقائي",
    29421: "تعيين ساعات العمل",
    29431: "اختياري",
    29441: "لا توجد مواقع تم تعيينها",
    29451: "لم تكن هناك نظرة ثاقبة لمجموعة التاريخ والمعايير المحددة.",
    29461: "تصفية القائمة",
    29471: "نوع",
    29481: "وجهات النظر في البحث",
    29491: "وجهات النظر في الخرائط",
    29501: "ليس لديك أذونات كافية لنشر الرد.",
    29511: "أرسلت مسبقا",
    29521: "تحميل قوالب AR.",
    29531: "أتباع العد",
    29541: "آخر مزامنة",
    29551: "شركة كبرى",
    29561: "وكالة",
    29571: "محلية ممكنة",
    29581: "لا في انتظار التحقق",
    29591: "انقر لعرض هذا الاستعراض في صندوق الوارد",
    29601: "اقرأ أكثر",
    29611: "تحميل",
    29621: "مجموع (عدد) البنود",
    29631: "التحقق من جوجل تجاري",
    29641: "علامة",
    29651: "أضف ساعات",
    29661: "اليوم",
    29671: "عنوان الشارع",
    29681: "رمز بريدي",
    29691: "يحدد كما المملوكة باللون الأسود",
    29701: "إضافة رابط",
    29711: "بريد",
    29721: "تواصل بالبريد الاكتروني",
    29731: "Covid_19 Update.",
    29741: "التغييرات في عملك؟",
    29751: "الحملة الانتخابية",
    29761: "النظام عبر الإنترنت",
    29771: "يشتري",
    29781: "اتصل الان",
    29791: "حاليا",
    29801: "مزامنة هذا الموقع؟",
    29811: "قائمة فيسبوك",
    29821: "إنشاء قائمة جديدة فيسبوك",
    29831: "المحدد",
    29841: "تفاصيل الأعمال",
    29851: "جهات الاتصال",
    29861: "المتغيرات",
    29871: "المعرف الداخلي",
    29881: "انقر للاتصال",
    29891: "العودة إلى التحميل",
    29901: "انظر Q & A على Google",
    29911: "يتطلب",
    29921: "إبطال",
    29931: "مراجعة تأكيد وثيق",
    29941: "استعراض رد التأكيد",
    29951: "مراجعة تأكيد إزالة",
    29961: "منطقة",
    29971: "الإجابة على هذا السؤال",
    29981: "يدير",
    29991: "إنشاء جوجل post.",
    30001: "إدارة جوجل ما بعد",
    30011: "إخفي الموقع",
    30021: "حدد الصفحة الحالية",
    30031: "إنشاء بريد الفيسبوك",
    30041: "إدارة بريد الفيسبوك",
    30051: "امسح الكل",
    30061: "حفظ مرشح",
    30071: "البحث عن الدور.",
    30081: "بحث المستخدم",
    30091: "جميع المحررين",
    30101: "تعيين لتصنيف (مطلوب)",
    30111: "أدخل اسم القالب (مطلوب)",
    30121: "متغير قالب مخصص (اختياري)",
    30131: "حدد أو إنشاء موضوع (اختياري)",
    30141: "تعيين موقع واحد (اختياري)",
    30151: "تعيين لعلامة الكيان (اختياري)",
    30161: "مراجعة المتغيرات",
    30171: "الاسم الأول للمراجع",
    30181: "الاسم الكامل للمراجع",
    30191: "متغيرات الموقع",
    30201: "اسم موقع الرد",
    30211: "اسم الموقع الجغرافي",
    30221: "تم بالفعل إرسال الرد لهذا الاستعراض.",
    30231: "لا يمكن إرسال ردود لهذا الاستعراض بعد الآن. يمكنك حذف هذا الرد لإزالته من هنا.",
    30241: "هل ترغب في مزامنة بيانات هذا الموقع؟ سيؤدي ذلك إلى سحب جميع التحديثات المقدمة إلى الموقع.",
    30251: "دع العملاء يعرفون أي تغييرات على عملك بسبب CovID-19",
    30261: "ارسل الان",
    30271: "البحث معرض",
    30281: 'استخدم عناصر التحكم على اليمين في إنشاء معرض المراجعة الدقيقة. انقر فوق الزر "تطبيق" لتحميل المعاينة الفورية',
    30291: "بناء معرض المراجعة الخاصة بك",
    30301: "عرض التفاصيل",
    30311: "اسم هذا المعرض",
    30321: "الموقع الفردي",
    30331: "مجموعة الموقع",
    30341: "عرض العنوان",
    30351: "إخفاء",
    30361: "مشارك الصورة / الصورة الرمزية",
    30371: "تبين",
    30381: "حدد مراجعة Set.",
    30391: "مراجعة المصادر",
    30401: "مراجعات من",
    30411: "إنشاء معرض",
    30421: "التصنيف الأدنى",
    30431: "تصنيف فقط الاستعراضات",
    30441: "تحديد العرض",
    30451: "استعراض الحد الأقصى",
    30461: "ماكس تعليق طوله",
    30471: "الاستعراضات القصوى لكل صفحة",
    30481: "تصميم متجاوب",
    30491: "امر ترتيب",
    30501: "الأحدث أولاً",
    30511: "تصنيف النجوم اللون",
    30521: "مراجعة ال��عليقات",
    30531: "مصدر مصدر",
    30541: "تاريخ المراجعة",
    30551: "تاريخ دقيق",
    30561: "خط العائلة",
    30571: "عرض حجم العنوان",
    30581: "اسم المعلق الحجم",
    30591: "تعليق الحجم",
    30601: "تعيين تجاوز",
    30611: "دبوس الى أعلى الصفحة",
    30621: "استبعاد",
    30631: "مشاريعي",
    30641: "يحتاج إلى مساعدة",
    30651: "في انتظار العملاء",
    30661: "فى انتظار التقييم",
    30671: "ردود فعل جديدة",
    30681: "اسم البحث",
    30691: "غيرمعتمد",
    30701: "تم التحديث بنجاح",
    30711: "اسم محتوى الحملة (اختياري)",
    30721: "الشروط والأحكام (اختياري)",
    30731: "هل أنت متأكد أنك تريد إزالة هذا المستخدم؟ بمجرد إزالتها، لن يتمكن المستخدم من الوصول إلى هذا الملف الشخصي، إلا إذا تمت دعوته.",
    30741: "هل ترغب في إزالة هذا المستخدم؟",
    30751: "توزيع الاستجابة",
    30761: "سوف نرسل رسالة بريد إلكتروني () مع رابط لتنزيل المراجعة CSV.",
    30771: "يحتوي هذا الملف الشخصي على أكثر من 100 موقع. سوف نرسل لك رسالة بريد إلكتروني مع رابط التنزيل",
    30781: "رد المستخدم",
    30791: "أجاب مارك",
    30801: "الرد الوجهة",
    null: "Months of Year",
    30811: "لوحة معلومات التقييمات",
    30812: "نظرة عامة ",
    30813: "متوسط",
    30814: "متوسط التقييم",
    30815: "موقع",
    30816: "السعادة",
    30817: "نسبة الكلمات",
    30818: "نسبة الاستجابة",
    30819: "المراجعة حسب المصدر",
    30820: "المراجعة حسب التقييم",
    30821: "الاستجابة حسب التقييم",
    30822: "المراجعات الأخيرة",
    30823: "لقد تلقيت {x} مراجعات في الأيام {x} الماضية. ها هي الأحدث",
    30824: "عدد المراجعات المتوسط لكل موقع رئيسي خلال النطاق الزمني",
    30825: "نسبة المراجعات التي حصلت على تقييمات 4 نجوم و5 نجوم",
    30826: "درجة السعادة هي عرض لنسبة المراجعات الإيجابية مطروحًا منها نسبة المراجعات السلبية",
    30827: "نسبة جميع التعليقات الموجودة في المراجعات ذات 5 نجوم و4 نجوم مقارنة بجميع الكلمات التي تم مشاركتها خلال النطاق الزمني. النطاق يتراوح من 5 نجوم إلى 1 نجمة.",
    30828: "نسبة المراجعات داخل الإطار الزمني التي تلقت ردًا.",
    30829: "انخفاض في {x data} من {xx} الأيام السابقة",
    30830: "زيادة في {x data} من {xx} الأيام السابقة",
    30831: "لا يوجد تغيير في {x data} من {xx} الأيام السابقة",
    30832: "انقر لعرض هذه المراجعات",
    30833: "(اسم المكان) , (x) نجوم, المراجع: (x)",
    30834: "المراجعات والتقييم المتوسط",
    30835: "عدد التقييمات على مدار الوقت مكدسة حسب تصنيف النجوم + مخطط خطي لمتوسط التقييم.",
    30836: "النسبة المئوية حسب تصنيف النجوم",
    30837: "عدد التقييمات على مدار الوقت مكدسة حسب تصنيف النجوم كنسبة مئوية من الإجمالي.",
    30838: "العدد التراكمي & متوسط التقييم",
    30839: "إجمالي المراجعات ومتوسط التقييم للفترة الزمنية للتقرير.",
    30840: "المراجعات حسب المصدر",
    30841: "عدد المراجعات على مدار الفترة حسب المصدر.",
    30842: "درجة السعادة مع مرور الوقت",
    30843: "صافي درجة السعادة لكل فترة زمنية على مدى نطاق التقرير.",
    30844: "يوم من أيام الأسبوع",
    30845: "يوم من الشهر",
    30846: "شهر من السنة",
    30847: "أهم البلدان",
    30848: "أهم الولايات",
    30849: "أهم المدن",
    30850: "الردود",
    30851: "معدل الرد السريع",
    30852: "الوسيط",
    30853: "عدد الردود المنشورة خلال الفترة الزمنية والمتوسط لكل موقع.",
    30854: "نسبة المراجعات التي تتلقى ردًا في غضون يومين ووقت الاستجابة الوسيط.",
    30855: "عدد الردود والنسبة",
    30856: "عدد الردود حسب تقييم النجوم ونسبة الرد الإجمالية.",
    30857: "متوسط وقت الاستجابة",
    30858: "متوسط وقت الاستجابة بالأيام.",
    30859: "توزيع الردود",
    30860: "مخطط بياني زمني لمدة استجابة المراجعة مقسم إلى 10 مستويات.",
    30861: "سعيد",
    30862: "نسبة",
    30863: "مدى الحياة",
    30864: "عدد سجلات الموقع الأصلية، بالإضافة إلى سجلات الإدراج غير المرسومة.",
    30865: "طاقة",
    30866: "نسبة التعليقات",
    30867: "طول التعليق",
    30868: "فجوة النسبة",
    30869: "فجوة الطول",
    30870: "المراجعات مع وبدون تعليقات",
    30871: "متوسط الكلمات لكل تصنيف نجوم",
    30872: "النسبة المئوية للكلمات في كل تصنيف نجوم",
    30873: "نسبة نسبة التعليقات",
    30874: "النسبة المئوية لجميع المراجعات التي تتضمن تعليقات العملاء",
    30875: "عدد الكلمات في التعليق",
    30876: "متوسط عدد الكلمات المحتواة في التقييمات مع التعليقات",
    30877: "توزيع الكلمات في التعليقات",
    30878: "نسبة الكلمات في كل تصنيف نجمي لكل فترة زمنية",
    30879: "نسبة المراجعات الإيجابية مع التعليقات ناقص نسبة المراجعات السلبية.",
    30880: "متوسط طول المراجعات الإيجابية ناقص متوسط طول المراجعات السلبية.",
    30881: "المراجعات مع معدل الاستجابة",
    30882: "معدل طول التعليق",
    30883: "عرض الشبكة",
    30884: "الموقع المتوسط",
    30885: "متوسط درجة مراجعة المواقع ونسبة المواقع التي تزيد عن 4.0 تقييم في نطاق الزمن.",
    30886: "مصفوفة أداء المراجعات",
    30887: "عرض متوسط تصنيف الموقع مقابل حجم المراجعات لتحديد القيم الشاذة",
    30888: "مشاعر",
    30889: "تأثير",
    30890: "لوحة معلومات الأداء",
    30891: "شبكة القيادة",
    30892: "إجمالي المشاهدات",
    30893: "معدل التحويل",
    30894: "إجمالي المشاهدات ومتوسط المشاهدات لكل موقع.",
    30895: "عرض الخريطة على سطح المكتب والجوال مع تقسيم النسبة المئوية.",
    30896: "عرض البحث المحلي على سطح المكتب والجوال مع تقسيم النسبة المئوية.",
    30897: "إجمالي الإجراءات مع تقسيم النسبة المئوية بين المكالمات والنقرات على الموقع واتجاهات القيادة.",
    30898: "معدل التحويل الإجمالي للإجراءات/المشاهدات للمكالمات والنقرات على الموقع واتجاهات القيادة.",
    30899: "عرض العملاء",
    30900: "كيف وأين يرى العملاء نشاطك التجاري.",
    30901: "إجراءات العملاء",
    30902: "الإجراءات القابلة للتتبع من قوائم Google الخاصة بك.",
    30903: "نسبة مرات الظهور لقوائم الأنشطة التجارية التي تؤدي إلى إجراء",
    30904: "الفعالية حسب الموقع",
    30905: "إجمالي المشاهدات مقابل معدل التحويل (الإجراءات/المشاهدات) لإظهار فعالية كل موقع في توليد المشاهدات وتحويلها إلى إجراءات.",
    30906: "الفعالية حسب المدينة",
    30907: "إجمالي المشاهدات مقابل معدل التحويل (الإجراءات/المشاهدات) لكل مدينة.",
    30908: "الفعالية حسب المجموعة",
    30909: "إجمالي المشاهدات مقابل معدل التحويل (الإجراءات/المشاهدات) لكل مجموعة مخصصة.",
    30910: "مرات ظهور عالية + تحويل منخفض",
    30911: "مرات ظهور عالية + تحويل عالي",
    30912: "مرات ظهور منخفضة + تحويل منخفض",
    30913: "مرات ظهور منخفضة + تحويل عالي",
    30914: "موبايل",
    30915: "مبحث",
    30916: "مابس",
    30917: "دي سيرش",
    30918: "دي مابس",
    30919: "موقع",
    30920: "مكالمات",
    30921: "درجة الصحة",
    30922: "الأداء اليومي",
    30923: "حدد المواقع من الجدول والمقياس (المشاهدات أو الإجراءات)",
    30924: "معدل السعادة",
    30925: "اسم/ودود",
    30926: "{x} مواقع بمتوسط {y} نجوم في آخر {xx} يومًا",
    30927: "فوق",
    30928: "مجموعة",
    30929: "جميع المشاهدات",
    30930: "جميع الإجراءات",
    30931: "سطح المكتب",
    30932: "تم الوصول إلى الحد الأقصى: حدد ما يصل إلى 8 مواقع للرسم البياني.",
    30933: "المراجع",
    30934: "الإحساس العام",
    30935: "توزيع درجة المشاعر عبر {XX} موضوعًا.",
    30936: "المشاعر حسب الموضوع",
    30937: "تكرار الموضوع ودرجات المشاعر المقابلة.",
    30938: "إيجابي جداً",
    30939: "سلبي جداً",
    30940: "تم تفعيل قاعدة أتمتة لمراجعة جديدة على",
    30941: "تم تفعيل قاعدة أتمتة لمراجعة محدثة على",
    30942: "وافق على الرد على",
    30943: "أسند وسمًا",
    30944: "أسند المراجعة إلى",
    30945: "في",
    30946: "تم إرسال الرد التلقائي",
    30947: "أنشأ مالك العمل ردًا خارجيًا جديدًا على",
    30948: "بواسطة قاعدة أتمتة على",
    30949: "بواسطة النظام على",
    30950: "أنشأ جديدًا",
    30951: "أنشأ ردًا جديدًا على",
    30952: "أنشأ ملاحظة مراجعة لـ",
    30953: "حذف ملاحظة على",
    30954: "حذف ملاحظة مراجعة على",
    30955: "حذف الرد على",
    30956: "حرر الرد على",
    30957: "من",
    30958: "أنشأ ردًا تلقائيًا على",
    30959: "محلي",
    30960: "إشعار",
    30961: "أُبلغ",
    30962: "نظرة عامة",
    30963: "تم",
    30964: "استجابة",
    30965: "تم نقل الرد إلى صندوق الموافقة في",
    30966: "تم نقل الرد إلى البريد الصادر وجدولته للنشر",
    30967: "تم نشر الرد على",
    30968: "مراجعة مخصصة لـ",
    30969: "مراجعة على",
    30970: "مراجعة مستلمة من",
    30971: "أرسل ملاحظة إلى",
    30972: "النظام عيّن علامة لغة",
    30973: "قام النظام بتعيين رد تلقائي في",
    30974: "علامات",
    30975: "فريق بواسطة قاعدة الأتمتة في",
    30976: "الجدول الزمني",
    30977: "إلى",
    30978: "قام بتحديث",
    30979: "قام بتحديث ملاحظة مراجعة في",
    30980: "قام بتحديث تقييم المراجعة من",
    30981: "قام بتحديث حالة المراجعة من",
    30982: "قام بتحديث حالة المراجعة إلى",
    30983: "قام بتحديث التعليق على",
    30984: "عبر API خلال",
    30985: "عبر Pub-Sub في",
    30986: "لم تتم إضافة أي تعليقات.",
    30987: "في",
    30988: "النظام",
    30989: "بواسطة",
    30990: "تم أخذ مهمة المراجعة من",
    30991: "مخصص لـ",
    30992: "العلامة المطبقة",
    30993: "مجموعة العلامات المعينة",
    30994: "تمت إزالة علامة:",
    30995: "مراجعة مع تحديثات",
    30996: "مراجعة بدون تحديثات",
    30997: "تحديد جميع العلامات",
    30998: "تحديد غير الموسوم",
    30999: "في انتظار الموافقة",
    31000: "الأقدم أولاً",
    31001: "ليس لديك أي ملاحظات محفوظة",
    31002: "الرد في صندوق الصادر",
    31003: "إصدارات المراجعة",
    31004: "تفاصيل المراجعة",
    31005: "فتح المعلومات",
    31006: "علاقات",
    31007: "خطأ",
    31008: "أساسي",
    31009: "فئات",
    31010: "روابط اجتماعية",
    31011: "تمت إزالة الصورة الأصلية بواسطة المستخدم أو المنصة."
  },
  italian: {
    1001: "Signing up signifies you’ve read and agree to our ",
    1002: "Terms of Service",
    1003: "and",
    1004: "Privacy Policy",
    1005: ".",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "Cumulativo",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "Recensioni del team",
    2029: "Automatizzare",
    2030: "Completo",
    2031: "Assegnato",
    2032: "Ricerca utente",
    2033: "Invia una email",
    2034: "Comporre",
    2035: "AI Risposta",
    2036: "Inviare una risposta",
    2037: "Rigenerare",
    2038: "Approvazione",
    2039: "Messaggio su Source",
    2040: "Risposta inviata",
    2041: "Nessun messaggio inviato",
    2042: "Libero",
    2043: "Chiuso",
    2044: "Nessun testo di risposta trovato",
    2045: "Copiare la risposta e andare alla fonte",
    2046: "Modificare la risposta",
    2047: "Approva la risposta",
    2048: "Aggiorna risposta",
    2049: "Cancellare la risposta",
    2050: "Sei sicuro di voler cancellare questa risposta?",
    2051: "Sei sicuro di voler inviare questa risposta?",
    2052: "Volete ripristinare questa recensione?",
    2053: "Sei sicuro?",
    2054: "Sei sicuro di voler approvare questa risposta?",
    2055: "Squadre",
    2056: "Solovalut azione",
    2057: "Valutazione + Commento breve",
    2058: "Valutazione + commento",
    2059: "Recensione per lingua",
    2060: "Indicare unalunghezza del commento compresa tra 1 e 100. Il valore predefinito è di 20 caratteri.",
    2061: "Copiare le risposte alle recensioni intelligenti a ciascun responsabile di sede assegnato",
    2062: "Registrazione",
    2063: "Indirizzo e-mail",
    2064: "Non hai un account?",
    2065: "Nome di battesimo",
    2066: "Cognome",
    2067: "Azienda",
    2068: "Nome della ditta",
    2069: "Hai già un account?",
    2070: "Mostra password",
    2071: "Nascondi password",
    2072: "Conversione locale",
    2073: "Mappe Mobile",
    2074: "Mappe Desktop",
    2075: "Cerca Mobile",
    2076: "Cerca Desktop",
    2077: "Viste di ricerca",
    2078: "Visualizzazioni della mappa",
    2081: "Universale",
    2091: "Per Argomento",
    10010: "1 stella",
    10013: "2 stelle",
    10016: "3 stelle",
    10019: "4 stelle",
    10022: "5 stelle",
    10025: "100-300 parole",
    10120: "Azioni",
    10123: "Attivare",
    10124: "Sempre attivo",
    10126: "Organizzazioni attive",
    10129: "Aggiungere",
    10132: "Aggiungi un pulsante",
    10135: "Aggiungi un pulsante (opzionale)",
    10138: "Aggiungi account",
    10141: "AGGIUNGI TELEFONO AGGIUNTIVO",
    10144: "Aggiungi un account",
    10147: "AGGIUNGI UN ALTRO CATEGORIA",
    10150: "AGGIUNGI UN ALTRO ETICHETTA",
    10153: "Aggiungi attributi",
    10156: "Aggiungi linea",
    10159: "AGGIUNGI NUOVA DATA",
    10162: "Aggiungi nuovo tag di recensione",
    10165: "Aggiungi nuovo ruolo",
    10168: "Aggiungi data di apertura",
    10171: "Aggiungi profilo",
    10174: "Nuovo rapporto",
    10177: "Aggiungi rapporto",
    10180: "Aggiungi ruolo",
    10181: "Aggiungi tag recensione",
    10183: "Categoria aggiuntiva",
    10186: "Telefono aggiuntivo",
    10189: "Indirizzo",
    10192: "ADMIN",
    10195: "Amministratore",
    10198: "estensioni di località adWords",
    10201: "Telefono con estensioni di località adWords",
    10204: "Tutti",
    10207: "Tutte le recensioni",
    10210: "Tutti gli utenti assegnati a questo ruolo avranno accesso alle seguenti funzionalità",
    10213: "Fare domanda a",
    10216: "Posta in arrivo di approvazione",
    10219: "Sei sicuro di voler reimpostare la password di questo utente?",
    10222: "Sei sicuro?",
    10225: "La zona",
    10228: "le zone",
    10231: "attributi",
    10234: "Autorizza account",
    10237: "Media",
    10240: "Quantità media",
    10243: "Voto medio",
    10244: "Avg. Valutazione",
    10246: "Media per posizione",
    10249: "In attesa di risposta",
    10320: "Indietro",
    10321: "torna all'amministratore",
    10323: "Fatturazione",
    10326: "Libro",
    10329: "Post di caricamento collettivo",
    10332: "Tag di caricamento collettivo",
    10335: "Caricamento in blocco TSV",
    10338: "Nome commerciale",
    10520: "Calendario",
    10523: "Annulla",
    10526: "Impossibile caricare la mappatura della posizione principale!",
    10529: "Categoria",
    10532: "Cambia ruolo",
    10535: "Storia delle citazioni",
    10538: "Città",
    10541: "Clicca qui",
    10544: "Fai clic su un utente per assegnargli questo ruolo",
    10547: "CO",
    10548: "conferma password",
    10550: "copia",
    10553: "Copia e incolla",
    10556: "Impossibile cambiare ruolo!",
    10559: "Impossibile caricare il post",
    10562: "Paesi",
    10565: "Paese",
    10568: "codice coupon",
    10571: "Codice coupon (opzionale)",
    10574: "Crea un nuovo filtro selezionando le opzioni seguenti",
    10577: "Crea nuovo filtro",
    10580: "Crea nuovo rapporto",
    10583: "Crea post",
    10586: "Crea tag",
    10589: "Crea questo rapporto",
    10592: "Crea questo ruolo",
    10595: "Creato da",
    10598: "Azioni del cliente",
    10720: "G",
    10723: "Pannello di controllo",
    10726: "Data",
    10729: "Intervallo di date",
    10732: "Giorno",
    10735: "Disattivare",
    10738: "PREDEFINITO",
    10741: "Ritardo prima della pubblicazione",
    10744: "Ritardare l'invio di risposte entro il",
    10747: "Ritardare l'invio di risposte entro il",
    10750: "Elimina",
    10753: "Elimina ?",
    10754: "Elimina profilo",
    10756: "desc",
    10759: "Descrizione",
    10762: "Diretto",
    10765: "Domande dirette",
    10768: "Indicazioni",
    10771: "Scoperta",
    10774: "Vista distinta",
    10777: "Scarica tutti i dati sulla posizione",
    10780: "Scarica",
    10783: "Scarica i dettagli sulla posizione di Google",
    10786: "Scarica i dati",
    10789: "bozze",
    10792: "Indicazioni stradali",
    10795: "Indicazioni stradali di giorno",
    10920: "Modificare",
    10923: "Modifica Profilo",
    10926: "Modifica rapporto",
    10929: "Modifica questo rapporto",
    10932: "editore",
    10935: "E-mail",
    10938: "Tempo scaduto",
    10941: "Inserisci le estensioni di località di AdWords",
    10944: "Inserisci il nome del tag entità",
    10947: "Inserisci etichette",
    10950: "Inserisci il testo da cercare",
    10953: "Inserisci il nome del tag",
    10956: "Equivale",
    10959: "Evento",
    10962: "dettagli dell'evento",
    10965: "Titolo dell'evento",
    10968: "Ogni",
    10971: "example.com",
    10974: "Esempio: sconto del 20% in negozio o online",
    11120: "Gestione dell'accesso alle funzioni",
    11123: "Filtri",
    11126: "Ha dimenticato la password?",
    11129: "Venerdì",
    11320: "Ottieni offerta",
    11323: "Più grande di",
    11520: "Valutazione della felicità",
    11525: "Aiuto",
    11530: "Vacanza",
    11535: "Ora",
    11540: "Ore",
    11545: "Come i clienti cercano la tua attività",
    11720: "Immagine",
    11723: "URL dell'immagine",
    11726: "In Maps",
    11729: "In cerca",
    11732: "Posta in arrivo",
    11735: "Query indirette",
    11738: "Intuizioni",
    11741: "Autorizzazione insufficiente",
    11744: "Integrazione",
    11747: "integrazioni",
    11750: "Invita l'utente",
    11753: "INVITATO",
    11756: "Invitato da",
    11759: "elementi",
    12120: "Pannello delle conoscenze",
    12320: "etichette",
    12323: "Ultimo accesso",
    12326: "Ultimo aggiornamento",
    12329: "Per saperne di più",
    12332: "Meno di",
    12335: "Link per il tuo pulsante",
    12338: "Link per riscattare l'offerta",
    12341: "Link all'offerta di riscatto (opzionale)",
    12344: "collegamento",
    12347: "Gestione degli elenchi",
    12350: "Performance locale",
    12353: "Panoramica delle prestazioni locali",
    12356: "Conversione ricerca locale",
    12359: "Località",
    12362: "Località",
    12365: "Posizione",
    12368: "Dettagli sulla posizione",
    12371: "ID posizione",
    12374: "Posizioni",
    12377: "Accesso",
    12380: "Disconnettersi",
    12520: "M",
    12523: "Rendi il tuo post eccezionale con una foto",
    12526: "Gestisci attività in blocco",
    12529: "Gestisci tag entità",
    12532: "Gestisci posizioni",
    12535: "Gestisci profilo",
    12538: "Gestisci ruoli",
    12541: "Gestisci utenti",
    12544: "Mappe",
    12547: "Conteggio commerciante",
    12550: "Foto mercantili",
    12553: "Foto dei commercianti",
    12556: "Messaggio",
    12559: "Minuti",
    12562: "Lunedi",
    12565: "Mese",
    12720: "Nome",
    12723: "Nome del nuovo ruolo",
    12726: "Nome del rapporto",
    12729: "Bisogno di un account?",
    12732: "Nuovo",
    12735: "Pagina successiva",
    12738: "Nessuna risposta",
    12741: "nessun risultato trovato",
    12744: "Non esistono tag di recensione",
    12747: "Nessuna recensione",
    12750: "No, annulla",
    12753: "Numero di utenti",
    12756: "Appunti",
    12920: "di",
    12923: "Offrire",
    12926: "ok",
    12929: "Ok capito!",
    12932: "Una volta",
    12935: "Data di apertura",
    12938: "Ordine",
    12941: "Organizzazioni",
    12944: "Outbox",
    12947: "Proprietario",
    13120: "pagina",
    13123: "Parola d'ordine",
    13126: "Incolla TSV",
    13129: "Tipo di PDF",
    13132: "Telefono",
    13135: "Telefonate di giorno",
    13138: "Numero di telefono",
    13141: "Foto quantità",
    13144: "Viste fotografiche",
    13147: "Inserisci un nome di destinatario!",
    13150: "Inserisci un nome per il rapporto!",
    13153: "Per favore, inserisci un riepilogo!",
    13156: "Per favore, inserisci un titolo!",
    13159: "Si prega di inserire un tempo valido!",
    13162: "Per favore, inserisci un URL valido!",
    13165: "Aggiorna la pagina per aggiornare i dettagli della tua posizione",
    13168: "Per favore ricarica",
    13171: "Seleziona il tipo di programma!",
    13174: "Cronologia dei post",
    13177: "Messaggi",
    13180: "Pagina precedente",
    13183: "Categoria primaria",
    13186: "Telefono principale",
    13189: "Numero di telefono principale",
    13192: "Profili",
    13195: "Conteggio pubblico",
    13198: "Foto pubbliche",
    13201: "Foto pubbliche",
    13204: "PUBBLICARE",
    13520: "Valutazione",
    13523: "Notifiche in tempo reale",
    13526: "Elenco dei destinatari",
    13529: "Recurring",
    13532: "Rimuovi utente",
    13535: "rispondere",
    13538: "Rispondi all'approvazione",
    13541: "Gestione dei report",
    13544: "Nome del rapporto",
    13547: "Tipo di rapporto",
    13550: "Resetta la password",
    13553: "Risposta da Star Rating",
    13556: "Conteggio delle recensioni",
    13559: "Scarica la recensione",
    13562: "Revisiona impostazioni",
    13565: "Fonte delle recensioni",
    13568: "Revisiona tag",
    13571: "Link recensione",
    13574: "Recensioni",
    13577: "Recensioni di Star Rating",
    13580: "Recensioni vs valutazione media",
    13583: "Recensioni Posta in arrivo",
    13586: "Gestione delle recensioni",
    13589: "Recensioni, giorno del mese",
    13592: "Recensioni, giorno della settimana",
    13595: "Recensioni, mese dell'anno",
    13598: "Ruolo",
    13601: "Dettagli sul ruolo",
    13604: "Nome del ruolo",
    13720: "Sabato",
    13723: "Salva",
    13726: "Salva come filtro personalizzato",
    13729: "Salva nuovo filtro",
    13732: "Salva ruolo",
    13735: "Risposte salvate",
    13738: "Data di pianificazione",
    13741: "Pianifica posta",
    13742: "Per pianificare un rapporto",
    13744: "Orario",
    13747: "Tipo di orario",
    13750: "Ricerca",
    13753: "Ricerche",
    13756: "Selezionare",
    13759: "Seleziona un filtro esistente",
    13762: "Seleziona categoria",
    13765: "Seleziona la città",
    13768: "Seleziona il paese",
    13771: "Seleziona data e ora",
    13774: "Seleziona Intervallo di date",
    13777: "Seleziona Editor da rivedere",
    13780: "Seleziona il tag entità",
    13783: "Seleziona filtro",
    13786: "Seleziona i filtri",
    13789: "Seleziona granularità",
    13792: "Seleziona l'organizzazione",
    13795: "Seleziona il tag di revisione",
    13798: "Seleziona filtro salvato",
    13801: "Seleziona sorgente",
    13804: "Seleziona stato",
    13807: "Seleziona l'ora",
    13810: "SE STESSO",
    13813: "Invialo per l'approvazione",
    13816: "Invia a Posta in uscita",
    13819: "Inviato",
    13822: "Servizi",
    13825: "impostazioni",
    13828: "Gestione delle impostazioni",
    13831: "Negozio",
    13834: "Mostra post",
    13837: "Mostra / Nascondi navigazione",
    13840: "Iscriviti",
    13843: "Modifica posizione singola",
    13846: "Scusa!",
    13849: "Ordina per",
    13852: "Ore speciali",
    13855: "Accesso specifico",
    13858: "STANDARD",
    13861: "Ora di inizio",
    13864: "Stato",
    13867: "Stato",
    13870: "Negozio",
    13873: "Codice archiviazione",
    13876: "strada",
    13879: "Vista di riepilogo",
    13882: "Domenica",
    13885: "Sincronizza questo account",
    13920: "Telefono",
    13923: "Termini e condizioni",
    13926: "giovedi",
    13929: "Tempo",
    13932: "Località principali",
    13935: "Totale",
    13938: "Martedì",
    14120: "Senza risposta",
    14123: "Non sei sicuro del formato?",
    14126: "Caricare",
    14129: "Carica dettagli posizione",
    14132: "Carica la mappa della posizione",
    14135: "Carica mappatura della posizione",
    14138: "Carica TSV",
    14141: "URL",
    14144: "ID utente",
    14320: "Guarda l'immagine",
    14323: "Vedi profilo",
    14326: "Visualizzazioni",
    14520: "S",
    14523: "Sito web",
    14526: "Sito web di giorno",
    14529: "Nome del sito Web",
    14532: "mercoledì",
    14535: "Settimana",
    14538: "Quali azioni intraprendono i clienti",
    14541: "Quando viene fatta una risposta a una recensione",
    14544: "Dove i clienti visualizzano la tua attività",
    14547: "Vuoi eliminare questo post programmato?",
    14550: "Scrivi il tuo titolo",
    14920: "Anno",
    14923: "Sì, continua",
    14926: "Puoi scegliere di limitare l'accesso degli utenti con questo ruolo selezionando un filtro da allegare ad esso.",
    14929: "Il tuo nome",
    15120: "Cerniera lampo",
    20010: "Lunedi",
    20011: "lun",
    20020: "martedì",
    20021: "mar",
    20030: "Mercoledì",
    20031: "mer",
    20040: "Giovedì",
    20041: "gio",
    20050: "Venerdì",
    20051: "ven",
    20060: "Sabato",
    20061: "sab",
    20070: "Domenica",
    20071: "do",
    20110: "gennaio",
    20111: "genn",
    20120: "febbraio",
    20121: "febbr",
    20130: "marzo",
    20131: "mar",
    20140: "aprile",
    20141: "apr",
    20150: "Maggio",
    20151: "magg",
    20160: "giugno",
    20161: "giugno",
    20170: "luglio",
    20171: "luglio",
    20180: "agosto",
    20181: "ag",
    20190: "settembre",
    20191: "sett",
    20200: "ottobre",
    20201: "ott",
    20210: "novembre",
    20211: "nov",
    20220: "dicembre",
    20221: "dic",
    20231: "Recensioni e valutazioni",
    20241: "Per cento",
    20251: "Rivedi con percentuale",
    20261: "Cumulativo",
    20271: "Conteggio cumulativo",
    20281: "fonte",
    20291: "Revisione da parte di fonti",
    20301: "Felicità",
    20311: "Tempo di risposta",
    20321: "Seleziona posizione",
    20331: "Cerca per parola chiave recensioni",
    20341: "cerca per Revisore",
    20351: "Selezionare",
    20361: "È uguale a",
    20371: "Meno di",
    20381: "Più grande di",
    20391: "Seleziona mesi",
    20401: "Seleziona la data",
    20411: "Fai clic per visualizzare queste recensioni",
    20421: "Non sono state trovate recensioni per l'intervallo di date e i criteri selezionati",
    20431: "Filtro pulito",
    20441: "Elimina un filtro personalizzato",
    20451: "Ha aggiornamenti di Google",
    20461: "Verificati",
    20471: "Posizione pubblicata",
    20481: "Ha modifiche in sospeso",
    20491: "Pannello di conoscenza",
    20501: "Link recensione",
    20511: "Indicazioni",
    20521: "Duplicare",
    20531: "Attivo",
    20541: "Può aggiornare",
    20551: "Può cancellare",
    20561: "Nessuna recensione in sospeso",
    20571: "Posizione abilitata",
    20581: "Non disconnesso",
    20591: "Registro delle modifiche",
    20601: "Immagine di caricamento collettivo",
    20611: "Cronologia delle immagini",
    20621: "Caricamento collettivo Nota",
    20631: "Caricamento collettivo domande e risposte",
    20641: "domande e risposte",
    20651: "Aggiungi una domanda",
    20661: "Presenta una domanda ai clienti che evidenzi una proposta di valore fondamentale o un netto vantaggio competitivo della tua posizione. È quindi possibile rispondere alle domande.",
    20671: "Dettagli della piattaforma",
    20681: "Variabili di risposta automatica",
    20691: "Nome del luogo",
    20701: "Nome geografico",
    20711: "Firma",
    20721: "Nome geografico (massimo 80 caratteri)",
    20731: "Nome della firma (massimo 80 caratteri)",
    20741: "Risposta automatica",
    20751: "Scarica recensioni",
    20761: "Autorisposta",
    20771: "link esterno",
    20781: "Copia recensione",
    20791: "Aggiungi nota",
    20801: "Nota esterna",
    20811: "Segnala come inappropriato",
    20821: "Segna come rimosso",
    20831: "Sei sicuro ?",
    20841: "Desideri contrassegnare questa recensione come rimossa da Google?",
    20851: "Inserisci risposte salvate",
    20861: "Salva come modello di risposta",
    20871: "Inserisci il modello di risposta automatica",
    20881: "Spedire",
    20891: "Invia per l'approvazione",
    20901: "Salva come bozza",
    20911: "Assegna nota",
    20921: "Nota e-mail",
    20931: "Destinatario",
    20941: "Salva come nota",
    20951: "Chiudi",
    20961: "Scartare",
    20971: "Inviare una mail",
    20981: "Non ci sono note salvate",
    20991: "Tutti raggiunti!",
    21001: "Nessuna voce da mostrare",
    21011: "Risposte inviate",
    21021: "Il recensore non ha aggiunto commenti",
    21031: "Modifica risposta",
    21041: "Elimina risposta",
    21051: "Cerca risposte salvate",
    21061: "Aggiungi la risposta salvata",
    21071: "Scegli un gruppo e soggetto per salvare questa risposta.",
    21081: "Seleziona un gruppo o inizia a digitare per crearne uno",
    21091: "Inserisci il titolo qui",
    21101: "Inserisci il modello di risposta",
    21111: "Assicurati di selezionare/creare un gruppo e un titolo per salvare questa risposta.",
    21121: "Risposte automatiche",
    21131: "Aggiungi risposta automatica",
    21141: "Seleziona un gruppo",
    21151: "Inserisci qui la variabile",
    21161: "Scegli le tue variabili",
    21171: "Vuoi continuare?",
    21181: "Questa richiesta contiene più di 100 recensioni Per tali richieste, ti invieremo un'email con un link per scaricare la recensione CSV.",
    21191: "Hai più di 100 recensioni",
    21201: "Ti invieremo un'email (a X) con un link per scaricare la recensione CSV.",
    21211: "Azioni",
    21221: "Tutta la posizione",
    21231: "Valutazione media",
    21241: "Marca",
    21251: "Diretto",
    21261: "Scoperta",
    21271: "Geografia",
    21281: "Felicità",
    21291: "Interrogazioni",
    21301: "Risposte",
    21311: "Visualizzazioni",
    21321: "Post Schedule",
    21331: "Programma di Google Post",
    21341: "Crea post",
    21351: "Gestisci posta",
    21361: "Pianifica LocalPost",
    21371: "Caricare",
    21381: "Progresso",
    21391: "Convalida e programma",
    21401: "Stato del programma",
    21411: "Seleziona il file",
    21421: "Seleziona un tipo di programma",
    21431: "Immediato",
    21441: "Ora del file",
    21451: "Seleziona l'ora",
    21461: "Pubblica subito dopo la verifica",
    21471: "Pianificazione basata sull'ora nel file",
    21481: "Pianifica il file in base all'ora selezionata",
    21491: "Coda",
    21501: "La convalida è in corso. Il tempo di elaborazione è di circa 40 messaggi al minuto. Dopo la convalida, lo stato di ciascun post sarà disponibile nella pagina successiva.",
    21511: "Post elaborato",
    21521: "Convalida riuscita",
    21531: "Convalida fallita",
    21541: "In programma",
    21551: "Tipo / Azione",
    21561: "Date",
    21571: "Inizio",
    21581: "Fine",
    21591: "Titolo / Prodotto",
    21601: "Riepilogo post",
    21611: "Stato",
    21621: "Successo",
    21631: "Non riuscito",
    21641: "Modifica / Elimina",
    21651: "Approfondimenti sul post",
    21661: "Google Post Insights",
    21671: "Prestazione",
    21681: "Pubblica visualizzazioni",
    21691: "Posta per media",
    21701: "Posta per argomento",
    21711: "Posta per azione",
    21721: "Analisi",
    21731: "Creato",
    21741: "genere",
    21751: "Azione",
    21761: "Filtro sorgente",
    21771: "Piattaforma",
    21781: "Aggiorna lo stato di localpost",
    21791: "Campaign Builder",
    21801: "Risposta automatica intelligente",
    21811: "Attiva il generatore di campagne di risposta automatica",
    21821: "Prima di abilitare l'opzione di pianificazione della risposta automatica, assicurarsi di seguire le istruzioni riportate di seguito:",
    21831: "Prima di abilitare la risposta automatica Inteligent, assicurati di aggiungere i tuoi modelli di risposta automatica nella sezione ReviewInbox. Costruisci prima le risposte in modo da poterle assegnare alle stelle (1-5) che attiveranno una risposta automatica Inteligent.",
    21841: "In Campaign Builder, seleziona un ritardo tra la ricevuta della recensione e la consegna della risposta automatica. L'impostazione del ritardo dovrebbe corrispondere al tempo di risposta di revisione ideale, poiché è intesa a mascherare la natura automatica del programma.",
    21851: "Considera anche di impostare il tempo di operazione (giorni della settimana e ore del giorno) per la campagna. L'impostazione predefinita del fuso orario è GMT + 00: 00, quindi si prega di aggiornare come appropriato.",
    21861: "Creare campagne",
    21871: "Assegna un nome e tutte le note per identificare facilmente la tua campagna.",
    21881: "Nome della campagna",
    21891: "Risponditore campagna",
    21901: "Se nessuna opzione è selezionata, l'e-mail utilizzata per registrarsi e autorizzare gli account sarà il rispondente predefinito.",
    21911: "Rispondente per la risposta automatica",
    21921: "Intervallo di date della campagna",
    21931: "Note / Obiettivi",
    21941: "Descrizione della campagna",
    21951: "Imposta trigger",
    21961: "Scegli il tipo di recensioni che richiederanno una risposta automatica per questa campagna.",
    21971: "con commento",
    21981: "senza commento",
    21991: "precedente",
    22001: "Il prossimo",
    22011: "Imposta pubblico (opzionale)",
    22021: "Imposta le posizioni in modo che facciano parte della campagna in base a un tag di entità, a un'organizzazione o a un Paese / area / località specifici. Questi filtri sono disponibili solo per recensioni di Google e posizioni mappate",
    22031: "entità",
    22041: "organizzazione",
    22051: "Imposta programma",
    22061: "Assegna i parametri e il programma per le risposte alle recensioni, ovvero la percentuale di revisioni mirate e le ore di operazioni operative per le risposte.",
    22071: 'Tieni presente che le risposte automatiche sono attualmente disponibili solo su base "go-forward". Stiamo lavorando su processi separati per gli utenti che potrebbero voler eseguire automaticamente una pulizia a breve termine.',
    22081: "Imposta il tasso di risposta",
    22091: "imposta il conteggio delle risposte",
    22101: "ritardo prima di inviare la risposta automatica",
    22111: "programmare periodicamente",
    22121: "Seleziona il giorno e imposta l'ora per programmare periodicamente la risposta automatica",
    22131: "Seleziona il fuso orario",
    22141: "Assegna risposte",
    22151: "Dall'elenco, seleziona le risposte da utilizzare a rotazione per questa campagna.",
    22161: "Confermare",
    22171: 'Rivedi ciascuno dei dettagli di seguito e premi "conferma" per avviare la tua campagna.',
    22181: "giorni",
    22191: "Stella",
    22201: "Media",
    22211: "segnalazione",
    22221: "Configurazione della concorrenza",
    22231: "Migliori pratiche",
    22241: "Quadrante",
    22251: "Giudizi",
    22261: "Classifica competitiva",
    22271: "Risp.",
    22281: "Visualizza fonti di recensione",
    22291: "Aggiungi concorrente",
    22301: "Filtrato per",
    22311: "Chiaro",
    22321: "Concorrente",
    22331: "CompEntity",
    22341: "Tag entità",
    22351: "Commenti",
    22361: "Nessuna opzione",
    22371: "Cattivo",
    22381: "Povero",
    22391: "Media",
    22401: "Grande",
    22411: "Eccellente",
    22421: "Recensioni con Reply",
    22431: "Recensioni senza risposta",
    22441: "Recensioni con commenti",
    22451: "Recensioni senza commenti",
    22461: "Volume recensione vs valutazione media",
    22471: "Marche",
    22481: "Ingrandisci",
    22491: "Recensioni totali",
    22501: "Esamina la valutazione in base alla stella",
    22511: "Recensioni dei concorrenti",
    22521: "Concorrente di",
    22531: "Codice",
    22541: "Gestire i concorrenti",
    22551: "aggiornato",
    22561: "Aggiungi concorrenti",
    22571: "Aggiungi luogo",
    22581: "Aggiungi nome concorrenti",
    22591: 'Il primo passo è aggiungere il nome del concorrente, una volta aggiunti i nomi e le icone opzionali (immagini 48x48) all\'elenco, fare clic su "Aggiungi". Una volta creati i concorrenti, si sarà in grado di assegnare le singole sedi',
    22601: "Inserisci il nome del concorrente (richiesto)",
    22611: "Inserisci l'URL della concorrenza (facoltativo)",
    22621: "Carica immagine",
    22631: "Prossimamente",
    22641: "Rapporto di commento",
    22651: "Percentuale di recensioni con e senza commenti",
    22661: "Senza",
    22671: "Con",
    22681: "Lunghezza del commento",
    22691: "Numero medio di parole utilizzate in ciascun commento in base alla valutazione a stelle",
    22701: "Parole",
    22711: "Rapporto di parole",
    22721: "Totale e percentuale di parole nei commenti per ciascuna valutazione a stelle",
    22731: "qui.",
    22741: "Concorrenti",
    22751: "Aggiungi Tag",
    22761: "Scegli le variabili da aggiungere al modello",
    22771: "chiudere la recensione",
    22781: "Revisione chiusa",
    22791: "Vuoi chiudere questa recensione? Una volta chiuso, sarà necessario riaprirlo per poter rispondere",
    22801: "Esterno",
    22811: "Negativo",
    22821: "No",
    22831: "Nessuna risposta automatica ancora!",
    22841: "Nessuna risposta salvata ancora!",
    22851: "Nota",
    22861: "Chiuso definitivamente",
    22871: "Positivo",
    22881: "Lettura scaduta",
    22891: "Ripristina revisione",
    22901: "Riapri revisione",
    22911: "Risposto",
    22921: "Risposta inviata (dall'interfaccia Google)",
    22931: "Risposta inviata dall'app",
    22941: "Revisione rimossa",
    22951: "Modelli",
    22961: "Temporaneamente chiuso",
    22971: "sì",
    22981: "Non hai bozze salvate",
    22991: "Autorizzazioni insufficienti per accedere alla risorsa",
    23001: "Errore interno incontrato",
    23011: "Richiesta contiene un argomento non valido",
    23021: "L'entità richiesta non è stata trovata",
    23031: "La revisione non esiste più su Google Platform",
    23041: "Alcuni dei valori di inserimento automatico non sono disponibili. Si prega di sostituire e inviare",
    23051: "Il servizio non è al momento disponibile",
    23061: "Questa operazione non è supportata per posizioni non reclamate",
    23071: "Post pubblicato",
    23081: "Post programmato",
    23091: "Nome amichevole",
    23101: "Add friendly name",
    23111: "Contatto",
    23121: "No contacts!",
    23131: "To add contact",
    23141: "Nome del contatto",
    23151: "Contact E-Mail",
    23161: "Aggiungi contatto",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "Nessun dato",
    23201: "Google Audit",
    23211: "Registri di audit.",
    23221: "Seleziona un report.",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "Download di dati",
    23271: "Scarica Scarica.",
    23291: "Scarica foto URL.",
    23301: "URL della foto del cliente.",
    23311: "URL della foto mercantile.",
    23321: "Report Downloads History.",
    23331: "Report Name",
    23341: "Inviato a",
    23351: "Tempo creato (UTC)",
    23361: "Tipo di rapporto",
    23371: "Profile Details",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "Aggiornare",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "Caricamento",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "Controllo della gestione della bulk",
    23721: "Aggiorna i dettagli della posizione e i parametri della piattaforma di controllo direttamente nei fogli di Google.",
    23731: "PLATFORM",
    23741: "Gestisci facilmente gli account di qualsiasi scala con variabili e impostazioni personalizzate di posizione.",
    23751: "Dettagli GBP.",
    23761: "Visualizza tutti gli annunci di Google Business Profile e aggiungi / modifica / Elimina / elimina i dettagli della posizione.",
    23771: "Attributi GBP.",
    23781: "Assegna tutti gli attributi ammissibili a ciascuna posizione per ottenere la scoperta della ricerca incrementale.",
    23791: "GBP Elenco",
    23801: "Crea un nuovo elenco GBP.",
    23811: "Facebook",
    23821: "Controllo della quotazione di Facebook",
    23831: "Storia",
    23841: "ADDESTRAMENTO",
    23851: "Accedi alle risorse per i flussi di lavoro Modifica sfusi, le migliori pratiche, limitazioni e aggiornamenti.",
    23861: "AVVERTIMENTO",
    23871: "Requisiti",
    23881: "Gli utenti devono avere un account Google in modo che il sistema possa presentare un foglio Google con i dati del profilo.",
    23891: "Avviso:",
    23901: "I dati che popolano ciascun foglio se dal database di sistema. Se desideri accertarsi che il foglio di calcolo presenta i dati di Google attuali, ti consigliamo vivamente di sincronizzare prima il tuo profilo.",
    23911: 'A seconda del numero di posizioni nel tuo account, i fogli di Google potrebbero richiedere del tempo per costruire e quindi aggiornare mentre navighi sul foglio. Si prega di assicurarsi che tutti i dati siano stabili prima di premere "Aggiorna" per salvare le modifiche al sistema e premere gli aggiornamenti su Google.',
    23921: "La piattaforma ha una connessione API diretta con Google, ma potrebbero ancora esserci momenti in cui Google ritarda l'aggiornamento diretto alla pagina di quotazione della posizione pubblica.",
    23931: 'Spingere "Aggiornamento" innesca un sistema diretto direttamente a Google. Non è disponibile alcun processo di annullamento o reversione. Si prega di assicurarsi che tu sia a tuo agio con tutte le modifiche prima di attivare l\'aggiornamento. Se viene effettuato un errore, attendi alcuni minuti e quindi effettuare il cambiamento necessario.',
    23941: "COMBINAZIONE DI COLORI",
    23951: "Ogni foglio ha una combinazione di colori predefinita per aiutare gli utenti a capire quali campi sono ammissibili per la modifica.",
    23961: "Variabili che trasmettono i dettagli dello stato di Google o non possono essere modificati direttamente tramite i controlli BULK.",
    23971: "Le variabili di Google si aprono direttamente per la modifica della bulk.",
    23981: "Variabili della piattaforma aperte direttamente per la bulk Modifica.",
    23991: "Controllo",
    24001: "Particolari",
    24011: "Attributi",
    24021: "Crea un elenco",
    24031: "Istruzioni",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "/PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 14 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "Attività",
    24361: "Autorizzato",
    24371: "Connessioni autorizzate Accedono alle funzionalità di riesame e risposta complete da / per ogni fonte.",
    24381: "Tag di entità di upload sfusi",
    24391: "Bulk Carica dettaglio GBP",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "Crea tag entità",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "GBP Dettagli Storia",
    24491: "Impressioni",
    24501: "Non attivo",
    24511: "Indicizzato",
    24521: "Le connessioni indicizzate accedono a tutte le recensioni storiche e attuali di ogni fonte.",
    24531: "Manage LocalPost",
    24541: "Nessun commento aggiunto.",
    24551: "Numero",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "Salva una risposta",
    24601: "Posizione totale",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "Carica alias di posizione",
    24641: "Visualizzazione",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "Distaccato",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Choose File",
    24911: "No file chosen",
    24921: "Visualizza un registro di ogni aggiornamento Premere per confermare l'elenco dei contenuti cambia e individuare eventuali errori.",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "ID utente",
    24961: "Do you want to delete?",
    24971: "Account",
    24981: "Non ha aggiornamenti di Google",
    24991: "Rivellezione non richiesta",
    25001: "No pending edits",
    25011: "Tempo di audit",
    25021: "Campo",
    25031: "Valore (TO)",
    25041: "Valore (da)",
    25051: "remove from entity tag",
    25061: "Attributedist.",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "Esplorare",
    25111: "Esplora le risposte",
    25121: "Seleziona Modelli.",
    25131: "Continua",
    25141: "Scegli la valutazione della stella, il nome del modello e aggiungi il contenuto del modello per salvare la risposta automatica.",
    25151: "Seleziona il tipo di risposta",
    25161: "Modello",
    25171: "Frammento",
    25181: "Assegnare al rating (richiesto)",
    25191: "Immettere il nome del modello (richiesto)",
    25201: "Variabile del modello personalizzato (opzionale)",
    25211: "Selezionare o creare argomento (opzionale)",
    25221: "Assegna alla posizione singola)",
    25231: "Assegna al tag entità",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "Nota della posizione",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "Vedi la recensione direttamente su Google",
    25301: "Positive-5 Stars",
    25311: "Negative - 1/2 Stars",
    25321: "Mixed - 3/4 Stars",
    25331: "Nome modello",
    25341: "Variabile",
    25351: "Seleziona o crea argomento",
    25361: "Gruppo",
    25371: "Argomento",
    25381: "Recensioni precedenti",
    25391: "Salva come risposta",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "Crea data",
    25441: "Nome del filtro personalizzato",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "Scarica",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "Pagina di destinazione predefinita",
    25691: "Recensioni in arrivo",
    25701: "Gestione sfusa",
    25711: "POST SCHEDULAZIONE",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn of Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "Tasso di risposta",
    25781: "Conteggio della risposta",
    25791: "Valutazioni delle stelle",
    25801: "Insieme a",
    25811: "Privo di",
    25821: "Ritardo",
    25831: "Fuso orario",
    25841: "Revisione",
    25851: "Competitor Report",
    25861: "Formato",
    25871: "HTML Email",
    25881: "Excel",
    25891: "Se non ci sono recensioni in intervallo selezionato",
    25901: "Non inviare email",
    25911: "Invia una email",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "Si prega di contattare il supporto con qualsiasi domanda sulla cadenza di sincronizzazione del profilo",
    25971: "Include Audit File",
    25981: "Profilo",
    25991: "CompTag",
    26001: "Recensione Dettagli.",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "Grafico delle azioni del cliente per la direzione di guida, le telefonate e i clic del sito Web.",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings.",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size.",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users.",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses.",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Yesterday",
    27251: "Last 7 days",
    27261: "Last week",
    27271: "Last 30 days",
    27281: "Last month",
    27291: "Sempre",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "Salva questa risposta",
    27341: "Select or create a group",
    27351: "Nessuna risposta salvata",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "Tutti i posti",
    27451: "Aprire",
    27461: "Google Updates",
    27471: "Missing Content",
    27481: "Codice del negozio",
    27491: "Additional Categories",
    27501: "Search Locations.",
    27511: "Audit GBP.",
    27521: "Attività sfusa",
    27531: "Seleziona Group.",
    27541: "20/ page",
    27551: "Sincronizzazione",
    27561: "Imposta il pubblico",
    27571: "Fatto",
    27581: "Group Name",
    27591: "Minuto",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "Analisi dei quadranti",
    27631: "Tutti i dati delle posizioni",
    27641: "Ricerca alta + conversione bassa",
    27651: "Ricerca alta + conversione alta",
    27661: "Ricerca bassa + conversione bassa",
    27671: "Ricerca bassa + conversione alta",
    27681: "Dati di posizione per regione",
    27691: "Dati di posizione per città",
    27701: "Location:",
    27711: "Conversion Rate:",
    27721: "Searches:",
    27731: "Google Q&A",
    27741: "Google QA",
    27751: "Download QA",
    27761: "Post risposta",
    27771: "Post Insight.",
    27781: "Download the sample CSV",
    27791: "Pre populated CSV",
    27801: "Manage Portfolio",
    27811: "Add Portfolio",
    27821: "View Portfolio",
    27831: "Delete Portfolio",
    27841: "Utenti",
    27851: "Manage Profiles",
    27861: "Remove Profile",
    27871: "Are you sure you want to Remove this profile ?",
    27881: "Accounts",
    27891: "Select Profiles",
    27901: "Select Profile",
    27911: "Portfolio Account",
    27921: "Portfolio Details",
    27931: "Portfolio Name",
    27941: "Currrent Portfolio Image",
    27951: "Upload image as a logo for portfolio",
    27961: "Change portfolio name",
    27971: "Free Trial",
    27981: "Current",
    27991: "Expired",
    28001: "Cancelled",
    28011: "Invoicing",
    28021: "Collegato",
    28031: "Number of Accounts",
    28041: "Total Locations",
    28051: "Active Locations",
    28061: "Reviews (30 days)",
    28071: "Payment Status",
    28081: "Profile Name",
    28091: "Enter name of new portfolio",
    28101: "A portfolio can bulk manage their users across different profiles easily",
    28111: "Name of new portfolio",
    28121: "Portfolio names can only have a maximum of 20 characters",
    28131: "Portfolio Created Successfully!",
    28141: "Total Profile",
    28151: "Total Users",
    28161: "Enter email",
    28171: "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role.",
    28181: "Invite",
    28191: "Current Portfolio Image",
    28201: "Sentiment",
    28211: "Awaiting",
    28221: "Più filtri",
    28231: "Review Tag",
    28241: "Filtri salvati",
    28251: "Meno filtri",
    28261: "No Text",
    28271: "Medium",
    28281: "Expand",
    28291: "Single image upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "Aprire",
    28471: "Chiuso",
    28481: "RIMOSSO",
    28491: "Nuova Recensione Tag",
    28501: "tutte le Recensioni",
    28511: "Niente da mostrare in questa fascia!",
    28521: "Ricerca",
    28531: "Seleziona tutto",
    28541: "Fonte di ricerca",
    28551: "Tag di ricerca della ricerca",
    28561: "Posizione di ricerca",
    28571: "Cerca codice Store",
    28581: "Gruppo di ricerca",
    28591: "organizzazioni",
    28601: "Tag di entità",
    28611: "Applicare",
    28621: "Gruppo",
    28631: "Cerca filtri salvati",
    28641: "Nessuna opzione!",
    28651: "Regola la visualizzazione del testo di revisione",
    28661: "Vedi la recensione direttamente sul",
    28671: "Rispondi Su Recensione Piattaforma",
    28681: "Seleziona modello",
    28691: "copia",
    28701: "Prior Recensioni",
    28711: "Nessuna recensione",
    28721: "Valutazione",
    28731: "Risposta Nome posizione non ha aggiunto in questa posizione",
    28741: "La firma non ha aggiunto in questa posizione",
    28751: "Vuoi continuare a scaricare?",
    28761: "Voti senza risposta",
    28771: "Recensioni con risposta interna",
    28781: "Recensioni con auto-replica",
    28791: "Voti con Rispondi esterno",
    28801: "Vista Panel Conoscenza Google",
    28811: "Posizione Nota",
    28821: "nuovo Direttore",
    28831: "Abilita Cc",
    28841: "Salva con nome Rispondi",
    28851: "Elimina Rispondi",
    28861: "Gruppo",
    28871: "Misto",
    28881: "Stelle",
    28891: "Negativo, Misto, positivo",
    28901: "Valutazione",
    28911: "Nome modello",
    28921: "Variabile",
    28931: "Salva un Commento",
    28941: "Modifica nome account.",
    28951: "Cambia nome account.",
    28961: "Nome utente",
    28971: "Luoghi di Facebook.",
    28981: "Aggiungi pagina",
    28991: "Attivato",
    29001: "Mostra la posizione nascosta",
    29011: "Visualizza la pagina fb.",
    29021: "Nessun account nascosto da mostrare",
    29031: "Ore fa",
    29041: "Inviter",
    29051: "Review Showcase.",
    29061: "Sedi di Google.",
    29071: "Le tue località",
    29081: "URL della posizione",
    29091: "Sei sicuro di voler cancellare questo URL?",
    29101: "Volete eliminare URL e i suoi dati correlati dall'applicazione?",
    29111: "Posizioni dei concorrenti",
    29121: "Nome del concorrente",
    29131: "Posto ID.",
    29141: "Comptag.",
    29151: "Inserisci url di posizione e dettagli sui concorrenti",
    29161: "Iscompetitor",
    29171: "Luoghi di prenotazione",
    29181: "Per avviare l'integrazione della revisione della prenotazione",
    29191: "Back Office ID posizione (opzionale)",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "Crea campagne per rispondere direttamente alle recensioni con la risposta perfetta al momento perfetto",
    29301: "Sei sicuro di voler cancellare questa campagna?",
    29311: "Copia le recensioni intelligenti per ogni gestore di localizzazione assegnato",
    29321: "CC risponde ai gestori di localizzazione assegnati",
    29331: "Cc risponde a corporate",
    29341: "Destinatari",
    29351: "Tutti i destinatari",
    29361: "Seleziona recensione Fonte",
    29371: "PUB / SUBO SOLO",
    29381: "Seleziona la valutazione della stella",
    29391: "Seleziona il contenuto della recensione.",
    29401: "Gruppo personalizzato",
    29411: "Impostare il ritardo prima di inviare una risposta automatica",
    29421: "Imposta ore di funzionamento",
    29431: "Opzionale",
    29441: "Nessun luogo assegnato",
    29451: "Non c'erano un'insight trovata per l'intervallo di date selezionato e i criteri.",
    29461: "Menu filtro",
    29471: "Ordinare",
    29481: "Viste alla ricerca",
    29491: "Viste nelle mappe",
    29501: "Non hai autorizzazioni sufficienti per pubblicare una risposta.",
    29511: "Già inviato",
    29521: "Carica i modelli AR.",
    29531: "Follower count.",
    29541: "Ultima sincronizzazione",
    29551: "Corporativo",
    29561: "Agenzia",
    29571: "LocalPost abilitato",
    29581: "Nessuna verifica in attesa",
    29591: "Clicca per vedere questa recensione nella casella di posta",
    29601: "Per saperne di più",
    29611: "Caricamento in corso",
    29621: "Articoli totali (numeri)",
    29631: "Google La mia attività verificata",
    29641: "Mark As.",
    29651: "Aggiungi orari",
    29661: "Oggi",
    29671: "Indirizzo",
    29681: "codice postale",
    29691: "Identifica come di proprietà del nero",
    29701: "Aggiungi URL",
    29711: "Inviare",
    29721: "contatto email",
    29731: "Aggiornamento Covid_19",
    29741: "Modifiche alla tua attività?",
    29751: "Campagna",
    29761: "Ordinare on-line",
    29771: "Acquistare",
    29781: "Chiamare ora",
    29791: "Ora",
    29801: "Sincronizza questa posizione?",
    29811: "Elenco di Facebook",
    29821: "Crea un nuovo elenco di Facebook",
    29831: "Selezionato",
    29841: "Dettagli di business.",
    29851: "Contatti",
    29861: "Variabili",
    29871: "ID interno",
    29881: "Clicca per connettersi",
    29891: "Torna a caricare.",
    29901: "Guarda il Q & A su Google",
    29911: "Richiedere",
    29921: "disattivare",
    29931: "Rivedi la conferma della conferma",
    29941: "Revisione della risposta conferma",
    29951: "Revisione della conferma della rimozione",
    29961: "Regione",
    29971: "Risposta a questa domanda",
    29981: "Maneggio",
    29991: "Crea Google Post.",
    30001: "Gestisci Google Post.",
    30011: "Località nascosta",
    30021: "Seleziona la pagina corrente.",
    30031: "Creare post di Facebook.",
    30041: "Gestisci il post Facebook.",
    30051: "Cancella tutto",
    30061: "Salva filtro.",
    30071: "Ruolo di ricerca",
    30081: "Ricerca utente",
    30091: "Tutti gli editori",
    30101: "Assegna alla valutazione (richiesta)",
    30111: "Inserire il nome del modello (richiesto)",
    30121: "Variabile modello personalizzato",
    30131: "Seleziona o crea argomento",
    30141: "Assegna alla posizione singola",
    30151: "Assegna al tag entità",
    30161: "Revisione delle variabili",
    30171: "Nome revisore",
    30181: "Nome completo del recensore",
    30191: "Variabili di posizione",
    30201: "Rispondi Posizione Nome",
    30211: "Nome della posizione GEO",
    30221: "Una risposta per questa recensione è già stata inviata.",
    30231: "Le risposte per questa recensione non possono più essere inviate. Puoi cancellare questa risposta per rimuoverlo da qui.",
    30241: "Ti piacerebbe sincronizzare i dati di questa posizione? Ciò tirerà in tutti gli aggiornamenti apportati alla posizione.",
    30251: "Lascia che i clienti a conoscere eventuali modifiche alla tua attività a causa di Covid-19",
    30261: "Spedisci ora",
    30271: "Cerca vetrina.",
    30281: 'Utilizzare i controlli a destra per costruire la vetrina esatta. Fare clic sul pulsante "Applica" per caricare l\'anteprima istantanea',
    30291: "Costruisci la tua recensione Showcase",
    30301: "Vetrina Details.",
    30311: "Nome questa vetrina.",
    30321: "Posizione individuale",
    30331: "Gruppo della posizione",
    30341: "Vetrina Titolo",
    30351: "Nascondere",
    30361: "Immagine del revisore / Avatar",
    30371: "Spettacolo",
    30381: "Seleziona Review Set.",
    30391: "Fonti di revisione",
    30401: "Recensioni da..",
    30411: "Crea vetrina.",
    30421: "Valutazione minima",
    30431: "Voto solo recensioni.",
    30441: "Definire la presentazione",
    30451: "Conteggio massimo della revisione.",
    30461: "Max commento Lunghezza",
    30471: "Max recensioni per pagina",
    30481: "Layout reattivo",
    30491: "Ordinamento",
    30501: "Più recenti prima",
    30511: "Valutazione stellare Color.",
    30521: "Recensione Commenti",
    30531: "Logo della fonte",
    30541: "Data della recensione",
    30551: "Data precisa",
    30561: "Famiglia di font",
    30571: "Vetrina Dimensione del titolo.",
    30581: "Dimensioni del nome del revisore",
    30591: "Dimensione del commento",
    30601: "Impostare le sostituzioni",
    30611: "PIN in TOP.",
    30621: "Escludere",
    30631: "Le mie recensioni",
    30641: "Ha bisogno di assistenza",
    30651: "In attesa del cliente",
    30661: "In attesa di feedback",
    30671: "Nuovo feedback.",
    30681: "Nome della ricerca",
    30691: "Non assegnato",
    30701: "Aggiornato con successo",
    30711: "Nome contenuto della campagna (facoltativo)",
    30721: "Termini e condizioni (facoltativo)",
    30731: "Sei sicuro di voler rimuovere questo utente? Una volta rimosso, l'utente non avrà più accesso a questo profilo, a meno che non sia invitato.",
    30741: "Ti piacerebbe rimuovere questo utente?",
    30751: "Distribuzione della risposta",
    30761: "Invieremo un'email () con un link per scaricare la revisione CSV.",
    30771: "Questo profilo ha più di 100 località. Ti invieremo un'email con il link di download",
    30781: "Risposta dell'utente",
    30791: "Mark ha risposto",
    30801: "Risposta della destinazione",
    null: "Months of Year",
    30811: "Cruscotto Recensioni  ",
    30812: "Panoramica",
    30813: "Media",
    30814: "Valutazione MEDIA",
    30815: "Pos",
    30816: "Felicità",
    30817: "Rapporto di Parole",
    30818: "Rapporto di Risposta",
    30819: "Recensione per Fonte",
    30820: "Recensione per Valutazione",
    30821: "Risposta per Valutazione",
    30822: "Recensioni Recenti",
    30823: "Hai ricevuto {x} recensioni negli ultimi {x} giorni. Ecco le più recenti",
    30824: "Il numero medio di recensioni per posizione principale durante l'intervallo di tempo",
    30825: "La percentuale di recensioni con valutazioni di 4 e 5 stelle",
    30826: "Il Punteggio di Felicità è una presentazione della percentuale di recensioni positive meno la percentuale di recensioni negative",
    30827: "La percentuale di tutti i commenti trovati nelle recensioni a 5 e 4 stelle rispetto a tutte le parole condivise nel periodo di tempo. L'intervallo va da 5 stelle a 1 stella.",
    30828: "La percentuale di recensioni all'interno del periodo di tempo che hanno ricevuto una risposta.",
    30829: "Diminuzione in {x data} rispetto ai {xx} giorni precedenti",
    30830: "Aumento in {x data} rispetto ai {xx} giorni precedenti",
    30831: "Nessun cambiamento in {x data} rispetto ai {xx} giorni precedenti",
    30832: "Clicca per vedere queste recensioni",
    30833: "(nome del luogo) , (x) Stelle, Revisore: (x)",
    30834: "Recensioni & Valutazione Media",
    30835: "Conteggio delle recensioni nel tempo impilato per valutazione a stelle + grafico a linee della media della valutazione.",
    30836: "Percentuale per Valutazione a Stelle",
    30837: "Conteggio delle recensioni nel tempo impilato per valutazione a stelle come percentuale del totale.",
    30838: "Conteggio Cumulativo & Media Voto",
    30839: "Totale delle recensioni e media delle valutazioni per l'intervallo di tempo del rapporto.",
    30840: "Recensioni per Fonte",
    30841: "Conteggio delle recensioni nel periodo di tempo per fonte.",
    30842: "Punteggio di Felicità nel Tempo",
    30843: "Il Punteggio Netto di Felicità per periodo di tempo nell'intervallo del rapporto.",
    30844: "Giorno della Settimana",
    30845: "Giorno del Mese",
    30846: "Mese dell'Anno",
    30847: "Principali Paesi",
    30848: "Stati Principali",
    30849: "Città Principali",
    30850: "Risposte",
    30851: "Tasso di Risposta Rapida",
    30852: "Mediana",
    30853: "Il numero di risposte pubblicate nel periodo e la media per sede.",
    30854: "La percentuale di recensioni che ricevono una risposta entro 2 giorni e il tempo di risposta mediano.",
    30855: "Conteggio & Rapporto delle Risposte",
    30856: "Il conteggio delle risposte per valutazione a stelle e il rapporto di risposta complessivo.",
    30857: "Tempo Medio di Risposta",
    30858: "Il tempo medio di risposta in giorni.",
    30859: "Distribuzione delle Risposte",
    30860: "Istogramma del tempo di risposta delle recensioni suddiviso in 10 livelli.",
    30861: "Felice",
    30862: "Rapporto",
    30863: "Durata",
    30864: "Conteggio dei record della posizione principale, oltre ai record degli elenchi non mappati.",
    30865: "Energia",
    30866: "Rapporto Commenti",
    30867: "Lunghezza del Commento",
    30868: "Divario di Rapporto",
    30869: "Divario di Lunghezza",
    30870: "Recensioni con e senza commenti",
    30871: "Media di parole per valutazione a stelle",
    30872: "Percentuale di parole in ciascuna valutazione a stelle",
    30873: "Percentuale del Rapporto Commenti",
    30874: "La percentuale di tutte le recensioni che includono commenti dei clienti",
    30875: "Conteggio parole del commento",
    30876: "Il numero medio di parole contenute nelle recensioni con commenti",
    30877: "Distribuzione delle parole del commento",
    30878: "La percentuale di parole in ogni valutazione stellare per ogni periodo di tempo",
    30879: "Percentuale di recensioni positive con commenti meno la percentuale di recensioni negative.",
    30880: "Lunghezza media delle recensioni positive meno la lunghezza media delle recensioni negative.",
    30881: "Recensioni con tasso di risposta",
    30882: "Tasso di lunghezza del commento",
    30883: "Visualizzazione a Griglia",
    30884: "Posizione Media",
    30885: "Il punteggio medio delle recensioni delle posizioni e la percentuale di posizioni sopra il punteggio di 4,0 nell'intervallo di tempo.",
    30886: "Griglia di Prestazioni delle Recensioni",
    30887: "Presentare la valutazione media della posizione rispetto al volume delle recensioni per identificare i valori anomali",
    30888: "Sentimento",
    30889: "Influenza",
    30890: "Cruscotto delle prestazioni",
    30891: "Griglia di leadership",
    30892: "Viste totali",
    30893: "Tasso di conversione",
    30894: "Visualizzazioni totali e visualizzazioni medie per località.",
    30895: "Visualizzazioni della mappa su desktop e mobile con ripartizione percentuale.",
    30896: "Vista di ricerca locale su desktop e mobile con ripartizione percentuale.",
    30897: "Azioni totali con la ripartizione percentuale tra chiamate, clic sul sito web e indicazioni stradali.",
    30898: "Tasso di conversione totale di azioni/visualizzazioni per chiamate, clic sul sito web e indicazioni stradali.",
    30899: "Visualizzazioni dei Clienti",
    30900: "Come e dove i clienti vedono la tua attività.",
    30901: "Azioni dei Clienti",
    30902: "Le azioni tracciabili dai tuoi elenchi Google.",
    30903: "La percentuale di impressioni delle inserzioni aziendali che si traduce in un'azione",
    30904: "Efficacia per Località",
    30905: "Visualizzazioni totali vs. tasso di conversione (azioni/visualizzazioni) per mostrare l'efficacia di ciascuna località nel generare visualizzazioni e convertirle in azioni.",
    30906: "Efficacia per Città",
    30907: "Visualizzazioni totali vs. tasso di conversione (azioni/visualizzazioni) per ogni città.",
    30908: "Efficacia per Gruppo",
    30909: "Visualizzazioni totali vs. tasso di conversione (azioni/visualizzazioni) per ciascun gruppo personalizzato.",
    30910: "Alte Visualizzazioni + Bassa Conversione",
    30911: "Alte Visualizzazioni + Alta Conversione",
    30912: "Basse Visualizzazioni + Bassa Conversione",
    30913: "Basse Visualizzazioni + Alta Conversione",
    30914: "Mobile",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "Sito",
    30920: "Chiamate",
    30921: "Punteggio di Salute",
    30922: "Prestazione Giornaliera",
    30923: "Seleziona le località dalla tabella e il metro (visualizzazioni o azioni)",
    30924: "Tasso di Felicità",
    30925: "Nome/Amichevole",
    30926: "{x} località con una media di {y} stelle nell'ultimo {xx} giorni",
    30927: "Sopra",
    30928: "Gruppo",
    30929: "Tutte le Visualizzazioni",
    30930: "Tutte le Azioni",
    30931: "Desktop",
    30932: "Limite massimo raggiunto: Seleziona fino a 8 località per il grafico.",
    30933: "Revisore",
    30934: "Sentimento Complessivo",
    30935: "Distribuzione del punteggio di sentiment su {XX} argomenti.",
    30936: "Sentimento per Argomento",
    30937: "Frequenza degli Argomenti e Punteggi di Sentimento Corrispondenti.",
    30938: "Molto Positivo",
    30939: "Molto Negativo",
    30940: "Una regola di automazione attivata per una nuova recensione su",
    30941: "Una regola di automazione attivata per una recensione aggiornata su",
    30942: "ha approvato la risposta su",
    30943: "assegnato un'etichetta",
    30944: "assegnato la recensione a",
    30945: "a",
    30946: "Risposta automatica inviata",
    30947: "Il proprietario dell'azienda ha creato una nuova risposta esterna su",
    30948: "per regola di automazione su",
    30949: "dal sistema su",
    30950: "ha creato un nuovo",
    30951: "ha creato una nuova risposta su",
    30952: "ha creato una nota di revisione per",
    30953: "ha eliminato una nota su",
    30954: "ha eliminato una nota di revisione su",
    30955: "ha eliminato la risposta su",
    30956: "ha modificato la risposta su",
    30957: "da",
    30958: "ha generato una risposta automatica su",
    30959: "locale",
    30960: "notifica",
    30961: "notificato",
    30962: "panoramica",
    30963: "eseguito",
    30964: "risposta",
    30965: "Risposta spostata nella Posta in arrivo dell'approvazione il",
    30966: "Risposta spostata nella posta in uscita e programmata per la pubblicazione",
    30967: "Risposta pubblicata su",
    30968: "Revisione assegnata a",
    30969: "revisione su",
    30970: "Revisione ricevuta da",
    30971: "ha inviato una nota a",
    30972: "Il sistema ha assegnato un tag di lingua",
    30973: "Il sistema ha assegnato una risposta automatica il",
    30974: "Etichette",
    30975: "team da regola di automazione il",
    30976: "Cronologia",
    30977: "a",
    30978: "aggiornato un",
    30979: "aggiornato una nota di revisione il",
    30980: "aggiornato la valutazione della recensione da",
    30981: "aggiornato lo stato della revisione da",
    30982: "aggiornato lo stato della revisione a",
    30983: "aggiornato il commento sul loro",
    30984: "tramite API durante",
    30985: "tramite Pub-Sub il",
    30986: "Nessun commento aggiunto",
    30987: "su",
    30988: "Sistema",
    30989: "da",
    30990: "Compito di revisione tratto da",
    30991: "assegnato a",
    30992: "Tag assegnato:",
    30993: "Gruppo di tag assegnato:",
    30994: "rimosso un tag:",
    30995: "Revisione con aggiornamenti",
    30996: "Revisione senza aggiornamenti",
    30997: "Seleziona tutti i tag",
    30998: "Seleziona non taggati",
    30999: "In attesa di approvazione",
    31000: "Più vecchio prima",
    31001: "Non hai note salvate",
    31002: "Rispondi nella casella di posta in uscita",
    31003: "Versioni delle Recensioni",
    31004: "Dettaglio della Recensione",
    31005: "Apri Informazioni",
    31006: "Relazioni",
    31007: "Errore",
    31008: "Primario",
    31009: "Categorie",
    31010: "Link Sociali",
    31011: "L’immagine originale è stata rimossa dall’utente o dalla piattaforma."
  },
  dutch: {
    1001: "Signing up signifies you’ve read and agree to our ",
    1002: "Terms of Service",
    1003: "and",
    1004: "Privacy Policy",
    1005: ".",
    1006: " ",
    2001: "Verify Location",
    2002: "Choose a way to verify.",
    2003: "In order to fully manage and represent this business on Google, you'll need to confirm that it's yours.Select how you'd like to get a verification code.",
    2004: "Get your code at this number now by automated call or text message (standard rates apply)",
    2005: "Postcard by mail",
    2006: "Have a postcard with your code mailed to this address",
    2007: "Contact name",
    2008: "PIN mailed to this mail ID",
    2009: "Mail",
    2010: "Reviews & Ratings",
    2011: "Percent",
    2012: "Review with Percentage",
    2013: "Cumulatief",
    2014: "Source",
    2015: "Review by Sources",
    2016: "Happiness",
    2017: "Response Time",
    2018: "Days",
    2019: "star",
    2020: "Avg",
    2021: "Brand",
    2022: "View All",
    2023: "Q&A",
    2024: "All",
    2025: "Has comments",
    2026: "No comments",
    2027: "Internal",
    2028: "Teamrecensies",
    2029: "Automate",
    2030: "Vol",
    2031: "Toegewezen",
    2032: "Zoek gebruiker",
    2033: "Stuur e -mail",
    2034: "componeren",
    2035: "AI Antwoord",
    2036: "Reageer",
    2037: "Regenereren",
    2038: "Goedkeuring",
    2039: "Plaats op Bron",
    2040: "Antwoord verzonden",
    2041: "Geen verzonden berichten",
    2042: "Duidelijk",
    2043: "Gesloten",
    2044: "Geen antwoordtekst gevonden",
    2045: "Kopieer het antwoord en ga naar de bron",
    2046: "Antwoord bewerken",
    2047: "Antwoord goedkeuren",
    2048: "Bijwerken Antwoord",
    2049: "Antwoord verwijderen",
    2050: "Weet je zeker dat je dit antwoord wilt verwijderen?",
    2051: "Weet je zeker dat je deze reactie wilt indienen?",
    2052: "Wilt u deze review opnieuw plaatsen ?",
    2053: "Weet u het zeker ?",
    2054: "Weet u zeker dat u dit antwoord wilt goedkeuren?",
    2055: "Teams",
    2056: "Alleen beoordeling",
    2057: "Waardering + KortCommentaar",
    2058: "Waardering + Commentaar",
    2059: "Beoordeling per taal",
    2060: "Geef een commentaarlengte tussen 1 en 100, standaard 20 tekens",
    2061: "Kopieer Intelligente Beoordeling Antwoorden naar elke toegewezen locatiemanager",
    2062: "Aanmelden",
    2063: "E-mailadres",
    2064: "Heb je geen account?",
    2065: "Voornaam",
    2066: "Achternaam",
    2067: "Bedrijf",
    2068: "Bedrijfsnaam",
    2069: "Heb je al een account?",
    2070: "Laat wachtwoord zien",
    2071: "Verberg wachtwoord",
    2072: "Lokale conversie",
    2073: "Kaarten Mobiel",
    2074: "Kaarten bureaublad",
    2075: "Zoeken Mobiel",
    2076: "Zoeken bureaublad",
    2077: "Zoekweergaven",
    2078: "Kaartweergaven",
    2081: "Universeel",
    2091: "Per Onderwerp",
    10010: "1 ster",
    10013: "2 sterren",
    10016: "3 sterren",
    10019: "4 -sterren",
    10022: "5 sterren",
    10025: "100-300 woorden",
    10120: "Acties",
    10123: "Activeren",
    10124: "Altijd actief",
    10126: "Actieve organisaties",
    10129: "Toevoegen",
    10132: "Voeg een knop toe",
    10135: "Voeg een knop toe (optioneel)",
    10138: "Account toevoegen",
    10141: "VOEG EXTRA TELEFOON TOE",
    10144: "Voeg een account toe",
    10147: "VOEG EEN ANDERE CATEGORIE TOE",
    10150: "VOEG EEN ANDER LABEL TOE",
    10153: "Voeg attributen toe",
    10156: "Lijn toevoegen",
    10159: "NIEUWE DATUM TOEVOEGEN",
    10162: "Voeg een nieuwe recensie -tag toe",
    10165: "Nieuwe rol toevoegen",
    10168: "Openingsdatum toevoegen",
    10171: "Profiel toevoegen",
    10174: "Nieuw rapport",
    10177: "Rapport toevoegen",
    10180: "Rol toevoegen",
    10181: "Review Tag toevoegen",
    10183: "Extra categorie",
    10186: "Extra telefoon",
    10189: "Adres",
    10192: "BEHEERDER",
    10195: "Beheerder",
    10198: "Locatie-extensies van adWords",
    10201: "adWords Locatie-extensies Telefoon",
    10204: "Allemaal",
    10207: "Alle beoordelingen",
    10210: "Alle gebruikers die aan deze rol zijn toegewezen, hebben toegang tot de volgende functies",
    10213: "Toepassen",
    10216: "Goedkeuring inbox",
    10219: "Weet u zeker dat u het wachtwoord van deze gebruiker wilt resetten?",
    10222: "Weet je het zeker?",
    10225: "Oppervlakte",
    10228: "Gebieden",
    10231: "Attributen",
    10234: "Account autoriseren",
    10237: "Gemiddeld",
    10240: "Gemiddelde hoeveelheid",
    10243: "Gemiddelde score",
    10244: "Gem. Beoordeling",
    10246: "Gemiddeld per locatie",
    10249: "In afwachting van reactie",
    10320: "Terug",
    10321: "terug naar admin",
    10323: "Facturering",
    10326: "Boek",
    10329: "Bulkupload",
    10332: "Tags voor bulkuploads",
    10335: "Bulk-upload TSV",
    10338: "Bedrijfsnaam",
    10520: "Kalender",
    10523: "Annuleren",
    10526: "Kan toewijzing van hoofdlocatie niet uploaden!",
    10529: "Categorie",
    10532: "Rol veranderen",
    10535: "Citatiegeschiedenis",
    10538: "stad",
    10541: "Klik hier",
    10544: "Klik op een gebruiker om hem deze rol toe te wijzen",
    10547: "CO",
    10548: "bevestig wachtwoord",
    10550: "Kopiëren",
    10553: "Knippen en plakken",
    10556: "Kon rol niet veranderen!",
    10559: "Kan bericht niet uploaden",
    10562: "Landen",
    10565: "Land",
    10568: "coupon code",
    10571: "Coupon code (optioneel)",
    10574: "Maak een nieuw filter door onderstaande opties te selecteren",
    10577: "Maak een nieuw filter",
    10580: "Nieuw rapport maken",
    10583: "Maak berichten",
    10586: "Tag maken",
    10589: "Maak dit rapport",
    10592: "Maak deze rol",
    10595: "Gemaakt door",
    10598: "Klantacties",
    10720: "D",
    10723: "Dashboard",
    10726: "Datum",
    10729: "Datumbereik",
    10732: "Dag",
    10735: "Deactiveren",
    10738: "STANDAARD",
    10741: "Stel uit voordat u een bericht plaatst",
    10744: "Verstuur het verzenden van antwoorden met",
    10747: "Verstuur het verzenden van antwoorden met",
    10750: "Verwijderen",
    10753: "Verwijderen?",
    10754: "Verwijder profiel",
    10756: "omschr",
    10759: "Omschrijving",
    10762: "Direct",
    10765: "Directe vragen",
    10768: "Routebeschrijving",
    10771: "Ontdekking",
    10774: "Duidelijk zicht",
    10777: "Download alle locatiegegevens",
    10780: "Downloaden",
    10783: "Download Google locatiegegevens",
    10786: "Gegevens downloaden",
    10789: "Concepten",
    10792: "Rij richtingen",
    10795: "Routebeschrijving overdag",
    10920: "Bewerking",
    10923: "Bewerk profiel",
    10926: "Rapport bewerken",
    10929: "Bewerk dit rapport",
    10932: "Editor",
    10935: "E-mail",
    10938: "Eindtijd",
    10941: "Voer adWords locatie-extensies in",
    10944: "Voer de naam van de entiteitstag in",
    10947: "Voer labels in",
    10950: "Voer zoektekst in",
    10953: "Voer de tagnaam in",
    10956: "IGelijkn",
    10959: "Evenement",
    10962: "Evenementdetails",
    10965: "Titel van het evenement",
    10968: "Elke",
    10971: "voorbeeld.com",
    10974: "Voorbeeld: 20% korting in winkel of online",
    11120: "Feature Access Management",
    11123: "Filters",
    11126: "Wachtwoord vergeten?",
    11129: "vrijdag",
    11320: "Aanbieding krijgen",
    11323: "Groter dan",
    11520: "Geluksbeoordeling",
    11525: "Helpen",
    11530: "Vakantie",
    11535: "Uur",
    11540: "Uren",
    11545: "Hoe klanten naar uw bedrijf zoeken",
    11720: "Beeld",
    11723: "afbeelding URL",
    11726: "In Maps",
    11729: "Op zoek",
    11732: "Postvak IN",
    11735: "Indirecte vragen",
    11738: "Inzichten",
    11741: "Onvoldoende toestemming",
    11744: "Integratie",
    11747: "Integraties",
    11750: "Gebruiker uitnodigen",
    11753: "UITGENODIGD",
    11756: "Uitgenodigd door",
    11759: "artikelen",
    12120: "Kennisvenster",
    12320: "Etiketten",
    12323: "Laatste aanmelding",
    12326: "Laatst bijgewerkt",
    12329: "Leer meer",
    12332: "Minder dan",
    12335: "Link voor uw knop",
    12338: "Link om aanbieding in te wisselen",
    12341: "Link om aanbieding in te wisselen (optioneel)",
    12344: "Koppeling",
    12347: "Beheer van vermeldingen",
    12350: "Lokale prestaties",
    12353: "Overzicht van lokale prestaties",
    12356: "Lokale zoekconversie",
    12359: "Plaatsen",
    12362: "Plaats",
    12365: "Plaats",
    12368: "Locatie Details",
    12371: "Locatie-ID",
    12374: "Locaties",
    12377: "Log in",
    12380: "Uitloggen",
    12520: "M",
    12523: "Laat je post opvallen met een foto",
    12526: "Beheer bulkactiviteiten",
    12529: "Entiteitstags beheren",
    12532: "Beheer locaties",
    12535: "Profiel beheren",
    12538: "Beheer rollen",
    12541: "Gebruikers beheren",
    12544: "Kaarten",
    12547: "Aantal verkopers",
    12550: "Koopvaardij foto's",
    12553: "Foto's van verkopers",
    12556: "Bericht",
    12559: "Minuten",
    12562: "Maandag",
    12565: "Maand",
    12720: "Naam",
    12723: "Naam van de nieuwe rol",
    12726: "Naam van het rapport",
    12729: "Een account nodig?",
    12732: "Nieuw",
    12735: "Volgende bladzijde",
    12738: "Geen antwoorden",
    12741: "geen resultaten gevonden",
    12744: "Er zijn geen beoordelingstags",
    12747: "Geen beoordelingen",
    12750: "Nee, annuleren",
    12753: "Aantal gebruikers",
    12756: "Aantekeningen",
    12920: "van",
    12923: "Aanbod",
    12926: "OK",
    12929: "OK ik snap het!",
    12932: "Eenmaal",
    12935: "Openingsdatum",
    12938: "Bestellen",
    12941: "Organisaties",
    12944: "Outbox",
    12947: "Eigenaar",
    13120: "bladzijde",
    13123: "Wachtwoord",
    13126: "Plak TSV",
    13129: "Pdf-type",
    13132: "Telefoon",
    13135: "Telefoontjes per dag",
    13138: "Telefoonnummer",
    13141: "Aantal foto's",
    13144: "Fotoweergaven",
    13147: "Voer een ontvangersnaam in!",
    13150: "Voer een rapportnaam in!",
    13153: "Geef een samenvatting op!",
    13156: "Voer een titel in!",
    13159: "Voer een geldige tijd in!",
    13162: "Voer een geldige URL in!",
    13165: "Vernieuw de pagina om uw locatiegegevens bij te werken",
    13168: "Herlaad alstublieft",
    13171: "Selecteer Schedule Type!",
    13174: "Berichtgeschiedenis",
    13177: "Berichten",
    13180: "Vorige pagina",
    13183: "Primaire categorie",
    13186: "Vaste telefoon",
    13189: "Primair telefoonnummer",
    13192: "Profielen",
    13195: "Openbare telling",
    13198: "Openbare foto's",
    13201: "Openbare foto's",
    13204: "PUBLICEREN",
    13520: "Beoordeling",
    13523: "Real-time meldingen",
    13526: "Lijst met ontvangers",
    13529: "Terugkerend",
    13532: "Gebruiker verwijderen",
    13535: "Antwoord",
    13538: "Goedkeuring antwoorden",
    13541: "Rapportbeheer",
    13544: "Rapportnaam",
    13547: "Rapporttype",
    13550: "Wachtwoord opnieuw instellen",
    13553: "Reactie door Star Rating",
    13556: "Beoordeling tellen",
    13559: "Bekijk Download",
    13562: "Bekijk instellingen",
    13565: "Bron bekijken",
    13568: "Review tags",
    13571: "Link bekijken",
    13574: "Recensies",
    13577: "Recensies van Star Rating",
    13580: "Beoordelingen versus gemiddelde beoordeling",
    13583: "Beoordelingen Inbox",
    13586: "Beheer van beoordelingen",
    13589: "Beoordelingen, dag van de maand",
    13592: "Beoordelingen, dag van de week",
    13595: "Beoordelingen, maand van het jaar",
    13598: "Rol",
    13601: "Rolgegevens",
    13604: "Rol naam",
    13720: "zaterdag",
    13723: "Sparen",
    13726: "Sla als aangepast filter op",
    13729: "Bewaar nieuw filter",
    13732: "Rol opslaan",
    13735: "Opgeslagen antwoorden",
    13738: "Planningsdatum",
    13741: "Post plannen",
    13742: "Een rapport plannen",
    13744: "Plan de tijd",
    13747: "Type planning",
    13750: "Zoekopdracht",
    13753: "Zoekopdrachten",
    13756: "Selecteer",
    13759: "Selecteer een bestaand filter",
    13762: "selecteer categorie",
    13765: "Selecteer stad",
    13768: "Selecteer land",
    13771: "Selecteer datum en tijd",
    13774: "Selecteer datumbereik",
    13777: "Selecteer Editor (s) om te bekijken",
    13780: "Selecteer Entity Tag",
    13783: "Selecteer filter",
    13786: "Selecteer filters",
    13789: "Selecteer granulariteit",
    13792: "Selecteer organisatie",
    13795: "Selecteer Review -tag",
    13798: "Selecteer opgeslagen filter",
    13801: "Selecteer Bron",
    13804: "Selecteer staat",
    13807: "Selecteer Tijd",
    13810: "ZELF",
    13813: "Stuur het ter goedkeuring",
    13816: "Stuur het naar Outbox",
    13819: "Verzonden",
    13822: "Diensten",
    13825: "Instellingen",
    13828: "Instellingenbeheer",
    13831: "Winkel",
    13834: "Toon berichten",
    13837: "Nav tonen / verbergen",
    13840: "Inschrijven",
    13843: "Eén locatie bewerken",
    13846: "Sorry!",
    13849: "Sorteer op",
    13852: "Speciale uren",
    13855: "Specifieke toegang",
    13858: "STANDAARD",
    13861: "Starttijd",
    13864: "Staat",
    13867: "Toestand",
    13870: "Op te slaan",
    13873: "Bewaar de code",
    13876: "Straat",
    13879: "Overzichtsweergave",
    13882: "zondag",
    13885: "Synchroniseer dit account",
    13920: "Telefoon",
    13923: "Voorwaarden",
    13926: "donderdag",
    13929: "Tijd",
    13932: "Top Plaatsen",
    13935: "Totaal",
    13938: "Dinsdag",
    14120: "Onbeantwoord",
    14123: "Weet u niet zeker wat het formaat is?",
    14126: "Uploaden",
    14129: "Upload locatiedetails",
    14132: "Locatiekaart uploaden",
    14135: "Locatietoewijzing uploaden",
    14138: "Upload TSV",
    14141: "URL",
    14144: "Gebruikersnaam",
    14320: "Bekijk afbeelding",
    14323: "Bekijk profiel",
    14326: "Keer bekeken",
    14520: "W",
    14523: "Website",
    14526: "Website per dag",
    14529: "website naam",
    14532: "woensdag",
    14535: "Week",
    14538: "Welke acties ondernemen klanten",
    14541: "Wanneer er op een review wordt gereageerd",
    14544: "Waar klanten uw bedrijf bekijken",
    14547: "Wilt u dit geplande bericht verwijderen?",
    14550: "Schrijf uw titel",
    14920: "Jaar",
    14923: "Ja, ga verder",
    14926: "U kunt ervoor kiezen om de toegang van gebruikers met deze rol te beperken door een filter te selecteren dat eraan moet worden gekoppeld.",
    14929: "Uw naam",
    15120: "Zip",
    20010: "maandag",
    20011: "ma",
    20020: "dinsdag",
    20021: "di",
    20030: "Woensdag",
    20031: "wo",
    20040: "Donderdag",
    20041: "do",
    20050: "Vrijdag",
    20051: "vr",
    20060: "Zaterdag",
    20061: "za",
    20070: "Zondag",
    20071: "zo",
    20110: "januari",
    20111: "jan",
    20120: "februari",
    20121: "feb",
    20130: "maart",
    20131: "maart",
    20140: "april",
    20141: "apr",
    20150: "mei",
    20151: "mei",
    20160: "juni",
    20161: "juni",
    20170: "juli",
    20171: "juli",
    20180: "augustus",
    20181: "aug",
    20190: "september",
    20191: "sept",
    20200: "oktober",
    20201: "okt",
    20210: "November",
    20211: "nov",
    20220: "december",
    20221: "dec",
    20231: "Recensies en beoordelingen",
    20241: "Percentage",
    20251: "Herzien met percentage",
    20261: "Cumulatief",
    20271: "Cumulatieve telling",
    20281: "Bron",
    20291: "Beoordeling door bronnen",
    20301: "Geluk",
    20311: "Reactietijd",
    20321: "Selecteer een locatie",
    20331: "Zoek op reviews trefwoord",
    20341: "zoek op Reviewer",
    20351: "Selecteer",
    20361: "Is gelijk aan",
    20371: "Minder dan",
    20381: "Groter dan",
    20391: "Selecteer Maanden",
    20401: "Selecteer een datum",
    20411: "Klik om deze beoordelingen te bekijken",
    20421: "Er zijn geen beoordelingen gevonden voor de geselecteerde periode en criteria",
    20431: "Filter wissen",
    20441: "Verwijder een aangepast filter",
    20451: "Heeft Google Updates",
    20461: "Geverifieerd",
    20471: "Locatie gepubliceerd",
    20481: "Heeft bewerkingen in behandeling",
    20491: "Kennispaneel",
    20501: "Link bekijken",
    20511: "Routebeschrijving",
    20521: "Duplicaat",
    20531: "Actief",
    20541: "Kan bijwerken",
    20551: "Kan verwijderen",
    20561: "Geen beoordeling in behandeling",
    20571: "Locatie ingeschakeld",
    20581: "Niet losgekoppeld",
    20591: "Wijzig logboek",
    20601: "Afbeelding in bulk uploaden",
    20611: "Afbeeldingsgeschiedenis",
    20621: "Bulkupload Opmerking",
    20631: "Vraag en antwoord in bulk uploaden",
    20641: "q & a geschiedenis",
    20651: "Voeg een vraag toe",
    20661: "Stel een vraag aan klanten die een kernwaardepropositie of een duidelijk concurrentievoordeel van uw locatie benadrukt. Vervolgens kunt u de vragen beantwoorden.",
    20671: "Platformdetails",
    20681: "Variabelen voor automatisch antwoorden",
    20691: "Locatie naam",
    20701: "Geo-naam",
    20711: "Handtekening",
    20721: "Geo-naam (max. 80 tekens)",
    20731: "Handtekeningnaam (max. 80 tekens)",
    20741: "Auto antwoord",
    20751: "Download beoordelingen",
    20761: "Automatisch Antwoord",
    20771: "externe link",
    20781: "Kopieer Review",
    20791: "Noot toevoegen",
    20801: "Externe opmerking",
    20811: "Markeren als ongepast",
    20821: "Markeer als verwijderd",
    20831: "Weet je het zeker ?",
    20841: "Wilt u deze recensie markeren als verwijderd van Google?",
    20851: "Voeg opgeslagen antwoorden in",
    20861: "Opslaan als antwoordsjabloon",
    20871: "Sjabloon voor automatisch antwoorden invoegen",
    20881: "Sturen",
    20891: "Stuur voor goedkeuring",
    20901: "Opslaan als concept",
    20911: "Notitie toewijzen",
    20921: "E-mailnotitie",
    20931: "Ontvanger",
    20941: "Bewaar als notitie",
    20951: "Dichtbij",
    20961: "Weggooien",
    20971: "Verzend mail",
    20981: "Je hebt geen opgeslagen notities",
    20991: "Allemaal ingehaald!",
    21001: "Geen items om weer te geven",
    21011: "Verzonden antwoorden",
    21021: "De recensent heeft geen opmerkingen toegevoegd",
    21031: "Bewerk antwoord",
    21041: "Antwoord verwijderen",
    21051: "Zoek opgeslagen antwoorden",
    21061: "Voeg opgeslagen antwoord toe",
    21071: "Kies een groep en onderwerp om dit antwoord op te slaan.",
    21081: "Selecteer een groep of begin met typen om er een te maken",
    21091: "Voer hier de titel in",
    21101: "Voer antwoordsjabloon in",
    21111: "Zorg ervoor dat u een groep en titel selecteert/maakt om dit antwoord op te slaan.",
    21121: "Automatische antwoorden",
    21131: "Automatisch antwoord toevoegen",
    21141: "Selecteer een groep",
    21151: "Voer hier variabele in",
    21161: "Kies uw variabelen",
    21171: "Wil je doorgaan?",
    21181: "Deze aanvraag bevat meer dan 100 beoordelingen. Voor dergelijke verzoeken sturen we u een e-mail met een link om de recensie csv te downloaden.",
    21191: "Je hebt meer dan 100 beoordelingen",
    21201: "We sturen u een e-mail (naar X) met een link om de recensie csv te downloaden.",
    21211: "Acties",
    21221: "Alle locatie",
    21231: "Gem. Beoordeling",
    21241: "Merk",
    21251: "Direct",
    21261: "Ontdekking",
    21271: "Aardrijkskunde",
    21281: "Geluk",
    21291: "Vragen",
    21301: "Antwoorden",
    21311: "Keer bekeken",
    21321: "Plaats schema",
    21331: "Google Post-schema",
    21341: "Post maken",
    21351: "Post beheren",
    21361: "Plan LocalPost",
    21371: "Uploaden",
    21381: "Vooruitgang",
    21391: "Valideren en plannen",
    21401: "Schedule Status",
    21411: "Selecteer bestand",
    21421: "Selecteer een schema -type",
    21431: "Onmiddellijk",
    21441: "Bestandstijd",
    21451: "Selecteer Tijd",
    21461: "Plaats onmiddellijk na verificatie",
    21471: "Schema op basis van de tijd in het bestand",
    21481: "Plan het bestand op de door u geselecteerde tijd",
    21491: "Wachtrij",
    21501: "Validatie wordt uitgevoerd. De verwerkingstijd is ongeveer 40 berichten per minuut. Na validatie is de status van elk bericht beschikbaar op de volgende pagina.",
    21511: "Post verwerkt",
    21521: "Succesvolle validatie",
    21531: "Validatie mislukt",
    21541: "Gepland",
    21551: "Type / actie",
    21561: "Datums",
    21571: "Begin",
    21581: "Einde",
    21591: "Titel / product",
    21601: "Samenvatting plaatsen",
    21611: "Toestand",
    21621: "Succes",
    21631: "Mislukt",
    21641: "Bewerken verwijderen",
    21651: "Post Insights",
    21661: "Google Post Insights",
    21671: "Prestatie",
    21681: "Plaats weergaven",
    21691: "Post door media",
    21701: "Plaats op onderwerp",
    21711: "Plaats door actie",
    21721: "Analyse",
    21731: "Gemaakt",
    21741: "Type",
    21751: "Actie",
    21761: "Bronfilter",
    21771: "Platform",
    21781: "Update de status van de lokale post",
    21791: "Campaign Builder",
    21801: "Intelligente automatische respons",
    21811: "Schakel het maken van campagnes voor automatische respons in",
    21821: "Voordat u de optie voor automatische reactieschema inschakelt, moet u de onderstaande instructies volgen:",
    21831: "Voordat u Inteligent Auto-respons inschakelt, moet u ervoor zorgen dat u uw automatische antwoord-sjablonen toevoegt in het gedeelte ReviewInbox. Bouw eerst de antwoorden op, zodat ze kunnen worden toegewezen aan de sterbeoordelingen (1-5) die een Inteligent Auto-reactie zullen activeren.",
    21841: "Selecteer in Campaign Builder een vertragingstijd tussen ontvangstbevestiging en automatische antwoordlevering. De vertragingsinstelling moet overeenkomen met de ideale reactietijd voor de beoordeling, aangezien deze bedoeld is om de automatische aard van het programma te maskeren.",
    21851: "Overweeg ook om de werkingstijd (dagen van de week en uren van de dag) voor de campagne in te stellen. De standaardinstelling voor de tijdzone is GMT + 00: 00, dus update alstublieft waar nodig.",
    21861: "Campaign maken",
    21871: "Wijs een naam en eventuele opmerkingen toe om uw campagne gemakkelijk te identificeren.",
    21881: "Campagne naam",
    21891: "Campagne-responder",
    21901: "Als er geen optie is geselecteerd, is het e-mailadres dat wordt gebruikt voor het aanmelden en autoriseren van accounts de standaardrespondent.",
    21911: "Respondent voor het automatische antwoord",
    21921: "Periode van campagne",
    21931: "Aantekeningen / doelen",
    21941: "Campagnebeschrijving",
    21951: "Stel triggers in",
    21961: "Kies het type beoordeling (en) waarmee een automatische reactie op deze campagne wordt gevraagd.",
    21971: "met commentaar",
    21981: "zonder commentaar",
    21991: "vorige",
    22001: "De volgende",
    22011: "Doelgroep instellen (optioneel)",
    22021: "Stel de locaties in om deel uit te maken van de campagne op basis van een entiteitstag, een organisatie of een specifiek land / gebied / plaats. Deze filters zijn alleen beschikbaar voor Google-recensies en toegewezen locaties",
    22031: "entiteit",
    22041: "organisatie",
    22051: "Stel schema in",
    22061: "Wijs de parameters en het schema toe voor de reacties op recensies, d.w.z. het percentage van de gerichte recensies en de openingstijden voor reacties.",
    22071: 'Houd er rekening mee dat automatische reacties momenteel alleen beschikbaar zijn op basis van "doorgaan". We werken aan afzonderlijke processen voor gebruikers die mogelijk op korte termijn automatisch willen opschonen.',
    22081: "Stel het responspercentage in",
    22091: "aantal reacties instellen",
    22101: "vertraging voordat automatisch antwoord wordt verzonden",
    22111: "schema periodiek",
    22121: "Selecteer de dag en stel de tijd in om de automatische respons periodiek in te plannen",
    22131: "Selecteer tijdzone",
    22141: "Wijs reacties toe",
    22151: "Selecteer in de lijst welke reacties u voor deze campagne in roulatie wilt gebruiken.",
    22161: "Bevestigen",
    22171: 'Bekijk elk van de onderstaande details en klik op "bevestigen" om uw campagne te starten.',
    22181: "Dagen",
    22191: "Ster",
    22201: "Gem",
    22211: "Rapportage",
    22221: "Configuratie van concurrent",
    22231: "Beste praktijken",
    22241: "Kwadrant",
    22251: "Waarderingen",
    22261: "Competitieve ranking",
    22271: "Reactie",
    22281: "Bekijk beoordelingsbronnen",
    22291: "Concurrent toevoegen",
    22301: "Gefilterd op",
    22311: "Duidelijk",
    22321: "Concurrent",
    22331: "CompEntity",
    22341: "Entity-tag",
    22351: "Opmerkingen",
    22361: "Geen opties",
    22371: "Slecht",
    22381: "Arm",
    22391: "Gemiddelde",
    22401: "Geweldig",
    22411: "Uitstekend",
    22421: "Beoordelingen met antwoord",
    22431: "Beoordelingen zonder antwoord",
    22441: "Beoordelingen met opmerkingen",
    22451: "Beoordelingen zonder opmerkingen",
    22461: "Bekijk volume versus gemiddelde beoordeling",
    22471: "Merken",
    22481: "Zoom",
    22491: "Totaal aantal beoordelingen",
    22501: "Beoordeling beoordelen op ster",
    22511: "Beoordelingen van concurrenten",
    22521: "Concurrent van",
    22531: "Code",
    22541: "Beheer concurrenten",
    22551: "Bijgewerkt",
    22561: "Concurrenten toevoegen",
    22571: "Voeg locatie toe",
    22581: "Naam concurrent toevoegen",
    22591: "The first step is to add the competitor's name, once you have added the names and optional icons (48x48 images) to the list, click on 'Add'. Once the Competitors are created, you will be able to assign the individual locations",
    22601: "Voer naam concurrent in (verplicht)",
    22611: "Voer concurrent URL in (optioneel)",
    22621: "Afbeelding uploaden",
    22631: "Komt binnenkort",
    22641: "Commentaarverhouding",
    22651: "Percentage beoordelingen met en zonder opmerkingen",
    22661: "Zonder",
    22671: "Met",
    22681: "Reageer lengte",
    22691: "Gemiddeld aantal woorden dat in elke opmerking wordt gebruikt, op sterbeoordeling",
    22701: "Woorden",
    22711: "Woordverhouding",
    22721: "Totaal en percentage van woorden in opmerkingen voor elke sterbeoordeling",
    22731: "here.",
    22741: "Concurrenten",
    22751: "Tag toevoegen",
    22761: "Kies variabelen die aan de sjabloon moeten worden toegevoegd",
    22771: "sluit beoordeling",
    22781: "Gesloten review",
    22791: "Wilt u deze recensie sluiten? Zodra u sluit, moet u het opnieuw openen om te kunnen antwoorden",
    22801: "Extern",
    22811: "Negatief",
    22821: "Nee",
    22831: "Nog geen automatische antwoorden!",
    22841: "Nog geen bewaarde reacties!",
    22851: "Opmerking",
    22861: "Permanent gesloten",
    22871: "Positief",
    22881: "Time-out voor lezen",
    22891: "Herstel beoordeling",
    22901: "Heropening recensie",
    22911: "Antwoordde",
    22921: "Antwoord verzonden (vanuit Google-interface)",
    22931: "Antwoord verzonden vanuit de app",
    22941: "Review verwijderd",
    22951: "Sjablonen",
    22961: "Tijdelijk gesloten",
    22971: "Ja",
    22981: "U heeft geen opgeslagen concepten",
    22991: "Onvoldoende machtigingen om toegang te krijgen tot de bron",
    23001: "Interne fout opgetreden",
    23011: "Aanvraag bevat een ongeldig argument",
    23021: "Gevraagde entiteit is niet gevonden",
    23031: "Beoordeling bestaat niet langer op Google-platform",
    23041: "Sommige waarden voor automatisch invoegen zijn niet beschikbaar. Vervang en verzonden",
    23051: "De service is momenteel niet beschikbaar",
    23061: "Deze bewerking wordt niet ondersteund voor niet-opgeëiste locaties",
    23071: "Gepubliceerde post",
    23081: "Geplande post",
    23091: "Vriendelijke naam",
    23101: "Add friendly name",
    23111: "Contact",
    23121: "No contacts!",
    23131: "To add contact",
    23141: "contactnaam",
    23151: "Contact E-Mail",
    23161: "Toevoeg contact",
    23171: "Post Insights",
    23181: "Google Post Insights",
    23191: "Geen gegevens",
    23201: "Google Audit",
    23211: "Auditlogboeken",
    23221: "Selecteer een rapport",
    23231: "Select",
    23241: "All Download",
    23251: "No options",
    23261: "Gegevensdownloads",
    23271: "Review downloaden",
    23281: "Alle beoordelingen",
    23291: "Download foto-URL",
    23301: "Klantfoto-URL's",
    23311: "Merchant Photo URL's",
    23321: "Rapporteer Geschiedenis Downloads",
    23331: "Report Name",
    23341: "Verzonden naar",
    23351: "Geplaatste tijd (UTC)",
    23361: "Rapporttype",
    23371: "Profile Details",
    23381: "Change Profile Name",
    23391: "Weekly sync",
    23401: "Enable Bulk Manage Location Tab",
    23411: "Date Format settings",
    23421: "Save",
    23431: "Happiness/NPS Setting",
    23441: "Promoter/Happy",
    23451: "Neutral",
    23461: "Detractor/Unhappy",
    23471: "Update",
    23481: "Current Logos",
    23491: "Full Logo",
    23501: "Icon",
    23511: "Report Logo",
    23521: "Favicon",
    23531: "This logo will present on the top-left corner while expanded left navigation of your profile.",
    23541: "This logo will present on the top-left corner of your profile.",
    23551: "This logo will be displayed in the dashboard reports and review reports generated in the system.Use a png image of size between 5kb to 20kb for best results",
    23561: "This logo will present on the top-left corner of the browser tab.",
    23571: "Replace logo",
    23581: "Choose which type logo you want to change using the dropdown options and upload logo.",
    23591: "Upload Logo For",
    23601: "GBP Location Status Configuration: Suppression Settings",
    23611: "Suppress",
    23621: "Visible",
    23631: "Disconnected",
    23641: "Unverified",
    23651: "Suspended",
    23661: "Duplicate",
    23671: "First Party Review Upload",
    23681: "Uploaden",
    23691: "Clear",
    23701: "Manage Locations in Bulk",
    23711: "Bulkmanagementcontrole",
    23721: "Update locatiedetails en besturingsplatformparameters rechtstreeks in Google Sheets.",
    23731: "PLATFORM",
    23741: "Beheer eenvoudig accounts van elke schaal met aangepaste locatievariabelen en -instellingen.",
    23751: "GBP-details",
    23761: "Bekijk alle Google Business Profile Listings en voeg direct Locatiedetails toe / bewerken / verwijderen.",
    23771: "GBP-attributen",
    23781: "Wijs alle in aanmerking komende kenmerken toe aan elke locatie om incrementele zoektocht te krijgen.",
    23791: "GBP-lijst",
    23801: "Maak nieuwe GBP-vermelding.",
    23811: "Facebook",
    23821: "Facebook Listing Control",
    23831: "Geschiedenis",
    23841: "OPLEIDING",
    23851: "Toegangsmiddelen voor bulk bewerken workflows, beste praktijken, beperkingen en updates.",
    23861: "WAARSCHUWING",
    23871: "Vereiste",
    23881: "Gebruikers moeten een Google-account hebben, zodat het systeem een ​​Google-blad kan presenteren met de profielgegevens.",
    23891: "Kennisgeving:",
    23901: "De gegevens die elk vel vullen als in de systeemdatabase. Als u er zeker van wilt zijn dat de spreadsheet huidige Google-gegevens presenteert, raden wij u ten zeerste aan dat u eerst uw profiel synchroniseert.",
    23911: 'Afhankelijk van het aantal locaties in uw account, kunnen de Google-vellen tijd kosten om in eerste instantie te bouwen en vervolgens te vernieuwen terwijl u het vel navigeert. Zorg ervoor dat alle gegevens stabiel zijn voordat u op de "Update" drukken om de bewerkingen op het systeem op te slaan en updates op Google te duwen.',
    23921: "Het platform heeft een directe API-verbinding met Google, maar er kunnen nog steeds tijden zijn waarop Google de directe update naar de pagina Openbare Locatie vermeldt.",
    23931: 'Pushing "Update" triggert een direct systeem rechtstreeks naar Google. Er is geen ongedaan gemaakt of terugkeerproces beschikbaar. Zorg ervoor dat u zich comfortabel voelt bij alle bewerkingen voordat u de update activeert. Als een fout is gemaakt, wacht dan een paar minuten en maak vervolgens de nodige verandering.',
    23941: "KLEURENSCHEMA",
    23951: "Elk vel heeft een standaardkleurenschema om gebruikers te begrijpen die velden in aanmerking komen voor het bewerken.",
    23961: "Variabelen die de statusgegevens van Google overbrengen of niet rechtstreeks via bulkbesturingen kunnen worden bewerkt.",
    23971: "Google Variabelen openen direct voor Bulk Edit.",
    23981: "Platformvariabelen direct openen voor bulkbewerking.",
    23991: "Controle",
    24001: "Details",
    24011: "Attributen",
    24021: "Maak een lijst",
    24031: "Instructies",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "/PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 14 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "Werkzaamheid",
    24361: "Geautoriseerd",
    24371: "Geautoriseerde verbindingen Toegang tot volledige beoordelings- en responsmogelijkheden van / naar elke bron.",
    24381: "Bulk uploaden entiteit tags",
    24391: "Bulk upload GBP Detail",
    24401: "Choose a group and subject to save the auto reply.",
    24411: "Count",
    24421: "Maak entiteit tag",
    24431: "Create Time (UTC)",
    24441: "Custom Sidebar Tabs",
    24451: "Custom Sidebar Tools",
    24461: "Download GBP Audit",
    24471: "File Name",
    24481: "GBP detailgeschiedenis",
    24491: "Indrukken",
    24501: "Inactief",
    24511: "Geïndexeerd",
    24521: "Geïndexeerde verbindingen Toegang tot alle historische en huidige beoordelingen van elke bron.",
    24531: "Manage LocalPost",
    24541: "Geen reactie toegevoegd",
    24551: "Nummer",
    24561: 'Please click on "New Report" Button,on the top Right',
    24571: "Profile Created",
    24581: "Request Id",
    24591: "Bewaar een antwoord",
    24601: "Totale locatie",
    24611: "Total Post",
    24621: "Upload AR Template",
    24631: "Upload locatie-aliassen",
    24641: "Weergave",
    24651: "You can configure and set custom tabs in the sidebar pointing to an iframe within platform, or a link hosted externally.",
    24661: "GBP DETAILS",
    24671: "GBP ATTRIBUTES",
    24681: "GBP LISTING",
    24691: "FACEBOOK",
    24701: "HISTORY",
    24711: "TRAINING",
    24721: "Weekly sync triggered on",
    24731: "MMM D,YYY",
    24741: "Eg:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "Eg:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "Eg:- 13 October 2020",
    24821: "Upload New Logo",
    24831: "Losgemaakt",
    24841: "Visible Hidden",
    24851: "Review Details Pane Configuration",
    24861: "Show Store code",
    24871: "Show Full Address",
    24881: "Show Summary Widget",
    24891: "Inverted Header",
    24901: "Choose File",
    24911: "No file chosen",
    24921: "Bekijk een logboek van elke update om te voorkomen dat het vermelding van inhoud wordt gewijzigd Wijzigingen en plaats eventuele fouten.",
    24931: 'Depending on the number of locations in your account, the Google Sheets may take time to initially build and then refresh as you navigate the sheet. Please make certain that all data is stable before pushing "Update" to save the edits to the system and push updates to Google.',
    24941: "Resources for bulk edit workflows, best practices, limitations, and updates.",
    24951: "gebruikersnaam",
    24961: "Do you want to delete?",
    24971: "Rekening",
    24981: "Heeft geen Google-updates",
    24991: "Eerbied niet vereist",
    25001: "No pending edits",
    25011: "Auditijd",
    25021: "Veld",
    25031: "Waarde (naar)",
    25041: "Waarde (van)",
    25051: "remove from entity tag",
    25061: "Attributierist",
    25071: "adwords",
    25081: "View All",
    25091: "Q&A",
    25101: "Ontdekken",
    25111: "Verken reacties",
    25121: "Selecteer sjabloon",
    25131: "Doorgaan",
    25141: "Kies Star Rating, sjabloonnaam en voeg sjablooninhoud toe om het automatische antwoord op te slaan.",
    25151: "Selecteer het antwoordtype",
    25161: "Sjabloon",
    25171: "Fragment",
    25181: "Toewijzen aan beoordeling (vereist)",
    25191: "Voer sjabloonnaam in (verplicht)",
    25201: "Aangepaste sjabloonvariabele (optioneel)",
    25211: "Selecteer of maak onderwerp (optioneel)",
    25221: "Toewijzen aan enkele locatie",
    25231: "Toewijzen aan entiteitstag",
    25241: "Add Topic name and snippet content to save the auto reply.",
    25251: "Total # items",
    25261: "Locatie Opmerking",
    25271: "View Location Details",
    25281: "View Google Knowledge Pannel",
    25291: "Zie de beoordeling rechtstreeks op Google",
    25301: "Positive-5 Stars",
    25311: "Negative - 1/2 Stars",
    25321: "Mixed - 3/4 Stars",
    25331: "Sjabloonnaam",
    25341: "Variabele",
    25351: "Selecteer of maak een onderwerp",
    25361: "Groep",
    25371: "Onderwerp",
    25381: "Eerdere beoordelingen",
    25391: "Bewaar als antwoord",
    25401: "Cc",
    25411: "Reset",
    25421: "WHAT'S NEW",
    25431: "Maak de datum",
    25441: "Aangepaste filternaam",
    25451: "READ ONLY",
    25461: "Feature Access",
    25471: "None",
    25481: "READ",
    25491: "Unrestricted",
    25501: "This is a default role and cannot be edited/deleted",
    25511: "Read",
    25521: "Write",
    25531: "Gedownload",
    25541: "All users assigned to this role will have visibilty/access to the following features",
    25551: "Settings Subtab Visibility",
    25561: "Manage Roles",
    25571: "Custom Sidebar",
    25581: "OR",
    25591: "Save role attributes",
    25601: "Are you sure you want to delete the role",
    25611: "This will change the role of all users currently assigned to this role to READ ONLY.",
    25621: "Assign Users",
    25631: "Users in profile",
    25641: "Search here",
    25651: "Users assigned to this role",
    25661: "NO USER",
    25671: "Re-invite",
    25681: "Standaard bestemmingspagina",
    25691: "Recensies Inbox",
    25701: "Bulkmanagement",
    25711: "Postplanningen",
    25721: "ON",
    25731: "OFF",
    25741: "Are you sure turn off Campaign?",
    25751: "Are you sure turn of Campaign?",
    25761: "Succesfully updated the campaign",
    25771: "Responspercentage",
    25781: "Antwoordtelling",
    25791: "Sterrenratings",
    25801: "Met",
    25811: "Zonder",
    25821: "Vertraging",
    25831: "Tijdzone",
    25841: "Beoordeling",
    25851: "Competitor Report",
    25861: "Formaat",
    25871: "HTML Email",
    25881: "Excel",
    25891: "Als er geen beoordelingen in het geselecteerde bereik zijn",
    25901: "Stuur geen e-mail",
    25911: "Stuur e-mail",
    25921: "Q&A",
    25931: "If there are no Q&A in selected range",
    25941: "Customer Image",
    25951: "Audit Log",
    25961: "Neem contact op met ondersteuning met vragen over profielsynchronisatie",
    25971: "Include Audit File",
    25981: "Profiel",
    25991: "CompTag",
    26001: "Bekijk details",
    26011: "Manage Tier Controls",
    26021: "Override the default functionality,organized into Tiers",
    26031: "Build Offer Tier",
    26041: "Create New Tier",
    26051: "Tier Name",
    26061: "DEFAULT",
    26071: "Default",
    26081: "Reputation Dashboard",
    26091: "Comprehensive insightsinto all review KPIs",
    26101: "Full visibility across all locations and sources",
    26111: "Sections",
    26121: "Core KPIs of review volume, average rating, distribution, source, Happiness, and response ratio.",
    26131: "Longitudinal analysis of reviews & rating, percent, cumulative, source, Happiness, and response time histogram.",
    26141: "Comment ratio, comment length and cumulative word ratio by rating.",
    26151: "Reviews by day of week, day of month, and month of year.",
    26161: "Top five countries, states/provinces, and cities by review volume.",
    26171: "All historic data is compiled during initial account set up and then updated from all connected review sources daily.",
    26181: "GBP Insights",
    26191: "Direct, Discover, and Brand daily search volume area chart.",
    26201: "Maps and Search daily views area chart.",
    26211: "Klantactiesgrafiek voor het besturen van richting, telefoontjes en website -klikken.",
    26221: "Location actions by day of week column charts.",
    26231: "Unique Local Conversion Ration (actions / daily searches).",
    26241: "Brand photo average quantity hosted to GBP location and total views",
    26251: "Customer uploaded photo average quantity hosted to GBP location and total views.",
    26261: "A full 18 months of daily data for every location is compiled during initial account set up and then updated from all connected review sources daily. Google currently reports Insights with a 3-5 day delay.",
    26271: "Local search exposure and action reporting.",
    26281: "LocalPerformance",
    26291: "Easily compare performance across locations",
    26301: "Daily line chart of selected individual locations for reviews, avg rating, searches, views, and actions",
    26311: "Sortable and searchable table presentation of each location’s reviews and local metrics with full download reporting.",
    26321: "Additional tab offers performance chart and table by geographic roll-up/drill-down with it’s own unique download trigger.",
    26331: "Reviews and GBP Insights table and charts by individual location.",
    26341: "ReviewsInbox",
    26351: "Aggregate inbox for all locations and sources - filter, search, respond, and manage.",
    26361: "Manage all reviews from all sources",
    26371: "Workflows",
    26381: "Search and filter to find reviews by rating, source, content, reviewer, tags or location.",
    26391: "Respond to authorized review sources directly from platform.",
    26401: "Explore templates by rating and snippets by topic to send personalized responses with unrivaled speed.",
    26411: "Create workflows for controlled response approvals.",
    26421: "Send notes or cc’ replies directly to location management.",
    26431: "Full Control",
    26441: "Manage Location Listings",
    26451: "Direct API add/edit/delete control of all location listings details across accounts.",
    26461: "Streamline control of any number of listings.",
    26471: "Search and filter across any number of locations and connected accounts by status and content.",
    26481: "Directly edit GBP details by individual location.",
    26491: "Create individual GBP Posts for all eligible locations.",
    26501: "Organize locations into an number of unique customer groups via entity tags.",
    26511: "Assign “Friendly Names” to make it easier to manage enterprise, chain, and franchise profiles.",
    26521: "Bulk add/edit GBP content, images, categories, hours, addresses, descriptions & more.",
    26531: "Bulk add new Google Questions & Answers to each location’s knowledge panel.",
    26541: "Bulk add/edit platform content such as location notes, local managers and more.",
    26551: "Competitor Review Tracking",
    26561: "Dashboard comparisons. Review distribution comparisons. Brand & location wave quadrant.",
    26571: "Gain unparalleled insights into competitor feedback",
    26581: "Competitor review reporting dashboard, filterable to identify exact comparisons.",
    26591: "Rating distribution comparison across competitor brands.",
    26601: "Wave chart of review volume versus average rating, comparing brands or individual locations,",
    26611: "Full review comment detail and even the competitor’s responses.",
    26621: "Section is officially still in beta status as we continue to add more reporting and presentation options.",
    26631: "Bulk Management",
    26641: "Unique “Spreadsheet UI” provide direct listing control via connected Google sheet.",
    26651: "The fastest and easiest way to control accounts of any size.",
    26661: "Platform - Bulk assignment and updates of the key variables to manage the platform.",
    26671: "Details - Primary section for all Google Business Profile details.",
    26681: "Attributes - Optimize the assignment of attributes across GBP listings",
    26691: "Create Listings - Build new GBP listings will all the critical content",
    26701: "Facebook - Control all Facebook details from a single spreadsheet",
    26711: "History - Log of file edits and updates.",
    26721: "Section is officially still in beta status as we continue to refine controls for accounts and include additional platforms.",
    26731: "Post Scheduling",
    26741: "Bulk creation and scheduling for Google Posts across locations and account.",
    26751: "Share critical updates and promotional messages",
    26761: "Download template to create Google Posts for all eligible locations.",
    26771: "Schedule timing for the entire file or set each post to start at a unique day and time",
    26781: "Plan an entire promotional calendar",
    26791: "Post Insights Reporting",
    26801: "View Google Post views and click performance over time - filters reporting by type, media, and call to action.",
    26811: "Identify performance trends to optimize free advertising",
    26821: "Bar chart represent performance over time, set date range and chart granularity.",
    26831: "View post volume by media, topic, and call to action type.",
    26841: "View each posts individual performance metrics.",
    26851: "Report download allows for further analysis by campaign.",
    26861: "Settings",
    26871: "The administrative section of the platform for all settings, roles, user permissions, report scheduling and data downloads",
    26881: "Enterprise-grade controls to set a customized experience for all users.",
    26891: "Primary Admin Sections",
    26901: "Authorize connection to platforms (Google, Facebook, TrustPilot, Booking).",
    26911: "Set integrations to available review sources.",
    26921: "Manage/Create distinct user roles.",
    26931: "Assign/Control individual access.",
    26941: "Schedule reporting by type, user, and even location.",
    26951: "Download data sets from the platform, access the 10 most recent requests.",
    26961: "Authorize Account",
    26971: "Google Audit",
    26981: "Integrations",
    26991: "Manager Role",
    27001: "Manage Users",
    27011: "Review Settings",
    27021: "Campagin Builder",
    27031: "Report Management",
    27041: "Data Downloads",
    27051: "Profile Details",
    27061: "Custom Navigation",
    27071: "Review Clarity",
    27081: "Claim Location",
    27091: "Authorized Sources",
    27101: "Required for full data access and direct review responses.",
    27111: "Options",
    27121: "Authorized connections will continue to grow as platforms make the API connections available.",
    27131: "Directly authorize the connection between the platform and user accounts to gain the created possible control.",
    27141: "All Sources",
    27151: "Indexed Review Sources",
    27161: "Aggregate feedback from 40+ sources across industry verticals",
    27171: "Notes",
    27181: "Use Google indexing to access reviews without control of the GBP listing.",
    27191: "Indexed sourcing is used for all competitive review collection.",
    27201: "After initial index, reviews and responses are collected daily",
    27211: "Public indexing or all historic reviews and responses by URL or PlaceID",
    27221: "All Sources",
    27231: "Configure",
    27241: "Yesterday",
    27251: "Last 7 days",
    27261: "Last week",
    27271: "Last 30 days",
    27281: "Last month",
    27291: "Altijd",
    27301: "Asc",
    27311: "Desc",
    27321: "No contact for cc",
    27331: "Bewaar dit antwoord",
    27341: "Select or create a group",
    27351: "Geen opgeslagen antwoorden",
    27361: "No auto replies",
    27371: "Total 0 items",
    27381: "Saved Templates",
    27391: "Total 26 items",
    27401: "Recently Used",
    27411: "Smileys & People",
    27421: "Has comments",
    27431: "No comments",
    27441: "Alle locaties",
    27451: "Open",
    27461: "Google Updates",
    27471: "Missing Content",
    27481: "Winkelcode",
    27491: "Additional Categories",
    27501: "Zoek locaties",
    27511: "GBP-audit",
    27521: "Bulkactiviteit",
    27531: "Selecteer Groep",
    27541: "20/ page",
    27551: "Synchroniseren",
    27561: "Instellen",
    27571: "Gedaan",
    27581: "Group Name",
    27591: "Minuut",
    27601: "with & without Comment",
    27611: "Rate",
    27621: "Kwadrantanalyse",
    27631: "Alle locatiesgegevens",
    27641: "Hoog zoeken + lage conversie",
    27651: "Hoog zoeken + hoge conversie",
    27661: "Lage zoekopdracht + lage conversie",
    27671: "Lage zoekopdracht + hoge conversie",
    27681: "Locatiegegevens per regio",
    27691: "Locatiegegevens per stad",
    27701: "Location:",
    27711: "Conversion Rate:",
    27721: "Searches:",
    27731: "Google Q&A",
    27741: "Google QA",
    27751: "Download QA",
    27761: "Post antwoord",
    27771: "Post inzicht",
    27781: "Download the sample CSV",
    27791: "Pre populated CSV",
    27801: "Manage Portfolio",
    27811: "Add Portfolio",
    27821: "View Portfolio",
    27831: "Delete Portfolio",
    27841: "Gebruikers",
    27851: "Manage Profiles",
    27861: "Remove Profile",
    27871: "Are you sure you want to Remove this profile ?",
    27881: "Accounts",
    27891: "Select Profiles",
    27901: "Select Profile",
    27911: "Portfolio Account",
    27921: "Portfolio Details",
    27931: "Portfolio Name",
    27941: "Currrent Portfolio Image",
    27951: "Upload image as a logo for portfolio",
    27961: "Change portfolio name",
    27971: "Free Trial",
    27981: "Current",
    27991: "Expired",
    28001: "Cancelled",
    28011: "Invoicing",
    28021: "Verbonden",
    28031: "Number of Accounts",
    28041: "Total Locations",
    28051: "Active Locations",
    28061: "Reviews (30 days)",
    28071: "Payment Status",
    28081: "Profile Name",
    28091: "Enter name of new portfolio",
    28101: "A portfolio can bulk manage their users across different profiles easily",
    28111: "Name of new portfolio",
    28121: "Portfolio names can only have a maximum of 20 characters",
    28131: "Portfolio Created Successfully!",
    28141: "Total Profile",
    28151: "Total Users",
    28161: "Enter email",
    28171: "Invite someone to help you manage profiles. You can set their access to profiles by selecting their role.",
    28181: "Invite",
    28191: "Current Portfolio Image",
    28201: "Sentiment",
    28211: "Awaiting",
    28221: "Meer filters",
    28231: "Review Tag",
    28241: "Opgeslagen filters",
    28251: "Minder filters",
    28261: "No Text",
    28271: "Medium",
    28281: "Expand",
    28291: "Single image upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "Open",
    28471: "Gesloten",
    28481: "VERWIJDERD",
    28491: "Nieuwe recensie Tag",
    28501: "alle Reviews",
    28511: "Niets te zien in dit gebied!",
    28521: "Zoeken",
    28531: "Selecteer alles",
    28541: "Zoekbron",
    28551: "Zoekrecensie -tag",
    28561: "Zoeklocatie",
    28571: "Zoekopslagcode",
    28581: "Zoekgroep",
    28591: "organisaties",
    28601: "Entity tags",
    28611: "Van toepassing zijn",
    28621: "Groep",
    28631: "Zoek opgeslagen filters",
    28641: "Geen opties!",
    28651: "Pas beoordelingstekstweergave aan",
    28661: "Zie de herziening rechtstreeks op",
    28671: "Antwoord Op Beoordeling Platform",
    28681: "Select Template",
    28691: "Kopiëren",
    28701: "Prior Reviews",
    28711: "geen beoordelingen",
    28721: "Beoordeling",
    28731: "Antwoord Locatie naam niet toegevoegd op deze locatie",
    28741: "Handtekening niet toegevoegd op deze locatie",
    28751: "Wilt u doorgaan downloaden?",
    28761: "Reviews zonder Antwoord",
    28771: "Beoordelingen met intern antwoord",
    28781: "Beoordelingen met automatisch herstel",
    28791: "Beoordelingen met extern antwoord",
    28801: "Bekijk Google Knowledge Panel",
    28811: "Locatie Note",
    28821: "nieuwe Manager",
    28831: "inschakelen Cc",
    28841: "Save As Antwoord",
    28851: "Antwoord verwijderen",
    28861: "Groep",
    28871: "Gemengd",
    28881: "Stars",
    28891: "Negatief, Mixed, Positive",
    28901: "Beoordeling",
    28911: "Template Name",
    28921: "veranderlijk",
    28931: "Save a Reply",
    28941: "Bewerk accountnaam",
    28951: "Wijzig accountnaam",
    28961: "Accountnaam",
    28971: "Facebook-locaties",
    28981: "Pagina toevoegen",
    28991: "Geactiveerd",
    29001: "Toon verborgen locatie",
    29011: "Bekijk de FB-pagina",
    29021: "Geen verborgen account om te laten zien",
    29031: "Uren geleden",
    29041: "Invoeren",
    29051: "Beoordeling Showcase",
    29061: "Google-locaties",
    29071: "Uw locaties",
    29081: "Locatie-URL",
    29091: "Weet je zeker dat je deze URL wilt verwijderen?",
    29101: "Wilt u URL en haar gerelateerde gegevens uit de toepassing verwijderen?",
    29111: "Concurrentlocaties",
    29121: "Concurrentnaam",
    29131: "Plaatsnaam",
    29141: "Comptag",
    29151: "Voer de details van de locatie-URL's en concurrent in",
    29161: "Iscompetitor",
    29171: "Boekingslocaties",
    29181: "Om de integratie van boekingsbeoordeling te initiëren",
    29191: "Back Office Location ID (optioneel)",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "Maak campagnes om direct te reageren op beoordelingen met de perfecte reactie op het perfecte moment",
    29301: "Weet je zeker dat je deze campagne wilt verwijderen?",
    29311: "Kopieer intelligente beoordelingen naar elke toegewezen locatiemanager",
    29321: "CC antwoorden op toegewezen locatiebeheerders",
    29331: "CC antwoordt op Corporate",
    29341: "Ontvangers",
    29351: "Alle ontvangers",
    29361: "Selecteer Review Source",
    29371: "PUB / SUB ALLEEN",
    29381: "Selecteer Star Rating",
    29391: "Selecteer Inhoud Review",
    29401: "Aangepaste groep",
    29411: "Stel vertraging in voordat u automatisch antwoord verzendt",
    29421: "Stel uren van Operatie in",
    29431: "Optioneel",
    29441: "Geen locaties toegewezen",
    29451: "Er waren geen inzicht gevonden voor het geselecteerde datumbereik en criteria.",
    29461: "Filtermenu",
    29471: "Soort",
    29481: "Weergaven op zoek",
    29491: "Bekeken in kaarten",
    29501: "U hebt niet voldoende machtigingen om een ​​antwoord te plaatsen.",
    29511: "Al verzonden",
    29521: "Upload AR-sjablonen",
    29531: "Volgers tellen",
    29541: "LAATSTE SYNC",
    29551: "Zakelijk",
    29561: "Bureau",
    29571: "Localpost ingeschakeld",
    29581: "Geen in afwachting van verificatie",
    29591: "Klik om deze beoordeling in de Inbox te bekijken",
    29601: "Lees verder",
    29611: "Bezig met laden",
    29621: "Totaal (aantal) items",
    29631: "Google mijn bedrijf geverifieerd",
    29641: "Markeer als",
    29651: "Uren toevoegen",
    29661: "Vandaag",
    29671: "Woonadres",
    29681: "Postcode",
    29691: "Identificeert als zwart-eigendom",
    29701: "Voeg URL toe",
    29711: "Na",
    29721: "contact email",
    29731: "Covid_19 Update",
    29741: "Wijzigingen in uw bedrijf?",
    29751: "Campagne",
    29761: "Bestel online",
    29771: "Kopen",
    29781: "Bel nu",
    29791: "nutsvoorzieningen",
    29801: "Synchroniseer deze locatie?",
    29811: "Facebook-lijst",
    29821: "Maak een nieuwe facebook-lijst",
    29831: "Geselecteerd",
    29841: "Bedrijfsgegevens",
    29851: "Contacten",
    29861: "Variabelen",
    29871: "Intern ID",
    29881: "Klik om verbinding te maken",
    29891: "Terug naar upload",
    29901: "Zie de Q & A op Google",
    29911: "Vereisen",
    29921: "Uitzetten",
    29931: "Bekijk de nauwe bevestiging",
    29941: "Beoordeel Antwoordbevestiging",
    29951: "Review Removal Bevestiging",
    29961: "Regio",
    29971: "Antwoord op deze vraag",
    29981: "Beheren",
    29991: "Maak Google POST",
    30001: "Beheer Google Post",
    30011: "Verberg locatie",
    30021: "Selecteer de huidige pagina",
    30031: "Maak Facebook-post",
    30041: "Facebook-post beheren",
    30051: "Wis alles",
    30061: "Filter opslaan",
    30071: "Zoekrol",
    30081: "Zoek de gebruiker",
    30091: "Alle redacteuren",
    30101: "Toewijzen aan de beoordeling (verplicht)",
    30111: "Voer sjabloonnaam in (verplicht)",
    30121: "Aangepaste sjabloonvariabele (optioneel)",
    30131: "Selecteer of maak onderwerp (optioneel)",
    30141: "Wijs toe aan afzonderlijke locatie (optioneel)",
    30151: "Toewijzen aan entiteit tag (optioneel)",
    30161: "Bekijk variabelen",
    30171: "Reviewer voornaam",
    30181: "Reviewer volledige naam",
    30191: "Locatievariabelen",
    30201: "Antwoord Locatienaam",
    30211: "Geo -locatienaam",
    30221: "Een antwoord voor deze beoordeling is al verzonden.",
    30231: "Antwoorden voor deze beoordeling kan niet meer worden verzonden. U kunt dit antwoord verwijderen om het vanaf hier te verwijderen.",
    30241: "Wilt u de gegevens van deze locatie synchroniseren? Dit zal alle updates naar de locatie trekken.",
    30251: "Laat klanten weten over eventuele wijzigingen in uw bedrijf dankzij Covend-19",
    30261: "Nu verzenden",
    30271: "Zoektocht",
    30281: "Gebruik de bedieningselementen aan het recht om de Exact Review Showcase te bouwen. Klik op de knop 'Toepassen' om het Instant Preview te laden",
    30291: "Bouw je recensie Showcase",
    30301: "Showcase Details",
    30311: "Noem deze showcase",
    30321: "Individuele locatie",
    30331: "Locatiegroep",
    30341: "Showcase-titel",
    30351: "Verbergen",
    30361: "Beoordelaar Afbeelding / Avatar",
    30371: "Laten zien",
    30381: "Selecteer Beoordelingsset",
    30391: "Bekijk bronnen",
    30401: "Beoordelingen van",
    30411: "Maak showcase",
    30421: "Minimale beoordeling",
    30431: "Alleen beoordelingen Beoordelingen",
    30441: "Definieer de presentatie",
    30451: "Max Review Count",
    30461: "MAX OPMERKING LENGHT",
    30471: "Max beoordelingen per pagina",
    30481: "Responsieve lay-out",
    30491: "sorteervolgorde",
    30501: "Nieuwste eerst",
    30511: "Star Rating Color",
    30521: "Controleer opmerkingen",
    30531: "Bronlogo",
    30541: "Beoordelingsdatum",
    30551: "Nauwkeurige datum",
    30561: "Font-familie",
    30571: "Titel van de titel",
    30581: "Recensent naamgrootte",
    30591: "Opmerking Grootte",
    30601: "Inrides ingesteld",
    30611: "Pin naar boven",
    30621: "Uitsluiten",
    30631: "Mijn recensies",
    30641: "Heeft hulp nodig",
    30651: "In afwachting van de klant",
    30661: "Op feedback wachten",
    30671: "Nieuwe feedback",
    30681: "Zoeknaam",
    30691: "Niet toegekend",
    30701: "Succesvol geüpdatet",
    30711: "Campagne-inhoudsnaam (optioneel)",
    30721: "Algemene voorwaarden (optioneel)",
    30731: "Weet je zeker dat je deze gebruiker wilt verwijderen? Eenmaal verwijderd, heeft de gebruiker geen toegang meer tot dit profiel, tenzij uitgenodigd.",
    30741: "Wilt u deze gebruiker verwijderen?",
    30751: "Reactieverdeling",
    30761: "We sturen een e-mail () met een link om de beoordeling CSV te downloaden.",
    30771: "Dit profiel heeft meer dan 100 locaties. We sturen u een e-mail met de downloadlink",
    30781: "Gebruikersantwoord",
    30791: "Mark antwoordde",
    30801: "Beantwoorden van bestemming",
    null: "Months of Year",
    30811: "Beoordelingen Dashboard",
    30812: "Overzicht",
    30813: "Gem.",
    30814: "GEM. Beoordeling",
    30815: "Pos",
    30816: "Geluk",
    30817: "Woordverhouding",
    30818: "Respons Ratio",
    30819: "Beoordeling per Bron",
    30820: "Beoordeling per Beoordeling",
    30821: "Antwoord per Beoordeling",
    30822: "Recente Beoordelingen",
    30823: "U heeft de afgelopen {x} dagen {x} beoordelingen ontvangen. Hier zijn de meest recente",
    30824: "Het gemiddelde aantal beoordelingen per moederlocatie tijdens de tijdsperiode",
    30825: "Het percentage beoordelingen met 4-sterren en 5-sterrenbeoordelingen",
    30826: "De Geluksscore is een voorstelling van het percentage positieve beoordelingen minus het percentage negatieve beoordelingen",
    30827: "Het percentage van alle opmerkingen die gevonden zijn in 5-sterren en 4-sterrenbeoordelingen in vergelijking met alle woorden die gedeeld zijn in de tijdsperiode. De reeks gaat van 5 sterren tot 1 ster.",
    30828: "Het percentage beoordelingen binnen de tijdsperiode dat een reactie heeft ontvangen.",
    30829: "Afname in {x data} van de voorgaande {xx} dagen",
    30830: "Toename in {x data} van de voorgaande {xx} dagen",
    30831: "Geen verandering in {x data} van de voorgaande {xx} dagen",
    30832: "Klik om deze beoordelingen te bekijken",
    30833: "(locatienaam) , (x) Sterren, Beoordelaar: (x)",
    30834: "Beoordelingen & Gemiddelde Beoordeling",
    30835: "Beoordelingenaantal in de loop van de tijd gestapeld per sterrenbeoordeling + lijngrafiek van de gemiddelde beoordeling.",
    30836: "Percentage per Sterrenbeoordeling",
    30837: "Beoordelingenaantal in de loop van de tijd gestapeld per sterrenbeoordeling als percentage van het totaal.",
    30838: "Cumulatieve Aantal & Gemiddelde Beoordeling",
    30839: "Totaal aantal beoordelingen en gemiddelde beoordeling voor de tijdspanne van het rapport.",
    30840: "Beoordelingen per Bron",
    30841: "Aantal beoordelingen over de tijdsperiode per bron.",
    30842: "Geluksscore in de Loop van de Tijd",
    30843: "De netto Geluksscore per tijdsperiode over de rapportperiode.",
    30844: "Dag van de Week",
    30845: "Dag van de Maand",
    30846: "Maand van het Jaar",
    30847: "Toplanden",
    30848: "Topstaten",
    30849: "Topsteden",
    30850: "Reacties",
    30851: "Snelle Reactiepercentage",
    30852: "Mediaan",
    30853: "Het aantal reacties dat gedurende de periode is gepubliceerd en het gemiddelde per locatie.",
    30854: "Het percentage beoordelingen dat binnen 2 dagen een antwoord ontvangt en de mediane responstijd.",
    30855: "Reactie Aantal & Ratio",
    30856: "Het aantal reacties per sterrenbeoordeling en de algehele reactieratio.",
    30857: "Gemiddelde Reactietijd",
    30858: "De gemiddelde reactietijd in dagen.",
    30859: "Reactieverdeling",
    30860: "Histogram van beoordeling reactietijd verdeeld in 10 niveaus.",
    30861: "Blij",
    30862: "Verhouding",
    30863: "Levensduur",
    30864: "Aantal ouderlocatierecords, plus niet-gekaartte listingrecords.",
    30865: "Energie",
    30866: "Opmerkingsverhouding",
    30867: "Opmerkinglengte",
    30868: "Verhoudingskloof",
    30869: "Lengtekloof",
    30870: "Beoordelingen met en zonder opmerkingen",
    30871: "Gemiddeld aantal woorden per sterrenbeoordeling",
    30872: "Percentage van woorden in elke sterrenbeoordeling",
    30873: "Opmerkingsverhoudingspercentage",
    30874: "Het percentage van alle beoordelingen die klantopmerkingen bevatten",
    30875: "Aantal woorden in de opmerking",
    30876: "Het gemiddelde aantal woorden in beoordelingen met opmerkingen",
    30877: "Woordenverdeling in opmerkingen",
    30878: "Percentage woorden in elke sterrenbeoordeling voor elke tijdsperiode",
    30879: "Percentage positieve recensies met opmerkingen minus percentage negatieve recensies.",
    30880: "Gemiddelde lengte van positieve beoordelingen minus gemiddelde lengte van negatieve beoordelingen.",
    30881: "Reviews met responseratio",
    30882: "Reactie lengte ratio",
    30883: "Rasterweergave",
    30884: "Gemiddelde locatie",
    30885: "Het gemiddelde beoordelingscijfer van de locaties en het percentage locaties met boven de 4.0 beoordeling in de tijdsperiode.",
    30886: "Beoordelingsprestatie-raster",
    30887: "Presentatie gemiddelde locatiebeoordeling versus beoordelingsvolume om uitschieters te identificeren",
    30888: "Sentiment",
    30889: "Invloed",
    30890: "Prestatie Dashboard",
    30891: "Leiderschap Raster",
    30892: "Totale Weergaven",
    30893: "Conversiepercentage",
    30894: "Totale weergaven en de gemiddelde weergaven per locatie.",
    30895: "Kaartweergaven op desktop en mobiel met de procentuele onderverdeling.",
    30896: "Lokale zoekweergave op desktop en mobiel met de procentuele onderverdeling.",
    30897: "Totale acties met de procentuele onderverdeling tussen oproepen, websiteklikken en routebeschrijvingen.",
    30898: "Totale conversieratio van acties/weergaven voor oproepen, websiteklikken en routebeschrijvingen.",
    30899: "Klantenweergaven",
    30900: "Hoe en waar klanten uw bedrijf bekijken.",
    30901: "Klantacties",
    30902: "De traceerbare acties van uw Google-vermeldingen.",
    30903: "Het percentage van de weergaven van bedrijfslijsten dat resulteert in een actie",
    30904: "Effectiviteit per Locatie",
    30905: "Totale weergaven versus conversiepercentage (acties/weergaven) om de effectiviteit van elke locatie in het genereren van weergaven en deze om te zetten in acties te tonen.",
    30906: "Effectiviteit per Stad",
    30907: "Totale weergaven versus conversiepercentage (acties/weergaven) per stad.",
    30908: "Effectiviteit per Groep",
    30909: "Totale weergaven versus conversiepercentage (acties/weergaven) voor elke aangepaste groep.",
    30910: "Hoge Weergaven + Lage Conversie",
    30911: "Hoge Weergaven + Hoge Conversie",
    30912: "Lage Weergaven + Lage Conversie",
    30913: "Lage Weergaven + Hoge Conversie",
    30914: "Mobiel",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "Site",
    30920: "Oproepen",
    30921: "Gezondheidscore",
    30922: "Dagelijkse Prestaties",
    30923: "Selecteer de locaties uit de tabel en de metriek (weergaven of acties)",
    30924: "Tevredenheidspercentage",
    30925: "Naam/Vriendelijk",
    30926: "{x} locaties met een gemiddelde van {y} sterren in de afgelopen {xx} dagen",
    30927: "Boven",
    30928: "Groep",
    30929: "Alle Weergaven",
    30930: "Alle Acties",
    30931: "Desktop",
    30932: "Maximale limiet bereikt: Selecteer maximaal 8 locaties voor de grafiek.",
    30933: "Beoordelaar",
    30934: "Algemene Sentiment",
    30935: "Verdeling van de sentimentscore over {XX} onderwerpen.",
    30936: "Sentiment per Onderwerp",
    30937: "Frequentie van onderwerpen en bijbehorende sentiment scores.",
    30938: "Zeer Positief",
    30939: "Zeer Negatief",
    30940: "Een automatiseringsregel geactiveerd voor nieuwe recensie op",
    30941: "Een automatiseringsregel geactiveerd voor bijgewerkte recensie op",
    30942: "keurde de reactie goed op",
    30943: "een tag toegewezen",
    30944: "de recensie toegewezen aan",
    30945: "bij",
    30946: "Automatisch antwoord verzonden",
    30947: "De eigenaar van het bedrijf heeft een nieuwe externe reactie gemaakt op",
    30948: "door automatiseringsregel op",
    30949: "door systeem op",
    30950: "heeft een nieuw gemaakt",
    30951: "heeft een nieuw antwoord gemaakt op",
    30952: "heeft een beoordelingsnota gemaakt voor",
    30953: "heeft een notitie verwijderd op",
    30954: "heeft een beoordelingsnota verwijderd op",
    30955: "heeft de reactie verwijderd op",
    30956: "heeft de reactie bewerkt op",
    30957: "van",
    30958: "heeft een automatische reactie gegenereerd op",
    30959: "lokaal",
    30960: "melding",
    30961: "op de hoogte gebracht",
    30962: "overzicht",
    30963: "uitgevoerd",
    30964: "reactie",
    30965: "Reactie verplaatst naar de Goedkeuringsinbox op",
    30966: "Reactie verplaatst naar de uitbox en gepland voor plaatsing",
    30967: "Reactie geplaatst op",
    30968: "Recensie toegewezen aan",
    30969: "recensie over",
    30970: "Recensie ontvangen van",
    30971: "stuurde een notitie naar",
    30972: "Systeem heeft een taallabel toegewezen",
    30973: "Systeem heeft een automatisch antwoord toegewezen op",
    30974: "Tags",
    30975: "team door automatiseringsregel op",
    30976: "Tijdlijn",
    30977: "naar",
    30978: "werkte een",
    30979: "werkte een beoordelingsnota bij op",
    30980: "werkte de beoordelingsscore bij van",
    30981: "werkte de beoordelingsstatus bij van",
    30982: "werkte de beoordelingsstatus bij naar",
    30983: "werkte de opmerking bij over hun",
    30984: "via API tijdens",
    30985: "via Pub-Sub op",
    30986: "Geen opmerking toegevoegd",
    30987: "op",
    30988: "Systeem",
    30989: "door",
    30990: "de beoordeling niet toegewezen aan",
    30991: "toegewezen aan",
    30992: "Toegewezen tag:",
    30993: "Toegewezen taggroep:",
    30994: "een tag verwijderd:",
    30995: "Review met updates",
    30996: "Review zonder updates",
    30997: "Selecteer alle tags",
    30998: "Selecteer niet-gelabeld",
    30999: "In afwachting van goedkeuring",
    31000: "Oudste eerst",
    31001: "Je hebt geen opgeslagen notities",
    31002: "Antwoord in de outbox",
    31003: "Versies van Beoordelingen",
    31004: "Beoordelingsdetails",
    31005: "Informatie Openen",
    31006: "Relaties",
    31007: "Fout",
    31008: "Primair",
    31009: "Categorieën",
    31010: "Sociale Links",
    31011: "De originele afbeelding is verwijderd door de gebruiker of het platform."
  },
  mandarin: {
    2013: "累积",
    2028: "团队评论",
    2029: "自动化",
    2030: "全程",
    2031: "分配",
    2032: "搜索用户",
    2033: "发电子邮件",
    2034: "撰写",
    2035: "AI回复",
    2036: "发表回复",
    2037: "再生",
    2038: "赞同",
    2039: "关于来源的帖子",
    2040: "回复发送",
    2041: "没有发送的信息",
    2042: "清楚",
    2043: "关闭",
    2044: "没有找到回复文本",
    2045: "复制响应并转到源头",
    2046: "编辑回复",
    2047: "批准回复",
    2048: "更新回复",
    2049: "删除回复",
    2050: "你确定要删除这个回复吗？",
    2051: "您确定要提交此回复吗？",
    2052: "你想恢复这个评论吗？",
    2053: "你确定吗？",
    2054: "你确定要批准这个回复吗？",
    2055: "​团队",
    2056: "仅评级",
    2057: "评价+简短评论",
    2058: "评级 + 评论",
    2059: "按语言评论",
    2060: "请提供1到100之间的评论长度，默认为20个字符",
    2061: "复制智能评论回复到每个指定的地点经理",
    2062: "登入",
    2063: "电子邮件地址",
    2064: "没有帐户？",
    2065: "名",
    2066: "姓",
    2067: "公司",
    2068: "公司名称",
    2069: "已经有帐户？",
    2070: "显示密码",
    2071: "隐藏密码",
    2072: "本地转换",
    2073: "地图 手机",
    2074: "地图 桌面",
    2075: "搜索 手机",
    2076: "搜索 桌面",
    2077: "搜索视图",
    2078: "地图视图",
    2081: "通用 (Tōngyòng)",
    2091: " 按主题 (Àn zhǔtí)",
    10010: "1星",
    10013: "2星",
    10016: "3星",
    10019: "4星   ",
    10022: "5星",
    10025: "100-300字",
    10120: "动作",
    10123: "啟用",
    10124: "始终活跃",
    10126: "啟用組織(GBP地點群組)",
    10129: "添加",
    10132: "新增按鈕",
    10135: "新增按鈕(選填)",
    10138: "新增帳戶",
    10141: "新增附加電話號碼",
    10144: "新增帳號",
    10147: "新增類別",
    10150: "新增標籤",
    10153: "新增屬性",
    10156: "新增地址行",
    10159: "新增新日期",
    10162: "添加新的评论标签",
    10165: "新增新角色",
    10168: "新增開幕日期",
    10171: "新增地點資料",
    10174: "新報表",
    10177: "新增報表",
    10180: "新增角色",
    10181: "新增評論標籤",
    10183: "額外類別",
    10186: "額外電話號碼",
    10189: "地址",
    10192: "管理",
    10195: "管理員",
    10198: "adWords 地點額外資訊",
    10201: "adWords 地點額外資訊電話",
    10204: "全部",
    10207: "所有评论",
    10210: "分配到此角色的所有使用者都可以使用此功能",
    10213: "申请",
    10216: "批准收件箱",
    10219: "您確定要重設此使用者的密碼嗎？",
    10222: "您確定嗎?",
    10225: "地區",
    10228: "区域",
    10231: "屬性",
    10234: "授權帳戶",
    10237: "平均的",
    10240: "平均数量",
    10243: "平均评分",
    10244: "平均評分",
    10246: "平均每个位置",
    10249: "等待回應",
    10320: "返回",
    10321: "返回管理",
    10323: "帳單",
    10326: "預約",
    10329: "批量上傳貼文",
    10332: "批量上傳標籤",
    10335: "批量上傳TSV",
    10338: "商家名稱",
    10520: "日曆",
    10523: "取消",
    10526: "無法上傳主要位置對應資訊",
    10529: "類別",
    10532: "更改角色",
    10535: "引用歷史紀錄",
    10538: "城市",
    10541: "點擊此處",
    10544: "點擊使用者以分派此角色",
    10547: "國家",
    10548: "確認密碼",
    10550: "複製",
    10553: "複製與貼上",
    10556: "無法更改角色!",
    10559: "無法上傳貼文",
    10562: "国家",
    10565: "国家",
    10568: "優惠卷號碼",
    10571: "優惠卷號碼 (選填)",
    10574: "點選下列選項以建立新的篩選器",
    10577: "建立新的篩選器",
    10580: "创建新报告",
    10583: "建立貼文",
    10586: "建立標籤",
    10589: "创建此报告",
    10592: "建立此角色",
    10595: "建立者",
    10598: "客戶動作",
    10720: "日",
    10723: "仪表板",
    10726: "日期",
    10729: "日期范围",
    10732: "日",
    10735: "停用",
    10738: "默认",
    10741: "貼文前延遲時間",
    10744: "延遲_x005F_x0008_發送回覆時間",
    10747: "延遲_x005F_x0008_發送回覆的時間",
    10750: "删除",
    10753: "確定刪除?",
    10754: "刪除個人資料",
    10756: "描述",
    10759: "描述",
    10762: "直接",
    10765: "直接查询",
    10768: "路線",
    10771: "探索",
    10774: "依地點檢視",
    10777: "下載所有地點資料",
    10780: "下載",
    10783: "下載Google地點詳細資訊",
    10786: "下載資料",
    10789: "草稿",
    10792: "行驶方向",
    10795: "每天驾驶指示",
    10920: "编辑",
    10923: "編輯個人資料",
    10926: "編輯報告",
    10929: "編輯此報告",
    10932: "編輯者",
    10935: "電子郵件",
    10938: "結束時間",
    10941: "輸入adWords地點額外資訊",
    10944: "輸入實體標籤名稱",
    10947: "輸入標籤",
    10950: "輸入搜尋字詞",
    10953: "輸入標籤名稱",
    10956: "等于",
    10959: "活動",
    10962: "活動詳情",
    10965: "活動標題",
    10968: "每",
    10971: "example.com",
    10974: "範例: 在商店或網上享有20％的折扣",
    11120: "功能權限管理",
    11123: "过滤器",
    11126: "忘記密碼?",
    11129: "星期五",
    11320: "領取折扣",
    11323: "比...更棒",
    11520: "幸福等级",
    11525: "說明",
    11530: "假日",
    11535: "時",
    11540: "時",
    11545: "客户如何搜索您的业务",
    11720: "圖檔",
    11723: "圖檔網址",
    11726: "在地圖上",
    11729: "在搜尋",
    11732: "收件箱",
    11735: "直接查詢",
    11738: "见解",
    11741: "權限不足",
    11744: "整合",
    11747: "整合",
    11750: "邀請使用者",
    11753: "已邀請",
    11756: "邀請者",
    11759: "項目",
    12120: "知識面板",
    12320: "標籤",
    12323: "上次登錄",
    12326: "最近更新時間",
    12329: "知道更多",
    12332: "少於",
    12335: "連結到您的按鈕",
    12338: "連結到兌換優惠",
    12341: "連結到兌換優惠（選填）",
    12344: "連結",
    12347: "清單管理",
    12350: "本地表现",
    12353: "本地表現概述",
    12356: "本地搜尋轉換",
    12359: "地方",
    12362: "區域",
    12365: "地点",
    12368: "地點詳情",
    12371: "地點編號",
    12374: "地点",
    12377: "登錄",
    12380: "登出",
    12520: "月",
    12523: "利用照片讓您的貼文更顯眼",
    12526: "管理大量活動",
    12529: "管理實體標籤",
    12532: "管理地點",
    12535: "管理地點資料",
    12538: "管理角色",
    12541: "管理使用者",
    12544: "地图",
    12547: "商家數量",
    12550: "商人照片",
    12553: "商家照片",
    12556: "訊息",
    12559: "分鐘",
    12562: "周一",
    12565: "月份",
    12720: "名稱",
    12723: "新角色的名稱",
    12726: "报告名称",
    12729: "需要一個帳戶？",
    12732: "新",
    12735: "下一页",
    12738: "没有答复",
    12741: "未找到結果",
    12744: "没有评论标签",
    12747: "没有评论",
    12750: "不，取消",
    12753: "使用者數",
    12756: "笔记",
    12920: "的",
    12923: "提供",
    12926: "好",
    12929: "好的，我知道了！",
    12932: "一次",
    12935: "開店日期",
    12938: "Order",
    12941: "组织",
    12944: "输出箱",
    12947: "擁有者",
    13120: "頁",
    13123: "密碼",
    13126: "貼上 TSV",
    13129: "Pdf 類型",
    13132: "電話",
    13135: "白天电话",
    13138: "電話號碼",
    13141: "照片數量",
    13144: "照片视图",
    13147: "請輸入收件人名稱!",
    13150: "請輸入報表名稱!",
    13153: "請輸入摘要!",
    13156: "請輸入頭銜名稱!",
    13159: "請輸入有效時間！",
    13162: "請輸入有效網址！",
    13165: "請刷新頁面以更新您的地點詳細資訊",
    13168: "請重新加載",
    13171: "請選擇時間表類型！",
    13174: "歷史貼文",
    13177: "貼文",
    13180: "前一頁",
    13183: "主要類別",
    13186: "主要電話",
    13189: "主要電話號碼",
    13192: "個人資料",
    13195: "公開計數",
    13198: "公開照片",
    13201: "公共照片",
    13204: "發布",
    13520: "评分",
    13523: "即時通知",
    13526: "收件人列表",
    13529: "重複發生",
    13532: "刪除使用者",
    13535: "回覆",
    13538: "回覆批准",
    13541: "報表管理",
    13544: "報表名稱",
    13547: "報表類型",
    13550: "重設密碼",
    13553: "星级评级的响应",
    13556: "評論數",
    13559: "評論下載",
    13562: "評論設定",
    13565: "評論來源",
    13568: "评论标签",
    13571: "評論連結",
    13574: "評論",
    13577: "星级评论的评论",
    13580: "评论与平均评分",
    13583: "评论收件箱",
    13586: "評論管理",
    13589: "评论，每天的一天",
    13592: "评论，一周中的一天",
    13595: "评论，一年中的一个月",
    13598: "角色",
    13601: "角色詳細資料",
    13604: "角色名稱",
    13720: "星期六",
    13723: "节省",
    13726: "另存为自定义过滤器",
    13729: "儲存新篩選器",
    13732: "儲存角色",
    13735: "保存的答复",
    13738: "时间表日期",
    13741: "排程貼文",
    13742: "排程報表",
    13744: "时间安排时间",
    13747: "排程類型",
    13750: "搜索",
    13753: "搜索",
    13756: "選擇",
    13759: "選擇現有篩選器",
    13762: "選擇類別",
    13765: "选择城市",
    13768: "选择国家",
    13771: "選擇日期與時間",
    13774: "選擇日期區間",
    13777: "選擇編輯者檢閱",
    13780: "选择实体标签",
    13783: "选择过滤器",
    13786: "选择过滤器",
    13789: "選擇日期細分方式",
    13792: "选择组织",
    13795: "选择评论标签",
    13798: "选择保存的过滤器",
    13801: "选择源",
    13804: "选择状态",
    13807: "選擇時間",
    13810: "自己",
    13813: "发送批准",
    13816: "發送至寄件箱",
    13819: "已發送",
    13822: "服務",
    13825: "設定",
    13828: "設定管理",
    13831: "商家",
    13834: "顯示貼文",
    13837: "顯示/隱藏導覽列",
    13840: "註冊",
    13843: "編輯單個地點",
    13846: "抱歉!",
    13849: "排序方式",
    13852: "特殊營業時間",
    13855: "Specific Access",
    13858: "標準",
    13861: "開始時間",
    13864: "州",
    13867: "狀態",
    13870: "商家",
    13873: "存储代码",
    13876: "街道",
    13879: "總覽檢視",
    13882: "星期日",
    13885: "同步此帳戶",
    13920: "电话",
    13923: "條款與細則",
    13926: "星期四",
    13929: "時間",
    13932: "熱門地區",
    13935: "全部的",
    13938: "周二",
    14120: "未回覆",
    14123: "不確定格式嗎？",
    14126: "上傳",
    14129: "上傳地點詳細資料",
    14132: "上傳地點地圖",
    14135: "上傳地點對應資訊",
    14138: "上傳 TSV",
    14141: "網址",
    14144: "UserId",
    14320: "檢視圖片",
    14323: "檢視資料",
    14326: "视图",
    14520: "週",
    14523: "网站",
    14526: "网站白天",
    14529: "網站名稱",
    14532: "星期三",
    14535: "週",
    14538: "客戶採取什麼行動",
    14541: "當一個評論被回覆時",
    14544: "客户在哪里查看您的业务",
    14547: "您要刪除此預定貼文嗎？",
    14550: "輸入你的頭銜",
    14920: "年",
    14923: "是的，继续",
    14926: "您可以選擇篩選器來限制此角色的使用者的權限。",
    14929: "你的名字",
    15120: "郵遞區號",
    20010: "星期一",
    20011: "星期一",
    20020: "星期二",
    20021: "星期二",
    20030: "周三",
    20031: "星期三",
    20040: "周四",
    20041: "星期四",
    20050: "星期五",
    20051: "星期五",
    20060: "周六",
    20061: "星期六",
    20070: "星期日",
    20071: "星期日",
    20110: "一月",
    20111: "一月",
    20120: "二月",
    20121: "二月",
    20130: "三月",
    20131: "三月",
    20140: "四月",
    20141: "四月",
    20150: "五月",
    20151: "五月",
    20160: "六月",
    20161: "六月",
    20170: "七月",
    20171: "七月",
    20180: "八月",
    20181: "八月",
    20190: "九月",
    20191: "九月",
    20200: "十月",
    20201: "十月",
    20210: "十一月",
    20211: "十一月",
    20220: "十二月",
    20221: "十二月",
    20231: "評論與評分",
    20241: "百分",
    20251: "有百分比的評論",
    20261: "累計",
    20271: "累計數",
    20281: "來源",
    20291: "来源的评论",
    20301: "快樂",
    20311: "响应时间",
    20321: "选择位置",
    20331: "用評論關鍵字搜尋",
    20341: "用評論者搜尋",
    20351: "選擇地點",
    20361: "等於",
    20371: "少于",
    20381: "大於",
    20391: "選擇月份",
    20401: "選擇日期",
    20411: "點選瀏覽這些評論",
    20421: "在所選日期範圍和條件未找到任何評價",
    20431: "清除过滤器",
    20441: "刪除自訂篩選器",
    20451: "有Google更新",
    20461: "已驗證",
    20471: "地點已發布",
    20481: "有待處理的編輯",
    20491: "知識面板",
    20501: "評論連結",
    20511: "行車路線",
    20521: "複製",
    20531: "啟用",
    20541: "可以更新",
    20551: "可以刪除",
    20561: "無待審核評論",
    20571: "地點啟用",
    20581: "無斷線",
    20591: "變更記錄",
    20601: "大量上傳圖檔",
    20611: "歷史圖檔",
    20621: "大量上傳註記",
    20631: "大量上傳 q&a",
    20641: "q&a 歷史紀錄",
    20651: "新增問題",
    20661: "向客戶提出一個問題，強調一個核心價值主張或您地點的獨特競爭優勢，然後您可以回答問題。",
    20671: "平台詳細資料",
    20681: "自動回覆變數",
    20691: "地点名称",
    20701: "GEO名稱(地理名稱)",
    20711: "签名",
    20721: "地名 (最多80字元，一個中文字為2字元)",
    20731: "簽名  (最多80字元，一個中文字為2字元)",
    20741: "自动回复",
    20751: "下载评论",
    20761: "自动响应",
    20771: "外部連結",
    20781: "複製評論",
    20791: "添加注意",
    20801: "外部註解",
    20811: "標記為不適當",
    20821: "標示為已刪除",
    20831: "您確定嗎?",
    20841: "您想將此評論標記為已從Google刪除嗎？",
    20851: "插入保存的答复",
    20861: "另存為回覆模板",
    20871: "插入自動回覆模板",
    20881: "發送",
    20891: "发送批准",
    20901: "儲存為草稿",
    20911: "指派備忘",
    20921: "電子信件備忘",
    20931: "收件者",
    20941: "儲存備忘",
    20951: "關閉",
    20961: "捨棄",
    20971: "發送郵件",
    20981: "您沒有任何儲存的備忘",
    20991: "全部趕上了！",
    21001: "沒有項目可以顯示",
    21011: "发送答复",
    21021: "此評論者尚未加入任何評論",
    21031: "编辑回复",
    21041: "刪除回覆",
    21051: "搜尋已儲存回覆",
    21061: "添加保存的答复",
    21071: "選擇群組和主題以儲存此回覆",
    21081: "选择一个组或开始打字以创建一个",
    21091: "在此处输入标题",
    21101: "输入回复模板",
    21111: "请确保选择/创建组和标题以保存此答复。",
    21121: "自動回覆",
    21131: "新增自動回覆",
    21141: "选择一个组",
    21151: "在此輸入變數",
    21161: "選擇變數",
    21171: "您是否要繼續?",
    21181: "該請求超過100多個評論。對於此類請求，我們將向您發送電子郵件，其中包含下載評論csv的連結。",
    21191: "您有超過100個評論",
    21201: "我們將向您發送電子郵件（至 X），並提供下載評論csv的連結。",
    21211: "動作",
    21221: "所有地點",
    21231: "平均評分",
    21241: "品牌",
    21251: "直接",
    21261: "发现",
    21271: "地理",
    21281: "快樂",
    21291: "搜尋",
    21301: "答复",
    21311: "瀏覽次數",
    21321: "貼文時間表",
    21331: "Google貼文時間表",
    21341: "建立貼文",
    21351: "管理貼文",
    21361: "安排本地貼文",
    21371: "上傳",
    21381: "進度",
    21391: "驗證和安排",
    21401: "安排狀態",
    21411: "選擇文件",
    21421: "选择时间表类型",
    21431: "即時",
    21441: "檔案時間",
    21451: "選擇時間",
    21461: "驗證後立即貼文",
    21471: "根據檔案中的時間安排",
    21481: "按您選擇的時間安排檔案",
    21491: "隊列",
    21501: "驗證正在進行中。處理時間約為每分鐘40個貼文。驗證後，每個貼文的狀態將在下一頁顯示。",
    21511: "貼文已處理",
    21521: "驗證成功",
    21531: "驗證失敗",
    21541: "已安排",
    21551: "類型/動作",
    21561: "日期",
    21571: "開始",
    21581: "結束",
    21591: "標題/產品",
    21601: "貼文摘要",
    21611: "狀態",
    21621: "成功",
    21631: "失败的",
    21641: "編輯/ 刪除",
    21651: "貼文深入分析",
    21661: "Google 貼文深入分析",
    21671: "表现",
    21681: "貼文瀏覽量",
    21691: "貼文依照媒體",
    21701: "貼文依照主題",
    21711: "貼文依照動作",
    21721: "分析",
    21731: "已建立",
    21741: "類型",
    21751: "行动",
    21761: "來源篩選器",
    21771: "平台",
    21781: "更新當地貼文狀態",
    21791: "自動回覆設定",
    21801: "智能自動回覆",
    21811: "打開自動回覆廣告活動製作工具",
    21821: "在啟用自動回覆安排選項前，請確保遵守以下說明：",
    21831: "啟用智能自動回覆前，請確保在評論收件夾部分新增自動回覆模板。先建立回覆，再分配給不同的星等（1-5）評分，再由智能依其自動回覆。",
    21841: "在廣告活動製作工具中，請選擇收到評論和自動回覆之間的延遲時間。延遲設置應與理想的評論回覆時間相對應，以淡化自動回覆的感覺。",
    21851: "另外，請考慮設置廣告活動的運行時間（星期幾和幾點）。預設時區設置為GMT + 00：00，請做適當的時間設定。",
    21861: "创造活动",
    21871: "指派名稱和備註以輕鬆識別您的廣告。",
    21881: "廣告活動名稱",
    21891: "廣告活動回覆者",
    21901: "如果未選擇任何選項，預設回覆者將會是用於註冊和授權帳戶的電子郵件。",
    21911: "自動回覆的回覆者",
    21921: "廣告活動日期區間",
    21931: "註釋/目標",
    21941: "廣告活動描述",
    21951: "建立觸發條件",
    21961: "選擇會此活動會進行自動回覆的評論類型。",
    21971: "有評論",
    21981: "沒有評論",
    21991: "前一個",
    22001: "下一個",
    22011: "設置受眾群體（可選）",
    22021: "透過實體標籤，組織或特定的國家/地區/位置，將地點設置為廣告活動的一部分。此篩選器僅適用於Google評論和地圖地點。",
    22031: "實體",
    22041: "組織",
    22051: "設定時間表",
    22061: "指定參數和評論回覆安排，即: 目標評論的百分比和回覆的操作時間。",
    22071: "請注意，當前僅在“轉發”的基礎上提供自動回复。我們正在為可能希望自動進行近期清理的用戶制定單獨的流程。",
    22081: "設定回覆率",
    22091: "設定回覆數",
    22101: "發送自動回復之前的延遲",
    22111: "定期安排",
    22121: "選擇日期並時間以設置定期自動回覆",
    22131: "选择时区",
    22141: "指定回覆",
    22151: "從列表中，選擇此廣告要輪流使用的回覆。",
    22161: "確認",
    22171: "查看下面的每個詳細資料，然後點擊“確認”以啟動您的廣告活動。",
    22181: "天",
    22191: "星",
    22201: "平均",
    22211: "報吿",
    22221: "競爭者建置",
    22231: "最佳方法",
    22241: "象限",
    22251: "��分等級",
    22261: "競爭排名",
    22271: "回覆",
    22281: "查看評論來源",
    22291: "增加競爭對手",
    22301: "篩選依據",
    22311: "清除",
    22321: "競爭者",
    22331: "競爭者實體",
    22341: "实体标签",
    22351: "注释",
    22361: "無選項",
    22371: "坏的",
    22381: "贫穷的",
    22391: "普通",
    22401: "伟大的",
    22411: "出色的",
    22421: "有回覆的評論",
    22431: "无答复的评论",
    22441: "评论评论",
    22451: "没有评论的评论",
    22461: "評論量與平均評分",
    22471: "品牌",
    22481: "放大",
    22491: "總評價",
    22501: "按星級評價",
    22511: "競爭對手評論",
    22521: "競爭對手",
    22531: "號",
    22541: "管理競爭對手",
    22551: "已更新",
    22561: "新增競爭者",
    22571: "新增地點",
    22581: "新增競爭者名稱",
    22591: "第一步是新增競爭對手的名稱，將名稱和圖標(圖標非必要)（48x48圖像）添加到列表後，點擊“新增”。建立競爭對手後，您將可以分配各個地點",
    22601: "輸入競爭者URL (必填)",
    22611: "輸入競爭者URL (選填)",
    22621: "上傳圖檔",
    22631: "即將推出",
    22641: "评论比率",
    22651: "有留言與沒有留言的評論比",
    22661: "無",
    22671: "有",
    22681: "评论长度",
    22691: "按星級評定每個評論中使用的平均單詞數",
    22701: "字",
    22711: "单词比率",
    22721: "每個星級的評論中單詞的總數和百分比",
    22731: "這裏",
    22741: "竞争对手",
    22751: "添加标签",
    22761: "選擇變數加到模板中",
    22771: "關閉評論",
    22781: "已關閉評論",
    22791: "您要關閉此評論嗎？關閉後，您需要重新打開才能回覆。",
    22801: "外部",
    22811: "負向",
    22821: "不",
    22831: "尚未有自動回覆!",
    22841: "尚未有已儲存回覆!",
    22851: "笔记",
    22861: "永久關閉",
    22871: "正向",
    22881: "讀取超時",
    22891: "恢復評論",
    22901: "重新開啟評論",
    22911: "回答",
    22921: "已傳送回覆 (從 google 介面)",
    22931: "從 App 傳送的回覆",
    22941: "删除了评论",
    22951: "模板",
    22961: "暫時性關閉",
    22971: "是的",
    22981: "您沒有任何儲存的草稿",
    22991: "访问资源的权限不足",
    23001: "遇到内部错误",
    23011: "请求包含无效的参数",
    23021: "未找到请求的实体",
    23031: "谷歌平台上不再存在",
    23041: "部分自動插入值不可用，請更換並發送。",
    23051: "该服务目前无法使用",
    23061: "无人认领的位置不支持此操作",
    23071: "发布的帖子",
    23081: "预定的帖子",
    23091: "友好名称",
    23101: "新增友好名稱",
    23111: "接触",
    23121: "無聯繫人！",
    23131: "添加聯繫人",
    23141: "联系人姓名",
    23151: "聯繫電子郵件",
    23161: "增加联系人",
    23171: "貼文深入分析",
    23181: "Google 貼文深入分析",
    23191: "没有数据",
    23201: "Google審核",
    23211: "审核日志",
    23221: "选择报告",
    23231: "選擇",
    23241: "全部下載",
    23251: "無選項",
    23261: "数据下载",
    23271: "审查下载",
    23281: "所有评论",
    23291: "下载照片URL.",
    23301: "客户照片URL.",
    23311: "商家照片网址",
    23321: "报告下载历史记录",
    23331: "報告名稱",
    23341: "寄去",
    23351: "创建的时间（UTC）",
    23361: "报告类型",
    23371: "資訊細節",
    23381: "更改資訊名稱",
    23391: "每週同步",
    23401: "啟用大量管理地點標籤",
    23411: "日期格式設定",
    23421: "儲存",
    23431: "快樂/ NPS設定",
    23441: "倡導者/快樂",
    23451: "中性",
    23461: "批評者/不快樂",
    23471: "更新",
    23481: "目前標誌",
    23491: "完整標誌",
    23501: "圖示",
    23511: "報表標誌",
    23521: "網站圖標",
    23531: "在您的個人資料向左擴展導覽時，此標誌將顯示在左上角。",
    23541: "此標誌將顯示在您個人資料的左上角。",
    23551: "該標誌將顯示在由系統產出的儀表板報表和評論報表中。\r\n使用大小在5kb至20kb之間的png圖片以獲得最佳效果。",
    23561: "該標誌將顯示在瀏覽器標籤的左上角。",
    23571: "取代標誌",
    23581: "使用下拉選項選擇要更改的標誌類型，然後上傳標誌。",
    23591: "上傳標誌給",
    23601: "GBP地點狀態配置：禁止設定",
    23611: "已禁止",
    23621: "可見",
    23631: "斷線",
    23641: "未驗證",
    23651: "已暫停",
    23661: "複製",
    23671: "第一方評論上傳",
    23681: "上传",
    23691: "清除",
    23701: "大量管理地點",
    23711: "批量管理控制",
    23721: "直接在Google試算表中更新地點詳細資料和控制平台參數。",
    23731: "平台",
    23741: "使用自定地點變數和設置輕鬆管理任何規模的帳戶。",
    23751: "GBP详细信息",
    23761: "瀏覽所有GBP清單並直接新增/ 編輯/ 刪除地點詳細資料",
    23771: "GBP属性",
    23781: "將所有符合的屬性分配給每個地點，以增加搜尋探索。",
    23791: "GBP上市",
    23801: "创建新的GBP列表。",
    23811: "Facebook",
    23821: "Facebook上市控制",
    23831: "历史",
    23841: "训练",
    23851: "學習資源:用於大量編輯工作流，最佳做法，限制和更新。",
    23861: "警告",
    23871: "要求",
    23881: "用户必须拥有Google帐户，以便系统可以使用配置文件数据呈现Google表。",
    23891: "注意 :",
    23901: "如果从系统数据库中填充每个表的数据。如果您希望确定电子表格提供当前的Google数据，我们强烈建议您首先同步您的个人资料。",
    23911: "根據您帳戶中地點的數量，Google試算表可能需要一些時間才能初步構建，然後在您瀏覽該表格時進行刷新。請先確保所有數據都是穩定的，然後再按“更新”將所做的編輯保存到系統，並將更新推送到Google。",
    23921: "该平台与Google有直接的API连接，但谷歌延迟到公共位置列表页面的直接更新可能仍有时间。",
    23931: "按下“更新”會直接觸發相關修改給Google的系統。**請注意**這是不能撤消或還原的動作。在觸發更新之前，請確保您對所有修改都滿意。如果出錯，請等待幾分鐘，然後進行必要的更改。",
    23941: "配色方案",
    23951: "每张表都有一个默认颜色方案，以帮助用户了解哪个字段有资格编辑。",
    23961: "传达Google的状态详细信息或无法通过批量控件直接编辑的变量。",
    23971: "Google变量直接打开批量编辑。",
    23981: "平台变量直接打开批量编辑。",
    23991: "控制",
    24001: "细节",
    24011: "属性",
    24021: "创建上市",
    24031: "指示",
    24041: "Expired on",
    24051: "Time to subscribe !",
    24061: "This profile will expire on",
    24071: "To keep accessing this profile, please subscribe.",
    24081: "Take me there!",
    24091: "Later",
    24101: "Billing",
    24111: "Plan details",
    24121: "Plus",
    24131: "Pro",
    24141: "/PER LOCATIONS",
    24151: "$8/PER LOCATIONS",
    24161: "First 10 Locations",
    24171: "$24/month minimum",
    24181: "Try Free for 30 Days",
    24191: "All Integrations Included",
    24201: "Full Reviews Inbox",
    24211: "Full Roles Access",
    24221: "Full Reporting Suite",
    24231: "Unlimited Users",
    24241: "30 Pre-installed Review Responses",
    24251: "Full Support",
    24261: "Locations 11-200",
    24271: "All Features of Plus Plan",
    24281: "Full GBP Management",
    24291: "Bulk/Schedule Google Posts",
    24301: "Real-time Notifications",
    24311: "Custom Report Set-Up",
    24321: "Local Search Optimization",
    24331: "Personalized Onboarding",
    24341: "Profanity & Fraudulent Review Audit",
    24351: "活动",
    24361: "授权",
    24371: "授权的连接访问每个来源的完整审查和响应功能。",
    24381: "批量上传实体标记",
    24391: "批量上传GBP细节",
    24401: "選擇群組和主題以儲存此自動回覆",
    24411: "店家數",
    24421: "创建实体标记",
    24431: "建立時間 (世界協調時間)",
    24441: "自訂邊欄標籤",
    24451: "自訂側欄工具",
    24461: "下載GBP審計",
    24471: "檔案名稱",
    24481: "GBP详细历史记录",
    24491: "印象",
    24501: "不活跃",
    24511: "索引",
    24521: "索引连接访问每个源的所有历史和当前评论。",
    24531: "管理本地貼文",
    24541: "没有发表评论",
    24551: "数字",
    24561: "請點擊右上方的“新報告”按鈕",
    24571: "資訊建立於",
    24581: "需求編號",
    24591: "保存答复",
    24601: "总位置",
    24611: "總貼文數",
    24621: "上傳AR模板",
    24631: "上传位置别名",
    24641: "看法",
    24651: "您可以在側欄設置自訂標籤，以連結平台內的iframe或外部主機的連結",
    24661: "GBP 詳細資料",
    24671: "GBP 屬性",
    24681: "GBP 清單",
    24691: "FACEBOOK",
    24701: "歷史紀錄",
    24711: "培訓",
    24721: "每週同步化啟用於",
    24731: "MMM D,YYY",
    24741: "例如:-Oct 13,2020",
    24751: "MM/DD/YYYY",
    24761: "MMMM D,YYYY",
    24771: "例如:-October 13,2020",
    24781: "DD/MM/YYYY",
    24791: "DD MMM YYYY",
    24801: "DD MMMM YYYY",
    24811: "例如:- 13 October 2020",
    24821: "上傳新Logo圖檔",
    24831: "拆开",
    24841: "隱藏",
    24851: "評論細節窗格設定",
    24861: "顯示商店代碼",
    24871: "顯示完整地址",
    24881: "顯示概要插件",
    24891: "Inverted Header",
    24901: "選取檔案",
    24911: "沒有檔案被選取",
    24921: "查看每個更新推送的紀錄，以確認列表內容的更改並避免任何錯誤。",
    24931: "根據您帳戶中地點的數量，Google表格可能需要一些時間才能初步建立，然後在您瀏覽該表格時進行更新。請在更新前確認所有數據都是正確的，然後再按“更新”，將所做的編輯保存到系統，並將推送到Google。",
    24941: "大量編輯工作程序，最佳做法，限制和更新的資源。",
    24951: "用户身份",
    24961: "您想要刪除嗎?",
    24971: "帐户",
    24981: "没有谷歌更新",
    24991: "崇敬不需要",
    25001: "沒有待處理的修改",
    25011: "审计时间",
    25021: "场地",
    25031: "价值（至）",
    25041: "价值（来自）",
    25051: "從實體標籤中刪除",
    25061: "Attributelist",
    25071: "adwords",
    25081: "查看全部",
    25091: "問&答",
    25101: "探索",
    25111: "探索回应",
    25121: "选择模板",
    25131: "继续",
    25141: "选择星级，模板名称和添加模板内容以保存自动回复。",
    25151: "选择回复类型",
    25161: "模板",
    25171: "片段",
    25181: "分配给评分（必需）",
    25191: "输入模板名称（必需）",
    25201: "自定义模板变量",
    25211: "选择或创建主题（可选）",
    25221: "分配到单个位置",
    25231: "分配给实体标签",
    25241: "新增主題名稱和片段內容以保存自動回覆。",
    25251: "總共#個項目",
    25261: "位置注意",
    25271: "查看地點詳情",
    25281: "查看Google知識欄",
    25291: "直接在Google上查看评论",
    25301: "正向評分- 5 星",
    25311: "負向評分- 1-2 星",
    25321: "中間評分- 3-4 星",
    25331: "模板名称",
    25341: "多变的",
    25351: "选择或创建主题",
    25361: "团体",
    25371: "话题",
    25381: "事先评论",
    25391: "另存为回复",
    25401: "副本寄送",
    25411: "重新設定",
    25421: "新消息",
    25431: "创建日期",
    25441: "自定义过滤器名称",
    25451: "僅查閱",
    25461: "功能",
    25471: "無",
    25481: "查閱",
    25491: "未限制",
    25501: "這是預設角色，無法編輯/刪除",
    25511: "讀取",
    25521: "編輯",
    25531: "下载",
    25541: "所有被指派此角色的使用者會有以下功能的權限",
    25551: "設定副頁的顯示設定",
    25561: "管理角色",
    25571: "自訂邊欄",
    25581: "或",
    25591: "儲存角色屬性",
    25601: "確定要篩除此角色嗎?",
    25611: '這會將所有目前是此腳色的使用者改成"僅查閱"',
    25621: "指派使用者",
    25631: "在檔案的使用者",
    25641: "在此搜尋",
    25651: "使用者被指派為此角色",
    25661: "無使用者",
    25671: "重新邀請",
    25681: "默认登陆页面",
    25691: "评论收件箱",
    25701: "批量生产",
    25711: "邮政调度",
    25721: "開啟",
    25731: "關閉",
    25741: "確定要關閉廣告活動嗎?",
    25751: "Are you sure turn on Campaign?",
    25761: "已成功更新廣告活動",
    25771: "反应速度",
    25781: "响应计数",
    25791: "星级",
    25801: "和",
    25811: "没有",
    25821: "延迟",
    25831: "时区",
    25841: "审查",
    25851: "競爭者報告",
    25861: "格式",
    25871: "HTML Email",
    25881: "Excel",
    25891: "如果在所选范围内没有评论",
    25901: "不要寄送電子郵件",
    25911: "寄送電子郵件",
    25921: "問&答",
    25931: "如果在選擇範圍內沒有問&答",
    25941: "客戶圖檔",
    25951: "審查紀錄",
    25961: "请联系支持对个人资料同步Cadence的任何疑问",
    25971: "夾帶審查檔案",
    25981: "轮廓",
    25991: "競爭者標籤",
    26001: "审查详情",
    26011: "管理層級控制",
    26021: "覆蓋預設功能，整理成層級",
    26031: "建立層級",
    26041: "創建新層級",
    26051: "層級名稱",
    26061: "預設",
    26071: "預設",
    26081: "信譽評論儀表板",
    26091: "評論KPI全方位洞察",
    26101: "所有地點和來源的全部檢視權",
    26111: "區域",
    26121: "評論量，平均評分，分佈，來源，開心指數和回應率的核心KPI。",
    26131: "縱向評估評論和星等，百分比，累積，來源，開心指數和回覆時間直方圖。",
    26141: "評論率，評論長度和累計詞率（按評論星等）。",
    26151: "評論(按星期幾，日期和月份)。",
    26161: "按評論量排在前五位的國家，州/省和城市。",
    26171: "所有歷史數據在初始帳戶設置期間都會進行匯總，然後每天從已連結的評論來源進行更新。",
    26181: "GBP洞察",
    26191: "直接，發現和品牌的每日搜尋量區域圖。",
    26201: "地圖和搜尋每日視圖面積圖。",
    26211: "驾驶指导，电话和网站点击的客户操作图表。",
    26221: "地點轉換的柱狀圖(按星期幾)。",
    26231: "不重複的本地轉化率(轉換/每日搜尋）。",
    26241: "品牌照片平均數量託管於GBP位置和總觀看次數",
    26251: "客戶上傳到GBP店點的照片平均數和瀏覽次數。",
    26261: "在初始帳戶時，會匯總每個地點完整18個月的每日數據，然後每天從已連結的數據源進行更新。 Google的洞察報告目前會延遲3-5天。",
    26271: "本地搜尋範圍和行動轉換報表。",
    26281: "本地表現",
    26291: "簡易比較各地點表現",
    26301: "所選地點的每日折線圖，用於評論，平均評分，搜尋，瀏覽量和轉換",
    26311: "可排序和可搜尋的表格展示每個地點的評論和指標，以及完整的報告下載。",
    26321: "“其他”標籤分頁提供了成效圖表，按地理位置進行匯總/深入分析，可設定下載觸發器。",
    26331: "評論和GBP 洞察表格和圖表（按單個地點）。",
    26341: "評論收件箱",
    26351: "匯總所有地點和來源的收件箱-篩選器，搜尋，回覆和管理。",
    26361: "管理所有來源的所有評論",
    26371: "工作流程",
    26381: "按評分，來源，內容，評論者，標籤或地點來搜尋和篩選評論。",
    26391: "直接從平台回覆已授權的評論來源。",
    26401: "按星級和片段套件(按主題)來瀏覽模板，迅速發送客製化回覆。",
    26411: "建立回覆核准的工作流程。",
    26421: "直接發送備註或Cc回覆到地點管理。",
    26431: "完全控制",
    26441: "管理地點列表",
    26451: "直接API 新增/編輯/刪除 各個帳戶中的地點列表詳細訊息。",
    26461: "簡化對任意數量列表的控制。",
    26471: "在地點和已連結的帳戶中用狀態和內容來搜尋和篩選。",
    26481: "直接編輯GBP單點地點的詳細資訊。",
    26491: "替所有符合條件的地點建立GBP貼文。",
    26501: "利用實體標籤將組織地點歸類成不重複客戶群。",
    26511: "分配“友好名稱”可以更輕鬆地管理企業，連鎖店和特許經營檔案。",
    26521: "大量新增/編輯GBP內容，圖檔，類別，時間，地址，說明等。",
    26531: "大量新增每個地點的Google問&答。",
    26541: "大量新增/編輯平台內容，例如地點註釋，本地管理員等。",
    26551: "競爭者評論追踪",
    26561: "儀錶板比較。 評論分布比較。 品牌和地點波象限。",
    26571: "深入了解競爭者的反饋意見",
    26581: "競爭者評論報表儀表板，有篩選功能以確切比較。",
    26591: "競爭品牌之間的評分分佈比較。",
    26601: "評論量與平均評分的波形圖，比較品牌或單個地點，",
    26611: "完整的評論訊息，甚至包括競爭者的回覆。",
    26621: "該部分正式仍處於測試版狀態，我們將持續新增報表和呈現的選擇。",
    26631: "大量管理",
    26641: "獨特的“電子表格用戶界面”透過Google表格直接控制列表。",
    26651: "控制任何規模帳戶最快/簡單的方法。",
    26661: "平台-大量分配和更新變數以管理平台。",
    26671: "詳細資訊-“ Google我的商家”所有詳細資訊的主要部分。",
    26681: "屬性-優化GBP列表中屬性的分配",
    26691: "新增列表-建立新的GBP列表將包含所有關鍵內容",
    26701: "Facebook-利用單個電子表單控制所有Facebook詳細資訊",
    26711: "歷史記錄-文件編輯和更新。",
    26721: "該部分仍處於測試狀態，我們會繼續完善帳戶控制並新增至其他平台。",
    26731: "後期排程",
    26741: "大量新增和排程各地點和帳戶的Google貼文。",
    26751: "分享重要更新和促銷訊息",
    26761: "下載模板為所有符合條件的地點新增Google貼文。",
    26771: "安排整個文件的時間安排或將每個帖子設置為在唯一的日期和時間開始",
    26781: "計劃整個促銷日曆",
    26791: "貼文洞察報告",
    26801: "查看Google 貼文瀏覽量和點擊成效 - 以類型，媒體和號召性用語篩選。",
    26811: "判別成效趨勢以優化免費廣告",
    26821: "用條形圖顯示成效，設置的日期範圍和圖表間隔尺寸。",
    26831: "查看貼文數量，按媒體，主題和號召性用語。",
    26841: "查看個別貼文的成效指標。",
    26851: "下載報告可按廣告系列進行進一步分析。",
    26861: "設定",
    26871: "平台的管理用於所有設定，角色，用戶權限，報告計劃和數據下載的部分。",
    26881: "企業級可為所有使用者有客製化的權限。",
    26891: "主要管理部分",
    26901: "授權平台（Google，Facebook，TrustPilot，Booking）的連接。",
    26911: "設定整合可用評論資料源。",
    26921: "管理/建立不同的使用者角色。",
    26931: "分配/控制個人權限。",
    26941: "排程報表，按類型，使用者甚至地點。",
    26951: "從平台下載數據集，獲取10個最新請求。",
    26961: "授權帳號",
    26971: "Google審核",
    26981: "整合",
    26991: "管理角色",
    27001: "管理使用者",
    27011: "評論設定",
    27021: "建立廣告活動",
    27031: "報表管理",
    27041: "數據下載",
    27051: "檔案細節",
    27061: "客製化導航",
    27071: "評論清晰度",
    27081: "認領地點",
    27091: "授權來源",
    27101: "取得完整數據和直接評論回覆所必需。",
    27111: "選項",
    27121: "隨著各平台API的開放，授權連接平台將繼續增加。",
    27131: "直接授權平台和用戶帳戶之間的連接以獲得創建的可能的控制。",
    27141: "所有來源",
    27151: "索引評論來源",
    27161: "收集來自各行業多達40個來源的反饋",
    27171: "註記",
    27181: "使用Google索引可以取得評論，而不用控制GBP列表。",
    27191: "索引來源用於競��者評論分析。",
    27201: "初始索引後，評論和回覆每天更新",
    27211: "利用URL或PlaceID公開索引所有歷史評論和回覆",
    27221: "所有來源",
    27231: "設定",
    27241: "昨日",
    27251: "過去七天",
    27261: "過去一週",
    27271: "過去30天",
    27281: "上個月",
    27291: "整天",
    27301: "升序排列",
    27311: "降序排列",
    27321: "無聯絡人寄送副本",
    27331: "儲存此回覆",
    27341: "選擇或是建立一個群組",
    27351: "没有保存的答复",
    27361: "無自動回覆",
    27371: "總共0項",
    27381: "已儲存模板",
    27391: "總共26項",
    27401: "最近使用",
    27411: "Emoji表情符號",
    27421: "有留言",
    27431: "沒有留言",
    27441: "所有地点",
    27451: "我的评论",
    27461: "Google更新",
    27471: "缺少的內容",
    27481: "商店代码",
    27491: "其他類別",
    27501: "搜索位置",
    27511: "GBP审核",
    27521: "批量活动",
    27531: "选择组",
    27541: "20/ 頁",
    27551: "同步",
    27561: "设置受众",
    27571: "完毕",
    27581: "實體標籤名稱",
    27591: "分钟",
    27601: "包含 & 不包含留言",
    27611: "轉換率",
    27621: "象限分析",
    27631: "所有地点数据",
    27641: "高搜索 +低转换",
    27651: "高搜索 +高转换",
    27661: "低搜索 +转化率低",
    27671: "低搜索 +高转换",
    27681: "位置数据按区域",
    27691: "城市的位置数据",
    27701: "地點：",
    27711: "轉換率：",
    27721: "搜尋：",
    27731: "Google問與答",
    27741: "Google問與答",
    27751: "下載問與答",
    27761: "发布答案",
    27771: "发布洞察力",
    27781: "下載CSV範例",
    27791: "預先填充的CSV",
    27801: "管理檔案組合",
    27811: "新增檔案組合",
    27821: "瀏覽檔案組合",
    27831: "刪除檔案組合",
    27841: "使用者",
    27851: "管理檔案",
    27861: "刪除檔案",
    27871: "你確定要刪除這個檔案嗎?",
    27881: "帳戶",
    27891: "選擇檔案",
    27901: "選擇檔案",
    27911: "檔案組合帳戶",
    27921: "檔案組合細節",
    27931: "檔案組合名稱",
    27941: "現階段檔案組合圖片",
    27951: "上傳圖片作為檔案組合的標誌",
    27961: "上傳檔案組合名稱",
    27971: "免費試用",
    27981: "目前狀態",
    27991: "帳號過期",
    28001: "取消",
    28011: "帳單",
    28021: "连接的",
    28031: "帳戶",
    28041: "地點",
    28051: "啟用",
    28061: "30天內評論",
    28071: "付款狀態",
    28081: "商家名稱",
    28091: "新增個人資料",
    28101: "輕鬆批次管理不同的檔案組合",
    28111: "輸入名稱",
    28121: "僅限20字元內",
    28131: "新增成功！",
    28141: "個人資料",
    28151: "使用者",
    28161: "輸入電子信箱",
    28171: "邀清某人協助您管理檔案組合。\r\n您可以透過設定不同的角色來管理他的系統使用權限。",
    28181: "邀請",
    28191: "當前地點：照片",
    28201: "評價",
    28211: "等候",
    28221: "更多过滤器",
    28231: "評論關鍵字",
    28241: "保存的过滤器",
    28251: "更少的过滤器",
    28261: "小",
    28271: "一般",
    28281: "大",
    28291: "Single image upload",
    28301: "Select Image Type",
    28311: "Select Type",
    28321: "Cover Photo",
    28331: "Profile Photo",
    28341: "Exterior Photo",
    28351: "Interior Photo",
    28361: "Product photo",
    28371: "Work Photo",
    28381: "Logo Photo",
    28391: "Food and Drink Photo",
    28401: "Menu Photo",
    28411: "Common Area Photo",
    28421: "Rooms Photo",
    28431: "Teams Photo",
    28441: "Views",
    28451: "Photo",
    28461: "打开",
    28471: "关闭",
    28481: "删除",
    28491: "新的回顾标签",
    28501: "所有评论",
    28511: "没有显示在这个范围内！",
    28521: "搜索",
    28531: "全选",
    28541: "搜索源",
    28551: "搜索评论标签",
    28561: "搜索位置",
    28571: "搜索商店代码",
    28581: "搜索组",
    28591: "组织",
    28601: "实体标签",
    28611: "申请",
    28621: "团体",
    28631: "搜索保存的过滤器",
    28641: "没有选项！",
    28651: "调整评论文字视图",
    28661: "见直接审查",
    28671: "回复在评论平台",
    28681: "选择模板",
    28691: "复制",
    28701: "在此之前评测",
    28711: "没有评价",
    28721: "评分",
    28731: "回复在此位置没有添加地点名称",
    28741: "在此位置不加签名",
    28751: "你要继续下载？",
    28761: "评论没有回复",
    28771: "带有内部答复的评论",
    28781: "自动回顾",
    28791: "带有外部答复的评论",
    28801: "查看谷歌知识面板",
    28811: "区注",
    28821: "新经理",
    28831: "启用抄送",
    28841: "另存为回复",
    28851: "删除回复",
    28861: "团体",
    28871: "杂",
    28881: "明星",
    28891: "负，混合正",
    28901: "评分",
    28911: "模板名称",
    28921: "多变的",
    28931: "保存评论",
    28941: "编辑帐户名称",
    28951: "更改帐户名称",
    28961: "用户名",
    28971: "Facebook位置",
    28981: "添加页面",
    28991: "活性",
    29001: "显示隐藏的位置",
    29011: "查看FB页面",
    29021: "没有隐藏的帐户显示",
    29031: "小时前",
    29041: "邀请者",
    29051: "审查展示",
    29061: "谷歌位置",
    29071: "你的位置",
    29081: "位置网址",
    29091: "您确定要删除此URL吗？",
    29101: "您想从应用程序中删除URL及其相关数据吗？",
    29111: "竞争对手的位置",
    29121: "竞争对手的名称",
    29131: "放置ID",
    29141: "Comptag.",
    29151: "输入位置URL和竞争对手详细信息",
    29161: "伊斯康普",
    29171: "预订位置",
    29181: "启动预订审查集成",
    29191: "后台位置ID（可选）",
    29201: "Please fill in your location PlaceID or the competitor details. For 20 or more locations,\r\n        please provide a list of each location as an Excel file to",
    29211: "To download the sample file click",
    29221: "please note it may take several minutes to complete the initial fetch",
    29231: "Please provide a list of each",
    29241: "location URLs for businesses to",
    29251: "You can place them directly in the email or provide an Excel of Google Sheet Lists",
    29261: "Please fill in your location URL and the optional back office location ID (to support deep-linking for review response), or the",
    29271: "competitor details.",
    29281: "Large accounts (20+ locations) can provide a list of each location as an Excel file to",
    29291: "创建广告系列，直接回复完美时间的完美反应的评论",
    29301: "您确定要删除此广告系列吗？",
    29311: "对每个分配的位置管理器复制智能审查",
    29321: "CC回复分配的位置经理",
    29331: "CC回复公司",
    29341: "收件人",
    29351: "所有收件人",
    29361: "选择查看源码",
    29371: "PUB / SUB",
    29381: "选择星级评级",
    29391: "选择评论内容",
    29401: "自定义组",
    29411: "在发送自动回复之前设置延迟",
    29421: "设定工作时间",
    29431: "可选的",
    29441: "没有分配的位置",
    29451: "所选日期范围和标准没有找到洞察力。",
    29461: "过滤器菜单",
    29471: "种类",
    29481: "搜索中的视图",
    29491: "在地图上的观点",
    29501: "您没有足够的权限来发布回复。",
    29511: "已经发送",
    29521: "上传AR模板",
    29531: "追随者计数",
    29541: "最后一个同步",
    29551: "公司的",
    29561: "机构",
    29571: "LocalPost已启用",
    29581: "没有等待验证",
    29591: "点击查看此评论在收件箱中",
    29601: "阅读更多",
    29611: "装载",
    29621: "总（数量）项目",
    29631: "谷歌我的业务已核实",
    29641: "标记为",
    29651: "添加小时",
    29661: "今天",
    29671: "街道地址",
    29681: "邮政编码",
    29691: "识别为黑色所有者",
    29701: "添加URL.",
    29711: "邮政",
    29721: "联系电子邮件",
    29731: "Covid_19更新",
    29741: "对您的业务进行更改？",
    29751: "活动",
    29761: "网上订购",
    29771: "买",
    29781: "现在打电话",
    29791: "现在",
    29801: "同步这个位置？",
    29811: "Facebook上市",
    29821: "创建新的Facebook列表",
    29831: "选择",
    29841: "商业详情",
    29851: "联系人",
    29861: "变量",
    29871: "内部ID",
    29881: "点击连接",
    29891: "回到上传",
    29901: "查看谷歌上的问答",
    29911: "要求",
    29921: "禁用",
    29931: "审查关闭确认",
    29941: "查看回复确认",
    29951: "审查删除确认",
    29961: "地区",
    29971: "答案",
    29981: "管理",
    29991: "创建谷歌帖子",
    30001: "管理谷歌职位",
    30011: "隐藏位置",
    30021: "选择当前页面",
    30031: "创建Facebook帖子",
    30041: "管理Facebook帖子",
    30051: "清除所有",
    30061: "保存过滤器",
    30071: "搜索角色",
    30081: "搜索用户",
    30091: "所有的编辑",
    30101: "分配给评级（必填）",
    30111: "输入模板名称（必填）",
    30121: "自定义模板变量（可选）",
    30131: "选择或创建主题（可选）",
    30141: "分配到单个位置（可选）",
    30151: "分配给实体标记（可选）",
    30161: "查看变量",
    30171: "评论者的名字",
    30181: "评论者全名",
    30191: "位置变量",
    30201: "回复位置名称",
    30211: "地理位置名称",
    30221: "对此评论的回复已已发送。",
    30231: "对此审查的回复不再发送。您可以删除此回复以将其从此处删除。",
    30241: "您想同步这个位置的数据吗？这将在所有更新中拉到该位置。",
    30251: "让客户了解您的业务的任何更改，因为Covid-19",
    30261: "立即发送",
    30271: "搜索展示",
    30281: "使用右侧的控件构建确切的评论展示。单击“应用”按钮以加载即时预览",
    30291: "建立您的评论展示",
    30301: "展示细节",
    30311: "这个展示这个展示",
    30321: "个人位置",
    30331: "位置组",
    30341: "展示标题",
    30351: "隐藏",
    30361: "审阅者图像/头像",
    30371: "展示",
    30381: "选择审核集",
    30391: "审查来源",
    30401: "点评",
    30411: "创建展示",
    30421: "最低评级",
    30431: "评级仅供参考",
    30441: "定义演示文稿",
    30451: "最大审查计数",
    30461: "最大评论长度",
    30471: "每页最高评论",
    30481: "响应布局",
    30491: "排序",
    30501: "最新第一",
    30511: "星级颜色",
    30521: "审查评论",
    30531: "来源徽标",
    30541: "审核日期",
    30551: "精确日期",
    30561: "字体系列",
    30571: "展示标题大小",
    30581: "审稿人名称大小",
    30591: "评论大小",
    30601: "设置覆盖",
    30611: "别针到顶部",
    30621: "排除",
    30631: "我的评论",
    30641: "需要帮助",
    30651: "等待客户",
    30661: "等待反馈",
    30671: "新反馈",
    30681: "搜索名称",
    30691: "未分配",
    30701: "成功更新",
    30711: "广告系列内容名称（可选）",
    30721: "条款和条件（可选）",
    30731: "您确定要删除此用户吗？删除后，除非邀请，否则用户将不再访问此配置文件。",
    30741: "你想删除这个用户吗？",
    30751: "响应分布",
    30761: "我们将通过链接发送电子邮件（）以下载Review CSV。",
    30771: "此配置文件有100多个位置。我们会向您发送一封带有下载链接的电子邮件",
    30781: "用户回复",
    30791: "马克回答说",
    30801: "目的地回复",
    30811: "评论仪表板 ",
    30812: "概览 ",
    30813: "平均",
    30814: "平均评分",
    30815: "位置",
    30816: "快乐",
    30817: "字数比",
    30818: "响应率",
    30819: "按来源评论",
    30820: "按评分评论",
    30821: "按评级响应",
    30822: "最新评论",
    30823: "您在过去 {x} 天收到 {x} 条评论。以下是最新评论",
    30824: "时间范围内每个父位置的平均评论数",
    30825: "4星和5星评分的评论百分比",
    30826: "幸福得分是正面评价百分比减去负面评价百分比的表现",
    30827: "在5星和4星评论中找到的所有评论与时间范围内共享的所有单词的百分比。范围从5星到1星。",
    30828: "在时间范围内收到回复的评论百分比。",
    30829: "从前 {xx} 天起 {x data} 的减少",
    30830: "从前 {xx} 天起 {x data} 的增加",
    30831: "从前 {xx} 天起 {x data} 无变化",
    30832: "点击查看这些评论",
    30833: "(位置名称) , (x) 星, 评论者: (x)",
    30834: "评论与评分平均值",
    30835: "按星级堆叠的随时间变化的评论计数+评分平均值折线图。",
    30836: "按星级划分的百分比",
    30837: "按星级堆叠的随时间变化的评论计数，占总数的百分比。",
    30838: "累计计数与评分平均值",
    30839: "报告时间范围内的评论总数和平均评分。",
    30840: "按来源评论",
    30841: "按来源按时间段划分的评论数量。",
    30842: "随时间变化的幸福评分",
    30843: "报告范围内每个时间段的净幸福评分。",
    30844: "星期几",
    30845: "月中的一天",
    30846: "一年中的月份",
    30847: "热门国家",
    30848: "热门州",
    30849: "热门城市",
    30850: "回复",
    30851: "快速回复率",
    30852: "中位数",
    30853: "在此期间发布的回复数量及每个位置的平均值。",
    30854: "在2天内收到回复的评论百分比和中位回复时间。",
    30855: "回复数量与比例",
    30856: "按星级评分的回复数量及总体回复率。",
    30857: "平均响应时间",
    30858: "平均响应时间（天）。",
    30859: "回复分布",
    30860: "评论回复时间的直方图分为10个等级。",
    30861: "快乐",
    30862: "比例",
    30863: "生命周期",
    30864: "父位置记录数，加上未映射的列表记录。",
    30865: "能量",
    30866: "评论比例",
    30867: "评论长度",
    30868: "比例差距",
    30869: "长度差距",
    30870: "有评论和没有评论的评论",
    30871: "每个星级的平均字数",
    30872: "每个星级中单词的百分比",
    30873: "评论比例百分比",
    30874: "包含客户评论的所有评论的百分比",
    30875: "评论字数",
    30876: "评论中包含的评论平均字数",
    30877: "评论字分布",
    30878: "每个时间段内每个星级评级中的单词百分比",
    30879: "带评论的正面评论百分比减去负面评论的百分比。",
    30880: "正面评论的平均长度减去负面评论的平均长度。",
    30881: "带回复的评论率",
    30882: "评论长度比率",
    30883: "网格视图",
    30884: "平均位置",
    30885: "各地点的平均评分和时间范围内超过4.0评分的地点百分比。",
    30886: "评论表现网格",
    30887: "展示地点评分平均值与评论量以识别异常值",
    30888: "情感",
    30889: "影响",
    30890: "性能仪表板",
    30891: "领导力网格",
    30892: "总浏览量",
    30893: "转换率",
    30894: "总浏览量和每个地点的平均浏览量。",
    30895: "桌面和移动设备上的地图视图与百分比细分。",
    30896: "桌面和移动设备上的本地搜索视图与百分比细分。",
    30897: "总操作量及其在呼叫、网站点击和行车路线之间的百分比细分。",
    30898: "呼叫、网站点击和行车路线的操作/浏览的总转换率。",
    30899: "客户查看",
    30900: "客户在哪里以及如何查看您的业务。",
    30901: "客户操作",
    30902: "您的 Google 列表中的可跟踪操作。",
    30903: "导致操作的商业列表展示次数的百分比",
    30904: "按位置划分的效果",
    30905: "总浏览量与转化率（操作/浏览），以显示每个地点在产生浏览量并将其转化为操作方面的效果。",
    30906: "按城市划分的效果",
    30907: "每个城市的总浏览量与转化率（操作/浏览）。",
    30908: "按组划分的效果",
    30909: "每个自定义群组的总浏览量与转化率（操作/浏览）。",
    30910: "高浏览量 + 低转化率",
    30911: "高浏览量 + 高转化率",
    30912: "低浏览量 + 低转化率",
    30913: "低浏览量 + 高转化率",
    30914: "移动",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "网站",
    30920: "电话",
    30921: "健康分数",
    30922: "每日表现",
    30923: "从表中选择位置和指标（浏览量或操作）",
    30924: "幸福感评分",
    30925: "名称/友好",
    30926: "{x} 个地点在过去 {xx} 天的平均 {y} 星",
    30927: "上面",
    30928: "组",
    30929: "所有浏览量",
    30930: "所有操作",
    30931: "桌面",
    30932: "达到最大限制：为图表选择最多 8 个位置。",
    30933: "评论者",
    30934: "整体情绪",
    30935: "{XX}个主题的情感分数分布。",
    30936: "按主题情感",
    30937: "主题频率及相应的情感分数。",
    30938: "非常积极",
    30939: "非常消极",
    30940: "触发的新评论自动化规则",
    30941: "自动化规则已触发，用于更新的评论",
    30942: "批准了关于的回复",
    30943: "分配了一个标签",
    30944: "将审查分配给",
    30945: "在",
    30946: "自动回复已发送",
    30947: "企业主创建了一个新的外部响应在",
    30948: "由自动化规则在",
    30949: "由系统在",
    30950: "创建了一个新的",
    30951: "创建了一个新的回复在",
    30952: "创建了一个评审备注用于",
    30953: "删除了一个备注在",
    30954: "删除了一个评审备注在",
    30955: "删除了回复在",
    30956: "编辑了回复在",
    30957: "从",
    30958: "生成了自动回复在",
    30959: "本地",
    30960: "通知",
    30961: "通知",
    30962: "概述",
    30963: "执行",
    30964: "响应",
    30965: "响应已移动到审批收件箱",
    30966: "响应已移动到发件箱并计划发布",
    30967: "响应发布到",
    30968: "审查分配给",
    30969: "审查于",
    30970: "收到的审查来自",
    30971: "发送了一条备注给",
    30972: "系统分配了语言标签",
    30973: "系统分配了自动回复于",
    30974: "标签",
    30975: "团队通过自动化规则于",
    30976: "时间线",
    30977: "到",
    30978: "更新了一个",
    30979: "更新了检查笔记于",
    30980: "更新了评论评分从",
    30981: "更新了审核状态从",
    30982: "更新了审核状态为",
    30983: "更新了他们的评论",
    30984: "通过API期间",
    30985: "通过Pub-Sub于",
    30986: "未添加評論",
    30987: "关于",
    30988: "系統",
    30989: "由 ",
    30990: "複習作業取自",
    30991: "指派給",
    30992: "指定標籤：",
    30993: "指定的標籤群組：",
    30994: "指定標籤群：",
    30995: "带更新的审核",
    30996: "没有更新的审核",
    30997: "选择所有标签",
    30998: "选择未标记的",
    30999: "等待批准",
    31000: "最旧的优先",
    31001: "您没有任何已保存的笔记",
    31002: "发件箱中的回复",
    31003: "评论版本",
    31004: "评论详情",
    31005: "打开信息",
    31006: "关系",
    31007: "错误",
    31008: "主要",
    31009: "类别",
    31010: "社交链接",
    31011: "原始圖片已由使用者或平台移除。"
  },
  vietnamese: {
    2013: "Tích lũy",
    2028: "Đánh giá nhóm",
    2029: "tự động hóa",
    2030: "Đầy",
    2031: "Giao",
    2032: "người dùng tìm kiếm",
    2033: "Gửi email",
    2034: "soạn, biên soạn",
    2035: "AI trả lời",
    2036: "Bài trả lời",
    2037: "tái tạo",
    2038: "Sự chấp thuận",
    2039: "Đăng trên Nguồn",
    2040: "Đã gửi trả lời",
    2041: "Không có tin nhắn nào được gửi",
    2042: "Thông thoáng",
    2043: "đóng cửa",
    2044: "Không tìm thấy văn bản trả lời",
    2045: "Sao chép phản hồi và đi đến nguồn",
    2046: "Chỉnh sửa câu trả lời",
    2047: "Phê duyệt trả lời",
    2048: "Cập nhật câu trả lời",
    2049: "Xóa trả lời",
    2050: "Bạn có chắc chắn muốn xóa câu trả lời này không?",
    2051: "Bạn có chắc chắn muốn gửi câu trả lời này?",
    2052: "Bạn có muốn khôi phục đánh giá này?",
    2053: "Bạn có chắc không ?",
    2054: "Bạn có chắc chắn muốn phê duyệt phản hồi này?",
    2055: "Nhóm",
    2056: "Chỉxếp hạng",
    2057: "Xếphạng + Nhậnxétngắn",
    2058: "Xếphạng + Nhậnxét",
    2059: "Đánh giá theo ngôn ngữ",
    2060: "Vui lòng cung cấp độ dài nhận xét từ 1 đến 100, Mặc định sẽ là 20 ký tự",
    2061: "Sao chép Đánh giá thông minh Trả lời cho từng người quản lý vị trí được chỉ định",
    2062: "Đăng nhập",
    2063: "Địa chỉ email",
    2064: "Không có một tài khoản?",
    2065: "Tên đầu tiên",
    2066: "Họ",
    2067: "Công ty",
    2068: "Tên công ty",
    2069: "Bạn co săn san để tạo một tai khoản?",
    2070: "Hiển thị mật khẩu",
    2071: "ẩn mật khẩu",
    2072: "Chuyển đổi địa phương",
    2073: "Bản đồ Di động",
    2074: "Bản đồ Máy tính để bàn",
    2075: "Tìm kiếm Mobile",
    2076: "Tìm kiếm - Máy tính để bàn",
    2077: "Quan điểm tìm kiếm",
    2078: "Quan điểm bản đồ",
    2081: "Phổ quát",
    2091: "Theo Chủ đề",
    10010: "1 sao",
    10013: "2 sao",
    10016: "3 sao",
    10019: "4 sao",
    10022: "5 sao",
    10025: "100-300 từ",
    10120: "Hành động",
    10123: "Kích hoạt",
    10124: "Luônluônhoạtđộng",
    10126: "Tổ chức đang hoạt động",
    10129: "Thêm vào",
    10132: "Thêm nút",
    10135: "Thêm nút (tùy chọn)",
    10138: "Thêm tài khoản",
    10141: "THÊM ĐIỆN THOẠI BỔ SUNG",
    10144: "Thêm một tài khoản",
    10147: "THÊM DANH MỤC KHÁC",
    10150: "THÊM NHÃN KHÁC",
    10153: "Thêm thuộc tính",
    10156: "Thêm dòng",
    10159: "THÊM NGÀY MỚI",
    10162: "Thêm thẻ đánh giá mới",
    10165: "Thêm vai trò mới",
    10168: "Thêm ngày mở",
    10171: "Thêm hồ sơ",
    10174: "Thêm báo cáo",
    10177: "Thêm báo cáo",
    10180: "Thêm vai trò",
    10181: "Thêm thẻ đánh giá",
    10183: "Danh mục bổ sung",
    10186: "Điện thoại bổ sung",
    10189: "Địa chỉ nhà",
    10192: "QUẢN TRỊ VIÊN",
    10195: "Người quản lý",
    10198: "Tiện ích mở rộng vị trí của AdWords",
    10201: "Tiện ích mở rộng vị trí của AdWords",
    10204: "Tất cả các",
    10207: "Tất cả các đánh giá",
    10210: "Tất cả người dùng được chỉ định cho vai trò này sẽ có quyền truy cập vào các tính năng sau",
    10213: "Ứng dụng",
    10216: "Hộp thư đến phê duyệt",
    10219: "Bạn có chắc chắn muốn đặt lại mật khẩu của người dùng này không?",
    10222: "Bạn có chắc không?",
    10225: "Khu vực",
    10228: "Khu vực",
    10231: "Danh sách thuộc tính",
    10234: "Ủy quyền tài khoản",
    10237: "Trung bình",
    10240: "Số lượng trung bình",
    10243: "Xếp hạng trung bình",
    10244: "Trung bình Xêp hạng",
    10246: "Trung bình cho mỗi vị trí",
    10249: "Đang chờ phản hồi",
    10320: "Trở lại",
    10321: "Trở lại",
    10323: "Thanh toán",
    10326: "Sách",
    10329: "Tải lên hàng loạt bài đăng",
    10332: "Thẻ tải lên hàng loạt",
    10335: "TSV tải lên hàng loạt",
    10338: "Tên doanh nghiệp",
    10520: "Lịch",
    10523: "Hủy bỏ",
    10526: "Không thể tải lên bản đồ vị trí chính!",
    10529: "thể loại",
    10532: "Thay đổi vai trò",
    10535: "Lịch sử trích dẫn",
    10538: "Thành phố",
    10541: "Bấm vào đây",
    10544: "Nhấp vào người dùng để chỉ định vai trò này",
    10547: "CO",
    10548: "Xác nhận mật khẩu",
    10550: "Sao chép",
    10553: "Sao chép và dán",
    10556: "Không thể thay đổi vai trò!",
    10559: "Không thể tải lên bài đăng",
    10562: "Quốc gia",
    10565: "Quốc gia",
    10568: "mã giảm giá",
    10571: "Mã phiếu giảm giá (tùy chọn)",
    10574: "Tạo bộ lọc mới bằng cách chọn các tùy chọn bên dưới",
    10577: "Tạo bộ lọc mới",
    10580: "Tạo báo cáo mới",
    10583: "Tạo bài viết",
    10586: "Tạo thẻ",
    10589: "Tạo báo cáo này",
    10592: "Tạo vai trò này",
    10595: "Được tạo bởi",
    10598: "Hành động của khách hàng",
    10720: "D, viết tắt của ngày",
    10723: "bảng điều khiển",
    10726: "Ngày",
    10729: "Phạm vi ngày",
    10732: "ngày",
    10735: "Hủy kích hoạt",
    10738: "MẶC ĐỊNH",
    10741: "Trì hoãn trước khi đăng",
    10744: "Trì hoãn việc gửi trả lời bằng",
    10747: "Trì hoãn việc gửi trả lời bằng",
    10750: "Xóa bỏ",
    10753: "Xóa bỏ ?",
    10754: "Xóa hồ sơ",
    10756: "Mô tả",
    10759: "Sự miêu tả",
    10762: "Thẳng thắn",
    10765: "Truy vấn trực tiếp",
    10768: "Hướng",
    10771: "Khám phá",
    10774: "Chế độ xem khác biệt",
    10777: "Tải xuống tất cả dữ liệu dưới dạng csv",
    10780: "Tải xuống dưới dạng pdf",
    10783: "Tải xuống chi tiết vị trí của Google",
    10786: "Tải xuống dữ liệu này dưới dạng csv",
    10789: "Bản nháp",
    10792: "Hướng dẫn lái xe",
    10795: "Chỉ đường lái xe theo ngày",
    10920: "Chỉnh sửa",
    10923: "Chỉnh sửa (các) Tiểu sử",
    10926: "Chỉnh sửa báo cáo",
    10929: "Chỉnh sửa Báo cáo này",
    10932: "Biên tập viên",
    10935: "E-mail",
    10938: "Thời gian kết thúc",
    10941: "Nhập tiện ích mở rộng vị trí của AdWords",
    10944: "Nhập tên thẻ thực thể",
    10947: "Nhập nhãn",
    10950: "Nhập văn bản tìm kiếm",
    10953: "Nhập tên thẻ",
    10956: "Bằng nhau",
    10959: "Biến cố",
    10962: "chi tiết sự kiện",
    10965: "Tiêu đề sự kiện",
    10968: "Mỗi",
    10971: "example.com",
    10974: "Ví dụ: Giảm giá 20% tại cửa hàng hoặc trực tuyến",
    11120: "Quản lý truy cập tính năng",
    11123: "Bộ lọc",
    11126: "Quên mật khẩu?",
    11129: "Thứ sáu",
    11320: "Nhận phiếu mua hàng",
    11323: "Lớn hơn",
    11520: "Đánh giá hạnh phúc",
    11525: "Cứu giúp",
    11530: "Hoiday",
    11535: "Giờ",
    11540: "Giờ",
    11545: "Cách khách hàng tìm kiếm doanh nghiệp của bạn",
    11720: "Hình ảnh",
    11723: "URL hình ảnh",
    11726: "Trong Maps",
    11729: "Đang tìm",
    11732: "Hộp thư đến",
    11735: "Truy vấn gián tiếp",
    11738: "Thông tin chi tiết",
    11741: "Không đủ quyền",
    11744: "Hội nhập",
    11747: "Tích hợp",
    11750: "Mời người dùng",
    11753: "ĐÃ MỜI",
    11756: "Được mời bởi",
    11759: "mặt hàng",
    12120: "Bảng kiến ​​thức",
    12320: "Nhãn",
    12323: "Lân đăng nhập cuôi",
    12326: "Cập nhật mới nhất",
    12329: "Tìm hiểu thêm",
    12332: "Ít hơn",
    12335: "Liên kết cho nút của bạn",
    12338: "Liên kết để đổi phiếu mua hàng",
    12341: "Liên kết để đổi phiếu mua hàng (tùy chọn)",
    12344: "Liên kết đến bài đánh giá này",
    12347: "Quản lý danh sách",
    12350: "Hiệu suất địa phương",
    12353: "Tổng quan về hiệu suất địa phương",
    12356: "Chuyển đổi tìm kiếm địa phương",
    12359: "Địa phương",
    12362: "Địa phương",
    12365: "Vị trí",
    12368: "Chi tiết vị trí",
    12371: "ID vị trí",
    12374: "Địa điểm",
    12377: "Đăng nhập",
    12380: "Đăng xuất",
    12520: "M, viết tắt của tháng",
    12523: "Làm nổi bật bài đăng của bạn bằng ảnh",
    12526: "Quản lý hoạt động hàng loạt",
    12529: "Quản lý thẻ đối tượng",
    12532: "Quản lý vị trí",
    12535: "Quản lý hồ sơ",
    12538: "Quản lý vai trò",
    12541: "Quản lý người dùng",
    12544: "Bản đồ",
    12547: "Số lượng thương gia",
    12550: "Ảnh thương gia",
    12553: "Số lượng người bán, số lượng ảnh và lượt xem ảnh",
    12556: "Thông điệp",
    12559: "Phút",
    12562: "Thứ hai",
    12565: "tháng",
    12720: "Tên",
    12723: "Tên của vai trò mới",
    12726: "Tên của báo cáo",
    12729: "Cần một tài khoản?",
    12732: "Mới",
    12735: "Trang tiếp theo",
    12738: "Không trả lời",
    12741: "không có kết quả nào được tìm thấy",
    12744: "Không có thẻ đánh giá tồn tại",
    12747: "Không có bài đánh giá nào",
    12750: "Không, hủy bỏ",
    12753: "Số lượng người dùng",
    12756: "Ghi chú",
    12920: "của",
    12923: "Phục vụ",
    12926: "được",
    12929: "OK đã nhận nó!",
    12932: "Một lần",
    12935: "Ngày khai mạc",
    12938: "Gọi món",
    12941: "Tổ chức",
    12944: "Hộp đi bộ",
    12947: "CHỦ NHÂN",
    13120: "trang",
    13123: "Mật khẩu",
    13126: "Dán TSV",
    13129: "Loại Pdf",
    13132: "Điện thoại",
    13135: "Cuộc gọi điện thoại theo ngày",
    13138: "Số điện thoại",
    13141: "Số lượng ảnh",
    13144: "Quan điểm hình ảnh",
    13147: "Vui lòng nhập tên người nhận!",
    13150: "Vui lòng nhập tên báo cáo!",
    13153: "Vui lòng nhập tóm tắt!",
    13156: "Vui lòng nhập tiêu đề!",
    13159: "Vui lòng nhập Thời gian hợp lệ!",
    13162: "Vui lòng nhập url hợp lệ!",
    13165: "Vui lòng Làm mới trang để Cập nhật chi tiết vị trí của bạn",
    13168: "Vui lòng tải lại",
    13171: "Vui lòng chọn Loại lịch biểu!",
    13174: "Lịch sử bài đăng",
    13177: "Bài đăng",
    13180: "Trang trước",
    13183: "Danh mục chính",
    13186: "Điện thoại chính",
    13189: "Số điện thoại chính",
    13192: "Tiểu sử",
    13195: "Số lượng công khai",
    13198: "Ảnh công khai",
    13201: "Ảnh công cộng",
    13204: "CÔNG BỐ",
    13520: "Xếp hạng",
    13523: "Thông báo thời gian thực",
    13526: "Danh sách người nhận",
    13529: "Định kỳ",
    13532: "Xóa người dùng",
    13535: "Đáp lại",
    13538: "Phê duyệt trả lời",
    13541: "Quản lý báo cáo",
    13544: "Tên báo cáo",
    13547: "Loại báo cáo",
    13550: "Đặt lại mật khẩu",
    13553: "Phản hồi bằng xếp hạng sao",
    13556: "Tổng số đánh giá",
    13559: "Xem lại Tải xuống",
    13562: "Xem lại cài đặt",
    13565: "Nguồn đánh giá",
    13568: "Đánh giá thẻ",
    13571: "Đánh giá liên kết",
    13574: "Nhận xét",
    13577: "Đánh giá theo xếp hạng sao",
    13580: "Đánh giá so với xếp hạng trung bình",
    13583: "Đánh giá Hộp thư đến",
    13586: "Quản lý đánh giá",
    13589: "Đánh giá, ngày trong tháng",
    13592: "Đánh giá, ngày trong tuần",
    13595: "Đánh giá, Tháng trong năm",
    13598: "Vai trò",
    13601: "Chi tiết vai trò",
    13604: "Tên vai trò",
    13720: "ngày thứ bảy",
    13723: "Tiết kiệm",
    13726: "Lưu dưới dạng bộ lọc tùy chỉnh",
    13729: "Lưu bộ lọc mới",
    13732: "Lưu vai trò",
    13735: "Đã lưu trả lời",
    13738: "Lịch trình ngày",
    13741: "Lên lịch bài đăng",
    13742: "Lập lịch báo cáo",
    13744: "Thời gian biểu",
    13747: "Loại lịch biểu",
    13750: "Tìm kiếm",
    13753: "Tìm kiếm",
    13756: "Lựa chọn",
    13759: "Chọn một bộ lọc hiện có",
    13762: "Chọn danh mục",
    13765: "Lựa chọn thành phố",
    13768: "Chọn quốc gia",
    13771: "Chọn ngày giờ",
    13774: "Chọn phạm vi ngày",
    13777: "Chọn (các) Editor để xem xét",
    13780: "Chọn Thẻ thực thể",
    13783: "Chọn Bộ lọc",
    13786: "Chọn bộ lọc",
    13789: "Chọn độ chi tiết",
    13792: "Chọn tổ chức",
    13795: "Chọn Tag đánh giá",
    13798: "Chọn Bộ lọc đã lưu",
    13801: "Chọn nguồn",
    13804: "Chọn trạng thái",
    13807: "Chọn thời gian",
    13810: "SELF",
    13813: "Gửi nó để phê duyệt",
    13816: "Gửi nó tới Hộp thư đi",
    13819: "Gởi",
    13822: "Dịch vụ",
    13825: "Cài đặt",
    13828: "Quản lý cài đặt",
    13831: "cửa tiệm",
    13834: "Hiển thị bài đăng",
    13837: "Hiển thị / Ẩn Điều hướng bên trái",
    13840: "Đăng ký",
    13843: "Một vị trí sửa",
    13846: "Lấy làm tiếc!",
    13849: "Sắp xếp theo",
    13852: "Giờ đặc biệt",
    13855: "Truy cập cụ thể",
    13858: "TIÊU CHUẨN",
    13861: "Thời gian bắt đầu",
    13864: "Tiểu bang",
    13867: "Trạng thái",
    13870: "Cửa hàng",
    13873: "Mã cửa hàng",
    13876: "đường phố",
    13879: "Chế độ xem tóm tắt",
    13882: "chủ nhật",
    13885: "Đồng bộ hóa tài khoản này",
    13920: "Điện thoại",
    13923: "Các điều khoản và điều kiện",
    13926: "Thứ năm",
    13929: "Thời gian",
    13932: "Địa phương hàng đầu",
    13935: "Tổng cộng",
    13938: "Thứ ba",
    14120: "Chưa trả lời",
    14123: "Không chắc chắn về định dạng?",
    14126: "Tải lên",
    14129: "Tải lên chi tiết vị trí",
    14132: "Tải lên bản đồ vị trí",
    14135: "Ánh xạ vị trí tải lên",
    14138: "Tải lên TSV",
    14141: "URL",
    14144: "Tên người dùng",
    14320: "Xem hình ảnh",
    14323: "Xem hồ sơ",
    14326: "Lượt xem",
    14520: "W, viết tắt của tuần",
    14523: "Trang mạng",
    14526: "Trang web theo ngày",
    14529: "Tên trang web",
    14532: "Thứ tư",
    14535: "Tuần",
    14538: "Khách hàng thực hiện những hành động nào",
    14541: "Khi trả lời bài đánh giá được thực hiện",
    14544: "Nơi khách hàng xem doanh nghiệp của bạn",
    14547: "Bạn có muốn xóa bài đăng đã lập lịch này không?",
    14550: "Viết tiêu đề của bạn",
    14920: "Năm",
    14923: "Vâng, tiếp tục",
    14926: "Bạn có thể chọn giới hạn quyền truy cập của người dùng bằng vai trò này bằng cách chọn một bộ lọc được đính kèm với nó.",
    14929: "Tên của bạn",
    15120: "Zip",
    20010: "Ngày trong tuần",
    20011: "Thứ hai",
    20020: "Thứ ba",
    20021: "Thứ tư",
    20030: "Thứ Tư",
    20031: "Thứ sáu",
    20040: "Thứ năm",
    20041: "chủ nhật",
    20050: "Thứ sáu",
    20051: "Thứ Ba",
    20060: "Thứ bảy",
    20061: "Thu",
    20070: "Chủ nhật",
    20071: "Ngồi",
    20110: "mặt trời",
    20111: "Tháng trong năm",
    20120: "tháng Giêng",
    20121: "Tháng hai",
    20130: "tháng Ba",
    20131: "Tháng tư",
    20140: "có thể",
    20141: "Tháng sáu",
    20150: "Tháng 7",
    20151: "tháng Tám",
    20160: "Tháng Chín",
    20161: "Tháng Mười",
    20170: "Tháng mười một",
    20171: "Tháng mười hai",
    20180: "Tháng giêng",
    20181: "Tháng hai",
    20190: "Tháng ba",
    20191: "Tháng tư",
    20200: "có thể",
    20201: "Tháng sáu",
    20210: "Tháng bảy",
    20211: "Tháng 8",
    20220: "Tháng 9",
    20221: "Tháng mười",
    20231: "Tháng mười một",
    20241: "Phần trăm",
    20251: "Xem lại với tỷ lệ phần trăm.",
    20261: "Tích lũy",
    20271: "Số tích lũy",
    20281: "Nguồn",
    20291: "Xem xét theo các nguồn",
    20301: "Niềm hạnh phúc",
    20311: "Thời gian đáp ứng",
    20321: "Chọn địa điểm",
    20331: "Tìm kiếm theo đánh giá từ khóa",
    20341: "Tìm kiếm theo người đánh giá",
    20351: "Lựa chọn",
    20361: "Bằng nhau",
    20371: "Ít hơn",
    20381: "Lớn hơn",
    20391: "Chọn tháng",
    20401: "Chọn ngày",
    20411: "Nhấn vào đây để xem các đánh giá này",
    20421: "Không có đánh giá nào được tìm thấy cho phạm vi và tiêu chí ngày đã chọn",
    20431: "LÀm sạch bộ lọc",
    20441: "Xóa bộ lọc tùy chỉnh",
    20451: "Có Google cập nhật",
    20461: "Đã xác minh",
    20471: "Vị trí được xuất bản.",
    20481: "Có các chỉnh sửa đang chờ xử lý",
    20491: "Bảng kiến ​​thức",
    20501: "Xem lại liên kết.",
    20511: "Hướng",
    20521: "Bản sao",
    20531: "Tích cực",
    20541: "Có thể cập nhật",
    20551: "Có thể xóa",
    20561: "Không chờ xem xét",
    20571: "Vị trí đã bật",
    20581: "Không bị ngắt kết nối",
    20591: "Thay đổi log.",
    20601: "Tải lên số lượng lớn hình ảnh",
    20611: "Lịch sử hình ảnh",
    20621: "Lưu lượng tải lên số lượng lớn",
    20631: "Tải lên hàng loạt Q & A",
    20641: "Lịch sử Q & A",
    20651: "Thêm một câu hỏi",
    20661: "Trình bày một câu hỏi cho khách hàng nhấn mạnh một đề xuất giá trị cốt lõi hoặc lợi thế cạnh tranh riêng biệt của vị trí của bạn. Sau đó bạn có thể trả lời các câu hỏi.",
    20671: "Chi tiết nền tảng",
    20681: "Tự động trả lời biến",
    20691: "Tên địa phương",
    20701: "Tên địa lý.",
    20711: "Chữ ký",
    20721: "Tên địa lý (tối đa 80 ký tự)",
    20731: "Tên chữ ký (tối đa 80 ký tự)",
    20741: "Tự động trả lời",
    20751: "Tải về đánh giá",
    20761: "Tự động phản hồi",
    20771: "Liên kết bên ngoài",
    20781: "Sao chép đánh giá",
    20791: "Thêm ghi chú",
    20801: "Lưu ý bên ngoài",
    20811: "Cờ là không phù hợp",
    20821: "Đánh dấu như đã xóa",
    20831: "Bạn có chắc không ?",
    20841: "Bạn có muốn đánh dấu đánh giá này như bị xóa khỏi Google?",
    20851: "Chèn trả lời đã lưu",
    20861: "Lưu dưới dạng mẫu trả lời",
    20871: "Chèn mẫu trả lời tự động",
    20881: "Gửi",
    20891: "Gửi phê duyệt",
    20901: "Lưu dưới dạng dự thảo.",
    20911: "Gán ghi chú",
    20921: "Email Note.",
    20931: "Người nhận",
    20941: "Lưu dưới dạng ghi chú",
    20951: "Gần",
    20961: "Loại bỏ.",
    20971: "Gửi thư",
    20981: "Bạn không có bất kỳ ghi chú đã lưu",
    20991: "Tất cả bắt kịp!",
    21001: "Không có mục để hiển thị",
    21011: "Gửi trả lời.",
    21021: "Người đánh giá đã không thêm bất kỳ ý kiến",
    21031: "Chỉnh sửa trả lời",
    21041: "Xóa trả lời",
    21051: "Tìm kiếm trả lời đã lưu",
    21061: "Thêm trả lời đã lưu",
    21071: "Chọn một nhóm và chủ đề để lưu trả lời này.",
    21081: "Chọn một nhóm hoặc bắt đầu gõ để tạo một",
    21091: "Nhập tiêu đề ở đây",
    21101: "Nhập mẫu trả lời",
    21111: "Vui lòng đảm bảo chọn/tạo một nhóm và tiêu đề để lưu câu trả lời này.",
    21121: "Tự động trả lời.",
    21131: "Thêm tự động trả lời",
    21141: "Chọn một nhóm",
    21151: "Nhập biến ở đây",
    21161: "Chọn biến của bạn",
    21171: "Bạn có muốn tiếp tục?",
    21181: "Yêu cầu này chứa hơn 100 đánh giá cho các yêu cầu như vậy, chúng tôi sẽ gửi cho bạn một email với một liên kết để tải xuống CSV đánh giá.",
    21191: "Bạn có hơn 100 đánh giá",
    21201: "Chúng tôi sẽ gửi cho bạn một email (đến x) với một liên kết để tải xuống CSV đánh giá.",
    21211: "Hành động",
    21221: "Tất cả vị trí",
    21231: "Xếp hạng AVG.",
    21241: "Thương hiệu",
    21251: "Trực tiếp",
    21261: "Khám phá",
    21271: "Môn Địa lý",
    21281: "Niềm hạnh phúc",
    21291: "Truy vấn",
    21301: "Trả lời",
    21311: "Lượt xem",
    21321: "Bài viết bài",
    21331: "Lịch trình bài viết của Google",
    21341: "Tạo bài viết",
    21351: "Quản lý POST.",
    21361: "Lịch trình localpost.",
    21371: "Tải lên",
    21381: "Tiến triển",
    21391: "Xác thực & Lịch trình",
    21401: "Lịch trình Trạng thái",
    21411: "Chọn tập tin",
    21421: "Chọn một loại lịch trình",
    21431: "Ngay tức khắc",
    21441: "Thời gian tập tin",
    21451: "Chọn thời gian",
    21461: "Đăng ngay sau khi xác minh",
    21471: "Lịch trình dựa trên thời gian trong tập tin",
    21481: "Tệp lịch trình theo thời gian đã chọn của bạn",
    21491: "Xếp hàng",
    21501: "Xác nhận đang được tiến hành. Thời gian xử lý là khoảng 40 bài viết mỗi phút. Sau khi xác thực, mỗi trạng thái của bài đăng sẽ có sẵn trên trang tiếp theo.",
    21511: "Đăng xử lý",
    21521: "Xác nhận thành công",
    21531: "Xác nhận thất bại",
    21541: "Lên kế hoạch",
    21551: "Loại / Hành động",
    21561: "ngày",
    21571: "Bắt đầu",
    21581: "Kết thúc",
    21591: "Tiêu đề / Sản phẩm",
    21601: "Bài viết tóm tắt",
    21611: "Trạng thái",
    21621: "Sự thành công",
    21631: "Thất bại",
    21641: "Chỉnh sửa / Xóa",
    21651: "Đăng cái nhìn sâu sắc",
    21661: "Google Post Insights.",
    21671: "Hiệu suất",
    21681: "Đăng Lượt xem.",
    21691: "Đăng theo phương tiện truyền thông",
    21701: "Đăng theo chủ đề",
    21711: "Bài viết của hành động",
    21721: "Phân tích",
    21731: "Tạo",
    21741: "Kiểu",
    21751: "Hoạt động",
    21761: "Bộ lọc nguồn",
    21771: "Nền tảng",
    21781: "Cập nhật trạng thái LocalPost",
    21791: "Builder chiến dịch",
    21801: "Đáp ứng ô tô thông minh",
    21811: "Bật xây dựng chiến dịch phản hồi tự động",
    21821: "Trước khi bật tùy chọn Lịch phản hồi tự động, vui lòng đảm bảo làm theo các hướng dẫn được đưa ra dưới đây:",
    21831: "Trước khi cho phép phản hồi tự động Inteligent, hãy đảm bảo thêm các mẫu trả lời tự động của bạn vào phần Đánh giá. Xây dựng các phản hồi đầu tiên để chúng có thể được gán cho xếp hạng sao (1-5) sẽ kích hoạt phản ứng tự động Inteligent.",
    21841: "Trong chiến dịch Builder, vui lòng chọn thời gian trễ giữa việc xem xét nhận và giao hàng tự động. Cài đặt độ trễ phải tương ứng với thời gian phản hồi đánh giá lý tưởng, vì nó được dự định để che dấu bản chất tự động của chương trình.",
    21851: "Cũng xin xem xét việc thiết lập thời gian hoạt động (ngày trong tuần và giờ trong ngày) cho chiến dịch. Cài đặt Múi giờ mặc định là GMT + 00: 00, vì vậy vui lòng cập nhật khi thích hợp.",
    21861: "Tạo chiến dịch",
    21871: "Gán tên và bất kỳ ghi chú nào để dễ dàng xác định chiến dịch của bạn.",
    21881: "Tên chiến dịch",
    21891: "Phản hồi chiến dịch",
    21901: "Nếu không có tùy chọn nào được chọn, email được sử dụng để đăng ký và ủy quyền tài khoản sẽ là người trả lời mặc định.",
    21911: "Bị đơn cho tự động trả lời",
    21921: "Phạm vi ngày chiến dịch",
    21931: "Ghi chú / Mục tiêu",
    21941: "Mô tả chiến dịch",
    21951: "Đặt kích hoạt",
    21961: "Chọn loại đánh giá sẽ nhắc nhở phản hồi tự động cho chiến dịch này.",
    21971: "với bình luận",
    21981: "không một lời bình",
    21991: "Trước",
    22001: "Kế tiếp",
    22011: "Đặt khán giả (tùy chọn)",
    22021: "Đặt các vị trí là một phần của chiến dịch dựa trên thẻ thực thể, một tổ chức hoặc quốc gia / khu vực cụ thể / địa phương. Bộ lọc này chỉ khả dụng cho các đánh giá của Google và các vị trí được ánh xạ",
    22031: "thực thể.",
    22041: "tổ chức",
    22051: "Lên kế hoạch",
    22061: "Chỉ định các tham số và lịch trình đánh giá phản hồi, tức là tỷ lệ đánh giá được nhắm mục tiêu và giờ hoạt động hoạt động cho các phản hồi.",
    22071: 'Vui lòng biết rằng các phản hồi tự động hiện chỉ có sẵn trên cơ sở "hướng dẫn". Chúng tôi đang làm việc trên các quy trình riêng cho người dùng có thể muốn thực hiện một cách tự động dọn dẹp trong thời gian ngắn.',
    22081: "Đặt tỷ lệ phản hồi",
    22091: "Đặt số phản hồi",
    22101: "Trì hoãn trước khi gửi tự động trả lời",
    22111: "lịch trình định kỳ.",
    22121: "Chọn ngày và đặt thời gian để chuyển hướng tự động theo định kỳ",
    22131: "Chọn Timezone",
    22141: "Gán phản hồi",
    22151: "Từ danh sách, chọn câu trả lời nào để sử dụng trong Xoay cho chiến dịch này.",
    22161: "Xác nhận",
    22171: 'Xem lại từng chi tiết bên dưới và nhấn "Xác nhận" để khởi chạy chiến dịch của bạn.',
    22181: "Ngày",
    22191: "Ngôi sao",
    22201: "Đại dịch viên",
    22211: "Báo cáo",
    22221: "Thiết lập đối thủ cạnh tranh",
    22231: "Thực hành tốt nhất",
    22241: "Góc phần tư.",
    22251: "Xếp hạng",
    22261: "Xếp hạng cạnh tranh",
    22271: "Ngược lại",
    22281: "Xem các nguồn đánh giá",
    22291: "Thêm đối thủ cạnh tranh",
    22301: "Lọc bởi",
    22311: "Sạch",
    22321: "Đối thủ",
    22331: "Biên dịch",
    22341: "Tag Tag.",
    22351: "Bình luận",
    22361: "Không có lựa chọn",
    22371: "Xấu",
    22381: "Nghèo",
    22391: "Trung bình",
    22401: "Tuyệt",
    22411: "Xuất sắc",
    22421: "Đánh giá với trả lời",
    22431: "Đánh giá mà không cần trả lời",
    22441: "Đánh giá với ý kiến",
    22451: "Đánh giá mà không có ý kiến",
    22461: "Đánh giá âm lượng vs đánh giá trung bình",
    22471: "Nhãn hiệu",
    22481: "Phóng",
    22491: "Tổng số đánh giá",
    22501: "Đánh giá đánh giá theo sao",
    22511: "Đánh giá đối thủ cạnh tranh",
    22521: "Đối thủ cạnh tranh của.",
    22531: "Mã số",
    22541: "Quản lý đối thủ cạnh tranh",
    22551: "Cập nhật",
    22561: "Thêm đối thủ cạnh tranh",
    22571: "Thêm vị trí",
    22581: "Thêm tên đối thủ cạnh tranh",
    22591: "Bước đầu tiên là thêm tên của đối thủ cạnh tranh, một khi bạn đã thêm tên và biểu tượng tùy chọn (hình ảnh 48x48) vào danh sách, nhấp vào 'Thêm'. Khi các đối thủ cạnh tranh được tạo, bạn sẽ có thể chỉ định các địa điểm riêng lẻ",
    22601: "Nhập tên đối thủ cạnh tranh (bắt buộc)",
    22611: "Nhập URL đối thủ cạnh tranh (tùy chọn)",
    22621: "Tải lên hình ảnh",
    22631: "Sắp có",
    22641: "Tỷ lệ bình luận",
    22651: "Phần trăm đánh giá với và không có ý kiến",
    22661: "Không có",
    22671: "Với",
    22681: "Độ dài bình luận",
    22691: "Số lượng từ trung bình được sử dụng trong mỗi bình luận theo xếp hạng sao",
    22701: "Từ",
    22711: "Tỷ lệ từ",
    22721: "Tổng cộng và tỷ lệ phần trăm từ trong bình luận cho mỗi xếp hạng sao",
    22731: "ở đây.",
    22741: "Đối thủ cạnh tranh",
    22751: "Thêm thẻ",
    22761: "Chọn các biến sẽ được thêm vào mẫu",
    22771: "Đóng đánh giá",
    22781: "Đóng đánh giá",
    22791: "Bạn có muốn đóng đánh giá này? Khi bạn đóng, bạn sẽ cần mở lại nó để trả lời",
    22801: "Bên ngoài",
    22811: "Phủ định",
    22821: "Không",
    22831: "Không có tự động trả lời!",
    22841: "Chưa có trả lời đã lưu!",
    22851: "Ghi chú",
    22861: "Đóng cửa vĩnh viễn",
    22871: "Khả quan",
    22881: "Đọc hết thời gian",
    22891: "Phục hồi đánh giá",
    22901: "Mở lại đánh giá",
    22911: "Trả lời",
    22921: "Trả lời đã được gửi (từ giao diện Google)",
    22931: "Trả lời được gửi từ ứng dụng",
    22941: "Xem xét gỡ bỏ",
    22951: "Mẫu",
    22961: "Tạm thời đóng cửa",
    22971: "đúng",
    22981: "Bạn không có bất kỳ bản nháp đã lưu",
    22991: "Không đủ quyền để truy cập tài nguyên",
    23001: "Lỗi nội bộ gặp phải",
    23011: "Yêu cầu chứa một đối số không hợp lệ",
    23021: "Không tìm thấy thực thể được yêu cầu",
    23031: "Đánh giá không còn tồn tại trên nền tảng Google",
    23041: "Một số giá trị chèn tự động không có sẵn. Vui lòng thay thế và gửi",
    23051: "Dịch vụ hiện không có sẵn",
    23061: "Hoạt động này không được hỗ trợ cho các địa điểm không có người nhận",
    23071: "Xuất bản bài",
    23081: "Bài viết theo lịch trình",
    23091: "Tên thân thiện.",
    23101: "Thêm tên thân thiện",
    23111: "Tiếp xúc",
    23121: "Không có liên lạc!",
    23131: "Để thêm liên lạc",
    23141: "Tên Liên lạc",
    23151: "Địa chỉ email liên lạc",
    23161: "Thêm liên lạc",
    23171: "Đăng cái nhìn sâu sắc",
    23181: "Google Post Insights.",
    23191: "Không có dữ liệu",
    23201: "Kiểm toán Google.",
    23211: "Nhật ký kiểm toán",
    23221: "Chọn một báo cáo",
    23231: "Lựa chọn",
    23241: "Tất cả tải về",
    23251: "Không có lựa chọn",
    23261: "Tải dữ liệu",
    23271: "Xem lại Tải về",
    23281: "Tất cả các đánh giá",
    23291: "Tải ảnh URL",
    23301: "URL ảnh khách hàng",
    23311: "URL ảnh thương gia",
    23321: "Báo cáo tải về lịch sử",
    23331: "Tên báo cáo",
    23341: "Gửi đến",
    23351: "Tạo thời gian (UTC)",
    23361: "Loại báo cáo",
    23371: "Chi tiết hồ sơ",
    23381: "Thay đổi tên hồ sơ.",
    23391: "Đồng bộ hóa hàng tuần",
    23401: "Cho phép quản lý số lượng lớn tab Vị trí",
    23411: "Cài đặt định dạng ngày",
    23421: "Cứu",
    23431: "Cài đặt Hạnh phúc / NPS",
    23441: "Promoter / Happy.",
    23451: "Trung lập",
    23461: "Gièm pha / không hài lòng",
    23471: "Cập nhật",
    23481: "Logo hiện tại",
    23491: "Logo đầy đủ",
    23501: "Biểu tượng",
    23511: "Báo cáo logo.",
    23521: "Favicon.",
    23531: "Logo này sẽ có mặt trên góc trên cùng bên trái trong khi mở rộng điều hướng bên trái của hồ sơ của bạn.",
    23541: "Logo này sẽ có mặt trên góc trên cùng bên trái của hồ sơ của bạn.",
    23551: "Logo này sẽ được hiển thị trong các báo cáo bảng điều khiển và các báo cáo đánh giá được tạo trong hệ thống. Sử dụng hình ảnh PNG có kích thước từ 5kb đến 20kb để có kết quả tốt nhất",
    23561: "Logo này sẽ trình bày trên góc trên cùng bên trái của tab Trình duyệt.",
    23571: "Thay thế logo.",
    23581: "Chọn loại logo nào bạn muốn thay đổi bằng cách sử dụng các tùy chọn thả xuống và tải lên logo.",
    23591: "Tải lên logo cho",
    23601: "Cấu hình trạng thái vị trí GBP: Cài đặt triệt tiêu",
    23611: "Kìm nén",
    23621: "Dễ thấy",
    23631: "Ngắt kết nối",
    23641: "Chưa được xác minh",
    23651: "Cấm",
    23661: "Bản sao",
    23671: "Đánh giá bên thứ nhất Tải lên",
    23681: "Tải lên",
    23691: "Sạch",
    23701: "Quản lý địa điểm số lượng lớn",
    23711: "Kiểm soát quản lý số lượng lớn",
    23721: "Cập nhật chi tiết vị trí và thông số nền tảng điều khiển trực tiếp trong Google Tấm.",
    23731: "NỀN TẢNG",
    23741: "Dễ dàng quản lý tài khoản bất kỳ thang đo nào với các biến vị trí tùy chỉnh và cài đặt.",
    23751: "Chi tiết GBP",
    23761: "Xem tất cả các danh sách doanh nghiệp của tôi và thêm / chỉnh sửa / xóa chi tiết vị trí.",
    23771: "Thuộc tính GBP.",
    23781: "Chỉ định tất cả các thuộc tính đủ điều kiện cho mỗi vị trí để đạt được khám phá tìm kiếm gia tăng.",
    23791: "Danh sách GBP",
    23801: "Tạo danh sách GBP mới.",
    23811: "Facebook",
    23821: "Kiểm soát danh sách Facebook",
    23831: "Môn lịch sử",
    23841: "Đào tạo",
    23851: "Tiện ích truy cập cho các quy trình chỉnh sửa hàng loạt, thực tiễn tốt nhất, hạn chế và cập nhật.",
    23861: "CẢNH BÁO",
    23871: "Yêu cầu:",
    23881: "Người dùng phải có tài khoản Google để hệ thống có thể trình bày Google Sheet với dữ liệu hồ sơ.",
    23891: "Lưu ý:",
    23901: "Dữ liệu điền vào từng tờ nếu từ cơ sở dữ liệu hệ thống. Nếu bạn muốn chắc chắn rằng bảng tính trình bày dữ liệu Google hiện tại, chúng tôi khuyên bạn nên đầu tiên đồng bộ hóa hồ sơ của mình.",
    23911: 'Tùy thuộc vào số lượng vị trí trong tài khoản của bạn, các sheets của Google có thể mất thời gian để xây dựng ban đầu và sau đó làm mới khi bạn điều hướng bảng. Vui lòng đảm bảo rằng tất cả dữ liệu ổn định trước khi nhấn "Cập nhật" để lưu các chỉnh sửa vào hệ thống và đẩy các bản cập nhật lên Google.',
    23921: "Nền tảng có kết nối API trực tiếp với Google, nhưng vẫn có thể có thời gian để Google trì hoãn cập nhật trực tiếp vào trang liệt kê vị trí công cộng.",
    23931: 'Đẩy "Cập nhật" kích hoạt hệ thống trực tiếp trực tiếp vào Google. Không có quy trình hoàn tác hoặc đảo ngược có sẵn. Hãy chắc chắn rằng bạn cảm thấy thoải mái với tất cả các chỉnh sửa trước khi kích hoạt cập nhật. Nếu một sai lầm được thực hiện, xin vui lòng đợi một vài phút và sau đó thực hiện thay đổi cần thiết.',
    23941: "BẢNG MÀU",
    23951: "Mỗi trang tính có một bảng màu mặc định để giúp người dùng hiểu các trường nào đủ điều kiện chỉnh sửa.",
    23961: "Các biến rằng truyền đạt chi tiết trạng thái từ Google hoặc không thể được chỉnh sửa trực tiếp thông qua các điều khiển số lượng lớn.",
    23971: "Các biến Google trực tiếp mở để chỉnh sửa hàng loạt.",
    23981: "Biến nền tảng trực tiếp mở để chỉnh sửa hàng loạt.",
    23991: "Điều khiển",
    24001: "Thông tin chi tiết",
    24011: "Thuộc tính",
    24021: "Tạo danh sách",
    24031: "Hướng dẫn",
    24041: "Hết hạn vào ngày",
    24051: "Thời gian để đăng ký!",
    24061: "Hồ sơ này sẽ hết hạn vào",
    24071: "Để tiếp tục truy cập hồ sơ này, vui lòng đăng ký.",
    24081: "Đưa tôi tơi đo!",
    24091: "Một lát sau",
    24101: "Thanh toán",
    24111: "Gói chi tiết",
    24121: "Thêm",
    24131: "Pro.",
    24141: "Mỗi địa điểm",
    24151: "$ 8 / mỗi địa điểm",
    24161: "10 địa điểm đầu tiên",
    24171: "Tối thiểu $ 24 / tháng",
    24181: "Thử miễn phí trong 14 ngày",
    24191: "Tất cả các tích hợp bao gồm",
    24201: "Đánh giá đầy đủ Inbox.",
    24211: "Toạng truy cập toàn bộ",
    24221: "Báo cáo đầy đủ Suite",
    24231: "Người dùng không giới hạn",
    24241: "30 phản hồi đánh giá được cài đặt sẵn",
    24251: "Hỗ trợ đầy đủ",
    24261: "Địa điểm 11-200.",
    24271: "Tất cả các tính năng của Plus Plan",
    24281: "Quản lý GBP đầy đủ",
    24291: "Số lượng lớn / lịch trình google bài viết",
    24301: "Thông báo thời gian thực",
    24311: "Thiết lập báo cáo tùy chỉnh",
    24321: "Tối ưu hóa tìm kiếm địa phương.",
    24331: "Cá nhân trên tàu",
    24341: "Kiểm toán đánh giá thô tục & gian lận",
    24351: "Hoạt động",
    24361: "Ủy quyền.",
    24371: "Kết nối được ủy quyền truy cập Đánh giá đầy đủ và Khả năng phản hồi từ / đến mỗi nguồn.",
    24381: "Tải lên số lượng lớn các thẻ thực thể",
    24391: "Tải lên số lượng lớn chi tiết GBP",
    24401: "Chọn một nhóm và chủ đề để lưu tự động trả lời.",
    24411: "Đếm",
    24421: "Tạo Tag Entity",
    24431: "Tạo thời gian (UTC)",
    24441: "Tab thanh bên tùy chỉnh",
    24451: "Công cụ thanh bên tùy chỉnh",
    24461: "Tải xuống kiểm toán GBP.",
    24471: "Tên tập tin.",
    24481: "Lịch sử chi tiết GBP.",
    24491: "Ấn tượng",
    24501: "Không hoạt động",
    24511: "Lập chỉ mục",
    24521: "Các kết nối được lập chỉ mục truy cập tất cả các đánh giá lịch sử và hiện tại từ mỗi nguồn.",
    24531: "Quản lý localpost.",
    24541: "Không có bình luận thêm",
    24551: "Con số",
    24561: 'Vui lòng nhấp vào nút "Báo cáo mới", ở trên cùng bên phải',
    24571: "Hồ sơ tạo",
    24581: "Yêu cầu ID",
    24591: "Lưu trả lời",
    24601: "Tổng số vị trí",
    24611: "Tổng số bài",
    24621: "Tải lên mẫu AR.",
    24631: "Tải lên bí danh vị trí.",
    24641: "Quan điểm",
    24651: "Bạn có thể định cấu hình và đặt các tab tùy chỉnh trong thanh bên trỏ đến iframe trong nền tảng hoặc liên kết được lưu trữ bên ngoài.",
    24661: "Chi tiết GBP",
    24671: "Thuộc tính GBP.",
    24681: "Danh sách GBP",
    24691: "FACEBOOK",
    24701: "MÔN LỊCH SỬ",
    24711: "ĐÀO TẠO",
    24721: "Đồng bộ hóa hàng tuần được kích hoạt trên",
    24731: "Mmm d, yyy",
    24741: "Ví dụ: -OCT 13,2020",
    24751: "Mm / dd / yyyy",
    24761: "Mmmm d, yyyy",
    24771: "Ví dụ: -Cần 11 tháng 10 năm 2010",
    24781: "DD / MM / YYYY",
    24791: "Dd mmm yyyy.",
    24801: "Dd mmmm yyyy.",
    24811: "Ví dụ: - 13 tháng 10 năm 2020",
    24821: "Tải lên logo mới",
    24831: "Tách ra.",
    24841: "Nhìn thấy ẩn",
    24851: "Xem lại chi tiết cấu hình khung",
    24861: "Hiển thị mã cửa hàng",
    24871: "Hiển thị địa chỉ đầy đủ",
    24881: "Hiển thị Tóm tắt Tiện ích",
    24891: "Tiêu đề đảo ngược.",
    24901: "Chọn tập tin",
    24911: "Không có tập tin nào được chọn",
    24921: "Xem nhật ký của mỗi lần nhấn cập nhật để xác nhận danh sách thay đổi nội dung và phát hiện bất kỳ lỗi nào.",
    24931: 'Tùy thuộc vào số lượng vị trí trong tài khoản của bạn, các sheets của Google có thể mất thời gian để xây dựng ban đầu và sau đó làm mới khi bạn điều hướng bảng. Vui lòng đảm bảo rằng tất cả dữ liệu ổn định trước khi nhấn "Cập nhật" để lưu các chỉnh sửa vào hệ thống và đẩy các bản cập nhật lên Google.',
    24941: "Tài nguyên để chỉnh sửa hàng loạt quy trình công việc, thực tiễn tốt nhất, hạn chế và cập nhật.",
    24951: "Tên người dùng",
    24961: "Bạn có muốn xóa không?",
    24971: "Tài khoản",
    24981: "Không có cập nhật Google",
    24991: "Sự tôn kính không bắt buộc",
    25001: "Không có chỉnh sửa đang chờ xử lý",
    25011: "Thời gian kiểm toán",
    25021: "đồng ruộng",
    25031: "có giá trị đối với)",
    25041: "Giá trị (từ)",
    25051: "Xóa khỏi thẻ thực thể",
    25061: "Thuộc tội",
    25071: "AdWords.",
    25081: "Xem tất cả",
    25091: "Q & A.",
    25101: "Khám phá",
    25111: "Khám phá phản ứng",
    25121: "Chọn mẫu",
    25131: "Tiếp tục",
    25141: "Chọn xếp hạng sao, tên mẫu và thêm nội dung mẫu để lưu trả lời tự động.",
    25151: "Chọn loại trả lời",
    25161: "Bản mẫu",
    25171: "Đoạn trích",
    25181: "Gán cho xếp hạng (bắt buộc)",
    25191: "Nhập tên mẫu (bắt buộc)",
    25201: "Biến mẫu tùy chỉnh (tùy chọn)",
    25211: "Chọn nội dung tạo (tùy chọn)",
    25221: "Gán cho một vị trí duy nhất",
    25231: "Gán cho thẻ thực thể",
    25241: "Thêm tên chủ đề và nội dung đoạn trích để lưu trả lời tự động.",
    25251: "Tổng số mặt hàng",
    25261: "Địa điểm Note.",
    25271: "Xem chi tiết vị trí",
    25281: "Xem Google Kiến thức Pannel",
    25291: "Xem đánh giá trực tiếp trên Google",
    25301: "Tích cực-5 sao",
    25311: "Tiêu cực - 1/2 sao",
    25321: "Hỗn hợp - 3/4 sao",
    25331: "Tên mẫu",
    25341: "Biến đổi",
    25351: "Chọn hoặc tạo chủ đề",
    25361: "Tập đoàn",
    25371: "Đề tài",
    25381: "Đánh giá trước",
    25391: "Lưu dưới dạng trả lời",
    25401: "Cc.",
    25411: "Cài lại",
    25421: "CÓ GÌ MỚI",
    25431: "Tạo ngày",
    25441: "Tên bộ lọc tùy chỉnh.",
    25451: "CHỈ ĐỌC",
    25461: "Truy cập tính năng",
    25471: "Không có",
    25481: "ĐỌC",
    25491: "Không bị hạn chế",
    25501: "Đây là một vai trò mặc định và không thể được chỉnh sửa / xóa",
    25511: "Đọc",
    25521: "Viết",
    25531: "Tải xuống",
    25541: "Tất cả người dùng được gán cho vai trò này sẽ có sự thịnh vượng / quyền truy cập vào các tính năng sau",
    25551: "Cài đặt hiển thị SUBTAB",
    25561: "Quản lý vai trò",
    25571: "Thanh bên tùy chỉnh.",
    25581: "HOẶC",
    25591: "Lưu thuộc tính vai trò",
    25601: "Bạn có chắc chắn muốn xóa vai trò",
    25611: "Điều này sẽ thay đổi vai trò của tất cả người dùng hiện được gán cho vai trò này để chỉ đọc.",
    25621: "Chỉ định người dùng",
    25631: "Người dùng trong hồ sơ.",
    25641: "Tìm kiếm ở đây",
    25651: "Người dùng được giao cho vai trò này",
    25661: "Không có người dùng",
    25671: "Mời lại",
    25681: "Trang đích mặc định",
    25691: "Đánh giá inbox.",
    25701: "Quản lý số lượng lớn.",
    25711: "Bài viết lên lịch",
    25721: "TRÊN",
    25731: "TẮT",
    25741: "Bạn có chắc chắn tắt chiến dịch?",
    25751: "Bạn có chắc chắn bật chiến dịch?",
    25761: "Thành công cập nhật chiến dịch",
    25771: "Tỷ lệ phản hồi",
    25781: "Đếm trả lời",
    25791: "Xếp hạng sao",
    25801: "Với",
    25811: "Không có",
    25821: "Trì hoãn",
    25831: "Múi giờ",
    25841: "Ôn tập",
    25851: "Báo cáo đối thủ cạnh tranh.",
    25861: "Sự sắp xếp",
    25871: "Html email.",
    25881: "Excel.",
    25891: "Nếu không có đánh giá trong phạm vi đã chọn",
    25901: "Đừng gửi email",
    25911: "Gửi email",
    25921: "Q & A.",
    25931: "Nếu không có Q & A trong phạm vi được chọn",
    25941: "Hình ảnh khách hàng",
    25951: "Sổ ghi chép đánh giá",
    25961: "Vui lòng liên hệ với sự hỗ trợ với bất kỳ câu hỏi về Cadence Sync Cadence.",
    25971: "Bao gồm tập tin kiểm toán",
    25981: "Hồ sơ",
    25991: "Comptag.",
    26001: "Xem lại chi tiết",
    26011: "Quản lý các điều khiển Tier.",
    26021: "Ghi đè chức năng mặc định, được sắp xếp vào các tầng",
    26031: "Xây dựng cung cấp cấp",
    26041: "Tạo cấp mới",
    26051: "TÊN TERER.",
    26061: "VỠ NỢ",
    26071: "Vỡ nợ",
    26081: "Bảng điều khiển danh tiếng",
    26091: "Insightsinto toàn diện Tất cả đánh giá KPI",
    26101: "Tầm nhìn đầy đủ trên tất cả các địa điểm và nguồn",
    26111: "Phần.",
    26121: "KPI lõi của khối lượng đánh giá, xếp hạng trung bình, phân phối, nguồn, hạnh phúc và tỷ lệ ứng phó.",
    26131: "Phân tích theo chiều dọc về đánh giá & đánh giá, phần trăm, tích lũy, nguồn, hạnh phúc và biểu đồ thời gian đáp ứng.",
    26141: "Tỷ lệ bình luận, chiều dài bình luận và tỷ lệ từ tích lũy theo đánh giá.",
    26151: "Đánh giá theo ngày trong tuần, ngày trong tháng, và tháng của năm.",
    26161: "Năm quốc gia hàng đầu, tiểu bang / tỉnh và thành phố bằng cách xem xét khối lượng.",
    26171: "Tất cả dữ liệu lịch sử được biên dịch trong khi thiết lập tài khoản ban đầu và sau đó được cập nhật từ tất cả các nguồn đánh giá được kết nối hàng ngày.",
    26181: "Thông tin chi tiết về GBP.",
    26191: "Biểu đồ khu vực khối lượng tìm kiếm trực tiếp, khám phá và thương hiệu hàng ngày.",
    26201: "Bản đồ và tìm kiếm biểu đồ khu vực xem hàng ngày.",
    26211: "Biểu đồ hành động của khách hàng cho hướng lái xe, cuộc gọi điện thoại và nhấp vào trang web.",
    26221: "Hành động vị trí theo ngày biểu đồ cột tuần.",
    26231: "Lệnh chuyển đổi cục bộ độc đáo (hành động / tìm kiếm hàng ngày).",
    26241: "Thương hiệu hình ảnh số lượng trung bình được lưu trữ đến vị trí GBP và tổng quan điểm",
    26251: "Khách hàng đã tải lên hình ảnh số lượng trung bình được lưu trữ đến vị trí GBP và tổng quan điểm.",
    26261: "18 tháng đầy đủ dữ liệu hàng ngày cho mỗi vị trí được biên dịch trong khi thiết lập tài khoản ban đầu và sau đó được cập nhật từ tất cả các nguồn đánh giá được kết nối hàng ngày. Google hiện báo cáo rõ ràng với độ trễ 3-5 ngày.",
    26271: "Tiếp xúc tìm kiếm địa phương và báo cáo hành động.",
    26281: "Localperperance.",
    26291: "Dễ dàng so sánh hiệu suất trên các địa điểm",
    26301: "Biểu đồ dòng hàng ngày của các địa điểm riêng lẻ được chọn để đánh giá, xếp hạng AVG, tìm kiếm, lượt xem và hành động",
    26311: "Trình bày bảng có thể sắp xếp và tìm kiếm của từng đánh giá của địa điểm và số liệu địa phương với báo cáo tải xuống đầy đủ.",
    26321: "Tab bổ sung cung cấp biểu đồ hiệu suất và bảng bằng cách cuộn địa lý / khoan xuống với trình kích hoạt tải xuống độc đáo của riêng mình.",
    26331: "Đánh giá và bảng thông tin chi tiết về GBP theo địa điểm cá nhân.",
    26341: "Đánh giáBox.",
    26351: "Hộp thư đến tổng hợp cho tất cả các vị trí và nguồn - lọc, tìm kiếm, phản hồi và quản lý.",
    26361: "Quản lý tất cả các đánh giá từ tất cả các nguồn",
    26371: "Quy trình làm việc",
    26381: "Tìm kiếm và lọc để tìm đánh giá theo đánh giá, nguồn, nội dung, người đánh giá, thẻ hoặc vị trí.",
    26391: "Trả lời các nguồn đánh giá được ủy quyền trực tiếp từ nền tảng.",
    26401: "Khám phá các mẫu theo Xếp hạng và Đoạn trích theo chủ đề để gửi phản hồi được cá nhân hóa với tốc độ vô song.",
    26411: "Tạo quy trình công việc để phê duyệt phản hồi được kiểm soát.",
    26421: "Gửi ghi chú hoặc CC 'trả lời trực tiếp để quản lý vị trí.",
    26431: "Kiểm soát đầy đủ",
    26441: "Quản lý danh sách vị trí",
    26451: "API trực tiếp Thêm / chỉnh sửa / xóa Kiểm soát tất cả các chi tiết danh sách vị trí trên các tài khoản.",
    26461: "Hợp lý kiểm soát bất kỳ số lượng danh sách.",
    26471: "Tìm kiếm và lọc trên bất kỳ số lượng vị trí và tài khoản được kết nối theo trạng thái và nội dung.",
    26481: "Chỉnh sửa trực tiếp chi tiết GBP theo địa điểm cá nhân.",
    26491: "Tạo bài viết GBP riêng cho tất cả các vị trí đủ điều kiện.",
    26501: "Sắp xếp các địa điểm thành một số nhóm khách hàng độc đáo thông qua các thẻ thực thể.",
    26511: 'Chỉ định "tên thân thiện" để giúp quản lý hồ sơ doanh nghiệp, chuỗi và nhượng quyền dễ dàng hơn.',
    26521: "Thêm / chỉnh sửa nội dung GBP, hình ảnh, danh mục, giờ, địa chỉ, mô tả và nhiều hơn nữa.",
    26531: "Số lượng lớn thêm câu hỏi và câu trả lời của Google mới cho bảng kiến ​​thức của mỗi địa điểm.",
    26541: "Thêm / chỉnh sửa nội dung nền tảng như ghi chú vị trí, người quản lý cục bộ và nhiều hơn nữa.",
    26551: "Theo dõi đánh giá đối thủ cạnh tranh",
    26561: "So sánh bảng điều khiển. Xem lại so sánh phân phối. Thương hiệu & vị trí sóng góc.",
    26571: "Đạt được những hiểu biết vô song vào phản hồi đối thủ cạnh tranh",
    26581: "Đánh giá đối thủ Bảng điều khiển báo cáo, có thể lọc để xác định các so sánh chính xác.",
    26591: "Xếp hạng phân phối so sánh trên các thương hiệu đối thủ cạnh tranh.",
    26601: "Biểu đồ sóng của khối lượng đánh giá so với xếp hạng trung bình, so sánh các thương hiệu hoặc địa điểm riêng lẻ,",
    26611: "Đánh giá đầy đủ chi tiết nhận xét và thậm chí các câu trả lời của đối thủ cạnh tranh.",
    26621: "Phần chính thức vẫn còn trong trạng thái beta khi chúng tôi tiếp tục thêm nhiều tùy chọn báo cáo và trình bày.",
    26631: "Quản lý số lượng lớn.",
    26641: '"UI bảng tính" duy nhất cung cấp điều khiển danh sách trực tiếp thông qua Google Sheet được kết nối.',
    26651: "Cách nhanh nhất và dễ nhất để kiểm soát tài khoản bất kỳ kích thước nào.",
    26661: "Nền tảng - Phân công số lượng lớn và cập nhật các biến chính để quản lý nền tảng.",
    26671: "Chi tiết - Phần chính cho tất cả các chi tiết kinh doanh của Google.",
    26681: "Thuộc tính - Tối ưu hóa việc gán các thuộc tính trên các danh sách GBP",
    26691: "Tạo danh sách - Xây dựng danh sách GBP mới Tất cả các nội dung quan trọng",
    26701: "Facebook - Kiểm soát tất cả các chi tiết Facebook từ một bảng tính duy nhất",
    26711: "Lịch sử - Nhật ký chỉnh sửa tệp và cập nhật.",
    26721: "Phần chính thức vẫn còn trong trạng thái beta khi chúng tôi tiếp tục tinh chỉnh các điều khiển cho các tài khoản và bao gồm các nền tảng bổ sung.",
    26731: "Bài viết lên lịch",
    26741: "Tạo số lượng lớn và lên lịch cho các bài đăng của Google trên các địa điểm và tài khoản.",
    26751: "Chia sẻ cập nhật quan trọng và thông điệp quảng cáo",
    26761: "Tải xuống mẫu để tạo bài viết của Google cho tất cả các vị trí đủ điều kiện.",
    26771: "Lịch trình thời gian cho toàn bộ tệp hoặc đặt từng bài đăng để bắt đầu vào một ngày và thời gian độc đáo",
    26781: "Lập kế hoạch toàn bộ lịch quảng cáo",
    26791: "Báo cáo thông tin chi tiết",
    26801: "Xem Google Post Lượt xem và nhấp vào hiệu suất theo thời gian - Bộ lọc báo cáo theo loại, phương tiện và gọi để hành động.",
    26811: "Xác định xu hướng hiệu suất để tối ưu hóa quảng cáo miễn phí",
    26821: "Biểu đồ thanh đại diện cho hiệu suất theo thời gian, đặt phạm vi ngày và biểu đồ chi tiết.",
    26831: "Xem khối lượng bài viết bằng phương tiện, chủ đề và gọi đến loại hành động.",
    26841: "Xem mỗi bài viết Số liệu hiệu suất riêng lẻ.",
    26851: "Tải về Báo cáo cho phép phân tích thêm qua chiến dịch.",
    26861: "Cài đặt",
    26871: "Phần quản trị của nền tảng cho tất cả các cài đặt, vai trò, quyền người dùng, báo cáo Lập lịch và tải xuống dữ liệu",
    26881: "Kiểm soát cấp doanh nghiệp để thiết lập trải nghiệm tùy chỉnh cho tất cả người dùng.",
    26891: "Phần quản trị chính",
    26901: "Cho phép kết nối với các nền tảng (Google, Facebook, TrustPilot, đặt phòng).",
    26911: "Đặt tích hợp các nguồn đánh giá có sẵn.",
    26921: "Quản lý / tạo vai trò người dùng khác biệt.",
    26931: "Chỉ định / kiểm soát truy cập cá nhân.",
    26941: "Lịch trình báo cáo theo loại, người dùng và thậm chí vị trí.",
    26951: "Tải xuống các bộ dữ liệu từ nền tảng, truy cập 10 yêu cầu gần đây nhất.",
    26961: "Ủy quyền tài khoản",
    26971: "Kiểm toán Google.",
    26981: "Tích hợp",
    26991: "Vai trò quản lý",
    27001: "Quản lý người dùng",
    27011: "Xem lại cài đặt",
    27021: "Builder Campagin",
    27031: "Quản lý báo cáo",
    27041: "Tải dữ liệu",
    27051: "Chi tiết hồ sơ",
    27061: "Điều hướng tùy chỉnh",
    27071: "Xem xét sự rõ ràng.",
    27081: "Yêu cầu địa điểm",
    27091: "Nguồn ủy quyền",
    27101: "Cần thiết để truy cập dữ liệu đầy đủ và phản hồi đánh giá trực tiếp.",
    27111: "Tùy chọn",
    27121: "Các kết nối được ủy quyền sẽ tiếp tục phát triển vì các nền tảng làm cho các kết nối API có sẵn.",
    27131: "Trực tiếp cho phép kết nối giữa các nền tảng và tài khoản người dùng để đạt được điều khiển được tạo có thể.",
    27141: "Tất cả các nguồn",
    27151: "Nguồn đánh giá được lập chỉ mục",
    27161: "Tổng hợp phản hồi từ hơn 40 nguồn trên các dọc công nghiệp",
    27171: "GHI CHÚ",
    27181: "Sử dụng Google lập chỉ mục để truy cập các đánh giá mà không kiểm soát danh sách GBP.",
    27191: "Tìm nguồn cung ứng được lập chỉ mục được sử dụng cho tất cả các bộ sưu tập đánh giá cạnh tranh.",
    27201: "Sau chỉ số ban đầu, đánh giá và phản hồi được thu thập hàng ngày",
    27211: "Lập chỉ mục công cộng hoặc tất cả các đánh giá và phản hồi lịch sử bằng URL hoặc PROIDIID",
    27221: "Tất cả các nguồn",
    27231: "Cấu hình.",
    27241: "Hôm qua",
    27251: "7 ngày qua",
    27261: "Tuần trước",
    27271: "30 ngày trước",
    27281: "Tháng trước",
    27291: "Tất cả thời gian",
    27301: "Tăng dần",
    27311: "Desc.",
    27321: "Không liên lạc cho CC",
    27331: "Lưu câu trả lời này?",
    27341: "Chọn hoặc tạo một nhóm",
    27351: "Không có trả lời đã lưu",
    27361: "Không tự động trả lời",
    27371: "Tổng số 0 mặt hàng",
    27381: "Tiết kiệm mẫu",
    27391: "Tổng cộng 26 mặt hàng",
    27401: "Gần đây được sử dụng",
    27411: "Smileys & People.",
    27421: "Có ý kiến",
    27431: "Miễn bình luận",
    27441: "Tất cả địa điểm",
    27451: "Đánh giá của tôi",
    27461: "Cập nhật Google",
    27471: "Thiếu nội dung",
    27481: "Mã cửa hàng",
    27491: "Danh mục bổ sung",
    27501: "Tìm kiếm địa điểm",
    27511: "Kiểm toán GBP.",
    27521: "Hoạt động số lượng lớn.",
    27531: "Chọn nhóm",
    27541: "20 / trang",
    27551: "Đồng bộ hóa",
    27561: "Đặt đối tượng.",
    27571: "Xong",
    27581: "Tên thẻ thực thể.",
    27591: "Phút",
    27601: "với & không có bình luận",
    27611: "Tỷ lệ",
    27621: "Phân tích góc phần tư",
    27631: "Tất cả các địa điểm dữ liệu",
    27641: "Tìm kiếm cao + chuyển đổi thấp",
    27651: "Tìm kiếm cao + chuyển đổi cao",
    27661: "Tìm kiếm thấp + Chuyển đổi thấp",
    27671: "Tìm kiếm thấp + chuyển đổi cao",
    27681: "Dữ liệu vị trí theo khu vực",
    27691: "Dữ liệu vị trí theo thành phố",
    27701: "Vị trí:",
    27711: "Tỷ lệ chuyển đổi:",
    27721: "Tìm kiếm:",
    27731: "Google Q & A",
    27741: "Google Qa.",
    27751: "Tải xuống Qa.",
    27761: "Bài viết trả lời",
    27771: "Đăng cái nhìn sâu sắc",
    27781: "Tải về CSV mẫu",
    27791: "CSV được điền trước",
    27801: "Quản lý danh mục đầu tư",
    27811: "Thêm danh mục đầu tư",
    27821: "Xem danh mục đầu tư",
    27831: "Xóa danh mục đầu tư",
    27841: "Người dùng",
    27851: "Quản lý hồ sơ",
    27861: "Xóa hồ sơ",
    27871: "Bạn có chắc chắn muốn xóa hồ sơ này?",
    27881: "Tài khoản",
    27891: "Chọn hồ sơ",
    27901: "Chọn hồ sơ.",
    27911: "Tài khoản danh mục đầu tư",
    27921: "Chi tiết danh mục đầu tư",
    27931: "Tên danh mục đầu tư.",
    27941: "Danh mục đầu tư Currrent.",
    27951: "Tải lên hình ảnh như một logo cho danh mục đầu tư",
    27961: "Thay đổi tên danh mục đầu tư.",
    27971: "Dùng thử miễn phí",
    27981: "Hiện hành",
    27991: "Hết hạn",
    28001: "Hủy bỏ",
    28011: "Hóa đơn",
    28021: "Kết nối",
    28031: "Số lượng tài khoản",
    28041: "Tổng số địa điểm",
    28051: "Vị trí tích cực",
    28061: "Nhận xét (30 ngày)",
    28071: "Tình trạng thanh toán",
    28081: "Tên hồ sơ",
    28091: "Nhập tên của danh mục đầu tư mới",
    28101: "Một danh mục đầu tư có thể quản lý số lượng lớn người dùng của họ trên các cấu hình khác nhau một cách dễ dàng",
    28111: "Tên của danh mục đầu tư mới",
    28121: "Tên danh mục đầu tư chỉ có thể có tối đa 20 ký tự",
    28131: "Danh mục đầu tư được tạo thành công!",
    28141: "Tổng hồ sơ.",
    28151: "Tổng số người dùng",
    28161: "Nhập email",
    28171: "Mời ai đó giúp bạn quản lý hồ sơ. Bạn có thể đặt quyền truy cập vào hồ sơ bằng cách chọn vai trò của họ.",
    28181: "Mời gọi",
    28191: "Hình ảnh danh mục đầu tư hiện tại",
    28201: "SENTIMENT.",
    28211: "Chờ đợi",
    28221: "Nhiều bộ lọc hơn",
    28231: "Xem lại Tag.",
    28241: "Bộ lọc đã lưu",
    28251: "Ít bộ lọc hơn",
    28261: "Không có văn bản",
    28271: "Trung bình",
    28281: "Mở rộng",
    28291: "Tải lên hình ảnh đơn",
    28301: "Chọn Loại hình ảnh",
    28311: "Lựa chọn đối tượng",
    28321: "Ảnh bìa",
    28331: "Ảnh đại diện.",
    28341: "Ảnh ngoại thất.",
    28351: "Ảnh nội thất",
    28361: "Ảnh sản phẩm",
    28371: "Ảnh làm việc",
    28381: "Logo ảnh.",
    28391: "Ảnh thức ăn và đồ uống",
    28401: "Menu Ảnh.",
    28411: "Hình ảnh khu vực chung",
    28421: "Phòng ảnh",
    28431: "Đội hình ảnh",
    28441: "Lượt xem",
    28451: "ảnh",
    28471: "Đóng",
    28481: "LOẠI BỎ",
    28491: "Đánh giá mới tag.",
    28511: "Không có gì để thể hiện trong phạm vi này!",
    28531: "Chọn tất cả",
    28541: "Tìm kiếm nguồn",
    28551: "Thẻ xem xét tìm kiếm",
    28561: "Vị trí tìm kiếm",
    28571: "Tìm kiếm mã cửa hàng",
    28581: "Nhóm tìm kiếm",
    28601: "Thẻ thực thể",
    28631: "Tìm kiếm các bộ lọc đã lưu",
    28641: "Không có lựa chọn!",
    28651: "Điều chỉnh chế độ xem văn bản đánh giá",
    28661: "Xem bài đánh giá trực tiếp trên",
    28671: "Trả lời trên nền tảng xem xét",
    28711: "Không có bài đánh giá nào",
    28731: "Trả lời Tên vị trí Không được thêm vào ở vị trí này",
    28741: "Chữ ký không được thêm vào ở vị trí này",
    28751: "Bạn có muốn tiếp tục tải về?",
    28771: "Đánh giá với trả lời nội bộ",
    28781: "Đánh giá với tự động trả lời",
    28791: "Đánh giá với trả lời bên ngoài",
    28801: "Xem bảng Kiến thức Google",
    28821: "Quản lý mới",
    28831: "Kích hoạt CC.",
    28851: "Xóa trả lời",
    28871: "Trộn",
    28881: "Ngôi sao.",
    28891: "Tiêu cực, hỗn hợp, tích cực",
    28931: "Lưu một câu trả lời",
    28941: "Chỉnh sửa tên tài khoản.",
    28951: "Thay đổi tên tài khoản.",
    28961: "Tên tài khoản",
    28971: "Địa điểm Facebook",
    28981: "Thêm trang",
    28991: "Kích hoạt.",
    29001: "Hiển thị vị trí ẩn",
    29011: "Xem trang fb",
    29021: "Không có tài khoản ẩn để hiển thị",
    29031: "Nhiều giờ trước",
    29041: "Lời mời",
    29051: "Xem lại showcase.",
    29061: "Địa điểm Google",
    29071: "Địa điểm của bạn",
    29081: "Địa điểm URL.",
    29091: "Bạn có chắc chắn muốn xóa URL này?",
    29101: "Bạn có muốn xóa URL và dữ liệu liên quan của nó từ ứng dụng không?",
    29111: "Địa điểm đối thủ cạnh tranh",
    29121: "Tên đối thủ cạnh tranh.",
    29131: "Địa điểm ID.",
    29141: "Comptag.",
    29151: "Nhập URL vị trí và chi tiết đối thủ cạnh tranh",
    29161: "Iscompetitor.",
    29171: "Đặt chỗ",
    29181: "Để bắt đầu tích hợp đánh giá đặt phòng",
    29191: "ID vị trí văn phòng trở lại (tùy chọn)",
    29201: "Vui lòng điền vào địa điểm của bạn hoặc chi tiết đối thủ cạnh tranh. Cho 20 địa điểm trở lên,\r\nVui lòng cung cấp danh sách từng vị trí dưới dạng tệp Excel để",
    29211: "Để tải xuống tệp mẫu nhấp vào",
    29221: "Xin lưu ý rằng có thể mất vài phút để hoàn thành tìm nạp ban đầu",
    29231: "Vui lòng cung cấp một danh sách của mỗi",
    29241: "URL vị trí cho các doanh nghiệp để",
    29251: "Bạn có thể đặt chúng trực tiếp vào email hoặc cung cấp Excel của danh sách Google Sheet",
    29261: "Vui lòng điền URL vị trí của bạn và ID vị trí Office Back tùy chọn (để hỗ trợ liên kết sâu để phản hồi đánh giá) hoặc",
    29271: "Chi tiết đối thủ cạnh tranh.",
    29281: "Tài khoản lớn (20 địa điểm) có thể cung cấp danh sách từng vị trí dưới dạng tệp Excel để",
    29291: "Tạo các chiến dịch để đáp ứng trực tiếp các đánh giá với phản ứng hoàn hảo vào thời điểm hoàn hảo",
    29301: "Bạn có chắc chắn muốn xóa chiến dịch này?",
    29311: "Sao chép đánh giá thông minh cho mỗi Trình quản lý vị trí được chỉ định",
    29321: "CC trả lời các nhà quản lý vị trí được chỉ định",
    29331: "CC trả lời cho công ty",
    29341: "Người nhận",
    29351: "Tất cả người nhận",
    29361: "Chọn Đánh giá Nguồn",
    29371: "Chỉ PUB / SUN",
    29381: "Chọn xếp hạng sao",
    29391: "Chọn Đánh giá nội dung",
    29401: "Nhóm tùy chỉnh",
    29411: "Đặt độ trễ trước khi gửi tự động trả lời",
    29421: "Đặt giờ hoạt động",
    29431: "Không bắt buộc",
    29441: "Không có địa điểm được giao",
    29451: "Không có cái nhìn sâu sắc tìm thấy cho phạm vi và tiêu chí ngày đã chọn.",
    29461: "Menu lọc",
    29471: "Loại",
    29481: "Quan điểm trong tìm kiếm.",
    29491: "Lượt xem trong Bản đồ",
    29501: "Bạn không có đủ quyền để gửi một câu trả lời.",
    29511: "Đã gửi",
    29521: "Tải lên AR Mẫu",
    29531: "Số người theo dõi",
    29541: "Đồng bộ hóa cuối cùng",
    29551: "CÔNG TY.",
    29561: "Hang",
    29571: "Localpost đã bật",
    29581: "Không xác minh chờ xử lý",
    29591: "Nhấn vào đây để xem đánh giá này trong Hộp thư đến",
    29601: "Đọc thêm",
    29611: "Đang tải",
    29621: "Tổng số (số)",
    29631: "Google My Doanh nghiệp đã được xác minh",
    29641: "Đánh dấu như",
    29651: "Thêm giờ",
    29661: "Hôm nay",
    29671: "Địa chỉ đường phố",
    29681: "Mã bưu điện",
    29691: "Xác định là sở hữu màu đen",
    29701: "Thêm URL",
    29711: "Bài đăng",
    29721: "địa chỉ email liên lạc",
    29731: "Covid_19 CẬP NHẬT",
    29741: "Thay đổi doanh nghiệp của bạn?",
    29751: "Chiến dịch",
    29761: "Đặt hàng trực tuyến",
    29771: "Mua",
    29781: "Gọi ngay bây giờ",
    29791: "Bây giờ",
    29801: "Đồng bộ vị trí này?",
    29811: "Danh sách Facebook",
    29821: "Tạo danh sách Facebook mới",
    29831: "Đã chọn",
    29841: "Chi tiết kinh doanh",
    29851: "Liên lạc",
    29861: "Biến",
    29871: "ID nội bộ",
    29881: "Nhấn vào đây để kết nối",
    29891: "Quay lại để tải lên",
    29901: "Xem Q & A trên Google",
    29911: "Yêu cầu",
    29921: "Vô hiệu",
    29931: "Xem lại Xác nhận chặt chẽ",
    29941: "Xem lại xác nhận trả lời",
    29951: "Xem xét xác nhận loại bỏ",
    29961: "Khu vực",
    29981: "Quản lý",
    29991: "Create Google Post",
    30001: "Tạo Google Post.",
    30011: "Quản lý Google Post.",
    30021: "Ẩn vị trí",
    30031: "Chọn trang hiện tại",
    30041: "Tạo Facebook Post.",
    30051: "Quet sạch tât cả",
    30061: "Lưu bộ lọc.",
    30071: "Vai trò tìm kiếm",
    30081: "Tìm kiếm người dùng",
    30091: "Tất cả các biên tập viên",
    30101: "Chỉ định đánh giá (bắt buộc)",
    30111: "Nhập tên mẫu (bắt buộc)",
    30121: "Biến mẫu tùy chỉnh (tùy chọn)",
    30131: "Chọn hoặc tạo chủ đề (tùy chọn)",
    30141: "Gán cho một vị trí duy nhất (tùy chọn)",
    30151: "Gán cho thẻ Entity (tùy chọn)",
    30161: "Xem lại các biến",
    30171: "Tên của người đánh giá",
    30181: "Người đánh giá tên đầy đủ",
    30191: "Vị trí biến",
    30201: "Trả lời Tên vị trí",
    30211: "Tên vị trí địa lý",
    30221: "Trả lời đánh giá này đã được gửi.",
    30231: "Trả lời cho đánh giá này không thể được gửi nữa. Bạn có thể xóa câu trả lời này để xóa nó khỏi đây.",
    30241: "Bạn có muốn đồng bộ hóa dữ liệu của vị trí này? Điều này sẽ kéo tất cả các bản cập nhật được thực hiện cho vị trí.",
    30251: "Hãy để khách hàng biết về bất kỳ thay đổi nào đối với doanh nghiệp của bạn do Covid-19",
    30261: "Gửi ngay bây giờ",
    30271: "Tìm kiếm Showcase.",
    30281: "Sử dụng các điều khiển bên phải để xây dựng giới thiệu đánh giá chính xác. Nhấp vào nút 'Áp dụng' để tải xem trước tức thì",
    30291: "Xây dựng showcase đánh giá của bạn",
    30301: "Giới thiệu chi tiết",
    30311: "Đặt tên cho showcase này",
    30321: "Vị trí cá nhân",
    30331: "Vị trí nhóm",
    30341: "Trưng bày tiêu đề",
    30351: "Ẩn giấu",
    30361: "Người phản biện Hình ảnh / Avatar",
    30371: "Chỉ",
    30381: "Chọn Đánh giá Set.",
    30391: "Xem lại nguồn.",
    30401: "Nhận xét từ",
    30411: "Tạo Showcase.",
    30421: "Đánh giá tối thiểu",
    30431: "Chỉ đánh giá đánh giá",
    30441: "Xác định bản trình bày",
    30451: "Đếm tối đa",
    30461: "Bình luận tối đa chiều dài.",
    30471: "Đánh giá tối đa trên mỗi trang",
    30481: "Bố trí đáp ứng",
    30491: "Thứ tự sắp xếp",
    30501: "Mới nhất trước",
    30511: "Xếp hạng sao màu sắc",
    30521: "Xem lại ý kiến",
    30531: "LOGO NGUỒN",
    30541: "Đánh giá ngày",
    30551: "Ngày chính xác",
    30561: "Font Family.",
    30571: "Showcase kích thước tiêu đề",
    30581: "Người đánh giá Tên kích thước.",
    30591: "Bình luận size.",
    30601: "Đặt ghi đè.",
    30611: "Ghim đầu trang",
    30621: "Loại trừ",
    30631: "Đánh giá của tôi",
    30641: "Cần hỗ trợ",
    30651: "Đang chờ khách hàng",
    30661: "Đang chờ phản hồi",
    30671: "Phản hồi mới",
    30681: "Tim kiêm tên",
    30691: "Không được chỉ định",
    30701: "Cập nhật thành công",
    30711: "Tên nội dung chiến dịch (tùy chọn)",
    30721: "Điều khoản và điều kiện (tùy chọn)",
    30731: "Bạn có chắc chắn muốn xóa người dùng này? Sau khi xóa, người dùng sẽ không còn có quyền truy cập vào hồ sơ này, trừ khi được mời.",
    30741: "Bạn có muốn xóa người dùng này?",
    30751: "Phân phối phản hồi",
    30761: "Chúng tôi sẽ gửi email () với một liên kết để tải xuống CSV đánh giá.",
    30771: "Hồ sơ này có nhiều hơn 100 địa điểm. Chúng tôi sẽ gửi cho bạn một email với liên kết tải xuống",
    30781: "Người dùng trả lời",
    30791: "Đánh dấu trả lời",
    30801: "Đích trả lời",
    30811: "Bảng Điều khiển Đánh giá ",
    30812: "Tổng quan",
    30813: "Trung bình",
    30814: "Đánh giá TRUNG BÌNH",
    30815: "Vị trí",
    30816: "Hạnh phúc",
    30817: "Tỉ lệ Từ",
    30818: "Tỷ lệ Phản hồi",
    30819: "Đánh giá theo Nguồn",
    30820: "Đánh giá theo Xếp hạng",
    30821: "Phản hồi theo Xếp hạng",
    30822: "Đánh giá Gần đây",
    30823: "Bạn đã nhận được {x} đánh giá trong {x} ngày qua. Đây là những cái gần đây nhất",
    30824: "Số lượng đánh giá trung bình cho mỗi vị trí mẹ trong khoảng thời gian",
    30825: "Phần trăm đánh giá có xếp hạng 4 sao và 5 sao",
    30826: "Điểm Hạnh phúc là một biểu trình của tỷ lệ phần trăm đánh giá tích cực trừ tỷ lệ phần trăm đánh giá tiêu cực",
    30827: "Phần trăm tất cả các bình luận được tìm thấy trong đánh giá 5 sao và 4 sao so với tất cả các từ được chia sẻ trong khoảng thời gian. Phạm vi đi từ 5 sao đến 1 sao.",
    30828: "Tỷ lệ phần trăm các đánh giá trong khoảng thời gian đã nhận được phản hồi.",
    30829: "Giảm trong {x data} từ {xx} ngày trước",
    30830: "Tăng trong {x data} từ {xx} ngày trước",
    30831: "Không có thay đổi trong {x data} từ {xx} ngày trước",
    30832: "Nhấp để xem các đánh giá này",
    30833: "(tên vị trí) , (x) Sao, Người đánh giá: (x)",
    30834: "Đánh giá & Xếp hạng Trung bình",
    30835: "Số lượng đánh giá theo thời gian được xếp chồng theo xếp hạng sao + biểu đồ đường của xếp hạng trung bình.",
    30836: "Phần trăm theo Xếp hạng Sao",
    30837: "Số lượng đánh giá theo thời gian được xếp chồng theo xếp hạng sao dưới dạng phần trăm của tổng số.",
    30838: "Tổng Số Tích Lũy & Xếp Hạng Trung Bình",
    30839: "Tổng số đánh giá và xếp hạng trung bình cho khoảng thời gian của báo cáo.",
    30840: "Đánh giá theo Nguồn",
    30841: "Số lượng đánh giá trong khoảng thời gian theo nguồn.",
    30842: "Điểm Hạnh Phúc theo Thời Gian",
    30843: "Điểm Hạnh Phúc ròng cho mỗi giai đoạn thời gian trong phạm vi báo cáo.",
    30844: "Ngày trong Tuần",
    30845: "Ngày trong Tháng",
    30846: "Tháng trong Năm",
    30847: "Các Quốc Gia Hàng Đầu",
    30848: "Các Bang Hàng Đầu",
    30849: "Các Thành Phố Hàng Đầu",
    30850: "Phản hồi",
    30851: "Tỷ lệ Phản hồi Nhanh",
    30852: "Trung vị",
    30853: "Số lượng phản hồi được công bố trong khoảng thời gian và trung bình mỗi vị trí.",
    30854: "Phần trăm các đánh giá nhận được trả lời trong vòng 2 ngày và thời gian phản hồi trung vị.",
    30855: "Số Lượng & Tỷ Lệ Phản Hồi",
    30856: "Số lượng phản hồi theo xếp hạng sao và tỷ lệ phản hồi tổng thể.",
    30857: "Thời Gian Phản Hồi Trung Bình",
    30858: "Thời gian phản hồi trung bình tính bằng ngày.",
    30859: "Phân Phối Phản Hồi",
    30860: "Biểu đồ tần suất thời gian phản hồi đánh giá chia thành 10 bậc.",
    30861: "Hạnh phúc",
    30862: "Tỷ lệ",
    30863: "Thời Gian Sống",
    30864: "Số lượng bản ghi vị trí gốc, cộng với các bản ghi danh sách chưa được ánh xạ.",
    30865: "Năng lượng",
    30866: "Tỉ lệ Bình luận",
    30867: "Độ Dài Bình Luận",
    30868: "Khoảng Cách Tỷ Lệ",
    30869: "Khoảng Cách Chiều Dài",
    30870: "Đánh giá có và không có bình luận",
    30871: "Số từ trung bình trên mỗi xếp hạng sao",
    30872: "Phần trăm số từ trong mỗi xếp hạng sao",
    30873: "Phần trăm Tỷ lệ Bình luận",
    30874: "Phần trăm của tất cả các đánh giá bao gồm bình luận của khách hàng",
    30875: "Số từ trong bình luận",
    30876: "Số từ trung bình có trong các bài đánh giá có bình luận",
    30877: "Phân phối từ trong bình luận",
    30878: "Tỷ lệ phần trăm của từ trong mỗi xếp hạng sao cho mỗi khoảng thời gian",
    30879: "Phần trăm của các bài đánh giá tích cực có bình luận trừ đi phần trăm của các bài đánh giá tiêu cực.",
    30880: "Độ dài trung bình của các bài đánh giá tích cực trừ độ dài trung bình của các bài đánh giá tiêu cực.",
    30881: "Đánh giá với tỷ lệ phản hồi",
    30882: "Tỷ lệ chiều dài bình luận",
    30883: "Chế độ xem lưới",
    30884: "Vị trí trung bình",
    30885: "Điểm đánh giá trung bình của các địa điểm và phần trăm các địa điểm có xếp hạng trên 4.0 trong khoảng thời gian.",
    30886: "Lưới hiệu suất đánh giá",
    30887: "Trình bày điểm đánh giá trung bình của địa điểm so với khối lượng đánh giá để xác định các giá trị ngoại lệ",
    30888: "Cảm xúc",
    30889: "Ảnh hưởng",
    30890: "Bảng điều khiển hiệu suất",
    30891: "Lưới lãnh đạo",
    30892: "Tổng lượt xem",
    30893: "Tỷ lệ chuyển đổi",
    30894: "Tổng lượt xem và lượt xem trung bình theo địa điểm.",
    30895: "Xem bản đồ trên máy tính để bàn và thiết bị di động với sự phân tích theo tỷ lệ phần tră",
    30896: "Xem tìm kiếm cục bộ trên máy tính để bàn và thiết bị di động với sự phân tích theo tỷ lệ phần trăm.",
    30897: "Tổng số hành động với sự phân tích theo tỷ lệ phần trăm giữa các cuộc gọi, nhấp chuột vào trang web và chỉ đường lái xe.",
    30898: "Tổng tỷ lệ chuyển đổi hành động/lượt xem đối với cuộc gọi, nhấp chuột vào trang web và chỉ đường lái xe.",
    30899: "Lượt xem của khách hàng",
    30900: "Cách khách hàng xem và họ xem doanh nghiệp của bạn ở đâu.",
    30901: "Hành động của khách hàng",
    30902: "Các hành động có thể theo dõi từ danh sách Google của bạn.",
    30903: "Phần trăm số lần hiển thị danh sách doanh nghiệp dẫn đến một hành động",
    30904: "Hiệu quả theo Vị trí",
    30905: "Tổng lượt xem so với tỷ lệ chuyển đổi (hành động/lượt xem) để hiển thị hiệu quả của từng vị trí trong việc tạo lượt xem và chuyển đổi chúng thành hành động.",
    30906: "Hiệu quả theo Thành phố",
    30907: "Tổng lượt xem so với tỷ lệ chuyển đổi (hành động/lượt xem) cho mỗi thành phố.",
    30908: "Hiệu quả theo Nhóm",
    30909: "Tổng lượt xem so với tỷ lệ chuyển đổi (hành động/lượt xem) cho từng nhóm tùy chỉnh.",
    30910: "Lượt Xem Cao + Chuyển Đổi Thấp",
    30911: "Lượt Xem Cao + Chuyển Đổi Cao",
    30912: "Lượt Xem Thấp + Chuyển Đổi Thấp",
    30913: "Lượt Xem Thấp + Chuyển Đổi Cao",
    30914: "Di động",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "Trang web",
    30920: "Cuộc gọi",
    30921: "Điểm sức khỏe",
    30922: "Hiệu suất hàng ngày",
    30923: "Chọn các vị trí từ bảng và chỉ số (lượt xem hoặc hành động)",
    30924: "Tỷ lệ hạnh phúc",
    30925: "Tên/Thân thiện",
    30926: "{x} địa điểm có mức trung bình từ {y} sao trong {xx} ngày qua",
    30927: "Trên",
    30928: "Nhóm",
    30929: "Tất cả lượt xem",
    30930: "Tất cả hành động",
    30931: "Máy tính để bàn",
    30932: "Đã đạt giới hạn tối đa: Chọn tối đa 8 vị trí cho biểu đồ.",
    30933: "Người đánh giá",
    30934: "Cảm xúc tổng thể",
    30935: "Phân phối điểm cảm xúc trên {XX} chủ đề.",
    30936: "Cảm xúc theo Chủ đề",
    30937: "Tần suất chủ đề và các điểm cảm xúc tương ứng.",
    30938: "Rất tích cực",
    30939: "Rất tiêu cực",
    30940: "Quy tắc tự động hóa được kích hoạt cho đánh giá mới trên",
    30941: "Quy tắc tự động hóa được kích hoạt cho đánh giá cập nhật trên",
    30942: "đã phê duyệt phản hồi trên",
    30943: "gán một thẻ",
    30944: "gán bài đánh giá cho",
    30945: "tại",
    30946: "Đã gửi trả lời tự động",
    30947: "Chủ doanh nghiệp đã tạo một phản hồi bên ngoài mới trên",
    30948: "bởi quy tắc tự động hóa trên",
    30949: "bởi hệ thống trên",
    30950: "đã tạo mới",
    30951: "đã tạo một phản hồi mới trên",
    30952: "đã tạo một ghi chú đánh giá cho",
    30953: "đã xóa một ghi chú trên",
    30954: "đã xóa một ghi chú đánh giá trên",
    30955: "đã xóa phản hồi trên",
    30956: "đã chỉnh sửa phản hồi trên",
    30957: "từ",
    30958: "đã tạo một phản hồi tự động trên",
    30959: "địa phương",
    30960: "thông báo",
    30961: "đã thông báo",
    30962: "tổng quan",
    30963: "thực hiện",
    30964: "phản hồi",
    30965: "Phản hồi đã chuyển đến Hộp thư phê duyệt vào",
    30966: "Phản hồi đã chuyển đến Hộp thư đi và lên lịch đăng",
    30967: "Phản hồi đã được đăng lên",
    30968: "Đánh giá được giao cho",
    30969: "đánh giá vào",
    30970: "Đánh giá nhận từ",
    30971: "gửi một ghi chú tới",
    30972: "Hệ thống gán một thẻ ngôn ngữ",
    30973: "Hệ thống gán một phản hồi tự động vào",
    30974: "Thẻ",
    30975: "đội theo quy tắc tự động hóa vào",
    30976: "Dòng thời gian",
    30977: "đến",
    30978: "đã cập nhật một",
    30979: "đã cập nhật một ghi chú đánh giá vào",
    30980: "đã cập nhật xếp hạng đánh giá từ",
    30981: "đã cập nhật trạng thái đánh giá từ",
    30982: "đã cập nhật trạng thái đánh giá thành",
    30983: "đã cập nhật bình luận về",
    30984: "qua API trong",
    30985: "qua Pub-Sub vào",
    30986: "Không có bình luận nào được thêm vào.",
    30987: "trên",
    30988: "Hệ thống",
    30989: "bởi",
    30990: "Hủy phân công việc đánh giá từ",
    30991: "được giao cho",
    30992: "Thẻ được gán:",
    30993: "Nhóm thẻ được gán:",
    30994: "Đã xóa thẻ:",
    30995: "Đánh giá với cập nhật",
    30996: "Đánh giá không có cập nhật",
    30997: "Chọn tất cả các thẻ",
    30998: "Chọn chưa gắn thẻ",
    30999: "Đang chờ phê duyệt",
    31000: "Cũ nhất trước",
    31001: "Bạn không có ghi chú nào đã lưu",
    31002: "Trả lời trong hộp thư đi",
    31003: "Phiên bản đánh giá",
    31004: "Chi tiết đánh giá",
    31005: "Mở Thông Tin",
    31006: "Các Mối Quan Hệ",
    31007: "Lỗi",
    31008: "Chính",
    31009: "Danh Mục",
    31010: "Liên Kết Xã Hội",
    31011: "Hình ảnh gốc đã bị người dùng hoặc nền tảng gỡ bỏ."
  },
  thai: {
    2013: "สะสม",
    2028: "รีวิวทีม",
    2029: "อัตโนมัติ",
    2030: "เต็ม",
    2031: "ตัวกรองเพิ่มเติม",
    2032: "ค้นหาผู้ใช้",
    2033: "ส่งอีเมล",
    2034: "แต่งเพลง",
    2035: "AI ตอบกลับ",
    2036: "โพสต์ตอบกลับ",
    2037: "สร้างใหม่",
    2038: "การอนุมัติ",
    2039: "โพสต์บนแหล่งที่มา",
    2040: "ส่งการตอบกลับแล้ว",
    2041: "ไม่มีข้อความที่ส่ง",
    2042: "ชัดเจน",
    2043: "ปิด",
    2044: "ไม่พบข้อความตอบกลับ",
    2045: "คัดลอกคำตอบและไปที่แหล่งที่มา",
    2046: "แก้ไขคำตอบ",
    2047: "อนุมัติการตอบกลับ",
    2048: "อัปเดตการตอบกลับ",
    2049: "ลบการตอบกลับ",
    2050: "คุณแน่ใจหรือไม่ว่าต้องการลบการตอบกลับนี้",
    2051: "คุณแน่ใจหรือไม่ว่าต้องการส่งคำตอบนี้",
    2052: "คุณต้องการคืนสถานะการตรวจสอบนี้หรือไม่",
    2053: "คุณแน่ใจไหม ?",
    2054: "คุณแน่ใจหรือไม่ว่าต้องการอนุมัติคำตอบนี้",
    2055: "ทีม",
    2056: "ให้คะแนนเท่านัน",
    2057: "คะแนน + ความคิดเห็นสันๆ",
    2058: "คะแนน + ความคิดเห็น",
    2059: "ตรวจสอบตามภาษา",
    2060: "โปรดระบุความ ยาวความคิดเห็นระหว่าง 1 ถึง 100 ค่าเริม ต ้นคือ 20 ตัวอักษร",
    2061: "คัดลอกการตอบกลับรีววิ อัจฉริยะไปยังผู ้จัดการสถานทีทไี่ ด ้รับมอบหมายแต่ละคน",
    2062: "เข้าสู่ระบบ",
    2063: "ที่อยู่อีเมล",
    2064: "ไม่มีบัญชี?",
    2065: "ชื่อจริง",
    2066: "นามสกุล",
    2067: "บริษัท",
    2068: "ชื่อ บริษัท",
    2069: "มีบัญชีอยู่แล้ว?",
    2070: "แสดงรหัสผ่าน",
    2071: "ซ่อนรหัสผ่าน",
    2072: "การเปลี่ยนใจเลื่อมใสในท้องถิ่น",
    2073: "แผนที่ มือถือ",
    2074: "แผนที่ เดสก์ท็อป",
    2075: "ค้นหา มือถือ",
    2076: "ค้นหา เดสก์ท็อป",
    2077: "มุมมองค้นหา",
    2078: "มุมมองแผนที่",
    2081: "สากล (Sākon)",
    2091: "ตามหัวข้อ (Tām h̄ạw k̄hx)",
    10010: "1 ดาว",
    10013: "2 ดาว",
    10016: "3 ดาว",
    10019: "4 ดาว",
    10022: "5 ดาว",
    10025: "100-300 คำ",
    10120: "การกระทำ",
    10123: "เปิดใช้งาน",
    10124: "ใช้งานอยู่เสมอ",
    10126: "องค์กรที่ใช้งาน",
    10129: "เพิ่ม",
    10132: "เพิ่มปุ่ม",
    10135: "เพิ่มปุ่ม (อุปกรณ์เสริม)",
    10138: "เพิ่มบัญชี",
    10141: "เพิ่มโทรศัพท์เพิ่มเติม",
    10144: "เพิ่มบัญชี",
    10147: "เพิ่มหมวดหมู่อื่น",
    10150: "เพิ่มฉลากอื่น",
    10153: "เพิ่มแอตทริบิวต์",
    10156: "เพิ่มบรรทัด",
    10159: "เพิ่มวันที่ใหม่",
    10162: "เพิ่มแท็กรีวิวใหม่",
    10165: "เพิ่มบทบาทใหม่",
    10168: "เพิ่มวันที่เปิด",
    10171: "เพิ่มโปรไฟล์",
    10174: "เพิ่มรายงาน",
    10177: "เพิ่มรายงาน",
    10180: "เพิ่มบทบาท",
    10181: "เพิ่มแท็กทบทวน",
    10183: "หมวดเพิ่มเติม",
    10186: "โทรศัพท์เพิ่มเติม",
    10189: "ที่อยู่",
    10192: "ผู้ดูแลระบบ",
    10195: "ผู้ดูแล",
    10198: "นามสกุลของ AdWords",
    10201: "โทรศัพท์นามสกุลของ AdWords",
    10204: "ทั้งหมด",
    10207: "บทวิจารณ์ทั้งหมด",
    10210: "ผู้ใช้ทุกคนที่กำหนดให้กับบทบาทนี้จะสามารถเข้าถึงคุณสมบัติต่อไปนี้",
    10213: "นำมาใช้",
    10216: "ส่งเพื่อขออนุมัติ",
    10219: "คุณแน่ใจหรือว่าต้องการรีเซ็ตรหัสผ่านของผู้ใช้นี้?",
    10222: "คุณแน่ใจไหม?",
    10225: "พื้นที่",
    10228: "พื้นที่",
    10231: "รายการแอตทริบิวต์",
    10234: "บัญชีอนุญาต",
    10237: "เฉลี่ย",
    10240: "ปริมาณเฉลี่ย",
    10243: "คะแนนเฉลี่ย",
    10244: "avg การจัดอันดับ",
    10246: "เฉลี่ยต่อสถานที่",
    10249: "รอการตอบสนอง",
    10320: "กลับ",
    10321: "กลับไปที่ผู้ดูแลระบบ",
    10323: "การเรียกเก็บเงิน",
    10326: "หนังสือ",
    10329: "โพสต์อัปโหลดจำนวนมาก",
    10332: "แท็กการอัพโหลดจำนวนมาก",
    10335: "อัปโหลดเป็นกลุ่ม TSV",
    10338: "ชื่อธุรกิจ",
    10520: "ปฏิทิน",
    10523: "ยกเลิก",
    10526: "ไม่สามารถอัปโหลดการทำแผนที่ตำแหน่งหลักได้!",
    10529: "หมวดหมู่",
    10532: "การเปลี่ยนแปลงบทบาท",
    10535: "ประวัติการอ้างอิง",
    10538: "เมือง",
    10541: "คลิกที่นี่",
    10544: "คลิกที่ผู้ใช้เพื่อกำหนดบทบาทนี้ให้เขา",
    10547: "ร่วม",
    10548: "ยืนยันรหัสผ่าน",
    10550: "สำเนา",
    10553: "คัดลอกและวาง",
    10556: "ไม่สามารถเปลี่ยนแปลงบทบาท!",
    10559: "ไม่สามารถอัปโหลดโพสต์",
    10562: "ประเทศ",
    10565: "ประเทศ",
    10568: "รหัสคูปอง",
    10571: "รหัสคูปอง (ไม่จำเป็น)",
    10574: "สร้างตัวกรองใหม่โดยเลือกตัวเลือกด้านล่าง",
    10577: "สร้างตัวกรองใหม่",
    10580: "สร้างรายงานใหม่",
    10583: "สร้างโพสต์",
    10586: "สร้างแท็ก",
    10589: "สร้างรายงานนี้",
    10592: "สร้างบทบาทนี้",
    10595: "สร้างโดย",
    10598: "การกระทำของลูกค้า",
    10720: "D, จดหมายตัวย่อสำหรับวัน",
    10723: "แผงควบคุม",
    10726: "วันที่",
    10729: "ช่วงวันที่",
    10732: "วัน",
    10735: "ปิดการใช้งาน",
    10738: "ค่าเริ่มต้น",
    10741: "ล่าช้าก่อนโพสต์",
    10744: "ล่าช้าส่งคำตอบโดย",
    10747: "ล่าช้าส่งคำตอบโดย",
    10750: "ลบ",
    10753: "ลบ ?",
    10754: "ลบโปรไฟล์",
    10756: "สืบทอด",
    10759: "คำอธิบาย",
    10762: "โดยตรง",
    10765: "แบบสอบถามโดยตรง",
    10768: "ทิศทาง",
    10771: "การค้นพบ",
    10774: "มุมมองที่แตกต่าง",
    10777: "ดาวน์โหลดข้อมูลทั้งหมดเป็น CSV",
    10780: "ดาวน์โหลดเป็น PDF",
    10783: "ดาวน์โหลดรายละเอียดตำแหน่งของ Google",
    10786: "ดาวน์โหลดข้อมูลนี้เป็น CSV",
    10789: "ร่าง",
    10792: "เส้นทางการขับรถ",
    10795: "เส้นทางขับรถตามวัน",
    10920: "แก้ไข",
    10923: "แก้ไขโปรไฟล์ (s)",
    10926: "แก้ไขรายงาน",
    10929: "แก้ไขรายงานนี้",
    10932: "บรรณาธิการ",
    10935: "อีเมล",
    10938: "เวลาสิ้นสุด",
    10941: "ป้อนส่วนขยายตำแหน่ง AdWords",
    10944: "ป้อนชื่อแท็กเอนทิตี",
    10947: "ป้อนป้ายกำกับ",
    10950: "ป้อนข้อความค้นหา",
    10953: "ป้อนชื่อแท็ก",
    10956: "เท่ากับ",
    10959: "เหตุการณ์",
    10962: "รายละเอียดกิจกรรม",
    10965: "ชื่อเหตุการณ์",
    10968: "ทั้งหมด",
    10971: "example.com",
    10974: "ตัวอย่าง: ส่วนลด 20% ในร้านค้าหรือออนไลน์",
    11120: "การจัดการการเข้าถึง",
    11123: "ตัวกรอง",
    11126: "ลืมรหัสผ่าน?",
    11129: "วันศุกร์",
    11320: "รับข้อเสนอ",
    11323: "มากกว่า",
    11520: "คะแนนความสุข",
    11525: "ช่วย",
    11530: "ฮาวเฟีย",
    11535: "ชั่วโมง",
    11540: "ชั่วโมง",
    11545: "ลูกค้าค้นหาธุรกิจของคุณอย่างไร",
    11720: "ภาพ",
    11723: "URL รูปภาพ",
    11726: "ในแผนที่",
    11729: "ในการค้นหา",
    11732: "กล่องจดหมาย",
    11735: "แบบสอบถามทางอ้อม",
    11738: "ข้อมูลเชิงลึก",
    11741: "การอนุญาตไม่เพียงพอ",
    11744: "การรวมกัน",
    11747: "การบูรณาการ",
    11750: "เชิญผู้ใช้",
    11753: "ที่ได้รับเชิญ",
    11756: "เชิญโดย",
    11759: "รายการ",
    12120: "แผงความรู้",
    12320: "ฉลาก",
    12323: "เข้าสู่ระบบครั้งล่าสุด",
    12326: "อัปเดตล่าสุด",
    12329: "เรียนรู้เพิ่มเติม",
    12332: "น้อยกว่า",
    12335: "ลิงก์สำหรับปุ่มของคุณ",
    12338: "ลิงก์ไปยังการแลกข้อเสนอ",
    12341: "ลิงก์ไปยังการแลกข้อเสนอ (ไม่บังคับ)",
    12344: "ลิงค์สำหรับรีวิวนี้",
    12347: "การจัดการรายชื่อ",
    12350: "ประสิทธิภาพในท้องถิ่น",
    12353: "ภาพรวมประสิทธิภาพท้องถิ่น",
    12356: "การแปลงการค้นหาในท้องถิ่น",
    12359: "เมือง",
    12362: "สถานที่ตั้ง",
    12365: "ที่ตั้ง",
    12368: "รายละเอียดสถานที่",
    12371: "รหัสตำแหน่ง",
    12374: "ตำแหน่ง",
    12377: "เข้าสู่ระบบ",
    12380: "ออกจากระบบ",
    12520: "m, ชื่อย่อสำหรับเดือน",
    12523: "ทำให้โพสต์ของคุณโดดเด่น���้วยภาพถ่าย",
    12526: "จัดการกิจกรรมจำนวนมาก",
    12529: "จัดการแท็กเอนทิตี",
    12532: "จัดการที่ตั้ง",
    12535: "จัดการโปรไฟล์",
    12538: "จัดการบทบาท",
    12541: "จัดการผู้ใช้",
    12544: "แผนที่",
    12547: "ผู้ค้านับ",
    12550: "ภาพถ่ายพ่อค้า",
    12553: "ผู้ค้า, ปริมาณภาพถ่าย vs มุมมองภาพถ่าย",
    12556: "ข้อความ",
    12559: "นาที",
    12562: "วันจันทร์",
    12565: "เดือน",
    12720: "ชื่อ",
    12723: "ชื่อของบทบาทใหม่",
    12726: "ชื่อรายงาน",
    12729: "ต้องการบัญชี?",
    12732: "ใหม่",
    12735: "หน้าต่อไป",
    12738: "ไม่มีคำตอบ",
    12741: "ไม่พบผลลัพธ์",
    12744: "ไม่มีแท็กรีวิว",
    12747: "ไม่มีรีวิว",
    12750: "ไม่ยกเลิก",
    12753: "จำนวนผู้ใช้",
    12756: "หมายเหตุ",
    12920: "ของ",
    12923: "เสนอ",
    12926: "ตกลง",
    12929: "ตกลงเข้าใจแล้ว!",
    12932: "ครั้งหนึ่ง",
    12935: "วันเปิด",
    12938: "คำสั่ง",
    12941: "องค์กร",
    12944: "กล่องด้านนอก",
    12947: "เจ้าของ",
    13120: "หน้าหนังสือ",
    13123: "รหัสผ่าน",
    13126: "วาง tsv",
    13129: "ประเภท PDF",
    13132: "โทรศัพท์",
    13135: "โทรศัพท์ในแต่ละวัน",
    13138: "หมายเลขโทรศัพท์",
    13141: "ปริมาณภาพถ่าย",
    13144: "มุมมองภาพถ่าย",
    13147: "กรุณากรอกชื่อ recepient!",
    13150: "กรุณากรอกชื่อรายงาน!",
    13153: "โปรดป้อนบทสรุป!",
    13156: "โปรดป้อนชื่อเรื่อง!",
    13159: "โปรดป้อนเวลาที่ถูกต้อง!",
    13162: "โปรดป้อน URL ที่ถูกต้อง!",
    13165: "กรุณารีเฟรชหน้าเพื่ออัปเดตรายละเอียดตำแหน่งของคุณ",
    13168: "โปรดโหลดซ้ำ",
    13171: "โปรดเลือกประเภทกำหนดการ!",
    13174: "โพสต์ประวัติศาสตร์",
    13177: "โพสต์",
    13180: "หน้าก่อนหน้า",
    13183: "หมวดหมู่หลัก",
    13186: "โทรศัพท์หลัก",
    13189: "หมายเลขโทรศัพท์หลัก",
    13192: "โปรไฟล์",
    13195: "จำนวนสาธารณะ",
    13198: "ภาพถ่ายสาธารณะ",
    13201: "ภาพถ่ายสาธารณะ",
    13204: "เผยแพร่",
    13520: "การให้คะแนน",
    13523: "การแจ้งเตือนแบบเรียลไทม์",
    13526: "รายชื่อผู้รับ",
    13529: "ที่ประจำ",
    13532: "ลบผู้ใช้",
    13535: "ตอบกลับ",
    13538: "ตอบกลับการอนุมัติ",
    13541: "การจัดการรายงาน",
    13544: "ชื่อรายงาน",
    13547: "ประเภทรายงาน",
    13550: "รีเซ็ตรหัสผ่าน",
    13553: "การตอบสนองโดยการจัดอันดับดาว",
    13556: "ตรวจสอบจำนวน",
    13559: "รีวิวดาวน์โหลด",
    13562: "ตรวจสอบการตั้งค่า",
    13565: "ทบทวนแหล่งที่มา",
    13568: "แท็กตรวจสอบ",
    13571: "ReviewsLink",
    13574: "ความคิดเห็น",
    13577: "บทวิจารณ์โดยการจัดอันดับดาว",
    13580: "บทวิจารณ์เทียบกับคะแนนเฉลี่ย",
    13583: "บทวิจารณ์กล่องจดหมาย",
    13586: "การจัดการความคิดเห็น",
    13589: "บทวิจารณ์วันของเดือน",
    13592: "บทวิจารณ์วันของสัปดาห์",
    13595: "บทวิจารณ์เดือนของปี",
    13598: "บทบาท",
    13601: "รายละเอียดบทบาท",
    13604: "ชื่อบทบาท",
    13720: "วันเสาร์",
    13723: "บันทึก",
    13726: "บันทึกเป็นตัวกรองที่กำหนดเอง",
    13729: "บันทึกตัวกรองใหม่",
    13732: "บันทึกบทบาท",
    13735: "บันทึกคำตอบ",
    13738: "วันที่กำหนดเวลา",
    13741: "กำหนดการโพสต์",
    13742: "กำหนดเวลารายงาน",
    13744: "กำหนดเวลา",
    13747: "ประเภทกำหนดการ",
    13750: "ค้นหา",
    13753: "การสืบค้น",
    13756: "เลือก",
    13759: "เลือกตัวกรองที่มีอยู่",
    13762: "เลือกประเภท",
    13765: "เลือกเมือง",
    13768: "เลือกประเทศ",
    13771: "เลือกวันที่และเวลา",
    13774: "เลือกช่วงวันที่",
    13777: "เลือกบรรณาธิการเพื่อตรวจสอบ",
    13780: "เลือกแท็กเอนทิตี",
    13783: "เลือกตัวกรอง",
    13786: "เลือกตัวกรอง",
    13789: "เลือก granularity",
    13792: "เลือกองค์กร",
    13795: "เลือกแท็กตรวจสอบ",
    13798: "เลือกตัวกรองที่บันทึกไว้",
    13801: "เลือกแหล่งที่มา",
    13804: "เลือกรัฐ",
    13807: "เลือกเวลา",
    13810: "ตัวเอง",
    13813: "ส่งเพื่อขออนุมัติ",
    13816: "ส่งไปที่ Outbox",
    13819: "ส่งแล้ว",
    13822: "บริการ",
    13825: "การตั้งค่า",
    13828: "การจัดการการตั้งค่า",
    13831: "ร้านค้า",
    13834: "แสดงกระทู้",
    13837: "แสดง / ซ่อน NEV ซ้าย",
    13840: "ลงชื่อ",
    13843: "แก้ไขตำแหน่งเดียว",
    13846: "เสียใจ!",
    13849: "เรียงลำดับ",
    13852: "ชั่วโมงพิเศษ",
    13855: "การเข้าถึงเฉพาะ",
    13858: "มาตรฐาน",
    13861: "เวลาเริ่มต้น",
    13864: "สถานะ",
    13867: "สถานะ",
    13870: "เก็บ",
    13873: "รหัสร้านค้า",
    13876: "ถนน",
    13879: "มุมมองสรุป",
    13882: "วันอาทิตย์",
    13885: "ซิงค์บัญชีนี้",
    13920: "โทรศัพท์",
    13923: "ข้อกำหนดและเงื่อนไข",
    13926: "วันพฤหัสบดี",
    13929: "เวลา",
    13932: "เมืองยอดนิยม",
    13935: "ทั้งหมด",
    13938: "วันอังคาร",
    14120: "ไม่ได้รับคำตอบ",
    14123: "ไม่แน่ใจในรูปแบบ?",
    14126: "ที่อัพโหลด",
    14129: "อัพโหลดรายละเอียดตำแหน่ง",
    14132: "อัปโหลดแผนที่ที่ตั้ง",
    14135: "อัปโหลดการทำแผนที่ตำแหน่ง",
    14138: "อัปโหลด TSV",
    14141: "url",
    14144: "ผู้ใช้",
    14320: "ดูภาพ",
    14323: "ดูประวัติ",
    14326: "มุมมอง",
    14520: "W, ตัวอักษรย่อสำหรับสัปดาห์",
    14523: "เว็บไซต์",
    14526: "เว็บไซต์ตามวัน",
    14529: "ชื่อเว็บไซต์",
    14532: "วันพุธ",
    14535: "สัปดาห์",
    14538: "ลูกค้าทำอะไรได้บ้าง",
    14541: "เมื่อตอบกลับการตรวจสอบ",
    14544: "ที่ลูกค้าดูธุรกิจของคุณ",
    14547: "คุณต้องการที่จะลบโพสต์ที่กำหนดไว้นี้หรือไม่?",
    14550: "เขียนชื่อของคุณ",
    14920: "ปี",
    14923: "ใช่ดำเนินการต่อ",
    14926: "คุณสามารถเลือกที่จะ จำกัด การเข้าถึงผู้ใช้ด้วยบทบาทนี้โดยเลือกตัวกรองที่จะแนบไปกับมัน",
    14929: "ชื่อของคุณ",
    15120: "ซิป",
    20010: "วันจันทร์",
    20011: "จันทร์",
    20020: "วันอังคาร",
    20021: "ตื้อ",
    20030: "วันพุธ",
    20031: "พุธ",
    20040: "วันพฤหัสบดี",
    20041: "ทู่",
    20050: "วันศุกร์",
    20051: "ศุกร์",
    20060: "วันเสาร์",
    20061: "นั่ง",
    20070: "วันอาทิตย์",
    20071: "ดวงอาทิตย์",
    20110: "มกราคม",
    20111: "ม.ค",
    20120: "กุมภาพันธ์",
    20121: "ก.พ.",
    20130: "มีนาคม",
    20131: "มีนาคม",
    20140: "เมษายน",
    20141: "เมษายน",
    20150: "อาจ",
    20151: "อาจ",
    20160: "มิถุนายน",
    20161: "จุน",
    20170: "กรกฎาคม",
    20171: "ก.",
    20180: "สิงหาคม",
    20181: "ส.ค.",
    20190: "กันยายน",
    20191: "ก.ย.",
    20200: "ตุลาคม",
    20201: "ตุลาคม",
    20210: "พฤศจิกายน",
    20211: "พ.ย.",
    20220: "ธันวาคม",
    20221: "ธรณี",
    20231: "ความคิดเห็นและการให้คะแนน",
    20241: "เปอร์เซ็นต์",
    20251: "ตรวจสอบกับเปอร์เซ็นต์",
    20261: "สะสม",
    20271: "จำนวนสะสม",
    20281: "แหล่งที่มา",
    20291: "ตรวจสอบโดยแหล่งที่มา",
    20301: "ความสุข",
    20311: "เวลาตอบสนอง",
    20321: "เลือกตำแหน่ง",
    20331: "ค้นหาตามคำวิจารณ์คำค้นหา",
    20341: "ค้นหาโดยผู้ตรวจสอบ",
    20351: "เลือก",
    20361: "เท่ากับ",
    20371: "น้อยกว่า",
    20381: "มากกว่า",
    20391: "เลือกเดือน",
    20401: "เลือกวันที่",
    20411: "คลิกเพื่อดูความคิดเห็นเหล่านี้",
    20421: "ไม่มีการตรวจสอบสำหรับช่วงวันที่ที่เลือกและเกณฑ์",
    20431: "ตัวกรองที่ชัดเจน",
    20441: "ลบตัวกรองที่กำหนดเอง",
    20451: "มีการอัปเดตของ Google",
    20461: "ตรวจสอบแล้ว",
    20471: "ที่ตั้งที่เผยแพร่",
    20481: "มีการแก้ไขที่รอดำเนินการ",
    20491: "แผงความรู้",
    20501: "ลิงค์รีวิว",
    20511: "ทิศทาง",
    20521: "ทำซ้ำ",
    20531: "คล่องแคล่ว",
    20541: "สามารถอัปเดต",
    20551: "สามารถลบ",
    20561: "ไม่มีการตรวจสอบที่รอดำเนินการ",
    20571: "เปิดใช้งานตำแหน่ง",
    20581: "ไม่ตัดการเชื่อมต่อ",
    20591: "เปลี่ยนบันทึก",
    20601: "รูปภาพอัพโหลดจำนวนมาก",
    20611: "ประวัติภาพ",
    20621: "อัปโหลดจำนวนมากหมายเหตุ",
    20631: "การอัพโหลดจำนวนมาก Q & A",
    20641: "ถาม & ตอบ",
    20651: "เพิ่มคำถาม",
    20661: "นำเสนอคำถามให้กับลูกค้าที่เน้นเรื่องค่านิยมหลักหรือความได้เปรียบในการแข่งขันที่แตกต่างกันของตำแหน่งของคุณ จากนั้นคุณสามารถตอบคำถาม",
    20671: "รายละเอียดแพลตฟอร์ม",
    20681: "ตัวแปรตอบกลับอัตโนมัติ",
    20691: "ชื่อสถานที่",
    20701: "ชื่อทางภูมิศาสตร์",
    20711: "ลายเซ็น",
    20721: "ชื่อ GEO (สูงสุด 80 ตัวอักษร)",
    20731: "ชื่อลายเซ็น (สูงสุด 80 ตัวอักษร)",
    20741: "ตอบกลับอัตโนมัติ",
    20751: "ดาวน์โหลดบทวิจารณ์",
    20761: "การตอบสนองอัตโนมัติ",
    20771: "การเชื่อมโยงภายนอก",
    20781: "คัดลอกรีวิว",
    20791: "เพิ่มหมายเหตุ",
    20801: "หมายเหตุภายนอก",
    20811: "ธงที่ไม่เหมาะสม",
    20821: "ทำเครื่องหมายว่าถูกลบ",
    20831: "คุณแน่ใจไหม ?",
    20841: "คุณต้องการทำเครื่องหมายรีวิวนี้เป็นลบออกจาก Google หรือไม่",
    20851: "แทรกคำตอบที่บันทึกไว้",
    20861: "บันทึกเป็นเทมเพลตตอบกลับ",
    20871: "แทรกเทมเพลตตอบกลับอัตโนมัติ",
    20881: "ส่ง",
    20891: "ส่งการอนุมัติ",
    20901: "บันทึกเป็นร่าง",
    20911: "กำหนดหมายเหตุ",
    20921: "อีเมลบันทึก",
    20931: "ผู้รับ",
    20941: "บันทึกเป็นบันทึกย่อ",
    20951: "ปิด I",
    20961: "ทิ้ง",
    20971: "ส่งอีเมล์",
    20981: "คุณไม่มีบันทึกที่บันทึกไว้ใด ๆ",
    20991: "ติดตามทั้งหมด!",
    21001: "ไม่มีรายการที่จะแสดง",
    21011: "ส่งคำตอบ",
    21021: "ผู้ตรวจสอบยังไม่ได้เพิ่มความคิดเห็นใด ๆ",
    21031: "แก้ไขตอบกลับ",
    21041: "ลบการตอบกลับ",
    21051: "ค้นหาการตอบกลับที่บันทึกไว้",
    21061: "เพิ่มการตอบกลับที่บันทึกไว้",
    21071: "เลือกกลุ่มและขึ้นอยู่กับการตอบกลับนี้",
    21081: "เลือกกลุ่มหรือเริ่มพิมพ์เพื่อสร้าง",
    21091: "ป้อนชื่อที่นี่",
    21101: "ป้อนเทมเพลตตอบกลับ",
    21111: "โปรดตรวจสอบให้แน่ใจว่าได้เลือก/สร้างกลุ่มและชื่อเรื่องเพื่อบันทึกการตอบกลับนี้",
    21121: "ตอบกลับอัตโนมัติ",
    21131: "เพิ่มการตอบกลับอัตโนมัติ",
    21141: "เลือกกลุ่ม",
    21151: "ป้อนตัวแปรที่นี่",
    21161: "เลือกตัวแปรของคุณ",
    21171: "คุณต้องการดำเนินการต่อหรือไม่?",
    21181: "คำขอนี้มีมากกว่า 100 รีวิวสำหรับคำขอดังกล่าวเราจะส่งอีเมลพร้อมลิงค์เพื่อดาวน์โหลดรีวิว CSV",
    21191: "คุณมีมากกว่า 100 รีวิว",
    21201: "เราจะส่งอีเมลถึงคุณ (ถึง x) ด้วยลิงก์เพื่อดาวน์โหลดรีวิว CSV",
    21211: "การกระทำ",
    21221: "สถานที่ทั้งหมด",
    21231: "avg Rating",
    21241: "ยี่ห้อ",
    21251: "โดยตรง",
    21261: "การค้นพบ",
    21271: "ภูมิศาสตร์",
    21281: "ความสุข",
    21291: "การสืบค้น",
    21301: "คำตอบ",
    21311: "มุมมอง",
    21321: "โพสต์ตาราง",
    21331: "ตารางการโพสต์ของ Google",
    21341: "สร้างโพสต์",
    21351: "จัดการโพสต์",
    21361: "กำหนดการ localpost",
    21371: "ที่อัพโหลด",
    21381: "ความคืบหน้า",
    21391: "ตรวจสอบและกำหนดเวลา",
    21401: "สถานะกำหนดการ",
    21411: "เลือกไฟล์",
    21421: "เลือกประเภทกำหนดการ",
    21431: "ทันที",
    21441: "เวลาไฟล์",
    21451: "เลือกเวลา",
    21461: "โพสต์ทันทีหลังจากการตรวจสอบ",
    21471: "กำหนดเวลาตามเวลาในไฟล์",
    21481: "กำหนดเวลาไฟล์ตามเวลาที่คุณเลือก",
    21491: "คิว",
    21501: "กำลังดำเนินการตรวจสอบความถูกต้อง เวลาในการประมวลผลประมาณ 40 โพสต์ต่อนาที หลังจากการตรวจสอบสถานะแต่ละโพสต์จะมีอยู่ในหน้าถัดไป",
    21511: "ประมวลผลการประมวลผล",
    21521: "การตรวจสอบที่ประสบความสำเร็จ",
    21531: "การตรวจสอบที่ล้มเหลว",
    21541: "ตามกำหนด",
    21551: "ประเภท / การกระทำ",
    21561: "วันที่",
    21571: "เริ่ม",
    21581: "จบ",
    21591: "ชื่อเรื่อง / ผลิตภัณฑ์",
    21601: "สรุปโพสต์",
    21611: "สถานะ",
    21621: "ความสำเร็จ",
    21631: "ล้มเหลว",
    21641: "แก้ไข / ลบ",
    21651: "โพสต์ข้อมูลเชิงลึก",
    21661: "Google Post Insights",
    21671: "ผลงาน",
    21681: "โพสต์มุมมอง",
    21691: "โพสต์โดยสื่อ",
    21701: "โพสต์ตามหัวข้อ",
    21711: "โพสต์โดยการกระทำ",
    21721: "การวิเคราะห์",
    21731: "สร้าง",
    21741: "พิมพ์",
    21751: "การกระทำ",
    21761: "ตัวกรองแหล่งที่มา",
    21771: "แพลตฟอร์ม",
    21781: "อัปเดตสถานะ LocalPost",
    21791: "ตัวสร้างแคมเปญ",
    21801: "การตอบสนองอัตโนมัติอัจฉริยะ",
    21811: "เปิดตัวสร้างแคมเปญตอบโต้อัตโนมัติ",
    21821: "ก่อนที่จะเปิดใช้งานตัวเลือกกำหนดการตอบกลับอัตโนมัติโปรดตรวจสอบให้แน่ใจว่าได้ทำตามคำแนะนำที่ระบุด้านล่าง:",
    21831: "ก่อนที่จะเปิดใช้งานการตอบสนองอัตโนมัติ inteligent ตรวจสอบให้แน่ใจว่าได้เพิ่มเทมเพลตการตอบกลับอัตโนมัติของคุณใน SIVELAIN BOX Section.Build Responses ก่อนเพื่อให้สามารถกำหนดให้กับการจัดอันดับดาว (1-5) ที่จะทำให้เกิดการตอบสนองอัตโนมัติ inteligent",
    21841: "ในการสร้างแคมเปญโปรดเลือกเวลาล่าช้าระหว่างการตรวจสอบใบเสร็จรับเงินและการส่งต่อการตอบกลับอัตโนมัติ การตั้งค่าความล่าช้าควรสอดคล้องกับเวลาตอบสนองการตรวจสอบในอุดมคติเนื่องจากมีวัตถุประสงค์เพื่อปกปิดลักษณะอัตโนมัติของโปรแกรม",
    21851: "โปรดพิจารณากำหนดเวลาการทำงาน (วันของสัปดาห์และชั่วโมงของวัน) สำหรับการรณรงค์ การตั้งค่าช่วงเวลาเริ่มต้นคือ GMT + 00: 00 ดังนั้นโปรดอัปเดตตามความเหมาะสม",
    21861: "สร้างแคมเปญ",
    21871: "กำหนดชื่อและบันทึกย่อใด ๆ เพื่อระบุแคมเปญของคุณได้อย่างง่ายดาย",
    21881: "ชื่อแคมเปญ",
    21891: "Responder แคมเปญ",
    21901: "หากเลือกไม่มีตัวเลือกอีเมลที่ใช้ในการลงทะเบียนและอนุมัติบัญชีจะเป็นผู้ตอบแบบสอบถามเริ่มต้น",
    21911: "ผู้ตอบสำหรับการตอบกลับอัตโนมัติ",
    21921: "ช่วงวันที่แคมเปญ",
    21931: "หมายเหตุ / เป้าหมาย",
    21941: "คำอธิบายแคมเปญ",
    21951: "ตั้งทริกเกอร์",
    21961: "เลือกประเภทของรีวิวที่จะแจ้งการตอบกลับอัตโนมัติสำหรับแคมเปญนี้",
    21971: "มีความคิดเห็น",
    21981: "ไม่มีความคิดเห็น",
    21991: "ก่อนหน้า",
    22001: "ต่อไป",
    22011: "ตั้งค่าผู้ชม (ไม่บังคับ)",
    22021: "ตั้งตำแหน่งที่จะเป็นส่วนหนึ่งของแคมเปญตามแท็กเอนทิตีองค์กรหรือประเทศเฉพาะ / พื้นที่ / ท้องถิ่น ตัวกรองนี้มีให้เฉพาะสำหรับความคิดเห็นของ Google และตำแหน่งที่แมปเท่านั้น",
    22031: "นิติบุคคล",
    22041: "องค์กร",
    22051: "กำหนดตารางเวลา",
    22061: "กำหนดพารามิเตอร์และกำหนดการสำหรับการตรวจสอบความคิดเห็น I.e. เปอร์เซ็นต์การตรวจสอบเป้าหมายและการดำเนินงานของการดำเนินงานสำหรับการตอบสนอง",
    22071: 'โปรดทราบว่าการตอบสนองอัตโนมัติมีอยู่ในขณะนี้อยู่ในพื้นฐาน "ไปข้างหน้า" เท่านั้น เรากำลังทำงานกับกระบวนการแยกต่างหากสำหรับผู้ใช้ที่อาจต้องการทำความสะอาดระยะสั้นโดยอัตโนมัติ',
    22081: "กำหนดอัตราการตอบกลับ",
    22091: "ตั้งค่าการตอบสนองการตั้งค่า",
    22101: "ล่าช้าก่อนส่งตอบกลับอัตโนมัติ",
    22111: "กำหนดเวลาเป็นระยะ",
    22121: "เลือกวันและกำหนดเวลาในการตอบสนองอัตโนมัติ Shedule เป็นระยะ",
    22131: "เลือกเขตเวลา",
    22141: "กำหนดคำตอบ",
    22151: "จากรายการเลือกคำตอบที่จะใช้ในการหมุนสำหรับแคมเปญนี้",
    22161: "ยืนยัน",
    22171: 'ตรวจสอบรายละเอียดแต่ละรายการด้านล่างและกด "ยืนยัน" เพื่อเปิดแคมเปญของคุณ',
    22181: "วัน",
    22191: "ดาว",
    22201: 'เฉลี่ย (เช่นใน "เฉลี่ย")',
    22211: "การรายงาน",
    22221: "การตั้งค่าคู่แข่ง",
    22231: "ปฏิบัติที่ดีที่สุด",
    22241: "จตุรัส",
    22251: "การให้คะแนน",
    22261: "การจัดอันดับการแข่งขัน",
    22271: 'ตอบสนอง (เช่นใน "การตอบสนอง")',
    22281: "ดูแหล่งทบทวน",
    22291: "เพิ่มคู่แข่ง",
    22301: "กรองโดย",
    22311: "ชัดเจน",
    22321: "คู่แข่ง",
    22331: 'commentity (เช่นใน "แท็กเอนทิตีคู่แข่ง")',
    22341: "แท็กเอนทิตี",
    22351: "ความคิดเห็น",
    22361: "ไม่มีตัวเลือก",
    22371: "แย่",
    22381: "ยากจน",
    22391: 'เฉลี่ย (เช่นใน "การจัดอันดับดาว")',
    22401: "ยอดเยี่ยม",
    22411: "ยอดเยี่ยม",
    22421: "รีวิวพร้อมตอบ",
    22431: "บทวิจารณ์โดยไม่ตอบกลับ",
    22441: "บทวิจารณ์พร้อมความคิดเห็น",
    22451: "บทวิจารณ์โดยไม่มีความคิดเห็น",
    22461: "รีวิวปริมาณ VS คะแนนเฉลี่ย",
    22471: "แบรนด์",
    22481: "ซูม",
    22491: "ความคิดเห็นรวม",
    22501: "รีวิวเรตติ้งโดย Star",
    22511: "ความคิดเห็นคู่แข่ง",
    22521: "คู่แข่ง",
    22531: "รหัส (เช่นใน 'storecode')",
    22541: "จัดการคู่แข่ง",
    22551: "อัปเดต",
    22561: "เพิ่มคู่แข่ง",
    22571: "เพิ่มสถานที่",
    22581: "เพิ่มชื่อคู่แข่ง",
    22591: "ขั้นตอนแรกคือการเพิ่มชื่อของคู่แข่งเมื่อคุณเพิ่มชื่อและไอคอนเสริม (48x48 ภาพ) ลงในรายการให้คลิกที่ 'เพิ่ม' เมื่อคู่แข่งถูกสร้างขึ้นคุณจะสามารถกำหนดสถานที่แต่ละแห่งได้",
    22601: "ป้อนชื่อคู่แข่ง (จำเป็น)",
    22611: "ป้อน URL คู่แข่ง (ไม่บังคับ)",
    22621: "อัพโหลดภาพ",
    22631: "เร็ว ๆ นี้",
    22641: "อัตราส่วนความคิดเห็น",
    22651: "ร้อยละของความคิดเห็นที่มีและไม่มีความคิดเห็น",
    22661: 'ไม่มี (เช่นเดียวกับ "ไม่มีความคิดเห็น")',
    22671: 'ด้วย (เช่นใน "กับความคิดเห็น")',
    22681: "แสดงความคิดเห็น",
    22691: "จำนวนคำที่ใช้ในแต่ละความคิดเห็นโดยการจัดอันดับดาว",
    22701: "คำ",
    22711: "อัตราส่วนคำ",
    22721: "ทั้งหมดและเปอร์เซ็นต์ของคำในความคิดเห็นสำหรับแต่ละระดับดาว",
    22731: "ที่นี่. (เชื่อมโยงในคู่แข่งกับหน้าบูรณาการ)",
    22741: "คู่แข่ง",
    22751: "เพิ่มแท็ก",
    22761: "เลือกตัวแปรที่จะเพิ่มลงในเทมเพลต",
    22771: "ปิดการตรวจสอบ",
    22781: "ปิดการตรวจสอบ",
    22791: "คุณต้องการปิดรีวิวนี้หรือไม่? เมื่อคุณปิดคุณจะต้องเปิดใหม่เพื่อตอบกลับ",
    22801: "ภายนอก",
    22811: "เชิงลบ",
    22821: "เลขที่",
    22831: "ยังไม่มีการตอบกลับอัตโนมัติ!",
    22841: "ยังไม่มีการตอบกลับที่บันทึกไว้!",
    22851: "บันทึก",
    22861: "ปิดอย่างถาวร",
    22871: "เชิงบวก",
    22881: "อ่านหมดเวลา",
    22891: "ตรวจสอบคืนสถานะ",
    22901: "เปิดการตรวจสอบอีกครั้ง",
    22911: "ตอบกลับ",
    22921: "ส่งคำตอบแล้ว (จากอินเทอร์เฟซของ Google)",
    22931: "ตอบกลับส่งจากแอป",
    22941: "ตรวจสอบลบออก",
    22951: "เทมเพลต",
    22961: "ปิดชั่วคราว",
    22971: "ใช่",
    22981: "คุณไม่มีร่างที่บันทึกไว้ใด ๆ",
    22991: "สิทธิ์ไม่เพียงพอในการเข้าถึงทรัพยากร",
    23001: "พบข้อผิดพลาดภายใน",
    23011: "คำขอมีอาร์กิวเมนต์ที่ไม่ถูกต้อง",
    23021: "ไม่พบนิติบุคคลที่ร้องขอ",
    23031: "ตรวจสอบไม่มีอยู่บนแพลตฟอร์ม Google อีกต่อไป",
    23041: "ค่าการแทรกอัตโนมัติบางอย่างไม่สามารถใช้ได้ กรุณาแทนที่และส่ง",
    23051: "บริการไม่สามารถใช้งานได้ในขณะนี้",
    23061: "การดำเนินการนี้ไม่รองรับตำแหน่งที่ไม่มีการอ้างสิทธิ์",
    23071: "โพสต์ที่เผยแพร่",
    23081: "โพสต์ตามกำหนด",
    23091: "ชื่อที่เป็นมิตร",
    23101: "เพิ่มชื่อที่ดี",
    23111: "ติดต่อ",
    23121: "ไม่มีผู้ติดต่อ!",
    23131: "เพื่อเพิ่มการติดต่อ",
    23141: "ชื่อผู้ติดต่อ",
    23151: "ติดต่ออีเมล",
    23161: "เพิ่มผู้ติดต่อ",
    23171: "โพสต์ข้อมูลเชิงลึก",
    23181: "Google Post Insights",
    23191: "ไม่มีข้อมูล",
    23201: "Google Audit",
    23211: "บันทึกการตรวจสอบ",
    23221: "เลือกรายงาน",
    23231: "เลือก",
    23241: "ดาวน์โหลดทั้งหมด",
    23251: "ไม่มีตัวเลือก",
    23261: "ดาวน์โหลดข้อมูล",
    23271: "รีวิวดาวน์โหลด",
    23281: "บทวิจารณ์ทั้งหมด",
    23291: "ดาวน์โหลดรูปภาพ URL",
    23301: "URL ภาพถ่ายของลูกค้า",
    23311: "URL Photo Merchant",
    23321: "รายงานประวัติดาวน์โหลด",
    23331: "ชื่อรายงาน",
    23341: "ส่งไปยัง",
    23351: "เวลาที่สร้างขึ้น (UTC)",
    23361: "ประเภทรายงาน",
    23371: "รายละเอียดรายละเอียด",
    23381: "เปลี่ยนชื่อโปรไฟล์",
    23391: "ซิงค์รายสัปดาห์",
    23401: "เปิดใช้งานแท็บจัดการตำแหน่งจำนวนมาก",
    23411: "การตั้งค่ารูปแบบวันที่",
    23421: "บันทึก",
    23431: "ความสุข / การตั้งค่า NPS",
    23441: "โปรโมเตอร์ / มีความสุข",
    23451: "เป็นกลาง",
    23461: "detractor / ไม่มีความสุข",
    23471: "อัปเดต",
    23481: "โลโก้ปัจจุบัน",
    23491: "โลโก้เต็มรูปแบบ",
    23501: "ไอคอน",
    23511: "โลโก้รายงาน",
    23521: "favicon",
    23531: "โลโก้นี้จะนำเสนอที่มุมซ้ายบนขณะที่ขยายการนำทางด้านซ้ายของโปรไฟล์ของคุณ",
    23541: "โลโก้นี้จะนำเสนอที่มุมบนซ้ายของโปรไฟล์ของคุณ",
    23551: "โลโก้นี้จะปรากฏในรายงานแดชบอร์ดและรายงานการตรวจสอบที่สร้างขึ้นในระบบใช้ภาพ PNG ขนาดระหว่าง 5KB ถึง 20KB เพื่อผลลัพธ์ที่ดีที่สุด",
    23561: "โลโก้นี้จะนำเสนอที่มุมบนซ้ายของแท็บเบราว์เซอร์",
    23571: "เปลี่ยนโลโก้",
    23581: "เลือกประเภทโลโก้ที่คุณต้องการเปลี่ยนโดยใช้ตัวเลือกแบบเลื่อนลงและอัปโหลดโลโก้",
    23591: "อัปโหลดโลโก้สำหรับ",
    23601: "การกำหนดค่าสถานะตำแหน่ง GBP: การตั้งค่าการปราบปร��ม",
    23611: "ปราบปราม",
    23621: "มองเห็นได้",
    23631: "ที่ตัดการเชื่อมต่อ",
    23641: "ไม่ผ่านการยืนยัน",
    23651: "ถูกระงับ",
    23661: "ทำซ้ำ",
    23671: "อัปโหลดรีวิวปาร์ตี้แรก",
    23681: "ที่อัพโหลด",
    23691: "ชัดเจน",
    23701: "จัดการที่ตั้งเป็นกลุ่ม",
    23711: "การควบคุมการจัดการจำนวนมาก",
    23721: "อัปเดตรายละเอียดตำแหน่งและพารามิเตอร์แพลตฟอร์มควบคุมโดยตรงใน Google Sheets",
    23731: "แพลตฟอร์ม",
    23741: "จัดการบัญชีของสเกลใด ๆ ได้อย่างง่ายดายด้วยตัวแปรตำแหน่งที่กำหนดเองและการตั้งค่า",
    23751: "รายละเอียด GBP",
    23761: "ดูรายชื่อธุรกิจของ Google ทั้งหมดของ Google ทั้งหมดและเพิ่ม / ลบ / ลบรายละเอียดตำแหน่งได้โดยตรง",
    23771: "แอตทริบิวต์ GBP",
    23781: "กำหนดแอตทริบิวต์ที่มีสิทธิ์ทั้งหมดให้กับแต่ละตำแหน่งเพื่อเพิ่มการค้นหาการค้นหาที่เพิ่มขึ้น",
    23791: "รายชื่อ GBP",
    23801: "สร้างรายชื่อ GBP ใหม่",
    23811: "เกี่ยวกับ facebook",
    23821: "การควบคุมรายการ Facebook",
    23831: "ประวัติศาสตร์",
    23841: "การฝึกอบรม",
    23851: "การเข้าถึงทรัพยากรสำหรับการแก้ไขเวิร์กโฟลว์จำนวนมากแนวปฏิบัติที่ดีที่สุดข้อ จำกัด และการอัปเดต",
    23861: "คำเตือน",
    23871: "ความต้องการ:",
    23881: "ผู้ใช้ต้องมีบัญชี Google เพื่อให้ระบบสามารถแสดงแผ่น Google ด้วยข้อมูลโปรไฟล์",
    23891: "สังเกต:",
    23901: "ข้อมูลที่เติมแต่ละแผ่นหากจากฐานข้อมูลระบบ หากคุณต้องการให้แน่ใจว่าสเปรดชีตนำเสนอข้อมูลของ Google ปัจจุบันเราขอแนะนำให้คุณซิงโครไนซ์โปรไฟล์ของคุณเป็นครั้งแรก",
    23911: 'ขึ้นอยู่กับจำนวนสถานที่ในบัญชีของคุณ Google Sheets อาจใช้เวลาในการสร้างและรีเฟรชในตอนแรกเมื่อคุณนำทางแผ่นงาน โปรดตรวจสอบให้แน่ใจว่าข้อมูลทั้งหมดมีความเสถียรก่อนกด "อัปเดต" เพื่อบันทึกการแก้ไขไปยังระบบและกดอัปเดตไปยัง Google',
    23921: "แพลตฟอร์มนี้มีการเชื่อมต่อ API โดยตรงกับ Google แต่อาจมีบางครั้งที่ Google Delays การอัปเดตโดยตรงไปยังหน้ารายการตำแหน่งสาธารณะ",
    23931: 'การกด "อัปเดต" เรียกระบบโดยตรงไปยัง Google โดยตรง ไม่มีกระบวนการเลิกทำหรือการพลิกกลับ โปรดตรวจสอบให้แน่ใจว่าคุณพอใจกับการแก้ไขทั้งหมดก่อนที่จะก่อให้เกิดการอัปเดต หากทำผิดพลาดโปรดรอสักครู่แล้วทำการเปลี่ยนแปลงที่จำเป็น',
    23941: "โทนสี",
    23951: "แต่ละแผ่นมีโทนสีเริ่มต้นเพื่อช่วยให้ผู้ใช้เข้าใจว่าฟิลด์ใดมีสิทธิ์ในการแก้ไข",
    23961: "ตัวแปรที่ถ่ายโอนรายละเอียดสถานะจาก Google หรือไม่สามารถแก้ไขได้โดยตรงผ่านการควบคุมจำนวนมาก",
    23971: "Google Variables เปิดโดยตรงสำหรับการแก้ไขจำนวนมาก",
    23981: "ตัวแปรแพลตฟอร์มเปิดโดยตรงสำหรับการแก้ไขจำนวนมาก",
    23991: "ควบคุม",
    24001: "รายละเอียด",
    24011: "คุณลักษณะ",
    24021: "สร้างรายชื่อ",
    24031: "คำแนะนำ",
    24041: "หมดอายุ",
    24051: "ถึงเวลาสมัครสมาชิก!",
    24061: "โปรไฟล์นี้จะหมดอายุ",
    24071: "เพื่อเข้าถึงโปรไฟล์นี้โปรดสมัครสมาชิก",
    24081: "พาฉันไปที่นั่น!",
    24091: "ภายหลัง",
    24101: "การเรียกเก็บเงิน",
    24111: "รายละเอียดแผน",
    24121: "บวก",
    24131: "มือโปร",
    24141: "/ ต่อสถานที่",
    24151: "$ 8 / ต่อสถานที่",
    24161: "10 สถานที่แรก",
    24171: "ขั้นต่ำ $ 24 / เดือน",
    24181: "ลองฟรี 30 วัน",
    24191: "รวมทั้งหมดรวมอยู่ด้วย",
    24201: "ความคิดเห็นเต็มรูปแบบกล่องจดหมาย",
    24211: "การเข้าถึงบทบาทเต็มรูปแบบ",
    24221: "ชุดการรายงานเต็มรูปแบบ",
    24231: "ผู้ใช้ไม่ จำกัด",
    24241: "30 การตอบสนองการตรวจสอบที่ติดตั้งล่วงหน้า",
    24251: "สนับสนุนเต็มรูปแบบ",
    24261: "สถานที่ 11-200",
    24271: "คุณสมบัติทั้งหมดของ Plus Plan",
    24281: "การจัดการ GBP แบบเต็ม",
    24291: "กลุ่ม / ตาราง Google โพสต์",
    24301: "การแจ้งเตือนแบบเรียลไทม์",
    24311: "การตั้งค่ารายงานที่กำหนดเอง",
    24321: "การเพิ่มประสิทธิภาพการค้นหาในท้องถิ่น",
    24331: "ส่วนบุคคลออนบอร์ด",
    24341: "การตรวจสอบการทบทวนที่หยาบคายและฉ้อโกง",
    24351: "กิจกรรม",
    24361: "ที่ได้รับอนุญาต",
    24371: "การเชื่อมต่อที่ได้รับอนุญาตเข้าถึงความสามารถและความสามารถในการตอบกลับเต็มรูปแบบจาก / ไปยังแต่ละแหล่งที่มา",
    24381: "แท็กนิติบุคคลอัพโหลดจำนวนมาก",
    24391: "จำนวนมากอัปโหลดรายละเอียด GBP",
    24401: "เลือกกลุ่มและขึ้นอยู่กับการบันทึกการตอบกลับอัตโนมัติ",
    24411: "นับ",
    24421: "สร้างแท็กเอนทิตี",
    24431: "สร้างเวลา (UTC)",
    24441: "แท็บแถบด้านข้างที่กำหนดเอง",
    24451: "เครื่องมือ Sidebar ที่กำหนดเอง",
    24461: "ดาวน์โหลด GBP Audit",
    24471: "ชื่อไฟล์",
    24481: "ประวัติรายละเอียด GBP",
    24491: "ความประทับใจ",
    24501: "ไม่ใช้งาน",
    24511: "ที่ได้จัดทำดัชนี",
    24521: "การเชื่อมต่อที่จัดทำดัชนีเข้าถึงความคิดเห็นในอดีตและปัจจุบันทั้งหมดจากแต่ละแหล่งที่มา",
    24531: "จัดการ localpost",
    24541: "ไม่มีการเพิ่มความคิดเห็น",
    24551: "ตัวเลข",
    24561: 'กรุณาคลิกที่ปุ่ม "รายงานใหม่" ที่ด้านบนขวา',
    24571: "สร้างรายละเอียด",
    24581: "ขอรหัส",
    24591: "บันทึกการตอบกลับ",
    24601: "สถานที่ทั้งหมด",
    24611: "โพสต์ทั้งหมด",
    24621: "อัปโหลดเทมเพลต AR",
    24631: "อัปโหลดนามแฝงตำแหน่ง",
    24641: "ดู",
    24651: "คุณสามารถกำหนดค่าและตั้งค่าแท็บที่กำหนดเองในแถบด้านข้างที่ชี้ไปที่ iframe ภายในแพลตฟอร์มหรือลิงก์โฮสต์ภายนอก",
    24661: "รายละเอียด GBP",
    24671: "แอตทริบิวต์ GBP",
    24681: "รายชื่อ GBP",
    24691: "เกี่ยวกับ facebook",
    24701: "ประวัติศาสตร์",
    24711: "การฝึกอบรม",
    24721: "การซิงค์รายสัปดาห์เรียกใช้",
    24731: "mmm d, yyy",
    24741: "เช่น -oct 13,2020",
    24751: "MM / DD / YYYY",
    24761: "mmmm d, yyyy",
    24771: "เช่น :- ตุลาคม 13,2020",
    24781: "DD / MM / YYYY",
    24791: "DD MMM YYYY",
    24801: "DD mmmm yyyy",
    24811: "เช่น: - 13 ตุลาคม 2020",
    24821: "อัปโหลดโลโก้ใหม่",
    24831: "เดี่ยว",
    24841: "มองเห็นได้ซ่อนอยู่",
    24851: "รีวิวรายละเอียดการกำหนดค่าบานหน้าต่าง",
    24861: "แสดงรหัสร้านค้า",
    24871: "แสดงที่อยู่แบบเต็ม",
    24881: "แสดงวิดเจ็ตสรุป",
    24891: "หัวกลม",
    24901: "เลือกไฟล์",
    24911: "ไม่มีไฟล์ที่เลือก",
    24921: "ดูบันทึกการอัปเดตแต่ละครั้งเพื่อยืนยันการเปลี่ยนแปลงเนื้อหาของรายการและระบุข้อผิดพลาดใด ๆ",
    24931: 'ขึ้นอยู่กับจำนวนสถานที่ในบัญชีของคุณ Google Sheets อาจใช้เวลาในการสร้างและรีเฟรชในตอนแรกเมื่อคุณนำทางแผ่นงาน โปรดตรวจสอบให้แน่ใจว่าข้อมูลทั้งหมดมีความเสถียรก่อนกด "อัปเดต" เพื่อบันทึกการแก้ไขไปยังระบบและกดอัปเดตไปยัง Google',
    24941: "ทรัพยากรสำหรับเวิร์กโฟลว์แก้ไขจำนวนมากแนวปฏิบัติที่ดีที่สุดข้อ จำกัด และการอัปเดต",
    24951: "ID ผู้ใช้",
    24961: "คุณต้องการลบหรือไม่",
    24971: "บัญชี",
    24981: "ไม่มีการอัปเดตของ Google",
    24991: "ไม่จำเป็นต้องเคารพนับถือ",
    25001: "ไม่มีการแก้ไขที่รอดำเนินการ",
    25011: "เวลาการตรวจสอบ",
    25021: "สนาม",
    25031: "ค่า (ถึง)",
    25041: "ค่า (จาก)",
    25051: "ลบออกจากแท็กเอนทิตี",
    25061: "attractuutelist",
    25071: "adwords",
    25081: "ดูทั้งหมด",
    25091: "คำถาม & คำตอบ (คำถามและคำตอบ)",
    25101: "สำรวจ",
    25111: "สำรวจคำตอบ",
    25121: "เลือกเทมเพลต",
    25131: "ดำเนินการต่อ",
    25141: "เลือกการจัดอันดับดาวชื่อเทมเพลตและเพิ่มเนื้อหาเทมเพลตเพื่อบันทึกการตอบกลับอัตโนมัติ",
    25151: "เลือกประเภทตอบกลับ",
    25161: "เทมเพลต",
    25171: "ตัวอย่าง",
    25181: "กำหนดให้กับการจัดอันดับ (จำเป็น)",
    25191: "ป้อนชื่อเทมเพลต (จำเป็น)",
    25201: "ตัวแปรเทมเพลตที่กำหนดเอง(ไม่จำเป็น)",
    25211: "เลือกหัวข้อสร้าง (ไม่บังคับ)",
    25221: "กำหนดตำแหน่งเดียว",
    25231: "กำหนดให้กับแท็กเอนทิตี",
    25241: "เพิ่มชื่อหัวข้อและเนื้อหา Snippet เพื่อบันทึกการตอบกลับอัตโนมัติ",
    25251: "รายการทั้งหมด # (จำนวน)",
    25261: "หมายเหตุตำแหน่ง",
    25271: "ดูรายละเอียดตำแหน่ง",
    25281: "ดู Google Knowledge Pannel",
    25291: "ดูรีวิวโดยตรงบน Google",
    25301: "บวก 5 ดาว",
    25311: "ลบ - 1/2 ดาว",
    25321: "ผสม - 3/4 ดาว",
    25331: "ชื่อแม่แบบ",
    25341: "ตัวแปร",
    25351: "เลือกหรือสร้างหัวข้อ",
    25361: "กลุ่ม",
    25371: "หัวข้อ",
    25381: "บทวิจารณ์ก่อนหน้านี้",
    25391: "บันทึกเป็นการตอบกลับ",
    25401: "CC (สำเนาคาร์บอน)",
    25411: "รีเซ็ต",
    25421: "มีอะไรใหม่",
    25431: "วันที่สร้าง",
    25441: "ชื่อตัวกรองที่กำหนดเอง",
    25451: "อ่านเท่านั้น",
    25461: "เข้าถึงคุณสมบัติ",
    25471: "ไม่มี",
    25481: "อ่าน",
    25491: "ไม่ จำกัด",
    25501: "นี่เป็นบทบาทเริ่มต้นและไม่สามารถแก้ไข / ลบได้",
    25511: "อ่าน",
    25521: "เขียน",
    25531: "ดาวน์โหลด",
    25541: "ผู้ใช้ทุกคนที่กำหนดให้กับบทบาทนี้จะมีความสามารถในการเข้าถึงคุณสมบัติต่อไปนี้",
    25551: "การตั้งค่าการมองเห็นแท็บย่อย",
    25561: "จัดการบทบาท",
    25571: "แถบด้านข้างที่กำหนดเอง",
    25581: "หรือ",
    25591: "บันทึกคุณสมบัติบทบาท",
    25601: "คุณแน่ใจหรือว่าต้องการลบบทบาท",
    25611: "สิ่งนี้จะเปลี่ยนบทบาทของผู้ใช้ทุกคนที่กำหนดให้กับบทบาทนี้ในการอ่านเท่านั้น",
    25621: "มอบหมายให้ผู้ใช้",
    25631: "ผู้ใช้ในโปรไฟล์",
    25641: "ค้นหาที่นี่",
    25651: "ผู้ใช้ที่ได้รับมอบหมายให้มีบทบาทนี้",
    25661: "ไม่มีผู้ใช้",
    25671: "เชิญอีกครั้ง",
    25681: "หน้า Landing หน้าเริ่มต้น",
    25691: "Ranalyinack",
    25701: "การจัดการจำนวนมาก",
    25711: "การตั้งเวลาโพสต์",
    25721: "บน",
    25731: "ปิด",
    25741: "คุณแน่ใจหรือไม่",
    25751: "คุณแน่ใจหรือไม่",
    25761: "อัปเดตแคมเปญสำเร็จแล้ว",
    25771: "อัตราการตอบสนอง",
    25781: "นับการตอบสนอง",
    25791: "การจัดอันดับดาว",
    25801: "กับ",
    25811: "ปราศจาก",
    25821: "ล่าช้า",
    25831: "เขตเวลา",
    25841: "ทบทวน",
    25851: "รายงานคู่แข่ง",
    25861: "รูปแบบ",
    25871: "อีเมล HTML",
    25881: "ทำให้เป็น excel",
    25891: "หากไม่มีบทวิจารณ์ในช่วงที่เลือก",
    25901: "อย่าส่งอีเมล",
    25911: "ส่งอีเมล",
    25921: "คำถาม & คำตอบ",
    25931: "หากไม่มีคำถาม & คำตอบในช่วงที่เลือก",
    25941: "ภาพลูกค้า",
    25951: "บันทึกการตรวจสอบ",
    25961: "กรุณาติดต่อฝ่ายสนับสนุนเกี่ยวกับคำถามใด ๆ เกี่ยวกับโปรไฟล์ Sync Cadence",
    25971: "รวมไฟล์การตรวจสอบ",
    25981: "ประวัติโดยย่อ",
    25991: "Comptag (แท็กคู่แข่ง)",
    26001: "ตรวจสอบรายละเอียด",
    26011: "จัดการการควบคุมระดับชั้น",
    26021: "แทนที่ฟังก์ชันการทำงานเริ่มต้นจัดเป็นระดับ",
    26031: "สร้างให้ระดับ",
    26041: "สร้างเทียร์ใหม่",
    26051: "ชื่อเทียร์",
    26061: "ค่าเริ่มต้น",
    26071: "ค่าเริ่มต้น",
    26081: "แดชบอร์ดชื่อเสียง",
    26091: "InsightsInsSInto ครบวงจรรีวิว KPI",
    26101: "ทัศนวิสัยอย่างเต็มที่ในทุกสถานที่และแหล่งที่มา",
    26111: "ส่วน",
    26121: "แกน KPI ของปริมาณการทบทวนคะแนนเฉลี่ยการกระจายแหล่งที่มาความสุขและการตอบสนอง",
    26131: "การวิเคราะห์ความคิดเห็นและการให้คะแนนตามยาวของเปอร์เซ็นต์สะสมแหล่งความสุขและเวลาตอบสนองของฮิสโตแกรม",
    26141: "อัตราส่วนความคิดเห็นความยาวความคิดเห็นและอัตราส่วนคำที่สะสมโดยการให้คะแนน",
    26151: "ความคิดเห็นตามวันต่อสัปดาห์วันเดือนและเดือนปี",
    26161: "ห้าประเทศสหรัฐอเมริกา / จังหวัดและเมืองตามปริมาณการทบทวน",
    26171: "ข้อมูลประวัติศาสตร์ทั้งหมดรวบรวมในระหว่างการตั้งค่าบัญชีเริ่มต้นแล้วอัปเดตจากแหล่งตรวจสอบที่เชื่อมต่อทั้งหมดทุกวัน",
    26181: "ข้อมูลเชิงลึกของ GBP",
    26191: "แผนภูมิพื้นที่ปริมาณการค้นหา Direct ค้นพบและยี่ห้อรายวัน",
    26201: "แผนที่และค้นหามุมมองรายวันแผนภูมิพื้นที่",
    26211: "แผนภูมิการกระทำของลูกค้าสำหรับทิศทางการขับขี่โทรศัพท์และการคลิกเว็บไซต์",
    26221: "การกระทำตำแหน่งตามแผนภูมิคอลัมน์วันสัปดาห์",
    26231: "การปันส่วนการแปลงในท้องถิ่นที่ไม่ซ้ำกัน (การกระทำ / การค้นหารายวัน)",
    26241: "ปริมาณภาพถ่ายทั่วไปของแบรนด์ที่โฮสต์เป็นตำแหน่ง GBP และมุมมองทั้งหมด",
    26251: "ลูกค้าที่อัปโหลดจำนวนภาพถ่ายเฉลี่ยที่โฮสต์เป็นตำแหน่ง GBP และมุมมองทั้งหมด",
    26261: "เต็ม 18 เดือนของข้อมูลรายวันสำหรับทุกสถานที่รวบรวมในระหว่างการตั้งค่าบัญชีเริ่มต้นแล้วอัปเดตจากแหล่งตรวจสอบที่เชื่อมต่อทั้งหมดทุกวัน ขณะนี้ Google รายงานข้อมูลเชิงลึกเกี่ยวกับความล่าช้า 3-5 วัน",
    26271: "การเปิดรับการค้นหาในท้องถิ่นและการรายงานการกระทำ",
    26281: "การเปลี่ยนแปลง",
    26291: "เปรียบเทียบประสิทธิภาพการทำงานข้ามที่ตั้งได้อย่างง่ายดาย",
    26301: "แผนภูมิบรรทัดรายวันของสถานที่แต่ละแห่งที่เลือกสำหรับรีวิว, avg rating, การค้นหา, มุมมองและการกระทำ",
    26311: "จัดเรียงและสามารถนำเสนอตารางที่ค้นหาได้ของรีวิวแต่ละตำแหน่งและตัวชี้วัดท้องถิ่นพร้อมการรายงานการดาวน์โหลดเต็มรูปแบบ",
    26321: "แท็บเพิ่มเติมเสนอแผนภูมิประสิทธิภาพและตารางโดยการม้วนทางภูมิศาสตร์ / การเจาะลึกด้วยทริกเกอร์การดาวน์โหลดที่เป็นเอกลักษณ์ของตัวเอง",
    26331: "ความคิดเห็นและตารางข้อมูลเชิงลึกของ GBP และแผนภูมิตามที่ตั้งของแต่ละบุคคล",
    26341: "Ranalyinack",
    26351: "กล่องขาเข้ารวมสำหรับทุกสถานที่และแหล่งที่มา - ตัวกรองการค้นหาตอบสนองและจัดการ",
    26361: "จัดการความคิดเห็นทั้งหมดจากแหล่งทั้งหมด",
    26371: "เวิร์กโฟลว์",
    26381: "ค้นหาและกรองเพื่อค้นหารีวิวโดยการให้คะแนน, แหล่งที่มา, เนื้อหา, ผู้ตรวจสอบ, แท็กหรือที่ตั้ง",
    26391: "ตอบสนองต่อแหล่งตรวจสอบที่ได้รับอนุญาตโดยตรงจากแพลตฟอร์ม",
    26401: "สำรวจเทมเพลตตามการให้คะแนนและตัวอย่างตามหัวข้อที่จะส่งการตอบสนองส่วนบุคคลด้วยความเร็วที่ไม่มีใครเทียบได้",
    26411: "สร้างเวิร์กโฟลว์สำหรับการอนุมัติการตอบสนองที่ควบคุมได้",
    26421: "ส่งโน้ตหรือคำตอบของ CC โดยตรงไปยังการจัดการตำแหน่ง",
    26431: "ควบคุมทั้งหมด",
    26441: "จัดการรายการตำแหน่ง",
    26451: "Direct API เพิ่ม / แก้ไข / ลบการควบคุมรายชื่อตำแหน่งทั้งหมดรายละเอียดในบัญชี",
    26461: "ปรับปรุงการควบคุมจำนวนรายการใด ๆ",
    26471: "ค้นหาและกรองในหลาย ๆ ตำแหน่งและบัญชีที่เชื่อมต่อตามสถานะและเนื้อหา",
    26481: "แก้ไขรายละเอียด GBP โดยตรงตามที่ตั้งของแต่ละตำแหน่ง",
    26491: "สร้างโพสต์ GBP ส่วนบุคคลสำหรับตำแหน่งที่มีสิทธิ์ทั้งหมด",
    26501: "จัดระเบียบสถานที่ให้เป็นจำนวนของกลุ่มลูกค้าที่ไม่ซ้ำกันผ่านแท็กเอนทิตี",
    26511: 'กำหนด "ชื่อที่เป็นมิตร" เพื่อให้ง่ายต่อการจัดการโปรไฟล์องค์กรโซ่และแฟรนไชส์',
    26521: "จำนวนมากเพิ่ม / แก้ไขเนื้อหา GBP, รูปภาพ, หมวดหมู่, ชั่วโมง, ที่อยู่, คำอธิบายและอื่น ๆ",
    26531: "กลุ่มเพิ่มคำถามและคำตอบของ Google ใหม่สำหรับแต่ละแผงความรู้ของแต่ละตำแหน่ง",
    26541: "เนื้อหาแพลตฟอร์มเพิ่ม / แก้ไขจำนวนมากเช่นบันทึกตำแหน่งผู้จัดการท้องถิ่นและอื่น ๆ",
    26551: "ติดตามความคิดเห็นของคู่แข่ง",
    26561: "การเปรียบเทียบแดชบอร์ด ตรวจสอบการเปรียบเทียบการกระจาย แบรนด์และที่ตั้งคลื่น Quadrant",
    26571: "รับข้อมูลเชิงลึกที่ไม่มีใครเทียบในข้อเสนอแนะของคู่แข่ง",
    26581: "แดชบอร์ดรายงานการทบทวนของคู่แข่งกรองเพื่อระบุการเปรียบเทียบที่แน่นอน",
    26591: "การเปรียบเทียบการจัดอันดับการจัดอันดับข้ามแบรนด์คู่แข่ง",
    26601: "แผนภูมิคลื่นของปริมาณการทบทวนกับคะแนนเฉลี่ยเปรียบเทียบแบรนด์หรือสถานที่แต่ละแห่ง",
    26611: "รีวิวความคิดเห็นเต็มรูปแบบรายละเอียดและแม้แต่การตอบสนองของคู่แข่ง",
    26621: "ส่วนยังคงอยู่ในสถานะเบต้าอย่างเป็นทางการในขณะที่เรายังคงเพิ่มตัวเลือกการรายงานและการนำเสนอเพิ่มเติม",
    26631: "การจัดการจำนวนมาก",
    26641: '"สเปรดชีต UI" ที่เป็นเอกลักษณ์ให้การควบคุมรายการโดยตรงผ่านการเชื่อมต่อ Google Sheet',
    26651: "วิธีที่เร็วและง่ายที่สุดในการควบคุมบัญชีขนาดใด ๆ",
    26661: "แพลตฟอร์ม - การมอบหมายจำนวนมากและการอัพเดทของตัวแปรหลักในการจัดการแพลตฟอร์ม",
    26671: "รายละเอียด - ส่วนหลักสำหรับรายละเอียดธุรกิจของ Google ทั้งหมดของฉันทั้งหมด",
    26681: "คุณลักษณะ - เพิ่มประสิทธิภาพการกำหนดแอตทริบิวต์ในรายการ GBP",
    26691: "สร้างรายชื่อ - สร้างรายชื่อ GBP ใหม่ทั้งหมดจะเป็นเนื้อหาที่สำคัญทั้งหมด",
    26701: "Facebook - ควบคุมรายละเอียด Facebook ทั้งหมดจากสเปรดชีตเดียว",
    26711: "ประวัติ - บันทึกการแก้ไขไฟล์และการอัปเดต",
    26721: "ส่วนยังคงอยู่ในสถานะเบต้าอย่างเป็นทางการในขณะที่เรายังคงปรับแต่งการควบคุมบัญชีและรวมถึงแพลตฟอร์มเพิ่มเติม",
    26731: "การตั้งเวลาโพสต์",
    26741: "การสร้างและกำหนดเวลาการสร้างจำนวนมากสำหรับ Google โพสต์ข้ามที่ตั้งและบัญชี",
    26751: "แบ่งปันการอัปเดตที่สำคัญและข้อความส่งเสริมการขาย",
    26761: "ดาวน์โหลดเทมเพลตเพื่อสร้าง Google โพสต์สำหรับตำแหน่งที่มีสิทธิ์ทั้งหมด",
    26771: "กำหนดเวลากำหนดเวลาสำหรับไฟล์ทั้งหมดหรือตั้งค่าแต่ละโพสต์เพื่อเริ่มต้นที่วันและเวลาที่เป็นเอกลักษณ์",
    26781: "วางแผนปฏิทินส่งเสริมการขายทั้งหมด",
    26791: "โพสต์รายงานข้อมูลเชิงลึก",
    26801: "ดูมุมมองของ Google โพสต์และคลิกประสิทธิภาพเมื่อเวลาผ่านไป - ฟิลเตอร์การรายงานตามประเภทสื่อและการเรียกร้องให้ดำเนินการ",
    26811: "ระบุแนวโน้มประสิทธิภาพในการเพิ่มประสิทธิภาพการโฆษณาฟรี",
    26821: "แผนภูมิแท่งแสดงถึงประสิทธิภาพเมื่อเวลาผ่านไปตั้งค่าช่วงวันที่และกราฟแผนภูมิ",
    26831: "ดูโพสต์ระดับเสียงตามสื่อหัวข้อและเรียกไปยังประเภทการดำเนินการ",
    26841: "ดูแต่ละโพสต์ตัวชี้วัดประสิทธิภาพแต่ละรายการ",
    26851: "การดาวน์โหลดรายงานอนุญาตให้ทำการวิเคราะห์เพิ่มเติมตามแคมเปญ",
    26861: "การตั้งค่า",
    26871: "ส่วนการบริหารของแพลตฟอร์มสำหรับการตั้งค่าทั้งหมดบทบาทการอนุญาตผู้ใช้การจัดตารางเวลารายงานและการดาวน์โหลดข้อมูล",
    26881: "การควบคุมระดับองค์กรเพื่อตั้งค่าประสบการณ์ที่กำหนดเองสำหรับผู้ใช้ทุกคน",
    26891: "ส่วนการจัดการหลัก",
    26901: "อนุญาตการเชื่อมต่อกับแพลตฟอร์ม (Google, Facebook, Trustpilot, จอง)",
    26911: "ตั้งค่าการรวมเข้ากับแหล่งตรวจสอบที่มีอยู่",
    26921: "จัดการ / สร้างบทบาทผู้ใช้ที่แตกต่างกัน",
    26931: "กำหนด / ควบคุมการเข้าถึงแต่ละรายการ",
    26941: "กำหนดการรายงานตามประเภทผู้ใช้และสถานที่ตั้ง",
    26951: "ดาวน์โหลดชุดข้อมูลจากแพลตฟอร์มเข้าถึงคำขอล่าสุด 10 รายการ",
    26961: "บัญชีอนุญาต",
    26971: "Google Audit",
    26981: "การบูรณาการ",
    26991: "บทบาทผู้จัดการ",
    27001: "จัดการผู้ใช้",
    27011: "ตรวจสอบการตั้งค่า",
    27021: "Campagin Builder",
    27031: "การจัดการรายงาน",
    27041: "ดาวน์โหลดข้อมูล",
    27051: "รายละเอียดรายละเอียด",
    27061: "การนำทางที่กำหนดเอง",
    27071: "ตรวจสอบความชัดเจน",
    27081: "เรียกร้องตำแหน่ง",
    27091: "แหล่งที่ได้รับอนุญาต",
    27101: "จำเป็นสำหรับการเข้าถึงข้อมูลแบบเต็มและการตอบสนองการตรวจสอบโดยตรง",
    27111: "ตัวเลือก",
    27121: "การเชื่อมต่อที่ได้รับอนุญาตจะยังคงเติบโตเป็นแพลตฟอร์มทำให้การเชื่อมต่อ API พร้อมใช้งาน",
    27131: "อนุญาตโดยตรงการเชื่อมต่อระหว่างแพลตฟอร์มและบัญชีผู้ใช้เพื่อรับการควบคุมที่เป็นไปได้ที่สร้างขึ้น",
    27141: "แหล่งทั้งหมด",
    27151: "แหล่งทบทวนที่จัดทำดัชนี",
    27161: "ความคิดเห็นรวมจาก 40+ แหล่งที่มาในแนวดิ่งอุตสาหกรรม",
    27171: "หมายเหตุ",
    27181: "ใช้ Google Indexing เพื่อเข้าถึงความคิดเห็นโดยไม่ต้องควบคุมรายชื่อ GBP",
    27191: "การจัดหาที่จัดทำดัชนีใช้สำหรับคอลเลกชันการทบทวนการแข่งขันทั้งหมด",
    27201: "หลังจากดัชนีเริ่มต้นความคิดเห็นและการตอบกลับจะถูกรวบรวมทุกวัน",
    27211: "การจัดทำดัชนีสาธารณะหรือความคิดเห็นทางประวัติศาสตร์และการตอบกลับทางประวัติศาสตร์ทั้งหมดโดย URL หรือ Phestid",
    27221: "แหล่งทั้งหมด",
    27231: "กำหนดค่า",
    27241: "เมื่อวาน",
    27251: "7 วันที่ผ่านมา",
    27261: "อาทิตย์ที่แล้ว",
    27271: "30 วันที่ผ่านมา",
    27281: "เดือนที่แล้ว",
    27291: "ตลอดเวลา",
    27301: "asc",
    27311: "สืบทอด",
    27321: "ไม่มีการติดต่อสำหรับ CC",
    27331: "บันทึกการตอบกลับนี้?",
    27341: "เลือกหรือสร้างกลุ่ม",
    27351: "ไม่มีการตอบกลับที่บันทึกไว้",
    27361: "ไม่มีการตอบกลับอัตโนมัติ",
    27371: "ทั้งหมด 0 รายการ",
    27381: "เทมเพลตที่บันทึกไว้",
    27391: "รวม 26 รายการ",
    27401: "เพิ่งใช้งาน",
    27411: "Smileys & People",
    27421: "มีความคิดเห็น",
    27431: "ไม่มีความคิดเห็น",
    27441: "สถานที่ทั้งหมด",
    27451: "เปิด",
    27461: "อัปเดตของ Google",
    27471: "เนื้อหาที่ขาดหายไป",
    27481: "รหัสร้านค้า",
    27491: "หมวดหมู่เพิ่มเติม",
    27501: "ค้นหาสถานที่",
    27511: "การตรวจสอบ GBP",
    27521: "กิจกรรมจำนวนมาก",
    27531: "เลือกกลุ่ม",
    27541: "20 / หน้า",
    27551: "ซิงค์",
    27561: "ตั้งค่าผู้ชม",
    27571: "เสร็จแล้ว",
    27581: "ชื่อแท็กเอนทิตี",
    27591: "นาที",
    27601: "ด้วย & ไม่มีความคิดเห็น",
    27611: "ประเมินค่า",
    27621: "การวิเคราะห์ควอดเรนต์",
    27631: "ข้อมูลสถานที่ทั้งหมด",
    27641: "การค้นหาสูง + การแปลงต่ำ",
    27651: "การค้นหาสูง + การแปลงสูง",
    27661: "การค้นหาต่ำ + การแปลงต่ำ",
    27671: "การค้นหาต่ำ + การแปลงสูง",
    27681: "ข้อมูลตำแหน่งตามภูมิภาค",
    27691: "ข้อมูลตำแหน่งตามเมือง",
    27701: "ที่ตั้ง:",
    27711: "อัตราการแปลง:",
    27721: "ค้นหา:",
    27731: "Google Q & A",
    27741: "Google QA",
    27751: "ดาวน์โหลด QA",
    27761: "โพสต์คำตอบ",
    27771: "โพสต์ข้อมูลเชิงลึก",
    27781: "ดาวน์โหลดตัวอย่าง CSV",
    27791: "Pre Populated CSV",
    27801: "จัดการพอร์ตโฟลิโอ",
    27811: "เพิ่มพอร์ตโฟลิโอ",
    27821: "ดูพอร์ตโฟลิโอ",
    27831: "ลบพอร์ตโฟลิโอ",
    27841: "ผู้ใช้",
    27851: "จัดการโปรไฟล์",
    27861: "ลบโปรไฟล์",
    27871: "คุณแน่ใจหรือว่าต้องการลบโปรไฟล์นี้?",
    27881: "บัญชี",
    27891: "เลือกโปรไฟล์",
    27901: "เลือกโปรไฟล์",
    27911: "บัญชีพอร์ตโฟลิโอ",
    27921: "รายละเอียดผลงาน",
    27931: "ชื่อพอร์ตโฟลิโอ",
    27941: "พอร์ตโฟลิโอ Currrent",
    27951: "อัปโหลดรูปภาพเป็นโลโก้สำหรับพอร์ตโฟลิโอ",
    27961: "เปลี่ยนชื่อพอร์ตโฟลิโอ",
    27971: "ทดลองฟรี",
    27981: "หมุนเวียน",
    27991: "หมดอายุแล้ว",
    28001: "ยกเลิก",
    28011: "ที่ออกใบแจ้งหนี้",
    28021: "เชื่อมต่อ",
    28031: "จำนวนบัญชี",
    28041: "สถานที่ทั้งหมด",
    28051: "สถานที่ทำงาน",
    28061: "ความคิดเห็น (30 วัน)",
    28071: "สถานะการชำระเงิน",
    28081: "ชื่อโปรไฟล์",
    28091: "ป้อนชื่อของพอร์ตใหม่",
    28101: "พอร์ตโฟลิโอสามารถจัดการผู้ใช้จำนวนมากในโปรไฟล์ที่แตกต่างกันได้อย่างง่ายดาย",
    28111: "ชื่อของพอร์ตโฟลิโอใหม่",
    28121: "ชื่อพอร์ตโฟลิโอสามารถมีได้สูงสุด 20 ตัวอักษรเท่านั้น",
    28131: "พอร์ตโฟลิโอสร้างสำเร็จแล้ว!",
    28141: "รวมโปรไฟล์",
    28151: "ผู้ใช้ทั้งหมด",
    28161: "กรอกอีเมล",
    28171: "เชิญใครบางคนเพื่อช่วยคุณจัดการโปรไฟล์ คุณสามารถตั้งค่าการเข้าถึงโปรไฟล์โดยเลือกบทบาทของพวกเขา",
    28181: "เชิญ",
    28191: "พอร์ตโฟลิโอปัจจุบัน",
    28201: "ความเชื่อมั่น",
    28211: "การรอคอย",
    28221: "ตัวกรองเพิ่มเติม",
    28231: "ทบทวนแท็ก",
    28241: "บันทึกตัวกรองว้",
    28251: "ตัวกรองน้อยลง",
    28261: "ไม่มีข้อความ",
    28271: "ปานกลาง",
    28281: "ขยาย",
    28291: "อัปโหลดภาพเดียว",
    28301: "เลือกประเภทภาพ",
    28311: "เลือกประเภท",
    28321: "ภาพปก",
    28331: "รูปประจำตัว",
    28341: "ภาพถ่ายภายนอก",
    28351: "ภาพภายใน",
    28361: "ภาพสินค้า",
    28371: "ภาพงาน",
    28381: "ภาพโลโก้",
    28391: "รูปภาพอาหารและเครื่องดื่ม",
    28401: "รูปภาพเมนู",
    28411: "ภาพถ่ายพื้นที่ส่วนกลาง",
    28421: "รูปภาพห้องพัก",
    28431: "รูปภาพทีม",
    28441: "มุมมอง",
    28451: "รูปถ่าย",
    28471: "ปิด",
    28481: "ลบออก",
    28491: "แท็กรีวิวใหม่",
    28511: "ไม่มีอะไรจะแสดงในช่วงนี้!",
    28531: "เลือกทั้งหมด",
    28541: "แหล่งค้นหา",
    28551: "แท็กตรวจสอบค้นหา",
    28561: "สถานที่ค้นหา",
    28571: "ค้นหารหัสร้านค้า",
    28581: "กลุ่มค้นหา",
    28601: "แท็กเอนทิตี",
    28631: "ค้นหาตัวกรองที่บันทึกไว้",
    28641: "ไม่มีตัวเลือก!",
    28651: "ปรับมุมมองข้อความรีวิว",
    28661: "ดูรีวิวโดยตรง",
    28671: "ตอบกลับรีวิวแพลตฟอร์ม",
    28711: "ไม่มีความคิดเห็น",
    28731: "ชื่อตำแหน่งตอบกลับไม่ได้เพิ่มในตำแหน่งนี้",
    28741: "ลายเซ็นไม่ได้เพิ่มในตำแหน่งนี้",
    28751: "คุณต้องการดาวน์โหลดต่อหรือไม่?",
    28771: "บทวิจารณ์พร้อมคำตอบภายใน",
    28781: "บทวิจารณ์ด้วยการตอบกลับอัตโนมัติ",
    28791: "บทวิจารณ์พร้อมการตอบกลับภายนอก",
    28801: "ดูแผงความรู้ของ Google",
    28821: "ผู้จัดการใหม่",
    28831: "เปิดใช้งาน CC",
    28851: "ลบการตอบกลับ",
    28871: "ผสม",
    28881: "ดาว",
    28891: "ลบผสมบวก",
    28931: "บันทึกการตอบกลับ",
    28941: "แก้ไขชื่อบัญชี",
    28951: "เปลี่ยนชื่อบัญชี",
    28961: "ชื่อบัญชี",
    28971: "ที่ตั้ง Facebook",
    28981: "เพิ่มหน้า",
    28991: "ที่ได้เปิดใช้งานแล้ว",
    29001: "แสดงตำแหน่งที่ซ่อนอยู่",
    29011: "ดูหน้า FB",
    29021: "ไม่มีบัญชีที่ซ่อนอยู่เพื่อแสดง",
    29031: "ครั้งที่แล้ว",
    29041: "ผู้ขอเชิญ",
    29051: "รีวิวตู้โชว์",
    29061: "Google ตั้ง",
    29071: "ตำแหน่งของคุณ",
    29081: "URL ตำแหน่ง",
    29091: "คุณแน่ใจหรือว่าต้องการลบ URL นี้?",
    29101: "คุณต้องการลบ URL และข้อมูลที่เกี่ยวข้องจากแอปพลิเคชันหรือไม่",
    29111: "ที่ตั้งของคู่แข่ง",
    29121: "ชื่อคู่แข่ง",
    29131: "รหัสสถานที่",
    29141: "comptag",
    29151: "ป้อน URL ตำแหน่งและรายละเอียดคู่แข่ง",
    29161: "iscompetitor",
    29171: "ที่ตั้งการจอง",
    29181: "เพื่อเริ่มต้นการจองทบทวนการจอง",
    29191: "ID ตำแหน่งสำนักงานกลับ (ไม่บังคับ)",
    29201: "กรุณากรอกตำแหน่งตำแหน่งของคุณหรือรายละเอียดคู่แข่ง สำหรับ 20 ตำแหน่งขึ้นไป\r\nโปรดระบุรายการของแต่ละตำแหน่งเป็นไฟล์ Excel ไปที่",
    29211: "ในการดาวน์โหลดไฟล์ตัวอย่างคลิก",
    29221: "โปรดทราบว่าอาจใช้เวลาหลายนาทีในการดึงข้อมูลเริ่มต้นให้เสร็จสมบูรณ์",
    29231: "โปรดระบุรายการของแต่ละรายการ",
    29241: "URL ตำแหน่งสำหรับธุรกิจไป",
    29251: "คุณสามารถวางพวกเขาโดยตรงในอีเมลหรือให้ excel ของรายการ Google แผ่นงาน",
    29261: "กรุณากรอก URL ตำแหน่งของคุณและรหัสตำแหน่ง Office ที่เป็นตัวเลือก (เพื่อรองรับการเชื่อมโยงแบบลึกเพื่อการตอบกลับรีวิว) หรือ",
    29271: "รายละเอียดคู่แข่ง",
    29281: "บัญชีขนาดใหญ่ (สถานที่ 20+) สามารถให้รายการของแต่ละตำแหน่งเป็นไฟล์ Excel ไปที่",
    29291: "สร้างแคมเปญเพื่อตอบสนองโดยตรงกับความคิดเห็นด้วยการตอบสนองที่สมบูรณ์แบบในเวลาที่เหมาะ",
    29301: "คุณแน่ใจหรือว่าต้องการลบแคมเปญนี้?",
    29311: "คัดลอกความคิดเห็นอัจฉริยะต่อแต่ละตัวจัดการตำแหน่งที่กำหนด",
    29321: "CC ตอบกลับไปยังผู้จัดการตำแหน่งที่กำหนด",
    29331: "CC ตอบกลับองค์กร",
    29341: "ผู้รับ",
    29351: "ผู้รับทั้งหมด",
    29361: "เลือกแหล่งท่องเที่ยว",
    29371: "ผับ / ย่อยเท่านั้น",
    29381: "เลือกการจัดอันดับดาว",
    29391: "เลือกตรวจสอบเนื้อหา",
    29401: "กลุ่มที่กำหนดเอง",
    29411: "ตั้งค่าความล่าช้าก่อนที่จะส่งการตอบกลับอัตโนมัติ",
    29421: "กำหนดเวลาการทำงาน",
    29431: "ไม่จำเป็น",
    29441: "ไม่มีที่ตั้งที่กำหนด",
    29451: "ไม่พบข้อมูลเชิงลึกสำหรับช่วงวันที่ที่เลือกและเกณฑ์",
    29461: "เมนูตัวกรอง",
    29471: "เรียงลำดับ",
    29481: "มุมมองในการค้นหา",
    29491: "มุมมองในแผนที่",
    29501: "คุณไม่มีสิทธิ์เพียงพอที่จะโพสต์การตอบกลับ",
    29511: "ส่งแล้ว",
    29521: "อัปโหลดเทมเพลต AR",
    29531: "ผู้ติดตามนับ",
    29541: "ซิงค์ล่าสุด",
    29551: "องค์กร",
    29561: "ตัวแทน",
    29571: "เปิดใช้งาน localpost",
    29581: "ไม่มีการตรวจสอบที่รอดำเนินการ",
    29591: "คลิกเพื่อดูรีวิวนี้ในกล่องจดหมาย",
    29601: "อ่านเพิ่มเติม",
    29611: "การโหลด",
    29621: "รายการทั้งหมด (จำนวน)",
    29631: "Google ธุรกิจของฉันได้รับการยืนยันแล้ว",
    29641: "ทำเครื่องหมายว่า",
    29651: "เพิ่มชั่วโมง",
    29661: "วันนี้",
    29671: "ที่อยู่ถนน",
    29681: "รหัสไปรษณีย์",
    29691: "ระบุว่าเป็นสีดำ",
    29701: "เพิ่ม URL",
    29711: "โพสต์",
    29721: "ติดต่ออีเมล",
    29731: "อัพเดต Covid_19",
    29741: "เปลี่ยนแปลงธุรกิจของคุณ?",
    29751: "แคมเปญ",
    29761: "สั่งซื้อออนไลน์",
    29771: "ซื้อ",
    29781: "เรียกตอนนี้",
    29791: "ตอนนี้",
    29801: "ซิงค์ตำแหน่งนี้หรือไม่",
    29811: "รายชื่อ Facebook",
    29821: "สร้างรายชื่อ Facebook ใหม่",
    29831: "ที่ถูกเลือก",
    29841: "รายละเอียดธุรกิจ",
    29851: "ผู้ติดต่อ",
    29861: "ตัวแปร",
    29871: "รหัสภายใน",
    29881: "คลิกเพื่อเชื่อมต่อ",
    29891: "กลับไปที่อัปโหลด",
    29901: "ดูคำถาม & คำตอบบน Google",
    29911: "จำเป็นต้อง",
    29921: "ปิดการใช้งาน",
    29931: "ตรวจสอบการยืนยันอย่างใกล้ชิด",
    29941: "ตรวจสอบการตอบกลับตอบกลับ",
    29951: "ตรวจสอบการยืนยันการลบ",
    29961: "ภาค",
    29971: "ตอบคำถามนี้",
    29981: "จัดการ",
    29991: "Create Google Post",
    30001: "สร้าง Google Post",
    30011: "จัดการ Google Post",
    30021: "ซ่อนสถานที่",
    30031: "เลือกหน้าปัจจุบัน",
    30041: "สร้าง Facebook Post",
    30051: "ลบทั้งหมด",
    30061: "บันทึกตัวกรอง",
    30071: "การค้นหาบทบาท",
    30081: "ค้นหาผู้ใช้",
    30091: "บรรณาธิการทั้งหมด",
    30101: "กำหนดให้คะแนน (จำเป็น)",
    30111: "ป้อนชื่อแม่แบบ (จำเป็น)",
    30121: "ตัวแปรเทมเพลตที่กำหนดเอง (ไม่จำเป็น)",
    30131: "เลือกหรือสร้างหัวข้อ (ไม่บังคับ)",
    30141: "มอบหมายให้ตำแหน่งเดียว (ไม่บังคับ)",
    30151: "กำหนดให้แท็กเอนทิตี (ไม่บังคับ)",
    30161: "ตรวจสอบตัวแปร",
    30171: "ผู้ตรวจสอบชื่อแรก",
    30181: "ผู้ตรวจสอบชื่อเต็ม",
    30191: "ตัวแปรตำแหน่ง",
    30201: "ตอบชื่อตำแหน่ง",
    30211: "ชื่อตำแหน่งทางภูมิศาสตร์",
    30221: "คำตอบสำหรับการตรวจสอบนี้ถูกส่งไปแล้ว",
    30231: "คำตอบสำหรับการตรวจสอบนี้ไม่สามารถส่งได้อีกต่อไป คุณสามารถลบคำตอบนี้เพื่อลบออกจากที่นี่",
    30241: "คุณต้องการซิงค์ข้อมูลของสถานที่นี้หรือไม่? สิ่งนี้จะดึงการอัปเดตทั้งหมดที่ทำกับตำแหน่ง",
    30251: "ให้ลูกค้ารู้เกี่ยวกับการเปลี่ยนแปลงธุรกิจของคุณเนื่องจาก Covid-19",
    30261: "ส่งเดี๋ยวนี้",
    30271: "ค้นหาตู้โชว์",
    30281: "ใช้การควบคุมทางด้านขวาเพื่อสร้างตู้โชว์การตรวจสอบที่แน่นอน คลิกที่ปุ่ม 'ใช้' เพื่อโหลดตัวอย่างทันที",
    30291: "สร้างตู้โชว์รีวิวของคุณ",
    30301: "แสดงรายละเอียด",
    30311: "ตั้งชื่อตู้โชว์นี้",
    30321: "ที่ตั้งของแต่ละบุคคล",
    30331: "กลุ่มสถานที่ตั้ง",
    30341: "ชื่อตู้โชว์",
    30351: "ซ่อน",
    30361: "ผู้ตรวจสอบภาพ / อวตาร",
    30371: "แสดง",
    30381: "เลือกชุดตรวจสอบ",
    30391: "ทบทวนแหล่งที่มา",
    30401: "รีวิวจาก",
    30411: "สร้างตู้โชว์",
    30421: "คะแนนขั้นต่ำ",
    30431: "คะแนนเฉพาะความคิดเห็น",
    30441: "กำหนดการนำเสนอ",
    30451: "จำนวนการตรวจสอบสูงสุด",
    30461: "ความคิดเห็นสูงสุดความคิดเห็น",
    30471: "ความคิดเห็นสูงสุดต่อหน้า",
    30481: "เค้าโครงที่ตอบสนอง",
    30491: "เรียงลำดับ",
    30501: "ใหม่ล่าสุดก่อน",
    30511: "สีการให้คะแนนดาว",
    30521: "ตรวจสอบความคิดเห็น",
    30531: "โลโก้ต้นทาง",
    30541: "วันสอบทาน",
    30551: "วันที่ที่แม่นยำ",
    30561: "ครอบครัวแบบอักษร",
    30571: "ตู้โชว์ชื่อเรื่อง",
    30581: "ผู้ตรวจสอบชื่อชื่อ",
    30591: "ขนาดความคิดเห็น",
    30601: "ตั้งค่าการแทนที่",
    30611: "ขาไปด้านบน",
    30621: "ไม่รวม",
    30631: "บทวิจารณ์ของทีม",
    30641: "ต้องการความช่วยเหลือ",
    30651: "รอลูกค้า",
    30661: "รอความคิดเห็น",
    30671: "ข้อเสนอแนะใหม่",
    30681: "ค้นหาชื่อ",
    30691: "ไม่ได้รับมอบหมาย",
    30701: "อัปเดตเรียบร้อยแล้ว",
    30711: "ชื่อเนื้อหาแคมเปญ (ไม่บังคับ)",
    30721: "ข้อกำหนดและเงื่อนไข (ไม่จำเป็น)",
    30731: "คุณแน่ใจหรือว่าต้องการลบผู้ใช้รายนี้? เมื่อลบออกแล้วผู้ใช้จะไม่สามารถเข้าถึงโปรไฟล์นี้ได้อีกแล้วเว้นแต่จะได้รับเชิญ",
    30741: "คุณต้องการที่จะลบผู้ใช้นี้หรือไม่",
    30751: "การกระจายการตอบสนอง",
    30761: "เราจะส่งอีเมล () พร้อมลิงค์เพื่อดาวน์โหลดรีวิว CSV",
    30771: "โปรไฟล์นี้มีมากกว่า 100 แห่ง เราจะส่งอีเมลถึงคุณพร้อมลิงค์ดาวน์โหลด",
    30781: "ผู้ใช้ตอบ",
    30791: "ทำเครื่องหมายตอบ",
    30801: "ตอบกลับปลายทาง",
    30811: "แดชบอร์ดรีวิว",
    30812: "ภาพรวม",
    30813: "เฉลี่ย",
    30814: "คะแนนเฉลี่ย",
    30815: "ตำแหน่ง",
    30816: "ความสุข",
    30817: "อัตราส่วนคำ",
    30818: "อัตราส่วนการตอบกลับ",
    30819: "รีวิวตามแหล่งที่มา",
    30820: "รีวิวตามคะแนน",
    30821: "การตอบกลับตามคะแนน",
    30822: "รีวิวล่าสุด",
    30823: "คุณได้รับรีวิว {x} รายการในช่วง {x} วันที่ผ่านมา นี่คือรายการล่าสุด",
    30824: "จำนวนรีวิวเฉลี่ยต่อสถานที่หลักในช่วงเวลาที่ระบุ",
    30825: "เปอร์เซ็นต์ของรีวิวที่มีคะแนน 4 ดาวและ 5 ดาว",
    30826: "คะแนนความสุขคือภาพรวมของเปอร์เซ็นต์รีวิวบวก ลบเปอร์เซ็นต์รีวิวลบ",
    30827: "เปอร์เซ็นต์ของความคิดเห็นทั้งหมดที่พบในรีวิว 5 ดาวและ 4 ดาวเมื่อเทียบกับคำทั้งหมดที่แชร์ในช่วงเวลา ช่วงนี้ไปจาก 5 ดาวถึง 1 ดาว",
    30828: "เปอร์เซ็นต์ของรีวิวภายในช่วงเวลาที่ได้รับการตอบกลับ",
    30829: "การลดลงใน {x data} จาก {xx} วันก่อนหน้า",
    30830: "การเพิ่มขึ้นใน {x data} จาก {xx} วันก่อนหน้า",
    30831: "ไม่มีการเปลี่ยนแปลงใน {x data} จาก {xx} วันก่อนหน้า",
    30832: "คลิกเพื่อดูรีวิวเหล่านี้",
    30833: "(ชื่อสถานที่) , (x) ดาว, นักวิจารณ์: (x)",
    30834: "รีวิว & คะแนนเฉลี่ย",
    30835: "การนับรีวิวตามเวลาจัดเรียงตามระดับดาว + แผนภูมิแบบเส้นของคะแนนเฉลี่ยการจัดอันดับ",
    30836: "เปอร์เซ็นต์ตามระดับดาว",
    30837: "การนับรีวิวตามเวลาจัดเรียงตามระดับดาวเป็นเปอร์เซ็นต์ของทั้งหมด",
    30838: "จำนวนสะสม & คะแนนเฉลี่ย",
    30839: "ยอดรวมรีวิวและคะแนนเฉลี่ยสำหรับช่วงเวลาของรายงาน",
    30840: "รีวิวตามแหล่งที่มา",
    30841: "จำนวนรีวิวในช่วงเวลาที่กำหนดตามแหล่งที่มา",
    30842: "คะแนนความสุขตามกาลเวลา",
    30843: "คะแนนความสุขสุทธิต่อช่วงเวลาตามช่วงรายงาน",
    30844: "วันของสัปดาห์",
    30845: "วันของเดือน",
    30846: "เดือนของปี",
    30847: "ประเทศชั้นนำ",
    30848: "รัฐชั้นนำ",
    30849: "เมืองชั้นนำ",
    30850: "การตอบกลับ",
    30851: "อัตราการตอบกลับโดยรวดเร็ว",
    30852: "มัธยฐาน",
    30853: "จำนวนการตอบกลับที่เผยแพร่ในช่วงเวลาที่กำหนดและค่าเฉลี่ยต่อสถานที่",
    30854: "เปอร์เซ็นต์ของรีวิวที่ได้รับการตอบกลับภายใน 2 วันและเวลาตอบที่เป็นมัธยฐาน",
    30855: "จำนวน & อัตราส่วนการตอบกลับ",
    30856: "จำนวนการตอบกลับตามระดับดาวและอัตราส่วนการตอบกลับโดยรวม",
    30857: "เวลาเฉลี่ยในการตอบกลับ",
    30858: "เวลาเฉลี่ยในการตอบกลับเป็นวัน",
    30859: "การกระจายการตอบกลับ",
    30860: "ฮิสโตแกรมของเวลาตอบกลับรีวิวแบ่งออกเป็น 10 ระดับ",
    30861: "มีความสุข",
    30862: "อัตราส่วน",
    30863: "ช่วงชีวิต",
    30864: "จำนวนบันทึกของสถานที่หลัก พร้อมกับบันทึกที่ยังไม่ได้แมป",
    30865: "พลังงาน",
    30866: "อัตราส่วนความคิดเห็น",
    30867: "ความยาวของความคิดเห็น",
    30868: "ช่องว่างของอัตราส่วน",
    30869: "ช่องว่างของความยาว",
    30870: "รีวิวที่มีและไม่มีความคิดเห็น",
    30871: "จำนวนคำเฉลี่ยต่อคะแนนดาว",
    30872: "เปอร์เซ็นต์ของคำในแต่ละคะแนนดาว",
    30873: "เปอร์เซ็นต์อัตราส่วนความคิดเห็น",
    30874: "เปอร์เซ็นต์ของรีวิวทั้งหมดที่มีความคิดเห็นของลูกค้า",
    30875: "นับจำนวนคำในความคิดเห็น",
    30876: "จำนวนคำเฉลี่ยที่มีในรีวิวที่มีความคิดเห็น",
    30877: "การกระจายคำในความคิดเห็น",
    30878: "เปอร์เซ็นต์ของคำในแต่ละระดับดาวในแต่ละช่วงเวลา",
    30879: "เปอร์เซ็นต์ของการรีวิวเชิงบวกที่มีความคิดเห็นลบเปอร์เซ็นต์ของการรีวิวเชิงลบ",
    30880: "ความยาวเฉลี่ยของการรีวิวเชิงบวกลบความยาวเฉลี่ยของการรีวิวเชิงลบ",
    30881: "รีวิวที่มีอัตราการตอบกลับ",
    30882: "อัตราความยาวของความคิดเห็น",
    30883: "มุมมองแบบตาราง",
    30884: "ตำแหน่งเฉลี่ย",
    30885: "คะแนนเฉลี่ยของรีวิวสถานที่และเปอร์เซ็นต์ของสถานที่ที่มีคะแนนเกิน 4.0 ในช่วงเวลา.",
    30886: "กริดประสิทธิภาพการรีวิว",
    30887: "นำเสนอคะแนนเฉลี่ยของสถานที่เทียบกับปริมาณการรีวิวเพื่อระบุค่าผิดปกติ",
    30888: "ความรู้สึก",
    30889: "อิทธิพล",
    30890: "แดชบอร์ดประสิทธิภาพ",
    30891: "กริดผู้นำ",
    30892: "ยอดดูทั้งหมด",
    30893: "อัตราการแปลง",
    30894: "ยอดดูทั้งหมดและยอดดูเฉลี่ยต่อสถานที่",
    30895: "ดูแผนที่บนเดสก์ท็อปและมือถือพร้อมการแยกเปอร์เซ็นต์",
    30896: "การดูการค้นหาท้องถิ่นบนเดสก์ท็อปและมือถือพร้อมการแบ่งเปอร์เซ็นต์",
    30897: "การดำเนินการทั้งหมดพร้อมการแบ่งเปอร์เซ็นต์ระหว่างการโทร คลิกเว็บไซต์ และเส้นทางการขับขี่",
    30898: "อัตราการแปลงรวมของการดำเนินการ/การดูสำหรับการโทร คลิกเว็บไซต์ และเส้นทางการขับขี่",
    30899: "การดูของลูกค้า",
    30900: "ลูกค้ามองเห็นธุรกิจของคุณอย่างไรและที่ไหน",
    30901: "การกระทำของลูกค้า",
    30902: "การกระทำที่ติดตามได้จากรายชื่อ Google ของคุณ",
    30903: "เปอร์เซ็นต์ของการแสดงผลรายการธุรกิจที่ส่งผลให้เกิดการดำเนินการ",
    30904: "ประสิทธิผลตามสถานที่ตั้ง",
    30905: "จำนวนการดูทั้งหมดเทียบกับอัตราการแปลง (การกระทำ/ยอดดู) เพื่อแสดงประสิทธิภาพของแต่ละสถานที่ในการสร้างการดูและแปลงเป็นการดำเนินการ",
    30906: "ประสิทธิภาพตามเมือง",
    30907: "ยอดดูทั้งหมดเทียบกับอัตราการแปลง (การกระทำ/ยอดดู) สำหรับแต่ละเมือง",
    30908: "ประสิทธิผลตามกลุ่ม",
    30909: "ยอดดูทั้งหมดเทียบกับอัตราการแปลง (การกระทำ/ยอดดู) สำหรับแต่ละกลุ่มที่กำหนดเอง",
    30910: "จำนวนการดูสูง + การแปลงต่ำ",
    30911: "จำนวนการดูสูง + การแปลงสูง",
    30912: "จำนวนการดูต่ำ + การแปลงต่ำ",
    30913: "จำนวนการดูต่ำ + การแปลงสูง",
    30914: "มือถือ",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "ไซต์",
    30920: "การโทร",
    30921: "คะแนนสุขภาพ",
    30922: "ประสิทธิภาพประจำวัน",
    30923: "เลือกสถานที่จากตารางและเมตริก (การดูหรือการกระทำ)",
    30924: "ระดับความสุข",
    30925: "ชื่อ/เป็นมิตร",
    30926: "{x} สถานที่ด้วยคะแนนเฉลี่ย {y} ดาวใน {xx} วันที่ผ่านมา",
    30927: "ข้างบน",
    30928: "กลุ่ม",
    30929: "ทั้งหมดดู",
    30930: "ทั้งหมดการดำเนินการ",
    30931: "เดสก์ท็อป",
    30932: "ถึงขีดจำกัดสูงสุด: เลือกได้สูงสุด 8 สถานที่สำหรับแผนภูมิ",
    30933: "นักวิจารณ์",
    30934: "ความคิดเห็นโดยรวม",
    30935: "การกระจายคะแนนความรู้สึกใน {XX} หัวข้อ",
    30936: "ความรู้สึกตามหัวข้อ",
    30937: "ความถี่ของหัวข้อและคะแนนความรู้สึกที่ Corresponding",
    30938: "เชิงบวกมาก",
    30939: "เชิงลบมาก",
    30940: "กฎการทำงานอัตโนมัติที่ถูกกระตุ้นสำหรับรีวิวใหม่บน",
    30941: "กฎการทำงานอัตโนมัติที่ถูกกระตุ้นสำหรับรีวิวที่อัปเดตบน",
    30942: "อนุมัติการตอบกลับบน",
    30943: "กำหนดแท็ก",
    30944: "มอบหมายการตรวจสอบให้",
    30945: "ที่",
    30946: "ส่งการตอบกลับอัตโนมัติ",
    30947: "เจ้าของธุรกิจสร้างการตอบกลับภายนอกใหม่บน",
    30948: "โดยกฎอัตโนมัติบน",
    30949: "โดยระบบบน",
    30950: "สร้างใหม่",
    30951: "สร้างการตอบกลับใหม่บน",
    30952: "สร้างบันทึกการตรวจสอบสำหรับ",
    30953: "ลบบันทึกบน",
    30954: "ลบบันทึกการตรวจสอบบน",
    30955: "ลบการตอบกลับบน",
    30956: "แก้ไขการตอบกลับบน",
    30957: "จาก",
    30958: "สร้างการตอบกลับอัตโนมัติบน",
    30959: "ท้องถิ่น",
    30960: "การแจ้งเตือน",
    30961: "แจ้งเตือนแล้ว",
    30962: "ภาพรวม",
    30963: "ดำเนินการ",
    30964: "การตอบสนอง",
    30965: "ตอบกลับได้ย้ายไปยังกล่องจดหมายอนุมัติเมื่อ",
    30966: "ตอบกลับถูกย้ายไปยังกล่องจดหมายออกและกำหนดเวลาในการโพสต์",
    30967: "ตอบกลับโพสต์ไปยัง",
    30968: "ทบทวนที่ได้รับมอบหมายให้",
    30969: "ทบทวนเมื่อ",
    30970: "ได้รับการทบทวนจาก",
    30971: "ส่งบันทึกถึง",
    30972: "ระบบกำหนดแท็กภาษา",
    30973: "ระบบกำหนดการตอบกลับอัตโนมัติเมื่อ",
    30974: "แท็ก",
    30975: "ทีมตามกฎอัตโนมัติเมื่อ",
    30976: "ไทม์ไลน์",
    30977: "ถึง",
    30978: "อัปเดต",
    30979: "อัปเดตบันทึกการตรวจสอบเมื่อ",
    30980: "อัปเดตการให้คะแนนรีวิวจาก",
    30981: "อัปเดตสถานะการตรวจสอบจาก",
    30982: "อัปเดตสถานะการตรวจสอบเป็น",
    30983: "อัปเดตความคิดเห็นเกี่ยวกับ",
    30984: "ผ่าน API ในระหว่าง",
    30985: "ผ่าน Pub-Sub เมื่อ",
    30986: "ไม่มีความคิดเห็นเพิ่มเติม",
    30987: "บน",
    30988: "ระบบ",
    30989: "โดย",
    30990: "รีวิวเอามาจาก.",
    30991: "ได้รับมอบหมายให้",
    30992: "แท็กที่กำหนด:",
    30993: "กลุ่มแท็กที่กำหนด:",
    30994: "ลบแท็ก:",
    30995: "รีวิวพร้อมการอัปเดต",
    30996: "รีวิวโดยไม่มีการอัปเดต",
    30997: "เลือกแท็กทั้งหมด",
    30998: "เลือกที่ไม่มีแท็ก",
    30999: "รอการอนุมัติ",
    31000: "เก่าที่สุดก่อน",
    31001: "คุณไม่มีบันทึกที่บันทึกไว้",
    31002: "ตอบกลับในกล่องขาออก",
    31003: "เวอร์ชันของรีวิว",
    31004: "รายละเอียดรีวิว",
    31005: "เปิดข้อมูล",
    31006: "ความสัมพันธ์",
    31007: "ข้อผิดพลาด",
    31008: "หลัก",
    31009: "หมวดหมู่",
    31010: "ลิงก์โซเชียล",
    31011: "รูปภาพต้นฉบับถูกลบโดยผู้ใช้หรือแพลตฟอร์ม"
  },
  hindi: {
    2013: "संचयी",
    2028: "टीम की समीक्षा",
    2029: "को स्वचालित",
    2030: "भरा हुआ",
    2031: "सौंपा गया",
    2032: "खोज उपयोगकर्ता",
    2033: "ईमेल भेजें",
    2034: "लिखें",
    2035: "Ai उत्तर",
    2036: "तेज़ी से उत्तर",
    2037: "पुनः जेनरेट",
    2038: "अनुमोदन",
    2039: "स्रोत पर पोस्ट करें",
    2040: "उत्तर भेजा गया",
    2041: "कोई संदेश नहीं भेजा गया",
    2042: "साफ़",
    2043: "बंद किया हुआ",
    2044: "कोई उत्तर लेख नहीं मिला",
    2045: "प्रतिक्रिया कॉपी करें और स्रोत पर जाएं",
    2046: "उत्तर संपादित करें",
    2047: "उत्तर स्वीकृत करें",
    2048: "उत्तर अपडेट करें",
    2049: "उत्तर हटाएं",
    2050: "क्या आप वाकई इस जवाब को हटाना चाहते हैं?",
    2051: "क्या आप वाकई यह प्रतिक्रिया सबमिट करना चाहते हैं?",
    2052: "क्या आप इस समीक्षा को पुनः स्थापित करना चाहेंगे?",
    2053: "क्या आपको यकीन है ?",
    2054: "क्या आप वाकई इस प्रतिक्रिया को स्वीकृत करना चाहते हैं?",
    2055: "टीमें",
    2056: "रेटंग केवल",
    2057: "रेटंग + लघुटपणी",
    2058: "रेटंग + टपणी",
    2059: "भाषा वारा समीा कर",
    2060: "कृपया 1 और 100 के बीच टिप्पणी की लंबाई प्रदान करें , डिफ़ॉल्ट 20 वर्ण होंग",
    2061: "प्रत्येक असाइन किए गए स्थान प्रबंधक के लिए इंटेलिजेंट समीक्षा उत्तरों की प्रतिलिपि बनाएँ",
    2062: "दाखिल करना",
    2063: "मेल पता",
    2064: "कोई खाता नहीं है?",
    2065: "पहला नाम",
    2066: "उपनाम",
    2067: "कंपनी",
    2068: "कंपनी का नाम",
    2069: "क्या आपके पास पहले से एक खाता मौजूद है?",
    2070: "पासवर्ड दिखाए",
    2071: "पासवर्ड छिपाएं",
    2072: "स्थानीय रूपांतरण",
    2073: "नक्शे मोबाइल",
    2074: "नक्शे डेस्कटॉप",
    2075: "खोज मोबाइल",
    2076: "खोज डेस्कटॉप",
    2077: "खोज दृश्य",
    2078: "मानचित्र दृश्य",
    2081: "सार्वभौमिक (Sārvabhaumik)",
    2091: "विषय के अनुसार (Vishay ke anusār)",
    10010: "1 स्टार",
    10013: "2 स्टार",
    10016: "3 स्टार",
    10019: "4 स्टार",
    10022: "5 सितारा",
    10025: "100-300 शब्द",
    10120: "कार्रवाई",
    10123: "सक्रिय",
    10124: "हमेशासय",
    10126: "सक्रिय संगठन",
    10129: "जोड़ें",
    10132: "एक बटन जोड़ें",
    10135: "एक बटन जोड़ें (वैकल्पिक)",
    10138: "खाता जोड़ो",
    10141: "अतिरिक्त फोन जोड़ें",
    10144: "एक खाता जोड़ें",
    10147: "एक और श्रेणी जोड़ें",
    10150: "एक और लेबल जोड़ें",
    10153: "विशेषताएँ जोड़ें",
    10156: "रेखा जोड़ें",
    10159: "नई तिथि जोड़ें",
    10162: "नई समीक्षा टैग जोड़ें",
    10165: "नई भूमिका जोड़ें",
    10168: "उद्घाटन तिथि जोड़ें",
    10171: "प्रोफ़ाइल जोड़ें",
    10174: "रिपोर्ट जोड़ें",
    10177: "रिपोर्ट जोड़ें",
    10180: "भूमिका जोड़ें",
    10181: "समीक्षा टैग जोड़ें",
    10183: "अतिरिक्त श्रेणी",
    10186: "अतिरिक्त फोन",
    10189: "पता",
    10192: "व्यवस्थापक",
    10195: "प्रशासक",
    10198: "AdWords स्थान एक्सटेंशन",
    10201: "AdWords स्थान एक्सटेंशन फोन",
    10204: "सभी",
    10207: "सभी समीक्षाएँ",
    10210: "इस भूमिका को आवंटित सभी उपयोगकर्ताओं को निम्नलिखित सुविधाओं तक पहुंच होगी",
    10213: "आवेदन करना",
    10216: "अनुमोदन इनबॉक्स",
    10219: "क्या आप वाकई इस उपयोगकर्ता के पासवर्ड को रीसेट करना चाहते हैं?",
    10222: "क्या आपको यकीन है?",
    10225: "क्षेत्र",
    10228: "क्षेत्रों",
    10231: "विशेषता सूची",
    10234: "लेखा प्राधिकृत",
    10237: "औसत",
    10240: "औसत मात्रा",
    10243: "औसत श्रेणी",
    10244: "औसत। रेटिंग",
    10246: "प्रति स्थान औसत",
    10249: "प्रतिक्रिया की प्रतीक्षा",
    10320: "वापस",
    10321: "व्यवस्थापक पर वापस",
    10323: "बिलिंग",
    10326: "पुस्तक",
    10329: "थोक अपलोड पोस्ट",
    10332: "थोक अपलोड टैग",
    10335: "थोक अपलोड टीएसवी",
    10338: "व्यवसाय का नाम",
    10520: "पंचांग",
    10523: "रद्द करना",
    10526: "मास्टर स्थान मानचित्रण अपलोड नहीं कर सकते!",
    10529: "श्रेणी",
    10532: "भूमिका",
    10535: "उद्धरण इतिहास",
    10538: "शहर",
    10541: "यहां क्लि�� करें",
    10544: "एक उपयोगकर्ता को यह भूमिका निभाने के लिए क्लिक करें",
    10547: "सीओ",
    10548: "पासवर्ड की पुष्टि कीजिये",
    10550: "प्रतिलिपि",
    10553: "कॉपी और पेस्ट",
    10556: "भूमिका नहीं बदल सका!",
    10559: "पोस्ट अपलोड नहीं कर सका",
    10562: "देशों",
    10565: "देश",
    10568: "कूपन कोड",
    10571: "परचा कोड (वैकल्पिक)",
    10574: "नीचे विकल्प चुनकर एक नया फ़िल्टर बनाएं",
    10577: "नया फ़िल्टर बनाएं",
    10580: "नई रिपोर्ट बनाएं",
    10583: "पोस्ट बनाएँ",
    10586: "टैग बनाएं",
    10589: "यह रिपोर्ट बनाएं",
    10592: "इस भूमिका को बनाएं",
    10595: "के द्वारा बनाई गई",
    10598: "ग्राहक क्रियाएं",
    10720: "डी, दिन के लिए संक्षिप्त पत्र",
    10723: "चकरानेवाला",
    10726: "दिनांक",
    10729: "तिथि सीमा",
    10732: "दिन",
    10735: "निष्क्रिय करें",
    10738: "गलती करना",
    10741: "पोस्ट करने से पहले देरी",
    10744: "देरी से जवाब भेजना",
    10747: "देरी से जवाब भेजना",
    10750: "हटाएं",
    10753: "हटाएं?",
    10754: "प्रोफ़ाइल हटाएं",
    10756: "वर्णन",
    10759: "विवरण",
    10762: "सीधे",
    10765: "प्रत्यक्ष प्रश्न",
    10768: "दिशा-निर्देश",
    10771: "खोज",
    10774: "विशिष्ट दृश्य",
    10777: "सभी डेटा CSV के रूप में डाउनलोड करें",
    10780: "पीडीएफ के रूप में डाउनलोड करें",
    10783: "Google स्थान विवरण डाउनलोड करें",
    10786: "इस डेटा को CSV के रूप में डाउनलोड करें",
    10789: "ड्राफ्ट",
    10792: "ड्राइविंग निर्देश",
    10795: "दिन के हिसाब से ड्राइविंग निर्देश",
    10920: "संपादित करें",
    10923: "प्रोफ़ाइल संपादित करें",
    10926: "रिपोर्ट संपादित करें",
    10929: "इस रिपोर्ट को संपादित करें",
    10932: "संपादक",
    10935: "ईमेल",
    10938: "अंतिम समय",
    10941: "AdWords स्थान एक्सटेंशन दर्ज करें",
    10944: "एंटिटी टैग नाम दर्ज करें",
    10947: "लेबल दर्ज करें",
    10950: "खोज पाठ दर्ज करें",
    10953: "टैग नाम दर्ज करें",
    10956: "बराबर",
    10959: "आयोजन",
    10962: "घटना की जानकारी",
    10965: "कार्यक्रम का शीर्षक",
    10968: "प्रत्येक",
    10971: "उदाहरण। com",
    10974: "उदाहरण: स्टोर या ऑनलाइन में 20% की छूट",
    11120: "सुविधा पहुंच प्रबंधन",
    11123: "फिल्टर",
    11126: "पासवर्ड भूल गए?",
    11129: "शुक्रवार",
    11320: "ऑफर हासिल करें",
    11323: "से अधिक",
    11520: "खुशी रेटिंग",
    11525: "मदद",
    11530: "होउडे",
    11535: "घंटा",
    11540: "घंटे",
    11545: "ग्राहक आपके व्यवसाय के लिए कैसे खोजते हैं",
    11720: "छवि",
    11723: "छवि यूआरएल",
    11726: "नक्शे में",
    11729: "खोज में",
    11732: "इनबॉक्स",
    11735: "अप्रत्यक्ष प्रश्न",
    11738: "इनसाइट्स",
    11741: "अपर्याप्त अनुमति",
    11744: "एकीकरण",
    11747: "एकीकरण",
    11750: "उपयोगकर्ता को आमंत्रित करें",
    11753: "आमंत्रित",
    11756: "द्वारा आमंत्रित",
    11759: "आइटम",
    12120: "ज्ञान पैनल",
    12320: "लेबल",
    12323: "अंतिम लॉगइन",
    12326: "आखरी अपडेट",
    12329: "और अधिक जानें",
    12332: "से कम",
    12335: "अपने बटन के लिए लिंक",
    12338: "ऑफ़र रिडीम करने के लिए लिंक",
    12341: "रिडीम ऑफ़र (वैकल्पिक) के लिए लिंक",
    12344: "इस समीक्षा से लिंक करें",
    12347: "लिस्टिंग प्रबंधन",
    12350: "स्थानीय प्रदर्शन",
    12353: "स्थानीय प्रदर्शन अवलोकन",
    12356: "स्थानीय खोज रूपांतरण",
    12359: "जनपद",
    12362: "इलाका",
    12365: "जगह",
    12368: "स्थान विवरण",
    12371: "स्थान आईडी",
    12374: "स्थानों",
    12377: "लॉग इन करें",
    12380: "लॉग आउट",
    12520: "मी, महीने के लिए संक्षिप्त नाम",
    12523: "अपनी पोस्ट स्टैंडआउट को एक फोटो के साथ बनाएं",
    12526: "थोक गतिविधि का प्रबंधन करें",
    12529: "संस्था टैग प्रबंधित करें",
    12532: "स्थानों को प्रबंधित करें",
    12535: "प्रोफ़ाइल प्रबंधित करें",
    12538: "भूमिकाएँ प्रबंधित",
    12541: "उपयोगकर्ताओं को प्रबंधित करें",
    12544: "एमएपीएस",
    12547: "व्यापारी गिनती",
    12550: "व्यापारी तस्वीरें",
    12553: "व्यापारी, फोटो मात्रा बनाम फोटो दृश्य",
    12556: "संदेश",
    12559: "मिनट",
    12562: "सोमवार",
    12565: "महीना",
    12720: "नाम",
    12723: "नई भूमिका का नाम",
    12726: "रिपोर्ट का नाम",
    12729: "एक खाता चाहिए?",
    12732: "नया",
    12735: "अगला पृष्ठ",
    12738: "जवाब नहीं",
    12741: "कोई परिणाम नहीं मिला",
    12744: "कोई समीक्षा टैग मौजूद नहीं है",
    12747: "कोई समीक्षा नहीं",
    12750: "नहीं, रद्द करें",
    12753: "उपयोगकर्ताओं की संख्या",
    12756: "टिप्पणियाँ",
    12920: "का",
    12923: "प्रस्ताव",
    12926: "ठीक है",
    12929: "ठीक मिल गया!",
    12932: "एक बार",
    12935: "खुलने की तिथि",
    12938: "आदेश",
    12941: "संगठनों",
    12944: "आउटबॉक्स",
    12947: "मालिक",
    13120: "पृष्ठ",
    13123: "पासवर्ड",
    13126: "पेस्ट टीएसवी",
    13129: "पीडीएफ प्रकार",
    13132: "फ़ोन",
    13135: "दिन के हिसाब से फोन कॉल",
    13138: "फ़ोन नंबर",
    13141: "फोटो मात्रा",
    13144: "फोटो दृश्य",
    13147: "कृपया एक तारक नाम दर्ज करें!",
    13150: "कृपया एक रिपोर्ट नाम दर्ज करें!",
    13153: "कृपया एक सारांश दर्ज करें!",
    13156: "कृपया एक शीर्षक दर्ज करें!",
    13159: "कृपया एक वैध समय दर्ज करें!",
    13162: "कृपया एक मान्य यूआरएल दर्ज कीजिए!",
    13165: "कृपया अपने स्थान विवरण अपडेट करने के लिए पृष्ठ को रीफ्रेश करें",
    13168: "कृपया पुनः लोड करें",
    13171: "कृपया अनुसूची प्रकार का चयन करें!",
    13174: "पोस्ट इतिहास",
    13177: "पदों",
    13180: "पिछला पृष्ठ",
    13183: "प्राथमिक श्रेणी",
    13186: "प्राथमिक फोन",
    13189: "प्राथमिक टेलीफ़ोन नंबर",
    13192: "प्रोफाइल",
    13195: "सार्वजनिक गणना",
    13198: "सार्वजनिक तस्वीरें",
    13201: "सार्वजनिक तस्वीरें",
    13204: "प्रकाशित",
    13520: "रेटिंग",
    13523: "वास्तविक समय अधिसूचनाएं",
    13526: "प्राप्तकर्ताओं की सूची",
    13529: "पुनरावर्ती",
    13532: "उपयोगकर्ता निकालें",
    13535: "जवाब",
    13538: "उत्तर स्वीकृति",
    13541: "रिपोर्ट प्रबंधन",
    13544: "रिपोर्ट नाम",
    13547: "आख्या की प्रकार",
    13550: "पासवर्ड रीसेट",
    13553: "स्टार रेटिंग द्वारा प्रतिक्रिया",
    13556: "समीक्षा गणना",
    13559: "समीक्षा डाउनलोड करें",
    13562: "समीक्षा सेटिंग्स",
    13565: "समीक्षा स्रोत",
    13568: "टैग की समीक्षा करें",
    13571: "रिव्यूलिंक",
    13574: "समीक्षा",
    13577: "स्टार रेटिंग द्वारा समीक्षा",
    13580: "समीक्षा बनाम औसत रेटिंग",
    13583: "इनबॉक्स की समीक्षा करें",
    13586: "समीक्षा प्रबंधन",
    13589: "समीक्षा, महीने का दिन",
    13592: "समीक्षा, सप्ताह का दिन",
    13595: "समीक्षा, वर्ष का महीना",
    13598: "भूमिका",
    13601: "भूमिका विवरण",
    13604: "भूमिका का नाम",
    13720: "शनिवार",
    13723: "सहेजें",
    13726: "कस्टम फ़िल्टर के रूप में सहेजें",
    13729: "नया फ़िल्टर सहेजें",
    13732: "भूमिका निभाना",
    13735: "उत्तर बचाओ",
    13738: "कार्यक्रम दिनांक",
    13741: "अनुसूची पद",
    13742: "एक रिपोर्ट अनुसूची",
    13744: "अनुसूचित समय",
    13747: "अनुसूची प्रकार",
    13750: "खोज",
    13753: "खोजें",
    13756: "चुनते हैं",
    13759: "एक मौजूदा फ़िल्टर का चयन करें",
    13762: "श्रेणी का चयन करें",
    13765: "शहर चुनें",
    13768: "देश चुनें",
    13771: "तिथि और समय का चयन करें",
    13774: "तिथि सीमा का चयन करें",
    13777: "समीक्षा करने के लिए संपादक का चयन करें",
    13780: "इकाई टैग का चयन करें",
    13783: "फ़िल्टर का चयन करें",
    13786: "फिल्टर का चयन करें",
    13789: "ग्रैन्युलरिटी का चयन करें",
    13792: "संगठन का चयन करें",
    13795: "समीक्षा टैग चुनें",
    13798: "सहेजे गए फ़िल्टर का चयन करें",
    13801: "सोर्स चुनें",
    13804: "राज्य चुनें",
    13807: "समय का चयन करें",
    13810: "स्वयं",
    13813: "इसे अनुमोदन के लिए भेजें",
    13816: "इसे आउटबॉक्स पर भेजें",
    13819: "भेज दिया",
    13822: "सेवाएं",
    13825: "समायोजन",
    13828: "सेटिंग प्रबंधन",
    13831: "दुकान",
    13834: "पद दिखाओ",
    13837: "वाम नव शो / छुपाएं",
    13840: "साइन अप करें",
    13843: "एकल स्थान संपादित करें",
    13846: "माफ़ करना!",
    13849: "इसके अनुसार क्रमबद्ध करें",
    13852: "विशेष घंटे",
    13855: "विशिष्ट पहुंच",
    13858: "मानक",
    13861: "समय शुरू",
    13864: "राज्य",
    13867: "स्थिति",
    13870: "दुकान",
    13873: "संग्रह कोड",
    13876: "गली",
    13879: "सारांश देखें",
    13882: "रविवार का दिन",
    13885: "इस खाते को सिंक करें",
    13920: "टेलीफ़ोन",
    13923: "नियम और शर्तें",
    13926: "गुरूवार",
    13929: "समय",
    13932: "शीर्ष इलाके",
    13935: "कुल",
    13938: "मंगलवार",
    14120: "अनुत्तरित",
    14123: "प्रारूप का अनिश्चित?",
    14126: "डालना",
    14129: "स्थान विवरण अपलोड करें",
    14132: "स्थान मानचित्र अपलोड करें",
    14135: "स्थान मानचित्रण अपलोड करें",
    14138: "TSV अपलोड करें",
    14141: "यूआरएल",
    14144: "यूज़र आईडी",
    14320: "छवि देखें",
    14323: "प्रोफ़ाइल देखें",
    14326: "विचारों",
    14520: "डब्ल्यू, सप्ताह के लिए संक्षिप्त पत्र",
    14523: "वेबसाइट",
    14526: "दिन के हिसाब से वेबसाइट",
    14529: "वेबसाइट का नाम",
    14532: "बुधवार",
    14535: "सप्ताह",
    14538: "ग्राहक क्या कार्य करते हैं",
    14541: "जब एक समीक्षा का उत्तर दिया जाता है",
    14544: "जहां ग्राहक आपके व्यवसाय को देखते हैं",
    14547: "क्या आप इस निर्धारित पोस्ट को मिटाना चाहेंगे?",
    14550: "अपना शीर्षक लिखें",
    14920: "वर्ष",
    14923: "हाँ, जारी रखें",
    14926: "आप इसे संलग्न करने के लिए फ़िल्टर का चयन करके इस भूमिका के साथ उपयोगकर्ताओं की पहुंच को सीमित करना चुन सकते हैं।",
    14929: "तुम्हारा नाम",
    15120: "ज़िप",
    20010: "सोमवार",
    20011: "सोमवार",
    20020: "मंगलवार",
    20021: "मंगल",
    20030: "बुधवार",
    20031: "बुध",
    20040: "गुरुवार",
    20041: "गुरु",
    20050: "शुक्रवार",
    20051: "शुक्र",
    20060: "शनिवार",
    20061: "बैठ गया",
    20070: "रविवार",
    20071: "रवि",
    20110: "जनवरी",
    20111: "जनवरी",
    20120: "फ़रवरी",
    20121: "फ़रवरी",
    20130: "जुलूस",
    20131: "मार्च",
    20140: "अप्रैल",
    20141: "अप्रैल",
    20150: "मई",
    20151: "मई",
    20160: "जून",
    20161: "जून",
    20170: "जुलाई",
    20171: "जुलाई",
    20180: "अगस्त",
    20181: "अगस्त",
    20190: "सितंबर",
    20191: "सितम्बर",
    20200: "अक्टूबर",
    20201: "अक्टूबर",
    20210: "नवंबर",
    20211: "नवम्बर",
    20220: "दिसंबर",
    20221: "दिसम्बर",
    20231: "समीक्षा और रेटिंग",
    20241: "प्रतिशत",
    20251: "प्रतिशत के साथ समीक्षा",
    20261: "संचयी",
    20271: "संचयी गिनती",
    20281: "स्रोत",
    20291: "स्रोतों द्वारा समीक्षा करें",
    20301: "ख़ुशी",
    20311: "प्रतिक्रिया समय",
    20321: "स्थान चुनें",
    20331: "समीक्षा कीवर्ड द्वारा खोजें",
    20341: "समीक्षक द्वारा खोजें",
    20351: "चुनते हैं",
    20361: "बराबर",
    20371: "से कम",
    20381: "से अधिक",
    20391: "महीनों का चयन करें",
    20401: "तारीख़ चुनें",
    20411: "इन समीक्षाओं को देखने के लिए क्लिक करें",
    20421: "चयनित तिथि सीमा और मानदंडों के लिए कोई समीक्षा नहीं मिली",
    20431: "स्पष्ट निस्यंदक",
    20441: "एक कस्टम फ़िल्टर हटाएं",
    20451: "Google अपडेट है",
    20461: "सत्यापित",
    20471: "स्थान प्रकाशित",
    20481: "लंबित संपादन",
    20491: "ज्ञान पैनल",
    20501: "समीक्षा लिंक",
    20511: "दिशा-निर्देश",
    20521: "डुप्लिकेट",
    20531: "सक्रिय",
    20541: "अद्यतन कर सकते हैं",
    20551: "हटा सकते हैं",
    20561: "कोई लंबित समीक्षा नहीं",
    20571: "स्थान सक्षम",
    20581: "डिस्कनेक्ट नहीं हुआ",
    20591: "लॉग बदलें",
    20601: "थोक अपलोड छवि",
    20611: "छवि इतिहास",
    20621: "थोक अपलोड नोट",
    20631: "थोक अपलोड q & a",
    20641: "क्यू एंड ए हिस्ट्री",
    20651: "एक प्रश्न जोड़ें",
    20661: "उन ग्राहकों को एक प्रश्न प्रस्तुत करें जो एक मूल मूल्य प्रस्ताव या आपके स्थान के एक अलग प्रतिस्पर्धी लाभ को हाइलाइट करता है। फिर आप सवालों के जवाब दे सकते हैं।",
    20671: "मंच विवरण",
    20681: "ऑटो उत्तर चर",
    20691: "स्थान का नाम",
    20701: "भू-नाम",
    20711: "हस्ताक्षर",
    20721: "जियो नाम (अधिकतम 80 अक्षर)",
    20731: "हस्ताक्षर नाम (अधिकतम 80 वर्ण)",
    20741: "स्वतः जवाब देने वाला",
    20751: "डाउनलोड समीक्षाएँ",
    20761: "स्व प्रतिक्रिया",
    20771: "बाहरी लिंक",
    20781: "प्रतिलिपि समीक्षा",
    20791: "नोट जोड़े",
    20801: "बाहरी नोट",
    20811: "अनुपयुक्त के रूप में चिह्नित करें",
    20821: "हटाए गए चिह्नित करें",
    20831: "क्या आपको यकीन है ?",
    20841: "क्या आप इस समीक्षा को Google से हटाकर चिह्नित करना चाहेंगे?",
    20851: "बचाए गए उत्तर डालें",
    20861: "उत्तर टेम्पलेट के रूप में सहेजें",
    20871: "ऑटो उत्तर टेम्पलेट डालें",
    20881: "भेजना",
    20891: "अनुमोदन के लिए भेजें",
    20901: "ड्राफ्ट के रूप में सेव करें",
    20911: "असाइन नोट",
    20921: "ईमेल नोट",
    20931: "प्राप्तकर्ता",
    20941: "नोट के रूप में सहेजें",
    20951: "बंद करे",
    20961: "रद्द करें",
    20971: "मेल भेजे",
    20981: "आपके पास कोई सहेजे गए नोट नहीं हैं",
    20991: "सारी जानकारी प्राप्त!",
    21001: "दिखाने के लिए कोई प्रविष्टि नहीं",
    21011: "उत्तर भेजे गए",
    21021: "समीक्षक ने कोई टिप्पणी नहीं जोड़ा है",
    21031: "उत्तर दें",
    21041: "उत्तर हटाएं",
    21051: "सहेजी गई उत्तरों की खोज",
    21061: "सहेजे गए उत्तर जोड़ें",
    21071: "इस उत्तर को बचाने के लिए एक समूह और विषय चुनें।",
    21081: "एक समूह का चयन करें या एक बनाने के लिए टाइपिंग शुरू करें",
    21091: "यहां शीर्षक दर्ज करें",
    21101: "उत्तर टेम्पलेट दर्ज करें",
    21111: "कृपया इस उत्तर को बचाने के लिए एक समूह और शीर्षक का चयन/बनाएं।",
    21121: "ऑटो जवाब",
    21131: "ऑटो उत्तर जोड़ें",
    21141: "एक समूह का चयन करें",
    21151: "यहां चर दर्ज करें",
    21161: "अपने चर चुनें",
    21171: "क्या आप जारी रखना चाहते हैं?",
    21181: "इस अनुरोध में ऐसे अनुरोधों के लिए 100 से अधिक समीक्षाएं हैं, हम आपको सीएसवी डाउनलोड करने के लिए एक लिंक के साथ एक ईमेल भेजेंगे।",
    21191: "आपके पास 100 से अधिक समीक्षाएं हैं",
    21201: "समीक्षा सीएसवी डाउनलोड करने के लिए एक लिंक के साथ हम आपको एक ईमेल (एक्स) भेजेंगे।",
    21211: "कार्रवाई",
    21221: "सभी स्थान",
    21231: "एवीजी रेटिंग",
    21241: "ब्रांड",
    21251: "सीधे",
    21261: "खोज",
    21271: "भूगोल",
    21281: "ख़ुशी",
    21291: "प्रश्नों",
    21301: "जवाब",
    21311: "विचारों",
    21321: "पोस्ट अनुसूची",
    21331: "Google पोस्ट शेड्यूल",
    21341: "पोस्ट बनाएँ",
    21351: "पोस्ट प्रबंधित करें",
    21361: "शेड्यूल लोकलपोस्ट",
    21371: "डालना",
    21381: "प्रगति",
    21391: "मान्य और अनुसूच���",
    21401: "अनुसूची की स्थिति",
    21411: "फ़ाइल का चयन करें",
    21421: "एक अनुसूची प्रकार का चयन करें",
    21431: "तुरंत",
    21441: "फ़ाइल समय",
    21451: "समय का चयन करें",
    21461: "सत्यापन के तुरंत बाद पोस्ट करें",
    21471: "फ़ाइल में समय के आधार पर अनुसूची",
    21481: "अपने चयनित समय से अनुसूची फ़ाइल",
    21491: "पंक्ति",
    21501: "सत्यापन प्रगति पर है। प्रसंस्करण समय प्रति मिनट लगभग 40 पद है। सत्यापन के बाद, प्रत्येक पोस्ट की स्थिति अगले पृष्ठ पर उपलब्ध होगी।",
    21511: "पोस्ट संसाधित",
    21521: "सफल सत्यापन",
    21531: "विफल सत्यापन",
    21541: "अनुसूचित",
    21551: "टाइप / एक्शन",
    21561: "पिंड खजूर",
    21571: "शुरू",
    21581: "समाप्त",
    21591: "शीर्षक / उत्पाद",
    21601: "पोस्ट सारांश",
    21611: "स्थिति",
    21621: "सफलता",
    21631: "अनुत्तीर्ण होना",
    21641: "एडिट डिलीट",
    21651: "अंतर्दृष्टि पोस्ट",
    21661: "Google पोस्ट अंतर्दृष्टि",
    21671: "प्रदर्शन",
    21681: "पोस्ट विचार",
    21691: "मीडिया द्वारा पोस्ट",
    21701: "विषय द्वारा पोस्ट",
    21711: "कार्रवाई द्वारा पोस्ट",
    21721: "विश्लेषण",
    21731: "बनाया था",
    21741: "प्रकार",
    21751: "कार्य",
    21761: "स्रोत फ़िल्टर",
    21771: "मंच",
    21781: "लोकलपोस्ट स्थिति अपडेट करें",
    21791: "अभियान बिल्डर",
    21801: "बुद्धिमान ऑटो प्रतिक्रिया",
    21811: "ऑटो प्रतिक्रिया अभियान बिल्डर चालू करें",
    21821: "ऑटो प्रतिक्रिया अनुसूची विकल्प को सक्षम करने से पहले, कृपया नीचे दिए गए निर्देशों का पालन करना सुनिश्चित करें:",
    21831: "इंटेलिजेंट ऑटो प्रतिक्रिया को सक्षम करने से पहले डाउनलोड बॉक्स में अपने ऑटो उत्तर टेम्पलेट्स को जोड़ना सुनिश्चित करें। पहले प्रतिक्रियाओं को तैयार करें ताकि उन्हें स्टार रेटिंग (1-5) को असाइन किया जा सके जो एक इंटेलिजेंट ऑटो प्रतिक्रिया को ट्रिगर करेगा।",
    21841: "अभियान निर्माता में कृपया समीक्षा रसीद और ऑटो प्रतिक्रिया वितरण के बीच देरी का चयन करें। देरी सेटिंग को आदर्श समीक्षा प्रतिक्रिया समय के अनुरूप होना चाहिए, क्योंकि इसका उद्देश्य कार्यक्रम की स्वचालित प्रकृति को मास्क करना है।",
    21851: "अभियान के लिए कृपया ऑपरेशन समय (सप्ताह के सप्ताह और दिन के दिन) सेट करने पर भी विचार करें। डिफ़ॉल्ट टाइमज़ोन सेटिंग GMT + 00: 00 है, इसलिए कृपया उपयुक्त के रूप में अपडेट करें।",
    21861: "अभियान बनाएँ",
    21871: "अपने अभियान को आसानी से पहचानने के लिए एक नाम और कोई भी नोट असाइन करें।",
    21881: "अभियान का नाम",
    21891: "अभियान उत्तरदाता",
    21901: "यदि कोई विकल्प नहीं चुना जाता है, तो साइन अप करने और अधिकृत करने के लिए उपयोग किए जाने वाले ईमेल डिफ़ॉल्ट उत्तरदाता होंगे।",
    21911: "ऑटो उत्तर के लिए उत्तरदाता",
    21921: "अभियान दिनांक सीमा",
    21931: "नोट्स / लक्ष्य",
    21941: "अभियान विवरण",
    21951: "ट्रिगर्स सेट करें",
    21961: "उस प्रकार की समीक्षा चुनें जो इस अभियान के लिए स्वचालित प्रतिक्रिया को संकेत देगा।",
    21971: "टिप्पणी के साथ",
    21981: "बिना टिप्पणी के",
    21991: "पहले का",
    22001: "अगला",
    22011: "दर्शकों को सेट करें (वैकल्पिक)",
    22021: "एक इकाई टैग, एक संगठन, या एक विशिष्ट देश / क्षेत्र / इलाके के आधार पर अभियान का हिस्सा बनने के लिए स्थान सेट करें। यह फ़िल्टर केवल Google समीक्षा और मैप किए गए स्थानों के लिए उपलब्ध हैं",
    22031: "कंपनी",
    22041: "संगठन",
    22051: "निर्धारित अनुसूची",
    22061: "प्रतिक्रिया प्रतिक्रियाओं के लिए पैरामीटर और अनुसूची असाइन करें, यानी लक्षित समीक्षाओं का प्रतिशत और प्रतिक्रियाओं के लिए संचालन संचालन के घंटे।",
    22071: 'कृपया जान लें कि स्वचालित प्रतिक्रिया वर्तमान में केवल "आगे बढ़ने" के आधार पर उपलब्ध हैं। हम उन उपयोगकर्ताओं के लिए अलग-अलग प्रक्रियाओं पर काम कर रहे हैं जो निकट अवधि को स्वचालित रूप से साफ करना चाहते हैं।',
    22081: "प्रतिक्रिया दर",
    22091: "प्रतिक्रिया गणना",
    22101: "ऑटो उत्तर भेजने से पहले देरी",
    22111: "समय-समय पर अनुसूची",
    22121: "दिन का चयन करें और समय-समय पर शेड्यूल ऑटो प्रतिक्रिया के लिए समय निर्धारित करें",
    22131: "Timezone का चयन करें",
    22141: "प्रतिक्रियाएं असाइन करें",
    22151: "सूची से, इस अभियान के लिए रोटेशन में उपयोग करने के लिए कौन सी प्रतिक्रियाएं चुनें।",
    22161: "पुष्टि करना",
    22171: 'नीचे दिए गए प्रत्येक विवरण की समीक्षा करें और अपना अभियान लॉन्च करने के लिए "पुष्टि करें" को हिट करें।',
    22181: "दिन",
    22191: "सितारा",
    22201: 'औसत ("औसत" में)',
    22211: "रिपोर्टिंग",
    22221: "प्रतिस्पर्धी सेटअप",
    22231: "सर्वोत्तम प्रथाएं",
    22241: "वृत्त का चतुर्थ भाग",
    22251: "रेटिंग्स",
    22261: "प्रतिस्पर्धी रैंकिंग",
    22271: 'सम्मान ("प्रतिक्रिया" में)',
    22281: "समीक्षा स्रोत देखें",
    22291: "प्रतियोगी जोड़ें",
    22301: "द्वारा फ़िल्टर किया गया",
    22311: "स्पष्ट",
    22321: "प्रतियोगी",
    22331: 'कॉम्पेंटिटी (जैसे "प्रतियोगी इकाई टैग" में)',
    22341: "इकाई टैग",
    22351: "टिप्पणियाँ",
    22361: "कोई विकल्प नहीं",
    22371: "खराब",
    22381: "औसत",
    22391: 'औसत ("स्टार रेटिंग" में)',
    22401: "महान",
    22411: "उत्कृष्ट",
    22421: "उत्तर के साथ समीक्षा",
    22431: "आंतरिक उत्तर के साथ समीक्षा",
    22441: "टिप्पणियों के साथ समीक्षा",
    22451: "टिप्पणियों के बिना समीक्षा",
    22461: "समीक्षा वॉल्यूम बनाम औसत रेटिंग",
    22471: "ब्रांड्स",
    22481: "ज़ूम",
    22491: "कुल समीक्षा",
    22501: "स्टार द्वारा रेटिंग रेटिंग",
    22511: "प्रतियोगी समीक्षा",
    22521: "प्रतिभागी",
    22531: "कोड (जैसे 'स्टोरकोड' में)",
    22541: "प्रतियोगियों को प्रबंधित करें",
    22551: "अद्यतन",
    22561: "प्रतियोगी जोड़ें",
    22571: "स्थान जोड़ना",
    22581: "प्रतियोगियों का नाम जोड़ें",
    22591: "पहला कदम प्रतिस्पर्धी के नाम को जोड़ना है, एक बार जब आप सूची में नाम और वैकल्पिक आइकन (48x48 छवियां) जोड़ते हैं, तो 'जोड़ें' पर क्लिक करें। एक बार प्रतियोगियों के निर्माण के बाद, आप व्यक्तिगत स्थानों को असाइन करने में सक्षम होंगे",
    22601: "प्रतियोगी नाम दर्ज करें (आवश्यक)",
    22611: "प्रतियोगी URL दर्ज करें (वैकल्पिक)",
    22621: "तस्विर अपलोड करना",
    22631: "जल्द आ रहा है",
    22641: "टिप्पणी अनुपात",
    22651: "टिप्पणियों के साथ और बिना समीक्षाओं का प्रतिशत",
    22661: 'बिना (बिना टिप्पणियों के ")',
    22671: '(के रूप में "टिप्पणियों के साथ")',
    22681: "टिप्पणी लंबाई",
    22691: "स्टार रेटिंग द्वारा प्रत्येक टिप्पणी में उपयोग किए गए शब्दों की औसत संख्या",
    22701: "शब्द",
    22711: "शब्द अनुपात",
    22721: "प्रत्येक स्टार रेटिंग के लिए टिप्पणियों में शब्दों का कुल और प्रतिशत",
    22731: "यहां। (एकीकरण पृष्ठ पर प्रतियोगियों में लिंक)",
    22741: "प्रतियोगियों",
    22751: "टैग जोड़ो",
    22761: "टेम्पलेट में जोड़े जाने के लिए चर चुनें",
    22771: "समीक्षा बंद करें",
    22781: "बंद समीक्षा",
    22791: "क्या आप इस समीक्षा को बंद करना चाहते हैं? एक बार जब आप बंद कर लेंगे, तो आपको जवाब देने के लिए इसे फिर से खोलना होगा",
    22801: "बाहरी",
    22811: "नकारात्मक",
    22821: "नहीं",
    22831: "अभी तक कोई ऑटो जवाब नहीं!",
    22841: "अभी तक कोई सहेजे गए जवाब नहीं!",
    22851: "ध्यान दें",
    22861: "स्थायी रूप से बंद",
    22871: "सकारात्मक",
    22881: "पढ़ने का समय खत्म हो गया",
    22891: "पुनर्स्थापित समीक्षा",
    22901: "पुन: खोलने की समीक्षा",
    22911: "उत्तर दिया",
    22921: "उत्तर भेजा गया (गूगल इंटरफ़ेस से)",
    22931: "ऐप से जवाब भेजा गया",
    22941: "हटाए गए समीक्षा",
    22951: "टेम्पलेट्स",
    22961: "अस्थायी रूप से बंद",
    22971: "हां",
    22981: "आपके पास कोई सहेजा गया ड्राफ्ट नहीं है",
    22991: "संसाधन तक पहुंचने के लिए अपर्याप्त अनुमतियाँ",
    23001: "आंतरिक त्रुटि का सामना करना पड़ा",
    23011: "अनुरोध में एक अवैध तर्क है",
    23021: "अनुरोधित इकाई नहीं मिली",
    23031: "Google प्लेटफ़ॉर्म पर समीक्षा अब मौजूद नहीं है",
    23041: "कुछ ऑटो सम्मिलित मान उपलब्ध नहीं हैं। कृपया बदलें और भेजा गया",
    23051: "सेवा वर्तमान में अनुपलब्ध है",
    23061: "यह ऑपरेशन लावारिस स्थानों के लिए समर्थित नहीं है",
    23071: "प्रकाशित पद",
    23081: "अनुसूचित पद",
    23091: "मित्रतापूर्ण नाम",
    23101: "दोस्ताना नाम जोड़ें",
    23111: "संपर्क",
    23121: "कोई संपर्क नहीं!",
    23131: "संपर्क जोड़ने के लिए",
    23141: "संपर्क नाम",
    23151: "ई - मेल से संपर्क करे",
    23161: "संपर्क जोड़ें",
    23171: "अंतर्दृष्टि पोस्ट",
    23181: "Google पोस्ट अंतर्दृष्टि",
    23191: "कोई आकड़ा उपलब्ध नहीं है",
    23201: "Google लेखापरीक्षा",
    23211: "लेखापरीक्षा लॉग",
    23221: "एक रिपोर्ट का चयन करें",
    23231: "चुनते हैं",
    23241: "सभी डाउनलोड",
    23251: "कोई विकल्प नहीं",
    23261: "डेटा डाउनलोड",
    23271: "समीक्षा डाउनलोड करें",
    23281: "सभी समीक्षाएँ",
    23291: "फोटो यूआरएल डाउनलोड करें",
    23301: "ग्राहक फोटो यूआरएल",
    23311: "व्यापारी फोटो यूआरएल",
    23321: "रिपोर्ट डाउनलोड इतिहास",
    23331: "रिपोर्ट नाम",
    23341: "को भेजा",
    23351: "बनाया गया समय (UTC)",
    23361: "आख्या की प्रकार",
    23371: "प्रोफ़ाइल विवरण",
    23381: "प्रोफ़ाइल नाम बदलें",
    23391: "साप्ताहिक सिंक",
    23401: "थोक सक्षम करें स्थान टैब सक्षम करें",
    23411: "तिथि प्रारूप सेटिंग्स",
    23421: "सहेजें",
    23431: "खुशी / एनपीएस सेटिंग",
    23441: "प्रमोटर / खुश",
    23451: "तटस्थ",
    23461: "Detractor / दुखी",
    23471: "अद्यतन",
    23481: "वर्तमान लोगो",
    23491: "पूर्ण लोगो",
    23501: "आइकन",
    23511: "रिपोर्ट लोगो",
    23521: "फ़ेविकॉन",
    23531: "यह लोगो शीर्ष-बाएं कोने पर उपस्थित होगा जबकि आपकी प्रोफ़ाइल के बाएं नेविगेशन का विस्तार किया जाएगा।",
    23541: "यह लोगो आपकी प्रोफ़ाइल के ऊपरी-बाएं कोने पर उपस्थित होगा।",
    23551: "यह लोगो डैशबोर्ड रिपोर्ट में प्रदर्शित किया जाएगा और सिस्टम में उत्पन्न रिपोर्ट की समीक्षा की जाएगी। सर्वोत्तम परिणामों के लिए 5kb से 20kb के बीच आकार की एक पीएनजी छवि का उपयोग करें",
    23561: "यह लोगो ब्राउज़र टैब के ऊपरी-बाएं कोने पर मौजूद होगा।",
    23571: "लोगो बदलें",
    23581: "ड्रॉपडाउन विकल्पों का उपयोग करके आप किस प्रकार का लोगो बदलना चाहते हैं और लोगो अपलोड करना चाहते हैं।",
    23591: "के लिए लोगो अपलोड करें",
    23601: "जीएमबी स्थान स्थिति विन्यास: दमन सेटिंग्स",
    23611: "दबाने",
    23621: "दृश्यमान",
    23631: "डिस्कनेक्ट किया गया",
    23641: "असत्यापित",
    23651: "निलंबित",
    23661: "डुप्लिकेट",
    23671: "प्रथम पार्टी समीक्षा अपलोड",
    23681: "डालना",
    23691: "स्पष्ट",
    23701: "थोक में स्थानों का प्रबंधन",
    23711: "थोक प्रबंधन नियंत्रण",
    23721: "Google शीट्स में सीधे स्थान विवरण और नियंत्रण प्लेटफ़ॉर्म पैरामीटर अपडेट करें।",
    23731: "प्लेटफार्म",
    23741: "कस्टम स्थान चर और सेटिंग्स के साथ किसी भी पैमाने के खातों को आसानी से प्रबंधित करें।",
    23751: "जीएमबी विवरण",
    23761: "सभी Google मेरी व्यावसायिक लिस्टिंग देखें और सीधे स्थान विवरण जोड़ें / संपादित / हटाएं।",
    23771: "जीएमबी विशेषताएँ",
    23781: "वृद्धिशील खोज खोज प्राप्त करने के लिए प्रत्येक स्थान पर सभी योग्य विशेषताओं को असाइन करें।",
    23791: "जीएमबी लिस्टिंग",
    23801: "नई GBP लिस्टिंग बनाएँ।",
    23811: "फेसबुक",
    23821: "फेसबुक लिस्टिंग कंट्रोल",
    23831: "इतिहास",
    23841: "प्रशिक्षण",
    23851: "थोक के लिए संसाधनों तक पहुंच वर्कफ़्लो, सर्वोत्तम प्रथाओं, सीमाएं, और अपडेट।",
    23861: "चेतावनी",
    23871: "आवश्यकता:",
    23881: "उपयोगकर्ताओं के पास एक Google खाता होना चाहिए ताकि सिस्टम प्रोफ़ाइल डेटा के साथ Google शीट पेश कर सके।",
    23891: "सूचना:",
    23901: "सिस्टम डेटाबेस से प्रत्येक शीट को पॉप्युलेट करने वाला डेटा। यदि आप यह सुनिश्चित करना चाहते हैं कि स्प्रेडशीट वर्तमान Google डेटा प्रस्तुत करता है, तो हम दृढ़ता से अनुशंसा करते हैं कि आप पहले अपनी प्रोफ़ाइल को सिंक्रनाइज़ करें।",
    23911: 'आपके खाते में स्थानों की संख्या के आधार पर, Google शीट्स में शुरुआत में निर्माण करने में समय लग सकता है और फिर शीट पर नेविगेट करने के बाद ताज़ा हो सकता है। कृपया सुनिश्चित करें कि सिस्टम को संपादन को सहेजने के लिए "अद्यतन" को धक्का देने से पहले सभी डेटा स्थिर है और Google को अपडेट पुश करें।',
    23921: "मंच में Google से सीधा एपीआई कनेक्शन है, लेकिन तब भी ऐसे समय हो सकते हैं जब Google सार्वजनिक स्थान लिस्टिंग पृष्ठ पर सीधे अपडेट में देरी करता है।",
    23931: '"अद्यतन" को धक्का देना सीधे Google को सीधे सिस्टम ट्रिगर करता है। कोई पूर्ववत या उलटा प्रक्रिया उपलब्ध नहीं है। कृपया सुनिश्चित करें कि आप अपडेट को ट्रिगर करने से पहले सभी संपादन के साथ सहज हैं। यदि कोई गलती की जाती है, तो कृपया कुछ मिनट प्रतीक्षा करें और फिर आवश्यक परिवर्तन करें।',
    23941: "रंग योजना",
    23951: "प्रत्येक शीट में उपयोगकर्ताओं को यह समझने में मदद करने के लिए एक डिफ़ॉल्ट रंग योजना होती है कि कौन से फ़ील्ड संपादन के लिए पात्र हैं।",
    23961: "वेरिएबल्स जो या तो Google से स्थिति विवरण व्यक्त करते हैं या सीधे थोक नियंत्रण के माध्यम से संपादित नहीं किए जा सकते हैं।",
    23971: "थोक संपादन के लिए सीधे Google चर खोलें।",
    23981: "प्लेटफार्म चर सीधे थोक संपादन के लिए खुला।",
    23991: "नियंत्रण",
    24001: "विवरण",
    24011: "गुण",
    24021: "लिस्ट बनाना",
    24031: "निर्देश",
    24041: "समाप्ति तिथि",
    24051: "सदस्यता लेने का समय!",
    24061: "यह प्रोफ़ाइल समाप्त हो जाएगी",
    24071: "इस प्रोफ़ाइल तक पहुंचने के लिए, कृपया सदस्यता लें।",
    24081: "मुझे वहां ले चलो!",
    24091: "बाद में",
    24101: "बिलिंग",
    24111: "य���जना विवरण",
    24121: "प्लस",
    24131: "समर्थक",
    24141: "/ प्रति स्थान",
    24151: "$ 8 / प्रति स्थान",
    24161: "पहले 10 स्थान",
    24171: "$ 24 / माह न्यूनतम",
    24181: "30 दिनों के लिए मुफ्त प्रयास करें",
    24191: "सभी एकीकरण शामिल थे",
    24201: "पूर्ण समीक्षा इनबॉक्स",
    24211: "पूर्ण भूमिकाएं",
    24221: "पूर्ण रिपोर्टिंग सूट",
    24231: "असीमित उपयोगकर्ता",
    24241: "30 पूर्व-स्थापित समीक्षा प्रतिक्रियाएं",
    24251: "पूर्ण समर्थन",
    24261: "स्थान 11-200",
    24271: "प्लस प्लान की सभी विशेषताएं",
    24281: "पूर्ण जीएमबी प्रबंधन",
    24291: "थोक / अनुसूची Google पोस्ट",
    24301: "वास्तविक समय अधिसूचनाएं",
    24311: "कस्टम रिपोर्ट सेट-अप",
    24321: "स्थानीय खोज अनुकूलन",
    24331: "व्यक्तिगत ऑनबोर्डिंग",
    24341: "अपवित्रता और धोखाधड़ी की समीक्षा लेखा परीक्षा",
    24351: "गतिविधि",
    24361: "अधिकार दिया गया",
    24371: "अधिकृत कनेक्शन प्रत्येक स्रोत से पूर्ण समीक्षा और प्रतिक्रिया क्षमताओं तक पहुंच सकते हैं।",
    24381: "थोक अपलोड इकाई टैग",
    24391: "थोक अपलोड जीएमबी विस्तार",
    24401: "एक समूह चुनें और ऑटो उत्तर को सहेजने के लिए विषय।",
    24411: "गिनती",
    24421: "इकाई टैग बनाएं",
    24431: "समय बनाएँ (UTC)",
    24441: "कस्टम साइडबार टैब",
    24451: "कस्टम साइडबार उपकरण",
    24461: "जीएमबी ऑडिट डाउनलोड करें",
    24471: "फ़ाइल का नाम",
    24481: "जीएमबी विस्तार इतिहास",
    24491: "छापे",
    24501: "निष्क्रिय",
    24511: "इंडेक्स किए गए",
    24521: "अनुक्रमित कनेक्शन प्रत्येक स्रोत से सभी ऐतिहासिक और वर्तमान समीक्षा तक पहुंचते हैं।",
    24531: "लोकलपोस्ट प्रबंधित करें",
    24541: "कोई टिप्पणी नहीं",
    24551: "संख्या",
    24561: 'कृपया "नई रिपोर्ट" बटन पर शीर्ष दाएं पर क्लिक करें',
    24571: "प्रोफ़ाइल बनाई गई",
    24581: "अनुरोध आईडी",
    24591: "एक उत्तर बचाओ",
    24601: "कुल स्थान",
    24611: "कुल पद",
    24621: "एआर टेम्पलेट अपलोड करें",
    24631: "स्थान उपनाम अपलोड करें",
    24641: "राय",
    24651: "आप प्लेटफॉर्म के भीतर किसी iframe, या बाहरी रूप से होस्ट किए गए एक लिंक को इंगित करने वाले साइडबार में कस्टम टैब को कॉन्फ़िगर और सेट कर सकते हैं।",
    24661: "जीएमबी विवरण",
    24671: "जीएमबी विशेषताएँ",
    24681: "जीएमबी लिस्टिंग",
    24691: "फेसबुक",
    24701: "इतिहास",
    24711: "प्रशिक्षण",
    24721: "साप्ताहिक सिंक पर ट्रिगर किया गया",
    24731: "Mmm d, yyy",
    24741: "उदाहरण: -ओसीटी 13,2020",
    24751: "मिमी / डीडी / yyyy",
    24761: "Mmmm d, yyyy",
    24771: "उदाहरण: -ऑक्टोबर 13,2020",
    24781: "डीडी / एमएम / yyyy",
    24791: "डीडी एमएमएम yyyy",
    24801: "डीडी mmmm yyyy",
    24811: "उदाहरण: - 13 अक्टूबर 2020",
    24821: "नया लोगो अपलोड करें",
    24831: "जुदा जुदा",
    24841: "दृश्य छिपा हुआ",
    24851: "विवरण विवरण फलक विन्यास",
    24861: "स्टोर कोड दिखाएं",
    24871: "पूरा पता दिखाएं",
    24881: "सारांश विजेट दिखाएं",
    24891: "उलटा शीर्षलेख",
    24901: "फाइलें चुनें",
    24911: "कोई फ़ाइल चुना नही",
    24921: "सूची सामग्री परिवर्तन की पुष्टि करने और किसी भी त्रुटि को खोजने के लिए प्रत्येक अद्यतन पुश का एक लॉग देखें।",
    24931: 'आपके खाते में स्थानों की संख्या के आधार पर, Google शीट्स में शुरुआत में निर्माण करने में समय लग सकता है और फिर शीट पर नेविगेट करने के बाद ताज़ा हो सकता है। कृपया सुनिश्चित करें कि सिस्टम को संपादन को सहेजने के लिए "अद्यतन" को धक्का देने से पहले सभी डेटा स्थिर है और Google को अपडेट पुश करें।',
    24941: "थोक के लिए संसाधन वर्कफ़्लो संपादित करें, सर्वोत्तम प्रथाओं, सीमाएं, और अपडेट।",
    24951: "यूज़र आईडी",
    24961: "क्या आप हटाना चाहते हैं?",
    24971: "लेखा",
    24981: "कोई Google अपडेट नहीं है",
    24991: "पुनरावृत्ति की आवश्यकता नहीं है",
    25001: "कोई लंबित संपादन नहीं",
    25011: "लेखापरीक्षा समय",
    25021: "खेत",
    25031: "मूल्य ()",
    25041: "मूल्य (से)",
    25051: "इकाई टैग से निकालें",
    25061: "जिम्मेदार",
    25071: "ऐडवर्ड्स",
    25081: "सभी को देखें",
    25091: "क्यू एंड ए (प्रश्न और उत्तर)",
    25101: "अन्वेषण करना",
    25111: "प्रतिक्रियाओं का अन्वेषण करें",
    25121: "टेम्पलेट का चयन करें",
    25131: "जारी रखना",
    25141: "स्टार रेटिंग, टेम्पलेट नाम चुनें और ऑटो उत्तर को सहेजने के लिए टेम्पलेट सामग्री जोड़ें।",
    25151: "उत्तर प्रकार का चयन करें",
    25161: "खाका",
    25171: "टुकड़ा",
    25181: "रेटिंग के लिए असाइन करें (आवश्यक)",
    25191: "टेम्पलेट नाम दर्ज करें (आवश्यक)",
    25201: "कस्टम टेम्पलेट चर (वैकल्पिक)",
    25211: "विषय बनाएँ का चयन करें (वैकल्पिक)",
    25221: "एकल स्थान पर असाइन करें",
    25231: "एंटिटी टैग को असाइन करें (वैकल्पिक)",
    25241: "ऑटो उत्तर को बचाने के लिए विषय नाम और स्निपेट सामग्री जोड़ें।",
    25251: "कुल # (संख्या) आइटम",
    25261: "स्थान नोट",
    25271: "स्थान विवरण देखें",
    25281: "Google नॉलेज पैनेल देखें",
    25291: "Google पर सीधे समीक्षा देखें",
    25301: "सकारात्मक -5 सितारे",
    25311: "नकारात्मक - 1/2 सितारे",
    25321: "मिश्रित - 3/4 सितारे",
    25331: "टेम्पलेट नाम",
    25341: "चर",
    25351: "विषय चुनें या बनाएं (वैकल्पिक)",
    25361: "समूह",
    25371: "विषय",
    25381: "पूर्व समीक्षा",
    25391: "उत्तर के रूप में सहेजें",
    25401: "सीसी (कार्बन-कॉपी)",
    25411: "रीसेट",
    25421: "नया क्या है",
    25431: "तारीख बनाना",
    25441: "कस्टम फ़िल्टर नाम",
    25451: "सिफ़ पढ़िये",
    25461: "सुविधा का उपयोग",
    25471: "कोई नहीं",
    25481: "पढ़ना",
    25491: "अप्रतिबंधित",
    25501: "यह एक डिफ़ॉल्ट भूमिका है और इसे संपादित / हटाया नहीं जा सकता है",
    25511: "पढ़ना",
    25521: "लिखना",
    25531: "डाउनलोड",
    25541: "इस भूमिका को आवंटित सभी उपयोगकर्ताओं को निम्नलिखित विशेषताओं के लिए दृश्यी / पहुंच होगी",
    25551: "सेटिंग्स सबटैब दृश्यता",
    25561: "भूमिका प्रबंधित करना",
    25571: "कस्टम साइडबार",
    25581: "या",
    25591: "भूमिका विशेषताओं को सहेजें",
    25601: "क्या आप वाकई भूमिका को हटाना चाहते हैं",
    25611: "यह वर्तमान में केवल पढ़ने के लिए इस भूमिका को सौंपा गया सभी उपयोगकर्ताओं की भूमिका को बदल देगा।",
    25621: "उपयोगकर्ताओं को असाइन करें",
    25631: "प्रोफाइल में उपयोगकर्ता",
    25641: "यहां तलाश करो",
    25651: "उपयोगकर्ता इस भूमिका को सौंपा",
    25661: "कोई उपयोगकर्ता नहीं",
    25671: "फिर से बुलाना",
    25681: "डिफ़ॉल्ट लैंडिंग पृष्ठ",
    25691: "समीक्षा बॉक्स",
    25701: "थोक प्रबंधन",
    25711: "पोस्ट शेड्यूलिंग",
    25721: "पर",
    25731: "बंद",
    25741: "क्या आप निश्चित रूप से अभियान बंद कर रहे हैं?",
    25751: "क्या आप निश्चित रूप से अभियान चालू कर रहे हैं?",
    25761: "सफलतापूर्वक अभियान को अपडेट किया गया",
    25771: "प्रतिक्रिया की दर",
    25781: "प्रतिक्रिया गणना",
    25791: "स्टार रेटिंग",
    25801: "साथ में",
    25811: "के बग़ैर",
    25821: "विलंब",
    25831: "समय क्षेत्र",
    25841: "समीक्षा",
    25851: "प्रतियोगी रिपोर्ट",
    25861: "प्रारूप",
    25871: "एचटीएमएल ईमेल",
    25881: "एक्सेल",
    25891: "यदि चयनित सीमा में कोई समीक्षा नहीं है",
    25901: "ईमेल न भेजें",
    25911: "ईमेल भेजें",
    25921: "क्यू एंड ए",
    25931: "यदि चयनित सीमा में कोई Q & A नहीं है",
    25941: "ग्राहक छवि",
    25951: "हिसाब सूचि",
    25961: "प्रोफ़ाइल सिंक ताल के बारे में किसी भी प्रश्न के साथ समर्थन से संपर्क करें।",
    25971: "लेखापरीक्षा फ़ाइल शामिल करें",
    25981: "प्रोफ़ाइल",
    25991: "कॉम्पटैग (प्रतियोगी टैग)",
    26001: "समीक्षा विवरण",
    26011: "स्तरीय नियंत्रण प्रबंधित करें",
    26021: "डिफ़ॉल्ट कार्यक्षमता को ओवरराइड करें, स्तरों में व्यवस्थित",
    26031: "बिल्ड ऑफर टियर",
    26041: "नया टायर बनाएँ",
    26051: "टियर नाम",
    26061: "चूक जाना",
    26071: "चूक जाना",
    26081: "प्रतिष्ठा डैशबोर्ड",
    26091: "व्यापक अंतर्दृष्टि में सभी समीक्षा केपीआई",
    26101: "सभी स्थानों और स्रोतों में पूर्ण दृश्यता",
    26111: "धारा",
    26121: "समीक्षा की मात्रा, औसत रेटिंग, वितरण, स्रोत, खुशी, और प्रतिक्रिया अनुपात की कोर केपीआई।",
    26131: "समीक्षा और रेटिंग, प्रतिशत, संचयी, स्रोत, खुशी, और प्रतिक्रिया समय हिस्टोग्राम का अनुदैर्ध्य विश्लेषण।",
    26141: "रेटिंग द्वारा टिप्पणी अनुपात, टिप्पणी लंबाई और संचयी शब्द अनुपात।",
    26151: "सप्ताह के दिन, महीने का दिन और वर्ष के महीने की समीक्षा।",
    26161: "शीर्ष पांच देशों, राज्यों / प्रांत, और समीक्षा मात्रा द्वारा शहरों।",
    26171: "प्रारंभिक खाता सेट अप के दौरान सभी ऐतिहासिक डेटा संकलित किया गया है और फिर दैनिक सभी जुड़े हुए समीक्षा स्रोतों से अपडेट किया गया है।",
    26181: "जीएमबी अंतर्दृष्टि",
    26191: "डायरेक्ट, डिस्कवर, और ब्रांड डेली सर्च वॉल्यूम एरिया चार्ट।",
    26201: "मानचित्र और खोज दैनिक दृश्य क्षेत्र चार्ट।",
    26211: "ड्राइविंग दिशा, फोन कॉल और वेबसाइट क्लिक के लिए ग्राहक क्रियाएं चार्ट।",
    26221: "सप्ताह के दिन कॉलम चार्ट के दिन स्थान क्रियाएं।",
    26231: "अद्वितीय स्थानीय रूपांतरण राशन (क्रियाएं / दैनिक खोज)।",
    26241: "जीएमबी स्थान और कुल विचारों के लिए होस्ट की गई ब्रांड फोटो औसत मात्रा",
    26251: "ग्राहक ने जीएमबी स्थान और कुल विचारों के लिए होस्ट की गई फोटो औसत मात्रा अपलोड की।",
    26261: "प्रत्येक स्थान के लिए दैनिक डेटा का एक पूर्ण 18 महीने प्रारंभिक खाता सेट अप के दौरान संकलित किया जाता है और फिर दैनिक सभी जुड़े समीक्षा स्रोतों से अपडेट किया जाता है। Google वर्तमान में 3-5 दिन की देरी के साथ अंतर्दृष्टि की रिपोर्ट करता है।",
    26271: "स्थानीय खोज एक्सपोजर और एक्शन रिपोर्टिंग।",
    26281: "लोकभक्ति",
    26291: "आसानी से स्थानों पर प्रदर्शन की तुलना करें",
    26301: "समीक्षा, औसत रेटिंग, खोज, विचार, और कार्यों के लिए चयनित व्यक्तिगत स्थानों का दैनिक लाइन चार्ट",
    26311: "पूर्ण डाउनलोड रिपोर्टिंग के साथ प्रत्येक स्थान की समीक्षा और स्थानीय मीट्रिक की सॉर्ट करने योग्य और खोज योग्य तालिका प्रस्तुति।",
    26321: "अतिरिक्त टैब प्रदर्शन चार्ट और भौगोलिक रोल-अप / ड्रिल-डाउन द्वारा इसकी अनूठी डाउनलोड ट्रिगर के साथ प्रदर्शन चार्ट और तालिका प्रदान करता है।",
    26331: "व्यक्तिगत स्थान द्वारा समीक्षा और जीएमबी अंतर्दृष्टि तालिका और चार्ट।",
    26341: "समीक्षा बॉक्स",
    26351: "सभी स्थानों और स्रोतों के लिए कुल इनबॉक्स - फ़िल्टर, खोज, प्रतिक्रिया, और प्रबंधन।",
    26361: "सभी स्रोतों से सभी समीक्षा प्रबंधित करें",
    26371: "वर्कफ़्लो",
    26381: "रेटिंग, स्रोत, सामग्री, समीक्षक, टैग या स्थान द्वारा समीक्षा खोजने के लिए खोजें और फ़िल्टर करें।",
    26391: "सीधे मंच से अधिकृत समीक्षा स्रोतों का जवाब दें।",
    26401: "अद्वितीय गति के साथ व्यक्तिगत प्रतिक्रिया भेजने के लिए विषय द्वारा रेटिंग और स्निपेट द्वारा टेम्पलेट्स का अन्वेषण करें।",
    26411: "नियंत्रित प्रतिक्रिया अनुमोदन के लिए वर्कफ़्लो बनाएं।",
    26421: "नोट्स या सीसी 'उत्तर सीधे स्थान प्रबंधन के लिए जवाब भेजें।",
    26431: "पूर्ण नियंत्रण",
    26441: "स्थान लिस्टिंग प्रबंधित करें",
    26451: "प्रत्यक्ष एपीआई खातों में सभी स्थान लिस्टिंग विवरणों के नियंत्रण को जोड़ें / संपादित / हटाएं।",
    26461: "किसी भी सूची के नियंत्रण को व्यवस्थित करें।",
    26471: "स्थिति और सामग्री द्वारा किसी भी संख्या में स्थानों और जुड़े खातों में खोजें और फ़िल्टर करें।",
    26481: "व्यक्तिगत स्थान द्वारा जीएमबी विवरण सीधे संपादित करें।",
    26491: "सभी योग्य स्थानों के लिए व्यक्तिगत जीएमबी पोस्ट बनाएं।",
    26501: "इकाई टैग के माध्यम से कई अद्वितीय ग्राहक समूहों में स्थानों को व्यवस्थित करें।",
    26511: 'उद्यम, श्रृंखला, और फ्रेंचाइजी प्रोफाइल का प्रबंधन करना आसान बनाने के लिए "दोस्ताना नाम" असाइन करें।',
    26521: "थोक जीएमबी सामग्री, छवियों, श्रेणियों, घंटों, पते, विवरण और अधिक जोड़ें / संपादित करें।",
    26531: "थोक प्रत्येक स्थान के ज्ञान पैनल के लिए नया Google प्रश्न और उत्तर जोड़ें।",
    26541: "थोक प्लेटफ़ॉर्म सामग्री जैसे कि स्थान नोट्स, स्थानीय प्रबंधकों आदि को जोड़ें / संपादित करें।",
    26551: "प्रतियोगी समीक्षा ट्रैकिंग",
    26561: "डैशबोर्ड तुलना। वितरण तुलना की समीक्षा करें। ब्रांड और स्थान तरंग चतुर्भुज।",
    26571: "प्रतियोगी प्रतिक्रिया में अद्वितीय अंतर्दृष्टि प्राप्त करें",
    26581: "प्रतियोगी समीक्षा रिपोर्टिंग डैशबोर्ड, सटीक तुलना की पहचान करने के लिए फ़िल्टर करने योग्य।",
    26591: "प्रतिद्वंद्वी ब्रांडों में रेटिंग वितरण तुलना।",
    26601: "समीक्षा मात्रा बनाम औसत रेटिंग का तरंग चार्ट, ब्रांड या व्यक्तिगत स्थानों की तुलना में,",
    26611: "पूर्ण समीक्षा टिप्पणी विवरण और यहां तक ​​कि प्रतियोगी के जवाब।",
    26621: "अनुभाग आधिकारिक तौर पर बीटा स्थिति में है क्योंकि हम अधिक रिपोर्टिंग और प्रस्तुति विकल्प जोड़ना जारी रखते हैं।",
    26631: "थोक प्रबंधन",
    26641: 'अद्वितीय "स्प्रेडशीट यूआई" जुड़े Google शीट के माध्यम से प्रत्यक्ष लिस्टिंग नियंत्रण प्रदान करते हैं।',
    26651: "किसी भी आकार के खातों को नियंत्रित करने का सबसे तेज़ और आसान तरीका।",
    26661: "प्लेटफ़ॉर्म - प्लेटफ़ॉर्म को प्रबंधित करने के लिए प्रमुख चर के थोक असाइनमेंट और अपडेट।",
    26671: "विवरण - सभी Google मेरे व्यापार विवरण के लिए प्राथमिक अनुभाग।",
    26681: "विशेषताएं - जीएमबी लिस्टिंग में विशेषताओं के असाइनमेंट को अनुकूलित करें",
    26691: "लिस्टिंग बनाएं - नई जीएमबी लिस्टिंग बनाएं सभी महत्वपूर्ण सामग्री होगी",
    26701: "फेसबुक - एक ही स्प्रेडशीट से सभी फेसबुक विवरण को नियंत्रित करें",
    26711: "इतिहास - फ़ाइल संपादन और अद्यतन लॉग।",
    26721: "अनुभाग आधिकारिक तौर पर बीटा स्थिति में है क्योंकि हम खातों के लिए नियंत्रण को परिष्कृत करना जारी रखते हैं और अतिरिक्त प्लेटफॉर्म शामिल करते हैं।",
    26731: "पोस्ट शेड्यूलिंग",
    26741: "स्थानों और खाते में Google पोस्ट के लिए थोक निर्माण और शेड्यूलिंग।",
    26751: "महत्वपूर्ण अद्यतन और प्रचार संदेश साझा करें",
    26761: "सभी योग्य स्थानों के लिए Google पोस्ट बनाने के लिए टेम्पलेट डाउनलोड करें।",
    26771: "संपूर्ण फ़ाइल के लिए समय निर्धारित करें या प्रत्येक पोस्ट को एक अद्वितीय दिन और समय पर शुरू करने के लिए सेट करें",
    26781: "एक संपूर्ण प्रचार कैलेंडर की योजना बनाएं",
    26791: "पोस्ट अंतर्दृष्टि रिपोर्टिंग",
    26801: "Google पोस्ट दृश्य देखें और समय के साथ प्रदर्शन पर क्लिक करें - प्रकार, मीडिया और कॉल द्वारा कॉल करने वाले फ़िल्टर।",
    26811: "मुफ्त विज्ञापन को अनुकूलित करने के लिए प्रदर्शन रुझानों की पहचान करें",
    26821: "बार चार्ट समय के साथ प्रदर्शन का प्रतिनिधित्व करता है, तिथि सीमा और चार्ट ग्रैन्युलरिटी सेट करता है।",
    26831: "मीडिया, विषय, और एक्शन प्रकार पर कॉल द्वारा पोस्ट वॉल्यूम देखें।",
    26841: "प्रत्येक पोस्ट व्यक्तिगत प्रदर्शन मीट्रिक देखें।",
    26851: "रिपोर्ट डाउनलोड अभियान द्वारा आगे विश्लेषण के लिए अनुमति देता है।",
    26861: "समायोजन",
    26871: "सभी सेटिंग्स, भूमिका, उपयोगकर्ता अनुमतियों, रिपोर्ट शेड्यूलिंग और डेटा डाउनलोड के लिए मंच का प्रशासनिक अनुभाग",
    26881: "एंटरप्राइज़ ग्रेड नियंत्रण सभी उपयोगकर्ताओं के लिए एक अनुकूलित अनुभव निर्धारित करने के लिए।",
    26891: "प्राथमिक व्यवस्थापक खंड",
    26901: "प्लेटफॉर्म (Google, फेसबुक, ट्रस्टपिलॉट, बुकिंग) से कनेक्शन को अधिकृत करें।",
    26911: "उपलब्ध समीक्षा स्रोतों के लिए एकीकरण सेट करें।",
    26921: "अलग-अलग उपयोगकर्ता भूमिकाएं प्रबंधित / बनाएं।",
    26931: "व्यक्तिगत पहुंच को असाइन / नियंत्रित करें।",
    26941: "प्रकार, उपयोगकर्ता, और यहां तक ​​कि स्थान द्वारा रिपोर्टिंग अनुसूची।",
    26951: "प्लेटफ़ॉर्म से डेटा सेट डाउनलोड करें, 10 सबसे हाल के अनुरोधों तक पहुंचें।",
    26961: "लेखा प्राधिकृत",
    26971: "Google लेखापरीक्षा",
    26981: "एकीकरण",
    26991: "प्रबंधक भूमिका",
    27001: "उपयोगकर्ताओं को प्रबंधित करें",
    27011: "समीक्षा सेटिंग्स",
    27021: "कैंपगिन बिल्डर",
    27031: "रिपोर्ट प्रबंधन",
    27041: "डेटा डाउनलोड",
    27051: "प्रोफ़ाइल विवरण",
    27061: "कस्टम नेविगेशन",
    27071: "समीक्षा स्पष्टता",
    27081: "दावा स्थान",
    27091: "अधिकृत स्रोत",
    27101: "पूर्ण डेटा पहुंच और प्रत्यक्ष समीक्षा प्रतिक्रियाओं के लिए आवश्यक है।",
    27111: "विकल्प",
    27121: "अधिकृत कनेक्शन बढ़ते रहेंगे क्योंकि प्लेटफॉर्म एपीआई कनेक्शन उपलब्ध कराते हैं।",
    27131: "निर्मित संभव नियंत्रण प्राप्त करने के लिए प्लेटफ़ॉर्म और उपयोगकर्ता खातों के बीच कनेक्शन को सीधे अधिकृत करें।",
    27141: "सभी स्रोत",
    27151: "अनुक्रमित समीक्षा स्रोत",
    27161: "उद्योग वर्टिकल में 40+ स्रोतों से कुल प्रतिक्रिया",
    27171: "टिप्पणियाँ",
    27181: "जीएमबी लिस्टिंग के नियंत्रण के बिना समीक्षाओं तक पहुंचने के लिए Google अनुक्रमण का उपयोग करें।",
    27191: "अनुक्रमित सोर्सिंग का उपयोग सभी प्रतिस्पर्धी समीक्षा संग्रह के लिए किया जाता है।",
    27201: "प्रारंभिक सूचकांक के बाद, समीक्षा और प्रतिक्रियाएं प्रतिदिन एकत्र की जाती हैं",
    27211: "सार्वजनिक अनुक्रमण या सभी ऐतिहासिक समीक्षा और यूआरएल या प्लेसिड द्वारा प्रतिक्रियाएं",
    27221: "सभी स्रोत",
    27231: "कॉन्फ़िगर",
    27241: "बीता हुआ कल",
    27251: "आखिरी 7 दिन",
    27261: "पिछले सप्ताह",
    27271: "पिछले 30 दिनों में",
    27281: "पिछले महीने",
    27291: "पूरा समय",
    27301: "एएससी",
    27311: "वर्णन",
    27321: "सीसी के लिए कोई संपर्क नहीं",
    27331: "इस उत्तर को सहेजें?",
    27341: "एक समूह का चयन या निर्माण",
    27351: "कोई सहेजे गए जवाब नहीं",
    27361: "कोई ऑटो जवाब नहीं",
    27371: "कुल 0 आइटम",
    27381: "सहेजा गया टेम्पलेट्स",
    27391: "कुल 26 आइटम",
    27401: "हाल ही में उपयोग किया गया",
    27411: "स्माइलीज और लोग",
    27421: "टिप्पणियाँ है",
    27431: "कोई टिप्पणी नहीं",
    27441: "समस्त स्थान",
    27451: "खुला",
    27461: "Google अपडेट",
    27471: "छुटे हुए तथ्य",
    27481: "मेरी समीक्षा",
    27491: "अतिरिक्त श्रेणियाँ",
    27501: "खोज स्थान",
    27511: "जीएमबी लेखा परीक्षा",
    27521: "थोक गतिविधि",
    27531: "समूह का चयन करें",
    27541: "20 / पृष्ठ",
    27551: "साथ - साथ करना",
    27561: "श्रोताओं को सेट करें",
    27571: "किया हुआ",
    27581: "इकाई टैग नाम",
    27591: "मिनट",
    27601: "बिना टिप्पणी के",
    27611: "भाव",
    27621: "चतुर्थांश विश्लेषण",
    27631: "सभी स्थान डेटा",
    27641: "उच्च खोज + कम रूपांतरण",
    27651: "उच्च खोज + उच्च रूपांतरण",
    27661: "कम खोज + कम रूपांतरण",
    27671: "कम खोज + उच्च रूपांतरण",
    27681: "क्षेत्र द्वारा स्थान डेटा",
    27691: "शहर द्वारा स्थान डेटा",
    27701: "स्थान:",
    27711: "रूपांतरण दर:",
    27721: "खोज:",
    27731: "Google Q & A",
    27741: "Google qa",
    27751: "क्यूए डाउनलोड करें",
    27761: "उत्तर पोस्ट",
    27771: "अंतर्दृष्टि पोस्ट",
    27781: "नमूना CSV डाउनलोड करें",
    27791: "पूर्व आबादी सीएसवी",
    27801: "पोर्टफोलियो प्रबंधित करें",
    27811: "पोर्टफोलियो जोड़ें",
    27821: "पोर्टफोलियो देखें",
    27831: "पोर्टफोलियो हटाएं",
    27841: "उपयोगकर्ताओं",
    27851: "प्रोफाइल प्रबंधित करें",
    27861: "प्रोफ़ाइल निकालें",
    27871: "क्या आप वाकई इस प्रोफाइल को हटाना चाहते हैं?",
    27881: "हिसाब किताब",
    27891: "प्रोफाइल का चयन करें",
    27901: "प्रोफ़ाइल चुनें",
    27911: "पोर्टफोलियो लेखा",
    27921: "पोर्टफोलियो विवरण",
    27931: "पोर्टफोलियो का नाम",
    27941: "Currrent पोर्टफोलियो छवि",
    27951: "पोर्टफोलियो के लिए एक लोगो के रूप में छवि अपलोड करें",
    27961: "पोर्टफोलियो नाम बदलें",
    27971: "मुफ्त परीक्षण",
    27981: "वर्तमान",
    27991: "समय सीमा समाप्त",
    28001: "रद्द",
    28011: "चालान-प्रक्रिया",
    28021: "जुड़े हुए",
    28031: "खातों की संख्या",
    28041: "कुल स्थान",
    28051: "सक्रिय स्थान",
    28061: "समीक्षा (30 दिन)",
    28071: "भुगतान की स्थिति",
    28081: "प्रोफ़ाइल नाम",
    28091: "नए पोर्टफोलियो का नाम दर्ज करें",
    28101: "एक पोर्टफोलियो अपने उपयोगकर्ताओं को विभिन्न प्रोफाइल में आसानी से प्रबंधित कर सकता है",
    28111: "नए पोर्टफोलियो का नाम",
    28121: "पोर्टफोलियो नामों में अधिकतम 20 वर्ण हो सकते हैं",
    28131: "पोर्टफोलियो सफलतापूर्वक बनाया गया!",
    28141: "कुल प्रोफाइल",
    28151: "कुल उपयोगकर्ता",
    28161: "ईमेल दर्ज करें",
    28171: "प्रोफाइल प्रबंधित करने में आपकी सहायता के लिए किसी को आमंत्रित करें। आप उनकी भूमिका का चयन करके प्रोफाइल तक पहुंच सेट कर सकते हैं।",
    28181: "आमंत्रण",
    28191: "वर्तमान पोर्टफोलियो छवि",
    28201: "भाव",
    28211: "प्रतीक्षा कर रहा है",
    28221: "अधिक फिल्टर",
    28231: "समीक्षा टैग",
    28241: "सहेजे गए फ़िल्टर",
    28251: "कम फिल्टर",
    28261: "कोई पाठ नहीं है",
    28271: "मध्यम",
    28281: "विस्तार करना",
    28291: "एकल छवि अपलोड",
    28301: "छवि प्रकार का चयन करें",
    28311: "प्रकार चुनें",
    28321: "आवरण चित्र",
    28331: "खाते की फोटो",
    28341: "बाहरी फोटो",
    28351: "आंतरिक फोटो",
    28361: "उत्पाद फोटो",
    28371: "कार्य फोटो",
    28381: "लोगो फोटो",
    28391: "भोजन और पेय फोटो",
    28401: "मेनू फोटो",
    28411: "सामान्य क्षेत्र फोटो",
    28421: "कमरे का फोटो",
    28431: "टीम फोटो",
    28441: "विचारों",
    28451: "तस्वीर",
    28471: "बंद किया हुआ",
    28481: "निकाला गया",
    28491: "नई समीक्षा टैग",
    28511: "इस सीमा में दिखाने के लिए कुछ भी नहीं!",
    28531: "सबका चयन करें",
    28541: "खोज स्रोत",
    28551: "खोज समीक्षा टैग",
    28561: "खोज स्थान",
    28571: "खोज भंडार कोड",
    28581: "खोज समूह",
    28601: "सहेजे गए फिल्टर",
    28631: "सहेजे गए उत्तर जोड़ें",
    28641: "कोई विकल्प नहीं!",
    28651: "समीक्षा पाठ दृश्य समायोजित करें",
    28661: "सीधे समीक्षा देखें",
    28671: "समीक्षा प्लेटफॉर्म पर उत्तर दें",
    28711: "कोई समीक्षा नहीं",
    28731: "उत्तर स्थान नाम इस स्थान में नहीं जोड़ा गया",
    28741: "ह��्ताक्षर इस स्थान में नहीं जोड़ा गया",
    28751: "क्या आप डाउनलोड करना जारी रखना चाहते हैं?",
    28771: "आंतरिक उत्तर के साथ समीक्षा",
    28781: "ऑटो-उत्तर के साथ समीक्षा",
    28791: "सौंपा गया",
    28801: "Google ज्ञान पैनल देखें",
    28821: "नया प्रबंधक",
    28831: "सीसी सक्षम करें",
    28851: "उत्तर हटाएं",
    28871: "मिश्रित",
    28881: "सितारे",
    28891: "नकारात्मक, मिश्रित, सकारात्मक",
    28931: "एक उत्तर सहेजें",
    28941: "खाता नाम संपादित करें",
    28951: "खाता नाम बदलें",
    28961: "खाता नाम",
    28971: "फेसबुक स्थान",
    28981: "पृष्ठ जोड़ें",
    28991: "सक्रिय",
    29001: "छिपा स्थान दिखाएं",
    29011: "एफबी पेज देखें",
    29021: "दिखाने के लिए कोई छुपा खाता नहीं",
    29031: "घंंटों पहले",
    29041: "निमंत्रणदाता",
    29051: "समीक्षा शोकेस",
    29061: "Google स्थान",
    29071: "आपके स्थान",
    29081: "स्थान URL",
    29091: "क्या आप वाकई इस यूआरएल को हटाना चाहते हैं?",
    29101: "क्या आप एप्लिकेशन से यूआरएल और इसके संबंधित डेटा को हटाना चाहते हैं?",
    29111: "प्रतिस्पर्धी स्थान",
    29121: "प्रतियोगी नाम",
    29131: "प्लेस आईडी",
    29141: "कॉम्पटैग",
    29151: "स्थान URL और प्रतियोगी विवरण दर्ज करें",
    29161: "Iscompetitor",
    29171: "बुकिंग स्थान",
    29181: "बुकिंग समीक्षा एकीकरण शुरू करने के लिए",
    29191: "बैक ऑफिस स्थान आईडी (वैकल्पिक)",
    29201: "कृपया अपना स्थान प्लेसाइड या प्रतियोगी विवरण भरें। 20 या अधिक स्थानों के लिए,\r\nकृपया प्रत्येक स्थान की एक सूची एक एक्सेल फ़ाइल के रूप में प्रदान करें",
    29211: "नमूना फ़ाइल डाउनलोड करने के लिए क्लिक करें",
    29221: "कृपया ध्यान दें कि प्रारंभिक fetch को पूरा करने में कई मिनट लग सकते हैं",
    29231: "कृपया प्रत्येक की एक सूची प्रदान करें",
    29241: "व्यवसाय के लिए स्थान URL",
    29251: "आप उन्हें सीधे ईमेल में रख सकते हैं या Google शीट सूची का एक्सेल प्रदान कर सकते हैं",
    29261: "कृपया अपना स्थान URL और वैकल्पिक बैक ऑफिस स्थान आईडी भरें (समीक्षा प्रतिक्रिया के लिए गहरी लिंकिंग का समर्थन करने के लिए), या",
    29271: "प्रतियोगी विवरण।",
    29281: "बड़े खाते (20+ स्थान) एक एक्सेल फ़ाइल के रूप में प्रत्येक स्थान की एक सूची प्रदान कर सकते हैं",
    29291: "सही समय पर सही प्रतिक्रिया के साथ समीक्षाओं को सीधे प्रतिक्रिया देने के लिए अभियान बनाएं",
    29301: "क्या आप वाकई इस अभियान को मिटाना चाहते हैं?",
    29311: "प्रत्येक असाइन किए गए स्थान प्रबंधक को बुद्धिमान समीक्षा कॉपी करें",
    29321: "सीसी असाइन किए गए स्थान प्रबंधकों को जवाब देता है",
    29331: "सीसी कॉर्पोरेट को जवाब देता है",
    29341: "प्राप्तकर्ताओं",
    29351: "सभी प्राप्तकर्ता",
    29361: "समीक्षा स्रोत का चयन करें",
    29371: "पब / उप",
    29381: "स्टार रेटिंग का चयन करें",
    29391: "समीक्षा सामग्री का चयन करें",
    29401: "कस्टम समूह",
    29411: "ऑटो उत्तर भेजने से पहले देरी सेट करें",
    29421: "ऑपरेशन के घंटे सेट करें",
    29431: "ऐच्छिक",
    29441: "कोई स्थान सौंपा गया",
    29451: "चयनित तिथि सीमा और मानदंडों के लिए कोई अंतर्दृष्टि नहीं मिली।",
    29461: "फ़िल्टर मेनू",
    29471: "तरह",
    29481: "खोज में विचार",
    29491: "नक्शे में दृश्य",
    29501: "उत्तर पोस्ट करने के लिए आपके पास पर्याप्त अनुमतियां नहीं हैं।",
    29511: "पहले से ही भेजा",
    29521: "AR टेम्पलेट्स अपलोड करें",
    29531: "अनुयायी गिनती",
    29541: "अंतिम सिंक",
    29551: "निगमित",
    29561: "एजेंसी",
    29571: "लोकलपोस्ट सक्षम",
    29581: "कोई लंबित सत्यापन नहीं",
    29591: "इनबॉक्स में इस समीक्षा को देखने के लिए क्लिक करें",
    29601: "अधिक पढ़ें",
    29611: "लोड हो रहा है",
    29621: "कुल (संख्या) आइटम",
    29631: "Google मेरा व्यवसाय सत्यापित",
    29641: "के रूप में मार्क करो",
    29651: "घंटे जोड़ें",
    29661: "आज",
    29671: "गली का पता",
    29681: "डाक कोड",
    29691: "काले स्वामित्व के रूप में पहचानता है",
    29701: "यू आर एल जोड़िये",
    29711: "पद",
    29721: "ई - मेल से संपर्क करे",
    29731: "Covid_19 अद्यतन",
    29741: "आपके व्यवसाय में परिवर्तन?",
    29751: "अभियान",
    29761: "ऑनलाइन ऑर्डर",
    29771: "खरीदना",
    29781: "अब कॉल करें",
    29791: "अभी",
    29801: "इस स्थान को सिंक करें?",
    29811: "फेसबुक लिस्टिंग",
    29821: "नई फेसबुक लिस्टिंग बनाएं",
    29831: "गिने चुने",
    29841: "व्यापार विवरण",
    29851: "संपर्क",
    29861: "चर",
    29871: "आंतरिक आईडी",
    29881: "कनेक्ट करने के लिए क्लिक करें",
    29891: "अपलोड करने के लिए वापस",
    29901: "Google पर Q & A देखें",
    29911: "आवश्यकता होती है",
    29921: "अक्षम करना",
    29931: "बंद पुष्टि की समीक्षा करें",
    29941: "उत्तर दें पुष्टि",
    29951: "समीक्षा हटाने की पुष्टि",
    29961: "क्षेत्र",
    29971: "इस सवाल का जवाब",
    29981: "प्रबंधित करना",
    29991: "Create Google Post",
    30001: "Google पोस्ट बनाएं",
    30011: "Google पोस्ट प्रबंधित करें",
    30021: "ठिकाने को छिपाएं",
    30031: "वर्तमान पृष्ठ का चयन करें",
    30041: "फेसबुक पोस्ट बनाएं",
    30051: "सभी साफ करें",
    30061: "फ़िल्टर सहेजें",
    30071: "खोज भूमिका",
    30081: "उपयोगकर्ता खोजें",
    30091: "सभी संपादक",
    30101: "रेटिंग के लिए असाइन करें (आवश्यक)",
    30111: "टेम्पलेट नाम दर्ज करें (आवश्यक)",
    30121: "कस्टम टेम्पलेट चर (वैकल्पिक)",
    30131: "विषय का चयन करें या बनाएं (वैकल्पिक)",
    30141: "एकल स्थान (वैकल्पिक) को असाइन करें",
    30151: "एंटिटी टैग को असाइन करें (वैकल्पिक)",
    30161: "चर की समीक्षा करें",
    30171: "समीक्षक पहला नाम",
    30181: "समीक्षक पूरा नाम",
    30191: "स्थान चर",
    30201: "उत्तर स्थान का नाम",
    30211: "भू स्थान का नाम",
    30221: "इस समीक्षा के लिए एक उत्तर पहले ही भेजा जा चुका है।",
    30231: "इस समीक्षा के लिए उत्तर अब और नहीं भेजा जा सकता है। आप इसे यहां से हटाने के लिए इस उत्तर को हटा सकते हैं।",
    30241: "क्या आप इस स्थान के डेटा को सिंक करना चाहेंगे? यह स्थान के लिए किए गए सभी अपडेटों में खींच जाएगा।",
    30251: "कोविद -19 के कारण ग्राहकों को आपके व्यवसाय में किसी भी बदलाव के बारे में बताएं",
    30261: "अब भेजें",
    30271: "खोज शोकेस",
    30281: "सटीक समीक्षा शोकेस बनाने के लिए दाईं ओर स्थित नियंत्रणों का उपयोग करें। तत्काल पूर्वावलोकन लोड करने के लिए 'लागू करें' बटन पर क्लिक करें",
    30291: "अपनी समीक्षा शोकेस बनाएं",
    30301: "शोकेस विवरण",
    30311: "इस शोकेस का नाम दें",
    30321: "व्यक्तिगत स्थान",
    30331: "स्थान समूह",
    30341: "शोकेस शीर्षक",
    30351: "छिपाना",
    30361: "समीक्षक छवि / अवतार",
    30371: "प्रदर्शन",
    30381: "समीक्षा सेट का चयन करें",
    30391: "स्रोतों की समीक्षा",
    30401: "से समीक्षा",
    30411: "शोकेस बनाएं",
    30421: "न्यूनतम रेटिंग",
    30431: "केवल समीक्षा रेटिंग",
    30441: "प्रस्तुति को परिभाषित करें",
    30451: "अधिकतम समीक्षा गिनती",
    30461: "अधिकतम टिप्पणी Lenght",
    30471: "प्रति पृष्ठ अधिकतम समीक्षा",
    30481: "अनुकूल लेआऊट",
    30491: "क्रमबद्ध करेन का आदेश",
    30501: "नवीनतम प्रथम",
    30511: "स्टार रेटिंग रंग",
    30521: "टिप्पणियों की समीक्षा करें",
    30531: "स्रोत लोगो",
    30541: "पुनरीक्षण दिनांक",
    30551: "सटीक तिथि",
    30561: "फ़ॉन्ट परिवार",
    30571: "शोकेस शीर्षक आकार",
    30581: "समीक्षक नाम का आकार",
    30591: "टिप्पणी का आकार",
    30601: "ओवरराइड सेट करें",
    30611: "सबसे ऊपर पिन करें",
    30621: "निकालना",
    30631: "मेरी समीक्षा",
    30641: "सहायता की जरूरत है",
    30651: "ग्राहक की प्रतीक्षा कर रहा है",
    30661: "प्रतिक्रिया का इंतजार",
    30671: "नई प्रतिक्रिया",
    30681: "खोज नाम",
    30691: "टैग जोड़ो",
    30701: "सफलतापूर्वक उत्परिवर्तित",
    30711: "अभियान सामग्री का नाम (वैकल्पिक)",
    30721: "नियम और शर्तें (वैकल्पिक)",
    30731: "क्या आप वाकई इस उपयोगकर्ता को हटाना चाहते हैं? एक बार हटा दिए जाने पर, उपयोगकर्ता को अब इस प्रोफ़ाइल तक पहुंच नहीं मिलेगी, जब तक कि आमंत्रित न हो।",
    30741: "क्या आप इस उपयोगकर्ता को हटाना चाहेंगे?",
    30751: "प्प्रतिक्रिया वितरण",
    30761: "हम समीक्षा सीएसवी डाउनलोड करने के लिए एक लिंक () एक ईमेल भेज देंगे।",
    30771: "इस प्रोफ़ाइल में 100 से अधिक स्थान हैं। हम आपको डाउनलोड लिंक के साथ एक ईमेल भेजेंगे",
    30781: "उपयोगकर्ता उत्तर",
    30791: "मार्क ने जवाब दिया",
    30801: "गंतव्य उत्तर",
    30811: "समीक्षा डैशबोर्ड  ",
    30812: "समीक्षा ",
    30813: "औसत",
    30814: "औसत रेटिंग",
    30815: "पो",
    30816: "ख़ुशी",
    30817: "शब्द अनुपात",
    30818: "प्रतिक्रिया अनुपात",
    30819: "स्रोत के अनुसार समीक्षा",
    30820: "रेटिंग के अनुसार समीक्षा",
    30821: "रेटिंग के अनुसार प्रतिक्रिया",
    30822: "हाल की समीक्षाएं",
    30823: "आपको पिछले {x} दिनों में {x} समीक्षाएं प्राप्त हुई हैं। यहां सबसे हाल के हैं",
    30824: "समय सीमा के दौरान प्रति प्राथमिक स्थान पर औसत समीक्षा संख्या",
    30825: "4-सितारा और 5-सितारा रेटिंग के साथ समीक्षाओं का प्रतिशत",
    30826: "खुशी का स्कोर सकारात्मक समीक्षाओं के प्रतिशत से नकारात्मक समीक्षाओं के प्रतिशत को घटाकर दर्शाया गया है",
    30827: "5-स्टार और 4-स्टार समीक्षाओं में पाए गए सभी टिप्पणियों का प्रतिशत सभी शब्दों की तुलना में साझा समय सीमा में। रेंज 5-स्टार से 1-स्टार तक जाता है।",
    30828: "समय सीमा के भीतर समीक्षाओं का प्रतिशत जिन्हें प्रतिक्रिया मिली है।",
    30829: "पिछले {xx} दिनों से {x data} में कमी",
    30830: "पिछले {xx} दिनों से {x data} में वृद्धि",
    30831: "पिछले {xx} दिनों से {x data} में कोई बदलाव नहीं",
    30832: "इन समीक्षाओं को देखने के लिए क्लिक करें",
    30833: "(स्थान का नाम) , (x) स्टार, समीक्षक: (x)",
    30834: "समीक्षाएं और औसत रेटिंग",
    30835: "समय के साथ स्टार रेटिंग द्वारा स्टैक की गई समीक्षा गणना + रेटिंग औसत का लाइन चार्ट।",
    30836: "स्टार रेटिंग द्वारा प्रतिशत",
    30837: "समय के साथ स्टार रेटिंग द्वारा स्टैक की गई समीक्षा गणना कुल का प्रतिशत के रूप में।",
    30838: "संचयी गिनती और औसत रेटिंग",
    30839: "रिपोर्ट की समय सीमा के लिए समीक्षा कुल और औसत रेटिंग।",
    30840: "स्रोत के अनुसार समीक्षाएं",
    30841: "स्रोत के अनुसार समय अवधि में समीक्षाओं की संख्या।",
    30842: "समय के साथ खुशी स्कोर",
    30843: "रिपोर्ट की श्रृंखला में प्रति समय अवधि का शुद्ध खुशी स्कोर।",
    30844: "सप्ताह का दिन",
    30845: "महीने का दिन",
    30846: "वर्ष का महीना",
    30847: "शीर्ष देश",
    30848: "शीर्ष राज्य",
    30849: "शीर्ष शहर",
    30850: "प्रतिक्रियाएं",
    30851: "त्वरित प्रतिक्रिया दर",
    30852: "माध्यिका",
    30853: "समय अवधि के दौरान प्रकाशित प्रतिक्रिया की संख्या और प्रति स्थान औसत।",
    30854: "2 दिनों के भीतर प्रतिक्रिया प्राप्त करने वाली समीक्षाओं का प्रतिशत और माध्यिका प्रतिक्रिया समय।",
    30855: "प्रतिक्रिया गणना और अनुपात",
    30856: "स्टार रेटिंग द्वारा प्रतिक्रिया की संख्या और समग्र प्रतिक्रिया अनुपात।",
    30857: "औसत प्रतिक्रिया समय",
    30858: "औसत प्रतिक्रिया समय दिनों में।",
    30859: "प्रतिक्रिया वितरण",
    30860: "समीक्षा प्रतिक्रिया समय का हिस्टोग्राम 10 श्रेणियों में विभाजित।",
    30861: "खुश",
    30862: "अनुपात",
    30863: "आयु",
    30864: "मूल स्थान रिकॉर्ड की गिनती, साथ में नक्शा नहीं किए गए लिस्टिंग रिकॉर्ड।",
    30865: "ऊर्जा",
    30866: "टिप्पणी अनुपात",
    30867: "टिप्पणी की लंबाई",
    30868: "अनुपात अंतर",
    30869: "लंबाई अंतर",
    30870: "टिप्पणियों के साथ और बिना टिप्पणियों के समीक्षाएं",
    30871: "प्रति स्टार रेटिंग औसत शब्द",
    30872: "प्रत्येक स्टार रेटिंग में शब्दों का प्रतिशत",
    30873: "टिप्पणी अनुपात प्रतिशत",
    30874: "सभी समीक्षाओं का प्रतिशत जिनमें ग्राहक टिप्पणियाँ शामिल हैं",
    30875: "टिप्पणी शब्द गणना",
    30876: "समीक्षाओं में टिप्पणियों के साथ शामिल किए गए शब्दों की औसत संख्या",
    30877: "टिप्पणी शब्द वितरण",
    30878: "प्रत्येक समय अवधि के लिए प्रत्येक सितारे की रेटिंग में शब्दों का प्रतिशत",
    30879: "सकारात्मक समीक्षाओं में टिप्पणियां छोड़कर नकारात्मक समीक्षाओं का प्रतिशत।",
    30880: "सकारात्मक समीक्षाओं की औसत लंबाई में से नकारात्मक समीक्षाओं की औसत लंबाई घटाएं।",
    30881: "समीक्षाएं जिनमें उत्तर दर होती है",
    30882: "टिप्पणी लंबाई दर",
    30883: "ग्रिड व्यू",
    30884: "औसत स्थान",
    30885: "स्थानों का औसत समीक्षा स्कोर और समय सीमा में 4.0 से ऊपर की रेटिंग वाले स्थानों का प्रतिशत।",
    30886: "समीक्षा प्रदर्शन ग्रिड",
    30887: "स्थान रेटिंग औसत के مقابل समीक्षा मात्रा प्रस्तुत करें ताकि अपवादों की पहचान की जा सके",
    30888: "भावना",
    30889: "प्रभाव",
    30890: "परफॉर्मेंस डैशबोर्ड",
    30891: "लीडरशिप ग्रिड",
    30892: "कुल दृश्य",
    30893: "परिवर्तन दर",
    30894: "कुल दृश्य और प्रत्येक स्थान पर औसत दृश्य।",
    30895: "डेस्कटॉप और मोबाइल पर नक्शा दृश्य, प्रतिशत विभाजन के साथ।",
    30896: "डेस्कटॉप और मोबाइल पर स्थानीय खोज दृश्य, प्रतिशत विभाजन के साथ।",
    30897: "कॉल, वेबसाइट क्लिक और ड्राइविंग दिशाओं के बीच प्रतिशत विभाजन के साथ कुल क्रियाएं।",
    30898: "कॉल, वेबसाइट क्लिक और ड्राइविंग दिशाओं के लिए कार्यों/दृश्यों का कुल रूपांतरण दर।",
    30899: "ग्राहक दृश्य",
    30900: "ग्राहक आपके व्यापार को कैसे और कहाँ देखते हैं।",
    30901: "ग्राहक क्रियाएँ",
    30902: "आपकी Google लिस्टिंग से ट्रैक करने योग्य क्रियाएँ।",
    30903: "कार्रवाई के परिणामस्वरूप होने वाले व्यापार लिस्टिंग इंप्रेशन का प्रतिशत",
    30904: "स्थान के अनुसार प्रभावशीलता",
    30905: "कुल दृश्य बनाम रूपांतरण दर (कार्रवाई / दृश्य) यह दिखाने के लिए कि प्रत्येक स्थान की प्रभावशीलता कितनी दृश्य उत्पन्न करने और उन्हें क्रियाओं में परिवर्तित करने में है।",
    30906: "नगर द्वारा प्रभावशीलता",
    30907: "प्रत्येक शहर के लिए कुल दृश्य बनाम रूपांतरण दर (कार्रवाई / दृश्य)।",
    30908: "समूह के अनुसार प्रभावशीलता",
    30909: "प्रत्येक कस्टम समूह के लिए कुल दृश्य बनाम रूपांतरण दर (कार्रवाई / दृश्य)।",
    30910: "उच्च दृश्य + कम रूपांतरण",
    30911: "उच्च दृश्य + उच्च रूपांतरण",
    30912: "कम दृश्य + कम रूपांतरण",
    30913: "कम दृश्य + उच्च रूपांतरण",
    30914: "मोबाइल",
    30915: "एमसर्च",
    30916: "एममैप्स",
    30917: "डीसर्च",
    30918: "डीमैप्स",
    30919: "साइट",
    30920: "कॉल",
    30921: "स्वास्थ्य स्कोर",
    30922: "दैनिक प्रदर्शन",
    30923: "तालिका से स्थान और मेट्रिक (दृश्य या क्रियाएँ) का चयन करें",
    30924: "खुशी दर",
    30925: "नाम/मित्रवत",
    30926: "पिछले {xx} दिनों में  {y} सितारों के औसत के साथ {x} स्थान",
    30927: "ऊपर",
    30928: "समूह",
    30929: "सभी दृष्टिकोण",
    30930: "सभी क्रियाएँ",
    30931: "डेस्कटॉप",
    30932: "अधिकतम सीमा पहुँच गई: चार्ट के लिए 8 स्थान तक चुनें।",
    30933: "समीक्षक",
    30934: "कुल मिलाकर भावना",
    30935: "{XX} विषयों में भावना स्कोर वितरण।",
    30936: "विषय द्वारा भावना",
    30937: "विषय आवृत्ति और संबंधित भावना स्कोर।",
    30938: "बहुत सकारात्मक",
    30939: "बहुत नकारात्मक",
    30940: "एक स्वचालन नियम नए समीक्षा पर ट्रिगर किया गया",
    30941: "एक स्वचालन नियम अद्यतन समीक्षा पर ट्रिगर किया गया",
    30942: "प्रतिक्रिया को स्वीकृत किया",
    30943: "एक टैग सौंपा",
    30944: "समीक्षा को सौंपा",
    30945: "पर",
    30946: "स्वचालित उत्तर भेजा गया",
    30947: "व्यवसाय के मालिक ने एक नई बाहरी प्रतिक्रिया बनाई",
    30948: "स्वचालन नियम द्वारा पर",
    30949: "सिस्टम द्वारा पर",
    30950: "नया बनाया",
    30951: "एक नया उत्तर बनाया पर",
    30952: "समीक्षा नोट बनाया के लिए",
    30953: "एक नोट हटाया पर",
    30954: "समीक्षा नोट हटाया पर",
    30955: "प्रतिक्रिया हटाई पर",
    30956: "प्रतिक्रिया संपादित की पर",
    30957: "से",
    30958: "स्वचालित उत्तर उत्पन्न किया पर",
    30959: "स्थानीय",
    30960: "सूचना",
    30961: "सूचित किया",
    30962: "अवलोकन",
    30963: "किया",
    30964: "प्रतिक्रिया",
    30965: "प्रतिक्रिया अनुमोदन इनबॉक्स में स्थानांतरित की गई",
    30966: "प्रतिक्रिया आउटबॉक्स में स्थानांतरित और पोस्टिंग के लिए अनुसूचित",
    30967: "प्रतिक्रिया पोस्ट की गई",
    30968: "समीक्षा सौंपा गया",
    30969: "समीक्षा पर",
    30970: "समीक्षा प्राप्त हुई",
    30971: "एक नोट भेजा",
    30972: "प्रणाली ने एक भाषा टैग असाइन किया",
    30973: "प्रणाली ने एक स्वचालित प्रतिक्रिया असाइन की",
    30974: "टैग",
    30975: "स्वचालन नियम द्वारा टीम पर",
    30976: "समयरेखा",
    30977: "को",
    30978: "अद्यतन किया",
    30979: "समीक्षा नोट को अद्यतन किया",
    30980: "समीक्षा रेटिंग को अद्यतन किया",
    30981: "समीक्षा स्थिति को अद्यतन किया",
    30982: "समीक्षा स्थिति को अद्यतन किया",
    30983: "उनके पर टिप्पणी को अद्यतन किया",
    30984: "API के माध्यम से के दौरान",
    30985: "Pub-Sub के माध्यम से पर",
    30986: "कोई टिप्पणी नहीं जोड़ी गई",
    30987: "पर",
    30988: "प्रणाली",
    30989: "द्वारा",
    30990: "से लिया गया समीक्षा असाइनमेंट",
    30991: "को सौंपना",
    30992: "निर्दिष्ट टैग:",
    30993: "निर्दिष्ट टैग समूह:",
    30994: "एक टैग हटा दिया गया:",
    30995: "अपडेट्स के साथ समीक्षा",
    30996: "अपडेट्स के बिना समीक्षा",
    30997: "सभी टैग चुनें",
    30998: "अचिह्नित को चुनें",
    30999: "अनुमोदन की प्रतीक्षा",
    31000: "सबसे पुराना पहले",
    31001: "आपके पास कोई सहेजी गई नोट्स नहीं हैं",
    31002: "आउटबॉक्स में उत्तर दें",
    31003: "समीक्षा संस्करण",
    31004: "समीक्षा विवरण",
    31005: "जानकारी खोलें",
    31006: "संबंध",
    31007: "त्रुटि",
    31008: "प्राथमिक",
    31009: "श्रेणियाँ",
    31010: "सोशल लिंक",
    31011: "मूल छवि उपयोगकर्ता या प्लेटफ़ॉर्म द्वारा हटा दी गई है।"
  },
  filipino: {
    2013: "Pinagsama -sama",
    2028: "Mga Review ng Koponan",
    2029: "I-automate",
    2030: "Puno",
    2031: "Itinalaga",
    2032: "Maghanap ng user",
    2033: "Magpadala ng email",
    2034: "Bumubuo",
    2035: "Sumagot si Ai",
    2036: "Mag -post ng tugon",
    2037: "Magbagong-buhay",
    2038: "Pag-apruba",
    2039: "Mag-post sa Source",
    2040: "Ipinadala ang tugon",
    2041: "Walang ipinadalang mensahe",
    2042: "Maaliwalas",
    2043: "Closed",
    2044: "Walang nakitang text ng tugon",
    2045: "Kopyahin ang tugon at pumunta sa pinagmulan",
    2046: "I-edit ang tugon",
    2047: "Aprubahan ang tugon",
    2048: "I-update ang Sagot",
    2049: "Tanggalin ang Tugon",
    2050: "Sigurado ka bang gusto mong tanggalin ang tugon na ito?",
    2051: "Sigurado ka bang gusto mong isumite ang tugon na ito?",
    2052: "Gusto mo bang ibalik ang pagsusuring ito?",
    2053: "Sigurado ka ba ?",
    2054: "Sigurado ka bang gusto mong aprubahan ang tugon na ito?",
    2055: "Mga Koponan",
    2056: "Rating Lang",
    2057: "Rating + MaiklingKomento",
    2058: "Rating + Komento",
    2059: "Pagsusuri Ayon sa Wika",
    2060: "Mangyaring magbigay ng haba ng komento sa pagitan ng 1 at 100, ang Default ay magiging 20 character",
    2061: "Kopyahin ang Intelligent Review Replies sa bawat nakatalagang location manager",
    2062: "Mag-sign in",
    2063: "Email address",
    2064: "Walang account?",
    2065: "Pangalan",
    2066: "Huling pangalan",
    2067: "kumpanya",
    2068: "Pangalan ng Kumpanya",
    2069: "Mayroon nang account?",
    2070: "Ipakita ang Password",
    2071: "Itago ang Password",
    2072: "Lokal na Pagbabago",
    2073: "Mga Mapa Mobile",
    2074: "Mga Mapa Desktop",
    2075: "Paghahanap Mobile",
    2076: "Paghahanap Desktop",
    2077: "Mga tanawin sa paghahanap",
    2078: "Mga tanawin ng mapa",
    2081: "Pangkalahatan",
    2091: "Ayon sa Paksa",
    10010: "1 bituin",
    10013: "2 bituin",
    10016: "3 bituin",
    10019: "4 na bituin",
    10022: "5 TALA",
    10025: "100-300 salita",
    10120: "Mga kilos",
    10123: "Buhayin",
    10124: "Lagingaktibo",
    10126: "Mga aktibong organisasyon",
    10129: "Idagdag",
    10132: "Magdagdag ng isang pindutan",
    10135: "Magdagdag ng isang pindutan (opsyonal)",
    10138: "Magdagdag ng account",
    10141: "Magdagdag ng karagdagang telepono",
    10144: "Magdagdag ng isang account.",
    10147: "Magdagdag ng isa pang kategorya",
    10150: "Magdagdag ng isa pang label",
    10153: "Magdagdag ng mga katangian",
    10156: "Magdagdag ng Linya",
    10159: "Magdagdag ng bagong petsa",
    10162: "Magdagdag ng bagong tag ng pagsusuri",
    10165: "Magdagdag ng bagong papel",
    10168: "Magdagdag ng petsa ng pagbubukas",
    10171: "Magdagdag ng profile",
    10174: "Magdagdag ng ulat",
    10177: "Magdagdag ng ulat",
    10180: "Magdagdag ng papel",
    10181: "Magdagdag ng pagsusuri tag",
    10183: "Karagdagang kategorya",
    10186: "Karagdagang Telepono",
    10189: "Address.",
    10192: "Admin.",
    10195: "Administrator",
    10198: "Mga Extension ng Lokasyon ng AdWords.",
    10201: "AdWords Location Extensions Phone.",
    10204: "Lahat",
    10207: "Lahat ng mga pagsusuri",
    10210: "Ang lahat ng mga gumagamit na nakatalaga sa papel na ito ay magkakaroon ng access sa mga sumusunod na tampok",
    10213: "Mag -apply",
    10216: "Inbox ng pag -apruba",
    10219: "Sigurado ka bang gusto mong i-reset ang password ng user na ito?",
    10222: "Sigurado ka ba?",
    10225: "Lugar",
    10228: "Mga lugar",
    10231: "Listahan ng Attribute.",
    10234: "Pahintulutan ang account.",
    10237: "Average",
    10240: "Average na dami",
    10243: "Average na rating",
    10244: "Avg. Rating",
    10246: "Average bawat lokasyon",
    10249: "Naghihintay ng tugon",
    10320: "Pabalik",
    10321: "bumalik sa admin.",
    10323: "Pagsingil",
    10326: "Book.",
    10329: "Bulk upload post.",
    10332: "Bulk upload tags.",
    10335: "Bulk Mag-upload ng TSV.",
    10338: "Pangalan ng Negosyo",
    10520: "Kalendaryo",
    10523: "Kanselahin",
    10526: "Hindi maaaring mag-upload ng master market mapping!",
    10529: "Kategorya",
    10532: "Baguhin ang papel",
    10535: "Kasaysayan ng pagsipi",
    10538: "Lungsod",
    10541: "Mag-click dito",
    10544: "Mag-click sa isang gumagamit upang italaga sa kanya ang papel na ito",
    10547: "Co.",
    10548: "Kumpirmahin ang Password",
    10550: "Kopya",
    10553: "Kopyahin at i-paste",
    10556: "Hindi mababago ang papel!",
    10559: "Hindi maaaring mag-upload ng post",
    10562: "Mga bansa",
    10565: "Bansa",
    10568: "Coupon Code.",
    10571: "Kupon code (opsyonal)",
    10574: "Lumikha ng bagong filter sa pamamagitan ng pagpili sa mga pagpipilian sa ibaba",
    10577: "Lumikha ng bagong filter",
    10580: "Lumikha ng bagong ulat",
    10583: "Lumikha ng mga post",
    10586: "Lumikha ng tag",
    10589: "Lumikha ng ulat na ito",
    10592: "Lumikha ng papel na ito",
    10595: "Nilikha ni.",
    10598: "Mga Pagkilos ng Customer",
    10720: "D, abbreviation letter para sa araw",
    10723: "Dashboard",
    10726: "Petsa",
    10729: "Saklaw ng petsa",
    10732: "Araw",
    10735: "I-deactivate",
    10738: "Default",
    10741: "Pagkaantala bago mag-post",
    10744: "Pagkaantala ng pagpapadala ng mga tugon sa pamamagitan ng.",
    10747: "Pagkaantala ng pagpapadala ng mga tugon sa pamamagitan ng.",
    10750: "Tanggalin.",
    10753: "Tanggalin?",
    10754: "Tanggalin ang profile",
    10756: "Desk",
    10759: "Paglalarawan.",
    10762: "Direct",
    10765: "Mga direktang query",
    10768: "Mga direksyon",
    10771: "Discovery.",
    10774: "Natatanging view.",
    10777: "I-download ang lahat ng data bilang CSV.",
    10780: "I-download bilang PDF.",
    10783: "I-download ang mga detalye ng lokasyon ng Google",
    10786: "I-download ang data na ito bilang CSV.",
    10789: "Mga draft",
    10792: "Direksyon sa pagmamaneho",
    10795: "Mga direksyon sa pagmamaneho sa araw",
    10920: "I-edit",
    10923: "I-edit ang Profile (s)",
    10926: "I-edit ang ulat",
    10929: "I-edit ang ulat na ito",
    10932: "Editor.",
    10935: "Email",
    10938: "End time.",
    10941: "Ipasok ang mga extension ng lokasyon ng AdWords.",
    10944: "Ipasok ang Pangalan ng Tag Entity.",
    10947: "Ipasok ang mga label",
    10950: "Ipasok ang teksto ng paghahanap",
    10953: "Ipasok ang pangalan ng tag",
    10956: "Katumbas",
    10959: "Kaganapan",
    10962: "Mga Detalye ng Kaganapan",
    10965: "Pamagat ng Kaganapan",
    10968: "Bawat",
    10971: "example.com.",
    10974: "Halimbawa: 20% off sa tindahan o online",
    11120: "Tampok na Pag-access sa Pamamahala",
    11123: "Mga filter",
    11126: "Nakalimutan ang password?",
    11129: "Biyernes",
    11320: "Kumuha ng alok",
    11323: "Mahigit sa",
    11520: "Rating ng kaligayahan",
    11525: "Tulong",
    11530: "Hoiday.",
    11535: "Oras.",
    11540: "Oras",
    11545: "Paano naghahanap ang mga customer para sa iyong negosyo",
    11720: "Larawan",
    11723: "URL ng imahe",
    11726: "Sa Maps.",
    11729: "Sa paghahanap",
    11732: "Inbox",
    11735: "Hindi tuwirang mga query",
    11738: "Mga pananaw",
    11741: "Hindi sapat na pahintulot.",
    11744: "Pagsasama",
    11747: "Pagsasama-sama",
    11750: "Mag-imbita ng user",
    11753: "Inanyayahan",
    11756: "Inanyayahan ni.",
    11759: "Mga Item",
    12120: "Knowledge Panel.",
    12320: "Mga label",
    12323: "Huling Login.",
    12326: "Huling na-update",
    12329: "Matuto nang higit pa",
    12332: "Mas mababa kaysa",
    12335: "Link para sa iyong pindutan",
    12338: "Link sa redeem alok",
    12341: "Link sa redeem alok (opsyonal)",
    12344: "Mag-link sa pagsusuri na ito",
    12347: "Pamamahala ng Listahan",
    12350: "Lokal na Pagganap",
    12353: "Pangkalahatang-ideya ng lokal na pagganap",
    12356: "Lokal na Paghahanap ng Conversion",
    12359: "Mga lokalidad",
    12362: "Lokalidad",
    12365: "Lokasyon",
    12368: "Mga Detalye ng Lokasyon",
    12371: "Lokasyon ID.",
    12374: "Mga lokasyon",
    12377: "Pag-login",
    12380: "Logout.",
    12520: "M, abbreviation para sa buwan",
    12523: "Gawin ang iyong post standout na may isang larawan",
    12526: "Pamahalaan ang bulk activity",
    12529: "Pamahalaan ang mga tag ng entity",
    12532: "Pamahalaan ang mga lokasyon",
    12535: "Pamahalaan ang Profile",
    12538: "Pamahalaan ang mga tungkulin",
    12541: "Pamahalaan ang mga gumagamit",
    12544: "Mga mapa.",
    12547: "Bilang ng merchant",
    12550: "Mga larawan ng mangangalakal",
    12553: "Merchant, Photo Quantity vs Photo Views.",
    12556: "Mensahe",
    12559: "Minuto",
    12562: "Lunes.",
    12565: "Buwan",
    12720: "Pangalan",
    12723: "Pangalan ng bagong papel",
    12726: "Pangalan ng ulat",
    12729: "Kailangan mo ng isang account?",
    12732: "Bago",
    12735: "Susunod na pahina",
    12738: "Walang mga tugon",
    12741: "Walang nakita na mga resulta",
    12744: "Walang umiiral na mga tag ng pagsusuri",
    12747: "Walang mga pagsusuri",
    12750: "Hindi, kanselahin",
    12753: "Hindi. Ng mga gumagamit",
    12756: "Mga Tala",
    12920: "ng.",
    12923: "Alok",
    12926: "Ok.",
    12929: "OK, nakuha ito!",
    12932: "Minsan",
    12935: "Petsa ng pagbubukas",
    12938: "Utos",
    12941: "Mga samahan",
    12944: "Outbox.",
    12947: "May-ari",
    13120: "Iganarako",
    13123: "Password",
    13126: "Ilagay ang TSV.",
    13129: "Uri ng PDF.",
    13132: "Telepono",
    13135: "Mga tawag sa telepono sa araw",
    13138: "Numero ng telepono",
    13141: "Dami ng larawan",
    13144: "Mga tanawin ng larawan",
    13147: "Mangyaring magpasok ng isang recepient name!",
    13150: "Mangyaring magpasok ng isang pangalan ng ulat!",
    13153: "Mangyaring magpasok ng buod!",
    13156: "Mangyaring magpasok ng pamagat!",
    13159: "Mangyaring magpasok ng wastong oras!",
    13162: "Mangyaring magpasok ng wastong URL!",
    13165: "Paki-refresh ang pahina upang i-update ang mga detalye ng iyong lokasyon",
    13168: "Mangyaring i-reload",
    13171: "Mangyaring piliin ang uri ng iskedyul!",
    13174: "Mag-post ng kasaysayan",
    13177: "Mga post",
    13180: "Nakaraang Pahina",
    13183: "Pangunahing kategorya",
    13186: "Pangunahing Telepono",
    13189: "Pangunahing numero ng telepono",
    13192: "Mga profile",
    13195: "Pampublikong bilang",
    13198: "Mga Larawan sa Publiko",
    13201: "Mga pampublikong larawan.",
    13204: "Ilathala",
    13520: "Marka",
    13523: "Real time notifications.",
    13526: "Listahan ng tatanggap",
    13529: "Paulit-ulit",
    13532: "Alisin ang user",
    13535: "Sumagot",
    13538: "Sumagot Pag-apruba",
    13541: "Ulat ng Pamamahala.",
    13544: "Pangalan ng Ulat",
    13547: "Ulat ng Ulat.",
    13550: "I-reset ang password",
    13553: "Tugon sa pamamagitan ng rating ng bituin",
    13556: "Repasuhin ang bilang",
    13559: "REVIEW DOWNLOAD.",
    13562: "Suriin ang mga setting",
    13565: "Suriin ang pinagmulan",
    13568: "Suriin ang mga tag",
    13571: "Reviewlink.",
    13574: "Mga Review",
    13577: "Mga pagsusuri sa pamamagitan ng rating ng bituin",
    13580: "Mga pagsusuri kumpara sa average na rating",
    13583: "Mga Review Inbox",
    13586: "Pamamahala ng mga review",
    13589: "Mga pagsusuri, araw ng buwan",
    13592: "Mga pagsusuri, araw ng linggo",
    13595: "Mga pagsusuri, buwan ng taon",
    13598: "Tungkulin",
    13601: "Mga Detalye ng Tungkulin",
    13604: "Pangalan ng tungkulin",
    13720: "Sabado",
    13723: "I-save",
    13726: "Makatipid bilang pasadyang filter",
    13729: "I-save ang bagong filter",
    13732: "I-save ang papel",
    13735: "Nai -save na mga tugon",
    13738: "Petsa ng iskedyul",
    13741: "Iskedyul ng post",
    13742: "Mag-iskedyul ng isang ulat",
    13744: "Iskedyul ng oras",
    13747: "Iskedyul ng Uri",
    13750: "Maghanap.",
    13753: "Mga paghahanap",
    13756: "Piliin ang.",
    13759: "Pumili ng isang umiiral na filter",
    13762: "Piliin ang Kategorya",
    13765: "Piliin ang Lungsod",
    13768: "Piliin ang bansa",
    13771: "Piliin ang petsa at oras",
    13774: "Pumili ng hanay ng petsa",
    13777: "Piliin ang (mga) editor upang suriin",
    13780: "Piliin ang tag ng entidad.",
    13783: "Piliin ang Filter.",
    13786: "Piliin ang mga filter",
    13789: "Piliin ang granularity.",
    13792: "Piliin ang Organisasyon",
    13795: "Piliin ang Tag Review",
    13798: "Piliin ang nai -save na filter",
    13801: "Piliin ang mapagkukunan",
    13804: "Piliin ang Estado",
    13807: "Pumili ng oras",
    13810: "Sarili",
    13813: "Ipadala ito para sa pag-apruba",
    13816: "Ipadala ito sa Outbox.",
    13819: "Ipinadala",
    13822: "Mga serbisyo",
    13825: "Mga setting",
    13828: "Pamamahala ng mga setting",
    13831: "Shop.",
    13834: "Ipakita ang mga post",
    13837: "Ipakita / itago ang kaliwang nav",
    13840: "Mag-sign up",
    13843: "Single Lokasyon I-edit",
    13846: "Paumanhin!",
    13849: "Pagsunud-sunurin sa pamamagitan ng",
    13852: "Mga espesyal na oras",
    13855: "Tiyak na pag-access",
    13858: "Standard.",
    13861: "Oras ng pagsisimula",
    13864: "Estado.",
    13867: "Katayuan",
    13870: "Tindahan",
    13873: "Store Code",
    13876: "Street.",
    13879: "Buod View.",
    13882: "Linggo",
    13885: "I-sync ang account na ito",
    13920: "Telepono",
    13923: "Mga tuntunin at kundisyon",
    13926: "Huwebes",
    13929: "Oras",
    13932: "Mga nangungunang lokalidad",
    13935: "Kabuuan",
    13938: "Martes.",
    14120: "Hindi nasagot",
    14123: "Hindi sigurado sa format?",
    14126: "Mag-upload",
    14129: "I-upload ang mga detalye ng lokasyon",
    14132: "Mag-upload ng mapa ng lokasyon",
    14135: "Mag-upload ng Pagma-map ng lokasyon",
    14138: "Mag-upload ng TSV.",
    14141: "Url.",
    14144: "Userid.",
    14320: "Tingnan ang larawan",
    14323: "Tingnan ang Profile",
    14326: "Tanawin.",
    14520: "W, abbreviation letter para sa linggo",
    14523: "Website",
    14526: "Website sa araw",
    14529: "Pangalan ng Website",
    14532: "Miyerkules",
    14535: "Linggo",
    14538: "Anong mga pagkilos ang ginagawa ng mga customer",
    14541: "Kapag ang isang sagot sa isang pagsusuri ay ginawa",
    14544: "Kung saan tinitingnan ng mga customer ang iyong negosyo",
    14547: "Gusto mo bang tanggalin ang naka-iskedyul na post na ito?",
    14550: "Isulat ang iyong Pamagat",
    14920: "Taon",
    14923: "Oo, magpatuloy",
    14926: "Maaari mong piliin na limitahan ang pag-access ng mga gumagamit na may papel na ito sa pamamagitan ng pagpili ng isang filter na naka-attach dito.",
    14929: "Ang iyong pangalan",
    15120: "Zip.",
    20010: "Lunes.",
    20011: "Mon.",
    20020: "Martes.",
    20021: "Tue.",
    20030: "Miyerkules",
    20031: "Wed.",
    20040: "Huwebes",
    20041: "Thu.",
    20050: "Biyernes",
    20051: "Biyernes",
    20060: "Sabado",
    20061: "Sab",
    20070: "Linggo",
    20071: "Sun.",
    20110: "Enero",
    20111: "Enero",
    20120: "Pebrero",
    20121: "Pebrero",
    20130: "Marso.",
    20131: "Mar.",
    20140: "Abril",
    20141: "Abr",
    20150: "Mayo",
    20151: "Mayo",
    20160: "Hunyo.",
    20161: "Jun.",
    20170: "Hulyo",
    20171: "Jul",
    20180: "Agosto.",
    20181: "Agosto",
    20190: "Setyembre",
    20191: "Sep.",
    20200: "Oktubre.",
    20201: "Oktubre obligasyon",
    20210: "Nobyembre",
    20211: "Nobyembre",
    20220: "Disyembre",
    20221: "Disyembre",
    20231: "Mga Review at Ratings.",
    20241: "Porsyento",
    20251: "Repasuhin sa porsyento",
    20261: "Pinagsama",
    20271: "Cumulative Count.",
    20281: "Pinagmulan",
    20291: "Suriin ng mga mapagkukunan",
    20301: "Kaligayahan",
    20311: "Oras ng pagtugon",
    20321: "Piliin ang Lokasyon",
    20331: "Maghanap ng mga review keyword",
    20341: "Search by reviewer.",
    20351: "Piliin ang.",
    20361: "Katumbas",
    20371: "Mas mababa sa",
    20381: "Mas malaki kaysa",
    20391: "Pumili ng mga buwan",
    20401: "Piliin ang petsa",
    20411: "I-click upang tingnan ang mga review na ito",
    20421: "Walang mga review na natagpuan para sa napiling hanay ng petsa at pamantayan",
    20431: "Malinaw na filter",
    20441: "Tanggalin ang isang pasadyang filter",
    20451: "Ay may mga update sa Google",
    20461: "Neripikadong",
    20471: "Inilathala ang lokasyon",
    20481: "May nakabinbing mga pag-edit",
    20491: "Knowledge Panel.",
    20501: "Suriin ang link",
    20511: "Mga direksyon",
    20521: "Duplicate",
    20531: "Aktibo",
    20541: "Maaaring i-update",
    20551: "Maaaring tanggalin.",
    20561: "Walang nakabinbing pagsusuri",
    20571: "Pinagana ang lokasyon",
    20581: "Hindi naka-disconnect",
    20591: "Baguhin ang log",
    20601: "Bulk upload image.",
    20611: "Kasaysayan ng imahe",
    20621: "Bulk Mag-upload ng tala",
    20631: "Bulk upload Q & A.",
    20641: "Q & A History.",
    20651: "Magdagdag ng isang katanungan",
    20661: "Ipakita ang isang tanong sa mga customer na nagha-highlight ng isang pangunahing halaga ng panukala o isang natatanging competitive na bentahe ng iyong lokasyon. Pagkatapos ay maaari mong sagutin ang mga tanong.",
    20671: "Mga Detalye ng Platform",
    20681: "Auto Reply Variables.",
    20691: "Pangalan ng lugar",
    20701: "Geo pangalan",
    20711: "Lagda",
    20721: "Geo name (max 80 characters)",
    20731: "Pangalan ng Lagda (max 80 character)",
    20741: "AAuto reply.",
    20751: "Mag -download ng mga pagsusuri",
    20761: "Auto Response.",
    20771: "Panlabas na link",
    20781: "Kopyahin ang pagsusuri",
    20791: "Magdagdag ng tala",
    20801: "Panlabas na tala",
    20811: "Bandila bilang hindi naaangkop",
    20821: "Markahan bilang inalis",
    20831: "Sigurado ka ba?",
    20841: "Gusto mo bang markahan ang pagsusuri na ito bilang inalis mula sa Google?",
    20851: "Ipasok ang nai-save na mga tugon",
    20861: "I-save bilang template ng tugon",
    20871: "Ipasok ang template ng auto reply.",
    20881: "Ipadala",
    20891: "Magpadala ng pag-apruba",
    20901: "I-save bilang draft",
    20911: "Magtalaga ng tala",
    20921: "Email note.",
    20931: "Tatanggap",
    20941: "I-save bilang tala",
    20951: "Malapit",
    20961: "Itapon",
    20971: "Magpadala ng mail",
    20981: "Wala kang mga naka-save na tala",
    20991: "Lahat ay nahuli!",
    21001: "Walang mga entry upang ipakita",
    21011: "Nagpadala ng mga tugon",
    21021: "Ang tagasuri ay hindi nagdagdag ng anumang mga komento",
    21031: "I -edit ang tugon",
    21041: "Tanggalin ang Sagot.",
    21051: "Maghanap ng mga naka-save na tugon",
    21061: "Magdagdag ng nai -save na tugon",
    21071: "Pumili ng isang grupo at paksa upang i-save ang sagot na ito.",
    21081: "Pumili ng isang pangkat o simulan ang pag -type upang lumikha ng isa",
    21091: "Ipasok ang pamagat dito",
    21101: "Ipasok ang template ng tugon",
    21111: "Mangyaring tiyaking piliin/lumikha ng isang pangkat at pamagat upang mai -save ang tugon na ito.",
    21121: "Auto replies.",
    21131: "Magdagdag ng auto reply.",
    21141: "Pumili ng isang pangkat",
    21151: "Ipasok ang variable dito",
    21161: "Piliin ang iyong mga variable",
    21171: "Gusto mo bang magpatuloy?",
    21181: "Ang kahilingan na ito ay naglalaman ng higit sa 100 mga review para sa naturang mga kahilingan, padadalhan ka namin ng isang email na may isang link upang i-download ang pagsusuri CSV.",
    21191: "Mayroon kang higit sa 100 mga review",
    21201: "Ipapadala namin sa iyo ang isang email (sa X) na may isang link upang i-download ang pagsusuri CSV.",
    21211: "Mga pagkilos",
    21221: "Lahat ng lokasyon",
    21231: "AVG Rating.",
    21241: "Tatak",
    21251: "Direct",
    21261: "Pagtuklas.",
    21271: "Heograpiya",
    21281: "Kaligayahan",
    21291: "Query",
    21301: "Tugon.",
    21311: "Views.",
    21321: "Mag-post ng iskedyul",
    21331: "Iskedyul ng Google Post",
    21341: "Lumikha ng post.",
    21351: "Pamahalaan ang Post",
    21361: "Iskedyul ng localpost.",
    21371: "Mag-upload",
    21381: "Pag-unlad",
    21391: "Patunayan at mag-iskedyul",
    21401: "Iskedyul ng katayuan",
    21411: "Piliin ang File.",
    21421: "Pumili ng isang uri ng iskedyul",
    21431: "Agarang",
    21441: "Oras ng file.",
    21451: "Pumili ng oras",
    21461: "Post kaagad pagkatapos ng pag-verify",
    21471: "Iskedyul batay sa oras sa file",
    21481: "Mag-iskedyul ng file sa pamamagitan ng iyong napiling oras",
    21491: "Queue.",
    21501: "Ang pagpapatunay ay nasa progreso. Ang oras ng pagpoproseso ay humigit-kumulang 40 post bawat minuto. Pagkatapos ng pagpapatunay, ang katayuan ng bawat post ay magagamit sa susunod na pahina.",
    21511: "Na-proseso ang post.",
    21521: "Matagumpay na pagpapatunay",
    21531: "Nabigong pagpapatunay",
    21541: "Naka-iskedyul",
    21551: "I-type / aksyon",
    21561: "Petsa",
    21571: "Magsimula",
    21581: "Dulo",
    21591: "Pamagat / Produkto",
    21601: "Buod ng Post.",
    21611: "Katayuan",
    21621: "Tagumpay",
    21631: "Bigo.",
    21641: "I-edit / Tanggalin",
    21651: "Post Insights.",
    21661: "Google Post Insights.",
    21671: "Pagganap",
    21681: "Post views.",
    21691: "Mag-post ng Media.",
    21701: "Mag-post ayon sa paksa",
    21711: "Post sa pamamagitan ng pagkilos",
    21721: "Pagtatasa",
    21731: "Nilikha",
    21741: "Type.",
    21751: "Pagkilos",
    21761: "Filter ng Pinagmulan",
    21771: "Platform.",
    21781: "I-update ang katayuan ng lokalPost.",
    21791: "Tagabuo ng kampanya",
    21801: "Intelligent Auto Response.",
    21811: "I-on ang Auto Response Campaign Builder.",
    21821: "Bago ang pagpapagana ng opsyon sa iskedyul ng tugon ng auto, mangyaring siguraduhin na sundin ang mga tagubilin na ibinigay sa ibaba:",
    21831: "Bago ang Pag-enable ng Inteligent Auto Response Siguraduhin na idagdag ang iyong mga template ng auto reply sa seksyon ng reviewInbox.build ang mga sagot muna upang maitatalaga sila sa Star Ratings (1-5) na magpapalit ng isang intelihente auto response.",
    21841: "Sa tagabuo ng kampanya mangyaring pumili ng oras ng pagkaantala sa pagitan ng resibo ng resibo at paghahatid ng auto response. Ang pagtatakda ng pagkaantala ay dapat tumutugma sa perpektong oras ng pagtugon sa oras, dahil ito ay inilaan upang i-mask ang awtomatikong katangian ng programa.",
    21851: "Mangyaring isaalang-alang din ang pagtatakda ng oras ng operasyon (araw ng linggo at oras ng araw) para sa kampanya. Ang default na setting ng timezone ay GMT + 00: 00, kaya mangyaring i-update kung naaangkop.",
    21861: "Lumikha ng kampanya",
    21871: "Magtalaga ng isang pangalan at anumang mga tala upang madaling makilala ang iyong kampanya.",
    21881: "Pangalan ng kampanya",
    21891: "Responder ng kampanya",
    21901: "Kung walang pagpipilian ang pagpipilian, ang email na ginagamit upang mag-signup at pahintulutan ang mga account ay magiging default na sumasagot.",
    21911: "Sumasagot para sa auto reply.",
    21921: "Saklaw ng petsa ng kampanya",
    21931: "Mga Tala / Mga Layunin",
    21941: "Paglalarawan ng kampanya",
    21951: "Magtakda ng mga trigger",
    21961: "Piliin ang uri ng (mga) pagsusuri na mag-uudyok ng awtomatikong tugon para sa kampanyang ito.",
    21971: "may komento",
    21981: "Walang komento",
    21991: "nakaraan",
    22001: "susunod",
    22011: "Itakda ang madla (opsyonal)",
    22021: "Itakda ang mga lokasyon upang maging bahagi ng kampanya batay sa isang entity tag, isang organisasyon, o isang partikular na bansa / lugar / lokalidad. Ang mga filter na ito ay magagamit lamang para sa mga review ng Google at mga lokasyon na naka-map",
    22031: "entity.",
    22041: "organisasyon",
    22051: "Itakda ang iskedyul",
    22061: "Magtalaga ng mga parameter at iskedyul para sa mga tugon ng mga tugon, i.e. Ang porsyento ng mga naka-target na review at ang mga oras ng operasyon ng operasyon para sa mga tugon.",
    22071: 'Mangyaring malaman na ang mga awtomatikong tugon ay kasalukuyang magagamit lamang sa isang "go-forward" na batayan. Nagsusumikap kami sa hiwalay na mga proseso para sa mga gumagamit na maaaring nais na gawin ang isang malapit na pang-matagalang linisin nang awtomatiko.',
    22081: "Itakda ang tugon rate.",
    22091: "Itakda ang bilang ng tugon",
    22101: "pagkaantala bago magpadala ng auto reply.",
    22111: "Pana-panahong iskedyul",
    22121: "Pumili ng araw at magtakda ng oras upang shedule auto tugon pana-panahon",
    22131: "Piliin ang Timezone.",
    22141: "Magtalaga ng mga tugon",
    22151: "Mula sa listahan, piliin kung aling mga sagot ang gagamitin sa pag-ikot para sa kampanyang ito.",
    22161: "Kumpirmahin",
    22171: 'Suriin ang bawat isa sa mga detalye sa ibaba at pindutin ang "kumpirmahin" upang ilunsad ang iyong kampanya.',
    22181: "Araw",
    22191: "Bituin",
    22201: 'Avg (tulad ng sa "average")',
    22211: "Pag-uulat",
    22221: "Pag-setup ng kakumpitensya",
    22231: "Pinakamahusay na kasanayan",
    22241: "Kuwadrante",
    22251: "Ratings.",
    22261: "Competitive ranking.",
    22271: 'Resp (tulad ng sa "tugon")',
    22281: "Tingnan ang mga mapagkukunang pagsusuri",
    22291: "Magdagdag ng katunggali",
    22301: "Na-filter ni.",
    22311: "Malinaw",
    22321: "Katunggali",
    22331: 'Compentity (tulad ng sa "katunggali entity tag")',
    22341: "Entity Tag.",
    22351: "Puna",
    22361: "Walang mga pagpipilian",
    22371: "Masama",
    22381: "Mahina",
    22391: 'Average (tulad ng sa "star rating")',
    22401: "Malaki",
    22411: "Mahusay",
    22421: "Mga Review na may Sagot.",
    22431: "Mga pagsusuri nang walang tugon",
    22441: "Mga pagsusuri sa mga komento",
    22451: "Mga pagsusuri nang walang mga komento",
    22461: "Review volume vs average na rating",
    22471: "Mga tatak",
    22481: "Zoom",
    22491: "Kabuuang mga pagsusuri",
    22501: "Suriin ang rating sa pamamagitan ng Star.",
    22511: "Mga Review ng Kapangyarihan",
    22521: "Kakumpitensya ng.",
    22531: "Code (tulad ng sa 'storecode')",
    22541: "Pamahalaan ang mga katunggali",
    22551: "Na-update",
    22561: "Magdagdag ng mga kakumpitensya",
    22571: "Magdagdag ng lokasyon",
    22581: "Magdagdag ng Pangalan ng Kumperitor.",
    22591: "Ang unang hakbang ay upang idagdag ang pangalan ng kakumpitensya, sa sandaling naidagdag mo ang mga pangalan at opsyonal na mga icon (48x48 na mga imahe) sa listahan, mag-click sa 'Add'. Sa sandaling ang mga kakumpitensya ay nilikha, maaari mong italaga ang mga indibidwal na lokasyon",
    22601: "Ipasok ang pangalan ng katunggali (kinakailangan)",
    22611: "Ipasok ang URL ng kakumpitensya (opsyonal)",
    22621: "Mag-upload ng larawan",
    22631: "Paparating na",
    22641: "Ratio ng puna",
    22651: "Porsyento ng mga review sa at walang mga komento",
    22661: 'Walang (tulad ng sa "walang mga komento")',
    22671: 'May (tulad ng sa "may mga komento")',
    22681: "Haba ng Komento",
    22691: "Average na bilang ng mga salita na ginamit sa bawat komento sa pamamagitan ng star rating",
    22701: "Mga salita",
    22711: "Ratio ng salita",
    22721: "Kabuuang at porsyento ng mga salita sa mga komento para sa bawat rating ng bituin",
    22731: "Dito. (Link sa mga kakumpitensya sa pahina ng pagsasama)",
    22741: "Kakumpitensya",
    22751: "Magdagdag ng tag",
    22761: "Pumili ng mga variable na idaragdag sa template",
    22771: "Isara ang pagsusuri",
    22781: "Sarado na pagsusuri",
    22791: "Gusto mo bang isara ang pagsusuri na ito? Sa sandaling malapit ka, kakailanganin mong muling buksan ito upang tumugon",
    22801: "Panlabas",
    22811: "Negatibo",
    22821: "No.",
    22831: "Walang auto tugon pa!",
    22841: "Walang naka-save na tugon!",
    22851: "Tandaan",
    22861: "Permanenteng sarado",
    22871: "Positibo",
    22881: "Basahin ang nag-time out",
    22891: "Ibalik ang pagsusuri",
    22901: "Muling buksan ang pagsusuri",
    22911: "Sagot",
    22921: "Ipinadala ang tugon (mula sa interface ng Google)",
    22931: "Ipinadala ang tugon mula sa App.",
    22941: "Tinanggal ang pagsusuri",
    22951: "Mga template",
    22961: "Pansamantalang sarado",
    22971: "OO.",
    22981: "Wala kang naka-save na mga draft",
    22991: "Hindi sapat na mga pahintulot upang ma-access ang mapagkukunan",
    23001: "Nakaranas ng panloob na error.",
    23011: "Ang kahilingan ay naglalaman ng di-wastong argumento",
    23021: "Ang hiniling na entidad ay hindi natagpuan",
    23031: "Ang pagsusuri ay hindi na umiiral sa Google Platform",
    23041: "Ang ilan sa mga halaga ng auto insert ay hindi magagamit. Mangyaring palitan at ipadala",
    23051: "Kasalukuyang hindi available ang serbisyo",
    23061: "Ang operasyon na ito ay hindi suportado para sa mga hindi nakuha na lokasyon",
    23071: "Nai-publish na post",
    23081: "Naka-iskedyul na post",
    23091: "Friendly na pangalan",
    23101: "Magdagdag ng friendly na pangalan",
    23111: "Makipag-ugnay sa",
    23121: "Walang mga contact!",
    23131: "Upang magdagdag ng contact",
    23141: "Pangalan ng contact",
    23151: "Makipag-ugnay sa e-mail",
    23161: "Magdagdag ng contact",
    23171: "Post Insights.",
    23181: "Google Post Insights.",
    23191: "Walang data",
    23201: "Google Audit",
    23211: "Mga log ng audit.",
    23221: "Pumili ng isang ulat",
    23231: "Piliin ang.",
    23241: "Lahat ng pag-download",
    23251: "Walang mga pagpipilian",
    23261: "DATA DOWNLOADS.",
    23271: "REVIEW DOWNLOAD.",
    23281: "Lahat ng mga pagsusuri",
    23291: "I-download ang URL ng larawan",
    23301: "Mga URL ng Larawan ng Customer",
    23311: "Mga URL ng Merchant Photo.",
    23321: "Iulat ang kasaysayan ng pag-download",
    23331: "Pangalan ng Ulat",
    23341: "Ipinadala sa.",
    23351: "Nilikha Oras (UTC)",
    23361: "Ulat ng Ulat.",
    23371: "Mga Detalye ng Profile",
    23381: "Baguhin ang pangalan ng profile",
    23391: "Lingguhang Pag-sync",
    23401: "Paganahin ang Bulk Pamahalaan ang Lokasyon ng Lokasyon",
    23411: "Mga setting ng format ng petsa",
    23421: "I-save",
    23431: "Kaligayahan / NPS setting.",
    23441: "Promoter / Happy.",
    23451: "Neutral",
    23461: "Detractor / malungkot",
    23471: "I-update",
    23481: "Kasalukuyang mga logo",
    23491: "Buong logo",
    23501: "Icon",
    23511: "Iulat ang logo",
    23521: "Favicon.",
    23531: "Ang logo na ito ay naroroon sa itaas na kaliwang sulok habang pinalawak ang kaliwang nabigasyon ng iyong profile.",
    23541: "Ang logo na ito ay magpapakita sa itaas na kaliwang sulok ng iyong profile.",
    23551: "Ang logo na ito ay ipapakita sa mga ulat ng dashboard at repasuhin ang mga ulat na nabuo sa system. Gamitin ang isang imahe ng PNG sa pagitan ng 5KB hanggang 20KB para sa pinakamahusay na mga resulta",
    23561: "Ang logo na ito ay naroroon sa itaas na kaliwang sulok ng tab ng browser.",
    23571: "Palitan ang logo",
    23581: "Piliin kung aling uri ang logo na gusto mong baguhin gamit ang mga pagpipilian sa dropdown at mag-upload ng logo.",
    23591: "Mag-upload ng logo para sa",
    23601: "Configuration ng katayuan ng lokasyon ng GBP: Mga setting ng pagpigil",
    23611: "Suppress",
    23621: "Nakikita",
    23631: "Disconnected.",
    23641: "Unverified",
    23651: "Nasuspinde",
    23661: "Duplicate",
    23671: "Unang Pag-upload ng Partido",
    23681: "Mag-upload",
    23691: "Malinaw",
    23701: "Pamahalaan ang mga lokasyon sa bulk.",
    23711: "Kontrol ng Pamamahala ng Bulk.",
    23721: "I-update ang mga detalye ng lokasyon at kontrolin ang mga parameter ng platform nang direkta sa Google Sheet.",
    23731: "Platform.",
    23741: "Madaling pamahalaan ang mga account ng anumang scale na may mga pasadyang mga variable at setting ng lokasyon.",
    23751: "Mga detalye ng GBP",
    23761: "Tingnan ang lahat ng mga listahan ng Google Business Profile at direktang magdagdag / mag-edit / magtanggal ng mga detalye ng lokasyon.",
    23771: "Mga Katangian ng GBP.",
    23781: "Magtalaga ng lahat ng karapat-dapat na mga katangian sa bawat lokasyon upang makakuha ng incremental na pagtuklas ng paghahanap.",
    23791: "GBP Listing.",
    23801: "Lumikha ng bagong listahan ng GBP.",
    23811: "Facebook",
    23821: "Control ng listahan ng Facebook",
    23831: "Kasaysayan",
    23841: "Pagsasanay",
    23851: "I-access ang mga mapagkukunan para sa bulk i-edit ang mga daloy ng trabaho, pinakamahusay na kasanayan, limitasyon, at mga update.",
    23861: "Babala",
    23871: "Kinakailangan:",
    23881: "Ang mga gumagamit ay dapat magkaroon ng isang Google account upang ang sistema ay maaaring magpakita ng isang Google sheet gamit ang data ng profile.",
    23891: "Pansinin:",
    23901: "Ang data na populating bawat sheet kung mula sa database ng system. Kung nais mong tiyakin na ang spreadsheet ay nagtatanghal ng kasalukuyang data ng Google, masidhing inirerekomenda namin na unang i-synchronize mo ang iyong profile.",
    23911: 'Depende sa bilang ng mga lokasyon sa iyong account, ang Google Sheet ay maaaring tumagal ng oras upang bumuo ng build at pagkatapos ay i-refresh habang nag-navigate ka sa sheet. Mangyaring tiyakin na ang lahat ng data ay matatag bago itulak ang "pag-update" upang i-save ang mga pag-edit sa system at itulak ang mga update sa Google.',
    23921: "Ang platform ay may direktang API na koneksyon sa Google, ngunit maaaring may mga oras pa rin kapag ang Google ay naantala ang direktang pag-update sa pahina ng listahan ng pampublikong lokasyon.",
    23931: 'Ang pagtulak ng "Update" ay nagpapalit ng direktang sistema sa Google. Walang magagamit na proseso ng pag-undo o pagbalik. Mangyaring tiyakin na ikaw ay komportable sa lahat ng mga pag-edit bago ma-trigger ang pag-update. Kung ang isang pagkakamali ay ginawa, mangyaring maghintay ng ilang minuto at pagkatapos ay gawin ang kinakailangang pagbabago.',
    23941: "Color Scheme.",
    23951: "Ang bawat sheet ay may default na scheme ng kulay upang matulungan ang mga user na maunawaan kung aling mga patlang ang karapat-dapat para sa pag-edit.",
    23961: "Mga variable na alinman sa ihatid ang mga detalye ng katayuan mula sa Google o hindi maaaring i-edit nang direkta sa pamamagitan ng mga kontrol ng bulk.",
    23971: "Direktang bukas ang mga variable ng Google para sa bulk edit.",
    23981: "Ang mga variable ng platform ay direktang bukas para sa bulk edit.",
    23991: "Kontrol",
    24001: "Mga detalye",
    24011: "Mga katangian",
    24021: "Lumikha ng listahan",
    24031: "Mga tagubilin",
    24041: "Nag-expire na",
    24051: "Oras upang mag-subscribe!",
    24061: "Ang profile na ito ay mawawalan ng bisa",
    24071: "Upang mapanatili ang pag-access sa profile na ito, mangyaring mag-subscribe.",
    24081: "Dalhin mo ako doon!",
    24091: "Mamaya",
    24101: "Pagsingil",
    24111: "Mga detalye ng plano",
    24121: "Plus.",
    24131: "Pro.",
    24141: "/ Bawat lokasyon.",
    24151: "$ 8 / bawat lokasyon.",
    24161: "Unang 10 Mga Lokasyon",
    24171: "$ 24 / buwan minimum",
    24181: "Subukan ang libreng para sa 14 araw",
    24191: "Kasama ang lahat ng integrasyon",
    24201: "Buong mga review Inbox.",
    24211: "FULL ROLES ACCESS.",
    24221: "Buong Reporting Suite.",
    24231: "Walang limitasyong mga gumagamit",
    24241: "30 pre-install na mga tugon sa pagsusuri",
    24251: "Buong suporta",
    24261: "Mga Lokasyon 11-200.",
    24271: "Lahat ng mga tampok ng plus plan.",
    24281: "Buong pamamahala ng GBP.",
    24291: "Bulk / Iskedyul Google Posts.",
    24301: "Mga notification sa real-time",
    24311: "Custom na ulat set-up",
    24321: "Lokal na pag-optimize ng paghahanap",
    24331: "Personalized onboarding.",
    24341: "Profanity & Fraudulent Review Audit.",
    24351: "Aktibidad",
    24361: "Awtorisado",
    24371: "Awtorisadong Mga Koneksyon I-access ang buong pagsusuri at mga kakayahan sa pagtugon mula sa / sa bawat pinagmulan.",
    24381: "Bulk upload entity tags.",
    24391: "Bulk I-upload ang detalye ng GBP.",
    24401: "Pumili ng isang grupo at paksa upang i-save ang auto reply.",
    24411: "Bilangin",
    24421: "Lumikha ng Entity Tag.",
    24431: "Lumikha ng Oras (UTC)",
    24441: "Custom Sidebar Tabs.",
    24451: "Custom na mga tool sa sidebar",
    24461: "I-download ang GBP Audit.",
    24471: "Pangalan ng File",
    24481: "Kasaysayan ng detalye ng GBP.",
    24491: "Mga impression",
    24501: "Hindi aktibo",
    24511: "Na-index",
    24521: "Mga na-index na koneksyon I-access ang lahat ng makasaysayang at kasalukuyang mga review mula sa bawat pinagmulan.",
    24531: "Pamahalaan ang localpost.",
    24541: "walang komento naidagdag",
    24551: "Numero",
    24561: 'Mangyaring mag-click sa pindutan ng "Bagong Ulat", sa kanang tuktok',
    24571: "Profile Nilikha",
    24581: "Humiling id",
    24591: "I -save ang isang tugon",
    24601: "Kabuuang lokasyon",
    24611: "Total Post",
    24621: "Mag-upload ng AR Template",
    24631: "Mag-upload ng mga alias ng lokasyon.",
    24641: "View.",
    24651: "Maaari mong i-configure at itakda ang mga pasadyang tab sa sidebar na tumuturo sa isang iframe sa loob ng platform, o isang link na naka-host sa labas.",
    24661: "Mga detalye ng GBP",
    24671: "Mga Katangian ng GBP.",
    24681: "GBP Listing.",
    24691: "Facebook",
    24701: "Kasaysayan",
    24711: "Pagsasanay",
    24721: "Lingguhang pag-sync na nag-trigger sa",
    24731: "Mmm d, yyy.",
    24741: "Eg: -Oct 13,2020.",
    24751: "Mm / dd / yyyy.",
    24761: "Mmmm d, yyyy.",
    24771: "Eg: -Octubre 13,2020.",
    24781: "Dd / mm / yyyy.",
    24791: "Dd mmm yyyy.",
    24801: "Dd mmmm yyyy.",
    24811: "Eg: - 13 Oktubre 2020.",
    24821: "Mag-upload ng bagong logo",
    24831: "Hiwalay",
    24841: "Nakikitang nakatago",
    24851: "Suriin ang mga detalye ng configuration ng pane",
    24861: "Ipakita ang code ng tindahan",
    24871: "Ipakita ang buong address",
    24881: "Ipakita ang buod ng widget",
    24891: "Inverted header.",
    24901: "Pumili ng file",
    24911: "Walang piniling file.",
    24921: "Tingnan ang isang log ng bawat pag-update Push upang kumpirmahin ang mga pagbabago sa nilalaman ng nilalaman at makita ang anumang mga error.",
    24931: 'Depende sa bilang ng mga lokasyon sa iyong account, ang Google Sheet ay maaaring tumagal ng oras upang bumuo ng build at pagkatapos ay i-refresh habang nag-navigate ka sa sheet. Mangyaring tiyakin na ang lahat ng data ay matatag bago itulak ang "pag-update" upang i-save ang mga pag-edit sa system at itulak ang mga update sa Google.',
    24941: "Mga mapagkukunan para sa bulk i-edit ang mga daloy ng trabaho, pinakamahusay na kasanayan, limitasyon, at mga update.",
    24951: "User ID.",
    24961: "Gusto mo bang tanggalin?",
    24971: "Account.",
    24981: "Ay walang mga update sa Google",
    24991: "Hindi kinakailangan ang paggalang",
    25001: "Walang nakabinbing mga pag-edit",
    25011: "Oras ng pag-audit",
    25021: "patlang",
    25031: "Halaga (sa)",
    25041: "Halaga (mula sa)",
    25051: "Alisin mula sa Entity Tag.",
    25061: "Attributelist.",
    25071: "AdWords",
    25081: "Tingnan ang lahat",
    25091: "Q & A (tanong at sagot)",
    25101: "Galugarin",
    25111: "Galugarin ang mga tugon",
    25121: "Piliin ang Template",
    25131: "Magpatuloy",
    25141: "Pumili ng star rating, pangalan ng template at magdagdag ng nilalaman ng template upang i-save ang auto reply.",
    25151: "Piliin ang Uri ng Sagot",
    25161: "Template",
    25171: "Snippet.",
    25181: "Magtalaga sa rating (kinakailangan)",
    25191: "Ipasok ang pangalan ng template (kinakailangan)",
    25201: "Pasadyang template variable (opsyonal)",
    25211: "Pumili ng lumikha ng paksa (opsyonal)",
    25221: "Magtalaga sa iisang lokasyon (opsyonal)",
    25231: "Magtalaga sa tag ng entidad",
    25241: "Magdagdag ng pangalan ng paksa at snippet na nilalaman upang i-save ang auto reply.",
    25251: "Kabuuang # (numero) items.",
    25261: "Lokasyon Tandaan",
    25271: "Tingnan ang mga detalye ng lokasyon.",
    25281: "Tingnan ang Google Knowledge Pannel.",
    25291: "Tingnan ang pagsusuri nang direkta sa Google",
    25301: "Positive-5 Stars.",
    25311: "Negatibong - 1/2 Stars.",
    25321: "Mixed - 3/4 stars.",
    25331: "Pangalan ng template.",
    25341: "Variable.",
    25351: "Pumili o lumikha ng paksa (opsyonal)",
    25361: "Grupo",
    25371: "Paksa",
    25381: "Bago ang mga pagsusuri",
    25391: "I-save bilang tugon",
    25401: "Cc (carbon-copy)",
    25411: "Reset.",
    25421: "Ano ang Bago",
    25431: "Lumikha ng petsa",
    25441: "Pasadyang filter na pangalan",
    25451: "Basahin lamang",
    25461: "Tampok na Access.",
    25471: "Wala",
    25481: "Basahin",
    25491: "Hindi ipinagpapahintulot",
    25501: "Ito ay isang default na papel at hindi ma-edit / tinanggal",
    25511: "Basahin",
    25521: "Isulat.",
    25531: "I-download",
    25541: "Ang lahat ng mga gumagamit na nakatalaga sa papel na ito ay magkakaroon ng visibilty / access sa mga sumusunod na tampok",
    25551: "Mga setting ng subtab visibility",
    25561: "Pamahalaan ang papel",
    25571: "Pasadyang sidebar",
    25581: "O.",
    25591: "I-save ang mga katangian ng papel",
    25601: "Sigurado ka bang gusto mong tanggalin ang papel",
    25611: "Ito ay magbabago sa papel ng lahat ng mga gumagamit na kasalukuyang nakatalaga sa papel na ito upang mabasa lamang.",
    25621: "Magtalaga ng mga gumagamit",
    25631: "Mga gumagamit sa profile",
    25641: "Maghanap dito",
    25651: "Ang mga gumagamit na nakatalaga sa papel na ito",
    25661: "Walang user",
    25671: "Muling mag-imbita",
    25681: "Default na landing page.",
    25691: "Mga reviewinbox",
    25701: "Bulk management.",
    25711: "Mag-post ng pag-iiskedyul",
    25721: "Sa.",
    25731: "Off.",
    25741: "Sigurado ka bang i-off ang kampanya?",
    25751: "Sigurado ka bang i-on ang kampanya?",
    25761: "Matagumpay na na-update ang kampanya",
    25771: "Rate ng tugon",
    25781: "Bilang ng tugon",
    25791: "Mga rating ng bituin",
    25801: "May",
    25811: "Wala",
    25821: "Pagkaantala",
    25831: "Timezone.",
    25841: "Balik-aral",
    25851: "Ulat ng kakumpitensya",
    25861: "Format",
    25871: "HTML email",
    25881: "Excel.",
    25891: "Kung walang mga review sa napiling hanay",
    25901: "Huwag magpadala ng email",
    25911: "Magpadala ng email",
    25921: "Q & A.",
    25931: "Kung walang Q & A sa napiling hanay",
    25941: "Imahe ng customer.",
    25951: "Audit log.",
    25961: "Mangyaring makipag-ugnay sa suporta sa anumang mga katanungan tungkol sa Cadence ng Pag-sync ng Profile.",
    25971: "Isama ang audit file.",
    25981: "Profile",
    25991: "Comptag (tag ng katunggali)",
    26001: "Mga detalye ng pagsusuri",
    26011: "Pamahalaan ang mga kontrol ng tier",
    26021: "I-override ang default na pag-andar, organisado sa mga tier.",
    26031: "Bumuo ng alok na tier.",
    26041: "Lumikha ng bagong tier",
    26051: "Tier Pangalan",
    26061: "Default",
    26071: "Default",
    26081: "Reputation Dashboard.",
    26091: "Comprehensive InsightSinto Lahat ng pagsusuri KPIS.",
    26101: "Buong kakayahang makita sa lahat ng mga lokasyon at pinagkukunan",
    26111: "Mga seksyon",
    26121: "Core KPIs ng volume ng pagsusuri, average na rating, pamamahagi, pinagmulan, kaligayahan, at ratio ng tugon.",
    26131: "Longitudinal pagtatasa ng mga review at rating, porsyento, pinagsama-samang, pinagmulan, kaligayahan, at oras ng pagtugon histogram.",
    26141: "Ratio ng komento, haba ng komento at pinagsama-samang salita ratio sa pamamagitan ng rating.",
    26151: "Mga review sa araw ng linggo, araw ng buwan, at buwan ng taon.",
    26161: "Nangungunang limang bansa, estado / lalawigan, at mga lungsod sa pamamagitan ng pagsusuri ng lakas ng tunog.",
    26171: "Ang lahat ng makasaysayang data ay naipon sa panahon ng unang account na naka-set up at pagkatapos ay na-update mula sa lahat ng nakakonektang mga mapagkukunan ng pagsusuri araw-araw.",
    26181: "GBP Insights.",
    26191: "Direktang, tuklasin, at brand araw-araw na tsart ng lugar ng paghahanap ng dami.",
    26201: "Mga mapa at paghahanap araw-araw na pagtingin sa lugar ng tsart.",
    26211: "Tsart ng mga aksyon ng customer para sa direksyon ng pagmamaneho, mga tawag sa telepono, at mga pag -click sa website.",
    26221: "Mga pagkilos ng lokasyon sa pamamagitan ng araw ng mga chart ng haligi ng linggo.",
    26231: "Natatanging lokal na rasyon ng conversion (pagkilos / araw-araw na paghahanap).",
    26241: "Brand Photo Average na dami na naka-host sa lokasyon ng GBP at kabuuang mga pagtingin",
    26251: "Na-upload ng customer ang average na dami ng larawan na naka-host sa lokasyon ng GBP at kabuuang mga pagtingin.",
    26261: "Ang isang buong 18 buwan ng pang-araw-araw na data para sa bawat lokasyon ay naipon sa panahon ng unang account na naka-set up at pagkatapos ay na-update mula sa lahat ng nakakonektang mga mapagkukunan ng pagsusuri araw-araw. Ang Google ay kasalukuyang nag-uulat ng mga pananaw na may pagkaantala sa 3-5 araw.",
    26271: "Lokal na pagkakalantad sa paghahanap at pag-uulat ng pagkilos.",
    26281: "Localperformance.",
    26291: "Madaling ihambing ang pagganap sa mga lokasyon",
    26301: "Araw-araw na linya ng tsart ng mga napiling indibidwal na lokasyon para sa mga review, avg rating, paghahanap, pananaw, at pagkilos",
    26311: "Sortable at nahahanap na pagtatanghal ng talahanayan ng mga review ng bawat lokasyon at mga lokal na sukatan na may buong pag-download ng pag-download.",
    26321: "Ang karagdagang tab ay nag-aalok ng tsart ng pagganap at talahanayan ng geographic roll-up / drill-down na may sariling natatanging pag-download ng pag-download.",
    26331: "Mga review at GBP Insights table at chart sa pamamagitan ng indibidwal na lokasyon.",
    26341: "Mga reviewinbox",
    26351: "Aggregate Inbox para sa lahat ng mga lokasyon at pinagkukunan - filter, paghahanap, tumugon, at pamahalaan.",
    26361: "Pamahalaan ang lahat ng mga review mula sa lahat ng mga mapagkukunan",
    26371: "Workflows.",
    26381: "Maghanap at mag-filter upang mahanap ang mga review sa pamamagitan ng rating, pinagmulan, nilalaman, reviewer, mga tag o lokasyon.",
    26391: "Tumugon sa mga awtorisadong pinagkukunan ng pagsusuri nang direkta mula sa platform.",
    26401: "Galugarin ang mga template sa pamamagitan ng rating at snippet sa pamamagitan ng paksa upang magpadala ng mga personalized na tugon na may walang kapantay na bilis.",
    26411: "Lumikha ng mga daloy ng trabaho para sa mga kinokontrol na pag-apruba ng tugon.",
    26421: "Magpadala ng mga tala o cc 'direktang sumagot sa pamamahala ng lokasyon.",
    26431: "Buong kontrol",
    26441: "Pamahalaan ang Mga Listahan ng Lokasyon",
    26451: "Direktang API Magdagdag / Mag-edit / Tanggalin ang kontrol ng lahat ng mga listahan ng lokasyon Mga detalye sa buong account.",
    26461: "I-streamline ang kontrol ng anumang bilang ng mga listahan.",
    26471: "Maghanap at mag-filter sa anumang bilang ng mga lokasyon at nakakonektang mga account ayon sa katayuan at nilalaman.",
    26481: "Direktang i-edit ang mga detalye ng GBP sa pamamagitan ng indibidwal na lokasyon.",
    26491: "Lumikha ng indibidwal na mga post ng GBP para sa lahat ng mga karapat-dapat na lokasyon.",
    26501: "Ayusin ang mga lokasyon sa isang bilang ng mga natatanging mga grupo ng customer sa pamamagitan ng mga tag ng entity.",
    26511: 'Magtalaga ng "friendly na mga pangalan" upang gawing mas madali ang pamamahala ng mga profile ng enterprise, chain, at franchise.',
    26521: "Bulk Idagdag / i-edit ang nilalaman ng GBP, mga larawan, mga kategorya, oras, address, paglalarawan at higit pa.",
    26531: "Bulk magdagdag ng mga bagong tanong at sagot sa Google sa panel ng kaalaman ng bawat lokasyon.",
    26541: "Bulk magdagdag / mag-edit ng nilalaman ng platform tulad ng mga tala ng lokasyon, mga lokal na tagapamahala at higit pa.",
    26551: "Pagsubaybay sa Pagsusuri ng Kumpetensya",
    26561: "Mga paghahambing ng dashboard. Suriin ang mga paghahambing ng pamamahagi. Brand & Location Wave Quadrant.",
    26571: "Makakuha ng walang kapantay na pananaw sa feedback ng kakumpitensya",
    26581: "Review ng Competitor Review Dashboard, i-filter upang makilala ang eksaktong mga paghahambing.",
    26591: "Paghahambing ng pamamahagi ng rating sa mga tatak ng kakumpitensya.",
    26601: "Wave Chart ng Dami ng Pagsusuri kumpara sa average na rating, paghahambing ng mga tatak o indibidwal na mga lokasyon,",
    26611: "Buong pagsusuri ng komento ng komento at kahit na ang mga tugon ng kakumpitensya.",
    26621: "Ang seksyon ay opisyal pa rin sa beta status habang patuloy kaming nagdaragdag ng higit pang mga pagpipilian sa pag-uulat at pagtatanghal.",
    26631: "Bulk management.",
    26641: 'Natatanging "Spreadsheet UI" Magbigay ng direktang listahan ng kontrol sa pamamagitan ng nakakonektang Google Sheet.',
    26651: "Ang pinakamabilis at pinakamadaling paraan upang kontrolin ang mga account ng anumang laki.",
    26661: "Platform - Bulk assignment at mga update ng key variable upang pamahalaan ang platform.",
    26671: "Mga Detalye - Pangunahing seksyon para sa lahat ng mga detalye ng Google Business Profile.",
    26681: "Mga Katangian - I-optimize ang pagtatalaga ng mga katangian sa buong listahan ng GBP",
    26691: "Lumikha ng Listahan - Bumuo ng mga bagong listahan ng GBP ang lahat ng kritikal na nilalaman",
    26701: "Facebook - kontrolin ang lahat ng mga detalye ng Facebook mula sa isang solong spreadsheet",
    26711: "Kasaysayan - log ng mga pag-edit ng file at mga update.",
    26721: "Ang seksyon ay opisyal pa rin sa beta status habang patuloy naming pinuhin ang mga kontrol para sa mga account at kasama ang mga karagdagang platform.",
    26731: "Mag-post ng pag-iiskedyul",
    26741: "Bulk Creation and Scheduling para sa Google Posts sa mga lokasyon at account.",
    26751: "Magbahagi ng mga kritikal na pag-update at mga mensahe na pang-promosyon",
    26761: "I-download ang template upang lumikha ng mga post sa Google para sa lahat ng mga karapat-dapat na lokasyon.",
    26771: "Iskedyul ng tiyempo para sa buong file o itakda ang bawat post upang magsimula sa isang natatanging araw at oras",
    26781: "Planuhin ang isang buong pang-promosyon na kalendaryo",
    26791: "Mag-post ng mga pag-uulat ng pananaw",
    26801: "Tingnan ang Google Post Views at i-click ang Pagganap sa paglipas ng panahon - Pag-uulat ng mga filter ayon sa uri, media, at tawag sa pagkilos.",
    26811: "Kilalanin ang mga uso sa pagganap upang i-optimize ang libreng advertising",
    26821: "Ang bar chart ay kumakatawan sa pagganap sa paglipas ng panahon, itakda ang hanay ng petsa at tsart granularity.",
    26831: "Tingnan ang dami ng post sa pamamagitan ng media, paksa, at tumawag sa uri ng pagkilos.",
    26841: "Tingnan ang bawat post ng mga indibidwal na sukatan ng pagganap.",
    26851: "Ang pag-download ng ulat ay nagbibigay-daan para sa karagdagang pagsusuri sa pamamagitan ng kampanya.",
    26861: "Mga setting",
    26871: "Ang seksyon ng administrasyon ng platform para sa lahat ng mga setting, mga tungkulin, mga pahintulot ng gumagamit, pag-iiskedyul ng pag-iiskedyul at pag-download ng data",
    26881: "Mga kontrol ng grado ng enterprise upang magtakda ng na-customize na karanasan para sa lahat ng mga gumagamit.",
    26891: "Pangunahing mga seksyon ng admin.",
    26901: "Pahintulutan ang koneksyon sa mga platform (Google, Facebook, TrustPilot, Booking).",
    26911: "Itakda ang pagsasama sa magagamit na mga mapagkukunan ng pagsusuri.",
    26921: "Pamahalaan / Lumikha ng mga natatanging tungkulin ng gumagamit.",
    26931: "Magtalaga / kontrolin ang indibidwal na pag-access.",
    26941: "Iskedyul ng pag-uulat ayon sa uri, user, at kahit na lokasyon.",
    26951: "I-download ang mga hanay ng data mula sa platform, i-access ang 10 pinakabagong mga kahilingan.",
    26961: "Pahintulutan ang account.",
    26971: "Google Audit",
    26981: "Pagsasama-sama",
    26991: "Manager Role.",
    27001: "Pamahalaan ang mga gumagamit",
    27011: "Suriin ang mga setting",
    27021: "Campagin Builder.",
    27031: "Ulat ng Pamamahala.",
    27041: "DATA DOWNLOADS.",
    27051: "Mga Detalye ng Profile",
    27061: "Pasadyang pag-navigate",
    27071: "Suriin ang kalinawan",
    27081: "Lokasyon ng claim.",
    27091: "Awtorisadong pinagkukunan",
    27101: "Kinakailangan para sa buong data access at direktang pagsusuri ng mga tugon.",
    27111: "Mga Opsyon",
    27121: "Ang mga awtorisadong koneksyon ay patuloy na lumalaki bilang mga platform na magagamit ng API na mga koneksyon.",
    27131: "Direktang pahintulutan ang koneksyon sa pagitan ng platform at mga account ng gumagamit upang makuha ang nilikha na posibleng kontrol.",
    27141: "Lahat ng pinagkukunan",
    27151: "Mga pinagkukunan ng pagsusuri sa pag-index",
    27161: "Pinagsama ang feedback mula sa 40+ mapagkukunan sa mga vertical ng industriya",
    27171: "Mga Tala",
    27181: "Gamitin ang pag-index ng Google upang ma-access ang mga review nang walang kontrol sa listahan ng GBP.",
    27191: "Ang Indexed Sourcing ay ginagamit para sa lahat ng Competitive Review Collection.",
    27201: "Pagkatapos ng paunang index, mga review at mga sagot ay nakolekta araw-araw",
    27211: "Pampublikong pag-index o lahat ng makasaysayang mga review at mga tugon sa pamamagitan ng URL o placeID",
    27221: "Lahat ng pinagkukunan",
    27231: "I-configure",
    27241: "Kahapon",
    27251: "Huling 7 araw",
    27261: "Noong nakaraang linggo",
    27271: "Huling 30 araw",
    27281: "Noong nakaraang buwan",
    27291: "Lahat ng oras",
    27301: "ASC.",
    27311: "Desk",
    27321: "Walang kontak para sa CC.",
    27331: "I-save ang sagot na ito?",
    27341: "Pumili o lumikha ng isang grupo",
    27351: "Walang naka-save na tugon.",
    27361: "Walang auto replies.",
    27371: "Kabuuang 0 item.",
    27381: "Save na mga template",
    27391: "Kabuuang 26 item.",
    27401: "Kamakailan ay ginamit",
    27411: "Smileys & People.",
    27421: "Ay may mga komento",
    27431: "Walang mga Komento",
    27441: "Lahat ng mga lokasyon",
    27451: "Buksan",
    27461: "Mga pag-update ng Google",
    27471: "Nawawalang nilalaman",
    27481: "Mag-imbak ng code",
    27491: "Karagdagang mga kategorya",
    27501: "Mga lokasyon ng paghahanap",
    27511: "GBP Audit.",
    27521: "Bulk activity.",
    27531: "Piliin ang grupo",
    27541: "20 / Page",
    27551: "I-sync",
    27561: "Itakda ang madla",
    27571: "Tapos na",
    27581: "Pangalan ng Tag ng Entity",
    27591: "Minuto",
    27601: "may & walang komento",
    27611: "Rate.",
    27621: "Pagsusuri ng Quadrant.",
    27631: "Lahat ng data ng lokasyon",
    27641: "Mataas na paghahanap + mababang conversion.",
    27651: "Mataas na paghahanap + mataas na conversion.",
    27661: "Mababang paghahanap + mababang conversion",
    27671: "Mababang paghahanap + mataas na conversion.",
    27681: "Ang data ng lokasyon ayon sa rehiyon",
    27691: "Ang data ng lokasyon sa pamamagitan ng lungsod",
    27701: "Lokasyon:",
    27711: "Rate ng Conversion:",
    27721: "Mga paghahanap:",
    27731: "Google Q & A.",
    27741: "Google QA.",
    27751: "I-download ang QA.",
    27761: "Post Sagot.",
    27771: "Post na pananaw",
    27781: "I-download ang sample na CSV.",
    27791: "Pre populated csv.",
    27801: "Pamahalaan ang portfolio",
    27811: "Magdagdag ng portfolio",
    27821: "Tingnan ang portfolio",
    27831: "Tanggalin ang Portfolio.",
    27841: "Mga gumagamit",
    27851: "Pamahalaan ang mga profile",
    27861: "Alisin ang profile",
    27871: "Sigurado ka bang gusto mong alisin ang profile na ito?",
    27881: "Mga account.",
    27891: "Pumili ng mga profile",
    27901: "Piliin ang Profile",
    27911: "Portfolio Account.",
    27921: "Mga Detalye ng Portfolio.",
    27931: "Portfolio Pangalan",
    27941: "Currrent Portfolio Image.",
    27951: "Mag-upload ng imahe bilang isang logo para sa portfolio",
    27961: "Baguhin ang Portfolio Pangalan",
    27971: "Libreng pagsubok",
    27981: "Kasalukuyang",
    27991: "Nag-expire na",
    28001: "Kinansela",
    28011: "Invoice.",
    28021: "Konektado",
    28031: "Bilang ng mga account",
    28041: "Kabuuang mga lokasyon",
    28051: "Aktibong Mga Lokasyon",
    28061: "Mga Review (30 araw)",
    28071: "Katayuan ng pagbabayad",
    28081: "Pangalan ng Profile",
    28091: "Ipasok ang pangalan ng bagong portfolio",
    28101: "Ang isang portfolio ay maaaring mamahala ng kanilang mga gumagamit sa iba't ibang mga profile madali",
    28111: "Pangalan ng bagong portfolio",
    28121: "Ang mga pangalan ng portfolio ay maaari lamang magkaroon ng maximum na 20 character",
    28131: "Matagumpay na nilikha ang portfolio!",
    28141: "Kabuuang Profile.",
    28151: "Kabuuang mga gumagamit",
    28161: "Ipasok ang email",
    28171: "Mag-imbita ng isang tao upang matulungan kang pamahalaan ang mga profile. Maaari mong itakda ang kanilang access sa mga profile sa pamamagitan ng pagpili ng kanilang papel.",
    28181: "Imbitahan",
    28191: "Kasalukuyang Imahe ng Portfolio.",
    28201: "Sentiment.",
    28211: "Naghihintay",
    28221: "Marami pang mga filter.",
    28231: "Repasuhin ang Tag.",
    28241: "Nai -save na mga filter",
    28251: "Mas kaunting mga filter",
    28261: "Walang teksto",
    28271: "Daluyan",
    28281: "Palawakin",
    28291: "I-upload ang isang imahe",
    28301: "Piliin ang Uri ng Larawan",
    28311: "Piliin ang Uri",
    28321: "Cover Photo.",
    28331: "Larawan ng profile",
    28341: "Exterior Photo.",
    28351: "Interior Photo.",
    28361: "Larawan ng produkto",
    28371: "Larawan Larawan",
    28381: "Logo Photo.",
    28391: "Pagkain at Inumin Larawan",
    28401: "Larawan ng menu",
    28411: "Karaniwang lugar ng lugar",
    28421: "Mga Larawan Photo.",
    28431: "Mga larawan ng koponan",
    28441: "Views.",
    28451: "Larawan",
    28471: "Sarado",
    28481: "Inalis",
    28491: "Bagong Review Tag.",
    28511: "Wala nang ipapakita sa saklaw na ito!",
    28531: "Piliin lahat",
    28541: "Mapagkukunan ng paghahanap",
    28551: "Paghahanap ng Tag Review",
    28561: "Lokasyon ng paghahanap",
    28571: "Search Store Code",
    28581: "Pangkat ng Paghahanap",
    28601: "Mga tag ng entidad",
    28631: "Mga nai -save na filter ng paghahanap",
    28641: "Walang mga pagpipilian!",
    28651: "Ayusin ang pagsusuri sa teksto ng pagsusuri",
    28661: "Tingnan ang direktang pagsusuri",
    28671: "Sumagot sa Pagsusuri Platform",
    28711: "Walang mga pagsusuri",
    28731: "Sumagot ang pangalan ng lokasyon na hindi idinagdag sa lokasyong ito",
    28741: "Hindi idinagdag ang lagda sa lokasyong ito",
    28751: "Gusto mo bang magpatuloy sa pag-download?",
    28771: "Mga pagsusuri na may panloob na tugon",
    28781: "Mga pagsusuri na may auto-reply",
    28791: "Mga pagsusuri na may panlabas na tugon",
    28801: "Tingnan ang Google Knowledge Panel.",
    28821: "New Manager.",
    28831: "Paganahin ang CC.",
    28851: "Tanggalin ang Sagot.",
    28871: "Halo",
    28881: "Stars.",
    28891: "Negatibo, halo-halong, positibo",
    28931: "I-save ang isang sagot",
    28941: "I-edit ang pangalan ng account",
    28951: "Baguhin ang pangalan ng account",
    28961: "Pangalan ng Account.",
    28971: "Facebook Locations.",
    28981: "Magdagdag ng pahina",
    28991: "Aktibo",
    29001: "Ipakita ang nakatagong lokasyon",
    29011: "Tingnan ang FB Page",
    29021: "Walang nakatagong account upang ipakita",
    29031: "Oras na ang nakalipas",
    29041: "Inviter.",
    29051: "Repasuhin ang Showcase.",
    29061: "Mga lokasyon ng Google.",
    29071: "Ang iyong mga lokasyon",
    29081: "URL ng lokasyon",
    29091: "Sigurado ka bang gusto mong tanggalin ang URL na ito?",
    29101: "Gusto mo bang tanggalin ang URL at kaugnay na data mula sa application?",
    29111: "Mga Lokasyon ng Kumperensiya",
    29121: "Pangalan ng katunggali",
    29131: "Ilagay ang ID",
    29141: "Comptag",
    29151: "Magpasok ng mga URL ng lokasyon at mga detalye ng kakumpitensya",
    29161: "Iscompetitor.",
    29171: "Mga lokasyon ng pagpapareserba",
    29181: "Upang simulan ang pagsasama ng pagsusuri ng booking",
    29191: "Back Office Location ID (opsyonal)",
    29201: "Mangyaring punan ang iyong lugar ng lugar o mga detalye ng kakumpitensya. Para sa 20 o higit pang mga lokasyon,\r\nMangyaring magbigay ng isang listahan ng bawat lokasyon bilang isang excel file sa",
    29211: "Upang i-download ang sample file click.",
    29221: "Mangyaring tandaan na maaaring tumagal ng ilang minuto upang makumpleto ang unang pagkuha",
    29231: "Mangyaring magbigay ng isang listahan ng bawat isa",
    29241: "Mga URL ng Lokasyon para sa mga negosyo sa.",
    29251: "Maaari mong ilagay ang mga ito nang direkta sa email o magbigay ng isang excel ng mga listahan ng google sheet",
    29261: "Mangyaring punan ang iyong URL ng lokasyon at ang opsyonal na back office lokasyon ID (upang suportahan ang malalim na pag-uugnay para sa tugon ng pagsusuri), o ang",
    29271: "mga detalye ng kakumpitensya.",
    29281: "Ang mga malalaking account (20+ na lokasyon) ay maaaring magbigay ng isang listahan ng bawat lokasyon bilang isang excel file sa",
    29291: "Lumikha ng mga kampanya upang direktang tumugon sa mga review sa perpektong tugon sa perpektong oras",
    29301: "Sigurado ka bang gusto mong tanggalin ang kampanyang ito?",
    29311: "Kopyahin ang Intelligent Review sa bawat nakatalagang tagapamahala ng lokasyon",
    29321: "CC tugon sa nakatalagang mga tagapamahala ng lokasyon",
    29331: "CC tugon sa korporasyon",
    29341: "Tatanggap",
    29351: "Lahat ng mga tatanggap",
    29361: "Piliin ang SOURCE NG REVIEW.",
    29371: "Pub / sub lamang",
    29381: "Pumili ng Star Rating.",
    29391: "Piliin ang Nilalaman ng Pagsusuri",
    29401: "Pasadyang grupo",
    29411: "Itakda ang Pagkaantala bago magpadala ng auto reply.",
    29421: "Itakda ang mga oras ng pagpapatakbo",
    29431: "Opsyonal.",
    29441: "walang mga lokasyon na itinalaga",
    29451: "Walang nakita na pananaw para sa napiling hanay ng petsa at pamantayan.",
    29461: "I-filter ang menu",
    29471: "Uri",
    29481: "Mga pagtingin sa paghahanap",
    29491: "Mga tanawin sa Maps.",
    29501: "Wala kang sapat na pahintulot upang mag-post ng tugon.",
    29511: "Naipadala na",
    29521: "Mag-upload ng mga template ng AR.",
    29531: "Bilang ng mga tagasunod",
    29541: "Huling Sync",
    29551: "Korporasyon",
    29561: "Ahensiya",
    29571: "Pinagana ang Localpost.",
    29581: "Walang nakabinbing pag-verify",
    29591: "I-click upang tingnan ang pagsusuri na ito sa Inbox",
    29601: "Magbasa pa",
    29611: "Loading",
    29621: "Kabuuang (numero) items.",
    29631: "Na-verify ang Google Business Profile.",
    29641: "Mark As",
    29651: "Magdagdag ng mga oras",
    29661: "Ngayon",
    29671: "Address ng kalye.",
    29681: "Postal Code",
    29691: "Kinikilala bilang itim na pag-aari",
    29701: "Magdagdag ng URL",
    29711: "Poste",
    29721: "Makipag-ugnay sa email",
    29731: "COVID_19 Update",
    29741: "Pagbabago sa iyong negosyo?",
    29751: "Kampanya",
    29761: "Mag-order online",
    29771: "Buy.",
    29781: "Tumawag ka ngayon",
    29791: "Ngayon",
    29801: "I-sync ang lokasyong ito?",
    29811: "Facebook Listing",
    29821: "Lumikha ng bagong listahan ng Facebook",
    29831: "Napili",
    29841: "Mga Detalye ng Negosyo",
    29851: "Contacts.",
    29861: "Mga variable.",
    29871: "Panloob na id",
    29881: "I-click upang kumonekta",
    29891: "Bumalik sa pag-upload",
    29901: "Tingnan ang Q & A sa Google",
    29911: "Nangangailangan",
    29921: "Huwag paganahin",
    29931: "Suriin ang malapit na kumpirmasyon",
    29941: "Repasuhin ang Kumpirmasyon ng Sagot.",
    29951: "Repasuhin ang kumpirmasyon ng pag-alis",
    29961: "Rehiyon",
    29971: "Sagutin ang tanong na ito",
    29981: "Pamahalaan",
    29991: "Create Google Post",
    30001: "Lumikha ng Google Post",
    30011: "Pamahalaan ang Google Post",
    30021: "Itago ang lokasyon",
    30031: "Piliin ang kasalukuyang pahina",
    30041: "Lumikha ng Facebook Post",
    30051: "Alisin lahat",
    30061: "I-save ang Filter",
    30071: "Talaan ng paghahanap",
    30081: "Maghanap ng user",
    30091: "Lahat ng mga editor",
    30101: "Magtalaga sa rating (kinakailangan)",
    30111: "Ipasok ang pangalan ng template (kinakailangan)",
    30121: "Pasadyang template variable (opsyonal)",
    30131: "Pumili o lumikha ng paksa (opsyonal)",
    30141: "Magtalaga sa iisang lokasyon (opsyonal)",
    30151: "Magtalaga sa entity tag (opsyonal)",
    30161: "Suriin ang mga variable",
    30171: "Unang Pangalan ng Reviewer",
    30181: "Buong pangalan ng Reviewer",
    30191: "Mga variable ng lokasyon",
    30201: "Sumagot ng pangalan ng lokasyon",
    30211: "Pangalan ng Lokasyon ng Geo",
    30221: "Ang sagot para sa pagsusuri na ito ay naipadala na.",
    30231: "Ang mga tugon para sa pagsusuri na ito ay hindi maipapadala ngayon. Maaari mong tanggalin ang sagot na ito upang alisin ito mula dito.",
    30241: "Gusto mo bang i-sync ang data ng lokasyong ito? Ito ay makakakuha ng lahat ng mga update na ginawa sa lokasyon.",
    30251: "Ipaalam sa mga customer ang tungkol sa anumang mga pagbabago sa iyong negosyo dahil sa Covid-19",
    30261: "Ipadala ngayon",
    30271: "Paghahanap ng Showcase.",
    30281: "Gamitin ang mga kontrol sa kanan upang bumuo ng eksaktong showcase ng pagsusuri. Mag-click sa pindutang 'Ilapat' upang i-load ang instant na preview",
    30291: "Buuin ang iyong showcase ng pagsusuri",
    30301: "Mga Detalye ng Showcase.",
    30311: "Pangalanan ang showcase na ito",
    30321: "Indibidwal na lokasyon",
    30331: "Grupo ng Lokasyon",
    30341: "Showcase Title.",
    30351: "Tago",
    30361: "Reviewer Image / Avatar.",
    30371: "Palabas",
    30381: "Piliin ang Set.",
    30391: "Suriin ang mga mapagkukunan",
    30401: "Mga Review mula sa.",
    30411: "Lumikha ng Showcase.",
    30421: "Minimum na rating.",
    30431: "Rating lamang ang mga review",
    30441: "Tukuyin ang pagtatanghal",
    30451: "Max Review Count.",
    30461: "Max Comment Lenght.",
    30471: "Max review sa bawat pahina",
    30481: "Tumutugon Layout",
    30491: "Pagbukud-bukurin",
    30501: "Pinakabago Una",
    30511: "Kulay ng star rating",
    30521: "Suriin ang mga komento",
    30531: "Source logo.",
    30541: "Suriin ang Petsa",
    30551: "Tumpak na petsa",
    30561: "Font family.",
    30571: "Sukat ng pamagat ng showcase.",
    30581: "Sukat ng pangalan ng tagasuri",
    30591: "Sukat ng komento",
    30601: "Itakda ang mga override.",
    30611: "PIN sa Top.",
    30621: "Ibukod",
    30631: "Ang aking mga pagsusuri",
    30641: "Nangangailangan ng tulong",
    30651: "Naghihintay sa Customer.",
    30661: "Naghihintay ng feedback",
    30671: "Bagong Feedback.",
    30681: "Pangalan ng Paghahanap",
    30691: "Hindi itinalaga",
    30701: "Matagumpay na na-update",
    30711: "Pangalan ng Nilalaman ng Kampanya (opsyonal)",
    30721: "Mga Tuntunin at Kundisyon (opsyonal)",
    30731: "Sigurado ka bang gusto mong alisin ang user na ito? Sa sandaling alisin, ang user ay hindi na magkakaroon ng access sa profile na ito, maliban kung inanyayahan.",
    30741: "Gusto mo bang alisin ang user na ito?",
    30751: "Pamamahagi ng tugon",
    30761: "Magpapadala kami ng isang email () na may isang link upang i-download ang pagsusuri CSV.",
    30771: "Ang profile na ito ay may higit sa 100 mga lokasyon. Magpapadala kami sa iyo ng isang email na may link sa pag-download",
    30781: "Sumagot ang user.",
    30791: "Sumagot si Mark.",
    30801: "Destination Sagot.",
    30811: "Dashboard ng Mga Review ",
    30812: "Pangkalahatang-ideya",
    30813: "Karaniwan",
    30814: "KAR. Rating",
    30815: "Pos",
    30816: "Kaligayahan",
    30817: "Word Ratio",
    30818: "Tugon Ratio",
    30819: "Review ayon sa Pinagmulan",
    30820: "Review ayon sa Rating",
    30821: "Tugon ayon sa Rating",
    30822: "Mga Bagong Review",
    30823: "Nakatanggap ka ng {x} na mga review sa nakaraang {x} na araw. Narito ang mga pinakabago",
    30824: "Ang karaniwang bilang ng mga review sa bawat magulang na lokasyon sa loob ng saklaw ng oras",
    30825: "Ang porsyento ng mga pagsusuri na may 4-star at 5-star na rating",
    30826: "Ang Kaligayahan Score ay isang presentasyon ng porsyento ng mga positibong review bawas ang porsyento ng mga negatibong review",
    30827: "Ang Porsyento ng lahat ng mga komento na natagpuan sa 5-Star at 4-Star na mga review kumpara sa lahat ng mga salitang ibinahagi sa saklaw ng oras. Ang saklaw ay mula sa 5-Star hanggang 1-Star.",
    30828: "Ang porsyento ng mga pagsusuri sa loob ng saklaw ng oras na nakatanggap ng tugon.",
    30829: "Pagbaba sa {x data} mula noong mga nakaraang {xx} araw",
    30830: "Pagtaas sa {x data} mula noong mga nakaraang {xx} araw",
    30831: "Walang pagbabago sa {x data} mula noong mga nakaraang {xx} araw",
    30832: "I-click upang tingnan ang mga review na ito",
    30833: "(pangalan ng lokasyon) , (x) Bituin, Tagasuri: (x)",
    30834: "Mga Review & Karaniwang Rating",
    30835: "Bilang ng mga pagsusuri sa paglipas ng panahon na naka-stack ayon sa star rating + line chart ng average na rating.",
    30836: "Porsyento ayon sa Star Rating",
    30837: "Bilang ng mga pagsusuri sa paglipas ng panahon na naka-stack ayon sa star rating bilang isang porsyento ng kabuuan.",
    30838: "Naipon na Bilang & Karaniwang Rating",
    30839: "Kabuuang pagsusuri at karaniwang rating para sa saklaw ng oras ng ulat.",
    30840: "Mga Review ayon sa Pinagmulan",
    30841: "Bilang ng mga pagsusuri sa paglipas ng panahon ayon sa pinagmulan.",
    30842: "Kaligayahan Score sa Paglipas ng Panahon",
    30843: "Ang netong Kaligayahan Score bawat panahon sa saklaw ng ulat.",
    30844: "Araw ng Linggo",
    30845: "Araw ng Buwan",
    30846: "Buwan ng Taon",
    30847: "Nangungunang Mga Bansa",
    30848: "Nangungunang mga Estado",
    30849: "Nangungunang Mga Lungsod",
    30850: "Mga Tugon",
    30851: "Rate ng Mabilis na Tugon",
    30852: "Gitnang Halaga",
    30853: "Ang bilang ng mga tugon na nai-publish sa loob ng saklaw ng oras at ang average bawat lokasyon.",
    30854: "Ang porsyento ng mga pagsusuri na nakatanggap ng tugon sa loob ng 2 araw at ang gitnang oras ng pagtugon.",
    30855: "Bilang & Ratio ng mga Tugon",
    30856: "Ang bilang ng mga tugon ayon sa star rating at ang pangkalahatang ratio ng tugon.",
    30857: "Karaniwang Oras ng Pagtugon",
    30858: "Ang mean na oras ng pagtugon sa mga araw.",
    30859: "Pamamahagi ng Tugon",
    30860: "Histogram ng oras ng tugon sa pagsusuri na nahahati sa 10 mga baitang.",
    30861: "Masaya",
    30862: "Ratio",
    30863: "Habambuhay",
    30864: "Bilang ng mga record ng pangunahing lokasyon, kasama ang hindi na-mapa na mga record ng listahan.",
    30865: "Enerhiya",
    30866: "Ratio ng Komento",
    30867: "Haba ng Komento",
    30868: "Agwat ng Ratio",
    30869: "Haba ng Agwat",
    30870: "Mga Review na may at walang komento",
    30871: "Karaniwang mga salita bawat rating ng bituin",
    30872: "Porsyento ng mga salita sa bawat rating ng bituin",
    30873: "Porsyento ng Ratio ng Komento",
    30874: "Ang porsyento ng lahat ng mga pagsusuri na may kasamang mga komento ng customer",
    30875: "Bilang ng Mga Salita ng Komento",
    30876: "Ang average na bilang ng mga salita na nilalaman sa mga pagsusuri na may mga komento",
    30877: "Paghahati-hati ng mga Salita ng Komento",
    30878: "Ang porsyento ng mga salita sa bawat rating ng bituin para sa bawat panahon",
    30879: "Porsyento ng mga positibong pagsusuri na may mga komento bawas ang porsyento ng mga negatibong pagsusuri.",
    30880: "Average na haba ng mga positibong pagsusuri bawas ang average na haba ng mga negatibong pagsusuri.",
    30881: "Mga pagsusuri na may rate ng pagtugon",
    30882: "Rate ng Haba ng Komento",
    30883: "Ipinapakitang Grid",
    30884: "AVG Lokasyon",
    30885: "Ang average na rating ng mga pagsusuri ng lokasyon at ang porsyento ng mga lokasyon na higit sa 4.0 na rating sa saklaw ng oras.",
    30886: "Review Performance Grid",
    30887: "Ipakita ang average na rating ng lokasyon kumpara sa volume ng review upang makilala ang mga outlier",
    30888: "Sentiment",
    30889: "Impluwensya",
    30890: "Performance Dashboard",
    30891: "Leadership Grid",
    30892: "Kabuuang Pagtingin",
    30893: "Bilis ng Pag-convert",
    30894: "Kabuuang pagtingin at ang karaniwang pagtingin sa bawat lokasyon.",
    30895: "Pagtingin sa mapa sa desktop at mobile na may porsyento ng pagkasira.",
    30896: "Pagtingin sa lokal na paghahanap sa desktop at mobile na may porsyento ng pagkasira.",
    30897: "Kabuuang aksyon na may porsyento ng pagkasira sa pagitan ng tawag, pag-click sa website, at mga direksyon sa pagmamaneho.",
    30898: "Kabuuang rate ng conversion ng mga aksyon/pagtingin para sa mga tawag, pag-click sa website, at mga direksyon sa pagmamaneho.",
    30899: "Mga Pagtingin ng Customer",
    30900: "Kung paano at saan tinitingnan ng mga customer ang iyong negosyo.",
    30901: "Mga Aksyon ng Customer",
    30902: "Ang mga nasusubaybayang aksyon mula sa iyong mga listahan sa Google.",
    30903: "Ang porsyento ng mga impression sa listahan ng negosyo na nagreresulta sa isang aksyon",
    30904: "Bisa ng Lokasyon",
    30905: "Kabuuang view vs. rate ng conversion (mga aksyon/view) upang ipakita ang pagiging epektibo ng bawat lokasyon sa pagbuo ng mga view at pag-convert ng mga ito sa mga aksyon.",
    30906: "Bisa ayon sa Lungsod",
    30907: "Kabuuang mga pagtingin kumpara sa rate ng conversion (mga aksyon/pagtingin) para sa bawat lungsod.",
    30908: "Bisa ayon sa Grupo",
    30909: "Kabuuang view vs. rate ng conversion (mga aksyon/view) para sa bawat custom na grupo.",
    30910: "Mataas na Pagtingin + Mababang Conversion",
    30911: "Mataas na Pagtingin + Mataas na Conversion",
    30912: "Mababang Pagtingin + Mababang Conversion",
    30913: "Mababang Pagtingin + Mataas na Conversion",
    30914: "Mobile",
    30915: "Msearch",
    30916: "MMaps",
    30917: "DSearch",
    30918: "DMaps",
    30919: "Site",
    30920: "Tawag",
    30921: "Health Score",
    30922: "Pagsusuri ng Araw-araw",
    30923: "Pumili ng mga lokasyon mula sa talahanayan at ang metriko (mga view o aksyon)",
    30924: "Rate ng Kaligayahan",
    30925: "Pangalan/Kaibigan",
    30926: "{x} lokasyon na may average na {y}  bituin sa nakaraang {xx} na araw",
    30927: "Nasa itaas",
    30928: "Grupo",
    30929: "Lahat ng Tanaw",
    30930: "Lahat ng Aksyon",
    30931: "Desktop",
    30932: "Nakalagak na limitasyon: Pumili ng hanggang 8 lokasyon para sa tsart.",
    30933: "Tagasuri",
    30934: "Pangkalahatang Sentimyento",
    30935: "Pagpapamahagi ng marka ng damdamin sa {XX} paksa.",
    30936: "Damdamin ayon sa Paksa",
    30937: "Dalas ng Paksa at mga Kaugnay na Marka ng Damdamin.",
    30938: "Napaka-positibo",
    30939: "Napaka-negatibo",
    30940: "Isang tuntunin ng pag-aautomat na nailunsad para sa bagong pagsusuri sa",
    30941: "Isang tuntunin ng pag-aautomat na nailunsad para sa na-update na pagsusuri sa",
    30942: "inaprubahan ang tugon sa",
    30943: "nagtalaga ng isang tag",
    30944: "nagtalaga ng pagsusuri sa",
    30945: "sa",
    30946: "Ipinadala ang awtomatikong tugon",
    30947: "Lumikha ang may-ari ng negosyo ng bagong panlabas na tugon sa",
    30948: "sa pamamagitan ng tuntunin ng pag-aautomat sa",
    30949: "sa pamamagitan ng sistema sa",
    30950: "lumikha ng bago",
    30951: "lumikha ng bagong tugon sa",
    30952: "lumikha ng tala ng pagsusuri para sa",
    30953: "tinanggal ang isang tala sa",
    30954: "tinanggal ang isang tala ng pagsusuri sa",
    30955: "tinanggal ang tugon sa",
    30956: "in-edit ang tugon sa",
    30957: "mula sa",
    30958: "lumikha ng isang awtomatikong tugon sa",
    30959: "lokal",
    30960: "pabatid",
    30961: "naabisuhan",
    30962: "pangkalahatang-ideya",
    30963: "ginanap",
    30964: "tugon",
    30965: "Inilipat ang tugon sa Inbox ng Pag-apruba noong",
    30966: "Inilipat ang tugon sa Outbox at naka-iskedyul para sa pag-post",
    30967: "Naipost ang tugon sa",
    30968: "Pagsusuri naitalaga sa",
    30969: "pagsusuri sa",
    30970: "Pagsusuri natanggap mula sa",
    30971: "nagpadala ng tala kay",
    30972: "Nagtalaga ang sistema ng tag ng wika",
    30973: "Nagtalaga ang sistema ng awtomatikong tugon noong",
    30974: "Mga tag",
    30975: "koponan sa pamamagitan ng panuntunan ng automation noong",
    30976: "Talasalitaan ng mga kaganapan",
    30977: "sa",
    30978: "nag-update ng isang",
    30979: "nag-update ng tala ng pagsusuri noong",
    30980: "nag-update ng rating ng pagsusuri mula sa",
    30981: "nag-update ng status ng pagsusuri mula sa",
    30982: "nag-update ng status ng pagsusuri sa",
    30983: "nag-update ng komento sa kanilang",
    30984: "sa pamamagitan ng API sa panahon ng",
    30985: "sa pamamagitan ng Pub-Sub noong",
    30986: "Walang Idinagdag na Komento",
    30987: "sa",
    30988: "sistema",
    30989: "sa pamamagitan ng",
    30990: "Inalis ang takdang-aralin sa pagsusuri",
    30991: "itinalaga sa",
    30992: "Nakatalagang tag:",
    30993: "Nakatalagang pangkat ng tag:",
    30994: "inalis ang isang tag:",
    30995: "Pagsusuri na may mga update",
    30996: "Pagsusuri na walang mga update",
    30997: "Piliin ang lahat ng mga tag",
    30998: "Piliin ang hindi naka-tag",
    30999: "Naghihintay ng pag-apruba",
    31000: "Pinakamatanda muna",
    31001: "Wala kang anumang naka-save na Tala",
    31002: "Tumugon sa outbox",
    31003: "Mga Bersyon ng Review",
    31004: "Detalye ng Review",
    31005: "Buksan Info",
    31006: "Mga Relasyon",
    31007: "Error",
    31008: "Pangunahing",
    31009: "Mga Kategorya",
    31010: "Mga Link sa Social Media",
    31011: "Inalis ang orihinal na larawan ng user o ng platform."
  }
};